export const dataAffiliateStat = [
    {
      _id: "6371251df03239e680000033",
      userId: "63701cc1f03239f09e00018a",
      affiliateSales: [
        "63701d74f0323986f300013e",
        "63701d74f03239b913000026",
        "63701d74f0323986f3000146",
        "63701d74f03239bef0000140",
        "63701d74f03239b913000042",
        "63701d74f03239bef0000150",
        "63701d74f032396b8e00002f",
        "63701d74f03239bef000014a",
        "63701d74f03239528f000042",
        "63701d74f032390a3400034d",
        "63701d74f03239cdc5000029",
      ],
    },
    {
      _id: "6371251df03239e680000034",
      userId: "63701cc1f03239d40b000044",
      affiliateSales: [
        "63701d74f032398675000144",
        "63701d74f03239bef0000156",
        "63701d74f03239db69000138",
        "63701d74f032399c00000148",
        "63701d74f03239d59100034a",
        "63701d74f032399c00000156",
        "63701d74f03239528f000021",
        "63701d74f032390a34000344",
        "63701d74f03239cdc5000023",
        "63701d74f03239d59100032f",
        "63701d74f03239bef0000145",
        "63701d74f032390a34000357",
        "63701d74f03239d59100034b",
        "63701d74f03239b7f7000042",
        "63701d74f03239d40b000066",
        "63701d74f032399c0000014e",
        "63701d74f03239f09e0001a2",
        "63701d74f03239b7f7000020",
        "63701d74f03239528f00002d",
        "63701d74f03239d40b000088",
        "63701d74f032395b33000140",
        "63701d74f03239d81e000020",
        "63701d74f03239f09e0001b8",
        "63701d74f032395b33000143",
        "63701d74f032399c00000139",
        "63701d74f032395b33000141",
        "63701d74f03239528f000039",
        "63701d74f0323986f3000142",
      ],
    },
    {
      _id: "6371251df032398675000196",
      userId: "63701cc1f032395694000009",
      affiliateSales: [
        "63701d74f03239db6900013b",
        "63701d74f03239528f00002e",
        "63701d74f032399c00000134",
        "63701d74f032396b8e000045",
        "63701d74f032390a3400033a",
        "63701d74f032390a3400033c",
        "63701d74f03239db6900013f",
        "63701d74f032395694000027",
        "63701d74f03239c72c0001be",
        "63701d74f03239d81e000031",
        "63701d74f03239528f00001e",
        "63701d74f03239cdc5000031",
        "63701d74f032398675000159",
        "63701d74f032398675000149",
        "63701d74f03239cdc500003f",
        "63701d74f032394c49000130",
        "63701d74f03239db69000159",
        "63701d74f032399c0000013c",
      ],
    },
    {
      _id: "6371251df032398675000197",
      userId: "63701cc1f03239c72c000181",
      affiliateSales: [
        "63701d74f03239444100030b",
        "63701d74f032395b33000149",
        "63701d74f032390a34000346",
        "63701d74f03239db6900015b",
        "63701d74f03239c72c00019f",
        "63701d74f03239d59100033e",
        "63701d74f032390a3400032c",
        "63701d74f03239d591000353",
        "63701d74f032396b8e000028",
        "63701d74f032394c49000152",
        "63701d74f03239528f00003d",
        "63701d74f032398675000140",
        "63701d74f03239528f000019",
        "63701d74f03239d40b000064",
        "63701d74f032396b8e00001b",
        "63701d74f03239d81e00001a",
        "63701d74f03239d81e000027",
        "63701d74f03239b7f700002f",
        "63701d74f03239528f000022",
        "63701d74f03239f09e0001a6",
        "63701d74f03239569400002f",
        "63701d74f03239b7f700001f",
        "63701d74f032395b33000146",
        "63701d74f03239db69000147",
        "63701d74f032394c49000156",
        "63701d74f03239db69000141",
        "63701d74f03239569400003c",
        "63701d74f03239d81e000029",
        "63701d74f032399c00000141",
        "63701d74f032390a34000349",
        "63701d74f03239bef0000148",
        "63701d74f03239d81e00002c",
        "63701d74f032395b3300014a",
        "63701d74f0323944410002fb",
        "63701d74f03239528f000028",
        "63701d74f03239db6900014a",
        "63701d74f03239d40b000089",
        "63701d74f032399c00000135",
        "63701d74f03239f09e0001a9",
        "63701d74f03239f09e0001be",
        "63701d74f03239d40b000090",
        "63701d74f032394441000303",
        "63701d74f03239b91300003d",
        "63701d74f032399c00000155",
        "63701d74f032398675000137",
        "63701d74f03239cdc5000036",
        "63701d74f0323986f300014b",
        "63701d74f032394441000315",
        "63701d74f03239528f00001d",
        "63701d74f032390a34000357",
        "63701d74f032394c49000150",
        "63701d74f03239d591000354",
        "63701d74f03239bef0000158",
        "63701d74f032395694000041",
        "63701d74f03239d81e00003f",
        "63701d74f03239d81e000040",
        "63701d74f03239cdc500002e",
        "63701d74f032396b8e00003e",
        "63701d74f03239f09e00019b",
        "63701d74f032398675000148",
        "63701d74f03239d81e000046",
        "63701d74f032396b8e00001d",
        "63701d74f03239444100031c",
        "63701d74f032396b8e000033",
        "63701d74f03239d40b000075",
        "63701d74f032394c49000141",
        "63701d74f03239d40b000083",
        "63701d74f03239867500014a",
        "63701d74f032390a34000332",
        "63701d74f03239b913000041",
        "63701d74f03239f09e0001aa",
        "63701d74f032399c00000139",
        "63701d74f032398675000143",
        "63701d74f032398675000145",
        "63701d74f03239bef000013f",
      ],
    },
    {
      _id: "6371251df03239b7f7000081",
      userId: "63701cc1f03239f09e000181",
      affiliateSales: [
        "63701d74f03239569400001a",
        "63701d74f03239c72c00019f",
        "63701d74f03239528f000032",
        "63701d74f03239b913000028",
        "63701d74f032395b33000143",
        "63701d74f032396b8e000020",
        "63701d74f032395694000019",
        "63701d74f03239b7f7000041",
        "63701d74f03239f09e0001a6",
        "63701d74f032398675000137",
        "63701d74f032399c00000150",
        "63701d74f03239d591000332",
        "63701d74f0323986f3000142",
        "63701d74f03239d40b000085",
        "63701d74f032398675000154",
        "63701d74f03239c72c0001bb",
        "63701d74f03239569400001f",
        "63701d74f03239b7f7000023",
        "63701d74f032390a3400033e",
        "63701d74f03239d81e00001d",
        "63701d74f03239d591000331",
        "63701d74f0323986f300013f",
        "63701d74f03239f09e0001a8",
        "63701d74f03239c72c00019a",
        "63701d74f03239d591000349",
        "63701d74f03239f09e00019c",
        "63701d74f03239cdc500003a",
        "63701d74f03239569400002c",
        "63701d74f03239db69000157",
        "63701d74f032395694000027",
        "63701d74f032394c4900012e",
        "63701d74f032395b33000147",
        "63701d74f032390a3400033b",
        "63701d74f03239bef0000159",
        "63701d74f03239cdc500001e",
      ],
    },
    {
      _id: "6371251df03239b7f7000082",
      userId: "63701cc1f032390a3400031a",
      affiliateSales: [
        "63701d74f032394c4900014c",
        "63701d74f032394441000315",
        "63701d74f03239b7f7000019",
        "63701d74f03239d59100034b",
        "63701d74f03239528f000035",
        "63701d74f032390a34000342",
        "63701d74f03239d40b000067",
        "63701d74f032398675000130",
        "63701d74f03239db69000142",
        "63701d74f032390a34000335",
        "63701d74f03239bef0000152",
        "63701d74f03239db69000159",
        "63701d74f032394441000305",
        "63701d74f032398675000131",
        "63701d74f032396b8e000019",
        "63701d74f03239cdc500001f",
        "63701d74f03239c72c0001ac",
        "63701d74f03239f09e0001b0",
      ],
    },
    {
      _id: "6371251df032394441000358",
      userId: "63701cc1f03239d81e000007",
      affiliateSales: [
        "63701d74f032395b3300014f",
        "63701d74f0323986f3000147",
        "63701d74f032395b33000152",
        "63701d74f03239f09e0001aa",
        "63701d74f032390a3400032c",
        "63701d74f03239b91300003c",
        "63701d74f03239528f000032",
        "63701d74f032399c00000134",
        "63701d74f032394c4900014c",
        "63701d74f03239db69000146",
        "63701d74f032398675000142",
        "63701d74f03239528f000039",
        "63701d74f032398675000141",
        "63701d74f03239bef0000149",
        "63701d74f03239528f00003e",
        "63701d74f032394c49000153",
        "63701d74f03239b7f7000019",
        "63701d74f032390a34000355",
        "63701d74f03239c72c0001bf",
        "63701d74f03239d591000344",
        "63701d74f0323944410002fa",
        "63701d74f0323986f300015b",
        "63701d74f03239cdc5000039",
        "63701d74f03239b91300001f",
        "63701d74f03239cdc5000033",
        "63701d74f032394c49000146",
        "63701d74f03239d40b00005f",
        "63701d74f03239f09e00019c",
        "63701d74f032398675000143",
        "63701d74f03239d40b000067",
        "63701d74f032398675000139",
        "63701d74f03239cdc5000040",
        "63701d74f03239569400002a",
        "63701d74f032396b8e00003a",
        "63701d74f03239b7f700001b",
        "63701d74f032394c49000132",
        "63701d74f032399c00000149",
        "63701d74f032390a3400034c",
        "63701d74f032394c49000135",
        "63701d74f032399c00000155",
        "63701d74f03239b913000040",
        "63701d74f032394c4900013a",
        "63701d74f032390a3400033f",
        "63701d74f03239444100030f",
        "63701d74f03239528f000044",
        "63701d74f03239528f00002e",
        "63701d74f0323986f3000145",
        "63701d74f03239d40b00008e",
        "63701d74f032395694000042",
        "63701d74f03239c72c0001b4",
        "63701d74f03239569400002b",
        "63701d74f03239f09e0001ae",
      ],
    },
    {
      _id: "6371251df032394441000359",
      userId: "63701cc1f032394c4900011b",
      affiliateSales: [
        "63701d74f03239b913000031",
        "63701d74f03239d40b00005c",
        "63701d74f03239d40b000086",
        "63701d74f03239c72c0001b9",
        "63701d74f032394441000311",
        "63701d74f032395b33000141",
        "63701d74f03239b7f7000020",
        "63701d74f03239f09e0001a9",
        "63701d74f03239f09e0001a2",
        "63701d74f03239c72c0001ab",
        "63701d74f03239bef000014f",
        "63701d74f03239b913000038",
        "63701d74f032396b8e00003b",
        "63701d74f03239d591000330",
        "63701d74f0323986f3000149",
        "63701d74f032395b33000142",
        "63701d74f03239d591000355",
        "63701d74f032395694000040",
        "63701d74f03239db69000130",
        "63701d74f03239569400003a",
        "63701d74f03239db69000149",
        "63701d74f03239d591000331",
        "63701d74f03239d591000335",
        "63701d74f03239569400003d",
        "63701d74f032395694000043",
        "63701d74f03239bef0000147",
      ],
    },
    {
      _id: "6371251df03239d81e000081",
      userId: "63701cc1f0323986f3000123",
      affiliateSales: [
        "63701d74f03239f09e000196",
        "63701d74f032394c49000136",
        "63701d74f032394c4900013c",
        "63701d74f032395b33000155",
        "63701d74f032394c4900014c",
        "63701d74f03239db69000137",
        "63701d74f032395b33000157",
        "63701d74f03239db6900013f",
        "63701d74f03239c72c0001aa",
        "63701d74f03239b91300003a",
        "63701d74f032394c49000149",
        "63701d74f032399c0000013e",
        "63701d74f03239d40b00006c",
        "63701d74f032390a3400032d",
        "63701d74f03239d40b000057",
        "63701d74f03239b7f7000027",
        "63701d74f03239b91300002d",
        "63701d74f03239b913000033",
        "63701d74f032395b33000137",
        "63701d74f03239569400002b",
        "63701d74f032390a3400032e",
        "63701d74f032395694000029",
        "63701d74f032394c49000154",
        "63701d74f03239db6900014e",
        "63701d74f0323986f3000145",
        "63701d74f03239d59100032d",
        "63701d74f03239c72c0001a4",
        "63701d74f03239cdc5000028",
        "63701d74f032395b33000135",
        "63701d74f03239b913000019",
      ],
    },
    {
      _id: "6371251df03239d81e000082",
      userId: "63701cc1f032390a34000324",
      affiliateSales: [
        "63701d74f03239c72c0001a0",
        "63701d74f03239c72c0001a2",
        "63701d74f03239cdc5000045",
        "63701d74f0323944410002f8",
        "63701d74f0323986f3000146",
        "63701d74f03239bef0000141",
        "63701d74f032390a34000348",
        "63701d74f032396b8e00002d",
        "63701d74f03239528f000041",
        "63701d74f032399c0000013d",
        "63701d74f03239bef0000133",
        "63701d74f03239d40b00008d",
        "63701d74f03239528f000034",
        "63701d74f03239b7f700001d",
        "63701d74f03239c72c000198",
        "63701d74f03239f09e000198",
        "63701d74f03239d591000331",
        "63701d74f03239d81e000034",
        "63701d74f0323986f300014c",
        "63701d74f032396b8e000038",
        "63701d74f03239c72c000196",
        "63701d74f03239c72c0001bf",
        "63701d74f03239b91300003c",
        "63701d74f032394c49000130",
        "63701d74f032398675000138",
        "63701d74f03239d81e000025",
      ],
    },
    {
      _id: "6371251df03239eb0c000000",
      userId: "63701cc1f03239b7f700000e",
      affiliateSales: [
        "63701d74f03239bef0000146",
        "63701d74f03239b7f7000030",
        "63701d74f032394441000305",
        "63701d74f032399c0000014a",
        "63701d74f03239b91300002d",
        "63701d74f03239d40b000081",
        "63701d74f032394c4900013a",
        "63701d74f03239528f00002a",
        "63701d74f03239b91300003c",
        "63701d74f032398675000138",
        "63701d74f032394c49000144",
        "63701d74f032398675000141",
        "63701d74f032394441000319",
        "63701d74f032398675000145",
        "63701d74f03239d591000351",
        "63701d74f03239867500014f",
        "63701d74f03239b913000030",
        "63701d74f03239b91300001d",
        "63701d74f032395b33000148",
        "63701d74f03239867500015b",
        "63701d74f032394441000310",
        "63701d74f03239d81e00003e",
        "63701d74f032394c49000151",
        "63701d74f03239f09e000199",
        "63701d74f032394c49000142",
        "63701d74f032396b8e00002c",
        "63701d74f03239d591000350",
        "63701d74f03239d59100034f",
        "63701d74f03239d591000345",
        "63701d74f032398675000156",
        "63701d74f03239f09e0001b1",
        "63701d74f03239d591000343",
        "63701d74f03239db69000157",
        "63701d74f03239b7f7000026",
        "63701d74f03239d81e000034",
        "63701d74f032398675000134",
        "63701d74f032396b8e00003d",
        "63701d74f03239db69000146",
        "63701d74f03239b7f7000045",
        "63701d74f03239d591000356",
        "63701d74f03239569400003b",
        "63701d74f03239b7f7000038",
        "63701d74f03239f09e0001ae",
        "63701d74f03239528f00001d",
        "63701d74f03239c72c0001b5",
        "63701d74f032390a34000339",
        "63701d74f032394c4900013e",
      ],
    },
    {
      _id: "6371251df03239eb0c000001",
      userId: "63701cc1f03239528f000011",
      affiliateSales: [
        "63701d74f032399c00000141",
        "63701d74f03239b7f700002a",
        "63701d74f03239bef000014d",
        "63701d74f032399c0000013b",
        "63701d74f032390a3400034a",
        "63701d74f032390a34000352",
        "63701d74f03239cdc500003e",
        "63701d74f032390a34000336",
        "63701d74f032396b8e000030",
        "63701d74f03239528f000020",
        "63701d74f03239d40b00007a",
        "63701d74f032395b3300013b",
        "63701d74f032390a3400032e",
        "63701d74f03239bef000013e",
        "63701d74f03239867500014b",
        "63701d74f032394c49000137",
        "63701d74f032390a3400032d",
        "63701d74f03239c72c0001bb",
        "63701d74f03239569400001e",
        "63701d74f032394441000308",
        "63701d74f0323986f300013b",
        "63701d74f03239b7f7000029",
        "63701d74f03239d591000330",
        "63701d74f0323986f300013a",
        "63701d74f032394c49000141",
        "63701d74f032395694000026",
        "63701d74f03239c72c0001ab",
        "63701d74f032398675000153",
        "63701d74f032395b33000153",
        "63701d74f03239d59100032b",
        "63701d74f03239f09e0001bc",
        "63701d74f03239d40b000086",
        "63701d74f032395694000036",
        "63701d74f03239c72c0001b7",
        "63701d74f032395694000035",
        "63701d74f03239b7f7000043",
        "63701d74f032390a3400034d",
        "63701d74f032396b8e00002e",
        "63701d74f032399c00000145",
        "63701d74f032394c4900014a",
        "63701d74f03239528f000029",
        "63701d74f03239867500013b",
        "63701d74f03239b91300002c",
        "63701d74f032399c00000153",
        "63701d74f03239db69000132",
        "63701d74f032396b8e000036",
        "63701d74f03239bef0000144",
        "63701d74f032394c49000149",
        "63701d74f032394c4900015a",
        "63701d74f032394c4900013b",
        "63701d74f032394c49000152",
        "63701d74f03239b913000035",
        "63701d74f03239528f00002d",
        "63701d74f03239f09e0001b4",
        "63701d74f032390a34000340",
        "63701d74f03239528f00002b",
        "63701d74f032395b3300014b",
        "63701d74f032394c49000131",
        "63701d74f03239528f000027",
        "63701d74f03239cdc5000046",
        "63701d74f0323944410002f9",
        "63701d74f03239c72c00019b",
        "63701d74f032390a3400033e",
        "63701d74f0323944410002f0",
        "63701d74f032399c0000013d",
        "63701d74f03239c72c0001b1",
        "63701d74f032396b8e000029",
        "63701d74f03239bef0000137",
        "63701d74f032399c00000131",
        "63701d74f032390a34000351",
      ],
    },
    {
      _id: "6371251df032395b33000196",
      userId: "63701cc1f03239867500011d",
      affiliateSales: [
        "63701d74f03239528f000032",
        "63701d74f032394441000307",
        "63701d74f03239d40b000066",
        "63701d74f03239d81e000037",
        "63701d74f03239bef0000139",
        "63701d74f03239b913000030",
        "63701d74f032396b8e000035",
      ],
    },
    {
      _id: "6371251df032395b33000197",
      userId: "63701cc1f032390a34000326",
      affiliateSales: [
        "63701d74f03239f09e000193",
        "63701d74f03239c72c0001b4",
        "63701d74f0323944410002fb",
        "63701d74f0323986f3000154",
        "63701d74f03239b7f7000027",
        "63701d74f03239d81e000039",
        "63701d74f032395b33000131",
        "63701d74f03239b7f700003b",
        "63701d74f032396b8e000030",
        "63701d74f032395b33000139",
        "63701d74f03239d81e000027",
        "63701d74f03239528f000031",
        "63701d74f03239d59100032b",
        "63701d74f03239d40b00005c",
        "63701d74f03239528f000026",
        "63701d74f032394c49000153",
        "63701d74f032395694000033",
        "63701d74f032395b33000141",
        "63701d74f03239d591000358",
        "63701d74f0323986f3000148",
        "63701d74f032394c49000144",
        "63701d74f0323944410002f5",
        "63701d74f032398675000150",
        "63701d74f03239d81e00001e",
        "63701d74f0323986f3000152",
        "63701d74f032394c4900015b",
        "63701d74f03239db69000147",
        "63701d74f03239b7f700003d",
        "63701d74f03239d81e000030",
        "63701d74f03239db6900015b",
        "63701d74f03239f09e0001be",
        "63701d74f032399c0000014e",
        "63701d74f032390a34000358",
        "63701d74f032395694000045",
        "63701d74f03239444100030f",
        "63701d74f03239cdc500002a",
        "63701d74f03239b913000024",
        "63701d74f03239bef0000145",
        "63701d74f032395b3300014d",
        "63701d74f03239d81e00003e",
        "63701d74f032394c49000151",
        "63701d74f03239db69000133",
        "63701d74f03239b91300002e",
        "63701d74f032390a34000355",
        "63701d74f032394c49000131",
        "63701d74f03239d81e000019",
        "63701d74f032399c00000133",
        "63701d74f03239d40b000079",
        "63701d74f032399c00000142",
        "63701d74f03239b7f700003a",
        "63701d74f03239f09e00019b",
        "63701d74f03239444100031c",
        "63701d74f032395b33000149",
        "63701d74f032396b8e000023",
        "63701d74f03239b91300003d",
        "63701d74f03239c72c000193",
        "63701d74f032398675000136",
        "63701d74f032399c0000014f",
        "63701d74f032398675000148",
        "63701d74f03239b7f7000024",
        "63701d74f03239d591000331",
        "63701d74f03239b913000046",
        "63701d74f03239f09e0001ac",
        "63701d74f0323986f3000142",
      ],
    },
    {
      _id: "6371251df03239d591000393",
      userId: "63701cc1f03239569400000f",
      affiliateSales: [
        "63701d74f032399c0000013d",
        "63701d74f03239867500013f",
        "63701d74f03239b7f7000032",
        "63701d74f03239b7f7000020",
        "63701d74f03239d40b00007a",
        "63701d74f03239569400003a",
        "63701d74f03239d40b00007e",
        "63701d74f03239528f00001a",
        "63701d74f032394441000305",
        "63701d74f0323944410002fe",
        "63701d74f03239b7f700001c",
      ],
    },
    {
      _id: "6371251df03239d591000394",
      userId: "63701cc1f032398675000125",
      affiliateSales: [
        "63701d74f03239c72c0001b3",
        "63701d74f03239d591000342",
        "63701d74f0323944410002ff",
        "63701d74f032395b33000154",
        "63701d74f03239bef000014e",
        "63701d74f032399c0000012e",
        "63701d74f03239bef0000152",
        "63701d74f03239f09e000197",
        "63701d74f03239bef000012f",
        "63701d74f032399c00000152",
        "63701d74f03239b7f7000026",
        "63701d74f03239bef000014c",
        "63701d74f03239d40b000063",
        "63701d74f03239d40b000089",
        "63701d74f03239cdc500002e",
        "63701d74f03239db69000137",
        "63701d74f03239f09e00019a",
        "63701d74f03239f09e0001a8",
        "63701d74f032395694000041",
        "63701d74f03239b7f700003a",
        "63701d74f032395694000035",
        "63701d74f032395b33000144",
        "63701d74f03239b91300002f",
        "63701d74f032396b8e000037",
        "63701d74f032395b33000131",
        "63701d74f032395694000038",
        "63701d74f0323944410002f7",
        "63701d74f03239d40b00007f",
        "63701d74f03239c72c000193",
        "63701d74f03239d40b000077",
        "63701d74f032396b8e000032",
        "63701d74f03239cdc500001c",
        "63701d74f03239b91300003a",
        "63701d74f032395694000045",
        "63701d74f03239b7f7000022",
        "63701d74f03239bef000013d",
        "63701d74f032399c00000144",
        "63701d74f03239d40b000088",
        "63701d74f03239db6900013e",
      ],
    },
    {
      _id: "6371251df032395694000081",
      userId: "63701cc1f032396b8e000007",
      affiliateSales: [
        "63701d74f032390a34000350",
        "63701d74f03239b7f700001f",
        "63701d74f03239b913000020",
        "63701d74f032390a34000345",
        "63701d74f032395b33000139",
        "63701d74f03239d40b000089",
        "63701d74f03239d81e000023",
        "63701d74f03239444100031c",
        "63701d74f03239b913000026",
        "63701d74f032390a34000356",
        "63701d74f03239f09e0001af",
        "63701d74f03239b7f7000046",
        "63701d74f032394c49000155",
        "63701d74f03239d81e000045",
        "63701d74f032398675000132",
        "63701d74f03239cdc500001b",
        "63701d74f03239d40b00008f",
        "63701d74f03239d81e000022",
        "63701d74f03239bef0000136",
        "63701d74f03239d40b000085",
        "63701d74f032390a34000357",
        "63701d74f032394c4900015a",
        "63701d74f03239528f000039",
        "63701d74f03239cdc5000019",
        "63701d74f03239b7f7000031",
      ],
    },
    {
      _id: "6371251df032395694000082",
      userId: "63701cc1f03239db6900011c",
      affiliateSales: [
        "63701d74f03239b7f7000036",
        "63701d74f03239d40b000086",
        "63701d74f032394c49000138",
        "63701d74f03239c72c000198",
        "63701d74f03239f09e000196",
        "63701d74f03239b7f7000045",
        "63701d74f03239d59100034f",
        "63701d74f03239f09e000198",
        "63701d74f0323986f3000138",
        "63701d74f03239b91300001b",
        "63701d74f032395694000036",
        "63701d74f032395b33000146",
        "63701d74f03239b7f700002f",
        "63701d74f032398675000138",
        "63701d74f032398675000155",
        "63701d74f032394c49000147",
        "63701d74f03239b913000028",
        "63701d74f03239db6900014a",
        "63701d74f032396b8e000019",
        "63701d74f0323986f300013a",
        "63701d74f032396b8e00003e",
        "63701d74f03239cdc5000020",
        "63701d74f03239528f00001d",
        "63701d74f032395694000040",
        "63701d74f032390a34000342",
        "63701d74f032394441000310",
        "63701d74f03239cdc5000044",
        "63701d74f03239569400001d",
        "63701d74f032399c00000148",
        "63701d74f03239d40b00008a",
      ],
    },
    {
      _id: "6371251df032396b8e000081",
      userId: "63701cc1f03239f09e000188",
      affiliateSales: [
        "63701d74f03239b913000034",
        "63701d74f03239d40b000058",
        "63701d74f032395b3300013f",
        "63701d74f03239b7f7000026",
        "63701d74f03239569400003a",
        "63701d74f032394c49000150",
        "63701d74f032398675000142",
        "63701d74f03239bef000013b",
        "63701d74f032395b33000132",
        "63701d74f0323944410002fd",
        "63701d74f03239528f00001b",
        "63701d74f03239f09e0001a6",
        "63701d74f03239db69000154",
        "63701d74f03239d81e000033",
        "63701d74f03239d81e000031",
        "63701d74f032395b3300014b",
        "63701d74f03239d59100032d",
        "63701d74f03239528f000035",
        "63701d74f03239c72c0001a4",
        "63701d74f03239f09e0001ac",
        "63701d74f03239569400001a",
        "63701d74f032396b8e000022",
        "63701d74f032395b3300015a",
        "63701d74f03239c72c000193",
        "63701d74f032395b33000136",
        "63701d74f03239db69000156",
        "63701d74f03239f09e0001b5",
        "63701d74f032394c4900014b",
        "63701d74f03239f09e0001aa",
        "63701d74f0323986f3000145",
        "63701d74f032398675000145",
        "63701d74f032396b8e00002c",
        "63701d74f03239d40b00005f",
        "63701d74f032394c4900013c",
        "63701d74f03239b7f7000033",
        "63701d74f03239b7f7000039",
        "63701d74f03239bef0000148",
        "63701d74f03239867500014f",
        "63701d74f03239f09e0001a9",
        "63701d74f032394c4900013e",
        "63701d74f03239db69000145",
      ],
    },
    {
      _id: "6371251df032396b8e000082",
      userId: "63701cc1f03239d59100031b",
      affiliateSales: [
        "63701d74f032399c0000014f",
        "63701d74f032395b33000131",
        "63701d74f032399c00000157",
        "63701d74f03239d40b00007d",
        "63701d74f032398675000133",
        "63701d74f032395694000034",
        "63701d74f032390a34000351",
        "63701d74f032394c4900014d",
        "63701d74f032398675000139",
        "63701d74f03239b7f7000023",
        "63701d74f032390a3400034a",
        "63701d74f0323986f3000135",
        "63701d74f03239d81e000024",
        "63701d74f032394c4900012f",
        "63701d74f03239bef0000130",
        "63701d74f03239d40b000062",
        "63701d74f03239d40b000070",
        "63701d74f03239b913000039",
        "63701d74f032394441000306",
        "63701d74f032395694000030",
        "63701d74f03239cdc5000026",
        "63701d74f032398675000144",
        "63701d74f032390a34000331",
        "63701d74f0323986f3000152",
      ],
    },
    {
      _id: "6371251df03239bef0000196",
      userId: "63701cc1f032396b8e000009",
      affiliateSales: [
        "63701d74f032395694000035",
        "63701d74f03239528f000037",
        "63701d74f03239569400001d",
        "63701d74f03239f09e0001ae",
        "63701d74f03239bef0000151",
        "63701d74f03239569400001f",
        "63701d74f03239bef0000141",
        "63701d74f0323986f3000135",
        "63701d74f032394c4900012f",
        "63701d74f032394c49000155",
        "63701d74f03239d40b00005b",
        "63701d74f03239cdc5000035",
        "63701d74f0323986f300014b",
        "63701d74f032394c4900013f",
        "63701d74f032396b8e000034",
        "63701d74f03239bef0000131",
        "63701d74f03239cdc5000043",
        "63701d74f03239d591000355",
        "63701d74f032394c49000158",
        "63701d74f03239db69000139",
        "63701d74f032396b8e000045",
        "63701d74f0323944410002f6",
        "63701d74f03239b7f7000038",
        "63701d74f0323986f3000154",
        "63701d74f032395694000039",
        "63701d74f03239569400003d",
        "63701d74f03239d40b00005e",
        "63701d74f032394c49000145",
        "63701d74f03239db6900014b",
        "63701d74f0323986f3000156",
        "63701d74f03239cdc5000020",
      ],
    },
    {
      _id: "6371251df03239bef0000197",
      userId: "63701cc1f03239b913000009",
      affiliateSales: [
        "63701d74f03239cdc500001d",
        "63701d74f03239d40b000081",
        "63701d74f03239d81e00001b",
        "63701d74f032394c49000130",
        "63701d74f032398675000159",
        "63701d74f03239b7f700003b",
        "63701d74f03239cdc500001e",
        "63701d74f03239c72c0001bc",
        "63701d74f03239d40b00007e",
        "63701d74f03239d40b000073",
        "63701d74f03239d81e00002d",
        "63701d74f03239db69000150",
        "63701d74f03239d40b000080",
        "63701d74f03239cdc5000034",
      ],
    },
    {
      _id: "6371251df03239f793000000",
      userId: "63701cc1f03239b7f700000d",
      affiliateSales: [
        "63701d74f032390a3400034e",
        "63701d74f032396b8e000030",
        "63701d74f032395b33000153",
        "63701d74f03239528f000032",
        "63701d74f032390a34000334",
        "63701d74f032395b33000145",
        "63701d74f032395b3300014b",
        "63701d74f032399c00000131",
        "63701d74f03239c72c000196",
        "63701d74f03239b7f7000019",
        "63701d74f03239d81e000035",
        "63701d74f03239c72c0001ad",
        "63701d74f03239b7f700001e",
        "63701d74f03239d81e000028",
        "63701d74f03239db6900014b",
        "63701d74f03239d59100034c",
        "63701d74f03239bef000012f",
        "63701d74f03239528f00002d",
        "63701d74f032395b3300015b",
        "63701d74f03239b7f700003b",
        "63701d74f03239d81e000020",
        "63701d74f0323944410002f5",
        "63701d74f03239d40b000074",
        "63701d74f032398675000132",
        "63701d74f0323986f3000133",
        "63701d74f032395b33000143",
        "63701d74f03239528f000045",
        "63701d74f032398675000131",
        "63701d74f03239cdc5000040",
        "63701d74f03239db6900015b",
        "63701d74f032390a34000352",
        "63701d74f032390a34000335",
        "63701d74f032395b33000148",
        "63701d74f032390a3400033e",
        "63701d74f032390a34000354",
        "63701d74f032398675000145",
        "63701d74f032394441000318",
        "63701d74f03239528f000027",
      ],
    },
    {
      _id: "6371251df03239f793000001",
      userId: "63701cc1f03239d40b00003a",
      affiliateSales: [
        "63701d74f03239cdc500001c",
        "63701d74f032398675000149",
        "63701d74f032395694000040",
        "63701d74f032396b8e000023",
        "63701d74f032396b8e00003f",
        "63701d74f032390a3400034c",
        "63701d74f03239db69000152",
        "63701d74f03239b7f700003c",
        "63701d74f03239cdc500002d",
        "63701d74f03239d40b000086",
        "63701d74f03239db69000135",
        "63701d74f032395694000041",
        "63701d74f03239f09e000197",
        "63701d74f0323986f300015a",
        "63701d74f032398675000156",
        "63701d74f03239b913000020",
        "63701d74f032390a34000355",
        "63701d74f03239528f000039",
        "63701d74f032394c49000156",
        "63701d74f03239cdc500003b",
        "63701d74f03239f09e0001b0",
        "63701d74f03239d40b00005a",
        "63701d74f03239d40b000064",
        "63701d74f032395b33000156",
        "63701d74f03239d591000334",
        "63701d74f032399c00000142",
        "63701d74f03239cdc5000041",
        "63701d74f032394441000307",
        "63701d74f032390a34000357",
        "63701d74f032394c4900013f",
        "63701d74f03239b7f7000045",
        "63701d74f03239f09e0001ad",
        "63701d74f03239d81e00003b",
      ],
    },
    {
      _id: "6371251df03239528f000081",
      userId: "63701cc1f03239d40b00003c",
      affiliateSales: [
        "63701d74f03239f09e00019b",
        "63701d74f03239569400003a",
        "63701d74f03239b7f700002a",
        "63701d74f032394c49000155",
        "63701d74f03239d81e000024",
        "63701d74f03239d40b00008e",
        "63701d74f0323986f3000144",
        "63701d74f032398675000153",
        "63701d74f032395b33000152",
        "63701d74f032398675000143",
        "63701d74f03239528f00001f",
        "63701d74f03239d591000351",
        "63701d74f032399c0000012f",
        "63701d74f03239528f000036",
        "63701d74f03239cdc5000027",
        "63701d74f03239d81e000030",
        "63701d74f03239569400001b",
        "63701d74f032395b33000137",
        "63701d74f03239db6900012e",
        "63701d74f032395694000029",
        "63701d74f03239b7f7000037",
        "63701d74f032396b8e00001d",
        "63701d74f0323986f3000157",
        "63701d74f03239d40b000078",
        "63701d74f032398675000142",
        "63701d74f03239c72c00019f",
        "63701d74f03239b91300001b",
        "63701d74f032394c4900014d",
        "63701d74f032395b3300014e",
        "63701d74f032395694000035",
        "63701d74f03239bef000014b",
        "63701d74f032398675000137",
        "63701d74f03239d40b00008b",
        "63701d74f03239f09e0001a7",
      ],
    },
    {
      _id: "6371251df03239528f000082",
      userId: "63701cc1f03239d59100031f",
      affiliateSales: [
        "63701d74f032398675000151",
        "63701d74f032395b3300015a",
        "63701d74f03239d40b00008d",
        "63701d74f032390a3400034d",
        "63701d74f032396b8e000043",
        "63701d74f03239bef000015a",
        "63701d74f03239f09e0001bc",
        "63701d74f03239b913000026",
        "63701d74f03239f09e0001a0",
        "63701d74f032394c49000158",
        "63701d74f03239cdc500003d",
        "63701d74f0323986f3000151",
        "63701d74f032390a34000336",
        "63701d74f03239528f000019",
        "63701d74f03239b913000021",
        "63701d74f0323986f300013d",
        "63701d74f03239b7f700002f",
        "63701d74f03239db6900013d",
        "63701d74f032390a34000340",
        "63701d74f032390a3400034a",
        "63701d74f032398675000140",
        "63701d74f032395694000030",
        "63701d74f03239d40b000071",
        "63701d74f0323986f3000138",
        "63701d74f03239f09e000195",
        "63701d74f0323986f3000133",
        "63701d74f032394441000305",
        "63701d74f03239b7f7000046",
        "63701d74f032390a34000339",
        "63701d74f03239f09e0001b6",
        "63701d74f03239cdc5000026",
        "63701d74f03239d591000336",
        "63701d74f0323944410002fc",
        "63701d74f032390a3400032d",
        "63701d74f032390a3400032f",
        "63701d74f0323986f3000130",
        "63701d74f0323986f300013e",
        "63701d74f03239d591000358",
        "63701d74f032399c00000146",
        "63701d74f032394c49000145",
        "63701d74f032394441000303",
        "63701d74f032395694000022",
        "63701d74f032394c49000142",
        "63701d74f032399c0000012e",
        "63701d74f03239c72c0001b7",
        "63701d74f03239d591000355",
        "63701d74f03239cdc5000021",
        "63701d74f032399c00000157",
        "63701d74f03239f09e00019c",
        "63701d74f032390a3400032e",
        "63701d74f032390a34000343",
        "63701d74f032396b8e000033",
        "63701d74f03239db6900014b",
        "63701d74f0323986f300015a",
        "63701d74f03239db6900014c",
        "63701d74f032398675000141",
        "63701d74f03239d81e00001f",
        "63701d74f03239b7f7000043",
        "63701d74f03239d591000349",
        "63701d74f03239528f00003c",
      ],
    },
    {
      _id: "6371251df03239f09e0001fa",
      userId: "63701cc1f03239528f000014",
      affiliateSales: [
        "63701d74f032399c00000158",
        "63701d74f03239b91300003c",
        "63701d74f03239d40b000089",
        "63701d74f03239cdc5000019",
        "63701d74f03239d40b00006b",
        "63701d74f03239c72c0001ad",
        "63701d74f032390a3400033e",
        "63701d74f032390a3400034a",
        "63701d74f03239c72c0001a8",
        "63701d74f03239cdc500002d",
        "63701d74f03239b913000026",
        "63701d74f03239f09e000196",
        "63701d74f032395b33000141",
        "63701d74f032395694000022",
        "63701d74f03239b91300003e",
        "63701d74f032390a34000353",
        "63701d74f032396b8e000030",
        "63701d74f03239db69000151",
        "63701d74f03239d81e00003a",
        "63701d74f03239b7f7000022",
        "63701d74f032395b33000149",
        "63701d74f032390a34000338",
        "63701d74f03239d40b000066",
        "63701d74f032395b33000154",
        "63701d74f032395b3300014b",
        "63701d74f03239db6900014b",
        "63701d74f03239db69000153",
        "63701d74f03239f09e00019d",
        "63701d74f03239b913000039",
        "63701d74f03239b91300002d",
        "63701d74f03239528f00003a",
        "63701d74f032399c00000133",
        "63701d74f03239528f000036",
        "63701d74f032399c00000139",
        "63701d74f032395b3300013b",
        "63701d74f032394c49000144",
        "63701d74f032399c00000145",
      ],
    },
    {
      _id: "6371251df03239f09e0001fb",
      userId: "63701cc1f03239d81e000006",
      affiliateSales: ["63701d74f03239db69000150"],
    },
    {
      _id: "6371251df03239db69000196",
      userId: "63701cc1f032395694000008",
      affiliateSales: [
        "63701d74f03239d81e00001f",
        "63701d74f032398675000146",
        "63701d74f032394441000314",
        "63701d74f032396b8e00002c",
        "63701d74f03239f09e0001ab",
        "63701d74f032399c0000013b",
        "63701d74f032394441000301",
        "63701d74f03239c72c0001b1",
        "63701d74f032396b8e000041",
        "63701d74f032398675000149",
        "63701d74f03239528f000028",
      ],
    },
    {
      _id: "6371251df03239db69000197",
      userId: "63701cc1f032396b8e000007",
      affiliateSales: [
        "63701d74f032399c00000145",
        "63701d74f03239d40b000064",
        "63701d74f03239bef000013b",
        "63701d74f032399c00000150",
        "63701d74f032394441000307",
        "63701d74f03239d40b00005e",
        "63701d74f03239d40b000066",
        "63701d74f03239bef000014e",
        "63701d74f03239d591000343",
        "63701d74f032395694000033",
        "63701d74f03239cdc500001a",
        "63701d74f03239b913000031",
        "63701d74f032396b8e000028",
        "63701d74f032399c00000134",
        "63701d74f03239d40b00007c",
        "63701d74f03239f09e0001b7",
        "63701d74f03239b913000027",
        "63701d74f03239569400003c",
        "63701d74f03239bef0000148",
        "63701d74f032398675000159",
        "63701d74f032395694000019",
        "63701d74f03239db69000135",
        "63701d74f03239867500015b",
        "63701d74f032394441000312",
        "63701d74f032395b33000135",
        "63701d74f032399c00000132",
        "63701d74f03239b7f7000042",
        "63701d74f03239cdc5000034",
        "63701d74f03239b913000037",
        "63701d74f03239d40b000075",
        "63701d74f03239bef0000155",
        "63701d74f032399c0000014b",
        "63701d74f032396b8e000031",
        "63701d74f03239b913000032",
        "63701d74f03239b913000024",
        "63701d74f032394c4900013b",
        "63701d74f03239d40b000061",
        "63701d74f032394c4900015b",
        "63701d74f03239bef000014c",
        "63701d74f03239b7f700003a",
        "63701d74f03239c72c00019c",
        "63701d74f0323944410002fd",
        "63701d74f03239d591000344",
        "63701d74f032394c49000141",
        "63701d74f03239d59100033d",
        "63701d74f03239cdc5000023",
        "63701d74f032395b33000130",
        "63701d74f032390a3400034b",
      ],
    },
    {
      _id: "6371251df03239b913000081",
      userId: "63701cc1f03239528f00000c",
      affiliateSales: [
        "63701d74f032396b8e00001c",
        "63701d74f032394c49000149",
        "63701d74f03239528f000029",
        "63701d74f0323986f300015a",
        "63701d74f03239d40b000084",
        "63701d74f03239528f000027",
        "63701d74f032390a34000331",
        "63701d74f03239528f00003e",
        "63701d74f03239c72c0001bb",
        "63701d74f03239c72c000192",
        "63701d74f03239d40b00007b",
        "63701d74f03239528f000034",
        "63701d74f03239867500014f",
        "63701d74f03239528f00002d",
        "63701d74f032395b33000149",
        "63701d74f032396b8e000027",
        "63701d74f032399c0000013a",
        "63701d74f03239569400002b",
        "63701d74f03239d59100034a",
        "63701d74f0323986f300013b",
        "63701d74f032399c0000014a",
        "63701d74f03239b7f7000027",
        "63701d74f03239d40b000086",
        "63701d74f03239bef0000148",
        "63701d74f03239db6900013a",
        "63701d74f03239bef0000134",
        "63701d74f032394c4900013b",
        "63701d74f03239c72c0001b3",
        "63701d74f03239d40b00008d",
        "63701d74f032398675000133",
        "63701d74f03239d81e000026",
        "63701d74f032394c4900013f",
        "63701d74f032390a34000345",
        "63701d74f03239d40b000074",
        "63701d74f03239f09e0001ab",
        "63701d74f032390a34000339",
        "63701d74f0323944410002f2",
      ],
    },
    {
      _id: "6371251df03239b913000082",
      userId: "63701cc1f032390a3400031f",
      affiliateSales: [
        "63701d74f03239db69000153",
        "63701d74f03239d81e00001a",
        "63701d74f03239c72c0001ab",
        "63701d74f032395694000045",
        "63701d74f032394c49000132",
        "63701d74f03239b913000024",
        "63701d74f03239528f00001c",
        "63701d74f03239569400002c",
        "63701d74f03239cdc5000036",
        "63701d74f03239528f000020",
        "63701d74f03239f09e000197",
        "63701d74f032394c49000155",
        "63701d74f032394c49000146",
        "63701d74f032394c4900012f",
        "63701d74f032399c00000136",
        "63701d74f032395b33000153",
        "63701d74f032390a34000336",
        "63701d74f03239569400001a",
        "63701d74f03239569400003a",
        "63701d74f032398675000151",
        "63701d74f0323986f3000137",
        "63701d74f032398675000157",
        "63701d74f0323986f300014e",
        "63701d74f0323986f300015b",
        "63701d74f03239b913000028",
        "63701d74f032396b8e000040",
        "63701d74f0323986f3000133",
        "63701d74f03239444100031a",
        "63701d74f032395694000036",
        "63701d74f032394c4900014a",
        "63701d74f03239b91300001d",
        "63701d74f03239f09e00019f",
        "63701d74f03239b7f700003e",
        "63701d74f03239c72c000198",
        "63701d74f032398675000153",
        "63701d74f03239cdc5000045",
        "63701d74f03239b91300003e",
      ],
    },
    {
      _id: "6371251df03239cdc5000081",
      userId: "63701cc1f032394c4900011c",
      affiliateSales: [
        "63701d74f032399c00000148",
        "63701d74f03239b7f7000031",
        "63701d74f03239db69000136",
        "63701d74f032399c0000014e",
        "63701d74f03239cdc500003e",
        "63701d74f03239d40b00008a",
        "63701d74f03239d81e000029",
        "63701d74f03239d81e000045",
        "63701d74f032396b8e00001d",
        "63701d74f03239b913000037",
        "63701d74f032398675000152",
        "63701d74f032390a34000334",
        "63701d74f032390a3400034c",
        "63701d74f032395b3300012e",
        "63701d74f032394c49000153",
        "63701d74f0323986f3000150",
        "63701d74f03239d81e000039",
        "63701d74f03239d40b000058",
        "63701d74f032390a34000350",
        "63701d74f03239b7f7000025",
        "63701d74f03239b913000036",
        "63701d74f03239bef0000151",
        "63701d74f032390a34000355",
        "63701d74f03239867500014d",
        "63701d74f032394441000310",
        "63701d74f03239444100030f",
        "63701d74f032394441000303",
        "63701d74f03239d591000348",
        "63701d74f032390a34000344",
        "63701d74f032396b8e000022",
        "63701d74f03239cdc500001a",
        "63701d74f03239d59100033b",
      ],
    },
    {
      _id: "6371251df03239cdc5000082",
      userId: "63701cc1f03239f09e00018d",
      affiliateSales: [
        "63701d74f03239d81e000040",
        "63701d74f03239d40b000087",
        "63701d74f03239db69000148",
        "63701d74f03239444100031d",
        "63701d74f03239bef0000147",
        "63701d74f03239c72c0001ba",
        "63701d74f03239d591000358",
        "63701d74f032395694000026",
        "63701d74f03239b913000022",
        "63701d74f03239b7f7000044",
        "63701d74f03239cdc5000034",
        "63701d74f03239d81e000032",
        "63701d74f03239db69000159",
        "63701d74f03239528f000033",
        "63701d74f032396b8e000027",
        "63701d74f03239d40b00006f",
        "63701d74f032390a34000356",
        "63701d74f032396b8e000039",
        "63701d74f03239528f00001d",
        "63701d74f03239d59100032b",
        "63701d74f03239d591000336",
        "63701d74f032390a34000351",
        "63701d74f03239c72c0001b1",
        "63701d74f03239cdc5000027",
        "63701d74f03239f09e000198",
        "63701d74f032394c4900013a",
        "63701d74f03239569400001e",
        "63701d74f032394c49000147",
        "63701d74f0323986f300014c",
        "63701d74f03239db69000146",
        "63701d74f03239f09e000196",
        "63701d74f03239528f00003c",
        "63701d74f03239d40b000078",
        "63701d74f03239cdc5000036",
        "63701d74f03239b91300003f",
        "63701d74f03239b91300003e",
        "63701d74f03239b7f700002d",
        "63701d74f032395b3300013e",
        "63701d74f032390a3400032c",
        "63701d74f03239528f00003a",
        "63701d74f03239f09e0001ba",
        "63701d74f03239528f00001e",
      ],
    },
    {
      _id: "6371251df032399c00000196",
      userId: "63701cc1f03239b7f7000010",
      affiliateSales: [
        "63701d74f03239cdc5000025",
        "63701d74f03239528f000038",
        "63701d74f032394c49000152",
        "63701d74f03239d40b000066",
        "63701d74f032394c4900014a",
        "63701d74f032399c00000132",
        "63701d74f03239b7f700001c",
        "63701d74f0323944410002f0",
        "63701d74f0323986f300014d",
        "63701d74f032394441000313",
        "63701d74f03239d81e00001e",
        "63701d74f03239d81e000033",
        "63701d74f03239d40b00007d",
        "63701d74f032395694000027",
        "63701d74f032399c00000139",
        "63701d74f03239cdc5000028",
        "63701d74f03239bef0000159",
        "63701d74f0323944410002fe",
        "63701d74f03239d59100034e",
        "63701d74f03239b7f700001a",
        "63701d74f03239db6900014f",
        "63701d74f03239f09e0001a1",
        "63701d74f03239444100030d",
        "63701d74f032395b33000150",
        "63701d74f03239d81e00001c",
        "63701d74f03239bef000014f",
        "63701d74f032394c49000148",
        "63701d74f03239444100030e",
        "63701d74f03239d591000344",
        "63701d74f03239db69000140",
        "63701d74f032395694000024",
        "63701d74f0323986f3000140",
        "63701d74f03239528f00003f",
        "63701d74f03239867500014e",
        "63701d74f032396b8e00001e",
        "63701d74f03239db69000139",
        "63701d74f03239d40b000076",
        "63701d74f03239db6900014a",
        "63701d74f03239569400002c",
        "63701d74f03239db69000157",
        "63701d74f03239d81e00001d",
        "63701d74f032399c00000133",
        "63701d74f03239b913000046",
        "63701d74f032395b33000155",
        "63701d74f03239b7f700003b",
        "63701d74f032390a34000344",
        "63701d74f03239d59100033a",
        "63701d74f032398675000147",
        "63701d74f03239d591000341",
        "63701d74f03239cdc5000037",
        "63701d74f03239cdc5000026",
        "63701d74f032395694000038",
        "63701d74f03239d81e00002b",
        "63701d74f032399c00000156",
        "63701d74f032395694000042",
        "63701d74f032394c49000136",
        "63701d74f032394c4900013b",
        "63701d74f03239cdc5000046",
        "63701d74f032396b8e00002c",
      ],
    },
    {
      _id: "6371251df032399c00000197",
      userId: "63701cc1f03239d81e000010",
      affiliateSales: [
        "63701d74f03239528f00003a",
        "63701d74f032390a34000337",
        "63701d74f03239d591000357",
        "63701d74f032390a3400034d",
        "63701d74f032390a34000351",
        "63701d74f032395694000026",
        "63701d74f0323986f300014c",
        "63701d74f032396b8e00002e",
        "63701d74f03239bef0000153",
        "63701d74f03239d59100032c",
        "63701d74f032394c49000156",
        "63701d74f03239d81e000025",
        "63701d74f03239867500015a",
        "63701d74f032395694000036",
      ],
    },
    {
      _id: "6371251df0323986f3000196",
      userId: "63701cc1f03239d591000325",
      affiliateSales: [
        "63701d74f032399c00000154",
        "63701d74f032399c00000136",
        "63701d74f03239d59100034d",
        "63701d74f0323944410002f3",
        "63701d74f032396b8e00002e",
        "63701d74f03239c72c0001ad",
        "63701d74f03239d591000348",
        "63701d74f03239c72c0001b5",
        "63701d74f032396b8e000038",
        "63701d74f03239867500012e",
        "63701d74f0323986f3000136",
        "63701d74f03239f09e0001ae",
        "63701d74f032396b8e000031",
        "63701d74f032396b8e000029",
        "63701d74f032390a3400033c",
        "63701d74f03239b7f7000029",
        "63701d74f03239f09e000194",
        "63701d74f03239b913000020",
        "63701d74f032395b33000132",
        "63701d74f03239d59100033d",
        "63701d74f03239db69000145",
        "63701d74f032395694000044",
        "63701d74f032399c0000014b",
        "63701d74f03239d40b000083",
        "63701d74f03239d81e000045",
        "63701d74f03239528f000031",
        "63701d74f032395b33000153",
        "63701d74f03239c72c000196",
        "63701d74f03239bef000013e",
        "63701d74f03239cdc500001a",
        "63701d74f03239f09e0001bd",
        "63701d74f03239d591000356",
        "63701d74f03239d81e000029",
        "63701d74f0323986f3000140",
        "63701d74f03239d40b00008c",
        "63701d74f03239867500014f",
      ],
    },
    {
      _id: "6371251df0323986f3000197",
      userId: "63701cc1f03239cdc5000011",
      affiliateSales: [
        "63701d74f03239cdc5000029",
        "63701d74f03239db69000138",
        "63701d74f03239d591000349",
        "63701d74f032394c49000156",
        "63701d74f03239d40b00008d",
        "63701d74f03239d40b00008e",
        "63701d74f0323944410002fb",
        "63701d74f0323944410002f6",
        "63701d74f03239f09e0001a3",
        "63701d74f03239f09e00019c",
        "63701d74f03239db69000155",
        "63701d74f03239cdc5000034",
        "63701d74f03239bef0000146",
        "63701d74f032396b8e00001d",
        "63701d74f03239c72c00019c",
        "63701d74f03239d591000344",
        "63701d74f03239d40b000073",
        "63701d74f032398675000140",
        "63701d74f03239528f000043",
        "63701d74f03239d40b000082",
        "63701d74f03239d40b00006c",
        "63701d74f03239d40b000075",
        "63701d74f032396b8e00001e",
        "63701d74f032398675000153",
        "63701d74f032396b8e000024",
        "63701d74f03239d81e00003e",
        "63701d74f032394c4900014c",
        "63701d74f03239db6900014b",
        "63701d74f03239b7f7000036",
        "63701d74f0323986f300014c",
        "63701d74f03239d40b00005e",
        "63701d74f032399c0000014a",
        "63701d74f032394c49000151",
        "63701d74f03239db69000144",
        "63701d74f03239b91300002d",
        "63701d74f03239bef0000150",
        "63701d74f03239bef000014b",
        "63701d74f03239d40b00006e",
        "63701d74f032396b8e000033",
        "63701d74f03239d591000337",
        "63701d74f03239b7f700001c",
        "63701d74f032390a34000356",
        "63701d74f032399c00000156",
        "63701d74f03239c72c0001b3",
        "63701d74f032399c00000131",
      ],
    },
    {
      _id: "6371251df03239d40b0000ce",
      userId: "63701cc1f032390a3400031c",
      affiliateSales: [
        "63701d74f03239bef0000146",
        "63701d74f032395b33000130",
        "63701d74f032398675000135",
        "63701d74f03239f09e00019a",
        "63701d74f03239d40b000070",
        "63701d74f032398675000155",
        "63701d74f03239d40b00008e",
        "63701d74f032396b8e00001d",
        "63701d74f03239569400002d",
        "63701d74f03239b91300002e",
        "63701d74f03239bef0000143",
        "63701d74f03239d40b000074",
        "63701d74f03239b7f700002c",
        "63701d74f032396b8e000037",
        "63701d74f03239c72c0001a7",
        "63701d74f032396b8e00003f",
        "63701d74f032398675000154",
        "63701d74f03239d40b000080",
        "63701d74f03239d81e00002b",
        "63701d74f0323986f300015b",
        "63701d74f03239444100030d",
        "63701d74f03239cdc5000019",
        "63701d74f032394441000300",
        "63701d74f032394441000305",
        "63701d74f03239cdc500003e",
        "63701d74f032390a34000334",
        "63701d74f0323986f3000139",
        "63701d74f03239444100030f",
        "63701d74f03239b7f700001a",
      ],
    },
    {
      _id: "6371251df03239d40b0000cf",
      userId: "63701cc1f03239528f000008",
      affiliateSales: [
        "63701d74f03239db6900015b",
        "63701d74f0323986f3000147",
        "63701d74f032395694000030",
        "63701d74f03239d40b00005d",
        "63701d74f03239b7f7000031",
        "63701d74f032394c49000153",
        "63701d74f032394441000303",
        "63701d74f032390a34000353",
        "63701d74f03239bef000014c",
        "63701d74f032395b33000135",
        "63701d74f032395b3300014c",
        "63701d74f03239db6900012f",
        "63701d74f03239b7f700001c",
        "63701d74f03239d40b000072",
        "63701d74f03239c72c0001b8",
        "63701d74f032390a34000356",
        "63701d74f03239d40b000085",
        "63701d74f032394c49000159",
        "63701d74f03239f09e0001a2",
        "63701d74f032390a3400032f",
        "63701d74f03239b7f7000036",
        "63701d74f03239d591000345",
        "63701d74f03239d81e00002a",
        "63701d74f03239b7f7000033",
        "63701d74f032395694000024",
        "63701d74f0323986f3000154",
        "63701d74f03239d40b000081",
        "63701d74f032396b8e000035",
        "63701d74f032396b8e00002c",
        "63701d74f03239528f000035",
        "63701d74f0323944410002fc",
        "63701d74f03239b7f700003b",
        "63701d74f03239bef000014e",
        "63701d74f03239f09e0001b1",
        "63701d74f03239bef0000154",
        "63701d74f032390a34000337",
        "63701d74f032390a34000352",
        "63701d74f0323986f3000138",
        "63701d74f032394c49000144",
        "63701d74f032394441000312",
        "63701d74f03239d40b000063",
        "63701d74f032390a34000336",
        "63701d74f032398675000133",
        "63701d74f032396b8e000019",
        "63701d74f03239569400003f",
        "63701d74f03239b7f700001e",
        "63701d74f03239b913000041",
        "63701d74f03239867500014b",
        "63701d74f0323986f3000132",
        "63701d74f032396b8e000025",
        "63701d74f032396b8e00001a",
        "63701d74f03239bef000014a",
        "63701d74f03239d40b000083",
        "63701d74f03239c72c0001a2",
      ],
    },
    {
      _id: "6371251df03239d40b0000d0",
      userId: "63701cc1f0323944410002dd",
      affiliateSales: [
        "63701d74f032399c0000014d",
        "63701d74f0323986f3000149",
        "63701d74f03239db69000152",
        "63701d74f03239d81e000032",
        "63701d74f032399c0000013d",
        "63701d74f03239bef000013c",
        "63701d74f03239c72c0001aa",
        "63701d74f03239f09e0001b2",
        "63701d74f032394441000306",
        "63701d74f03239b7f7000038",
        "63701d74f03239d40b00006a",
        "63701d74f032390a34000345",
        "63701d74f03239db69000140",
        "63701d74f03239b913000039",
        "63701d74f032394c4900013b",
        "63701d74f03239d591000354",
        "63701d74f032395b33000139",
        "63701d74f03239db6900013c",
        "63701d74f03239f09e00019d",
        "63701d74f03239d40b000065",
        "63701d74f03239c72c0001a0",
        "63701d74f03239d40b000084",
        "63701d74f032394c49000134",
        "63701d74f03239cdc5000027",
        "63701d74f032395b33000159",
        "63701d74f03239867500014f",
        "63701d74f03239528f00001e",
        "63701d74f03239528f00002b",
        "63701d74f03239d81e000038",
        "63701d74f032394441000309",
        "63701d74f03239b7f7000037",
        "63701d74f032394c49000149",
        "63701d74f03239f09e0001b9",
        "63701d74f03239d591000353",
        "63701d74f032395b33000148",
        "63701d74f03239c72c000196",
        "63701d74f03239cdc500002d",
        "63701d74f03239528f00001b",
        "63701d74f03239d40b000062",
        "63701d74f03239db69000150",
        "63701d74f032395694000042",
        "63701d74f03239d40b00005a",
        "63701d74f032390a34000354",
        "63701d74f03239867500015a",
        "63701d74f03239444100030c",
        "63701d74f03239d40b000089",
        "63701d74f03239b913000043",
        "63701d74f03239cdc500003f",
        "63701d74f03239b913000022",
        "63701d74f03239cdc5000036",
        "63701d74f03239cdc5000038",
        "63701d74f03239528f000024",
        "63701d74f03239b91300001a",
        "63701d74f032396b8e00003d",
        "63701d74f032395694000019",
        "63701d74f03239d81e00002c",
        "63701d74f03239d40b000058",
        "63701d74f03239d40b00006b",
        "63701d74f03239db69000156",
        "63701d74f0323944410002f5",
        "63701d74f03239bef0000144",
        "63701d74f03239d40b000071",
        "63701d74f032399c0000013f",
        "63701d74f03239bef0000140",
        "63701d74f032395694000044",
        "63701d74f03239b7f7000045",
      ],
    },
    {
      _id: "6371251df03239d40b0000d1",
      userId: "63701cc1f03239c72c000184",
      affiliateSales: [
        "63701d74f032390a3400032d",
        "63701d74f03239bef0000158",
        "63701d74f03239528f00001f",
        "63701d74f03239bef0000135",
        "63701d74f032395b33000137",
        "63701d74f03239cdc5000025",
        "63701d74f032390a34000338",
        "63701d74f03239cdc5000033",
        "63701d74f032390a34000346",
        "63701d74f03239b91300003b",
        "63701d74f032395694000031",
        "63701d74f03239b913000019",
        "63701d74f03239b913000026",
        "63701d74f03239f09e0001af",
        "63701d74f03239528f00003d",
        "63701d74f032390a34000341",
        "63701d74f03239569400002c",
        "63701d74f03239bef0000131",
        "63701d74f032395b3300013b",
        "63701d74f03239528f000039",
        "63701d74f03239b913000027",
        "63701d74f03239d591000343",
        "63701d74f03239b7f7000030",
        "63701d74f03239f09e000194",
        "63701d74f032390a34000342",
        "63701d74f03239bef000015b",
        "63701d74f032399c0000013a",
        "63701d74f032396b8e000030",
        "63701d74f03239c72c0001bb",
        "63701d74f0323944410002fe",
        "63701d74f03239b7f7000027",
        "63701d74f032399c00000148",
        "63701d74f032396b8e00002b",
        "63701d74f0323986f3000152",
        "63701d74f03239b7f700001f",
        "63701d74f032394c4900013c",
        "63701d74f032390a3400034c",
        "63701d74f03239db6900014a",
        "63701d74f032395694000043",
        "63701d74f03239528f00002d",
        "63701d74f0323986f300014a",
        "63701d74f03239b91300001f",
        "63701d74f032396b8e000028",
        "63701d74f032395b33000155",
        "63701d74f0323986f300013b",
        "63701d74f03239db69000137",
        "63701d74f03239cdc5000042",
        "63701d74f03239528f000021",
        "63701d74f03239d591000348",
        "63701d74f032395b3300014d",
        "63701d74f032396b8e000032",
        "63701d74f03239c72c0001bd",
        "63701d74f032390a3400032e",
        "63701d74f03239528f000026",
        "63701d74f032394441000316",
        "63701d74f03239c72c0001b7",
        "63701d74f03239d40b00006e",
        "63701d74f03239c72c00019b",
        "63701d74f03239d81e00001d",
        "63701d74f03239444100030a",
        "63701d74f03239f09e0001b3",
        "63701d74f03239d591000355",
        "63701d74f03239b91300002f",
        "63701d74f03239b7f7000042",
        "63701d74f03239d81e000044",
        "63701d74f032395b3300015b",
        "63701d74f03239d591000342",
        "63701d74f032394441000302",
      ],
    },
    {
      _id: "6371251df03239d40b0000d2",
      userId: "63701cc1f032394c49000126",
      affiliateSales: [
        "63701d74f0323986f300013e",
        "63701d74f03239867500012f",
        "63701d74f03239db69000149",
        "63701d74f032398675000157",
        "63701d74f03239b913000036",
        "63701d74f03239f09e0001ad",
        "63701d74f0323986f3000159",
        "63701d74f03239528f00003c",
        "63701d74f03239db6900013d",
        "63701d74f032398675000132",
        "63701d74f03239f09e0001a0",
        "63701d74f0323986f3000143",
        "63701d74f0323944410002f0",
        "63701d74f03239c72c0001a5",
        "63701d74f032390a34000331",
        "63701d74f03239db69000159",
        "63701d74f03239b91300002d",
        "63701d74f03239d59100032d",
        "63701d74f03239f09e000195",
        "63701d74f03239f09e0001bc",
        "63701d74f03239b7f700001b",
        "63701d74f032394c4900014b",
        "63701d74f032396b8e000041",
        "63701d74f03239bef0000149",
        "63701d74f03239bef000015a",
        "63701d74f03239867500013d",
        "63701d74f03239b7f700002f",
        "63701d74f03239528f00002a",
        "63701d74f03239cdc500002c",
        "63701d74f03239c72c00019f",
        "63701d74f032399c00000134",
        "63701d74f032395694000023",
        "63701d74f03239d40b000087",
        "63701d74f032394c4900012e",
        "63701d74f0323986f3000144",
        "63701d74f03239b7f7000023",
        "63701d74f032398675000144",
        "63701d74f03239d81e000035",
        "63701d74f0323986f300013c",
        "63701d74f032396b8e000031",
        "63701d74f0323944410002fa",
        "63701d74f03239b91300003f",
        "63701d74f03239b7f7000040",
        "63701d74f03239cdc5000021",
        "63701d74f03239bef0000152",
        "63701d74f03239d81e00001b",
      ],
    },
  ];
  
export const dataOverallStat = [
  {
    totalCustomers: 5251,
    yearlySalesTotal: 65152,
    yearlyTotalSoldUnits: 12969,
    year: 2021,
    monthlyData: [
      {
        month: "January",
        totalSales: 6166,
        totalUnits: 37738,
        _id: "637000f7a5a686695b5170b1",
      },
      {
        month: "February",
        totalSales: 9412,
        totalUnits: 34516,
        _id: "637000f7a5a686695b5170b2",
      },
      {
        month: "March",
        totalSales: 1081,
        totalUnits: 31562,
        _id: "637000f7a5a686695b5170b3",
      },
      {
        month: "April",
        totalSales: 20716,
        totalUnits: 41908,
        _id: "637000f7a5a686695b5170b4",
      },
      {
        month: "May",
        totalSales: 41908,
        totalUnits: 39159,
        _id: "637000f7a5a686695b5170b5",
      },
      {
        month: "June",
        totalSales: 1557,
        totalUnits: 34460,
        _id: "637000f7a5a686695b5170b6",
      },
      {
        month: "July",
        totalSales: 58772,
        totalUnits: 42746,
        _id: "637000f7a5a686695b5170b7",
      },
      {
        month: "August",
        totalSales: 61931,
        totalUnits: 41924,
        _id: "637000f7a5a686695b5170b8",
      },
      {
        month: "September",
        totalSales: 3777,
        totalUnits: 55792,
        _id: "637000f7a5a686695b5170b9",
      },
      {
        month: "October",
        totalSales: 2814,
        totalUnits: 48923,
        _id: "637000f7a5a686695b5170ba",
      },
      {
        month: "November",
        totalSales: 59525,
        totalUnits: 39324,
        _id: "637000f7a5a686695b5170bb",
      },
      {
        month: "December",
        totalSales: 5842,
        totalUnits: 34119,
        _id: "637000f7a5a686695b5170bc",
      },
    ],
    dailyData: [
      { date: "2021-01-02", totalSales: 4440, totalUnits: 178 },
      { date: "2021-01-03", totalSales: 9208, totalUnits: 277 },
      { date: "2021-01-04", totalSales: 4078, totalUnits: 564 },
      { date: "2021-01-05", totalSales: 7537, totalUnits: 521 },
      { date: "2021-01-06", totalSales: 2136, totalUnits: 871 },
      { date: "2021-01-07", totalSales: 6005, totalUnits: 503 },
      { date: "2021-01-08", totalSales: 8290, totalUnits: 604 },
      { date: "2021-01-09", totalSales: 5539, totalUnits: 167 },
      { date: "2021-01-10", totalSales: 2508, totalUnits: 769 },
      { date: "2021-01-11", totalSales: 7899, totalUnits: 220 },
      { date: "2021-01-12", totalSales: 7706, totalUnits: 793 },
      { date: "2021-01-13", totalSales: 9322, totalUnits: 528 },
      { date: "2021-01-14", totalSales: 4613, totalUnits: 889 },
      { date: "2021-01-15", totalSales: 6847, totalUnits: 898 },
      { date: "2021-01-16", totalSales: 5773, totalUnits: 505 },
      { date: "2021-01-17", totalSales: 7358, totalUnits: 796 },
      { date: "2021-01-18", totalSales: 3053, totalUnits: 535 },
      { date: "2021-01-19", totalSales: 6975, totalUnits: 137 },
      { date: "2021-01-20", totalSales: 5760, totalUnits: 567 },
      { date: "2021-01-21", totalSales: 1496, totalUnits: 651 },
      { date: "2021-01-22", totalSales: 4391, totalUnits: 742 },
      { date: "2021-01-23", totalSales: 3099, totalUnits: 687 },
      { date: "2021-01-24", totalSales: 3910, totalUnits: 845 },
      { date: "2021-01-25", totalSales: 7019, totalUnits: 286 },
      { date: "2021-01-26", totalSales: 7495, totalUnits: 687 },
      { date: "2021-01-27", totalSales: 3351, totalUnits: 561 },
      { date: "2021-01-28", totalSales: 8893, totalUnits: 837 },
      { date: "2021-01-29", totalSales: 2463, totalUnits: 347 },
      { date: "2021-01-30", totalSales: 5740, totalUnits: 973 },
      { date: "2021-01-31", totalSales: 2053, totalUnits: 758 },
      { date: "2021-02-01", totalSales: 6121, totalUnits: 864 },
      { date: "2021-02-02", totalSales: 8806, totalUnits: 776 },
      { date: "2021-02-03", totalSales: 1748, totalUnits: 624 },
      { date: "2021-02-04", totalSales: 9853, totalUnits: 468 },
      { date: "2021-02-05", totalSales: 4183, totalUnits: 434 },
      { date: "2021-02-06", totalSales: 5302, totalUnits: 882 },
      { date: "2021-02-07", totalSales: 3788, totalUnits: 722 },
      { date: "2021-02-08", totalSales: 7761, totalUnits: 451 },
      { date: "2021-02-09", totalSales: 3720, totalUnits: 659 },
      { date: "2021-02-10", totalSales: 5499, totalUnits: 825 },
      { date: "2021-02-11", totalSales: 3474, totalUnits: 180 },
      { date: "2021-02-12", totalSales: 2857, totalUnits: 687 },
      { date: "2021-02-13", totalSales: 2929, totalUnits: 736 },
      { date: "2021-02-14", totalSales: 7519, totalUnits: 690 },
      { date: "2021-02-15", totalSales: 7673, totalUnits: 233 },
      { date: "2021-02-16", totalSales: 6933, totalUnits: 330 },
      { date: "2021-02-17", totalSales: 4510, totalUnits: 837 },
      { date: "2021-02-18", totalSales: 4773, totalUnits: 847 },
      { date: "2021-02-19", totalSales: 8331, totalUnits: 213 },
      { date: "2021-02-20", totalSales: 1460, totalUnits: 975 },
      { date: "2021-02-21", totalSales: 2019, totalUnits: 954 },
      { date: "2021-02-22", totalSales: 4342, totalUnits: 608 },
      { date: "2021-02-23", totalSales: 4246, totalUnits: 865 },
      { date: "2021-02-24", totalSales: 4534, totalUnits: 873 },
      { date: "2021-02-25", totalSales: 3458, totalUnits: 428 },
      { date: "2021-02-26", totalSales: 9667, totalUnits: 843 },
      { date: "2021-02-27", totalSales: 4472, totalUnits: 469 },
      { date: "2021-02-28", totalSales: 3017, totalUnits: 922 },
      { date: "2021-02-29", totalSales: 2851, totalUnits: 802 },
      { date: "2021-03-01", totalSales: 8296, totalUnits: 768 },
      { date: "2021-03-02", totalSales: 5479, totalUnits: 340 },
      { date: "2021-03-03", totalSales: 9791, totalUnits: 712 },
      { date: "2021-03-04", totalSales: 7183, totalUnits: 174 },
      { date: "2021-03-05", totalSales: 8617, totalUnits: 240 },
      { date: "2021-03-06", totalSales: 4289, totalUnits: 980 },
      { date: "2021-03-07", totalSales: 4903, totalUnits: 140 },
      { date: "2021-03-08", totalSales: 4580, totalUnits: 782 },
      { date: "2021-03-09", totalSales: 7680, totalUnits: 952 },
      { date: "2021-03-10", totalSales: 8158, totalUnits: 514 },
      { date: "2021-03-11", totalSales: 1568, totalUnits: 173 },
      { date: "2021-03-12", totalSales: 7984, totalUnits: 961 },
      { date: "2021-03-13", totalSales: 4534, totalUnits: 765 },
      { date: "2021-03-14", totalSales: 6478, totalUnits: 777 },
      { date: "2021-03-15", totalSales: 7361, totalUnits: 126 },
      { date: "2021-03-16", totalSales: 8626, totalUnits: 406 },
      { date: "2021-03-17", totalSales: 6885, totalUnits: 834 },
      { date: "2021-03-18", totalSales: 7998, totalUnits: 194 },
      { date: "2021-03-19", totalSales: 1798, totalUnits: 133 },
      { date: "2021-03-20", totalSales: 1186, totalUnits: 392 },
      { date: "2021-03-21", totalSales: 7765, totalUnits: 355 },
      { date: "2021-03-22", totalSales: 6411, totalUnits: 561 },
      { date: "2021-03-23", totalSales: 6003, totalUnits: 434 },
      { date: "2021-03-24", totalSales: 9039, totalUnits: 881 },
      { date: "2021-03-25", totalSales: 4284, totalUnits: 260 },
      { date: "2021-03-26", totalSales: 9655, totalUnits: 823 },
      { date: "2021-03-27", totalSales: 3022, totalUnits: 747 },
      { date: "2021-03-28", totalSales: 5342, totalUnits: 546 },
      { date: "2021-03-29", totalSales: 9784, totalUnits: 234 },
      { date: "2021-03-30", totalSales: 5045, totalUnits: 301 },
      { date: "2021-03-31", totalSales: 5802, totalUnits: 429 },
      { date: "2021-04-01", totalSales: 4725, totalUnits: 649 },
      { date: "2021-04-02", totalSales: 8225, totalUnits: 673 },
      { date: "2021-04-03", totalSales: 3355, totalUnits: 995 },
      { date: "2021-04-04", totalSales: 8735, totalUnits: 539 },
      { date: "2021-04-05", totalSales: 8041, totalUnits: 433 },
      { date: "2021-04-06", totalSales: 6195, totalUnits: 900 },
      { date: "2021-04-07", totalSales: 5474, totalUnits: 562 },
      { date: "2021-04-08", totalSales: 6637, totalUnits: 922 },
      { date: "2021-04-09", totalSales: 7757, totalUnits: 260 },
      { date: "2021-04-10", totalSales: 1768, totalUnits: 888 },
      { date: "2021-04-11", totalSales: 6799, totalUnits: 394 },
      { date: "2021-04-12", totalSales: 1277, totalUnits: 387 },
      { date: "2021-04-13", totalSales: 6292, totalUnits: 932 },
      { date: "2021-04-14", totalSales: 1990, totalUnits: 174 },
      { date: "2021-04-15", totalSales: 6132, totalUnits: 870 },
      { date: "2021-04-16", totalSales: 9385, totalUnits: 503 },
      { date: "2021-04-17", totalSales: 8463, totalUnits: 744 },
      { date: "2021-04-18", totalSales: 5406, totalUnits: 719 },
      { date: "2021-04-19", totalSales: 7544, totalUnits: 508 },
      { date: "2021-04-20", totalSales: 8510, totalUnits: 992 },
      { date: "2021-04-21", totalSales: 7671, totalUnits: 507 },
      { date: "2021-04-22", totalSales: 5105, totalUnits: 291 },
      { date: "2021-04-23", totalSales: 9563, totalUnits: 621 },
      { date: "2021-04-24", totalSales: 6764, totalUnits: 627 },
      { date: "2021-04-25", totalSales: 2359, totalUnits: 909 },
      { date: "2021-04-26", totalSales: 5369, totalUnits: 329 },
      { date: "2021-04-27", totalSales: 3370, totalUnits: 827 },
      { date: "2021-04-28", totalSales: 2470, totalUnits: 274 },
      { date: "2021-04-29", totalSales: 5255, totalUnits: 846 },
      { date: "2021-04-30", totalSales: 2727, totalUnits: 878 },
      { date: "2021-05-01", totalSales: 1607, totalUnits: 311 },
      { date: "2021-05-02", totalSales: 6151, totalUnits: 561 },
      { date: "2021-05-03", totalSales: 2484, totalUnits: 465 },
      { date: "2021-05-04", totalSales: 9561, totalUnits: 179 },
      { date: "2021-05-05", totalSales: 2279, totalUnits: 820 },
      { date: "2021-05-06", totalSales: 9042, totalUnits: 545 },
      { date: "2021-05-07", totalSales: 1861, totalUnits: 731 },
      { date: "2021-05-08", totalSales: 3152, totalUnits: 554 },
      { date: "2021-05-09", totalSales: 4039, totalUnits: 323 },
      { date: "2021-05-10", totalSales: 6632, totalUnits: 314 },
      { date: "2021-05-11", totalSales: 4559, totalUnits: 909 },
      { date: "2021-05-12", totalSales: 1401, totalUnits: 125 },
      { date: "2021-05-13", totalSales: 6642, totalUnits: 460 },
      { date: "2021-05-14", totalSales: 7035, totalUnits: 168 },
      { date: "2021-05-15", totalSales: 3370, totalUnits: 401 },
      { date: "2021-05-16", totalSales: 8193, totalUnits: 935 },
      { date: "2021-05-17", totalSales: 2015, totalUnits: 120 },
      { date: "2021-05-18", totalSales: 6924, totalUnits: 844 },
      { date: "2021-05-19", totalSales: 8985, totalUnits: 781 },
      { date: "2021-05-20", totalSales: 4003, totalUnits: 457 },
      { date: "2021-05-21", totalSales: 8490, totalUnits: 125 },
      { date: "2021-05-22", totalSales: 1939, totalUnits: 114 },
      { date: "2021-05-23", totalSales: 9219, totalUnits: 131 },
      { date: "2021-05-24", totalSales: 8730, totalUnits: 734 },
      { date: "2021-05-25", totalSales: 1849, totalUnits: 629 },
      { date: "2021-05-26", totalSales: 7054, totalUnits: 206 },
      { date: "2021-05-27", totalSales: 9346, totalUnits: 749 },
      { date: "2021-05-28", totalSales: 7864, totalUnits: 776 },
      { date: "2021-05-29", totalSales: 5484, totalUnits: 326 },
      { date: "2021-05-30", totalSales: 4803, totalUnits: 429 },
      { date: "2021-05-31", totalSales: 7118, totalUnits: 279 },
      { date: "2021-06-01", totalSales: 1357, totalUnits: 588 },
      { date: "2021-06-02", totalSales: 5236, totalUnits: 943 },
      { date: "2021-06-03", totalSales: 9715, totalUnits: 380 },
      { date: "2021-06-04", totalSales: 4121, totalUnits: 437 },
      { date: "2021-06-05", totalSales: 9768, totalUnits: 698 },
      { date: "2021-06-06", totalSales: 8486, totalUnits: 351 },
      { date: "2021-06-07", totalSales: 1291, totalUnits: 368 },
      { date: "2021-06-08", totalSales: 2278, totalUnits: 453 },
      { date: "2021-06-09", totalSales: 5051, totalUnits: 174 },
      { date: "2021-06-10", totalSales: 6861, totalUnits: 863 },
      { date: "2021-06-11", totalSales: 2331, totalUnits: 169 },
      { date: "2021-06-12", totalSales: 8200, totalUnits: 655 },
      { date: "2021-06-13", totalSales: 9906, totalUnits: 194 },
      { date: "2021-06-14", totalSales: 9835, totalUnits: 343 },
      { date: "2021-06-15", totalSales: 8508, totalUnits: 592 },
      { date: "2021-06-16", totalSales: 9313, totalUnits: 1000 },
      { date: "2021-06-17", totalSales: 3612, totalUnits: 612 },
      { date: "2021-06-18", totalSales: 7732, totalUnits: 227 },
      { date: "2021-06-19", totalSales: 9594, totalUnits: 374 },
      { date: "2021-06-20", totalSales: 4254, totalUnits: 553 },
      { date: "2021-06-21", totalSales: 9011, totalUnits: 368 },
      { date: "2021-06-22", totalSales: 3390, totalUnits: 657 },
      { date: "2021-06-23", totalSales: 6151, totalUnits: 925 },
      { date: "2021-06-24", totalSales: 8028, totalUnits: 703 },
      { date: "2021-06-25", totalSales: 3258, totalUnits: 698 },
      { date: "2021-06-26", totalSales: 5536, totalUnits: 165 },
      { date: "2021-06-27", totalSales: 9745, totalUnits: 667 },
      { date: "2021-06-28", totalSales: 1066, totalUnits: 845 },
      { date: "2021-06-29", totalSales: 3550, totalUnits: 573 },
      { date: "2021-06-30", totalSales: 3656, totalUnits: 264 },
      { date: "2021-07-01", totalSales: 6496, totalUnits: 562 },
      { date: "2021-07-02", totalSales: 9990, totalUnits: 412 },
      { date: "2021-07-03", totalSales: 5603, totalUnits: 753 },
      { date: "2021-07-04", totalSales: 1077, totalUnits: 629 },
      { date: "2021-07-05", totalSales: 4093, totalUnits: 604 },
      { date: "2021-07-06", totalSales: 5120, totalUnits: 190 },
      { date: "2021-07-07", totalSales: 4515, totalUnits: 907 },
      { date: "2021-07-08", totalSales: 9038, totalUnits: 148 },
      { date: "2021-07-09", totalSales: 6667, totalUnits: 632 },
      { date: "2021-07-10", totalSales: 8122, totalUnits: 127 },
      { date: "2021-07-11", totalSales: 1972, totalUnits: 117 },
      { date: "2021-07-12", totalSales: 6801, totalUnits: 563 },
      { date: "2021-07-13", totalSales: 4091, totalUnits: 637 },
      { date: "2021-07-14", totalSales: 3113, totalUnits: 410 },
      { date: "2021-07-15", totalSales: 4585, totalUnits: 375 },
      { date: "2021-07-16", totalSales: 6517, totalUnits: 446 },
      { date: "2021-07-17", totalSales: 1881, totalUnits: 319 },
      { date: "2021-07-18", totalSales: 7364, totalUnits: 170 },
      { date: "2021-07-19", totalSales: 6019, totalUnits: 761 },
      { date: "2021-07-20", totalSales: 4955, totalUnits: 896 },
      { date: "2021-07-21", totalSales: 4778, totalUnits: 128 },
      { date: "2021-07-22", totalSales: 9728, totalUnits: 292 },
      { date: "2021-07-23", totalSales: 7928, totalUnits: 539 },
      { date: "2021-07-24", totalSales: 4345, totalUnits: 595 },
      { date: "2021-07-25", totalSales: 8472, totalUnits: 928 },
      { date: "2021-07-26", totalSales: 5393, totalUnits: 958 },
      { date: "2021-07-27", totalSales: 6508, totalUnits: 691 },
      { date: "2021-07-28", totalSales: 8991, totalUnits: 513 },
      { date: "2021-07-29", totalSales: 3115, totalUnits: 830 },
      { date: "2021-07-30", totalSales: 8772, totalUnits: 556 },
      { date: "2021-07-31", totalSales: 4551, totalUnits: 284 },
      { date: "2021-08-01", totalSales: 6332, totalUnits: 292 },
      { date: "2021-08-02", totalSales: 2518, totalUnits: 969 },
      { date: "2021-08-03", totalSales: 7598, totalUnits: 786 },
      { date: "2021-08-04", totalSales: 5509, totalUnits: 146 },
      { date: "2021-08-05", totalSales: 7491, totalUnits: 304 },
      { date: "2021-08-06", totalSales: 3664, totalUnits: 425 },
      { date: "2021-08-07", totalSales: 7173, totalUnits: 268 },
      { date: "2021-08-08", totalSales: 4771, totalUnits: 888 },
      { date: "2021-08-09", totalSales: 2593, totalUnits: 565 },
      { date: "2021-08-10", totalSales: 4951, totalUnits: 552 },
      { date: "2021-08-11", totalSales: 7876, totalUnits: 651 },
      { date: "2021-08-12", totalSales: 7589, totalUnits: 555 },
      { date: "2021-08-13", totalSales: 6829, totalUnits: 520 },
      { date: "2021-08-14", totalSales: 8193, totalUnits: 232 },
      { date: "2021-08-15", totalSales: 1075, totalUnits: 833 },
      { date: "2021-08-16", totalSales: 1384, totalUnits: 299 },
      { date: "2021-08-17", totalSales: 4635, totalUnits: 820 },
      { date: "2021-08-18", totalSales: 1886, totalUnits: 397 },
      { date: "2021-08-19", totalSales: 1461, totalUnits: 302 },
      { date: "2021-08-20", totalSales: 3612, totalUnits: 122 },
      { date: "2021-08-21", totalSales: 7275, totalUnits: 697 },
      { date: "2021-08-22", totalSales: 2319, totalUnits: 768 },
      { date: "2021-08-23", totalSales: 7268, totalUnits: 531 },
      { date: "2021-08-24", totalSales: 4286, totalUnits: 222 },
      { date: "2021-08-25", totalSales: 8294, totalUnits: 413 },
      { date: "2021-08-26", totalSales: 2961, totalUnits: 469 },
      { date: "2021-08-27", totalSales: 2920, totalUnits: 374 },
      { date: "2021-08-28", totalSales: 8327, totalUnits: 522 },
      { date: "2021-08-29", totalSales: 4722, totalUnits: 958 },
      { date: "2021-08-30", totalSales: 3219, totalUnits: 787 },
      { date: "2021-08-31", totalSales: 3713, totalUnits: 356 },
      { date: "2021-09-01", totalSales: 9797, totalUnits: 519 },
      { date: "2021-09-02", totalSales: 4632, totalUnits: 865 },
      { date: "2021-09-03", totalSales: 5273, totalUnits: 272 },
      { date: "2021-09-04", totalSales: 4765, totalUnits: 750 },
      { date: "2021-09-05", totalSales: 3041, totalUnits: 306 },
      { date: "2021-09-06", totalSales: 8139, totalUnits: 302 },
      { date: "2021-09-07", totalSales: 3348, totalUnits: 776 },
      { date: "2021-09-08", totalSales: 2433, totalUnits: 432 },
      { date: "2021-09-09", totalSales: 5919, totalUnits: 518 },
      { date: "2021-09-10", totalSales: 6850, totalUnits: 292 },
      { date: "2021-09-11", totalSales: 1371, totalUnits: 429 },
      { date: "2021-09-12", totalSales: 4895, totalUnits: 729 },
      { date: "2021-09-13", totalSales: 2404, totalUnits: 564 },
      { date: "2021-09-14", totalSales: 8578, totalUnits: 382 },
      { date: "2021-09-15", totalSales: 7339, totalUnits: 826 },
      { date: "2021-09-16", totalSales: 9930, totalUnits: 140 },
      { date: "2021-09-17", totalSales: 4042, totalUnits: 972 },
      { date: "2021-09-18", totalSales: 7080, totalUnits: 502 },
      { date: "2021-09-19", totalSales: 2858, totalUnits: 722 },
      { date: "2021-09-20", totalSales: 8279, totalUnits: 119 },
      { date: "2021-09-21", totalSales: 3473, totalUnits: 290 },
      { date: "2021-09-22", totalSales: 2254, totalUnits: 112 },
      { date: "2021-09-23", totalSales: 8813, totalUnits: 658 },
      { date: "2021-09-24", totalSales: 5857, totalUnits: 617 },
      { date: "2021-09-25", totalSales: 8542, totalUnits: 531 },
      { date: "2021-09-26", totalSales: 1537, totalUnits: 975 },
      { date: "2021-09-27", totalSales: 9325, totalUnits: 323 },
      { date: "2021-09-28", totalSales: 4286, totalUnits: 599 },
      { date: "2021-09-29", totalSales: 2375, totalUnits: 760 },
      { date: "2021-09-30", totalSales: 7925, totalUnits: 863 },
      { date: "2021-10-01", totalSales: 1766, totalUnits: 601 },
      { date: "2021-10-02", totalSales: 2578, totalUnits: 195 },
      { date: "2021-10-03", totalSales: 6840, totalUnits: 887 },
      { date: "2021-10-04", totalSales: 2257, totalUnits: 845 },
      { date: "2021-10-05", totalSales: 2168, totalUnits: 606 },
      { date: "2021-10-06", totalSales: 8791, totalUnits: 275 },
      { date: "2021-10-07", totalSales: 2005, totalUnits: 652 },
      { date: "2021-10-08", totalSales: 4086, totalUnits: 925 },
      { date: "2021-10-09", totalSales: 5851, totalUnits: 921 },
      { date: "2021-10-10", totalSales: 4390, totalUnits: 490 },
      { date: "2021-10-11", totalSales: 7271, totalUnits: 131 },
      { date: "2021-10-12", totalSales: 6548, totalUnits: 337 },
      { date: "2021-10-13", totalSales: 1736, totalUnits: 822 },
      { date: "2021-10-14", totalSales: 3722, totalUnits: 305 },
      { date: "2021-10-15", totalSales: 3772, totalUnits: 814 },
      { date: "2021-10-16", totalSales: 3169, totalUnits: 712 },
      { date: "2021-10-17", totalSales: 7579, totalUnits: 676 },
      { date: "2021-10-18", totalSales: 8615, totalUnits: 644 },
      { date: "2021-10-19", totalSales: 3766, totalUnits: 172 },
      { date: "2021-10-20", totalSales: 5803, totalUnits: 405 },
      { date: "2021-10-21", totalSales: 8430, totalUnits: 338 },
      { date: "2021-10-22", totalSales: 7648, totalUnits: 631 },
      { date: "2021-10-23", totalSales: 2434, totalUnits: 461 },
      { date: "2021-10-24", totalSales: 9520, totalUnits: 846 },
      { date: "2021-10-25", totalSales: 6588, totalUnits: 674 },
      { date: "2021-10-26", totalSales: 7180, totalUnits: 276 },
      { date: "2021-10-27", totalSales: 1039, totalUnits: 899 },
      { date: "2021-10-28", totalSales: 7440, totalUnits: 469 },
      { date: "2021-10-29", totalSales: 3026, totalUnits: 620 },
      { date: "2021-10-30", totalSales: 3594, totalUnits: 368 },
      { date: "2021-10-31", totalSales: 2710, totalUnits: 213 },
      { date: "2021-11-01", totalSales: 4998, totalUnits: 826 },
      { date: "2021-11-02", totalSales: 1856, totalUnits: 598 },
      { date: "2021-11-03", totalSales: 3032, totalUnits: 694 },
      { date: "2021-11-04", totalSales: 8275, totalUnits: 491 },
      { date: "2021-11-05", totalSales: 8105, totalUnits: 911 },
      { date: "2021-11-06", totalSales: 2815, totalUnits: 222 },
      { date: "2021-11-07", totalSales: 2183, totalUnits: 402 },
      { date: "2021-11-08", totalSales: 5988, totalUnits: 597 },
      { date: "2021-11-09", totalSales: 9263, totalUnits: 609 },
      { date: "2021-11-10", totalSales: 5886, totalUnits: 187 },
      { date: "2021-11-11", totalSales: 3003, totalUnits: 665 },
      { date: "2021-11-12", totalSales: 3093, totalUnits: 116 },
      { date: "2021-11-13", totalSales: 1791, totalUnits: 758 },
      { date: "2021-11-14", totalSales: 1540, totalUnits: 327 },
      { date: "2021-11-15", totalSales: 7916, totalUnits: 953 },
      { date: "2021-11-16", totalSales: 5222, totalUnits: 563 },
      { date: "2021-11-17", totalSales: 4137, totalUnits: 567 },
      { date: "2021-11-18", totalSales: 6127, totalUnits: 594 },
      { date: "2021-11-19", totalSales: 6733, totalUnits: 843 },
      { date: "2021-11-20", totalSales: 8355, totalUnits: 536 },
      { date: "2021-11-21", totalSales: 7293, totalUnits: 645 },
      { date: "2021-11-22", totalSales: 2042, totalUnits: 405 },
      { date: "2021-11-23", totalSales: 5261, totalUnits: 246 },
      { date: "2021-11-24", totalSales: 6218, totalUnits: 359 },
      { date: "2021-11-25", totalSales: 4316, totalUnits: 572 },
      { date: "2021-11-26", totalSales: 4855, totalUnits: 922 },
      { date: "2021-11-27", totalSales: 4620, totalUnits: 870 },
      { date: "2021-11-28", totalSales: 5238, totalUnits: 620 },
      { date: "2021-11-29", totalSales: 2176, totalUnits: 474 },
      { date: "2021-11-30", totalSales: 8352, totalUnits: 705 },
      { date: "2021-12-01", totalSales: 6264, totalUnits: 301 },
      { date: "2021-12-02", totalSales: 8046, totalUnits: 533 },
      { date: "2021-12-03", totalSales: 4552, totalUnits: 430 },
      { date: "2021-12-04", totalSales: 8425, totalUnits: 634 },
      { date: "2021-12-05", totalSales: 2423, totalUnits: 520 },
      { date: "2021-12-06", totalSales: 9756, totalUnits: 691 },
      { date: "2021-12-07", totalSales: 2974, totalUnits: 740 },
      { date: "2021-12-08", totalSales: 8947, totalUnits: 933 },
      { date: "2021-12-09", totalSales: 8435, totalUnits: 997 },
      { date: "2021-12-10", totalSales: 7246, totalUnits: 490 },
      { date: "2021-12-11", totalSales: 1691, totalUnits: 758 },
      { date: "2021-12-12", totalSales: 6938, totalUnits: 272 },
      { date: "2021-12-13", totalSales: 1443, totalUnits: 821 },
      { date: "2021-12-14", totalSales: 5855, totalUnits: 179 },
      { date: "2021-12-15", totalSales: 7722, totalUnits: 545 },
      { date: "2021-12-16", totalSales: 7117, totalUnits: 121 },
      { date: "2021-12-17", totalSales: 5420, totalUnits: 684 },
      { date: "2021-12-18", totalSales: 1271, totalUnits: 113 },
      { date: "2021-12-19", totalSales: 2586, totalUnits: 379 },
      { date: "2021-12-20", totalSales: 5116, totalUnits: 958 },
      { date: "2021-12-21", totalSales: 5393, totalUnits: 818 },
      { date: "2021-12-22", totalSales: 2832, totalUnits: 247 },
      { date: "2021-12-23", totalSales: 4626, totalUnits: 268 },
      { date: "2021-12-24", totalSales: 6757, totalUnits: 169 },
      { date: "2021-12-25", totalSales: 7515, totalUnits: 550 },
      { date: "2021-12-26", totalSales: 8269, totalUnits: 566 },
      { date: "2021-12-27", totalSales: 1322, totalUnits: 791 },
      { date: "2021-12-28", totalSales: 5404, totalUnits: 167 },
      { date: "2021-12-29", totalSales: 8295, totalUnits: 852 },
      { date: "2021-12-30", totalSales: 2525, totalUnits: 858 },
      { date: "2021-12-31", totalSales: 1326, totalUnits: 360 },
    ],
    salesByCategory: {
      Knee: 65150,
      Lower_Back: 32803,
      Upper_Back: 26288,
      Hip: 49545,
      
    },
    _id: "636ffd4fc7195768677097d7",
    createdAt: "1983-01-10T18:53:05.874Z",
    updatedAt: "2019-07-06T05:12:27.736Z",
    __v: 36729,
  },
];
  
  export const dataProduct = [
    {
      _id: "63701d24f03239c72c00018e",
      name: "Port Beckley",
      price: 311.71,
      description: "Revision of Nonaut Sub in Mouth/Throat, Via Opening",
      category: "clothing",
      rating: 1.15,
      supply: 1320,
    },
    {
      _id: "63701d24f03239c72c00018f",
      name: "Killy Fidian",
      price: 649.77,
      description: "Removal of Drain Dev from L Metatarsophal Jt, Perc Approach",
      category: "accessories",
      rating: 4.84,
      supply: 633,
    },
    {
      _id: "63701d24f03239c72c000190",
      name: "Federica Pieper",
      price: 576.06,
      description: "Replace of R Up Arm Tendon with Nonaut Sub, Open Approach",
      category: "clothing",
      rating: 1.48,
      supply: 977,
    },
    {
      _id: "63701d24f03239c72c000191",
      name: "Solomon Ferrandez",
      price: 77.54,
      description: "Beam Radiation of Adrenal Glands using Electrons, Intraop",
      category: "misc",
      rating: 1.72,
      supply: 190,
    },
    {
      _id: "63701d24f03239867500012a",
      name: "Filia Rusling",
      price: 293.64,
      description: "Division of Left Trunk Tendon, Open Approach",
      category: "accessories",
      rating: 4.1,
      supply: 235,
    },
    {
      _id: "63701d24f03239867500012b",
      name: "Madeleine Mateescu",
      price: 361.14,
      description: "Destruction of Thoracic Duct, Percutaneous Approach",
      category: "shoes",
      rating: 1.92,
      supply: 1274,
    },
    {
      _id: "63701d24f03239867500012c",
      name: "Moyna Birkinshaw",
      price: 219.56,
      description: "Extirpation of Matter from R Fem Art, Open Approach",
      category: "shoes",
      rating: 3.52,
      supply: 212,
    },
    {
      _id: "63701d24f03239867500012d",
      name: "Rosa Lemon",
      price: 16.91,
      description: "Replace L Up Leg Subcu/Fascia w Nonaut Sub, Open",
      category: "accessories",
      rating: 4.1,
      supply: 655,
    },
    {
      _id: "63701d24f03239b7f7000015",
      name: "Loleta Meach",
      price: 555.73,
      description: "Supplement Head & Neck Tendon with Autol Sub, Open Approach",
      category: "shoes",
      rating: 1.5,
      supply: 880,
    },
    {
      _id: "63701d24f03239b7f7000016",
      name: "Cordelie Packe",
      price: 269.45,
      description: "Stereotactic Other Photon Radiosurgery of Bronchus",
      category: "clothing",
      rating: 2.83,
      supply: 1101,
    },
    {
      _id: "63701d24f03239b7f7000017",
      name: "Norene Swiggs",
      price: 642.61,
      description: "Revision of Nonaut Sub in Low Bursa/Lig, Open Approach",
      category: "misc",
      rating: 4.96,
      supply: 736,
    },
    {
      _id: "63701d24f03239b7f7000018",
      name: "Duane Docharty",
      price: 949.37,
      description: "Removal of Synth Sub from L Patella, Perc Endo Approach",
      category: "clothing",
      rating: 1.56,
      supply: 1026,
    },
    {
      _id: "63701d24f0323944410002ec",
      name: "Mirabella Doucette",
      price: 11.7,
      description: "Destruction of Anus, External Approach",
      category: "accessories",
      rating: 2.31,
      supply: 734,
    },
    {
      _id: "63701d24f0323944410002ed",
      name: "Hoebart Isted",
      price: 380.01,
      description: "Drainage of Left Inguinal Region, Perc Endo Approach",
      category: "shoes",
      rating: 4.4,
      supply: 958,
    },
    {
      _id: "63701d24f0323944410002ee",
      name: "Dayna Maruska",
      price: 670.71,
      description: "Low Dose Rate (LDR) Brachytherapy of Lung using Iodine 125",
      category: "clothing",
      rating: 1.02,
      supply: 527,
    },
    {
      _id: "63701d24f0323944410002ef",
      name: "Horacio Lippitt",
      price: 690.23,
      description: "Fusion of Right Wrist Joint with Int Fix, Perc Approach",
      category: "accessories",
      rating: 1.73,
      supply: 520,
    },
    {
      _id: "63701d24f03239d81e000015",
      name: "Elnore Knoton",
      price: 104.24,
      description: "Division of Right Hand Muscle, Perc Endo Approach",
      category: "clothing",
      rating: 4,
      supply: 395,
    },
    {
      _id: "63701d24f03239d81e000016",
      name: "Charisse Shakespeare",
      price: 132.95,
      description: "Drainage of Left Radial Artery, Open Approach",
      category: "misc",
      rating: 2.81,
      supply: 863,
    },
    {
      _id: "63701d24f03239d81e000017",
      name: "Pablo Sharrock",
      price: 459.23,
      description: "Revision of Other Device in GI Tract, Perc Approach",
      category: "shoes",
      rating: 3.25,
      supply: 704,
    },
    {
      _id: "63701d24f03239d81e000018",
      name: "Rollo Prendergrast",
      price: 629.2,
      description: "Drainage of Urethra with Drainage Device, Endo",
      category: "accessories",
      rating: 2.36,
      supply: 1177,
    },
    {
      _id: "63701d24f032390a34000327",
      name: "Elle Chart",
      price: 530.86,
      description: "Occlusion of Right Axillary Vein, Perc Endo Approach",
      category: "shoes",
      rating: 1.53,
      supply: 450,
    },
    {
      _id: "63701d24f032390a34000328",
      name: "Letti Garnam",
      price: 934.46,
      description: "Bypass Ileum to Descending Colon, Endo",
      category: "accessories",
      rating: 2.64,
      supply: 480,
    },
    {
      _id: "63701d24f032390a34000329",
      name: "Micheil Roumier",
      price: 867.33,
      description: "Destruction of Left Toe Phalangeal Joint, Open Approach",
      category: "misc",
      rating: 3.89,
      supply: 1164,
    },
    {
      _id: "63701d24f032390a3400032a",
      name: "Elli Hyde-Chambers",
      price: 22.98,
      description: "Revision of Extraluminal Device in Low Intest Tract, Endo",
      category: "misc",
      rating: 3.26,
      supply: 617,
    },
    {
      _id: "63701d24f032395b3300012a",
      name: "Jessie Marioneau",
      price: 607.7,
      description: "Reposition Right Peroneal Artery, Percutaneous Approach",
      category: "shoes",
      rating: 2.71,
      supply: 385,
    },
    {
      _id: "63701d24f032395b3300012b",
      name: "Oriana Blofeld",
      price: 988.4,
      description: "Release Left Thorax Muscle, Percutaneous Endoscopic Approach",
      category: "clothing",
      rating: 2.54,
      supply: 314,
    },
    {
      _id: "63701d24f032395b3300012c",
      name: "Barnie Divill",
      price: 786.02,
      description: "Excision of Right Foot Muscle, Percutaneous Approach",
      category: "shoes",
      rating: 1.11,
      supply: 858,
    },
    {
      _id: "63701d24f032395b3300012d",
      name: "Tomasina Faithfull",
      price: 211.21,
      description: "Supplement Left Foot Tendon with Autol Sub, Open Approach",
      category: "accessories",
      rating: 4.98,
      supply: 1185,
    },
    {
      _id: "63701d25f03239d591000327",
      name: "Pollyanna Pilmer",
      price: 247.93,
      description: "Immobilization of Right Foot using Cast",
      category: "clothing",
      rating: 1.17,
      supply: 659,
    },
    {
      _id: "63701d25f03239d591000328",
      name: "Israel Chason",
      price: 342.56,
      description: "Transfuse Autol Hemat Stem Cell in Central Art, Perc",
      category: "clothing",
      rating: 1.43,
      supply: 157,
    },
  ];
  
  export const dataProductStat = [
    {
      _id: "6371259df03239e680000035",
      productId: "63701d24f03239c72c00018e",
      yearlySalesTotal: 7152,
      yearlyTotalSoldUnits: 1414,
      monthlyData: [
        { month: "january", totalSales: 574, totalUnits: 93 },
        { month: "february", totalSales: 290, totalUnits: 337 },
        { month: "march", totalSales: 947, totalUnits: 182 },
        { month: "april", totalSales: 774, totalUnits: 490 },
        { month: "may", totalSales: 707, totalUnits: 320 },
        { month: "june", totalSales: 468, totalUnits: 3 },
        { month: "july", totalSales: 346, totalUnits: 15 },
        { month: "august", totalSales: 838, totalUnits: 456 },
        { month: "september", totalSales: 193, totalUnits: 341 },
        { month: "october", totalSales: 76, totalUnits: 231 },
        { month: "november", totalSales: 305, totalUnits: 219 },
        { month: "december", totalSales: 90, totalUnits: 1 },
      ],
      dailyData: [
        { date: "2021-01-02", totalSales: 18, totalUnits: 3 },
        { date: "2021-01-03", totalSales: 33, totalUnits: 29 },
        { date: "2021-01-04", totalSales: 5, totalUnits: 20 },
        { date: "2021-01-05", totalSales: 40, totalUnits: 41 },
        { date: "2021-01-06", totalSales: 83, totalUnits: 17 },
        { date: "2021-01-07", totalSales: 79, totalUnits: 26 },
        { date: "2021-01-08", totalSales: 98, totalUnits: 9 },
        { date: "2021-01-09", totalSales: 33, totalUnits: 25 },
        { date: "2021-01-10", totalSales: 32, totalUnits: 15 },
        { date: "2021-01-11", totalSales: 65, totalUnits: 48 },
        { date: "2021-01-12", totalSales: 71, totalUnits: 5 },
        { date: "2021-01-13", totalSales: 66, totalUnits: 34 },
        { date: "2021-01-14", totalSales: 3, totalUnits: 10 },
        { date: "2021-01-15", totalSales: 64, totalUnits: 29 },
        { date: "2021-01-16", totalSales: 13, totalUnits: 30 },
        { date: "2021-01-17", totalSales: 43, totalUnits: 49 },
        { date: "2021-01-18", totalSales: 5, totalUnits: 9 },
        { date: "2021-01-19", totalSales: 50, totalUnits: 42 },
        { date: "2021-01-20", totalSales: 42, totalUnits: 43 },
        { date: "2021-01-21", totalSales: 32, totalUnits: 2 },
        { date: "2021-01-22", totalSales: 53, totalUnits: 30 },
        { date: "2021-01-23", totalSales: 98, totalUnits: 39 },
        { date: "2021-01-24", totalSales: 6, totalUnits: 43 },
        { date: "2021-01-25", totalSales: 78, totalUnits: 34 },
        { date: "2021-01-26", totalSales: 71, totalUnits: 4 },
        { date: "2021-01-27", totalSales: 88, totalUnits: 16 },
        { date: "2021-01-28", totalSales: 39, totalUnits: 47 },
        { date: "2021-01-29", totalSales: 41, totalUnits: 20 },
        { date: "2021-01-30", totalSales: 31, totalUnits: 22 },
        { date: "2021-01-31", totalSales: 37, totalUnits: 11 },
        { date: "2021-02-01", totalSales: 15, totalUnits: 44 },
        { date: "2021-02-02", totalSales: 36, totalUnits: 48 },
        { date: "2021-02-03", totalSales: 89, totalUnits: 11 },
        { date: "2021-02-04", totalSales: 10, totalUnits: 13 },
        { date: "2021-02-05", totalSales: 64, totalUnits: 31 },
        { date: "2021-02-06", totalSales: 91, totalUnits: 7 },
        { date: "2021-02-07", totalSales: 66, totalUnits: 1 },
        { date: "2021-02-08", totalSales: 71, totalUnits: 48 },
        { date: "2021-02-09", totalSales: 9, totalUnits: 8 },
        { date: "2021-02-10", totalSales: 78, totalUnits: 15 },
        { date: "2021-02-11", totalSales: 51, totalUnits: 10 },
        { date: "2021-02-12", totalSales: 36, totalUnits: 23 },
        { date: "2021-02-13", totalSales: 49, totalUnits: 13 },
        { date: "2021-02-14", totalSales: 67, totalUnits: 3 },
        { date: "2021-02-15", totalSales: 15, totalUnits: 7 },
        { date: "2021-02-16", totalSales: 15, totalUnits: 5 },
        { date: "2021-02-17", totalSales: 67, totalUnits: 12 },
        { date: "2021-02-18", totalSales: 72, totalUnits: 31 },
        { date: "2021-02-19", totalSales: 52, totalUnits: 30 },
        { date: "2021-02-20", totalSales: 77, totalUnits: 40 },
        { date: "2021-02-21", totalSales: 81, totalUnits: 35 },
        { date: "2021-02-22", totalSales: 18, totalUnits: 35 },
        { date: "2021-02-23", totalSales: 27, totalUnits: 46 },
        { date: "2021-02-24", totalSales: 16, totalUnits: 45 },
        { date: "2021-02-25", totalSales: 40, totalUnits: 5 },
        { date: "2021-02-26", totalSales: 92, totalUnits: 31 },
        { date: "2021-02-27", totalSales: 90, totalUnits: 47 },
        { date: "2021-02-28", totalSales: 80, totalUnits: 30 },
        { date: "2021-03-01", totalSales: 65, totalUnits: 19 },
        { date: "2021-03-02", totalSales: 40, totalUnits: 16 },
        { date: "2021-03-03", totalSales: 42, totalUnits: 14 },
        { date: "2021-03-04", totalSales: 86, totalUnits: 28 },
        { date: "2021-03-05", totalSales: 1, totalUnits: 40 },
        { date: "2021-03-06", totalSales: 83, totalUnits: 8 },
        { date: "2021-03-07", totalSales: 17, totalUnits: 6 },
        { date: "2021-03-08", totalSales: 29, totalUnits: 8 },
        { date: "2021-03-09", totalSales: 73, totalUnits: 19 },
        { date: "2021-03-10", totalSales: 2, totalUnits: 15 },
        { date: "2021-03-11", totalSales: 49, totalUnits: 17 },
        { date: "2021-03-12", totalSales: 71, totalUnits: 40 },
        { date: "2021-03-13", totalSales: 17, totalUnits: 30 },
        { date: "2021-03-14", totalSales: 13, totalUnits: 29 },
        { date: "2021-03-15", totalSales: 35, totalUnits: 15 },
        { date: "2021-03-16", totalSales: 94, totalUnits: 41 },
        { date: "2021-03-17", totalSales: 75, totalUnits: 33 },
        { date: "2021-03-18", totalSales: 91, totalUnits: 36 },
        { date: "2021-03-19", totalSales: 80, totalUnits: 5 },
        { date: "2021-03-20", totalSales: 84, totalUnits: 43 },
        { date: "2021-03-21", totalSales: 10, totalUnits: 34 },
        { date: "2021-03-22", totalSales: 80, totalUnits: 47 },
        { date: "2021-03-23", totalSales: 4, totalUnits: 49 },
        { date: "2021-03-24", totalSales: 51, totalUnits: 9 },
        { date: "2021-03-25", totalSales: 54, totalUnits: 23 },
        { date: "2021-03-26", totalSales: 53, totalUnits: 2 },
        { date: "2021-03-27", totalSales: 48, totalUnits: 41 },
        { date: "2021-03-28", totalSales: 86, totalUnits: 43 },
        { date: "2021-03-29", totalSales: 84, totalUnits: 50 },
        { date: "2021-03-30", totalSales: 32, totalUnits: 15 },
        { date: "2021-03-31", totalSales: 82, totalUnits: 4 },
        { date: "2021-04-01", totalSales: 3, totalUnits: 43 },
        { date: "2021-04-02", totalSales: 12, totalUnits: 16 },
        { date: "2021-04-03", totalSales: 62, totalUnits: 20 },
        { date: "2021-04-04", totalSales: 95, totalUnits: 12 },
        { date: "2021-04-05", totalSales: 90, totalUnits: 7 },
        { date: "2021-04-06", totalSales: 28, totalUnits: 29 },
        { date: "2021-04-07", totalSales: 31, totalUnits: 34 },
        { date: "2021-04-08", totalSales: 16, totalUnits: 15 },
        { date: "2021-04-09", totalSales: 89, totalUnits: 9 },
        { date: "2021-04-10", totalSales: 56, totalUnits: 6 },
        { date: "2021-04-11", totalSales: 49, totalUnits: 50 },
        { date: "2021-04-12", totalSales: 30, totalUnits: 5 },
        { date: "2021-04-13", totalSales: 64, totalUnits: 50 },
        { date: "2021-04-14", totalSales: 73, totalUnits: 32 },
        { date: "2021-04-15", totalSales: 59, totalUnits: 20 },
        { date: "2021-04-16", totalSales: 97, totalUnits: 34 },
        { date: "2021-04-17", totalSales: 69, totalUnits: 23 },
        { date: "2021-04-18", totalSales: 27, totalUnits: 10 },
        { date: "2021-04-19", totalSales: 16, totalUnits: 39 },
        { date: "2021-04-20", totalSales: 38, totalUnits: 33 },
        { date: "2021-04-21", totalSales: 15, totalUnits: 25 },
        { date: "2021-04-22", totalSales: 23, totalUnits: 3 },
        { date: "2021-04-23", totalSales: 13, totalUnits: 29 },
        { date: "2021-04-24", totalSales: 97, totalUnits: 22 },
        { date: "2021-04-25", totalSales: 18, totalUnits: 44 },
        { date: "2021-04-26", totalSales: 4, totalUnits: 29 },
        { date: "2021-04-27", totalSales: 19, totalUnits: 20 },
        { date: "2021-04-28", totalSales: 96, totalUnits: 38 },
        { date: "2021-04-29", totalSales: 58, totalUnits: 45 },
        { date: "2021-04-30", totalSales: 30, totalUnits: 32 },
        { date: "2021-05-01", totalSales: 30, totalUnits: 11 },
        { date: "2021-05-02", totalSales: 68, totalUnits: 25 },
        { date: "2021-05-03", totalSales: 42, totalUnits: 36 },
        { date: "2021-05-04", totalSales: 69, totalUnits: 39 },
        { date: "2021-05-05", totalSales: 63, totalUnits: 36 },
        { date: "2021-05-06", totalSales: 39, totalUnits: 37 },
        { date: "2021-05-07", totalSales: 47, totalUnits: 39 },
        { date: "2021-05-08", totalSales: 28, totalUnits: 36 },
        { date: "2021-05-09", totalSales: 68, totalUnits: 47 },
        { date: "2021-05-10", totalSales: 20, totalUnits: 32 },
        { date: "2021-05-11", totalSales: 43, totalUnits: 34 },
        { date: "2021-05-12", totalSales: 80, totalUnits: 29 },
        { date: "2021-05-13", totalSales: 78, totalUnits: 43 },
        { date: "2021-05-14", totalSales: 87, totalUnits: 21 },
        { date: "2021-05-15", totalSales: 86, totalUnits: 6 },
        { date: "2021-05-16", totalSales: 7, totalUnits: 19 },
        { date: "2021-05-17", totalSales: 47, totalUnits: 16 },
        { date: "2021-05-18", totalSales: 38, totalUnits: 27 },
        { date: "2021-05-19", totalSales: 79, totalUnits: 47 },
        { date: "2021-05-20", totalSales: 9, totalUnits: 32 },
        { date: "2021-05-21", totalSales: 15, totalUnits: 22 },
        { date: "2021-05-22", totalSales: 53, totalUnits: 3 },
        { date: "2021-05-23", totalSales: 49, totalUnits: 4 },
        { date: "2021-05-24", totalSales: 52, totalUnits: 13 },
        { date: "2021-05-25", totalSales: 30, totalUnits: 44 },
        { date: "2021-05-26", totalSales: 7, totalUnits: 46 },
        { date: "2021-05-27", totalSales: 22, totalUnits: 14 },
        { date: "2021-05-28", totalSales: 53, totalUnits: 38 },
        { date: "2021-05-29", totalSales: 77, totalUnits: 38 },
        { date: "2021-05-30", totalSales: 67, totalUnits: 20 },
        { date: "2021-05-31", totalSales: 88, totalUnits: 11 },
        { date: "2021-06-01", totalSales: 60, totalUnits: 22 },
        { date: "2021-06-02", totalSales: 88, totalUnits: 41 },
        { date: "2021-06-03", totalSales: 86, totalUnits: 32 },
        { date: "2021-06-04", totalSales: 19, totalUnits: 26 },
        { date: "2021-06-05", totalSales: 12, totalUnits: 11 },
        { date: "2021-06-06", totalSales: 79, totalUnits: 4 },
        { date: "2021-06-07", totalSales: 54, totalUnits: 22 },
        { date: "2021-06-08", totalSales: 98, totalUnits: 33 },
        { date: "2021-06-09", totalSales: 33, totalUnits: 20 },
        { date: "2021-06-10", totalSales: 92, totalUnits: 19 },
        { date: "2021-06-11", totalSales: 14, totalUnits: 43 },
        { date: "2021-06-12", totalSales: 35, totalUnits: 2 },
        { date: "2021-06-13", totalSales: 18, totalUnits: 4 },
        { date: "2021-06-14", totalSales: 91, totalUnits: 13 },
        { date: "2021-06-15", totalSales: 97, totalUnits: 46 },
        { date: "2021-06-16", totalSales: 90, totalUnits: 41 },
        { date: "2021-06-17", totalSales: 96, totalUnits: 11 },
        { date: "2021-06-18", totalSales: 65, totalUnits: 25 },
        { date: "2021-06-19", totalSales: 73, totalUnits: 13 },
        { date: "2021-06-20", totalSales: 41, totalUnits: 32 },
        { date: "2021-06-21", totalSales: 36, totalUnits: 6 },
        { date: "2021-06-22", totalSales: 84, totalUnits: 49 },
        { date: "2021-06-23", totalSales: 42, totalUnits: 50 },
        { date: "2021-06-24", totalSales: 94, totalUnits: 33 },
        { date: "2021-06-25", totalSales: 6, totalUnits: 16 },
        { date: "2021-06-26", totalSales: 95, totalUnits: 20 },
        { date: "2021-06-27", totalSales: 49, totalUnits: 4 },
        { date: "2021-06-28", totalSales: 70, totalUnits: 46 },
        { date: "2021-06-29", totalSales: 1, totalUnits: 41 },
        { date: "2021-06-30", totalSales: 54, totalUnits: 2 },
        { date: "2021-07-01", totalSales: 100, totalUnits: 45 },
        { date: "2021-07-02", totalSales: 65, totalUnits: 27 },
        { date: "2021-07-03", totalSales: 66, totalUnits: 20 },
        { date: "2021-07-04", totalSales: 9, totalUnits: 24 },
        { date: "2021-07-05", totalSales: 81, totalUnits: 48 },
        { date: "2021-07-06", totalSales: 5, totalUnits: 17 },
        { date: "2021-07-07", totalSales: 77, totalUnits: 30 },
        { date: "2021-07-08", totalSales: 88, totalUnits: 37 },
        { date: "2021-07-09", totalSales: 17, totalUnits: 37 },
        { date: "2021-07-10", totalSales: 35, totalUnits: 10 },
        { date: "2021-07-11", totalSales: 32, totalUnits: 35 },
        { date: "2021-07-12", totalSales: 13, totalUnits: 10 },
        { date: "2021-07-13", totalSales: 64, totalUnits: 23 },
        { date: "2021-07-14", totalSales: 76, totalUnits: 33 },
        { date: "2021-07-15", totalSales: 25, totalUnits: 50 },
        { date: "2021-07-16", totalSales: 72, totalUnits: 8 },
        { date: "2021-07-17", totalSales: 44, totalUnits: 7 },
        { date: "2021-07-18", totalSales: 87, totalUnits: 29 },
        { date: "2021-07-19", totalSales: 30, totalUnits: 7 },
        { date: "2021-07-20", totalSales: 93, totalUnits: 7 },
        { date: "2021-07-21", totalSales: 72, totalUnits: 42 },
        { date: "2021-07-22", totalSales: 97, totalUnits: 20 },
        { date: "2021-07-23", totalSales: 78, totalUnits: 42 },
        { date: "2021-07-24", totalSales: 6, totalUnits: 17 },
        { date: "2021-07-25", totalSales: 9, totalUnits: 7 },
        { date: "2021-07-26", totalSales: 5, totalUnits: 36 },
        { date: "2021-07-27", totalSales: 3, totalUnits: 2 },
        { date: "2021-07-28", totalSales: 18, totalUnits: 36 },
        { date: "2021-07-29", totalSales: 69, totalUnits: 33 },
        { date: "2021-07-30", totalSales: 6, totalUnits: 15 },
        { date: "2021-07-31", totalSales: 54, totalUnits: 24 },
        { date: "2021-08-01", totalSales: 70, totalUnits: 29 },
        { date: "2021-08-02", totalSales: 56, totalUnits: 12 },
        { date: "2021-08-03", totalSales: 90, totalUnits: 46 },
        { date: "2021-08-04", totalSales: 46, totalUnits: 39 },
        { date: "2021-08-05", totalSales: 49, totalUnits: 10 },
        { date: "2021-08-06", totalSales: 1, totalUnits: 37 },
        { date: "2021-08-07", totalSales: 51, totalUnits: 41 },
        { date: "2021-08-08", totalSales: 20, totalUnits: 33 },
        { date: "2021-08-09", totalSales: 50, totalUnits: 43 },
        { date: "2021-08-10", totalSales: 91, totalUnits: 41 },
        { date: "2021-08-11", totalSales: 63, totalUnits: 19 },
        { date: "2021-08-12", totalSales: 28, totalUnits: 41 },
        { date: "2021-08-13", totalSales: 93, totalUnits: 7 },
        { date: "2021-08-14", totalSales: 26, totalUnits: 50 },
        { date: "2021-08-15", totalSales: 33, totalUnits: 40 },
        { date: "2021-08-16", totalSales: 71, totalUnits: 11 },
        { date: "2021-08-17", totalSales: 40, totalUnits: 44 },
        { date: "2021-08-18", totalSales: 31, totalUnits: 6 },
        { date: "2021-08-19", totalSales: 29, totalUnits: 7 },
        { date: "2021-08-20", totalSales: 96, totalUnits: 47 },
        { date: "2021-08-21", totalSales: 27, totalUnits: 48 },
        { date: "2021-08-22", totalSales: 29, totalUnits: 31 },
        { date: "2021-08-23", totalSales: 31, totalUnits: 22 },
        { date: "2021-08-24", totalSales: 16, totalUnits: 16 },
        { date: "2021-08-25", totalSales: 33, totalUnits: 38 },
        { date: "2021-08-26", totalSales: 76, totalUnits: 28 },
        { date: "2021-08-27", totalSales: 25, totalUnits: 7 },
        { date: "2021-08-28", totalSales: 46, totalUnits: 18 },
        { date: "2021-08-29", totalSales: 30, totalUnits: 34 },
        { date: "2021-08-30", totalSales: 61, totalUnits: 2 },
        { date: "2021-08-31", totalSales: 6, totalUnits: 10 },
        { date: "2021-09-01", totalSales: 36, totalUnits: 29 },
        { date: "2021-09-02", totalSales: 75, totalUnits: 45 },
        { date: "2021-09-03", totalSales: 46, totalUnits: 5 },
        { date: "2021-09-04", totalSales: 2, totalUnits: 41 },
        { date: "2021-09-05", totalSales: 73, totalUnits: 38 },
        { date: "2021-09-06", totalSales: 96, totalUnits: 50 },
        { date: "2021-09-07", totalSales: 53, totalUnits: 4 },
        { date: "2021-09-08", totalSales: 51, totalUnits: 44 },
        { date: "2021-09-09", totalSales: 40, totalUnits: 41 },
        { date: "2021-09-10", totalSales: 49, totalUnits: 28 },
        { date: "2021-09-11", totalSales: 35, totalUnits: 8 },
        { date: "2021-09-12", totalSales: 59, totalUnits: 43 },
        { date: "2021-09-13", totalSales: 20, totalUnits: 1 },
        { date: "2021-09-14", totalSales: 90, totalUnits: 5 },
        { date: "2021-09-15", totalSales: 40, totalUnits: 42 },
        { date: "2021-09-16", totalSales: 24, totalUnits: 41 },
        { date: "2021-09-17", totalSales: 42, totalUnits: 34 },
        { date: "2021-09-18", totalSales: 36, totalUnits: 20 },
        { date: "2021-09-19", totalSales: 17, totalUnits: 48 },
        { date: "2021-09-20", totalSales: 15, totalUnits: 4 },
        { date: "2021-09-21", totalSales: 86, totalUnits: 47 },
        { date: "2021-09-22", totalSales: 52, totalUnits: 35 },
        { date: "2021-09-23", totalSales: 44, totalUnits: 14 },
        { date: "2021-09-24", totalSales: 60, totalUnits: 1 },
        { date: "2021-09-25", totalSales: 3, totalUnits: 22 },
        { date: "2021-09-26", totalSales: 31, totalUnits: 43 },
        { date: "2021-09-27", totalSales: 56, totalUnits: 32 },
        { date: "2021-09-28", totalSales: 42, totalUnits: 49 },
        { date: "2021-09-29", totalSales: 36, totalUnits: 6 },
        { date: "2021-09-30", totalSales: 5, totalUnits: 19 },
        { date: "2021-10-01", totalSales: 68, totalUnits: 16 },
        { date: "2021-10-02", totalSales: 33, totalUnits: 50 },
        { date: "2021-10-03", totalSales: 99, totalUnits: 26 },
        { date: "2021-10-04", totalSales: 81, totalUnits: 35 },
        { date: "2021-10-05", totalSales: 27, totalUnits: 32 },
        { date: "2021-10-06", totalSales: 23, totalUnits: 45 },
        { date: "2021-10-07", totalSales: 40, totalUnits: 33 },
        { date: "2021-10-08", totalSales: 65, totalUnits: 21 },
        { date: "2021-10-09", totalSales: 44, totalUnits: 17 },
        { date: "2021-10-10", totalSales: 7, totalUnits: 17 },
        { date: "2021-10-11", totalSales: 60, totalUnits: 12 },
        { date: "2021-10-12", totalSales: 34, totalUnits: 18 },
        { date: "2021-10-13", totalSales: 21, totalUnits: 12 },
        { date: "2021-10-14", totalSales: 58, totalUnits: 15 },
        { date: "2021-10-15", totalSales: 21, totalUnits: 9 },
        { date: "2021-10-16", totalSales: 41, totalUnits: 6 },
        { date: "2021-10-17", totalSales: 70, totalUnits: 29 },
        { date: "2021-10-18", totalSales: 38, totalUnits: 31 },
        { date: "2021-10-19", totalSales: 69, totalUnits: 46 },
        { date: "2021-10-20", totalSales: 21, totalUnits: 37 },
        { date: "2021-10-21", totalSales: 40, totalUnits: 19 },
        { date: "2021-10-22", totalSales: 78, totalUnits: 20 },
        { date: "2021-10-23", totalSales: 71, totalUnits: 43 },
        { date: "2021-10-24", totalSales: 36, totalUnits: 18 },
        { date: "2021-10-25", totalSales: 65, totalUnits: 41 },
        { date: "2021-10-26", totalSales: 52, totalUnits: 12 },
        { date: "2021-10-27", totalSales: 67, totalUnits: 46 },
        { date: "2021-10-28", totalSales: 25, totalUnits: 14 },
        { date: "2021-10-29", totalSales: 5, totalUnits: 48 },
        { date: "2021-10-30", totalSales: 6, totalUnits: 42 },
        { date: "2021-10-31", totalSales: 14, totalUnits: 42 },
        { date: "2021-11-01", totalSales: 74, totalUnits: 43 },
        { date: "2021-11-02", totalSales: 92, totalUnits: 20 },
        { date: "2021-11-03", totalSales: 39, totalUnits: 46 },
        { date: "2021-11-04", totalSales: 83, totalUnits: 13 },
        { date: "2021-11-05", totalSales: 10, totalUnits: 35 },
        { date: "2021-11-06", totalSales: 69, totalUnits: 26 },
        { date: "2021-11-07", totalSales: 21, totalUnits: 36 },
        { date: "2021-11-08", totalSales: 19, totalUnits: 39 },
        { date: "2021-11-09", totalSales: 27, totalUnits: 10 },
        { date: "2021-11-10", totalSales: 57, totalUnits: 9 },
        { date: "2021-11-11", totalSales: 98, totalUnits: 14 },
        { date: "2021-11-12", totalSales: 73, totalUnits: 2 },
        { date: "2021-11-13", totalSales: 37, totalUnits: 32 },
        { date: "2021-11-14", totalSales: 94, totalUnits: 27 },
        { date: "2021-11-15", totalSales: 32, totalUnits: 15 },
        { date: "2021-11-16", totalSales: 74, totalUnits: 15 },
        { date: "2021-11-17", totalSales: 26, totalUnits: 42 },
      ],
    },
    {
      _id: "6371259ef032398675000198",
      productId: "63701d24f03239c72c00018f",
      yearlySalesTotal: 2192,
      yearlyTotalSoldUnits: 1169,
      monthlyData: [
        { month: "january", totalSales: 738, totalUnits: 275 },
        { month: "february", totalSales: 938, totalUnits: 71 },
        { month: "march", totalSales: 24, totalUnits: 400 },
        { month: "april", totalSales: 423, totalUnits: 174 },
        { month: "may", totalSales: 875, totalUnits: 238 },
        { month: "june", totalSales: 376, totalUnits: 471 },
        { month: "july", totalSales: 364, totalUnits: 78 },
        { month: "august", totalSales: 510, totalUnits: 223 },
        { month: "september", totalSales: 395, totalUnits: 109 },
        { month: "october", totalSales: 279, totalUnits: 68 },
        { month: "november", totalSales: 604, totalUnits: 174 },
        { month: "december", totalSales: 701, totalUnits: 422 },
      ],
      dailyData: [
        { date: "2021-01-02", totalSales: 88, totalUnits: 30 },
        { date: "2021-01-03", totalSales: 96, totalUnits: 19 },
        { date: "2021-01-04", totalSales: 9, totalUnits: 26 },
        { date: "2021-01-05", totalSales: 79, totalUnits: 38 },
        { date: "2021-01-06", totalSales: 27, totalUnits: 30 },
        { date: "2021-01-07", totalSales: 7, totalUnits: 7 },
        { date: "2021-01-08", totalSales: 4, totalUnits: 27 },
        { date: "2021-01-09", totalSales: 19, totalUnits: 12 },
        { date: "2021-01-10", totalSales: 20, totalUnits: 10 },
        { date: "2021-01-11", totalSales: 58, totalUnits: 34 },
        { date: "2021-01-12", totalSales: 54, totalUnits: 43 },
        { date: "2021-01-13", totalSales: 58, totalUnits: 15 },
        { date: "2021-01-14", totalSales: 60, totalUnits: 14 },
        { date: "2021-01-15", totalSales: 93, totalUnits: 41 },
        { date: "2021-01-16", totalSales: 60, totalUnits: 47 },
        { date: "2021-01-17", totalSales: 97, totalUnits: 33 },
        { date: "2021-01-18", totalSales: 28, totalUnits: 25 },
        { date: "2021-01-19", totalSales: 13, totalUnits: 25 },
        { date: "2021-01-20", totalSales: 59, totalUnits: 8 },
        { date: "2021-01-21", totalSales: 53, totalUnits: 5 },
        { date: "2021-01-22", totalSales: 64, totalUnits: 28 },
        { date: "2021-01-23", totalSales: 77, totalUnits: 41 },
        { date: "2021-01-24", totalSales: 71, totalUnits: 1 },
        { date: "2021-01-25", totalSales: 53, totalUnits: 17 },
        { date: "2021-01-26", totalSales: 40, totalUnits: 18 },
        { date: "2021-01-27", totalSales: 84, totalUnits: 25 },
        { date: "2021-01-28", totalSales: 26, totalUnits: 38 },
        { date: "2021-01-29", totalSales: 85, totalUnits: 5 },
        { date: "2021-01-30", totalSales: 82, totalUnits: 30 },
        { date: "2021-01-31", totalSales: 7, totalUnits: 6 },
        { date: "2021-02-01", totalSales: 78, totalUnits: 14 },
        { date: "2021-02-02", totalSales: 1, totalUnits: 2 },
        { date: "2021-02-03", totalSales: 58, totalUnits: 24 },
        { date: "2021-02-04", totalSales: 89, totalUnits: 45 },
        { date: "2021-02-05", totalSales: 56, totalUnits: 44 },
        { date: "2021-02-06", totalSales: 33, totalUnits: 20 },
        { date: "2021-02-07", totalSales: 48, totalUnits: 26 },
        { date: "2021-02-08", totalSales: 33, totalUnits: 36 },
        { date: "2021-02-09", totalSales: 61, totalUnits: 36 },
        { date: "2021-02-10", totalSales: 3, totalUnits: 11 },
        { date: "2021-02-11", totalSales: 55, totalUnits: 16 },
        { date: "2021-02-12", totalSales: 86, totalUnits: 2 },
        { date: "2021-02-13", totalSales: 53, totalUnits: 19 },
        { date: "2021-02-14", totalSales: 78, totalUnits: 24 },
        { date: "2021-02-15", totalSales: 88, totalUnits: 37 },
        { date: "2021-02-16", totalSales: 49, totalUnits: 38 },
        { date: "2021-02-17", totalSales: 90, totalUnits: 38 },
        { date: "2021-02-18", totalSales: 16, totalUnits: 15 },
        { date: "2021-02-19", totalSales: 49, totalUnits: 49 },
        { date: "2021-02-20", totalSales: 68, totalUnits: 16 },
        { date: "2021-02-21", totalSales: 35, totalUnits: 48 },
        { date: "2021-02-22", totalSales: 37, totalUnits: 37 },
        { date: "2021-02-23", totalSales: 85, totalUnits: 37 },
        { date: "2021-02-24", totalSales: 69, totalUnits: 39 },
        { date: "2021-02-25", totalSales: 5, totalUnits: 12 },
        { date: "2021-02-26", totalSales: 67, totalUnits: 29 },
        { date: "2021-02-27", totalSales: 95, totalUnits: 11 },
        { date: "2021-02-28", totalSales: 43, totalUnits: 13 },
        { date: "2021-03-01", totalSales: 87, totalUnits: 13 },
        { date: "2021-03-02", totalSales: 46, totalUnits: 19 },
        { date: "2021-03-03", totalSales: 96, totalUnits: 28 },
        { date: "2021-03-04", totalSales: 31, totalUnits: 23 },
        { date: "2021-03-05", totalSales: 91, totalUnits: 39 },
        { date: "2021-03-06", totalSales: 96, totalUnits: 49 },
        { date: "2021-03-07", totalSales: 55, totalUnits: 27 },
        { date: "2021-03-08", totalSales: 62, totalUnits: 31 },
        { date: "2021-03-09", totalSales: 39, totalUnits: 36 },
        { date: "2021-03-10", totalSales: 62, totalUnits: 49 },
        { date: "2021-03-11", totalSales: 9, totalUnits: 18 },
        { date: "2021-03-12", totalSales: 21, totalUnits: 9 },
        { date: "2021-03-13", totalSales: 35, totalUnits: 19 },
        { date: "2021-03-14", totalSales: 68, totalUnits: 8 },
        { date: "2021-03-15", totalSales: 77, totalUnits: 15 },
        { date: "2021-03-16", totalSales: 41, totalUnits: 49 },
        { date: "2021-03-17", totalSales: 67, totalUnits: 46 },
        { date: "2021-03-18", totalSales: 58, totalUnits: 46 },
        { date: "2021-03-19", totalSales: 19, totalUnits: 9 },
        { date: "2021-03-20", totalSales: 41, totalUnits: 15 },
        { date: "2021-03-21", totalSales: 78, totalUnits: 11 },
        { date: "2021-03-22", totalSales: 28, totalUnits: 35 },
        { date: "2021-03-23", totalSales: 85, totalUnits: 1 },
        { date: "2021-03-24", totalSales: 46, totalUnits: 18 },
        { date: "2021-03-25", totalSales: 42, totalUnits: 11 },
        { date: "2021-03-26", totalSales: 28, totalUnits: 3 },
        { date: "2021-03-27", totalSales: 79, totalUnits: 10 },
        { date: "2021-03-28", totalSales: 37, totalUnits: 5 },
        { date: "2021-03-29", totalSales: 99, totalUnits: 27 },
        { date: "2021-03-30", totalSales: 85, totalUnits: 2 },
        { date: "2021-03-31", totalSales: 34, totalUnits: 33 },
        { date: "2021-04-01", totalSales: 64, totalUnits: 15 },
        { date: "2021-04-02", totalSales: 30, totalUnits: 48 },
        { date: "2021-04-03", totalSales: 80, totalUnits: 8 },
        { date: "2021-04-04", totalSales: 6, totalUnits: 1 },
        { date: "2021-04-05", totalSales: 28, totalUnits: 49 },
        { date: "2021-04-06", totalSales: 94, totalUnits: 19 },
        { date: "2021-04-07", totalSales: 56, totalUnits: 27 },
        { date: "2021-04-08", totalSales: 89, totalUnits: 9 },
        { date: "2021-04-09", totalSales: 64, totalUnits: 32 },
        { date: "2021-04-10", totalSales: 73, totalUnits: 38 },
        { date: "2021-04-11", totalSales: 19, totalUnits: 36 },
        { date: "2021-04-12", totalSales: 28, totalUnits: 25 },
        { date: "2021-04-13", totalSales: 4, totalUnits: 41 },
        { date: "2021-04-14", totalSales: 52, totalUnits: 2 },
        { date: "2021-04-15", totalSales: 58, totalUnits: 20 },
        { date: "2021-04-16", totalSales: 3, totalUnits: 13 },
        { date: "2021-04-17", totalSales: 82, totalUnits: 9 },
        { date: "2021-04-18", totalSales: 13, totalUnits: 41 },
        { date: "2021-04-19", totalSales: 93, totalUnits: 36 },
        { date: "2021-04-20", totalSales: 29, totalUnits: 15 },
        { date: "2021-04-21", totalSales: 99, totalUnits: 16 },
        { date: "2021-04-22", totalSales: 91, totalUnits: 43 },
        { date: "2021-04-23", totalSales: 7, totalUnits: 12 },
        { date: "2021-04-24", totalSales: 87, totalUnits: 36 },
        { date: "2021-04-25", totalSales: 35, totalUnits: 23 },
        { date: "2021-04-26", totalSales: 61, totalUnits: 18 },
        { date: "2021-04-27", totalSales: 86, totalUnits: 47 },
        { date: "2021-04-28", totalSales: 81, totalUnits: 27 },
        { date: "2021-04-29", totalSales: 65, totalUnits: 24 },
        { date: "2021-04-30", totalSales: 53, totalUnits: 23 },
        { date: "2021-05-01", totalSales: 10, totalUnits: 38 },
        { date: "2021-05-02", totalSales: 39, totalUnits: 4 },
        { date: "2021-05-03", totalSales: 24, totalUnits: 42 },
        { date: "2021-05-04", totalSales: 83, totalUnits: 36 },
        { date: "2021-05-05", totalSales: 46, totalUnits: 39 },
        { date: "2021-05-06", totalSales: 48, totalUnits: 32 },
        { date: "2021-05-07", totalSales: 53, totalUnits: 35 },
        { date: "2021-05-08", totalSales: 72, totalUnits: 1 },
        { date: "2021-05-09", totalSales: 76, totalUnits: 24 },
        { date: "2021-05-10", totalSales: 83, totalUnits: 34 },
        { date: "2021-05-11", totalSales: 43, totalUnits: 25 },
        { date: "2021-05-12", totalSales: 37, totalUnits: 20 },
        { date: "2021-05-13", totalSales: 86, totalUnits: 12 },
        { date: "2021-05-14", totalSales: 65, totalUnits: 17 },
        { date: "2021-05-15", totalSales: 90, totalUnits: 43 },
        { date: "2021-05-16", totalSales: 64, totalUnits: 21 },
        { date: "2021-05-17", totalSales: 35, totalUnits: 32 },
        { date: "2021-05-18", totalSales: 32, totalUnits: 1 },
        { date: "2021-05-19", totalSales: 63, totalUnits: 48 },
        { date: "2021-05-20", totalSales: 97, totalUnits: 49 },
        { date: "2021-05-21", totalSales: 69, totalUnits: 43 },
        { date: "2021-05-22", totalSales: 21, totalUnits: 38 },
        { date: "2021-05-23", totalSales: 11, totalUnits: 42 },
        { date: "2021-05-24", totalSales: 40, totalUnits: 34 },
        { date: "2021-05-25", totalSales: 29, totalUnits: 30 },
        { date: "2021-05-26", totalSales: 9, totalUnits: 37 },
        { date: "2021-05-27", totalSales: 64, totalUnits: 19 },
        { date: "2021-05-28", totalSales: 77, totalUnits: 22 },
        { date: "2021-05-29", totalSales: 59, totalUnits: 2 },
        { date: "2021-05-30", totalSales: 22, totalUnits: 40 },
        { date: "2021-05-31", totalSales: 49, totalUnits: 31 },
        { date: "2021-06-01", totalSales: 34, totalUnits: 44 },
        { date: "2021-06-02", totalSales: 8, totalUnits: 20 },
        { date: "2021-06-03", totalSales: 89, totalUnits: 47 },
        { date: "2021-06-04", totalSales: 33, totalUnits: 43 },
        { date: "2021-06-05", totalSales: 64, totalUnits: 31 },
        { date: "2021-06-06", totalSales: 56, totalUnits: 36 },
        { date: "2021-06-07", totalSales: 7, totalUnits: 33 },
        { date: "2021-06-08", totalSales: 19, totalUnits: 40 },
        { date: "2021-06-09", totalSales: 59, totalUnits: 2 },
        { date: "2021-06-10", totalSales: 91, totalUnits: 31 },
        { date: "2021-06-11", totalSales: 57, totalUnits: 35 },
        { date: "2021-06-12", totalSales: 70, totalUnits: 43 },
        { date: "2021-06-13", totalSales: 38, totalUnits: 33 },
        { date: "2021-06-14", totalSales: 7, totalUnits: 6 },
        { date: "2021-06-15", totalSales: 68, totalUnits: 11 },
        { date: "2021-06-16", totalSales: 95, totalUnits: 38 },
        { date: "2021-06-17", totalSales: 44, totalUnits: 27 },
        { date: "2021-06-18", totalSales: 100, totalUnits: 18 },
        { date: "2021-06-19", totalSales: 8, totalUnits: 20 },
        { date: "2021-06-20", totalSales: 58, totalUnits: 50 },
        { date: "2021-06-21", totalSales: 92, totalUnits: 50 },
        { date: "2021-06-22", totalSales: 100, totalUnits: 39 },
        { date: "2021-06-23", totalSales: 61, totalUnits: 37 },
        { date: "2021-06-24", totalSales: 56, totalUnits: 48 },
        { date: "2021-06-25", totalSales: 85, totalUnits: 15 },
        { date: "2021-06-26", totalSales: 62, totalUnits: 45 },
        { date: "2021-06-27", totalSales: 94, totalUnits: 41 },
        { date: "2021-06-28", totalSales: 24, totalUnits: 28 },
        { date: "2021-06-29", totalSales: 22, totalUnits: 17 },
        { date: "2021-06-30", totalSales: 59, totalUnits: 28 },
        { date: "2021-07-01", totalSales: 42, totalUnits: 6 },
        { date: "2021-07-02", totalSales: 43, totalUnits: 33 },
        { date: "2021-07-03", totalSales: 79, totalUnits: 22 },
        { date: "2021-07-04", totalSales: 6, totalUnits: 11 },
        { date: "2021-07-05", totalSales: 53, totalUnits: 6 },
        { date: "2021-07-06", totalSales: 60, totalUnits: 36 },
        { date: "2021-07-07", totalSales: 60, totalUnits: 49 },
        { date: "2021-07-08", totalSales: 81, totalUnits: 16 },
        { date: "2021-07-09", totalSales: 53, totalUnits: 14 },
        { date: "2021-07-10", totalSales: 15, totalUnits: 9 },
        { date: "2021-07-11", totalSales: 5, totalUnits: 38 },
        { date: "2021-07-12", totalSales: 89, totalUnits: 16 },
        { date: "2021-07-13", totalSales: 91, totalUnits: 37 },
        { date: "2021-07-14", totalSales: 41, totalUnits: 7 },
        { date: "2021-07-15", totalSales: 10, totalUnits: 45 },
        { date: "2021-07-16", totalSales: 7, totalUnits: 28 },
        { date: "2021-07-17", totalSales: 45, totalUnits: 46 },
        { date: "2021-07-18", totalSales: 16, totalUnits: 32 },
        { date: "2021-07-19", totalSales: 32, totalUnits: 27 },
        { date: "2021-07-20", totalSales: 78, totalUnits: 3 },
        { date: "2021-07-21", totalSales: 47, totalUnits: 38 },
        { date: "2021-07-22", totalSales: 34, totalUnits: 27 },
        { date: "2021-07-23", totalSales: 57, totalUnits: 13 },
        { date: "2021-07-24", totalSales: 18, totalUnits: 11 },
        { date: "2021-07-25", totalSales: 82, totalUnits: 6 },
        { date: "2021-07-26", totalSales: 90, totalUnits: 25 },
        { date: "2021-07-27", totalSales: 77, totalUnits: 5 },
        { date: "2021-07-28", totalSales: 79, totalUnits: 38 },
        { date: "2021-07-29", totalSales: 23, totalUnits: 2 },
        { date: "2021-07-30", totalSales: 93, totalUnits: 2 },
        { date: "2021-07-31", totalSales: 91, totalUnits: 26 },
        { date: "2021-08-01", totalSales: 78, totalUnits: 21 },
        { date: "2021-08-02", totalSales: 82, totalUnits: 23 },
        { date: "2021-08-03", totalSales: 49, totalUnits: 16 },
        { date: "2021-08-04", totalSales: 42, totalUnits: 50 },
        { date: "2021-08-05", totalSales: 1, totalUnits: 13 },
        { date: "2021-08-06", totalSales: 58, totalUnits: 27 },
        { date: "2021-08-07", totalSales: 1, totalUnits: 10 },
        { date: "2021-08-08", totalSales: 30, totalUnits: 47 },
        { date: "2021-08-09", totalSales: 35, totalUnits: 1 },
        { date: "2021-08-10", totalSales: 49, totalUnits: 2 },
        { date: "2021-08-11", totalSales: 46, totalUnits: 48 },
        { date: "2021-08-12", totalSales: 85, totalUnits: 33 },
        { date: "2021-08-13", totalSales: 65, totalUnits: 46 },
        { date: "2021-08-14", totalSales: 2, totalUnits: 10 },
        { date: "2021-08-15", totalSales: 92, totalUnits: 44 },
        { date: "2021-08-16", totalSales: 68, totalUnits: 35 },
        { date: "2021-08-17", totalSales: 49, totalUnits: 25 },
        { date: "2021-08-18", totalSales: 64, totalUnits: 18 },
        { date: "2021-08-19", totalSales: 97, totalUnits: 46 },
        { date: "2021-08-20", totalSales: 33, totalUnits: 13 },
        { date: "2021-08-21", totalSales: 28, totalUnits: 1 },
        { date: "2021-08-22", totalSales: 54, totalUnits: 15 },
        { date: "2021-08-23", totalSales: 19, totalUnits: 1 },
        { date: "2021-08-24", totalSales: 1, totalUnits: 7 },
        { date: "2021-08-25", totalSales: 57, totalUnits: 39 },
        { date: "2021-08-26", totalSales: 71, totalUnits: 8 },
        { date: "2021-08-27", totalSales: 66, totalUnits: 15 },
        { date: "2021-08-28", totalSales: 34, totalUnits: 46 },
        { date: "2021-08-29", totalSales: 100, totalUnits: 7 },
        { date: "2021-08-30", totalSales: 46, totalUnits: 10 },
        { date: "2021-08-31", totalSales: 29, totalUnits: 2 },
        { date: "2021-09-01", totalSales: 57, totalUnits: 10 },
        { date: "2021-09-02", totalSales: 27, totalUnits: 5 },
        { date: "2021-09-03", totalSales: 23, totalUnits: 13 },
        { date: "2021-09-04", totalSales: 46, totalUnits: 11 },
        { date: "2021-09-05", totalSales: 33, totalUnits: 20 },
        { date: "2021-09-06", totalSales: 6, totalUnits: 5 },
        { date: "2021-09-07", totalSales: 61, totalUnits: 11 },
        { date: "2021-09-08", totalSales: 7, totalUnits: 44 },
        { date: "2021-09-09", totalSales: 58, totalUnits: 26 },
        { date: "2021-09-10", totalSales: 89, totalUnits: 12 },
        { date: "2021-09-11", totalSales: 86, totalUnits: 20 },
        { date: "2021-09-12", totalSales: 8, totalUnits: 31 },
        { date: "2021-09-13", totalSales: 16, totalUnits: 35 },
        { date: "2021-09-14", totalSales: 95, totalUnits: 32 },
        { date: "2021-09-15", totalSales: 2, totalUnits: 13 },
        { date: "2021-09-16", totalSales: 34, totalUnits: 17 },
        { date: "2021-09-17", totalSales: 70, totalUnits: 15 },
        { date: "2021-09-18", totalSales: 27, totalUnits: 15 },
        { date: "2021-09-19", totalSales: 8, totalUnits: 12 },
        { date: "2021-09-20", totalSales: 31, totalUnits: 30 },
        { date: "2021-09-21", totalSales: 44, totalUnits: 32 },
        { date: "2021-09-22", totalSales: 4, totalUnits: 31 },
        { date: "2021-09-23", totalSales: 56, totalUnits: 46 },
        { date: "2021-09-24", totalSales: 40, totalUnits: 40 },
        { date: "2021-09-25", totalSales: 55, totalUnits: 5 },
        { date: "2021-09-26", totalSales: 100, totalUnits: 18 },
        { date: "2021-09-27", totalSales: 47, totalUnits: 4 },
        { date: "2021-09-28", totalSales: 80, totalUnits: 20 },
        { date: "2021-09-29", totalSales: 100, totalUnits: 35 },
        { date: "2021-09-30", totalSales: 19, totalUnits: 47 },
        { date: "2021-10-01", totalSales: 81, totalUnits: 44 },
        { date: "2021-10-02", totalSales: 39, totalUnits: 42 },
        { date: "2021-10-03", totalSales: 21, totalUnits: 44 },
        { date: "2021-10-04", totalSales: 30, totalUnits: 13 },
        { date: "2021-10-05", totalSales: 8, totalUnits: 16 },
        { date: "2021-10-06", totalSales: 92, totalUnits: 26 },
        { date: "2021-10-07", totalSales: 96, totalUnits: 48 },
        { date: "2021-10-08", totalSales: 78, totalUnits: 7 },
        { date: "2021-10-09", totalSales: 4, totalUnits: 37 },
        { date: "2021-10-10", totalSales: 51, totalUnits: 4 },
        { date: "2021-10-11", totalSales: 73, totalUnits: 2 },
        { date: "2021-10-12", totalSales: 23, totalUnits: 16 },
        { date: "2021-10-13", totalSales: 15, totalUnits: 18 },
        { date: "2021-10-14", totalSales: 11, totalUnits: 22 },
        { date: "2021-10-15", totalSales: 96, totalUnits: 7 },
        { date: "2021-10-16", totalSales: 76, totalUnits: 11 },
        { date: "2021-10-17", totalSales: 16, totalUnits: 2 },
        { date: "2021-10-18", totalSales: 54, totalUnits: 25 },
        { date: "2021-10-19", totalSales: 81, totalUnits: 31 },
        { date: "2021-10-20", totalSales: 74, totalUnits: 5 },
        { date: "2021-10-21", totalSales: 95, totalUnits: 16 },
        { date: "2021-10-22", totalSales: 81, totalUnits: 22 },
        { date: "2021-10-23", totalSales: 1, totalUnits: 36 },
        { date: "2021-10-24", totalSales: 93, totalUnits: 19 },
        { date: "2021-10-25", totalSales: 64, totalUnits: 29 },
        { date: "2021-10-26", totalSales: 4, totalUnits: 4 },
        { date: "2021-10-27", totalSales: 16, totalUnits: 14 },
        { date: "2021-10-28", totalSales: 74, totalUnits: 10 },
        { date: "2021-10-29", totalSales: 50, totalUnits: 20 },
        { date: "2021-10-30", totalSales: 43, totalUnits: 27 },
        { date: "2021-10-31", totalSales: 67, totalUnits: 31 },
        { date: "2021-11-01", totalSales: 75, totalUnits: 40 },
        { date: "2021-11-02", totalSales: 23, totalUnits: 33 },
        { date: "2021-11-03", totalSales: 82, totalUnits: 29 },
        { date: "2021-11-04", totalSales: 12, totalUnits: 40 },
        { date: "2021-11-05", totalSales: 11, totalUnits: 15 },
        { date: "2021-11-06", totalSales: 7, totalUnits: 20 },
        { date: "2021-11-07", totalSales: 75, totalUnits: 32 },
        { date: "2021-11-08", totalSales: 54, totalUnits: 20 },
        { date: "2021-11-09", totalSales: 87, totalUnits: 28 },
        { date: "2021-11-10", totalSales: 4, totalUnits: 28 },
        { date: "2021-11-11", totalSales: 82, totalUnits: 46 },
        { date: "2021-11-12", totalSales: 19, totalUnits: 40 },
        { date: "2021-11-13", totalSales: 91, totalUnits: 48 },
        { date: "2021-11-14", totalSales: 71, totalUnits: 14 },
        { date: "2021-11-15", totalSales: 43, totalUnits: 18 },
        { date: "2021-11-16", totalSales: 89, totalUnits: 31 },
        { date: "2021-11-17", totalSales: 39, totalUnits: 18 },
      ],
    },
    {
      _id: "6371259df03239b7f7000083",
      productId: "63701d24f03239c72c000190",
      yearlySalesTotal: 4356,
      yearlyTotalSoldUnits: 4305,
      monthlyData: [
        { month: "january", totalSales: 606, totalUnits: 471 },
        { month: "february", totalSales: 688, totalUnits: 15 },
        { month: "march", totalSales: 563, totalUnits: 293 },
        { month: "april", totalSales: 39, totalUnits: 300 },
        { month: "may", totalSales: 573, totalUnits: 219 },
        { month: "june", totalSales: 226, totalUnits: 206 },
        { month: "july", totalSales: 638, totalUnits: 223 },
        { month: "august", totalSales: 884, totalUnits: 401 },
        { month: "september", totalSales: 118, totalUnits: 151 },
        { month: "october", totalSales: 307, totalUnits: 265 },
        { month: "november", totalSales: 997, totalUnits: 351 },
        { month: "december", totalSales: 234, totalUnits: 462 },
      ],
      dailyData: [
        { date: "2021-01-02", totalSales: 3, totalUnits: 26 },
        { date: "2021-01-03", totalSales: 56, totalUnits: 35 },
        { date: "2021-01-04", totalSales: 77, totalUnits: 43 },
        { date: "2021-01-05", totalSales: 82, totalUnits: 47 },
        { date: "2021-01-06", totalSales: 5, totalUnits: 41 },
        { date: "2021-01-07", totalSales: 89, totalUnits: 39 },
        { date: "2021-01-08", totalSales: 48, totalUnits: 33 },
        { date: "2021-01-09", totalSales: 67, totalUnits: 38 },
        { date: "2021-01-10", totalSales: 56, totalUnits: 17 },
        { date: "2021-01-11", totalSales: 91, totalUnits: 8 },
        { date: "2021-01-12", totalSales: 47, totalUnits: 39 },
        { date: "2021-01-13", totalSales: 76, totalUnits: 2 },
        { date: "2021-01-14", totalSales: 91, totalUnits: 9 },
        { date: "2021-01-15", totalSales: 38, totalUnits: 29 },
        { date: "2021-01-16", totalSales: 76, totalUnits: 8 },
        { date: "2021-01-17", totalSales: 37, totalUnits: 18 },
        { date: "2021-01-18", totalSales: 74, totalUnits: 48 },
        { date: "2021-01-19", totalSales: 41, totalUnits: 37 },
        { date: "2021-01-20", totalSales: 1, totalUnits: 10 },
        { date: "2021-01-21", totalSales: 33, totalUnits: 29 },
        { date: "2021-01-22", totalSales: 69, totalUnits: 47 },
        { date: "2021-01-23", totalSales: 31, totalUnits: 15 },
        { date: "2021-01-24", totalSales: 68, totalUnits: 38 },
        { date: "2021-01-25", totalSales: 7, totalUnits: 8 },
        { date: "2021-01-26", totalSales: 42, totalUnits: 47 },
        { date: "2021-01-27", totalSales: 43, totalUnits: 9 },
        { date: "2021-01-28", totalSales: 86, totalUnits: 8 },
        { date: "2021-01-29", totalSales: 37, totalUnits: 5 },
        { date: "2021-01-30", totalSales: 80, totalUnits: 27 },
        { date: "2021-01-31", totalSales: 44, totalUnits: 43 },
        { date: "2021-02-01", totalSales: 4, totalUnits: 19 },
        { date: "2021-02-02", totalSales: 87, totalUnits: 47 },
        { date: "2021-02-03", totalSales: 51, totalUnits: 16 },
        { date: "2021-02-04", totalSales: 35, totalUnits: 30 },
        { date: "2021-02-05", totalSales: 2, totalUnits: 48 },
        { date: "2021-02-06", totalSales: 2, totalUnits: 6 },
        { date: "2021-02-07", totalSales: 90, totalUnits: 31 },
        { date: "2021-02-08", totalSales: 84, totalUnits: 48 },
        { date: "2021-02-09", totalSales: 65, totalUnits: 44 },
        { date: "2021-02-10", totalSales: 11, totalUnits: 50 },
        { date: "2021-02-11", totalSales: 2, totalUnits: 28 },
        { date: "2021-02-12", totalSales: 97, totalUnits: 3 },
        { date: "2021-02-13", totalSales: 37, totalUnits: 3 },
        { date: "2021-02-14", totalSales: 60, totalUnits: 50 },
        { date: "2021-02-15", totalSales: 70, totalUnits: 28 },
        { date: "2021-02-16", totalSales: 87, totalUnits: 6 },
        { date: "2021-02-17", totalSales: 41, totalUnits: 34 },
        { date: "2021-02-18", totalSales: 35, totalUnits: 49 },
        { date: "2021-02-19", totalSales: 77, totalUnits: 15 },
        { date: "2021-02-20", totalSales: 56, totalUnits: 44 },
        { date: "2021-02-21", totalSales: 37, totalUnits: 44 },
        { date: "2021-02-22", totalSales: 7, totalUnits: 13 },
        { date: "2021-02-23", totalSales: 69, totalUnits: 34 },
        { date: "2021-02-24", totalSales: 14, totalUnits: 13 },
        { date: "2021-02-25", totalSales: 18, totalUnits: 23 },
        { date: "2021-02-26", totalSales: 65, totalUnits: 27 },
        { date: "2021-02-27", totalSales: 67, totalUnits: 50 },
        { date: "2021-02-28", totalSales: 9, totalUnits: 21 },
        { date: "2021-03-01", totalSales: 7, totalUnits: 48 },
        { date: "2021-03-02", totalSales: 51, totalUnits: 23 },
        { date: "2021-03-03", totalSales: 86, totalUnits: 20 },
        { date: "2021-03-04", totalSales: 67, totalUnits: 23 },
        { date: "2021-03-05", totalSales: 70, totalUnits: 23 },
        { date: "2021-03-06", totalSales: 45, totalUnits: 14 },
        { date: "2021-03-07", totalSales: 5, totalUnits: 10 },
        { date: "2021-03-08", totalSales: 66, totalUnits: 7 },
        { date: "2021-03-09", totalSales: 31, totalUnits: 1 },
        { date: "2021-03-10", totalSales: 4, totalUnits: 45 },
        { date: "2021-03-11", totalSales: 39, totalUnits: 38 },
        { date: "2021-03-12", totalSales: 51, totalUnits: 23 },
        { date: "2021-03-13", totalSales: 25, totalUnits: 4 },
        { date: "2021-03-14", totalSales: 92, totalUnits: 48 },
        { date: "2021-03-15", totalSales: 25, totalUnits: 9 },
        { date: "2021-03-16", totalSales: 57, totalUnits: 8 },
        { date: "2021-03-17", totalSales: 53, totalUnits: 25 },
        { date: "2021-03-18", totalSales: 45, totalUnits: 31 },
        { date: "2021-03-19", totalSales: 52, totalUnits: 17 },
        { date: "2021-03-20", totalSales: 90, totalUnits: 13 },
        { date: "2021-03-21", totalSales: 87, totalUnits: 17 },
        { date: "2021-03-22", totalSales: 2, totalUnits: 38 },
        { date: "2021-03-23", totalSales: 66, totalUnits: 31 },
        { date: "2021-03-24", totalSales: 19, totalUnits: 34 },
        { date: "2021-03-25", totalSales: 58, totalUnits: 46 },
        { date: "2021-03-26", totalSales: 46, totalUnits: 38 },
        { date: "2021-03-27", totalSales: 61, totalUnits: 42 },
        { date: "2021-03-28", totalSales: 85, totalUnits: 31 },
        { date: "2021-03-29", totalSales: 52, totalUnits: 16 },
        { date: "2021-03-30", totalSales: 77, totalUnits: 47 },
        { date: "2021-03-31", totalSales: 54, totalUnits: 29 },
        { date: "2021-04-01", totalSales: 4, totalUnits: 44 },
        { date: "2021-04-02", totalSales: 79, totalUnits: 4 },
        { date: "2021-04-03", totalSales: 2, totalUnits: 10 },
        { date: "2021-04-04", totalSales: 61, totalUnits: 3 },
        { date: "2021-04-05", totalSales: 48, totalUnits: 32 },
        { date: "2021-04-06", totalSales: 32, totalUnits: 27 },
        { date: "2021-04-07", totalSales: 75, totalUnits: 6 },
        { date: "2021-04-08", totalSales: 55, totalUnits: 1 },
        { date: "2021-04-09", totalSales: 36, totalUnits: 41 },
        { date: "2021-04-10", totalSales: 49, totalUnits: 47 },
        { date: "2021-04-11", totalSales: 70, totalUnits: 22 },
        { date: "2021-04-12", totalSales: 87, totalUnits: 38 },
        { date: "2021-04-13", totalSales: 24, totalUnits: 28 },
        { date: "2021-04-14", totalSales: 77, totalUnits: 28 },
        { date: "2021-04-15", totalSales: 68, totalUnits: 26 },
        { date: "2021-04-16", totalSales: 89, totalUnits: 19 },
        { date: "2021-04-17", totalSales: 24, totalUnits: 6 },
        { date: "2021-04-18", totalSales: 92, totalUnits: 29 },
        { date: "2021-04-19", totalSales: 4, totalUnits: 42 },
        { date: "2021-04-20", totalSales: 92, totalUnits: 31 },
        { date: "2021-04-21", totalSales: 51, totalUnits: 26 },
        { date: "2021-04-22", totalSales: 38, totalUnits: 32 },
        { date: "2021-04-23", totalSales: 57, totalUnits: 9 },
        { date: "2021-04-24", totalSales: 22, totalUnits: 13 },
        { date: "2021-04-25", totalSales: 37, totalUnits: 19 },
        { date: "2021-04-26", totalSales: 48, totalUnits: 15 },
        { date: "2021-04-27", totalSales: 30, totalUnits: 3 },
        { date: "2021-04-28", totalSales: 96, totalUnits: 46 },
        { date: "2021-04-29", totalSales: 57, totalUnits: 50 },
        { date: "2021-04-30", totalSales: 68, totalUnits: 29 },
        { date: "2021-05-01", totalSales: 26, totalUnits: 8 },
        { date: "2021-05-02", totalSales: 43, totalUnits: 16 },
        { date: "2021-05-03", totalSales: 84, totalUnits: 13 },
        { date: "2021-05-04", totalSales: 16, totalUnits: 12 },
        { date: "2021-05-05", totalSales: 95, totalUnits: 9 },
        { date: "2021-05-06", totalSales: 16, totalUnits: 6 },
        { date: "2021-05-07", totalSales: 26, totalUnits: 18 },
        { date: "2021-05-08", totalSales: 46, totalUnits: 45 },
        { date: "2021-05-09", totalSales: 25, totalUnits: 1 },
        { date: "2021-05-10", totalSales: 59, totalUnits: 43 },
        { date: "2021-05-11", totalSales: 26, totalUnits: 38 },
        { date: "2021-05-12", totalSales: 74, totalUnits: 44 },
        { date: "2021-05-13", totalSales: 24, totalUnits: 9 },
        { date: "2021-05-14", totalSales: 3, totalUnits: 3 },
        { date: "2021-05-15", totalSales: 91, totalUnits: 31 },
        { date: "2021-05-16", totalSales: 65, totalUnits: 42 },
        { date: "2021-05-17", totalSales: 99, totalUnits: 44 },
        { date: "2021-05-18", totalSales: 25, totalUnits: 19 },
        { date: "2021-05-19", totalSales: 97, totalUnits: 40 },
        { date: "2021-05-20", totalSales: 75, totalUnits: 20 },
        { date: "2021-05-21", totalSales: 27, totalUnits: 11 },
        { date: "2021-05-22", totalSales: 66, totalUnits: 36 },
        { date: "2021-05-23", totalSales: 78, totalUnits: 29 },
        { date: "2021-05-24", totalSales: 86, totalUnits: 4 },
        { date: "2021-05-25", totalSales: 60, totalUnits: 39 },
        { date: "2021-05-26", totalSales: 51, totalUnits: 36 },
        { date: "2021-05-27", totalSales: 53, totalUnits: 35 },
        { date: "2021-05-28", totalSales: 59, totalUnits: 25 },
        { date: "2021-05-29", totalSales: 3, totalUnits: 24 },
        { date: "2021-05-30", totalSales: 10, totalUnits: 20 },
        { date: "2021-05-31", totalSales: 32, totalUnits: 9 },
        { date: "2021-06-01", totalSales: 63, totalUnits: 38 },
        { date: "2021-06-02", totalSales: 45, totalUnits: 16 },
        { date: "2021-06-03", totalSales: 24, totalUnits: 47 },
        { date: "2021-06-04", totalSales: 31, totalUnits: 31 },
        { date: "2021-06-05", totalSales: 88, totalUnits: 1 },
        { date: "2021-06-06", totalSales: 20, totalUnits: 6 },
        { date: "2021-06-07", totalSales: 59, totalUnits: 38 },
        { date: "2021-06-08", totalSales: 41, totalUnits: 8 },
        { date: "2021-06-09", totalSales: 34, totalUnits: 28 },
        { date: "2021-06-10", totalSales: 79, totalUnits: 25 },
        { date: "2021-06-11", totalSales: 81, totalUnits: 35 },
        { date: "2021-06-12", totalSales: 64, totalUnits: 13 },
        { date: "2021-06-13", totalSales: 34, totalUnits: 49 },
        { date: "2021-06-14", totalSales: 71, totalUnits: 38 },
        { date: "2021-06-15", totalSales: 89, totalUnits: 44 },
        { date: "2021-06-16", totalSales: 33, totalUnits: 49 },
        { date: "2021-06-17", totalSales: 87, totalUnits: 5 },
        { date: "2021-06-18", totalSales: 94, totalUnits: 2 },
        { date: "2021-06-19", totalSales: 21, totalUnits: 3 },
        { date: "2021-06-20", totalSales: 15, totalUnits: 21 },
        { date: "2021-06-21", totalSales: 54, totalUnits: 37 },
        { date: "2021-06-22", totalSales: 48, totalUnits: 42 },
        { date: "2021-06-23", totalSales: 3, totalUnits: 37 },
        { date: "2021-06-24", totalSales: 6, totalUnits: 46 },
        { date: "2021-06-25", totalSales: 83, totalUnits: 39 },
        { date: "2021-06-26", totalSales: 76, totalUnits: 37 },
        { date: "2021-06-27", totalSales: 79, totalUnits: 2 },
        { date: "2021-06-28", totalSales: 67, totalUnits: 28 },
        { date: "2021-06-29", totalSales: 54, totalUnits: 21 },
        { date: "2021-06-30", totalSales: 14, totalUnits: 20 },
        { date: "2021-07-01", totalSales: 41, totalUnits: 16 },
        { date: "2021-07-02", totalSales: 27, totalUnits: 3 },
        { date: "2021-07-03", totalSales: 1, totalUnits: 20 },
        { date: "2021-07-04", totalSales: 38, totalUnits: 45 },
        { date: "2021-07-05", totalSales: 79, totalUnits: 28 },
        { date: "2021-07-06", totalSales: 56, totalUnits: 17 },
        { date: "2021-07-07", totalSales: 29, totalUnits: 17 },
        { date: "2021-07-08", totalSales: 65, totalUnits: 3 },
        { date: "2021-07-09", totalSales: 99, totalUnits: 21 },
        { date: "2021-07-10", totalSales: 11, totalUnits: 33 },
        { date: "2021-07-11", totalSales: 24, totalUnits: 25 },
        { date: "2021-07-12", totalSales: 83, totalUnits: 1 },
        { date: "2021-07-13", totalSales: 80, totalUnits: 21 },
        { date: "2021-07-14", totalSales: 9, totalUnits: 33 },
        { date: "2021-07-15", totalSales: 84, totalUnits: 27 },
        { date: "2021-07-16", totalSales: 34, totalUnits: 23 },
        { date: "2021-07-17", totalSales: 60, totalUnits: 42 },
        { date: "2021-07-18", totalSales: 96, totalUnits: 8 },
        { date: "2021-07-19", totalSales: 96, totalUnits: 1 },
        { date: "2021-07-20", totalSales: 1, totalUnits: 21 },
        { date: "2021-07-21", totalSales: 56, totalUnits: 36 },
        { date: "2021-07-22", totalSales: 52, totalUnits: 28 },
        { date: "2021-07-23", totalSales: 95, totalUnits: 19 },
        { date: "2021-07-24", totalSales: 89, totalUnits: 14 },
        { date: "2021-07-25", totalSales: 60, totalUnits: 47 },
        { date: "2021-07-26", totalSales: 7, totalUnits: 17 },
        { date: "2021-07-27", totalSales: 56, totalUnits: 2 },
        { date: "2021-07-28", totalSales: 46, totalUnits: 45 },
        { date: "2021-07-29", totalSales: 36, totalUnits: 13 },
        { date: "2021-07-30", totalSales: 41, totalUnits: 38 },
        { date: "2021-07-31", totalSales: 65, totalUnits: 13 },
        { date: "2021-08-01", totalSales: 28, totalUnits: 48 },
        { date: "2021-08-02", totalSales: 60, totalUnits: 42 },
        { date: "2021-08-03", totalSales: 15, totalUnits: 29 },
        { date: "2021-08-04", totalSales: 99, totalUnits: 34 },
        { date: "2021-08-05", totalSales: 19, totalUnits: 11 },
        { date: "2021-08-06", totalSales: 71, totalUnits: 31 },
        { date: "2021-08-07", totalSales: 90, totalUnits: 22 },
        { date: "2021-08-08", totalSales: 99, totalUnits: 37 },
        { date: "2021-08-09", totalSales: 62, totalUnits: 27 },
        { date: "2021-08-10", totalSales: 83, totalUnits: 41 },
        { date: "2021-08-11", totalSales: 27, totalUnits: 11 },
        { date: "2021-08-12", totalSales: 27, totalUnits: 21 },
        { date: "2021-08-13", totalSales: 73, totalUnits: 50 },
        { date: "2021-08-14", totalSales: 14, totalUnits: 50 },
        { date: "2021-08-15", totalSales: 86, totalUnits: 29 },
        { date: "2021-08-16", totalSales: 92, totalUnits: 16 },
        { date: "2021-08-17", totalSales: 75, totalUnits: 25 },
        { date: "2021-08-18", totalSales: 11, totalUnits: 3 },
        { date: "2021-08-19", totalSales: 7, totalUnits: 35 },
        { date: "2021-08-20", totalSales: 42, totalUnits: 38 },
        { date: "2021-08-21", totalSales: 76, totalUnits: 49 },
        { date: "2021-08-22", totalSales: 97, totalUnits: 21 },
        { date: "2021-08-23", totalSales: 73, totalUnits: 6 },
        { date: "2021-08-24", totalSales: 13, totalUnits: 17 },
        { date: "2021-08-25", totalSales: 57, totalUnits: 11 },
        { date: "2021-08-26", totalSales: 98, totalUnits: 48 },
        { date: "2021-08-27", totalSales: 42, totalUnits: 33 },
        { date: "2021-08-28", totalSales: 15, totalUnits: 14 },
        { date: "2021-08-29", totalSales: 9, totalUnits: 7 },
        { date: "2021-08-30", totalSales: 54, totalUnits: 44 },
        { date: "2021-08-31", totalSales: 4, totalUnits: 24 },
        { date: "2021-09-01", totalSales: 13, totalUnits: 32 },
        { date: "2021-09-02", totalSales: 58, totalUnits: 28 },
        { date: "2021-09-03", totalSales: 66, totalUnits: 26 },
        { date: "2021-09-04", totalSales: 30, totalUnits: 42 },
        { date: "2021-09-05", totalSales: 19, totalUnits: 10 },
        { date: "2021-09-06", totalSales: 64, totalUnits: 16 },
        { date: "2021-09-07", totalSales: 1, totalUnits: 20 },
        { date: "2021-09-08", totalSales: 86, totalUnits: 17 },
        { date: "2021-09-09", totalSales: 93, totalUnits: 50 },
        { date: "2021-09-10", totalSales: 88, totalUnits: 23 },
        { date: "2021-09-11", totalSales: 14, totalUnits: 1 },
        { date: "2021-09-12", totalSales: 36, totalUnits: 4 },
        { date: "2021-09-13", totalSales: 51, totalUnits: 49 },
        { date: "2021-09-14", totalSales: 53, totalUnits: 22 },
        { date: "2021-09-15", totalSales: 86, totalUnits: 16 },
        { date: "2021-09-16", totalSales: 71, totalUnits: 26 },
        { date: "2021-09-17", totalSales: 88, totalUnits: 25 },
        { date: "2021-09-18", totalSales: 24, totalUnits: 44 },
        { date: "2021-09-19", totalSales: 9, totalUnits: 50 },
        { date: "2021-09-20", totalSales: 5, totalUnits: 8 },
        { date: "2021-09-21", totalSales: 8, totalUnits: 9 },
        { date: "2021-09-22", totalSales: 37, totalUnits: 30 },
        { date: "2021-09-23", totalSales: 74, totalUnits: 18 },
        { date: "2021-09-24", totalSales: 49, totalUnits: 9 },
        { date: "2021-09-25", totalSales: 96, totalUnits: 46 },
        { date: "2021-09-26", totalSales: 91, totalUnits: 7 },
        { date: "2021-09-27", totalSales: 100, totalUnits: 23 },
        { date: "2021-09-28", totalSales: 12, totalUnits: 22 },
        { date: "2021-09-29", totalSales: 51, totalUnits: 43 },
        { date: "2021-09-30", totalSales: 22, totalUnits: 11 },
        { date: "2021-10-01", totalSales: 9, totalUnits: 8 },
        { date: "2021-10-02", totalSales: 10, totalUnits: 30 },
        { date: "2021-10-03", totalSales: 33, totalUnits: 21 },
        { date: "2021-10-04", totalSales: 95, totalUnits: 47 },
        { date: "2021-10-05", totalSales: 78, totalUnits: 30 },
        { date: "2021-10-06", totalSales: 86, totalUnits: 42 },
        { date: "2021-10-07", totalSales: 27, totalUnits: 42 },
        { date: "2021-10-08", totalSales: 74, totalUnits: 13 },
        { date: "2021-10-09", totalSales: 23, totalUnits: 46 },
        { date: "2021-10-10", totalSales: 39, totalUnits: 1 },
        { date: "2021-10-11", totalSales: 66, totalUnits: 11 },
        { date: "2021-10-12", totalSales: 66, totalUnits: 26 },
        { date: "2021-10-13", totalSales: 61, totalUnits: 2 },
        { date: "2021-10-14", totalSales: 59, totalUnits: 44 },
        { date: "2021-10-15", totalSales: 31, totalUnits: 43 },
        { date: "2021-10-16", totalSales: 64, totalUnits: 6 },
        { date: "2021-10-17", totalSales: 25, totalUnits: 48 },
        { date: "2021-10-18", totalSales: 93, totalUnits: 7 },
        { date: "2021-10-19", totalSales: 27, totalUnits: 33 },
        { date: "2021-10-20", totalSales: 7, totalUnits: 9 },
        { date: "2021-10-21", totalSales: 99, totalUnits: 48 },
        { date: "2021-10-22", totalSales: 66, totalUnits: 27 },
        { date: "2021-10-23", totalSales: 91, totalUnits: 11 },
        { date: "2021-10-24", totalSales: 65, totalUnits: 25 },
        { date: "2021-10-25", totalSales: 94, totalUnits: 43 },
        { date: "2021-10-26", totalSales: 51, totalUnits: 49 },
        { date: "2021-10-27", totalSales: 24, totalUnits: 2 },
        { date: "2021-10-28", totalSales: 11, totalUnits: 4 },
        { date: "2021-10-29", totalSales: 41, totalUnits: 25 },
        { date: "2021-10-30", totalSales: 30, totalUnits: 1 },
        { date: "2021-10-31", totalSales: 45, totalUnits: 33 },
        { date: "2021-11-01", totalSales: 40, totalUnits: 46 },
        { date: "2021-11-02", totalSales: 48, totalUnits: 33 },
        { date: "2021-11-03", totalSales: 23, totalUnits: 19 },
        { date: "2021-11-04", totalSales: 24, totalUnits: 50 },
        { date: "2021-11-05", totalSales: 90, totalUnits: 46 },
        { date: "2021-11-06", totalSales: 39, totalUnits: 46 },
        { date: "2021-11-07", totalSales: 76, totalUnits: 24 },
        { date: "2021-11-08", totalSales: 5, totalUnits: 17 },
        { date: "2021-11-09", totalSales: 62, totalUnits: 8 },
        { date: "2021-11-10", totalSales: 42, totalUnits: 4 },
        { date: "2021-11-11", totalSales: 12, totalUnits: 40 },
        { date: "2021-11-12", totalSales: 31, totalUnits: 40 },
        { date: "2021-11-13", totalSales: 95, totalUnits: 43 },
        { date: "2021-11-14", totalSales: 39, totalUnits: 12 },
        { date: "2021-11-15", totalSales: 55, totalUnits: 19 },
        { date: "2021-11-16", totalSales: 38, totalUnits: 18 },
        { date: "2021-11-17", totalSales: 7, totalUnits: 33 },
      ],
    },
    {
      _id: "6371259df03239444100035a",
      productId: "63701d24f03239c72c000191",
      yearlySalesTotal: 9976,
      yearlyTotalSoldUnits: 3579,
      monthlyData: [
        { month: "january", totalSales: 298, totalUnits: 394 },
        { month: "february", totalSales: 261, totalUnits: 435 },
        { month: "march", totalSales: 756, totalUnits: 209 },
        { month: "april", totalSales: 985, totalUnits: 404 },
        { month: "may", totalSales: 247, totalUnits: 464 },
        { month: "june", totalSales: 853, totalUnits: 134 },
        { month: "july", totalSales: 264, totalUnits: 433 },
        { month: "august", totalSales: 290, totalUnits: 195 },
        { month: "september", totalSales: 186, totalUnits: 401 },
        { month: "october", totalSales: 194, totalUnits: 275 },
        { month: "november", totalSales: 534, totalUnits: 131 },
        { month: "december", totalSales: 680, totalUnits: 234 },
      ],
      dailyData: [
        { date: "2021-01-02", totalSales: 4, totalUnits: 18 },
        { date: "2021-01-03", totalSales: 4, totalUnits: 48 },
        { date: "2021-01-04", totalSales: 76, totalUnits: 25 },
        { date: "2021-01-05", totalSales: 66, totalUnits: 9 },
        { date: "2021-01-06", totalSales: 48, totalUnits: 33 },
        { date: "2021-01-07", totalSales: 16, totalUnits: 46 },
        { date: "2021-01-08", totalSales: 26, totalUnits: 35 },
        { date: "2021-01-09", totalSales: 79, totalUnits: 18 },
        { date: "2021-01-10", totalSales: 93, totalUnits: 22 },
        { date: "2021-01-11", totalSales: 36, totalUnits: 23 },
        { date: "2021-01-12", totalSales: 34, totalUnits: 28 },
        { date: "2021-01-13", totalSales: 9, totalUnits: 46 },
        { date: "2021-01-14", totalSales: 35, totalUnits: 5 },
        { date: "2021-01-15", totalSales: 78, totalUnits: 33 },
        { date: "2021-01-16", totalSales: 87, totalUnits: 31 },
        { date: "2021-01-17", totalSales: 70, totalUnits: 40 },
        { date: "2021-01-18", totalSales: 52, totalUnits: 8 },
        { date: "2021-01-19", totalSales: 76, totalUnits: 6 },
        { date: "2021-01-20", totalSales: 21, totalUnits: 42 },
        { date: "2021-01-21", totalSales: 20, totalUnits: 19 },
        { date: "2021-01-22", totalSales: 96, totalUnits: 23 },
        { date: "2021-01-23", totalSales: 58, totalUnits: 3 },
        { date: "2021-01-24", totalSales: 43, totalUnits: 22 },
        { date: "2021-01-25", totalSales: 25, totalUnits: 6 },
        { date: "2021-01-26", totalSales: 56, totalUnits: 11 },
        { date: "2021-01-27", totalSales: 61, totalUnits: 42 },
        { date: "2021-01-28", totalSales: 34, totalUnits: 18 },
        { date: "2021-01-29", totalSales: 95, totalUnits: 33 },
        { date: "2021-01-30", totalSales: 44, totalUnits: 11 },
        { date: "2021-01-31", totalSales: 45, totalUnits: 30 },
        { date: "2021-02-01", totalSales: 89, totalUnits: 34 },
        { date: "2021-02-02", totalSales: 61, totalUnits: 46 },
        { date: "2021-02-03", totalSales: 79, totalUnits: 28 },
        { date: "2021-02-04", totalSales: 93, totalUnits: 50 },
        { date: "2021-02-05", totalSales: 64, totalUnits: 10 },
        { date: "2021-02-06", totalSales: 75, totalUnits: 3 },
        { date: "2021-02-07", totalSales: 55, totalUnits: 8 },
        { date: "2021-02-08", totalSales: 73, totalUnits: 48 },
        { date: "2021-02-09", totalSales: 27, totalUnits: 18 },
        { date: "2021-02-10", totalSales: 47, totalUnits: 40 },
        { date: "2021-02-11", totalSales: 57, totalUnits: 38 },
        { date: "2021-02-12", totalSales: 27, totalUnits: 1 },
        { date: "2021-02-13", totalSales: 45, totalUnits: 2 },
        { date: "2021-02-14", totalSales: 71, totalUnits: 4 },
        { date: "2021-02-15", totalSales: 38, totalUnits: 42 },
        { date: "2021-02-16", totalSales: 58, totalUnits: 1 },
        { date: "2021-02-17", totalSales: 60, totalUnits: 19 },
        { date: "2021-02-18", totalSales: 32, totalUnits: 4 },
        { date: "2021-02-19", totalSales: 20, totalUnits: 38 },
        { date: "2021-02-20", totalSales: 55, totalUnits: 23 },
        { date: "2021-02-21", totalSales: 81, totalUnits: 3 },
        { date: "2021-02-22", totalSales: 76, totalUnits: 7 },
        { date: "2021-02-23", totalSales: 45, totalUnits: 30 },
        { date: "2021-02-24", totalSales: 19, totalUnits: 47 },
        { date: "2021-02-25", totalSales: 24, totalUnits: 44 },
        { date: "2021-02-26", totalSales: 41, totalUnits: 12 },
        { date: "2021-02-27", totalSales: 92, totalUnits: 7 },
        { date: "2021-02-28", totalSales: 30, totalUnits: 38 },
        { date: "2021-03-01", totalSales: 31, totalUnits: 33 },
        { date: "2021-03-02", totalSales: 26, totalUnits: 34 },
        { date: "2021-03-03", totalSales: 12, totalUnits: 20 },
        { date: "2021-03-04", totalSales: 37, totalUnits: 40 },
        { date: "2021-03-05", totalSales: 35, totalUnits: 7 },
        { date: "2021-03-06", totalSales: 1, totalUnits: 11 },
        { date: "2021-03-07", totalSales: 89, totalUnits: 25 },
        { date: "2021-03-08", totalSales: 84, totalUnits: 33 },
        { date: "2021-03-09", totalSales: 43, totalUnits: 32 },
        { date: "2021-03-10", totalSales: 32, totalUnits: 41 },
        { date: "2021-03-11", totalSales: 72, totalUnits: 40 },
        { date: "2021-03-12", totalSales: 1, totalUnits: 22 },
        { date: "2021-03-13", totalSales: 51, totalUnits: 24 },
        { date: "2021-03-14", totalSales: 36, totalUnits: 17 },
        { date: "2021-03-15", totalSales: 37, totalUnits: 17 },
        { date: "2021-03-16", totalSales: 83, totalUnits: 46 },
        { date: "2021-03-17", totalSales: 87, totalUnits: 48 },
        { date: "2021-03-18", totalSales: 16, totalUnits: 19 },
        { date: "2021-03-19", totalSales: 88, totalUnits: 36 },
        { date: "2021-03-20", totalSales: 74, totalUnits: 49 },
        { date: "2021-03-21", totalSales: 53, totalUnits: 13 },
        { date: "2021-03-22", totalSales: 64, totalUnits: 45 },
        { date: "2021-03-23", totalSales: 70, totalUnits: 43 },
        { date: "2021-03-24", totalSales: 55, totalUnits: 4 },
        { date: "2021-03-25", totalSales: 2, totalUnits: 15 },
        { date: "2021-03-26", totalSales: 57, totalUnits: 6 },
        { date: "2021-03-27", totalSales: 77, totalUnits: 44 },
        { date: "2021-03-28", totalSales: 43, totalUnits: 47 },
        { date: "2021-03-29", totalSales: 78, totalUnits: 47 },
        { date: "2021-03-30", totalSales: 22, totalUnits: 13 },
        { date: "2021-03-31", totalSales: 6, totalUnits: 21 },
        { date: "2021-04-01", totalSales: 68, totalUnits: 4 },
        { date: "2021-04-02", totalSales: 30, totalUnits: 40 },
        { date: "2021-04-03", totalSales: 100, totalUnits: 8 },
        { date: "2021-04-04", totalSales: 68, totalUnits: 1 },
        { date: "2021-04-05", totalSales: 16, totalUnits: 25 },
        { date: "2021-04-06", totalSales: 6, totalUnits: 37 },
        { date: "2021-04-07", totalSales: 98, totalUnits: 25 },
        { date: "2021-04-08", totalSales: 56, totalUnits: 11 },
        { date: "2021-04-09", totalSales: 26, totalUnits: 48 },
        { date: "2021-04-10", totalSales: 18, totalUnits: 9 },
        { date: "2021-04-11", totalSales: 9, totalUnits: 15 },
        { date: "2021-04-12", totalSales: 48, totalUnits: 9 },
        { date: "2021-04-13", totalSales: 80, totalUnits: 49 },
        { date: "2021-04-14", totalSales: 17, totalUnits: 19 },
        { date: "2021-04-15", totalSales: 19, totalUnits: 6 },
        { date: "2021-04-16", totalSales: 76, totalUnits: 50 },
        { date: "2021-04-17", totalSales: 29, totalUnits: 23 },
        { date: "2021-04-18", totalSales: 42, totalUnits: 8 },
        { date: "2021-04-19", totalSales: 12, totalUnits: 24 },
        { date: "2021-04-20", totalSales: 42, totalUnits: 40 },
        { date: "2021-04-21", totalSales: 19, totalUnits: 9 },
        { date: "2021-04-22", totalSales: 90, totalUnits: 5 },
        { date: "2021-04-23", totalSales: 68, totalUnits: 41 },
        { date: "2021-04-24", totalSales: 54, totalUnits: 24 },
        { date: "2021-04-25", totalSales: 97, totalUnits: 32 },
        { date: "2021-04-26", totalSales: 100, totalUnits: 42 },
        { date: "2021-04-27", totalSales: 66, totalUnits: 44 },
        { date: "2021-04-28", totalSales: 45, totalUnits: 1 },
        { date: "2021-04-29", totalSales: 29, totalUnits: 20 },
        { date: "2021-04-30", totalSales: 55, totalUnits: 13 },
        { date: "2021-05-01", totalSales: 66, totalUnits: 24 },
        { date: "2021-05-02", totalSales: 87, totalUnits: 35 },
        { date: "2021-05-03", totalSales: 3, totalUnits: 6 },
        { date: "2021-05-04", totalSales: 6, totalUnits: 17 },
        { date: "2021-05-05", totalSales: 81, totalUnits: 12 },
        { date: "2021-05-06", totalSales: 21, totalUnits: 50 },
        { date: "2021-05-07", totalSales: 9, totalUnits: 43 },
        { date: "2021-05-08", totalSales: 98, totalUnits: 3 },
        { date: "2021-05-09", totalSales: 64, totalUnits: 22 },
        { date: "2021-05-10", totalSales: 85, totalUnits: 18 },
        { date: "2021-05-11", totalSales: 16, totalUnits: 13 },
        { date: "2021-05-12", totalSales: 49, totalUnits: 44 },
        { date: "2021-05-13", totalSales: 81, totalUnits: 42 },
        { date: "2021-05-14", totalSales: 33, totalUnits: 3 },
        { date: "2021-05-15", totalSales: 16, totalUnits: 33 },
        { date: "2021-05-16", totalSales: 17, totalUnits: 25 },
        { date: "2021-05-17", totalSales: 40, totalUnits: 18 },
        { date: "2021-05-18", totalSales: 98, totalUnits: 33 },
        { date: "2021-05-19", totalSales: 74, totalUnits: 27 },
        { date: "2021-05-20", totalSales: 19, totalUnits: 14 },
        { date: "2021-05-21", totalSales: 41, totalUnits: 20 },
        { date: "2021-05-22", totalSales: 30, totalUnits: 43 },
        { date: "2021-05-23", totalSales: 98, totalUnits: 41 },
        { date: "2021-05-24", totalSales: 88, totalUnits: 37 },
        { date: "2021-05-25", totalSales: 89, totalUnits: 19 },
        { date: "2021-05-26", totalSales: 39, totalUnits: 4 },
        { date: "2021-05-27", totalSales: 42, totalUnits: 2 },
        { date: "2021-05-28", totalSales: 97, totalUnits: 31 },
        { date: "2021-05-29", totalSales: 6, totalUnits: 27 },
        { date: "2021-05-30", totalSales: 14, totalUnits: 48 },
        { date: "2021-05-31", totalSales: 44, totalUnits: 14 },
        { date: "2021-06-01", totalSales: 57, totalUnits: 9 },
        { date: "2021-06-02", totalSales: 65, totalUnits: 37 },
        { date: "2021-06-03", totalSales: 34, totalUnits: 10 },
        { date: "2021-06-04", totalSales: 20, totalUnits: 47 },
        { date: "2021-06-05", totalSales: 54, totalUnits: 14 },
        { date: "2021-06-06", totalSales: 96, totalUnits: 47 },
        { date: "2021-06-07", totalSales: 92, totalUnits: 16 },
        { date: "2021-06-08", totalSales: 30, totalUnits: 49 },
        { date: "2021-06-09", totalSales: 79, totalUnits: 46 },
        { date: "2021-06-10", totalSales: 81, totalUnits: 21 },
        { date: "2021-06-11", totalSales: 100, totalUnits: 11 },
        { date: "2021-06-12", totalSales: 83, totalUnits: 31 },
        { date: "2021-06-13", totalSales: 51, totalUnits: 37 },
        { date: "2021-06-14", totalSales: 21, totalUnits: 32 },
        { date: "2021-06-15", totalSales: 15, totalUnits: 48 },
        { date: "2021-06-16", totalSales: 69, totalUnits: 10 },
        { date: "2021-06-17", totalSales: 81, totalUnits: 2 },
        { date: "2021-06-18", totalSales: 75, totalUnits: 32 },
        { date: "2021-06-19", totalSales: 27, totalUnits: 19 },
        { date: "2021-06-20", totalSales: 37, totalUnits: 22 },
        { date: "2021-06-21", totalSales: 2, totalUnits: 28 },
        { date: "2021-06-22", totalSales: 33, totalUnits: 42 },
        { date: "2021-06-23", totalSales: 53, totalUnits: 35 },
        { date: "2021-06-24", totalSales: 6, totalUnits: 5 },
        { date: "2021-06-25", totalSales: 11, totalUnits: 41 },
        { date: "2021-06-26", totalSales: 34, totalUnits: 8 },
        { date: "2021-06-27", totalSales: 24, totalUnits: 4 },
        { date: "2021-06-28", totalSales: 8, totalUnits: 34 },
        { date: "2021-06-29", totalSales: 84, totalUnits: 9 },
        { date: "2021-06-30", totalSales: 56, totalUnits: 6 },
        { date: "2021-07-01", totalSales: 81, totalUnits: 37 },
        { date: "2021-07-02", totalSales: 19, totalUnits: 46 },
        { date: "2021-07-03", totalSales: 10, totalUnits: 4 },
        { date: "2021-07-04", totalSales: 34, totalUnits: 28 },
        { date: "2021-07-05", totalSales: 89, totalUnits: 22 },
        { date: "2021-07-06", totalSales: 84, totalUnits: 42 },
        { date: "2021-07-07", totalSales: 73, totalUnits: 12 },
        { date: "2021-07-08", totalSales: 48, totalUnits: 16 },
        { date: "2021-07-09", totalSales: 46, totalUnits: 48 },
        { date: "2021-07-10", totalSales: 89, totalUnits: 12 },
        { date: "2021-07-11", totalSales: 44, totalUnits: 27 },
        { date: "2021-07-12", totalSales: 70, totalUnits: 26 },
        { date: "2021-07-13", totalSales: 2, totalUnits: 7 },
        { date: "2021-07-14", totalSales: 12, totalUnits: 5 },
        { date: "2021-07-15", totalSales: 13, totalUnits: 9 },
        { date: "2021-07-16", totalSales: 67, totalUnits: 16 },
        { date: "2021-07-17", totalSales: 95, totalUnits: 26 },
        { date: "2021-07-18", totalSales: 100, totalUnits: 48 },
        { date: "2021-07-19", totalSales: 37, totalUnits: 5 },
        { date: "2021-07-20", totalSales: 38, totalUnits: 32 },
        { date: "2021-07-21", totalSales: 80, totalUnits: 15 },
        { date: "2021-07-22", totalSales: 83, totalUnits: 25 },
        { date: "2021-07-23", totalSales: 89, totalUnits: 18 },
        { date: "2021-07-24", totalSales: 85, totalUnits: 11 },
        { date: "2021-07-25", totalSales: 61, totalUnits: 11 },
        { date: "2021-07-26", totalSales: 5, totalUnits: 5 },
        { date: "2021-07-27", totalSales: 52, totalUnits: 21 },
        { date: "2021-07-28", totalSales: 4, totalUnits: 9 },
        { date: "2021-07-29", totalSales: 38, totalUnits: 6 },
        { date: "2021-07-30", totalSales: 16, totalUnits: 33 },
        { date: "2021-07-31", totalSales: 77, totalUnits: 2 },
        { date: "2021-08-01", totalSales: 3, totalUnits: 47 },
        { date: "2021-08-02", totalSales: 70, totalUnits: 13 },
        { date: "2021-08-03", totalSales: 48, totalUnits: 33 },
        { date: "2021-08-04", totalSales: 92, totalUnits: 22 },
        { date: "2021-08-05", totalSales: 35, totalUnits: 37 },
        { date: "2021-08-06", totalSales: 5, totalUnits: 3 },
        { date: "2021-08-07", totalSales: 3, totalUnits: 24 },
        { date: "2021-08-08", totalSales: 21, totalUnits: 23 },
        { date: "2021-08-09", totalSales: 39, totalUnits: 26 },
        { date: "2021-08-10", totalSales: 26, totalUnits: 35 },
        { date: "2021-08-11", totalSales: 65, totalUnits: 10 },
        { date: "2021-08-12", totalSales: 13, totalUnits: 34 },
        { date: "2021-08-13", totalSales: 53, totalUnits: 37 },
        { date: "2021-08-14", totalSales: 89, totalUnits: 38 },
        { date: "2021-08-15", totalSales: 4, totalUnits: 11 },
        { date: "2021-08-16", totalSales: 4, totalUnits: 10 },
        { date: "2021-08-17", totalSales: 22, totalUnits: 34 },
        { date: "2021-08-18", totalSales: 13, totalUnits: 26 },
        { date: "2021-08-19", totalSales: 98, totalUnits: 29 },
        { date: "2021-08-20", totalSales: 22, totalUnits: 25 },
        { date: "2021-08-21", totalSales: 55, totalUnits: 45 },
        { date: "2021-08-22", totalSales: 25, totalUnits: 19 },
        { date: "2021-08-23", totalSales: 87, totalUnits: 25 },
        { date: "2021-08-24", totalSales: 71, totalUnits: 32 },
        { date: "2021-08-25", totalSales: 18, totalUnits: 30 },
        { date: "2021-08-26", totalSales: 35, totalUnits: 35 },
        { date: "2021-08-27", totalSales: 53, totalUnits: 27 },
        { date: "2021-08-28", totalSales: 37, totalUnits: 18 },
        { date: "2021-08-29", totalSales: 68, totalUnits: 20 },
        { date: "2021-08-30", totalSales: 100, totalUnits: 43 },
        { date: "2021-08-31", totalSales: 63, totalUnits: 24 },
        { date: "2021-09-01", totalSales: 97, totalUnits: 38 },
        { date: "2021-09-02", totalSales: 91, totalUnits: 13 },
        { date: "2021-09-03", totalSales: 63, totalUnits: 38 },
        { date: "2021-09-04", totalSales: 8, totalUnits: 50 },
        { date: "2021-09-05", totalSales: 49, totalUnits: 35 },
        { date: "2021-09-06", totalSales: 76, totalUnits: 12 },
        { date: "2021-09-07", totalSales: 4, totalUnits: 25 },
        { date: "2021-09-08", totalSales: 2, totalUnits: 46 },
        { date: "2021-09-09", totalSales: 58, totalUnits: 48 },
        { date: "2021-09-10", totalSales: 73, totalUnits: 18 },
        { date: "2021-09-11", totalSales: 26, totalUnits: 32 },
        { date: "2021-09-12", totalSales: 58, totalUnits: 49 },
        { date: "2021-09-13", totalSales: 78, totalUnits: 31 },
        { date: "2021-09-14", totalSales: 29, totalUnits: 33 },
        { date: "2021-09-15", totalSales: 67, totalUnits: 11 },
        { date: "2021-09-16", totalSales: 49, totalUnits: 30 },
        { date: "2021-09-17", totalSales: 17, totalUnits: 28 },
        { date: "2021-09-18", totalSales: 1, totalUnits: 22 },
        { date: "2021-09-19", totalSales: 74, totalUnits: 4 },
        { date: "2021-09-20", totalSales: 78, totalUnits: 42 },
        { date: "2021-09-21", totalSales: 61, totalUnits: 24 },
        { date: "2021-09-22", totalSales: 96, totalUnits: 44 },
        { date: "2021-09-23", totalSales: 4, totalUnits: 41 },
        { date: "2021-09-24", totalSales: 12, totalUnits: 49 },
        { date: "2021-09-25", totalSales: 57, totalUnits: 17 },
        { date: "2021-09-26", totalSales: 2, totalUnits: 21 },
        { date: "2021-09-27", totalSales: 75, totalUnits: 30 },
        { date: "2021-09-28", totalSales: 24, totalUnits: 1 },
        { date: "2021-09-29", totalSales: 9, totalUnits: 32 },
        { date: "2021-09-30", totalSales: 67, totalUnits: 2 },
        { date: "2021-10-01", totalSales: 1, totalUnits: 47 },
        { date: "2021-10-02", totalSales: 77, totalUnits: 24 },
        { date: "2021-10-03", totalSales: 20, totalUnits: 23 },
        { date: "2021-10-04", totalSales: 97, totalUnits: 43 },
        { date: "2021-10-05", totalSales: 96, totalUnits: 7 },
        { date: "2021-10-06", totalSales: 69, totalUnits: 8 },
        { date: "2021-10-07", totalSales: 57, totalUnits: 13 },
        { date: "2021-10-08", totalSales: 21, totalUnits: 26 },
        { date: "2021-10-09", totalSales: 48, totalUnits: 33 },
        { date: "2021-10-10", totalSales: 4, totalUnits: 21 },
        { date: "2021-10-11", totalSales: 16, totalUnits: 30 },
        { date: "2021-10-12", totalSales: 90, totalUnits: 31 },
        { date: "2021-10-13", totalSales: 63, totalUnits: 23 },
        { date: "2021-10-14", totalSales: 63, totalUnits: 19 },
        { date: "2021-10-15", totalSales: 19, totalUnits: 35 },
        { date: "2021-10-16", totalSales: 55, totalUnits: 15 },
        { date: "2021-10-17", totalSales: 6, totalUnits: 46 },
        { date: "2021-10-18", totalSales: 6, totalUnits: 25 },
        { date: "2021-10-19", totalSales: 87, totalUnits: 21 },
        { date: "2021-10-20", totalSales: 18, totalUnits: 25 },
        { date: "2021-10-21", totalSales: 60, totalUnits: 28 },
        { date: "2021-10-22", totalSales: 8, totalUnits: 44 },
        { date: "2021-10-23", totalSales: 24, totalUnits: 45 },
        { date: "2021-10-24", totalSales: 96, totalUnits: 37 },
        { date: "2021-10-25", totalSales: 30, totalUnits: 38 },
        { date: "2021-10-26", totalSales: 100, totalUnits: 45 },
        { date: "2021-10-27", totalSales: 6, totalUnits: 26 },
        { date: "2021-10-28", totalSales: 26, totalUnits: 39 },
        { date: "2021-10-29", totalSales: 84, totalUnits: 24 },
        { date: "2021-10-30", totalSales: 61, totalUnits: 39 },
        { date: "2021-10-31", totalSales: 82, totalUnits: 13 },
        { date: "2021-11-01", totalSales: 27, totalUnits: 8 },
        { date: "2021-11-02", totalSales: 4, totalUnits: 6 },
        { date: "2021-11-03", totalSales: 36, totalUnits: 19 },
        { date: "2021-11-04", totalSales: 70, totalUnits: 41 },
        { date: "2021-11-05", totalSales: 4, totalUnits: 10 },
        { date: "2021-11-06", totalSales: 14, totalUnits: 44 },
        { date: "2021-11-07", totalSales: 62, totalUnits: 37 },
        { date: "2021-11-08", totalSales: 82, totalUnits: 2 },
        { date: "2021-11-09", totalSales: 41, totalUnits: 42 },
        { date: "2021-11-10", totalSales: 48, totalUnits: 20 },
        { date: "2021-11-11", totalSales: 43, totalUnits: 37 },
        { date: "2021-11-12", totalSales: 18, totalUnits: 32 },
        { date: "2021-11-13", totalSales: 51, totalUnits: 35 },
        { date: "2021-11-14", totalSales: 79, totalUnits: 28 },
        { date: "2021-11-15", totalSales: 80, totalUnits: 27 },
        { date: "2021-11-16", totalSales: 2, totalUnits: 29 },
        { date: "2021-11-17", totalSales: 68, totalUnits: 5 },
      ],
    },
    {
      _id: "6371259df03239d81e000083",
      productId: "63701d24f03239867500012a",
      yearlySalesTotal: 3602,
      yearlyTotalSoldUnits: 1491,
      monthlyData: [
        { month: "january", totalSales: 405, totalUnits: 384 },
        { month: "february", totalSales: 740, totalUnits: 210 },
        { month: "march", totalSales: 665, totalUnits: 206 },
        { month: "april", totalSales: 15, totalUnits: 423 },
        { month: "may", totalSales: 83, totalUnits: 198 },
        { month: "june", totalSales: 257, totalUnits: 337 },
        { month: "july", totalSales: 957, totalUnits: 118 },
        { month: "august", totalSales: 225, totalUnits: 6 },
        { month: "september", totalSales: 528, totalUnits: 437 },
        { month: "october", totalSales: 915, totalUnits: 429 },
        { month: "november", totalSales: 458, totalUnits: 346 },
        { month: "december", totalSales: 42, totalUnits: 227 },
      ],
      dailyData: [
        { date: "2021-01-02", totalSales: 3, totalUnits: 42 },
        { date: "2021-01-03", totalSales: 30, totalUnits: 39 },
        { date: "2021-01-04", totalSales: 95, totalUnits: 35 },
        { date: "2021-01-05", totalSales: 3, totalUnits: 15 },
        { date: "2021-01-06", totalSales: 88, totalUnits: 44 },
        { date: "2021-01-07", totalSales: 80, totalUnits: 8 },
        { date: "2021-01-08", totalSales: 67, totalUnits: 3 },
        { date: "2021-01-09", totalSales: 70, totalUnits: 24 },
        { date: "2021-01-10", totalSales: 40, totalUnits: 35 },
        { date: "2021-01-11", totalSales: 50, totalUnits: 19 },
        { date: "2021-01-12", totalSales: 77, totalUnits: 48 },
        { date: "2021-01-13", totalSales: 27, totalUnits: 29 },
        { date: "2021-01-14", totalSales: 35, totalUnits: 44 },
        { date: "2021-01-15", totalSales: 84, totalUnits: 20 },
        { date: "2021-01-16", totalSales: 48, totalUnits: 40 },
        { date: "2021-01-17", totalSales: 41, totalUnits: 25 },
        { date: "2021-01-18", totalSales: 14, totalUnits: 11 },
        { date: "2021-01-19", totalSales: 74, totalUnits: 33 },
        { date: "2021-01-20", totalSales: 99, totalUnits: 27 },
        { date: "2021-01-21", totalSales: 19, totalUnits: 43 },
        { date: "2021-01-22", totalSales: 43, totalUnits: 14 },
        { date: "2021-01-23", totalSales: 42, totalUnits: 18 },
        { date: "2021-01-24", totalSales: 60, totalUnits: 18 },
        { date: "2021-01-25", totalSales: 85, totalUnits: 47 },
        { date: "2021-01-26", totalSales: 51, totalUnits: 48 },
        { date: "2021-01-27", totalSales: 54, totalUnits: 36 },
        { date: "2021-01-28", totalSales: 3, totalUnits: 32 },
        { date: "2021-01-29", totalSales: 71, totalUnits: 6 },
        { date: "2021-01-30", totalSales: 6, totalUnits: 1 },
        { date: "2021-01-31", totalSales: 8, totalUnits: 23 },
        { date: "2021-02-01", totalSales: 61, totalUnits: 35 },
        { date: "2021-02-02", totalSales: 24, totalUnits: 30 },
        { date: "2021-02-03", totalSales: 44, totalUnits: 28 },
        { date: "2021-02-04", totalSales: 75, totalUnits: 44 },
        { date: "2021-02-05", totalSales: 88, totalUnits: 29 },
        { date: "2021-02-06", totalSales: 73, totalUnits: 48 },
        { date: "2021-02-07", totalSales: 5, totalUnits: 18 },
        { date: "2021-02-08", totalSales: 27, totalUnits: 20 },
        { date: "2021-02-09", totalSales: 97, totalUnits: 2 },
        { date: "2021-02-10", totalSales: 35, totalUnits: 12 },
        { date: "2021-02-11", totalSales: 23, totalUnits: 40 },
        { date: "2021-02-12", totalSales: 56, totalUnits: 47 },
        { date: "2021-02-13", totalSales: 27, totalUnits: 46 },
        { date: "2021-02-14", totalSales: 96, totalUnits: 20 },
        { date: "2021-02-15", totalSales: 60, totalUnits: 15 },
        { date: "2021-02-16", totalSales: 65, totalUnits: 30 },
        { date: "2021-02-17", totalSales: 83, totalUnits: 50 },
        { date: "2021-02-18", totalSales: 78, totalUnits: 34 },
        { date: "2021-02-19", totalSales: 59, totalUnits: 39 },
        { date: "2021-02-20", totalSales: 29, totalUnits: 30 },
        { date: "2021-02-21", totalSales: 80, totalUnits: 44 },
        { date: "2021-02-22", totalSales: 2, totalUnits: 42 },
        { date: "2021-02-23", totalSales: 70, totalUnits: 6 },
        { date: "2021-02-24", totalSales: 58, totalUnits: 1 },
        { date: "2021-02-25", totalSales: 96, totalUnits: 29 },
        { date: "2021-02-26", totalSales: 77, totalUnits: 37 },
        { date: "2021-02-27", totalSales: 61, totalUnits: 25 },
        { date: "2021-02-28", totalSales: 53, totalUnits: 49 },
        { date: "2021-03-01", totalSales: 87, totalUnits: 22 },
        { date: "2021-03-02", totalSales: 29, totalUnits: 1 },
        { date: "2021-03-03", totalSales: 19, totalUnits: 29 },
        { date: "2021-03-04", totalSales: 44, totalUnits: 43 },
        { date: "2021-03-05", totalSales: 45, totalUnits: 46 },
        { date: "2021-03-06", totalSales: 52, totalUnits: 12 },
        { date: "2021-03-07", totalSales: 40, totalUnits: 41 },
        { date: "2021-03-08", totalSales: 73, totalUnits: 23 },
        { date: "2021-03-09", totalSales: 23, totalUnits: 29 },
        { date: "2021-03-10", totalSales: 94, totalUnits: 25 },
        { date: "2021-03-11", totalSales: 37, totalUnits: 28 },
        { date: "2021-03-12", totalSales: 61, totalUnits: 15 },
        { date: "2021-03-13", totalSales: 57, totalUnits: 5 },
        { date: "2021-03-14", totalSales: 13, totalUnits: 14 },
        { date: "2021-03-15", totalSales: 56, totalUnits: 14 },
        { date: "2021-03-16", totalSales: 24, totalUnits: 6 },
        { date: "2021-03-17", totalSales: 33, totalUnits: 12 },
        { date: "2021-03-18", totalSales: 80, totalUnits: 44 },
        { date: "2021-03-19", totalSales: 97, totalUnits: 15 },
        { date: "2021-03-20", totalSales: 28, totalUnits: 46 },
        { date: "2021-03-21", totalSales: 78, totalUnits: 11 },
        { date: "2021-03-22", totalSales: 34, totalUnits: 38 },
        { date: "2021-03-23", totalSales: 65, totalUnits: 30 },
        { date: "2021-03-24", totalSales: 17, totalUnits: 35 },
        { date: "2021-03-25", totalSales: 62, totalUnits: 26 },
        { date: "2021-03-26", totalSales: 1, totalUnits: 37 },
        { date: "2021-03-27", totalSales: 88, totalUnits: 4 },
        { date: "2021-03-28", totalSales: 90, totalUnits: 19 },
        { date: "2021-03-29", totalSales: 99, totalUnits: 17 },
        { date: "2021-03-30", totalSales: 11, totalUnits: 37 },
        { date: "2021-03-31", totalSales: 37, totalUnits: 20 },
        { date: "2021-04-01", totalSales: 42, totalUnits: 9 },
        { date: "2021-04-02", totalSales: 43, totalUnits: 20 },
        { date: "2021-04-03", totalSales: 84, totalUnits: 22 },
        { date: "2021-04-04", totalSales: 30, totalUnits: 18 },
        { date: "2021-04-05", totalSales: 25, totalUnits: 11 },
        { date: "2021-04-06", totalSales: 72, totalUnits: 8 },
        { date: "2021-04-07", totalSales: 99, totalUnits: 17 },
        { date: "2021-04-08", totalSales: 50, totalUnits: 16 },
        { date: "2021-04-09", totalSales: 1, totalUnits: 23 },
        { date: "2021-04-10", totalSales: 28, totalUnits: 20 },
        { date: "2021-04-11", totalSales: 51, totalUnits: 43 },
        { date: "2021-04-12", totalSales: 77, totalUnits: 8 },
        { date: "2021-04-13", totalSales: 81, totalUnits: 33 },
        { date: "2021-04-14", totalSales: 44, totalUnits: 40 },
        { date: "2021-04-15", totalSales: 38, totalUnits: 11 },
        { date: "2021-04-16", totalSales: 37, totalUnits: 39 },
        { date: "2021-04-17", totalSales: 86, totalUnits: 49 },
        { date: "2021-04-18", totalSales: 49, totalUnits: 14 },
        { date: "2021-04-19", totalSales: 44, totalUnits: 33 },
        { date: "2021-04-20", totalSales: 16, totalUnits: 10 },
        { date: "2021-04-21", totalSales: 20, totalUnits: 36 },
        { date: "2021-04-22", totalSales: 60, totalUnits: 16 },
        { date: "2021-04-23", totalSales: 15, totalUnits: 5 },
        { date: "2021-04-24", totalSales: 3, totalUnits: 43 },
        { date: "2021-04-25", totalSales: 61, totalUnits: 23 },
        { date: "2021-04-26", totalSales: 10, totalUnits: 4 },
        { date: "2021-04-27", totalSales: 3, totalUnits: 45 },
        { date: "2021-04-28", totalSales: 41, totalUnits: 30 },
        { date: "2021-04-29", totalSales: 44, totalUnits: 6 },
        { date: "2021-04-30", totalSales: 68, totalUnits: 23 },
        { date: "2021-05-01", totalSales: 69, totalUnits: 35 },
        { date: "2021-05-02", totalSales: 77, totalUnits: 34 },
        { date: "2021-05-03", totalSales: 85, totalUnits: 15 },
        { date: "2021-05-04", totalSales: 80, totalUnits: 11 },
        { date: "2021-05-05", totalSales: 81, totalUnits: 50 },
        { date: "2021-05-06", totalSales: 39, totalUnits: 26 },
        { date: "2021-05-07", totalSales: 26, totalUnits: 2 },
        { date: "2021-05-08", totalSales: 29, totalUnits: 49 },
        { date: "2021-05-09", totalSales: 54, totalUnits: 37 },
        { date: "2021-05-10", totalSales: 97, totalUnits: 31 },
        { date: "2021-05-11", totalSales: 50, totalUnits: 28 },
        { date: "2021-05-12", totalSales: 27, totalUnits: 2 },
        { date: "2021-05-13", totalSales: 55, totalUnits: 46 },
        { date: "2021-05-14", totalSales: 89, totalUnits: 1 },
        { date: "2021-05-15", totalSales: 90, totalUnits: 40 },
        { date: "2021-05-16", totalSales: 96, totalUnits: 8 },
        { date: "2021-05-17", totalSales: 14, totalUnits: 50 },
        { date: "2021-05-18", totalSales: 92, totalUnits: 38 },
        { date: "2021-05-19", totalSales: 63, totalUnits: 36 },
        { date: "2021-05-20", totalSales: 56, totalUnits: 26 },
        { date: "2021-05-21", totalSales: 6, totalUnits: 11 },
        { date: "2021-05-22", totalSales: 87, totalUnits: 34 },
        { date: "2021-05-23", totalSales: 79, totalUnits: 40 },
        { date: "2021-05-24", totalSales: 78, totalUnits: 26 },
        { date: "2021-05-25", totalSales: 83, totalUnits: 50 },
        { date: "2021-05-26", totalSales: 6, totalUnits: 36 },
        { date: "2021-05-27", totalSales: 39, totalUnits: 15 },
        { date: "2021-05-28", totalSales: 10, totalUnits: 39 },
        { date: "2021-05-29", totalSales: 54, totalUnits: 37 },
        { date: "2021-05-30", totalSales: 73, totalUnits: 50 },
        { date: "2021-05-31", totalSales: 50, totalUnits: 7 },
        { date: "2021-06-01", totalSales: 53, totalUnits: 17 },
        { date: "2021-06-02", totalSales: 40, totalUnits: 50 },
        { date: "2021-06-03", totalSales: 89, totalUnits: 9 },
        { date: "2021-06-04", totalSales: 91, totalUnits: 33 },
        { date: "2021-06-05", totalSales: 42, totalUnits: 38 },
        { date: "2021-06-06", totalSales: 26, totalUnits: 43 },
        { date: "2021-06-07", totalSales: 72, totalUnits: 3 },
        { date: "2021-06-08", totalSales: 53, totalUnits: 11 },
        { date: "2021-06-09", totalSales: 1, totalUnits: 12 },
        { date: "2021-06-10", totalSales: 49, totalUnits: 38 },
        { date: "2021-06-11", totalSales: 6, totalUnits: 46 },
        { date: "2021-06-12", totalSales: 16, totalUnits: 23 },
        { date: "2021-06-13", totalSales: 47, totalUnits: 20 },
        { date: "2021-06-14", totalSales: 19, totalUnits: 26 },
        { date: "2021-06-15", totalSales: 8, totalUnits: 45 },
        { date: "2021-06-16", totalSales: 22, totalUnits: 35 },
        { date: "2021-06-17", totalSales: 56, totalUnits: 41 },
        { date: "2021-06-18", totalSales: 8, totalUnits: 12 },
        { date: "2021-06-19", totalSales: 2, totalUnits: 48 },
        { date: "2021-06-20", totalSales: 78, totalUnits: 3 },
        { date: "2021-06-21", totalSales: 15, totalUnits: 27 },
        { date: "2021-06-22", totalSales: 54, totalUnits: 25 },
        { date: "2021-06-23", totalSales: 2, totalUnits: 7 },
        { date: "2021-06-24", totalSales: 57, totalUnits: 43 },
        { date: "2021-06-25", totalSales: 85, totalUnits: 31 },
        { date: "2021-06-26", totalSales: 39, totalUnits: 25 },
        { date: "2021-06-27", totalSales: 26, totalUnits: 21 },
        { date: "2021-06-28", totalSales: 99, totalUnits: 28 },
        { date: "2021-06-29", totalSales: 37, totalUnits: 46 },
        { date: "2021-06-30", totalSales: 71, totalUnits: 20 },
        { date: "2021-07-01", totalSales: 93, totalUnits: 44 },
        { date: "2021-07-02", totalSales: 52, totalUnits: 46 },
        { date: "2021-07-03", totalSales: 58, totalUnits: 43 },
        { date: "2021-07-04", totalSales: 78, totalUnits: 27 },
        { date: "2021-07-05", totalSales: 76, totalUnits: 14 },
        { date: "2021-07-06", totalSales: 50, totalUnits: 42 },
        { date: "2021-07-07", totalSales: 31, totalUnits: 50 },
        { date: "2021-07-08", totalSales: 92, totalUnits: 40 },
        { date: "2021-07-09", totalSales: 35, totalUnits: 27 },
        { date: "2021-07-10", totalSales: 4, totalUnits: 1 },
        { date: "2021-07-11", totalSales: 73, totalUnits: 3 },
        { date: "2021-07-12", totalSales: 26, totalUnits: 20 },
        { date: "2021-07-13", totalSales: 79, totalUnits: 36 },
        { date: "2021-07-14", totalSales: 6, totalUnits: 28 },
        { date: "2021-07-15", totalSales: 75, totalUnits: 26 },
        { date: "2021-07-16", totalSales: 42, totalUnits: 7 },
        { date: "2021-07-17", totalSales: 85, totalUnits: 21 },
        { date: "2021-07-18", totalSales: 24, totalUnits: 2 },
        { date: "2021-07-19", totalSales: 30, totalUnits: 9 },
        { date: "2021-07-20", totalSales: 54, totalUnits: 23 },
        { date: "2021-07-21", totalSales: 48, totalUnits: 21 },
        { date: "2021-07-22", totalSales: 77, totalUnits: 32 },
        { date: "2021-07-23", totalSales: 91, totalUnits: 44 },
        { date: "2021-07-24", totalSales: 25, totalUnits: 15 },
        { date: "2021-07-25", totalSales: 17, totalUnits: 29 },
        { date: "2021-07-26", totalSales: 11, totalUnits: 34 },
        { date: "2021-07-27", totalSales: 37, totalUnits: 44 },
        { date: "2021-07-28", totalSales: 24, totalUnits: 22 },
        { date: "2021-07-29", totalSales: 90, totalUnits: 12 },
        { date: "2021-07-30", totalSales: 70, totalUnits: 20 },
        { date: "2021-07-31", totalSales: 51, totalUnits: 43 },
        { date: "2021-08-01", totalSales: 73, totalUnits: 12 },
        { date: "2021-08-02", totalSales: 81, totalUnits: 33 },
        { date: "2021-08-03", totalSales: 96, totalUnits: 41 },
        { date: "2021-08-04", totalSales: 19, totalUnits: 7 },
        { date: "2021-08-05", totalSales: 6, totalUnits: 22 },
        { date: "2021-08-06", totalSales: 69, totalUnits: 35 },
        { date: "2021-08-07", totalSales: 57, totalUnits: 22 },
        { date: "2021-08-08", totalSales: 67, totalUnits: 41 },
        { date: "2021-08-09", totalSales: 40, totalUnits: 10 },
        { date: "2021-08-10", totalSales: 52, totalUnits: 19 },
        { date: "2021-08-11", totalSales: 88, totalUnits: 25 },
        { date: "2021-08-12", totalSales: 1, totalUnits: 22 },
        { date: "2021-08-13", totalSales: 78, totalUnits: 46 },
        { date: "2021-08-14", totalSales: 90, totalUnits: 11 },
        { date: "2021-08-15", totalSales: 43, totalUnits: 34 },
        { date: "2021-08-16", totalSales: 68, totalUnits: 18 },
        { date: "2021-08-17", totalSales: 28, totalUnits: 23 },
        { date: "2021-08-18", totalSales: 5, totalUnits: 5 },
        { date: "2021-08-19", totalSales: 27, totalUnits: 20 },
        { date: "2021-08-20", totalSales: 97, totalUnits: 11 },
        { date: "2021-08-21", totalSales: 97, totalUnits: 42 },
        { date: "2021-08-22", totalSales: 92, totalUnits: 4 },
        { date: "2021-08-23", totalSales: 73, totalUnits: 1 },
        { date: "2021-08-24", totalSales: 42, totalUnits: 18 },
        { date: "2021-08-25", totalSales: 16, totalUnits: 10 },
        { date: "2021-08-26", totalSales: 18, totalUnits: 11 },
        { date: "2021-08-27", totalSales: 48, totalUnits: 16 },
        { date: "2021-08-28", totalSales: 70, totalUnits: 4 },
        { date: "2021-08-29", totalSales: 62, totalUnits: 44 },
        { date: "2021-08-30", totalSales: 71, totalUnits: 13 },
        { date: "2021-08-31", totalSales: 65, totalUnits: 8 },
        { date: "2021-09-01", totalSales: 89, totalUnits: 49 },
        { date: "2021-09-02", totalSales: 75, totalUnits: 17 },
        { date: "2021-09-03", totalSales: 79, totalUnits: 2 },
        { date: "2021-09-04", totalSales: 11, totalUnits: 45 },
        { date: "2021-09-05", totalSales: 97, totalUnits: 25 },
        { date: "2021-09-06", totalSales: 46, totalUnits: 4 },
        { date: "2021-09-07", totalSales: 43, totalUnits: 3 },
        { date: "2021-09-08", totalSales: 44, totalUnits: 17 },
        { date: "2021-09-09", totalSales: 65, totalUnits: 11 },
        { date: "2021-09-10", totalSales: 50, totalUnits: 4 },
        { date: "2021-09-11", totalSales: 36, totalUnits: 30 },
        { date: "2021-09-12", totalSales: 37, totalUnits: 49 },
        { date: "2021-09-13", totalSales: 84, totalUnits: 21 },
        { date: "2021-09-14", totalSales: 79, totalUnits: 49 },
        { date: "2021-09-15", totalSales: 49, totalUnits: 5 },
        { date: "2021-09-16", totalSales: 21, totalUnits: 31 },
        { date: "2021-09-17", totalSales: 20, totalUnits: 20 },
        { date: "2021-09-18", totalSales: 1, totalUnits: 13 },
        { date: "2021-09-19", totalSales: 15, totalUnits: 29 },
        { date: "2021-09-20", totalSales: 52, totalUnits: 33 },
        { date: "2021-09-21", totalSales: 42, totalUnits: 3 },
        { date: "2021-09-22", totalSales: 81, totalUnits: 33 },
        { date: "2021-09-23", totalSales: 74, totalUnits: 40 },
        { date: "2021-09-24", totalSales: 46, totalUnits: 35 },
        { date: "2021-09-25", totalSales: 47, totalUnits: 23 },
        { date: "2021-09-26", totalSales: 40, totalUnits: 50 },
        { date: "2021-09-27", totalSales: 100, totalUnits: 45 },
        { date: "2021-09-28", totalSales: 76, totalUnits: 35 },
        { date: "2021-09-29", totalSales: 93, totalUnits: 15 },
        { date: "2021-09-30", totalSales: 19, totalUnits: 29 },
        { date: "2021-10-01", totalSales: 72, totalUnits: 27 },
        { date: "2021-10-02", totalSales: 10, totalUnits: 36 },
        { date: "2021-10-03", totalSales: 12, totalUnits: 5 },
        { date: "2021-10-04", totalSales: 66, totalUnits: 47 },
        { date: "2021-10-05", totalSales: 47, totalUnits: 32 },
        { date: "2021-10-06", totalSales: 18, totalUnits: 43 },
        { date: "2021-10-07", totalSales: 65, totalUnits: 8 },
        { date: "2021-10-08", totalSales: 71, totalUnits: 48 },
        { date: "2021-10-09", totalSales: 65, totalUnits: 38 },
        { date: "2021-10-10", totalSales: 16, totalUnits: 2 },
        { date: "2021-10-11", totalSales: 37, totalUnits: 19 },
        { date: "2021-10-12", totalSales: 54, totalUnits: 21 },
        { date: "2021-10-13", totalSales: 28, totalUnits: 38 },
        { date: "2021-10-14", totalSales: 82, totalUnits: 8 },
        { date: "2021-10-15", totalSales: 40, totalUnits: 28 },
        { date: "2021-10-16", totalSales: 60, totalUnits: 44 },
        { date: "2021-10-17", totalSales: 73, totalUnits: 10 },
        { date: "2021-10-18", totalSales: 11, totalUnits: 10 },
        { date: "2021-10-19", totalSales: 35, totalUnits: 23 },
        { date: "2021-10-20", totalSales: 50, totalUnits: 16 },
        { date: "2021-10-21", totalSales: 48, totalUnits: 20 },
        { date: "2021-10-22", totalSales: 50, totalUnits: 35 },
        { date: "2021-10-23", totalSales: 72, totalUnits: 40 },
        { date: "2021-10-24", totalSales: 86, totalUnits: 11 },
        { date: "2021-10-25", totalSales: 99, totalUnits: 35 },
        { date: "2021-10-26", totalSales: 40, totalUnits: 48 },
        { date: "2021-10-27", totalSales: 29, totalUnits: 25 },
        { date: "2021-10-28", totalSales: 30, totalUnits: 24 },
        { date: "2021-10-29", totalSales: 10, totalUnits: 38 },
        { date: "2021-10-30", totalSales: 6, totalUnits: 9 },
        { date: "2021-10-31", totalSales: 85, totalUnits: 16 },
        { date: "2021-11-01", totalSales: 30, totalUnits: 20 },
        { date: "2021-11-02", totalSales: 47, totalUnits: 16 },
        { date: "2021-11-03", totalSales: 95, totalUnits: 2 },
        { date: "2021-11-04", totalSales: 91, totalUnits: 10 },
        { date: "2021-11-05", totalSales: 82, totalUnits: 20 },
        { date: "2021-11-06", totalSales: 80, totalUnits: 29 },
        { date: "2021-11-07", totalSales: 75, totalUnits: 21 },
        { date: "2021-11-08", totalSales: 96, totalUnits: 45 },
        { date: "2021-11-09", totalSales: 7, totalUnits: 46 },
        { date: "2021-11-10", totalSales: 3, totalUnits: 46 },
        { date: "2021-11-11", totalSales: 35, totalUnits: 47 },
        { date: "2021-11-12", totalSales: 85, totalUnits: 33 },
        { date: "2021-11-13", totalSales: 51, totalUnits: 45 },
        { date: "2021-11-14", totalSales: 33, totalUnits: 13 },
        { date: "2021-11-15", totalSales: 14, totalUnits: 28 },
        { date: "2021-11-16", totalSales: 54, totalUnits: 14 },
        { date: "2021-11-17", totalSales: 72, totalUnits: 23 },
      ],
    },
    {
      _id: "6371259df03239eb0c000002",
      productId: "63701d24f03239867500012b",
      yearlySalesTotal: 4819,
      yearlyTotalSoldUnits: 4228,
      monthlyData: [
        { month: "january", totalSales: 682, totalUnits: 269 },
        { month: "february", totalSales: 565, totalUnits: 199 },
        { month: "march", totalSales: 136, totalUnits: 212 },
        { month: "april", totalSales: 149, totalUnits: 459 },
        { month: "may", totalSales: 709, totalUnits: 36 },
        { month: "june", totalSales: 939, totalUnits: 262 },
        { month: "july", totalSales: 916, totalUnits: 241 },
        { month: "august", totalSales: 547, totalUnits: 94 },
        { month: "september", totalSales: 764, totalUnits: 453 },
        { month: "october", totalSales: 348, totalUnits: 286 },
        { month: "november", totalSales: 849, totalUnits: 389 },
        { month: "december", totalSales: 480, totalUnits: 13 },
      ],
      dailyData: [
        { date: "2021-01-02", totalSales: 78, totalUnits: 2 },
        { date: "2021-01-03", totalSales: 36, totalUnits: 14 },
        { date: "2021-01-04", totalSales: 99, totalUnits: 50 },
        { date: "2021-01-05", totalSales: 86, totalUnits: 37 },
        { date: "2021-01-06", totalSales: 33, totalUnits: 50 },
        { date: "2021-01-07", totalSales: 13, totalUnits: 34 },
        { date: "2021-01-08", totalSales: 83, totalUnits: 5 },
        { date: "2021-01-09", totalSales: 47, totalUnits: 41 },
        { date: "2021-01-10", totalSales: 25, totalUnits: 32 },
        { date: "2021-01-11", totalSales: 24, totalUnits: 24 },
        { date: "2021-01-12", totalSales: 9, totalUnits: 42 },
        { date: "2021-01-13", totalSales: 95, totalUnits: 39 },
        { date: "2021-01-14", totalSales: 100, totalUnits: 41 },
        { date: "2021-01-15", totalSales: 35, totalUnits: 14 },
        { date: "2021-01-16", totalSales: 73, totalUnits: 29 },
        { date: "2021-01-17", totalSales: 46, totalUnits: 22 },
        { date: "2021-01-18", totalSales: 98, totalUnits: 7 },
        { date: "2021-01-19", totalSales: 22, totalUnits: 7 },
        { date: "2021-01-20", totalSales: 61, totalUnits: 37 },
        { date: "2021-01-21", totalSales: 88, totalUnits: 12 },
        { date: "2021-01-22", totalSales: 46, totalUnits: 28 },
        { date: "2021-01-23", totalSales: 31, totalUnits: 6 },
        { date: "2021-01-24", totalSales: 85, totalUnits: 9 },
        { date: "2021-01-25", totalSales: 62, totalUnits: 8 },
        { date: "2021-01-26", totalSales: 53, totalUnits: 21 },
        { date: "2021-01-27", totalSales: 77, totalUnits: 44 },
        { date: "2021-01-28", totalSales: 92, totalUnits: 19 },
        { date: "2021-01-29", totalSales: 68, totalUnits: 12 },
        { date: "2021-01-30", totalSales: 87, totalUnits: 27 },
        { date: "2021-01-31", totalSales: 54, totalUnits: 4 },
        { date: "2021-02-01", totalSales: 64, totalUnits: 33 },
        { date: "2021-02-02", totalSales: 31, totalUnits: 35 },
        { date: "2021-02-03", totalSales: 14, totalUnits: 33 },
        { date: "2021-02-04", totalSales: 74, totalUnits: 31 },
        { date: "2021-02-05", totalSales: 81, totalUnits: 42 },
        { date: "2021-02-06", totalSales: 71, totalUnits: 47 },
        { date: "2021-02-07", totalSales: 14, totalUnits: 3 },
        { date: "2021-02-08", totalSales: 52, totalUnits: 8 },
        { date: "2021-02-09", totalSales: 67, totalUnits: 45 },
        { date: "2021-02-10", totalSales: 57, totalUnits: 42 },
        { date: "2021-02-11", totalSales: 25, totalUnits: 31 },
        { date: "2021-02-12", totalSales: 47, totalUnits: 18 },
        { date: "2021-02-13", totalSales: 85, totalUnits: 43 },
        { date: "2021-02-14", totalSales: 64, totalUnits: 19 },
        { date: "2021-02-15", totalSales: 23, totalUnits: 49 },
        { date: "2021-02-16", totalSales: 17, totalUnits: 8 },
        { date: "2021-02-17", totalSales: 93, totalUnits: 2 },
        { date: "2021-02-18", totalSales: 48, totalUnits: 21 },
        { date: "2021-02-19", totalSales: 54, totalUnits: 31 },
        { date: "2021-02-20", totalSales: 26, totalUnits: 4 },
        { date: "2021-02-21", totalSales: 45, totalUnits: 47 },
        { date: "2021-02-22", totalSales: 96, totalUnits: 31 },
        { date: "2021-02-23", totalSales: 41, totalUnits: 13 },
        { date: "2021-02-24", totalSales: 56, totalUnits: 24 },
        { date: "2021-02-25", totalSales: 13, totalUnits: 10 },
        { date: "2021-02-26", totalSales: 65, totalUnits: 31 },
        { date: "2021-02-27", totalSales: 62, totalUnits: 35 },
        { date: "2021-02-28", totalSales: 67, totalUnits: 4 },
        { date: "2021-03-01", totalSales: 24, totalUnits: 22 },
        { date: "2021-03-02", totalSales: 2, totalUnits: 31 },
        { date: "2021-03-03", totalSales: 35, totalUnits: 8 },
        { date: "2021-03-04", totalSales: 74, totalUnits: 15 },
        { date: "2021-03-05", totalSales: 72, totalUnits: 41 },
        { date: "2021-03-06", totalSales: 62, totalUnits: 30 },
        { date: "2021-03-07", totalSales: 85, totalUnits: 33 },
        { date: "2021-03-08", totalSales: 89, totalUnits: 13 },
        { date: "2021-03-09", totalSales: 36, totalUnits: 6 },
        { date: "2021-03-10", totalSales: 92, totalUnits: 15 },
        { date: "2021-03-11", totalSales: 33, totalUnits: 5 },
        { date: "2021-03-12", totalSales: 34, totalUnits: 34 },
        { date: "2021-03-13", totalSales: 79, totalUnits: 9 },
        { date: "2021-03-14", totalSales: 54, totalUnits: 21 },
        { date: "2021-03-15", totalSales: 34, totalUnits: 40 },
        { date: "2021-03-16", totalSales: 85, totalUnits: 45 },
        { date: "2021-03-17", totalSales: 87, totalUnits: 15 },
        { date: "2021-03-18", totalSales: 38, totalUnits: 12 },
        { date: "2021-03-19", totalSales: 91, totalUnits: 14 },
        { date: "2021-03-20", totalSales: 73, totalUnits: 17 },
        { date: "2021-03-21", totalSales: 21, totalUnits: 10 },
        { date: "2021-03-22", totalSales: 45, totalUnits: 21 },
        { date: "2021-03-23", totalSales: 74, totalUnits: 12 },
        { date: "2021-03-24", totalSales: 87, totalUnits: 27 },
        { date: "2021-03-25", totalSales: 21, totalUnits: 33 },
        { date: "2021-03-26", totalSales: 76, totalUnits: 32 },
        { date: "2021-03-27", totalSales: 9, totalUnits: 28 },
        { date: "2021-03-28", totalSales: 39, totalUnits: 23 },
        { date: "2021-03-29", totalSales: 44, totalUnits: 16 },
        { date: "2021-03-30", totalSales: 7, totalUnits: 45 },
        { date: "2021-03-31", totalSales: 65, totalUnits: 13 },
        { date: "2021-04-01", totalSales: 23, totalUnits: 29 },
        { date: "2021-04-02", totalSales: 86, totalUnits: 49 },
        { date: "2021-04-03", totalSales: 62, totalUnits: 38 },
        { date: "2021-04-04", totalSales: 59, totalUnits: 23 },
        { date: "2021-04-05", totalSales: 40, totalUnits: 29 },
        { date: "2021-04-06", totalSales: 76, totalUnits: 16 },
        { date: "2021-04-07", totalSales: 50, totalUnits: 17 },
        { date: "2021-04-08", totalSales: 87, totalUnits: 4 },
        { date: "2021-04-09", totalSales: 24, totalUnits: 7 },
        { date: "2021-04-10", totalSales: 100, totalUnits: 16 },
        { date: "2021-04-11", totalSales: 92, totalUnits: 33 },
        { date: "2021-04-12", totalSales: 43, totalUnits: 47 },
        { date: "2021-04-13", totalSales: 92, totalUnits: 38 },
        { date: "2021-04-14", totalSales: 78, totalUnits: 49 },
        { date: "2021-04-15", totalSales: 53, totalUnits: 41 },
        { date: "2021-04-16", totalSales: 41, totalUnits: 27 },
        { date: "2021-04-17", totalSales: 84, totalUnits: 43 },
        { date: "2021-04-18", totalSales: 94, totalUnits: 50 },
        { date: "2021-04-19", totalSales: 19, totalUnits: 45 },
        { date: "2021-04-20", totalSales: 96, totalUnits: 26 },
        { date: "2021-04-21", totalSales: 87, totalUnits: 27 },
        { date: "2021-04-22", totalSales: 54, totalUnits: 23 },
        { date: "2021-04-23", totalSales: 60, totalUnits: 21 },
        { date: "2021-04-24", totalSales: 61, totalUnits: 2 },
        { date: "2021-04-25", totalSales: 71, totalUnits: 10 },
        { date: "2021-04-26", totalSales: 52, totalUnits: 29 },
        { date: "2021-04-27", totalSales: 33, totalUnits: 48 },
        { date: "2021-04-28", totalSales: 65, totalUnits: 11 },
        { date: "2021-04-29", totalSales: 86, totalUnits: 29 },
        { date: "2021-04-30", totalSales: 48, totalUnits: 46 },
        { date: "2021-05-01", totalSales: 40, totalUnits: 2 },
        { date: "2021-05-02", totalSales: 80, totalUnits: 10 },
        { date: "2021-05-03", totalSales: 42, totalUnits: 34 },
        { date: "2021-05-04", totalSales: 98, totalUnits: 28 },
        { date: "2021-05-05", totalSales: 3, totalUnits: 16 },
        { date: "2021-05-06", totalSales: 71, totalUnits: 15 },
        { date: "2021-05-07", totalSales: 75, totalUnits: 3 },
        { date: "2021-05-08", totalSales: 7, totalUnits: 43 },
        { date: "2021-05-09", totalSales: 70, totalUnits: 3 },
        { date: "2021-05-10", totalSales: 12, totalUnits: 48 },
        { date: "2021-05-11", totalSales: 9, totalUnits: 16 },
        { date: "2021-05-12", totalSales: 24, totalUnits: 15 },
        { date: "2021-05-13", totalSales: 23, totalUnits: 17 },
        { date: "2021-05-14", totalSales: 98, totalUnits: 10 },
        { date: "2021-05-15", totalSales: 18, totalUnits: 11 },
        { date: "2021-05-16", totalSales: 87, totalUnits: 28 },
        { date: "2021-05-17", totalSales: 4, totalUnits: 4 },
        { date: "2021-05-18", totalSales: 57, totalUnits: 25 },
        { date: "2021-05-19", totalSales: 24, totalUnits: 46 },
        { date: "2021-05-20", totalSales: 64, totalUnits: 20 },
        { date: "2021-05-21", totalSales: 88, totalUnits: 38 },
        { date: "2021-05-22", totalSales: 29, totalUnits: 18 },
        { date: "2021-05-23", totalSales: 11, totalUnits: 28 },
        { date: "2021-05-24", totalSales: 83, totalUnits: 23 },
        { date: "2021-05-25", totalSales: 86, totalUnits: 20 },
        { date: "2021-05-26", totalSales: 68, totalUnits: 37 },
        { date: "2021-05-27", totalSales: 89, totalUnits: 41 },
        { date: "2021-05-28", totalSales: 40, totalUnits: 17 },
        { date: "2021-05-29", totalSales: 67, totalUnits: 26 },
        { date: "2021-05-30", totalSales: 67, totalUnits: 44 },
        { date: "2021-05-31", totalSales: 8, totalUnits: 47 },
        { date: "2021-06-01", totalSales: 62, totalUnits: 19 },
        { date: "2021-06-02", totalSales: 70, totalUnits: 22 },
        { date: "2021-06-03", totalSales: 11, totalUnits: 21 },
        { date: "2021-06-04", totalSales: 46, totalUnits: 2 },
        { date: "2021-06-05", totalSales: 85, totalUnits: 27 },
        { date: "2021-06-06", totalSales: 87, totalUnits: 10 },
        { date: "2021-06-07", totalSales: 2, totalUnits: 2 },
        { date: "2021-06-08", totalSales: 57, totalUnits: 20 },
        { date: "2021-06-09", totalSales: 4, totalUnits: 24 },
        { date: "2021-06-10", totalSales: 67, totalUnits: 15 },
        { date: "2021-06-11", totalSales: 15, totalUnits: 4 },
        { date: "2021-06-12", totalSales: 96, totalUnits: 25 },
        { date: "2021-06-13", totalSales: 87, totalUnits: 40 },
        { date: "2021-06-14", totalSales: 33, totalUnits: 49 },
        { date: "2021-06-15", totalSales: 98, totalUnits: 31 },
        { date: "2021-06-16", totalSales: 61, totalUnits: 15 },
        { date: "2021-06-17", totalSales: 9, totalUnits: 35 },
        { date: "2021-06-18", totalSales: 68, totalUnits: 38 },
        { date: "2021-06-19", totalSales: 82, totalUnits: 34 },
        { date: "2021-06-20", totalSales: 21, totalUnits: 4 },
        { date: "2021-06-21", totalSales: 8, totalUnits: 11 },
        { date: "2021-06-22", totalSales: 44, totalUnits: 43 },
        { date: "2021-06-23", totalSales: 89, totalUnits: 23 },
        { date: "2021-06-24", totalSales: 44, totalUnits: 21 },
        { date: "2021-06-25", totalSales: 9, totalUnits: 10 },
        { date: "2021-06-26", totalSales: 50, totalUnits: 1 },
        { date: "2021-06-27", totalSales: 3, totalUnits: 36 },
        { date: "2021-06-28", totalSales: 72, totalUnits: 20 },
        { date: "2021-06-29", totalSales: 79, totalUnits: 23 },
        { date: "2021-06-30", totalSales: 20, totalUnits: 28 },
        { date: "2021-07-01", totalSales: 27, totalUnits: 34 },
        { date: "2021-07-02", totalSales: 87, totalUnits: 18 },
        { date: "2021-07-03", totalSales: 7, totalUnits: 18 },
        { date: "2021-07-04", totalSales: 18, totalUnits: 15 },
        { date: "2021-07-05", totalSales: 49, totalUnits: 37 },
        { date: "2021-07-06", totalSales: 78, totalUnits: 23 },
        { date: "2021-07-07", totalSales: 24, totalUnits: 41 },
        { date: "2021-07-08", totalSales: 13, totalUnits: 37 },
        { date: "2021-07-09", totalSales: 35, totalUnits: 34 },
        { date: "2021-07-10", totalSales: 9, totalUnits: 46 },
        { date: "2021-07-11", totalSales: 28, totalUnits: 41 },
        { date: "2021-07-12", totalSales: 20, totalUnits: 27 },
        { date: "2021-07-13", totalSales: 34, totalUnits: 41 },
        { date: "2021-07-14", totalSales: 83, totalUnits: 5 },
        { date: "2021-07-15", totalSales: 76, totalUnits: 6 },
        { date: "2021-07-16", totalSales: 77, totalUnits: 41 },
        { date: "2021-07-17", totalSales: 35, totalUnits: 41 },
        { date: "2021-07-18", totalSales: 37, totalUnits: 34 },
        { date: "2021-07-19", totalSales: 33, totalUnits: 36 },
        { date: "2021-07-20", totalSales: 43, totalUnits: 41 },
        { date: "2021-07-21", totalSales: 49, totalUnits: 38 },
        { date: "2021-07-22", totalSales: 57, totalUnits: 46 },
        { date: "2021-07-23", totalSales: 28, totalUnits: 48 },
        { date: "2021-07-24", totalSales: 34, totalUnits: 20 },
        { date: "2021-07-25", totalSales: 34, totalUnits: 33 },
        { date: "2021-07-26", totalSales: 77, totalUnits: 27 },
        { date: "2021-07-27", totalSales: 14, totalUnits: 21 },
        { date: "2021-07-28", totalSales: 36, totalUnits: 33 },
        { date: "2021-07-29", totalSales: 35, totalUnits: 7 },
        { date: "2021-07-30", totalSales: 25, totalUnits: 31 },
        { date: "2021-07-31", totalSales: 67, totalUnits: 19 },
        { date: "2021-08-01", totalSales: 94, totalUnits: 22 },
        { date: "2021-08-02", totalSales: 33, totalUnits: 31 },
        { date: "2021-08-03", totalSales: 77, totalUnits: 34 },
        { date: "2021-08-04", totalSales: 11, totalUnits: 23 },
        { date: "2021-08-05", totalSales: 4, totalUnits: 17 },
        { date: "2021-08-06", totalSales: 39, totalUnits: 25 },
        { date: "2021-08-07", totalSales: 24, totalUnits: 5 },
        { date: "2021-08-08", totalSales: 25, totalUnits: 8 },
        { date: "2021-08-09", totalSales: 53, totalUnits: 12 },
        { date: "2021-08-10", totalSales: 38, totalUnits: 33 },
        { date: "2021-08-11", totalSales: 81, totalUnits: 25 },
        { date: "2021-08-12", totalSales: 81, totalUnits: 32 },
        { date: "2021-08-13", totalSales: 2, totalUnits: 38 },
        { date: "2021-08-14", totalSales: 52, totalUnits: 34 },
        { date: "2021-08-15", totalSales: 25, totalUnits: 5 },
        { date: "2021-08-16", totalSales: 48, totalUnits: 30 },
        { date: "2021-08-17", totalSales: 5, totalUnits: 27 },
        { date: "2021-08-18", totalSales: 35, totalUnits: 35 },
        { date: "2021-08-19", totalSales: 54, totalUnits: 1 },
        { date: "2021-08-20", totalSales: 99, totalUnits: 13 },
        { date: "2021-08-21", totalSales: 13, totalUnits: 13 },
        { date: "2021-08-22", totalSales: 17, totalUnits: 8 },
        { date: "2021-08-23", totalSales: 68, totalUnits: 34 },
        { date: "2021-08-24", totalSales: 40, totalUnits: 18 },
        { date: "2021-08-25", totalSales: 2, totalUnits: 14 },
        { date: "2021-08-26", totalSales: 6, totalUnits: 37 },
        { date: "2021-08-27", totalSales: 32, totalUnits: 37 },
        { date: "2021-08-28", totalSales: 79, totalUnits: 33 },
        { date: "2021-08-29", totalSales: 99, totalUnits: 5 },
        { date: "2021-08-30", totalSales: 59, totalUnits: 32 },
        { date: "2021-08-31", totalSales: 62, totalUnits: 28 },
        { date: "2021-09-01", totalSales: 63, totalUnits: 13 },
        { date: "2021-09-02", totalSales: 75, totalUnits: 4 },
        { date: "2021-09-03", totalSales: 66, totalUnits: 12 },
        { date: "2021-09-04", totalSales: 40, totalUnits: 34 },
        { date: "2021-09-05", totalSales: 94, totalUnits: 25 },
        { date: "2021-09-06", totalSales: 25, totalUnits: 46 },
        { date: "2021-09-07", totalSales: 91, totalUnits: 29 },
        { date: "2021-09-08", totalSales: 100, totalUnits: 24 },
        { date: "2021-09-09", totalSales: 55, totalUnits: 36 },
        { date: "2021-09-10", totalSales: 38, totalUnits: 19 },
        { date: "2021-09-11", totalSales: 26, totalUnits: 39 },
        { date: "2021-09-12", totalSales: 74, totalUnits: 26 },
        { date: "2021-09-13", totalSales: 58, totalUnits: 15 },
        { date: "2021-09-14", totalSales: 35, totalUnits: 18 },
        { date: "2021-09-15", totalSales: 81, totalUnits: 18 },
        { date: "2021-09-16", totalSales: 77, totalUnits: 25 },
        { date: "2021-09-17", totalSales: 14, totalUnits: 17 },
        { date: "2021-09-18", totalSales: 16, totalUnits: 17 },
        { date: "2021-09-19", totalSales: 92, totalUnits: 36 },
        { date: "2021-09-20", totalSales: 77, totalUnits: 45 },
        { date: "2021-09-21", totalSales: 58, totalUnits: 39 },
        { date: "2021-09-22", totalSales: 34, totalUnits: 5 },
        { date: "2021-09-23", totalSales: 100, totalUnits: 33 },
        { date: "2021-09-24", totalSales: 100, totalUnits: 36 },
        { date: "2021-09-25", totalSales: 69, totalUnits: 5 },
        { date: "2021-09-26", totalSales: 75, totalUnits: 28 },
        { date: "2021-09-27", totalSales: 55, totalUnits: 20 },
        { date: "2021-09-28", totalSales: 33, totalUnits: 23 },
        { date: "2021-09-29", totalSales: 51, totalUnits: 4 },
        { date: "2021-09-30", totalSales: 36, totalUnits: 35 },
        { date: "2021-10-01", totalSales: 93, totalUnits: 35 },
        { date: "2021-10-02", totalSales: 93, totalUnits: 42 },
        { date: "2021-10-03", totalSales: 72, totalUnits: 13 },
        { date: "2021-10-04", totalSales: 100, totalUnits: 31 },
        { date: "2021-10-05", totalSales: 15, totalUnits: 36 },
        { date: "2021-10-06", totalSales: 48, totalUnits: 25 },
        { date: "2021-10-07", totalSales: 93, totalUnits: 12 },
        { date: "2021-10-08", totalSales: 38, totalUnits: 34 },
        { date: "2021-10-09", totalSales: 69, totalUnits: 6 },
        { date: "2021-10-10", totalSales: 63, totalUnits: 12 },
        { date: "2021-10-11", totalSales: 28, totalUnits: 29 },
        { date: "2021-10-12", totalSales: 40, totalUnits: 37 },
        { date: "2021-10-13", totalSales: 45, totalUnits: 13 },
        { date: "2021-10-14", totalSales: 71, totalUnits: 37 },
        { date: "2021-10-15", totalSales: 32, totalUnits: 24 },
        { date: "2021-10-16", totalSales: 12, totalUnits: 33 },
        { date: "2021-10-17", totalSales: 16, totalUnits: 36 },
        { date: "2021-10-18", totalSales: 64, totalUnits: 44 },
        { date: "2021-10-19", totalSales: 17, totalUnits: 31 },
        { date: "2021-10-20", totalSales: 48, totalUnits: 18 },
        { date: "2021-10-21", totalSales: 56, totalUnits: 1 },
        { date: "2021-10-22", totalSales: 24, totalUnits: 45 },
        { date: "2021-10-23", totalSales: 68, totalUnits: 24 },
        { date: "2021-10-24", totalSales: 94, totalUnits: 13 },
        { date: "2021-10-25", totalSales: 65, totalUnits: 34 },
        { date: "2021-10-26", totalSales: 67, totalUnits: 3 },
        { date: "2021-10-27", totalSales: 15, totalUnits: 21 },
        { date: "2021-10-28", totalSales: 58, totalUnits: 32 },
        { date: "2021-10-29", totalSales: 22, totalUnits: 17 },
        { date: "2021-10-30", totalSales: 74, totalUnits: 21 },
        { date: "2021-10-31", totalSales: 44, totalUnits: 40 },
        { date: "2021-11-01", totalSales: 81, totalUnits: 20 },
        { date: "2021-11-02", totalSales: 62, totalUnits: 37 },
        { date: "2021-11-03", totalSales: 75, totalUnits: 6 },
        { date: "2021-11-04", totalSales: 85, totalUnits: 13 },
        { date: "2021-11-05", totalSales: 35, totalUnits: 47 },
        { date: "2021-11-06", totalSales: 21, totalUnits: 50 },
        { date: "2021-11-07", totalSales: 79, totalUnits: 40 },
        { date: "2021-11-08", totalSales: 4, totalUnits: 15 },
        { date: "2021-11-09", totalSales: 62, totalUnits: 33 },
        { date: "2021-11-10", totalSales: 70, totalUnits: 9 },
        { date: "2021-11-11", totalSales: 82, totalUnits: 30 },
        { date: "2021-11-12", totalSales: 93, totalUnits: 36 },
        { date: "2021-11-13", totalSales: 55, totalUnits: 16 },
        { date: "2021-11-14", totalSales: 2, totalUnits: 41 },
        { date: "2021-11-15", totalSales: 46, totalUnits: 16 },
        { date: "2021-11-16", totalSales: 31, totalUnits: 33 },
        { date: "2021-11-17", totalSales: 52, totalUnits: 5 },
      ],
    },
    {
      _id: "6371259df032395b33000198",
      productId: "63701d24f03239867500012c",
      yearlySalesTotal: 4091,
      yearlyTotalSoldUnits: 4832,
      monthlyData: [
        { month: "january", totalSales: 866, totalUnits: 189 },
        { month: "february", totalSales: 35, totalUnits: 104 },
        { month: "march", totalSales: 937, totalUnits: 325 },
        { month: "april", totalSales: 574, totalUnits: 39 },
        { month: "may", totalSales: 239, totalUnits: 304 },
        { month: "june", totalSales: 932, totalUnits: 263 },
        { month: "july", totalSales: 238, totalUnits: 427 },
        { month: "august", totalSales: 658, totalUnits: 447 },
        { month: "september", totalSales: 419, totalUnits: 470 },
        { month: "october", totalSales: 299, totalUnits: 135 },
        { month: "november", totalSales: 415, totalUnits: 396 },
        { month: "december", totalSales: 291, totalUnits: 319 },
      ],
      dailyData: [
        { date: "2021-01-02", totalSales: 30, totalUnits: 22 },
        { date: "2021-01-03", totalSales: 26, totalUnits: 14 },
        { date: "2021-01-04", totalSales: 78, totalUnits: 22 },
        { date: "2021-01-05", totalSales: 93, totalUnits: 35 },
        { date: "2021-01-06", totalSales: 73, totalUnits: 21 },
        { date: "2021-01-07", totalSales: 88, totalUnits: 5 },
        { date: "2021-01-08", totalSales: 25, totalUnits: 18 },
        { date: "2021-01-09", totalSales: 95, totalUnits: 47 },
        { date: "2021-01-10", totalSales: 10, totalUnits: 28 },
        { date: "2021-01-11", totalSales: 86, totalUnits: 31 },
        { date: "2021-01-12", totalSales: 44, totalUnits: 4 },
        { date: "2021-01-13", totalSales: 89, totalUnits: 14 },
        { date: "2021-01-14", totalSales: 9, totalUnits: 44 },
        { date: "2021-01-15", totalSales: 100, totalUnits: 30 },
        { date: "2021-01-16", totalSales: 81, totalUnits: 28 },
        { date: "2021-01-17", totalSales: 53, totalUnits: 35 },
        { date: "2021-01-18", totalSales: 68, totalUnits: 25 },
        { date: "2021-01-19", totalSales: 96, totalUnits: 33 },
        { date: "2021-01-20", totalSales: 63, totalUnits: 32 },
        { date: "2021-01-21", totalSales: 29, totalUnits: 7 },
        { date: "2021-01-22", totalSales: 38, totalUnits: 1 },
        { date: "2021-01-23", totalSales: 68, totalUnits: 46 },
        { date: "2021-01-24", totalSales: 56, totalUnits: 19 },
        { date: "2021-01-25", totalSales: 12, totalUnits: 5 },
        { date: "2021-01-26", totalSales: 23, totalUnits: 24 },
        { date: "2021-01-27", totalSales: 70, totalUnits: 28 },
        { date: "2021-01-28", totalSales: 67, totalUnits: 39 },
        { date: "2021-01-29", totalSales: 89, totalUnits: 4 },
        { date: "2021-01-30", totalSales: 70, totalUnits: 6 },
        { date: "2021-01-31", totalSales: 34, totalUnits: 35 },
        { date: "2021-02-01", totalSales: 51, totalUnits: 39 },
        { date: "2021-02-02", totalSales: 80, totalUnits: 27 },
        { date: "2021-02-03", totalSales: 32, totalUnits: 7 },
        { date: "2021-02-04", totalSales: 68, totalUnits: 17 },
        { date: "2021-02-05", totalSales: 57, totalUnits: 41 },
        { date: "2021-02-06", totalSales: 56, totalUnits: 6 },
        { date: "2021-02-07", totalSales: 25, totalUnits: 37 },
        { date: "2021-02-08", totalSales: 23, totalUnits: 46 },
        { date: "2021-02-09", totalSales: 49, totalUnits: 40 },
        { date: "2021-02-10", totalSales: 17, totalUnits: 27 },
        { date: "2021-02-11", totalSales: 20, totalUnits: 50 },
        { date: "2021-02-12", totalSales: 15, totalUnits: 29 },
        { date: "2021-02-13", totalSales: 95, totalUnits: 40 },
        { date: "2021-02-14", totalSales: 60, totalUnits: 28 },
        { date: "2021-02-15", totalSales: 31, totalUnits: 35 },
        { date: "2021-02-16", totalSales: 51, totalUnits: 49 },
        { date: "2021-02-17", totalSales: 16, totalUnits: 34 },
        { date: "2021-02-18", totalSales: 43, totalUnits: 16 },
        { date: "2021-02-19", totalSales: 70, totalUnits: 36 },
        { date: "2021-02-20", totalSales: 82, totalUnits: 12 },
        { date: "2021-02-21", totalSales: 48, totalUnits: 6 },
        { date: "2021-02-22", totalSales: 32, totalUnits: 6 },
        { date: "2021-02-23", totalSales: 34, totalUnits: 47 },
        { date: "2021-02-24", totalSales: 86, totalUnits: 10 },
        { date: "2021-02-25", totalSales: 11, totalUnits: 10 },
        { date: "2021-02-26", totalSales: 65, totalUnits: 16 },
        { date: "2021-02-27", totalSales: 78, totalUnits: 47 },
        { date: "2021-02-28", totalSales: 83, totalUnits: 5 },
        { date: "2021-03-01", totalSales: 58, totalUnits: 20 },
        { date: "2021-03-02", totalSales: 72, totalUnits: 3 },
        { date: "2021-03-03", totalSales: 59, totalUnits: 22 },
        { date: "2021-03-04", totalSales: 76, totalUnits: 31 },
        { date: "2021-03-05", totalSales: 64, totalUnits: 1 },
        { date: "2021-03-06", totalSales: 6, totalUnits: 48 },
        { date: "2021-03-07", totalSales: 44, totalUnits: 16 },
        { date: "2021-03-08", totalSales: 94, totalUnits: 39 },
        { date: "2021-03-09", totalSales: 28, totalUnits: 15 },
        { date: "2021-03-10", totalSales: 22, totalUnits: 14 },
        { date: "2021-03-11", totalSales: 74, totalUnits: 12 },
        { date: "2021-03-12", totalSales: 71, totalUnits: 15 },
        { date: "2021-03-13", totalSales: 13, totalUnits: 48 },
        { date: "2021-03-14", totalSales: 77, totalUnits: 30 },
        { date: "2021-03-15", totalSales: 11, totalUnits: 21 },
        { date: "2021-03-16", totalSales: 32, totalUnits: 24 },
        { date: "2021-03-17", totalSales: 6, totalUnits: 40 },
        { date: "2021-03-18", totalSales: 69, totalUnits: 20 },
        { date: "2021-03-19", totalSales: 90, totalUnits: 33 },
        { date: "2021-03-20", totalSales: 31, totalUnits: 28 },
        { date: "2021-03-21", totalSales: 100, totalUnits: 42 },
        { date: "2021-03-22", totalSales: 55, totalUnits: 13 },
        { date: "2021-03-23", totalSales: 55, totalUnits: 21 },
        { date: "2021-03-24", totalSales: 37, totalUnits: 32 },
        { date: "2021-03-25", totalSales: 19, totalUnits: 1 },
        { date: "2021-03-26", totalSales: 53, totalUnits: 7 },
        { date: "2021-03-27", totalSales: 46, totalUnits: 31 },
        { date: "2021-03-28", totalSales: 12, totalUnits: 2 },
        { date: "2021-03-29", totalSales: 9, totalUnits: 40 },
        { date: "2021-03-30", totalSales: 69, totalUnits: 38 },
        { date: "2021-03-31", totalSales: 90, totalUnits: 43 },
        { date: "2021-04-01", totalSales: 15, totalUnits: 25 },
        { date: "2021-04-02", totalSales: 32, totalUnits: 35 },
        { date: "2021-04-03", totalSales: 4, totalUnits: 17 },
        { date: "2021-04-04", totalSales: 48, totalUnits: 9 },
        { date: "2021-04-05", totalSales: 71, totalUnits: 25 },
        { date: "2021-04-06", totalSales: 83, totalUnits: 25 },
        { date: "2021-04-07", totalSales: 68, totalUnits: 4 },
        { date: "2021-04-08", totalSales: 16, totalUnits: 39 },
        { date: "2021-04-09", totalSales: 73, totalUnits: 33 },
        { date: "2021-04-10", totalSales: 20, totalUnits: 8 },
        { date: "2021-04-11", totalSales: 31, totalUnits: 21 },
        { date: "2021-04-12", totalSales: 96, totalUnits: 9 },
        { date: "2021-04-13", totalSales: 73, totalUnits: 4 },
        { date: "2021-04-14", totalSales: 67, totalUnits: 18 },
        { date: "2021-04-15", totalSales: 53, totalUnits: 25 },
        { date: "2021-04-16", totalSales: 26, totalUnits: 9 },
        { date: "2021-04-17", totalSales: 12, totalUnits: 36 },
        { date: "2021-04-18", totalSales: 99, totalUnits: 39 },
        { date: "2021-04-19", totalSales: 39, totalUnits: 41 },
        { date: "2021-04-20", totalSales: 83, totalUnits: 24 },
        { date: "2021-04-21", totalSales: 62, totalUnits: 17 },
        { date: "2021-04-22", totalSales: 50, totalUnits: 4 },
        { date: "2021-04-23", totalSales: 71, totalUnits: 42 },
        { date: "2021-04-24", totalSales: 76, totalUnits: 23 },
        { date: "2021-04-25", totalSales: 41, totalUnits: 29 },
        { date: "2021-04-26", totalSales: 100, totalUnits: 47 },
        { date: "2021-04-27", totalSales: 82, totalUnits: 14 },
        { date: "2021-04-28", totalSales: 52, totalUnits: 29 },
        { date: "2021-04-29", totalSales: 39, totalUnits: 23 },
        { date: "2021-04-30", totalSales: 39, totalUnits: 20 },
        { date: "2021-05-01", totalSales: 85, totalUnits: 33 },
        { date: "2021-05-02", totalSales: 60, totalUnits: 23 },
        { date: "2021-05-03", totalSales: 12, totalUnits: 43 },
        { date: "2021-05-04", totalSales: 25, totalUnits: 3 },
        { date: "2021-05-05", totalSales: 74, totalUnits: 34 },
        { date: "2021-05-06", totalSales: 67, totalUnits: 46 },
        { date: "2021-05-07", totalSales: 64, totalUnits: 29 },
        { date: "2021-05-08", totalSales: 7, totalUnits: 27 },
        { date: "2021-05-09", totalSales: 58, totalUnits: 35 },
        { date: "2021-05-10", totalSales: 44, totalUnits: 31 },
        { date: "2021-05-11", totalSales: 11, totalUnits: 24 },
        { date: "2021-05-12", totalSales: 41, totalUnits: 14 },
        { date: "2021-05-13", totalSales: 66, totalUnits: 36 },
        { date: "2021-05-14", totalSales: 48, totalUnits: 42 },
        { date: "2021-05-15", totalSales: 96, totalUnits: 13 },
        { date: "2021-05-16", totalSales: 70, totalUnits: 31 },
        { date: "2021-05-17", totalSales: 82, totalUnits: 21 },
        { date: "2021-05-18", totalSales: 7, totalUnits: 16 },
        { date: "2021-05-19", totalSales: 6, totalUnits: 5 },
        { date: "2021-05-20", totalSales: 94, totalUnits: 20 },
        { date: "2021-05-21", totalSales: 96, totalUnits: 3 },
        { date: "2021-05-22", totalSales: 94, totalUnits: 50 },
        { date: "2021-05-23", totalSales: 66, totalUnits: 25 },
        { date: "2021-05-24", totalSales: 81, totalUnits: 6 },
        { date: "2021-05-25", totalSales: 70, totalUnits: 3 },
        { date: "2021-05-26", totalSales: 44, totalUnits: 16 },
        { date: "2021-05-27", totalSales: 82, totalUnits: 1 },
        { date: "2021-05-28", totalSales: 80, totalUnits: 19 },
        { date: "2021-05-29", totalSales: 50, totalUnits: 45 },
        { date: "2021-05-30", totalSales: 71, totalUnits: 26 },
        { date: "2021-05-31", totalSales: 99, totalUnits: 41 },
        { date: "2021-06-01", totalSales: 97, totalUnits: 38 },
        { date: "2021-06-02", totalSales: 47, totalUnits: 16 },
        { date: "2021-06-03", totalSales: 61, totalUnits: 47 },
        { date: "2021-06-04", totalSales: 41, totalUnits: 36 },
        { date: "2021-06-05", totalSales: 89, totalUnits: 36 },
        { date: "2021-06-06", totalSales: 62, totalUnits: 20 },
        { date: "2021-06-07", totalSales: 14, totalUnits: 1 },
        { date: "2021-06-08", totalSales: 82, totalUnits: 16 },
        { date: "2021-06-09", totalSales: 51, totalUnits: 37 },
        { date: "2021-06-10", totalSales: 15, totalUnits: 45 },
        { date: "2021-06-11", totalSales: 31, totalUnits: 10 },
        { date: "2021-06-12", totalSales: 23, totalUnits: 45 },
        { date: "2021-06-13", totalSales: 92, totalUnits: 26 },
        { date: "2021-06-14", totalSales: 7, totalUnits: 26 },
        { date: "2021-06-15", totalSales: 2, totalUnits: 14 },
        { date: "2021-06-16", totalSales: 93, totalUnits: 29 },
        { date: "2021-06-17", totalSales: 21, totalUnits: 7 },
        { date: "2021-06-18", totalSales: 62, totalUnits: 5 },
        { date: "2021-06-19", totalSales: 76, totalUnits: 27 },
        { date: "2021-06-20", totalSales: 79, totalUnits: 45 },
        { date: "2021-06-21", totalSales: 20, totalUnits: 9 },
        { date: "2021-06-22", totalSales: 71, totalUnits: 2 },
        { date: "2021-06-23", totalSales: 62, totalUnits: 47 },
        { date: "2021-06-24", totalSales: 70, totalUnits: 35 },
        { date: "2021-06-25", totalSales: 64, totalUnits: 14 },
        { date: "2021-06-26", totalSales: 92, totalUnits: 10 },
        { date: "2021-06-27", totalSales: 37, totalUnits: 42 },
        { date: "2021-06-28", totalSales: 19, totalUnits: 46 },
        { date: "2021-06-29", totalSales: 56, totalUnits: 9 },
        { date: "2021-06-30", totalSales: 87, totalUnits: 6 },
        { date: "2021-07-01", totalSales: 89, totalUnits: 31 },
        { date: "2021-07-02", totalSales: 51, totalUnits: 41 },
        { date: "2021-07-03", totalSales: 63, totalUnits: 21 },
        { date: "2021-07-04", totalSales: 77, totalUnits: 29 },
        { date: "2021-07-05", totalSales: 40, totalUnits: 44 },
        { date: "2021-07-06", totalSales: 95, totalUnits: 2 },
        { date: "2021-07-07", totalSales: 84, totalUnits: 14 },
        { date: "2021-07-08", totalSales: 48, totalUnits: 28 },
        { date: "2021-07-09", totalSales: 13, totalUnits: 41 },
        { date: "2021-07-10", totalSales: 96, totalUnits: 19 },
        { date: "2021-07-11", totalSales: 96, totalUnits: 34 },
        { date: "2021-07-12", totalSales: 40, totalUnits: 35 },
        { date: "2021-07-13", totalSales: 10, totalUnits: 1 },
        { date: "2021-07-14", totalSales: 61, totalUnits: 40 },
        { date: "2021-07-15", totalSales: 3, totalUnits: 44 },
        { date: "2021-07-16", totalSales: 91, totalUnits: 17 },
        { date: "2021-07-17", totalSales: 88, totalUnits: 30 },
        { date: "2021-07-18", totalSales: 49, totalUnits: 37 },
        { date: "2021-07-19", totalSales: 32, totalUnits: 25 },
        { date: "2021-07-20", totalSales: 99, totalUnits: 23 },
        { date: "2021-07-21", totalSales: 59, totalUnits: 2 },
        { date: "2021-07-22", totalSales: 13, totalUnits: 42 },
        { date: "2021-07-23", totalSales: 79, totalUnits: 25 },
        { date: "2021-07-24", totalSales: 54, totalUnits: 39 },
        { date: "2021-07-25", totalSales: 88, totalUnits: 32 },
        { date: "2021-07-26", totalSales: 26, totalUnits: 8 },
        { date: "2021-07-27", totalSales: 68, totalUnits: 33 },
        { date: "2021-07-28", totalSales: 37, totalUnits: 39 },
        { date: "2021-07-29", totalSales: 78, totalUnits: 32 },
        { date: "2021-07-30", totalSales: 71, totalUnits: 5 },
        { date: "2021-07-31", totalSales: 100, totalUnits: 5 },
        { date: "2021-08-01", totalSales: 83, totalUnits: 4 },
        { date: "2021-08-02", totalSales: 55, totalUnits: 22 },
        { date: "2021-08-03", totalSales: 13, totalUnits: 27 },
        { date: "2021-08-04", totalSales: 82, totalUnits: 41 },
        { date: "2021-08-05", totalSales: 39, totalUnits: 14 },
        { date: "2021-08-06", totalSales: 95, totalUnits: 3 },
        { date: "2021-08-07", totalSales: 14, totalUnits: 10 },
        { date: "2021-08-08", totalSales: 96, totalUnits: 16 },
        { date: "2021-08-09", totalSales: 81, totalUnits: 21 },
        { date: "2021-08-10", totalSales: 1, totalUnits: 46 },
        { date: "2021-08-11", totalSales: 97, totalUnits: 26 },
        { date: "2021-08-12", totalSales: 81, totalUnits: 42 },
        { date: "2021-08-13", totalSales: 2, totalUnits: 7 },
        { date: "2021-08-14", totalSales: 69, totalUnits: 31 },
        { date: "2021-08-15", totalSales: 34, totalUnits: 30 },
        { date: "2021-08-16", totalSales: 78, totalUnits: 41 },
        { date: "2021-08-17", totalSales: 48, totalUnits: 45 },
        { date: "2021-08-18", totalSales: 96, totalUnits: 17 },
        { date: "2021-08-19", totalSales: 24, totalUnits: 22 },
        { date: "2021-08-20", totalSales: 84, totalUnits: 6 },
        { date: "2021-08-21", totalSales: 18, totalUnits: 36 },
        { date: "2021-08-22", totalSales: 64, totalUnits: 7 },
        { date: "2021-08-23", totalSales: 24, totalUnits: 49 },
        { date: "2021-08-24", totalSales: 59, totalUnits: 17 },
        { date: "2021-08-25", totalSales: 28, totalUnits: 48 },
        { date: "2021-08-26", totalSales: 9, totalUnits: 7 },
        { date: "2021-08-27", totalSales: 20, totalUnits: 27 },
        { date: "2021-08-28", totalSales: 88, totalUnits: 3 },
        { date: "2021-08-29", totalSales: 35, totalUnits: 30 },
        { date: "2021-08-30", totalSales: 23, totalUnits: 41 },
        { date: "2021-08-31", totalSales: 99, totalUnits: 39 },
        { date: "2021-09-01", totalSales: 35, totalUnits: 25 },
        { date: "2021-09-02", totalSales: 84, totalUnits: 16 },
        { date: "2021-09-03", totalSales: 26, totalUnits: 41 },
        { date: "2021-09-04", totalSales: 43, totalUnits: 9 },
        { date: "2021-09-05", totalSales: 83, totalUnits: 13 },
        { date: "2021-09-06", totalSales: 100, totalUnits: 5 },
        { date: "2021-09-07", totalSales: 80, totalUnits: 41 },
        { date: "2021-09-08", totalSales: 1, totalUnits: 7 },
        { date: "2021-09-09", totalSales: 94, totalUnits: 2 },
        { date: "2021-09-10", totalSales: 88, totalUnits: 7 },
        { date: "2021-09-11", totalSales: 40, totalUnits: 50 },
        { date: "2021-09-12", totalSales: 45, totalUnits: 42 },
        { date: "2021-09-13", totalSales: 9, totalUnits: 18 },
        { date: "2021-09-14", totalSales: 13, totalUnits: 2 },
        { date: "2021-09-15", totalSales: 35, totalUnits: 40 },
        { date: "2021-09-16", totalSales: 61, totalUnits: 9 },
        { date: "2021-09-17", totalSales: 28, totalUnits: 3 },
        { date: "2021-09-18", totalSales: 10, totalUnits: 10 },
        { date: "2021-09-19", totalSales: 100, totalUnits: 28 },
        { date: "2021-09-20", totalSales: 68, totalUnits: 18 },
        { date: "2021-09-21", totalSales: 48, totalUnits: 21 },
        { date: "2021-09-22", totalSales: 19, totalUnits: 3 },
        { date: "2021-09-23", totalSales: 89, totalUnits: 48 },
        { date: "2021-09-24", totalSales: 85, totalUnits: 36 },
        { date: "2021-09-25", totalSales: 49, totalUnits: 5 },
        { date: "2021-09-26", totalSales: 28, totalUnits: 33 },
        { date: "2021-09-27", totalSales: 78, totalUnits: 27 },
        { date: "2021-09-28", totalSales: 61, totalUnits: 38 },
        { date: "2021-09-29", totalSales: 24, totalUnits: 35 },
        { date: "2021-09-30", totalSales: 65, totalUnits: 11 },
        { date: "2021-10-01", totalSales: 27, totalUnits: 9 },
        { date: "2021-10-02", totalSales: 76, totalUnits: 8 },
        { date: "2021-10-03", totalSales: 88, totalUnits: 50 },
        { date: "2021-10-04", totalSales: 11, totalUnits: 8 },
        { date: "2021-10-05", totalSales: 100, totalUnits: 29 },
        { date: "2021-10-06", totalSales: 18, totalUnits: 1 },
        { date: "2021-10-07", totalSales: 44, totalUnits: 31 },
        { date: "2021-10-08", totalSales: 75, totalUnits: 42 },
        { date: "2021-10-09", totalSales: 5, totalUnits: 21 },
        { date: "2021-10-10", totalSales: 28, totalUnits: 16 },
        { date: "2021-10-11", totalSales: 15, totalUnits: 17 },
        { date: "2021-10-12", totalSales: 58, totalUnits: 7 },
        { date: "2021-10-13", totalSales: 47, totalUnits: 22 },
        { date: "2021-10-14", totalSales: 42, totalUnits: 44 },
        { date: "2021-10-15", totalSales: 5, totalUnits: 39 },
        { date: "2021-10-16", totalSales: 16, totalUnits: 18 },
        { date: "2021-10-17", totalSales: 13, totalUnits: 42 },
        { date: "2021-10-18", totalSales: 29, totalUnits: 26 },
        { date: "2021-10-19", totalSales: 99, totalUnits: 38 },
        { date: "2021-10-20", totalSales: 60, totalUnits: 33 },
        { date: "2021-10-21", totalSales: 18, totalUnits: 46 },
        { date: "2021-10-22", totalSales: 3, totalUnits: 31 },
        { date: "2021-10-23", totalSales: 74, totalUnits: 15 },
        { date: "2021-10-24", totalSales: 67, totalUnits: 42 },
        { date: "2021-10-25", totalSales: 63, totalUnits: 49 },
        { date: "2021-10-26", totalSales: 54, totalUnits: 48 },
        { date: "2021-10-27", totalSales: 69, totalUnits: 14 },
        { date: "2021-10-28", totalSales: 74, totalUnits: 25 },
        { date: "2021-10-29", totalSales: 75, totalUnits: 36 },
        { date: "2021-10-30", totalSales: 77, totalUnits: 45 },
        { date: "2021-10-31", totalSales: 100, totalUnits: 20 },
        { date: "2021-11-01", totalSales: 95, totalUnits: 25 },
        { date: "2021-11-02", totalSales: 80, totalUnits: 22 },
        { date: "2021-11-03", totalSales: 77, totalUnits: 11 },
        { date: "2021-11-04", totalSales: 94, totalUnits: 14 },
        { date: "2021-11-05", totalSales: 70, totalUnits: 37 },
        { date: "2021-11-06", totalSales: 1, totalUnits: 14 },
        { date: "2021-11-07", totalSales: 94, totalUnits: 47 },
        { date: "2021-11-08", totalSales: 96, totalUnits: 13 },
        { date: "2021-11-09", totalSales: 44, totalUnits: 46 },
        { date: "2021-11-10", totalSales: 6, totalUnits: 12 },
        { date: "2021-11-11", totalSales: 82, totalUnits: 49 },
        { date: "2021-11-12", totalSales: 33, totalUnits: 20 },
        { date: "2021-11-13", totalSales: 53, totalUnits: 15 },
        { date: "2021-11-14", totalSales: 97, totalUnits: 15 },
        { date: "2021-11-15", totalSales: 8, totalUnits: 49 },
        { date: "2021-11-16", totalSales: 61, totalUnits: 43 },
        { date: "2021-11-17", totalSales: 46, totalUnits: 47 },
      ],
    },
    {
      _id: "6371259df03239d591000395",
      productId: "63701d24f03239867500012d",
      yearlySalesTotal: 6435,
      yearlyTotalSoldUnits: 4627,
      monthlyData: [
        { month: "january", totalSales: 558, totalUnits: 206 },
        { month: "february", totalSales: 394, totalUnits: 99 },
        { month: "march", totalSales: 440, totalUnits: 239 },
        { month: "april", totalSales: 676, totalUnits: 223 },
        { month: "may", totalSales: 112, totalUnits: 416 },
        { month: "june", totalSales: 451, totalUnits: 19 },
        { month: "july", totalSales: 1000, totalUnits: 346 },
        { month: "august", totalSales: 798, totalUnits: 441 },
        { month: "september", totalSales: 652, totalUnits: 340 },
        { month: "october", totalSales: 816, totalUnits: 164 },
        { month: "november", totalSales: 874, totalUnits: 163 },
        { month: "december", totalSales: 230, totalUnits: 146 },
      ],
      dailyData: [
        { date: "2021-01-02", totalSales: 1, totalUnits: 9 },
        { date: "2021-01-03", totalSales: 91, totalUnits: 5 },
        { date: "2021-01-04", totalSales: 94, totalUnits: 12 },
        { date: "2021-01-05", totalSales: 82, totalUnits: 42 },
        { date: "2021-01-06", totalSales: 94, totalUnits: 19 },
        { date: "2021-01-07", totalSales: 2, totalUnits: 2 },
        { date: "2021-01-08", totalSales: 3, totalUnits: 2 },
        { date: "2021-01-09", totalSales: 13, totalUnits: 20 },
        { date: "2021-01-10", totalSales: 90, totalUnits: 33 },
        { date: "2021-01-11", totalSales: 30, totalUnits: 11 },
        { date: "2021-01-12", totalSales: 96, totalUnits: 2 },
        { date: "2021-01-13", totalSales: 73, totalUnits: 16 },
        { date: "2021-01-14", totalSales: 87, totalUnits: 19 },
        { date: "2021-01-15", totalSales: 55, totalUnits: 12 },
        { date: "2021-01-16", totalSales: 25, totalUnits: 34 },
        { date: "2021-01-17", totalSales: 45, totalUnits: 32 },
        { date: "2021-01-18", totalSales: 80, totalUnits: 33 },
        { date: "2021-01-19", totalSales: 37, totalUnits: 39 },
        { date: "2021-01-20", totalSales: 37, totalUnits: 46 },
        { date: "2021-01-21", totalSales: 1, totalUnits: 42 },
        { date: "2021-01-22", totalSales: 85, totalUnits: 38 },
        { date: "2021-01-23", totalSales: 71, totalUnits: 1 },
        { date: "2021-01-24", totalSales: 83, totalUnits: 27 },
        { date: "2021-01-25", totalSales: 53, totalUnits: 48 },
        { date: "2021-01-26", totalSales: 51, totalUnits: 15 },
        { date: "2021-01-27", totalSales: 8, totalUnits: 49 },
        { date: "2021-01-28", totalSales: 7, totalUnits: 22 },
        { date: "2021-01-29", totalSales: 55, totalUnits: 3 },
        { date: "2021-01-30", totalSales: 7, totalUnits: 40 },
        { date: "2021-01-31", totalSales: 17, totalUnits: 46 },
        { date: "2021-02-01", totalSales: 16, totalUnits: 2 },
        { date: "2021-02-02", totalSales: 90, totalUnits: 32 },
        { date: "2021-02-03", totalSales: 66, totalUnits: 2 },
        { date: "2021-02-04", totalSales: 14, totalUnits: 21 },
        { date: "2021-02-05", totalSales: 47, totalUnits: 33 },
        { date: "2021-02-06", totalSales: 8, totalUnits: 2 },
        { date: "2021-02-07", totalSales: 7, totalUnits: 46 },
        { date: "2021-02-08", totalSales: 28, totalUnits: 33 },
        { date: "2021-02-09", totalSales: 32, totalUnits: 21 },
        { date: "2021-02-10", totalSales: 27, totalUnits: 21 },
        { date: "2021-02-11", totalSales: 84, totalUnits: 47 },
        { date: "2021-02-12", totalSales: 76, totalUnits: 36 },
        { date: "2021-02-13", totalSales: 33, totalUnits: 15 },
        { date: "2021-02-14", totalSales: 51, totalUnits: 11 },
        { date: "2021-02-15", totalSales: 24, totalUnits: 25 },
        { date: "2021-02-16", totalSales: 100, totalUnits: 21 },
        { date: "2021-02-17", totalSales: 76, totalUnits: 20 },
        { date: "2021-02-18", totalSales: 64, totalUnits: 3 },
        { date: "2021-02-19", totalSales: 18, totalUnits: 34 },
        { date: "2021-02-20", totalSales: 63, totalUnits: 24 },
        { date: "2021-02-21", totalSales: 18, totalUnits: 29 },
        { date: "2021-02-22", totalSales: 69, totalUnits: 29 },
        { date: "2021-02-23", totalSales: 94, totalUnits: 44 },
        { date: "2021-02-24", totalSales: 57, totalUnits: 17 },
        { date: "2021-02-25", totalSales: 43, totalUnits: 10 },
        { date: "2021-02-26", totalSales: 86, totalUnits: 2 },
        { date: "2021-02-27", totalSales: 6, totalUnits: 25 },
        { date: "2021-02-28", totalSales: 56, totalUnits: 5 },
        { date: "2021-03-01", totalSales: 67, totalUnits: 34 },
        { date: "2021-03-02", totalSales: 97, totalUnits: 34 },
        { date: "2021-03-03", totalSales: 56, totalUnits: 22 },
        { date: "2021-03-04", totalSales: 90, totalUnits: 13 },
        { date: "2021-03-05", totalSales: 17, totalUnits: 47 },
        { date: "2021-03-06", totalSales: 24, totalUnits: 3 },
        { date: "2021-03-07", totalSales: 39, totalUnits: 34 },
        { date: "2021-03-08", totalSales: 8, totalUnits: 27 },
        { date: "2021-03-09", totalSales: 96, totalUnits: 45 },
        { date: "2021-03-10", totalSales: 99, totalUnits: 12 },
        { date: "2021-03-11", totalSales: 38, totalUnits: 1 },
        { date: "2021-03-12", totalSales: 94, totalUnits: 18 },
        { date: "2021-03-13", totalSales: 25, totalUnits: 47 },
        { date: "2021-03-14", totalSales: 69, totalUnits: 48 },
        { date: "2021-03-15", totalSales: 59, totalUnits: 40 },
        { date: "2021-03-16", totalSales: 50, totalUnits: 39 },
        { date: "2021-03-17", totalSales: 18, totalUnits: 20 },
        { date: "2021-03-18", totalSales: 63, totalUnits: 2 },
        { date: "2021-03-19", totalSales: 25, totalUnits: 43 },
        { date: "2021-03-20", totalSales: 19, totalUnits: 21 },
        { date: "2021-03-21", totalSales: 44, totalUnits: 29 },
        { date: "2021-03-22", totalSales: 91, totalUnits: 17 },
        { date: "2021-03-23", totalSales: 51, totalUnits: 7 },
        { date: "2021-03-24", totalSales: 93, totalUnits: 13 },
        { date: "2021-03-25", totalSales: 68, totalUnits: 4 },
        { date: "2021-03-26", totalSales: 31, totalUnits: 1 },
        { date: "2021-03-27", totalSales: 93, totalUnits: 22 },
        { date: "2021-03-28", totalSales: 20, totalUnits: 10 },
        { date: "2021-03-29", totalSales: 51, totalUnits: 8 },
        { date: "2021-03-30", totalSales: 40, totalUnits: 50 },
        { date: "2021-03-31", totalSales: 71, totalUnits: 19 },
        { date: "2021-04-01", totalSales: 79, totalUnits: 21 },
        { date: "2021-04-02", totalSales: 43, totalUnits: 6 },
        { date: "2021-04-03", totalSales: 19, totalUnits: 29 },
        { date: "2021-04-04", totalSales: 47, totalUnits: 15 },
        { date: "2021-04-05", totalSales: 98, totalUnits: 26 },
        { date: "2021-04-06", totalSales: 90, totalUnits: 37 },
        { date: "2021-04-07", totalSales: 18, totalUnits: 1 },
        { date: "2021-04-08", totalSales: 75, totalUnits: 37 },
        { date: "2021-04-09", totalSales: 99, totalUnits: 18 },
        { date: "2021-04-10", totalSales: 62, totalUnits: 23 },
        { date: "2021-04-11", totalSales: 70, totalUnits: 42 },
        { date: "2021-04-12", totalSales: 8, totalUnits: 48 },
        { date: "2021-04-13", totalSales: 29, totalUnits: 2 },
        { date: "2021-04-14", totalSales: 64, totalUnits: 6 },
        { date: "2021-04-15", totalSales: 84, totalUnits: 33 },
        { date: "2021-04-16", totalSales: 28, totalUnits: 20 },
        { date: "2021-04-17", totalSales: 3, totalUnits: 7 },
        { date: "2021-04-18", totalSales: 32, totalUnits: 26 },
        { date: "2021-04-19", totalSales: 89, totalUnits: 34 },
        { date: "2021-04-20", totalSales: 27, totalUnits: 47 },
        { date: "2021-04-21", totalSales: 13, totalUnits: 36 },
        { date: "2021-04-22", totalSales: 67, totalUnits: 48 },
        { date: "2021-04-23", totalSales: 37, totalUnits: 35 },
        { date: "2021-04-24", totalSales: 70, totalUnits: 34 },
        { date: "2021-04-25", totalSales: 94, totalUnits: 12 },
        { date: "2021-04-26", totalSales: 45, totalUnits: 18 },
        { date: "2021-04-27", totalSales: 4, totalUnits: 20 },
        { date: "2021-04-28", totalSales: 67, totalUnits: 12 },
        { date: "2021-04-29", totalSales: 34, totalUnits: 22 },
        { date: "2021-04-30", totalSales: 63, totalUnits: 30 },
        { date: "2021-05-01", totalSales: 14, totalUnits: 20 },
        { date: "2021-05-02", totalSales: 3, totalUnits: 47 },
        { date: "2021-05-03", totalSales: 87, totalUnits: 17 },
        { date: "2021-05-04", totalSales: 26, totalUnits: 49 },
        { date: "2021-05-05", totalSales: 82, totalUnits: 19 },
        { date: "2021-05-06", totalSales: 8, totalUnits: 42 },
        { date: "2021-05-07", totalSales: 34, totalUnits: 24 },
        { date: "2021-05-08", totalSales: 92, totalUnits: 38 },
        { date: "2021-05-09", totalSales: 23, totalUnits: 18 },
        { date: "2021-05-10", totalSales: 12, totalUnits: 25 },
        { date: "2021-05-11", totalSales: 77, totalUnits: 30 },
        { date: "2021-05-12", totalSales: 17, totalUnits: 34 },
        { date: "2021-05-13", totalSales: 71, totalUnits: 27 },
        { date: "2021-05-14", totalSales: 26, totalUnits: 28 },
        { date: "2021-05-15", totalSales: 34, totalUnits: 18 },
        { date: "2021-05-16", totalSales: 72, totalUnits: 49 },
        { date: "2021-05-17", totalSales: 20, totalUnits: 24 },
        { date: "2021-05-18", totalSales: 42, totalUnits: 9 },
        { date: "2021-05-19", totalSales: 34, totalUnits: 7 },
        { date: "2021-05-20", totalSales: 66, totalUnits: 28 },
        { date: "2021-05-21", totalSales: 38, totalUnits: 28 },
        { date: "2021-05-22", totalSales: 44, totalUnits: 12 },
        { date: "2021-05-23", totalSales: 17, totalUnits: 22 },
        { date: "2021-05-24", totalSales: 6, totalUnits: 2 },
        { date: "2021-05-25", totalSales: 8, totalUnits: 17 },
        { date: "2021-05-26", totalSales: 51, totalUnits: 21 },
        { date: "2021-05-27", totalSales: 14, totalUnits: 1 },
        { date: "2021-05-28", totalSales: 2, totalUnits: 20 },
        { date: "2021-05-29", totalSales: 9, totalUnits: 1 },
        { date: "2021-05-30", totalSales: 26, totalUnits: 10 },
        { date: "2021-05-31", totalSales: 18, totalUnits: 5 },
        { date: "2021-06-01", totalSales: 36, totalUnits: 49 },
        { date: "2021-06-02", totalSales: 37, totalUnits: 24 },
        { date: "2021-06-03", totalSales: 32, totalUnits: 27 },
        { date: "2021-06-04", totalSales: 52, totalUnits: 9 },
        { date: "2021-06-05", totalSales: 2, totalUnits: 30 },
        { date: "2021-06-06", totalSales: 89, totalUnits: 28 },
        { date: "2021-06-07", totalSales: 6, totalUnits: 49 },
        { date: "2021-06-08", totalSales: 87, totalUnits: 49 },
        { date: "2021-06-09", totalSales: 38, totalUnits: 44 },
        { date: "2021-06-10", totalSales: 27, totalUnits: 31 },
        { date: "2021-06-11", totalSales: 55, totalUnits: 31 },
        { date: "2021-06-12", totalSales: 38, totalUnits: 23 },
        { date: "2021-06-13", totalSales: 58, totalUnits: 33 },
        { date: "2021-06-14", totalSales: 11, totalUnits: 8 },
        { date: "2021-06-15", totalSales: 24, totalUnits: 49 },
        { date: "2021-06-16", totalSales: 25, totalUnits: 13 },
        { date: "2021-06-17", totalSales: 57, totalUnits: 27 },
        { date: "2021-06-18", totalSales: 47, totalUnits: 19 },
        { date: "2021-06-19", totalSales: 35, totalUnits: 21 },
        { date: "2021-06-20", totalSales: 66, totalUnits: 34 },
        { date: "2021-06-21", totalSales: 21, totalUnits: 18 },
        { date: "2021-06-22", totalSales: 85, totalUnits: 5 },
        { date: "2021-06-23", totalSales: 98, totalUnits: 34 },
        { date: "2021-06-24", totalSales: 12, totalUnits: 44 },
        { date: "2021-06-25", totalSales: 28, totalUnits: 15 },
        { date: "2021-06-26", totalSales: 63, totalUnits: 43 },
        { date: "2021-06-27", totalSales: 8, totalUnits: 30 },
        { date: "2021-06-28", totalSales: 57, totalUnits: 27 },
        { date: "2021-06-29", totalSales: 30, totalUnits: 18 },
        { date: "2021-06-30", totalSales: 6, totalUnits: 44 },
        { date: "2021-07-01", totalSales: 86, totalUnits: 16 },
        { date: "2021-07-02", totalSales: 84, totalUnits: 36 },
        { date: "2021-07-03", totalSales: 71, totalUnits: 10 },
        { date: "2021-07-04", totalSales: 72, totalUnits: 40 },
        { date: "2021-07-05", totalSales: 96, totalUnits: 28 },
        { date: "2021-07-06", totalSales: 45, totalUnits: 23 },
        { date: "2021-07-07", totalSales: 21, totalUnits: 29 },
        { date: "2021-07-08", totalSales: 46, totalUnits: 22 },
        { date: "2021-07-09", totalSales: 45, totalUnits: 49 },
        { date: "2021-07-10", totalSales: 5, totalUnits: 6 },
        { date: "2021-07-11", totalSales: 58, totalUnits: 50 },
        { date: "2021-07-12", totalSales: 8, totalUnits: 13 },
        { date: "2021-07-13", totalSales: 80, totalUnits: 2 },
        { date: "2021-07-14", totalSales: 36, totalUnits: 16 },
        { date: "2021-07-15", totalSales: 19, totalUnits: 19 },
        { date: "2021-07-16", totalSales: 56, totalUnits: 30 },
        { date: "2021-07-17", totalSales: 2, totalUnits: 18 },
        { date: "2021-07-18", totalSales: 28, totalUnits: 29 },
        { date: "2021-07-19", totalSales: 39, totalUnits: 29 },
        { date: "2021-07-20", totalSales: 8, totalUnits: 37 },
        { date: "2021-07-21", totalSales: 71, totalUnits: 42 },
        { date: "2021-07-22", totalSales: 21, totalUnits: 27 },
        { date: "2021-07-23", totalSales: 56, totalUnits: 18 },
        { date: "2021-07-24", totalSales: 8, totalUnits: 43 },
        { date: "2021-07-25", totalSales: 27, totalUnits: 1 },
        { date: "2021-07-26", totalSales: 2, totalUnits: 14 },
        { date: "2021-07-27", totalSales: 68, totalUnits: 37 },
        { date: "2021-07-28", totalSales: 50, totalUnits: 30 },
        { date: "2021-07-29", totalSales: 96, totalUnits: 31 },
        { date: "2021-07-30", totalSales: 99, totalUnits: 37 },
        { date: "2021-07-31", totalSales: 53, totalUnits: 42 },
        { date: "2021-08-01", totalSales: 43, totalUnits: 42 },
        { date: "2021-08-02", totalSales: 76, totalUnits: 30 },
        { date: "2021-08-03", totalSales: 93, totalUnits: 1 },
        { date: "2021-08-04", totalSales: 76, totalUnits: 11 },
        { date: "2021-08-05", totalSales: 38, totalUnits: 34 },
        { date: "2021-08-06", totalSales: 86, totalUnits: 3 },
        { date: "2021-08-07", totalSales: 46, totalUnits: 27 },
        { date: "2021-08-08", totalSales: 99, totalUnits: 21 },
        { date: "2021-08-09", totalSales: 35, totalUnits: 30 },
        { date: "2021-08-10", totalSales: 17, totalUnits: 45 },
        { date: "2021-08-11", totalSales: 85, totalUnits: 48 },
        { date: "2021-08-12", totalSales: 10, totalUnits: 29 },
        { date: "2021-08-13", totalSales: 98, totalUnits: 29 },
        { date: "2021-08-14", totalSales: 41, totalUnits: 25 },
        { date: "2021-08-15", totalSales: 39, totalUnits: 26 },
        { date: "2021-08-16", totalSales: 29, totalUnits: 28 },
        { date: "2021-08-17", totalSales: 37, totalUnits: 1 },
        { date: "2021-08-18", totalSales: 2, totalUnits: 11 },
        { date: "2021-08-19", totalSales: 90, totalUnits: 25 },
        { date: "2021-08-20", totalSales: 85, totalUnits: 23 },
        { date: "2021-08-21", totalSales: 19, totalUnits: 7 },
        { date: "2021-08-22", totalSales: 99, totalUnits: 27 },
        { date: "2021-08-23", totalSales: 54, totalUnits: 41 },
        { date: "2021-08-24", totalSales: 62, totalUnits: 24 },
        { date: "2021-08-25", totalSales: 44, totalUnits: 14 },
        { date: "2021-08-26", totalSales: 57, totalUnits: 18 },
        { date: "2021-08-27", totalSales: 14, totalUnits: 21 },
        { date: "2021-08-28", totalSales: 61, totalUnits: 11 },
        { date: "2021-08-29", totalSales: 47, totalUnits: 12 },
        { date: "2021-08-30", totalSales: 37, totalUnits: 39 },
        { date: "2021-08-31", totalSales: 27, totalUnits: 37 },
        { date: "2021-09-01", totalSales: 37, totalUnits: 48 },
        { date: "2021-09-02", totalSales: 72, totalUnits: 9 },
        { date: "2021-09-03", totalSales: 74, totalUnits: 13 },
        { date: "2021-09-04", totalSales: 64, totalUnits: 49 },
        { date: "2021-09-05", totalSales: 30, totalUnits: 19 },
        { date: "2021-09-06", totalSales: 80, totalUnits: 18 },
        { date: "2021-09-07", totalSales: 95, totalUnits: 33 },
        { date: "2021-09-08", totalSales: 24, totalUnits: 31 },
        { date: "2021-09-09", totalSales: 4, totalUnits: 10 },
        { date: "2021-09-10", totalSales: 91, totalUnits: 7 },
        { date: "2021-09-11", totalSales: 48, totalUnits: 1 },
        { date: "2021-09-12", totalSales: 34, totalUnits: 50 },
        { date: "2021-09-13", totalSales: 19, totalUnits: 2 },
        { date: "2021-09-14", totalSales: 31, totalUnits: 48 },
        { date: "2021-09-15", totalSales: 26, totalUnits: 18 },
        { date: "2021-09-16", totalSales: 36, totalUnits: 49 },
        { date: "2021-09-17", totalSales: 6, totalUnits: 7 },
        { date: "2021-09-18", totalSales: 31, totalUnits: 34 },
        { date: "2021-09-19", totalSales: 3, totalUnits: 3 },
        { date: "2021-09-20", totalSales: 21, totalUnits: 18 },
        { date: "2021-09-21", totalSales: 54, totalUnits: 48 },
        { date: "2021-09-22", totalSales: 89, totalUnits: 32 },
        { date: "2021-09-23", totalSales: 98, totalUnits: 37 },
        { date: "2021-09-24", totalSales: 57, totalUnits: 40 },
        { date: "2021-09-25", totalSales: 48, totalUnits: 4 },
        { date: "2021-09-26", totalSales: 93, totalUnits: 16 },
        { date: "2021-09-27", totalSales: 71, totalUnits: 31 },
        { date: "2021-09-28", totalSales: 98, totalUnits: 19 },
        { date: "2021-09-29", totalSales: 51, totalUnits: 41 },
        { date: "2021-09-30", totalSales: 83, totalUnits: 13 },
        { date: "2021-10-01", totalSales: 59, totalUnits: 20 },
        { date: "2021-10-02", totalSales: 89, totalUnits: 33 },
        { date: "2021-10-03", totalSales: 81, totalUnits: 8 },
        { date: "2021-10-04", totalSales: 85, totalUnits: 36 },
        { date: "2021-10-05", totalSales: 40, totalUnits: 38 },
        { date: "2021-10-06", totalSales: 69, totalUnits: 24 },
        { date: "2021-10-07", totalSales: 60, totalUnits: 14 },
        { date: "2021-10-08", totalSales: 50, totalUnits: 13 },
        { date: "2021-10-09", totalSales: 15, totalUnits: 40 },
        { date: "2021-10-10", totalSales: 24, totalUnits: 9 },
        { date: "2021-10-11", totalSales: 58, totalUnits: 17 },
        { date: "2021-10-12", totalSales: 6, totalUnits: 50 },
        { date: "2021-10-13", totalSales: 20, totalUnits: 50 },
        { date: "2021-10-14", totalSales: 44, totalUnits: 40 },
        { date: "2021-10-15", totalSales: 71, totalUnits: 40 },
        { date: "2021-10-16", totalSales: 29, totalUnits: 35 },
        { date: "2021-10-17", totalSales: 95, totalUnits: 34 },
        { date: "2021-10-18", totalSales: 78, totalUnits: 35 },
        { date: "2021-10-19", totalSales: 71, totalUnits: 21 },
        { date: "2021-10-20", totalSales: 68, totalUnits: 15 },
        { date: "2021-10-21", totalSales: 23, totalUnits: 27 },
        { date: "2021-10-22", totalSales: 2, totalUnits: 45 },
        { date: "2021-10-23", totalSales: 14, totalUnits: 32 },
        { date: "2021-10-24", totalSales: 54, totalUnits: 12 },
        { date: "2021-10-25", totalSales: 90, totalUnits: 21 },
        { date: "2021-10-26", totalSales: 58, totalUnits: 28 },
        { date: "2021-10-27", totalSales: 11, totalUnits: 49 },
        { date: "2021-10-28", totalSales: 61, totalUnits: 47 },
        { date: "2021-10-29", totalSales: 60, totalUnits: 3 },
        { date: "2021-10-30", totalSales: 65, totalUnits: 12 },
        { date: "2021-10-31", totalSales: 91, totalUnits: 15 },
        { date: "2021-11-01", totalSales: 15, totalUnits: 4 },
        { date: "2021-11-02", totalSales: 39, totalUnits: 45 },
        { date: "2021-11-03", totalSales: 55, totalUnits: 50 },
        { date: "2021-11-04", totalSales: 33, totalUnits: 43 },
        { date: "2021-11-05", totalSales: 93, totalUnits: 48 },
        { date: "2021-11-06", totalSales: 53, totalUnits: 34 },
        { date: "2021-11-07", totalSales: 89, totalUnits: 40 },
        { date: "2021-11-08", totalSales: 19, totalUnits: 22 },
        { date: "2021-11-09", totalSales: 49, totalUnits: 15 },
        { date: "2021-11-10", totalSales: 55, totalUnits: 43 },
        { date: "2021-11-11", totalSales: 60, totalUnits: 27 },
        { date: "2021-11-12", totalSales: 70, totalUnits: 9 },
        { date: "2021-11-13", totalSales: 65, totalUnits: 43 },
        { date: "2021-11-14", totalSales: 56, totalUnits: 31 },
        { date: "2021-11-15", totalSales: 95, totalUnits: 6 },
        { date: "2021-11-16", totalSales: 47, totalUnits: 10 },
        { date: "2021-11-17", totalSales: 73, totalUnits: 20 },
      ],
    },
    {
      _id: "6371259df032395694000083",
      productId: "63701d24f03239b7f7000015",
      yearlySalesTotal: 3309,
      yearlyTotalSoldUnits: 2331,
      monthlyData: [
        { month: "january", totalSales: 118, totalUnits: 317 },
        { month: "february", totalSales: 47, totalUnits: 181 },
        { month: "march", totalSales: 810, totalUnits: 498 },
        { month: "april", totalSales: 230, totalUnits: 455 },
        { month: "may", totalSales: 353, totalUnits: 15 },
        { month: "june", totalSales: 799, totalUnits: 409 },
        { month: "july", totalSales: 56, totalUnits: 440 },
        { month: "august", totalSales: 158, totalUnits: 90 },
        { month: "september", totalSales: 459, totalUnits: 374 },
        { month: "october", totalSales: 162, totalUnits: 169 },
        { month: "november", totalSales: 102, totalUnits: 74 },
        { month: "december", totalSales: 338, totalUnits: 129 },
      ],
      dailyData: [
        { date: "2021-01-02", totalSales: 17, totalUnits: 33 },
        { date: "2021-01-03", totalSales: 51, totalUnits: 18 },
        { date: "2021-01-04", totalSales: 52, totalUnits: 46 },
        { date: "2021-01-05", totalSales: 44, totalUnits: 11 },
        { date: "2021-01-06", totalSales: 83, totalUnits: 9 },
        { date: "2021-01-07", totalSales: 85, totalUnits: 5 },
        { date: "2021-01-08", totalSales: 67, totalUnits: 5 },
        { date: "2021-01-09", totalSales: 41, totalUnits: 8 },
        { date: "2021-01-10", totalSales: 63, totalUnits: 45 },
        { date: "2021-01-11", totalSales: 14, totalUnits: 11 },
        { date: "2021-01-12", totalSales: 67, totalUnits: 48 },
        { date: "2021-01-13", totalSales: 47, totalUnits: 7 },
        { date: "2021-01-14", totalSales: 99, totalUnits: 46 },
        { date: "2021-01-15", totalSales: 5, totalUnits: 3 },
        { date: "2021-01-16", totalSales: 75, totalUnits: 43 },
        { date: "2021-01-17", totalSales: 26, totalUnits: 9 },
        { date: "2021-01-18", totalSales: 17, totalUnits: 49 },
        { date: "2021-01-19", totalSales: 19, totalUnits: 22 },
        { date: "2021-01-20", totalSales: 78, totalUnits: 35 },
        { date: "2021-01-21", totalSales: 53, totalUnits: 1 },
        { date: "2021-01-22", totalSales: 23, totalUnits: 21 },
        { date: "2021-01-23", totalSales: 36, totalUnits: 7 },
        { date: "2021-01-24", totalSales: 75, totalUnits: 5 },
        { date: "2021-01-25", totalSales: 90, totalUnits: 2 },
        { date: "2021-01-26", totalSales: 27, totalUnits: 27 },
        { date: "2021-01-27", totalSales: 67, totalUnits: 45 },
        { date: "2021-01-28", totalSales: 38, totalUnits: 36 },
        { date: "2021-01-29", totalSales: 63, totalUnits: 38 },
        { date: "2021-01-30", totalSales: 60, totalUnits: 39 },
        { date: "2021-01-31", totalSales: 4, totalUnits: 45 },
        { date: "2021-02-01", totalSales: 71, totalUnits: 1 },
        { date: "2021-02-02", totalSales: 60, totalUnits: 49 },
        { date: "2021-02-03", totalSales: 91, totalUnits: 33 },
        { date: "2021-02-04", totalSales: 26, totalUnits: 38 },
        { date: "2021-02-05", totalSales: 39, totalUnits: 25 },
        { date: "2021-02-06", totalSales: 1, totalUnits: 25 },
        { date: "2021-02-07", totalSales: 97, totalUnits: 37 },
        { date: "2021-02-08", totalSales: 54, totalUnits: 48 },
        { date: "2021-02-09", totalSales: 46, totalUnits: 45 },
        { date: "2021-02-10", totalSales: 83, totalUnits: 31 },
        { date: "2021-02-11", totalSales: 58, totalUnits: 26 },
        { date: "2021-02-12", totalSales: 16, totalUnits: 21 },
        { date: "2021-02-13", totalSales: 96, totalUnits: 4 },
        { date: "2021-02-14", totalSales: 17, totalUnits: 34 },
        { date: "2021-02-15", totalSales: 59, totalUnits: 3 },
        { date: "2021-02-16", totalSales: 16, totalUnits: 24 },
        { date: "2021-02-17", totalSales: 24, totalUnits: 36 },
        { date: "2021-02-18", totalSales: 51, totalUnits: 27 },
        { date: "2021-02-19", totalSales: 32, totalUnits: 4 },
        { date: "2021-02-20", totalSales: 69, totalUnits: 42 },
        { date: "2021-02-21", totalSales: 40, totalUnits: 45 },
        { date: "2021-02-22", totalSales: 68, totalUnits: 43 },
        { date: "2021-02-23", totalSales: 89, totalUnits: 24 },
        { date: "2021-02-24", totalSales: 8, totalUnits: 2 },
        { date: "2021-02-25", totalSales: 91, totalUnits: 11 },
        { date: "2021-02-26", totalSales: 10, totalUnits: 47 },
        { date: "2021-02-27", totalSales: 41, totalUnits: 44 },
        { date: "2021-02-28", totalSales: 23, totalUnits: 6 },
        { date: "2021-03-01", totalSales: 39, totalUnits: 9 },
        { date: "2021-03-02", totalSales: 32, totalUnits: 2 },
        { date: "2021-03-03", totalSales: 47, totalUnits: 48 },
        { date: "2021-03-04", totalSales: 45, totalUnits: 31 },
        { date: "2021-03-05", totalSales: 77, totalUnits: 20 },
        { date: "2021-03-06", totalSales: 33, totalUnits: 48 },
        { date: "2021-03-07", totalSales: 33, totalUnits: 15 },
        { date: "2021-03-08", totalSales: 69, totalUnits: 30 },
        { date: "2021-03-09", totalSales: 48, totalUnits: 39 },
        { date: "2021-03-10", totalSales: 74, totalUnits: 45 },
        { date: "2021-03-11", totalSales: 3, totalUnits: 30 },
        { date: "2021-03-12", totalSales: 92, totalUnits: 10 },
        { date: "2021-03-13", totalSales: 40, totalUnits: 24 },
        { date: "2021-03-14", totalSales: 91, totalUnits: 26 },
        { date: "2021-03-15", totalSales: 33, totalUnits: 10 },
        { date: "2021-03-16", totalSales: 68, totalUnits: 44 },
        { date: "2021-03-17", totalSales: 78, totalUnits: 48 },
        { date: "2021-03-18", totalSales: 100, totalUnits: 50 },
        { date: "2021-03-19", totalSales: 78, totalUnits: 39 },
        { date: "2021-03-20", totalSales: 56, totalUnits: 9 },
        { date: "2021-03-21", totalSales: 62, totalUnits: 18 },
        { date: "2021-03-22", totalSales: 56, totalUnits: 24 },
        { date: "2021-03-23", totalSales: 14, totalUnits: 16 },
        { date: "2021-03-24", totalSales: 99, totalUnits: 29 },
        { date: "2021-03-25", totalSales: 98, totalUnits: 40 },
        { date: "2021-03-26", totalSales: 99, totalUnits: 39 },
        { date: "2021-03-27", totalSales: 26, totalUnits: 18 },
        { date: "2021-03-28", totalSales: 53, totalUnits: 39 },
        { date: "2021-03-29", totalSales: 58, totalUnits: 37 },
        { date: "2021-03-30", totalSales: 14, totalUnits: 37 },
        { date: "2021-03-31", totalSales: 86, totalUnits: 29 },
        { date: "2021-04-01", totalSales: 49, totalUnits: 14 },
        { date: "2021-04-02", totalSales: 26, totalUnits: 39 },
        { date: "2021-04-03", totalSales: 54, totalUnits: 12 },
        { date: "2021-04-04", totalSales: 77, totalUnits: 4 },
        { date: "2021-04-05", totalSales: 66, totalUnits: 3 },
        { date: "2021-04-06", totalSales: 50, totalUnits: 27 },
        { date: "2021-04-07", totalSales: 21, totalUnits: 21 },
        { date: "2021-04-08", totalSales: 3, totalUnits: 27 },
        { date: "2021-04-09", totalSales: 20, totalUnits: 49 },
        { date: "2021-04-10", totalSales: 63, totalUnits: 6 },
        { date: "2021-04-11", totalSales: 24, totalUnits: 37 },
        { date: "2021-04-12", totalSales: 50, totalUnits: 30 },
        { date: "2021-04-13", totalSales: 100, totalUnits: 47 },
        { date: "2021-04-14", totalSales: 71, totalUnits: 19 },
        { date: "2021-04-15", totalSales: 57, totalUnits: 33 },
        { date: "2021-04-16", totalSales: 59, totalUnits: 33 },
        { date: "2021-04-17", totalSales: 49, totalUnits: 20 },
        { date: "2021-04-18", totalSales: 77, totalUnits: 48 },
        { date: "2021-04-19", totalSales: 49, totalUnits: 29 },
        { date: "2021-04-20", totalSales: 6, totalUnits: 29 },
        { date: "2021-04-21", totalSales: 17, totalUnits: 22 },
        { date: "2021-04-22", totalSales: 67, totalUnits: 30 },
        { date: "2021-04-23", totalSales: 46, totalUnits: 43 },
        { date: "2021-04-24", totalSales: 98, totalUnits: 46 },
        { date: "2021-04-25", totalSales: 29, totalUnits: 11 },
        { date: "2021-04-26", totalSales: 23, totalUnits: 36 },
        { date: "2021-04-27", totalSales: 9, totalUnits: 9 },
        { date: "2021-04-28", totalSales: 5, totalUnits: 45 },
        { date: "2021-04-29", totalSales: 20, totalUnits: 13 },
        { date: "2021-04-30", totalSales: 30, totalUnits: 30 },
        { date: "2021-05-01", totalSales: 31, totalUnits: 24 },
        { date: "2021-05-02", totalSales: 89, totalUnits: 30 },
        { date: "2021-05-03", totalSales: 16, totalUnits: 42 },
        { date: "2021-05-04", totalSales: 100, totalUnits: 29 },
        { date: "2021-05-05", totalSales: 26, totalUnits: 25 },
        { date: "2021-05-06", totalSales: 19, totalUnits: 13 },
        { date: "2021-05-07", totalSales: 78, totalUnits: 33 },
        { date: "2021-05-08", totalSales: 84, totalUnits: 38 },
        { date: "2021-05-09", totalSales: 81, totalUnits: 17 },
        { date: "2021-05-10", totalSales: 95, totalUnits: 29 },
        { date: "2021-05-11", totalSales: 36, totalUnits: 17 },
        { date: "2021-05-12", totalSales: 75, totalUnits: 13 },
        { date: "2021-05-13", totalSales: 36, totalUnits: 23 },
        { date: "2021-05-14", totalSales: 83, totalUnits: 17 },
        { date: "2021-05-15", totalSales: 26, totalUnits: 45 },
        { date: "2021-05-16", totalSales: 2, totalUnits: 24 },
        { date: "2021-05-17", totalSales: 78, totalUnits: 7 },
        { date: "2021-05-18", totalSales: 41, totalUnits: 9 },
        { date: "2021-05-19", totalSales: 75, totalUnits: 20 },
        { date: "2021-05-20", totalSales: 49, totalUnits: 50 },
        { date: "2021-05-21", totalSales: 14, totalUnits: 40 },
        { date: "2021-05-22", totalSales: 28, totalUnits: 36 },
        { date: "2021-05-23", totalSales: 66, totalUnits: 14 },
        { date: "2021-05-24", totalSales: 1, totalUnits: 32 },
        { date: "2021-05-25", totalSales: 57, totalUnits: 19 },
        { date: "2021-05-26", totalSales: 17, totalUnits: 34 },
        { date: "2021-05-27", totalSales: 94, totalUnits: 27 },
        { date: "2021-05-28", totalSales: 42, totalUnits: 37 },
        { date: "2021-05-29", totalSales: 2, totalUnits: 17 },
        { date: "2021-05-30", totalSales: 78, totalUnits: 16 },
        { date: "2021-05-31", totalSales: 38, totalUnits: 9 },
        { date: "2021-06-01", totalSales: 50, totalUnits: 32 },
        { date: "2021-06-02", totalSales: 18, totalUnits: 13 },
        { date: "2021-06-03", totalSales: 78, totalUnits: 18 },
        { date: "2021-06-04", totalSales: 1, totalUnits: 32 },
        { date: "2021-06-05", totalSales: 62, totalUnits: 36 },
        { date: "2021-06-06", totalSales: 7, totalUnits: 14 },
        { date: "2021-06-07", totalSales: 92, totalUnits: 30 },
        { date: "2021-06-08", totalSales: 38, totalUnits: 37 },
        { date: "2021-06-09", totalSales: 95, totalUnits: 47 },
        { date: "2021-06-10", totalSales: 89, totalUnits: 20 },
        { date: "2021-06-11", totalSales: 25, totalUnits: 7 },
        { date: "2021-06-12", totalSales: 3, totalUnits: 31 },
        { date: "2021-06-13", totalSales: 21, totalUnits: 31 },
        { date: "2021-06-14", totalSales: 10, totalUnits: 37 },
        { date: "2021-06-15", totalSales: 86, totalUnits: 48 },
        { date: "2021-06-16", totalSales: 1, totalUnits: 41 },
        { date: "2021-06-17", totalSales: 25, totalUnits: 6 },
        { date: "2021-06-18", totalSales: 77, totalUnits: 48 },
        { date: "2021-06-19", totalSales: 15, totalUnits: 7 },
        { date: "2021-06-20", totalSales: 8, totalUnits: 5 },
        { date: "2021-06-21", totalSales: 53, totalUnits: 48 },
        { date: "2021-06-22", totalSales: 54, totalUnits: 37 },
        { date: "2021-06-23", totalSales: 28, totalUnits: 48 },
        { date: "2021-06-24", totalSales: 8, totalUnits: 6 },
        { date: "2021-06-25", totalSales: 7, totalUnits: 2 },
        { date: "2021-06-26", totalSales: 79, totalUnits: 19 },
        { date: "2021-06-27", totalSales: 39, totalUnits: 29 },
        { date: "2021-06-28", totalSales: 78, totalUnits: 6 },
        { date: "2021-06-29", totalSales: 26, totalUnits: 19 },
        { date: "2021-06-30", totalSales: 61, totalUnits: 37 },
        { date: "2021-07-01", totalSales: 74, totalUnits: 50 },
        { date: "2021-07-02", totalSales: 59, totalUnits: 20 },
        { date: "2021-07-03", totalSales: 75, totalUnits: 38 },
        { date: "2021-07-04", totalSales: 95, totalUnits: 2 },
        { date: "2021-07-05", totalSales: 9, totalUnits: 14 },
        { date: "2021-07-06", totalSales: 70, totalUnits: 2 },
        { date: "2021-07-07", totalSales: 60, totalUnits: 31 },
        { date: "2021-07-08", totalSales: 23, totalUnits: 31 },
        { date: "2021-07-09", totalSales: 15, totalUnits: 14 },
        { date: "2021-07-10", totalSales: 83, totalUnits: 14 },
        { date: "2021-07-11", totalSales: 76, totalUnits: 45 },
        { date: "2021-07-12", totalSales: 17, totalUnits: 25 },
        { date: "2021-07-13", totalSales: 76, totalUnits: 19 },
        { date: "2021-07-14", totalSales: 13, totalUnits: 3 },
        { date: "2021-07-15", totalSales: 90, totalUnits: 29 },
        { date: "2021-07-16", totalSales: 14, totalUnits: 18 },
        { date: "2021-07-17", totalSales: 37, totalUnits: 46 },
        { date: "2021-07-18", totalSales: 24, totalUnits: 20 },
        { date: "2021-07-19", totalSales: 16, totalUnits: 8 },
        { date: "2021-07-20", totalSales: 67, totalUnits: 1 },
        { date: "2021-07-21", totalSales: 80, totalUnits: 32 },
        { date: "2021-07-22", totalSales: 87, totalUnits: 38 },
        { date: "2021-07-23", totalSales: 86, totalUnits: 44 },
        { date: "2021-07-24", totalSales: 30, totalUnits: 13 },
        { date: "2021-07-25", totalSales: 3, totalUnits: 38 },
        { date: "2021-07-26", totalSales: 88, totalUnits: 40 },
        { date: "2021-07-27", totalSales: 72, totalUnits: 33 },
        { date: "2021-07-28", totalSales: 48, totalUnits: 8 },
        { date: "2021-07-29", totalSales: 74, totalUnits: 34 },
        { date: "2021-07-30", totalSales: 98, totalUnits: 10 },
        { date: "2021-07-31", totalSales: 58, totalUnits: 20 },
        { date: "2021-08-01", totalSales: 34, totalUnits: 20 },
        { date: "2021-08-02", totalSales: 76, totalUnits: 19 },
        { date: "2021-08-03", totalSales: 98, totalUnits: 36 },
        { date: "2021-08-04", totalSales: 61, totalUnits: 49 },
        { date: "2021-08-05", totalSales: 10, totalUnits: 37 },
        { date: "2021-08-06", totalSales: 53, totalUnits: 3 },
        { date: "2021-08-07", totalSales: 99, totalUnits: 9 },
        { date: "2021-08-08", totalSales: 95, totalUnits: 9 },
        { date: "2021-08-09", totalSales: 71, totalUnits: 48 },
        { date: "2021-08-10", totalSales: 46, totalUnits: 21 },
        { date: "2021-08-11", totalSales: 7, totalUnits: 38 },
        { date: "2021-08-12", totalSales: 25, totalUnits: 15 },
        { date: "2021-08-13", totalSales: 80, totalUnits: 12 },
        { date: "2021-08-14", totalSales: 4, totalUnits: 38 },
        { date: "2021-08-15", totalSales: 43, totalUnits: 32 },
        { date: "2021-08-16", totalSales: 67, totalUnits: 4 },
        { date: "2021-08-17", totalSales: 11, totalUnits: 18 },
        { date: "2021-08-18", totalSales: 33, totalUnits: 17 },
        { date: "2021-08-19", totalSales: 96, totalUnits: 18 },
        { date: "2021-08-20", totalSales: 62, totalUnits: 12 },
        { date: "2021-08-21", totalSales: 12, totalUnits: 12 },
        { date: "2021-08-22", totalSales: 27, totalUnits: 14 },
        { date: "2021-08-23", totalSales: 64, totalUnits: 29 },
        { date: "2021-08-24", totalSales: 53, totalUnits: 27 },
        { date: "2021-08-25", totalSales: 63, totalUnits: 15 },
        { date: "2021-08-26", totalSales: 62, totalUnits: 35 },
        { date: "2021-08-27", totalSales: 23, totalUnits: 37 },
        { date: "2021-08-28", totalSales: 54, totalUnits: 18 },
        { date: "2021-08-29", totalSales: 89, totalUnits: 17 },
        { date: "2021-08-30", totalSales: 95, totalUnits: 7 },
        { date: "2021-08-31", totalSales: 57, totalUnits: 3 },
        { date: "2021-09-01", totalSales: 92, totalUnits: 36 },
        { date: "2021-09-02", totalSales: 26, totalUnits: 12 },
        { date: "2021-09-03", totalSales: 27, totalUnits: 21 },
        { date: "2021-09-04", totalSales: 60, totalUnits: 44 },
        { date: "2021-09-05", totalSales: 34, totalUnits: 38 },
        { date: "2021-09-06", totalSales: 11, totalUnits: 35 },
        { date: "2021-09-07", totalSales: 67, totalUnits: 6 },
        { date: "2021-09-08", totalSales: 78, totalUnits: 30 },
        { date: "2021-09-09", totalSales: 56, totalUnits: 18 },
        { date: "2021-09-10", totalSales: 57, totalUnits: 24 },
        { date: "2021-09-11", totalSales: 57, totalUnits: 27 },
        { date: "2021-09-12", totalSales: 2, totalUnits: 47 },
        { date: "2021-09-13", totalSales: 39, totalUnits: 33 },
        { date: "2021-09-14", totalSales: 42, totalUnits: 48 },
        { date: "2021-09-15", totalSales: 30, totalUnits: 6 },
        { date: "2021-09-16", totalSales: 66, totalUnits: 19 },
        { date: "2021-09-17", totalSales: 1, totalUnits: 13 },
        { date: "2021-09-18", totalSales: 48, totalUnits: 30 },
        { date: "2021-09-19", totalSales: 40, totalUnits: 43 },
        { date: "2021-09-20", totalSales: 13, totalUnits: 37 },
        { date: "2021-09-21", totalSales: 76, totalUnits: 13 },
        { date: "2021-09-22", totalSales: 87, totalUnits: 1 },
        { date: "2021-09-23", totalSales: 60, totalUnits: 1 },
        { date: "2021-09-24", totalSales: 28, totalUnits: 49 },
        { date: "2021-09-25", totalSales: 64, totalUnits: 37 },
        { date: "2021-09-26", totalSales: 36, totalUnits: 22 },
        { date: "2021-09-27", totalSales: 7, totalUnits: 43 },
        { date: "2021-09-28", totalSales: 82, totalUnits: 35 },
        { date: "2021-09-29", totalSales: 81, totalUnits: 11 },
        { date: "2021-09-30", totalSales: 90, totalUnits: 21 },
        { date: "2021-10-01", totalSales: 73, totalUnits: 21 },
        { date: "2021-10-02", totalSales: 30, totalUnits: 41 },
        { date: "2021-10-03", totalSales: 83, totalUnits: 38 },
        { date: "2021-10-04", totalSales: 90, totalUnits: 50 },
        { date: "2021-10-05", totalSales: 5, totalUnits: 20 },
        { date: "2021-10-06", totalSales: 88, totalUnits: 35 },
        { date: "2021-10-07", totalSales: 42, totalUnits: 29 },
        { date: "2021-10-08", totalSales: 14, totalUnits: 29 },
        { date: "2021-10-09", totalSales: 61, totalUnits: 5 },
        { date: "2021-10-10", totalSales: 80, totalUnits: 7 },
        { date: "2021-10-11", totalSales: 14, totalUnits: 47 },
        { date: "2021-10-12", totalSales: 89, totalUnits: 5 },
        { date: "2021-10-13", totalSales: 76, totalUnits: 41 },
        { date: "2021-10-14", totalSales: 77, totalUnits: 50 },
        { date: "2021-10-15", totalSales: 32, totalUnits: 16 },
        { date: "2021-10-16", totalSales: 91, totalUnits: 40 },
        { date: "2021-10-17", totalSales: 15, totalUnits: 17 },
        { date: "2021-10-18", totalSales: 7, totalUnits: 38 },
        { date: "2021-10-19", totalSales: 59, totalUnits: 41 },
        { date: "2021-10-20", totalSales: 98, totalUnits: 27 },
        { date: "2021-10-21", totalSales: 38, totalUnits: 38 },
        { date: "2021-10-22", totalSales: 5, totalUnits: 25 },
        { date: "2021-10-23", totalSales: 34, totalUnits: 39 },
        { date: "2021-10-24", totalSales: 39, totalUnits: 19 },
        { date: "2021-10-25", totalSales: 33, totalUnits: 42 },
        { date: "2021-10-26", totalSales: 99, totalUnits: 35 },
        { date: "2021-10-27", totalSales: 43, totalUnits: 1 },
        { date: "2021-10-28", totalSales: 22, totalUnits: 7 },
        { date: "2021-10-29", totalSales: 43, totalUnits: 17 },
        { date: "2021-10-30", totalSales: 23, totalUnits: 13 },
        { date: "2021-10-31", totalSales: 31, totalUnits: 46 },
        { date: "2021-11-01", totalSales: 16, totalUnits: 28 },
        { date: "2021-11-02", totalSales: 74, totalUnits: 37 },
        { date: "2021-11-03", totalSales: 17, totalUnits: 24 },
        { date: "2021-11-04", totalSales: 46, totalUnits: 35 },
        { date: "2021-11-05", totalSales: 40, totalUnits: 5 },
        { date: "2021-11-06", totalSales: 34, totalUnits: 45 },
        { date: "2021-11-07", totalSales: 29, totalUnits: 33 },
        { date: "2021-11-08", totalSales: 35, totalUnits: 28 },
        { date: "2021-11-09", totalSales: 37, totalUnits: 37 },
        { date: "2021-11-10", totalSales: 81, totalUnits: 23 },
        { date: "2021-11-11", totalSales: 92, totalUnits: 43 },
        { date: "2021-11-12", totalSales: 88, totalUnits: 48 },
        { date: "2021-11-13", totalSales: 77, totalUnits: 40 },
        { date: "2021-11-14", totalSales: 28, totalUnits: 50 },
        { date: "2021-11-15", totalSales: 36, totalUnits: 28 },
        { date: "2021-11-16", totalSales: 56, totalUnits: 24 },
        { date: "2021-11-17", totalSales: 97, totalUnits: 43 },
      ],
    },
    {
      _id: "6371259df032396b8e000083",
      productId: "63701d24f03239b7f7000016",
      yearlySalesTotal: 5264,
      yearlyTotalSoldUnits: 1782,
      monthlyData: [
        { month: "january", totalSales: 635, totalUnits: 368 },
        { month: "february", totalSales: 732, totalUnits: 2 },
        { month: "march", totalSales: 294, totalUnits: 363 },
        { month: "april", totalSales: 478, totalUnits: 82 },
        { month: "may", totalSales: 438, totalUnits: 116 },
        { month: "june", totalSales: 911, totalUnits: 20 },
        { month: "july", totalSales: 722, totalUnits: 119 },
        { month: "august", totalSales: 739, totalUnits: 55 },
        { month: "september", totalSales: 646, totalUnits: 7 },
        { month: "october", totalSales: 177, totalUnits: 222 },
        { month: "november", totalSales: 111, totalUnits: 31 },
        { month: "december", totalSales: 122, totalUnits: 284 },
      ],
      dailyData: [
        { date: "2021-01-02", totalSales: 71, totalUnits: 43 },
        { date: "2021-01-03", totalSales: 27, totalUnits: 34 },
        { date: "2021-01-04", totalSales: 77, totalUnits: 28 },
        { date: "2021-01-05", totalSales: 13, totalUnits: 6 },
        { date: "2021-01-06", totalSales: 44, totalUnits: 8 },
        { date: "2021-01-07", totalSales: 45, totalUnits: 4 },
        { date: "2021-01-08", totalSales: 30, totalUnits: 32 },
        { date: "2021-01-09", totalSales: 7, totalUnits: 20 },
        { date: "2021-01-10", totalSales: 32, totalUnits: 2 },
        { date: "2021-01-11", totalSales: 95, totalUnits: 49 },
        { date: "2021-01-12", totalSales: 19, totalUnits: 22 },
        { date: "2021-01-13", totalSales: 17, totalUnits: 16 },
        { date: "2021-01-14", totalSales: 28, totalUnits: 48 },
        { date: "2021-01-15", totalSales: 43, totalUnits: 48 },
        { date: "2021-01-16", totalSales: 14, totalUnits: 1 },
        { date: "2021-01-17", totalSales: 41, totalUnits: 17 },
        { date: "2021-01-18", totalSales: 43, totalUnits: 27 },
        { date: "2021-01-19", totalSales: 29, totalUnits: 1 },
        { date: "2021-01-20", totalSales: 94, totalUnits: 17 },
        { date: "2021-01-21", totalSales: 20, totalUnits: 28 },
        { date: "2021-01-22", totalSales: 83, totalUnits: 49 },
        { date: "2021-01-23", totalSales: 27, totalUnits: 29 },
        { date: "2021-01-24", totalSales: 86, totalUnits: 2 },
        { date: "2021-01-25", totalSales: 88, totalUnits: 49 },
        { date: "2021-01-26", totalSales: 100, totalUnits: 3 },
        { date: "2021-01-27", totalSales: 87, totalUnits: 14 },
        { date: "2021-01-28", totalSales: 19, totalUnits: 2 },
        { date: "2021-01-29", totalSales: 13, totalUnits: 36 },
        { date: "2021-01-30", totalSales: 31, totalUnits: 8 },
        { date: "2021-01-31", totalSales: 99, totalUnits: 32 },
        { date: "2021-02-01", totalSales: 15, totalUnits: 22 },
        { date: "2021-02-02", totalSales: 8, totalUnits: 33 },
        { date: "2021-02-03", totalSales: 26, totalUnits: 23 },
        { date: "2021-02-04", totalSales: 38, totalUnits: 19 },
        { date: "2021-02-05", totalSales: 49, totalUnits: 46 },
        { date: "2021-02-06", totalSales: 56, totalUnits: 15 },
        { date: "2021-02-07", totalSales: 69, totalUnits: 28 },
        { date: "2021-02-08", totalSales: 1, totalUnits: 7 },
        { date: "2021-02-09", totalSales: 53, totalUnits: 1 },
        { date: "2021-02-10", totalSales: 1, totalUnits: 19 },
        { date: "2021-02-11", totalSales: 98, totalUnits: 36 },
        { date: "2021-02-12", totalSales: 12, totalUnits: 4 },
        { date: "2021-02-13", totalSales: 22, totalUnits: 41 },
        { date: "2021-02-14", totalSales: 52, totalUnits: 29 },
        { date: "2021-02-15", totalSales: 69, totalUnits: 19 },
        { date: "2021-02-16", totalSales: 5, totalUnits: 3 },
        { date: "2021-02-17", totalSales: 27, totalUnits: 2 },
        { date: "2021-02-18", totalSales: 26, totalUnits: 22 },
        { date: "2021-02-19", totalSales: 20, totalUnits: 16 },
        { date: "2021-02-20", totalSales: 12, totalUnits: 34 },
        { date: "2021-02-21", totalSales: 26, totalUnits: 16 },
        { date: "2021-02-22", totalSales: 24, totalUnits: 30 },
        { date: "2021-02-23", totalSales: 92, totalUnits: 30 },
        { date: "2021-02-24", totalSales: 34, totalUnits: 21 },
        { date: "2021-02-25", totalSales: 70, totalUnits: 37 },
        { date: "2021-02-26", totalSales: 41, totalUnits: 38 },
        { date: "2021-02-27", totalSales: 70, totalUnits: 1 },
        { date: "2021-02-28", totalSales: 78, totalUnits: 1 },
        { date: "2021-03-01", totalSales: 29, totalUnits: 11 },
        { date: "2021-03-02", totalSales: 71, totalUnits: 27 },
        { date: "2021-03-03", totalSales: 47, totalUnits: 46 },
        { date: "2021-03-04", totalSales: 77, totalUnits: 17 },
        { date: "2021-03-05", totalSales: 56, totalUnits: 49 },
        { date: "2021-03-06", totalSales: 45, totalUnits: 37 },
        { date: "2021-03-07", totalSales: 40, totalUnits: 13 },
        { date: "2021-03-08", totalSales: 93, totalUnits: 6 },
        { date: "2021-03-09", totalSales: 7, totalUnits: 7 },
        { date: "2021-03-10", totalSales: 30, totalUnits: 35 },
        { date: "2021-03-11", totalSales: 13, totalUnits: 28 },
        { date: "2021-03-12", totalSales: 68, totalUnits: 32 },
        { date: "2021-03-13", totalSales: 89, totalUnits: 45 },
        { date: "2021-03-14", totalSales: 57, totalUnits: 8 },
        { date: "2021-03-15", totalSales: 40, totalUnits: 42 },
        { date: "2021-03-16", totalSales: 16, totalUnits: 25 },
        { date: "2021-03-17", totalSales: 51, totalUnits: 8 },
        { date: "2021-03-18", totalSales: 19, totalUnits: 1 },
        { date: "2021-03-19", totalSales: 21, totalUnits: 9 },
        { date: "2021-03-20", totalSales: 81, totalUnits: 5 },
        { date: "2021-03-21", totalSales: 10, totalUnits: 45 },
        { date: "2021-03-22", totalSales: 92, totalUnits: 12 },
        { date: "2021-03-23", totalSales: 74, totalUnits: 5 },
        { date: "2021-03-24", totalSales: 7, totalUnits: 21 },
        { date: "2021-03-25", totalSales: 35, totalUnits: 49 },
        { date: "2021-03-26", totalSales: 93, totalUnits: 16 },
        { date: "2021-03-27", totalSales: 7, totalUnits: 15 },
        { date: "2021-03-28", totalSales: 18, totalUnits: 9 },
        { date: "2021-03-29", totalSales: 17, totalUnits: 26 },
        { date: "2021-03-30", totalSales: 15, totalUnits: 17 },
        { date: "2021-03-31", totalSales: 80, totalUnits: 33 },
        { date: "2021-04-01", totalSales: 87, totalUnits: 34 },
        { date: "2021-04-02", totalSales: 73, totalUnits: 17 },
        { date: "2021-04-03", totalSales: 89, totalUnits: 49 },
        { date: "2021-04-04", totalSales: 60, totalUnits: 23 },
        { date: "2021-04-05", totalSales: 18, totalUnits: 6 },
        { date: "2021-04-06", totalSales: 63, totalUnits: 8 },
        { date: "2021-04-07", totalSales: 48, totalUnits: 11 },
        { date: "2021-04-08", totalSales: 1, totalUnits: 48 },
        { date: "2021-04-09", totalSales: 24, totalUnits: 21 },
        { date: "2021-04-10", totalSales: 5, totalUnits: 26 },
        { date: "2021-04-11", totalSales: 73, totalUnits: 44 },
        { date: "2021-04-12", totalSales: 47, totalUnits: 49 },
        { date: "2021-04-13", totalSales: 35, totalUnits: 37 },
        { date: "2021-04-14", totalSales: 90, totalUnits: 48 },
        { date: "2021-04-15", totalSales: 24, totalUnits: 47 },
        { date: "2021-04-16", totalSales: 89, totalUnits: 11 },
        { date: "2021-04-17", totalSales: 17, totalUnits: 18 },
        { date: "2021-04-18", totalSales: 35, totalUnits: 11 },
        { date: "2021-04-19", totalSales: 44, totalUnits: 29 },
        { date: "2021-04-20", totalSales: 25, totalUnits: 42 },
        { date: "2021-04-21", totalSales: 20, totalUnits: 7 },
        { date: "2021-04-22", totalSales: 41, totalUnits: 10 },
        { date: "2021-04-23", totalSales: 83, totalUnits: 15 },
        { date: "2021-04-24", totalSales: 53, totalUnits: 37 },
        { date: "2021-04-25", totalSales: 31, totalUnits: 14 },
        { date: "2021-04-26", totalSales: 28, totalUnits: 13 },
        { date: "2021-04-27", totalSales: 17, totalUnits: 34 },
        { date: "2021-04-28", totalSales: 80, totalUnits: 21 },
        { date: "2021-04-29", totalSales: 74, totalUnits: 11 },
        { date: "2021-04-30", totalSales: 52, totalUnits: 31 },
        { date: "2021-05-01", totalSales: 7, totalUnits: 11 },
        { date: "2021-05-02", totalSales: 71, totalUnits: 37 },
        { date: "2021-05-03", totalSales: 88, totalUnits: 28 },
        { date: "2021-05-04", totalSales: 51, totalUnits: 14 },
        { date: "2021-05-05", totalSales: 53, totalUnits: 8 },
        { date: "2021-05-06", totalSales: 22, totalUnits: 17 },
        { date: "2021-05-07", totalSales: 84, totalUnits: 45 },
        { date: "2021-05-08", totalSales: 57, totalUnits: 20 },
        { date: "2021-05-09", totalSales: 44, totalUnits: 44 },
        { date: "2021-05-10", totalSales: 16, totalUnits: 49 },
        { date: "2021-05-11", totalSales: 27, totalUnits: 29 },
        { date: "2021-05-12", totalSales: 97, totalUnits: 21 },
        { date: "2021-05-13", totalSales: 70, totalUnits: 50 },
        { date: "2021-05-14", totalSales: 38, totalUnits: 32 },
        { date: "2021-05-15", totalSales: 36, totalUnits: 17 },
        { date: "2021-05-16", totalSales: 38, totalUnits: 47 },
        { date: "2021-05-17", totalSales: 40, totalUnits: 22 },
        { date: "2021-05-18", totalSales: 58, totalUnits: 49 },
        { date: "2021-05-19", totalSales: 98, totalUnits: 43 },
        { date: "2021-05-20", totalSales: 43, totalUnits: 12 },
        { date: "2021-05-21", totalSales: 65, totalUnits: 18 },
        { date: "2021-05-22", totalSales: 99, totalUnits: 26 },
        { date: "2021-05-23", totalSales: 54, totalUnits: 35 },
        { date: "2021-05-24", totalSales: 21, totalUnits: 3 },
        { date: "2021-05-25", totalSales: 56, totalUnits: 9 },
        { date: "2021-05-26", totalSales: 21, totalUnits: 45 },
        { date: "2021-05-27", totalSales: 22, totalUnits: 23 },
        { date: "2021-05-28", totalSales: 60, totalUnits: 31 },
        { date: "2021-05-29", totalSales: 49, totalUnits: 8 },
        { date: "2021-05-30", totalSales: 30, totalUnits: 50 },
        { date: "2021-05-31", totalSales: 85, totalUnits: 49 },
        { date: "2021-06-01", totalSales: 70, totalUnits: 17 },
        { date: "2021-06-02", totalSales: 100, totalUnits: 24 },
        { date: "2021-06-03", totalSales: 34, totalUnits: 4 },
        { date: "2021-06-04", totalSales: 7, totalUnits: 25 },
        { date: "2021-06-05", totalSales: 12, totalUnits: 36 },
        { date: "2021-06-06", totalSales: 84, totalUnits: 20 },
        { date: "2021-06-07", totalSales: 69, totalUnits: 34 },
        { date: "2021-06-08", totalSales: 69, totalUnits: 15 },
        { date: "2021-06-09", totalSales: 96, totalUnits: 6 },
        { date: "2021-06-10", totalSales: 50, totalUnits: 50 },
        { date: "2021-06-11", totalSales: 57, totalUnits: 47 },
        { date: "2021-06-12", totalSales: 14, totalUnits: 44 },
        { date: "2021-06-13", totalSales: 75, totalUnits: 35 },
        { date: "2021-06-14", totalSales: 69, totalUnits: 8 },
        { date: "2021-06-15", totalSales: 51, totalUnits: 20 },
        { date: "2021-06-16", totalSales: 80, totalUnits: 10 },
        { date: "2021-06-17", totalSales: 61, totalUnits: 50 },
        { date: "2021-06-18", totalSales: 69, totalUnits: 48 },
        { date: "2021-06-19", totalSales: 96, totalUnits: 40 },
        { date: "2021-06-20", totalSales: 21, totalUnits: 5 },
        { date: "2021-06-21", totalSales: 2, totalUnits: 20 },
        { date: "2021-06-22", totalSales: 71, totalUnits: 39 },
        { date: "2021-06-23", totalSales: 16, totalUnits: 1 },
        { date: "2021-06-24", totalSales: 55, totalUnits: 2 },
        { date: "2021-06-25", totalSales: 32, totalUnits: 2 },
        { date: "2021-06-26", totalSales: 20, totalUnits: 35 },
        { date: "2021-06-27", totalSales: 94, totalUnits: 41 },
        { date: "2021-06-28", totalSales: 53, totalUnits: 2 },
        { date: "2021-06-29", totalSales: 99, totalUnits: 43 },
        { date: "2021-06-30", totalSales: 8, totalUnits: 19 },
        { date: "2021-07-01", totalSales: 73, totalUnits: 47 },
        { date: "2021-07-02", totalSales: 99, totalUnits: 22 },
        { date: "2021-07-03", totalSales: 59, totalUnits: 21 },
        { date: "2021-07-04", totalSales: 58, totalUnits: 45 },
        { date: "2021-07-05", totalSales: 98, totalUnits: 31 },
        { date: "2021-07-06", totalSales: 98, totalUnits: 37 },
        { date: "2021-07-07", totalSales: 17, totalUnits: 40 },
        { date: "2021-07-08", totalSales: 69, totalUnits: 20 },
        { date: "2021-07-09", totalSales: 5, totalUnits: 9 },
        { date: "2021-07-10", totalSales: 93, totalUnits: 50 },
        { date: "2021-07-11", totalSales: 69, totalUnits: 19 },
        { date: "2021-07-12", totalSales: 2, totalUnits: 2 },
        { date: "2021-07-13", totalSales: 56, totalUnits: 4 },
        { date: "2021-07-14", totalSales: 85, totalUnits: 49 },
        { date: "2021-07-15", totalSales: 46, totalUnits: 39 },
        { date: "2021-07-16", totalSales: 99, totalUnits: 27 },
        { date: "2021-07-17", totalSales: 18, totalUnits: 22 },
        { date: "2021-07-18", totalSales: 22, totalUnits: 9 },
        { date: "2021-07-19", totalSales: 89, totalUnits: 45 },
        { date: "2021-07-20", totalSales: 43, totalUnits: 47 },
        { date: "2021-07-21", totalSales: 17, totalUnits: 16 },
        { date: "2021-07-22", totalSales: 51, totalUnits: 47 },
        { date: "2021-07-23", totalSales: 6, totalUnits: 34 },
        { date: "2021-07-24", totalSales: 27, totalUnits: 48 },
        { date: "2021-07-25", totalSales: 79, totalUnits: 9 },
        { date: "2021-07-26", totalSales: 93, totalUnits: 45 },
        { date: "2021-07-27", totalSales: 69, totalUnits: 26 },
        { date: "2021-07-28", totalSales: 9, totalUnits: 30 },
        { date: "2021-07-29", totalSales: 61, totalUnits: 31 },
        { date: "2021-07-30", totalSales: 21, totalUnits: 43 },
        { date: "2021-07-31", totalSales: 43, totalUnits: 29 },
        { date: "2021-08-01", totalSales: 71, totalUnits: 48 },
        { date: "2021-08-02", totalSales: 37, totalUnits: 39 },
        { date: "2021-08-03", totalSales: 77, totalUnits: 4 },
        { date: "2021-08-04", totalSales: 79, totalUnits: 40 },
        { date: "2021-08-05", totalSales: 79, totalUnits: 1 },
        { date: "2021-08-06", totalSales: 32, totalUnits: 37 },
        { date: "2021-08-07", totalSales: 61, totalUnits: 18 },
        { date: "2021-08-08", totalSales: 90, totalUnits: 9 },
        { date: "2021-08-09", totalSales: 14, totalUnits: 49 },
        { date: "2021-08-10", totalSales: 49, totalUnits: 36 },
        { date: "2021-08-11", totalSales: 96, totalUnits: 48 },
        { date: "2021-08-12", totalSales: 78, totalUnits: 11 },
        { date: "2021-08-13", totalSales: 27, totalUnits: 11 },
        { date: "2021-08-14", totalSales: 39, totalUnits: 15 },
        { date: "2021-08-15", totalSales: 10, totalUnits: 15 },
        { date: "2021-08-16", totalSales: 89, totalUnits: 40 },
        { date: "2021-08-17", totalSales: 28, totalUnits: 7 },
        { date: "2021-08-18", totalSales: 70, totalUnits: 25 },
        { date: "2021-08-19", totalSales: 60, totalUnits: 4 },
        { date: "2021-08-20", totalSales: 24, totalUnits: 5 },
        { date: "2021-08-21", totalSales: 31, totalUnits: 41 },
        { date: "2021-08-22", totalSales: 62, totalUnits: 28 },
        { date: "2021-08-23", totalSales: 74, totalUnits: 10 },
        { date: "2021-08-24", totalSales: 98, totalUnits: 10 },
        { date: "2021-08-25", totalSales: 60, totalUnits: 50 },
        { date: "2021-08-26", totalSales: 93, totalUnits: 9 },
        { date: "2021-08-27", totalSales: 8, totalUnits: 49 },
        { date: "2021-08-28", totalSales: 48, totalUnits: 11 },
        { date: "2021-08-29", totalSales: 79, totalUnits: 37 },
        { date: "2021-08-30", totalSales: 35, totalUnits: 38 },
        { date: "2021-08-31", totalSales: 97, totalUnits: 5 },
        { date: "2021-09-01", totalSales: 44, totalUnits: 20 },
        { date: "2021-09-02", totalSales: 1, totalUnits: 32 },
        { date: "2021-09-03", totalSales: 26, totalUnits: 4 },
        { date: "2021-09-04", totalSales: 88, totalUnits: 49 },
        { date: "2021-09-05", totalSales: 45, totalUnits: 18 },
        { date: "2021-09-06", totalSales: 62, totalUnits: 15 },
        { date: "2021-09-07", totalSales: 83, totalUnits: 44 },
        { date: "2021-09-08", totalSales: 47, totalUnits: 36 },
        { date: "2021-09-09", totalSales: 91, totalUnits: 48 },
        { date: "2021-09-10", totalSales: 40, totalUnits: 19 },
        { date: "2021-09-11", totalSales: 90, totalUnits: 33 },
        { date: "2021-09-12", totalSales: 77, totalUnits: 42 },
        { date: "2021-09-13", totalSales: 44, totalUnits: 38 },
        { date: "2021-09-14", totalSales: 44, totalUnits: 44 },
        { date: "2021-09-15", totalSales: 23, totalUnits: 12 },
        { date: "2021-09-16", totalSales: 72, totalUnits: 50 },
        { date: "2021-09-17", totalSales: 49, totalUnits: 41 },
        { date: "2021-09-18", totalSales: 30, totalUnits: 23 },
        { date: "2021-09-19", totalSales: 13, totalUnits: 28 },
        { date: "2021-09-20", totalSales: 38, totalUnits: 40 },
        { date: "2021-09-21", totalSales: 49, totalUnits: 36 },
        { date: "2021-09-22", totalSales: 18, totalUnits: 46 },
        { date: "2021-09-23", totalSales: 50, totalUnits: 9 },
        { date: "2021-09-24", totalSales: 88, totalUnits: 18 },
        { date: "2021-09-25", totalSales: 16, totalUnits: 9 },
        { date: "2021-09-26", totalSales: 38, totalUnits: 19 },
        { date: "2021-09-27", totalSales: 40, totalUnits: 44 },
        { date: "2021-09-28", totalSales: 65, totalUnits: 16 },
        { date: "2021-09-29", totalSales: 90, totalUnits: 4 },
        { date: "2021-09-30", totalSales: 21, totalUnits: 7 },
        { date: "2021-10-01", totalSales: 19, totalUnits: 5 },
        { date: "2021-10-02", totalSales: 80, totalUnits: 25 },
        { date: "2021-10-03", totalSales: 78, totalUnits: 19 },
        { date: "2021-10-04", totalSales: 28, totalUnits: 25 },
        { date: "2021-10-05", totalSales: 11, totalUnits: 11 },
        { date: "2021-10-06", totalSales: 24, totalUnits: 7 },
        { date: "2021-10-07", totalSales: 79, totalUnits: 3 },
        { date: "2021-10-08", totalSales: 51, totalUnits: 2 },
        { date: "2021-10-09", totalSales: 38, totalUnits: 50 },
        { date: "2021-10-10", totalSales: 76, totalUnits: 42 },
        { date: "2021-10-11", totalSales: 8, totalUnits: 29 },
        { date: "2021-10-12", totalSales: 27, totalUnits: 50 },
        { date: "2021-10-13", totalSales: 81, totalUnits: 8 },
        { date: "2021-10-14", totalSales: 18, totalUnits: 49 },
        { date: "2021-10-15", totalSales: 90, totalUnits: 17 },
        { date: "2021-10-16", totalSales: 21, totalUnits: 32 },
        { date: "2021-10-17", totalSales: 9, totalUnits: 31 },
        { date: "2021-10-18", totalSales: 53, totalUnits: 16 },
        { date: "2021-10-19", totalSales: 82, totalUnits: 44 },
        { date: "2021-10-20", totalSales: 43, totalUnits: 35 },
        { date: "2021-10-21", totalSales: 57, totalUnits: 8 },
        { date: "2021-10-22", totalSales: 27, totalUnits: 33 },
        { date: "2021-10-23", totalSales: 10, totalUnits: 6 },
        { date: "2021-10-24", totalSales: 96, totalUnits: 23 },
        { date: "2021-10-25", totalSales: 73, totalUnits: 27 },
        { date: "2021-10-26", totalSales: 54, totalUnits: 13 },
        { date: "2021-10-27", totalSales: 63, totalUnits: 18 },
        { date: "2021-10-28", totalSales: 65, totalUnits: 32 },
        { date: "2021-10-29", totalSales: 11, totalUnits: 23 },
        { date: "2021-10-30", totalSales: 83, totalUnits: 30 },
        { date: "2021-10-31", totalSales: 25, totalUnits: 44 },
        { date: "2021-11-01", totalSales: 64, totalUnits: 45 },
        { date: "2021-11-02", totalSales: 60, totalUnits: 37 },
        { date: "2021-11-03", totalSales: 57, totalUnits: 24 },
        { date: "2021-11-04", totalSales: 1, totalUnits: 10 },
        { date: "2021-11-05", totalSales: 93, totalUnits: 28 },
        { date: "2021-11-06", totalSales: 20, totalUnits: 43 },
        { date: "2021-11-07", totalSales: 4, totalUnits: 48 },
        { date: "2021-11-08", totalSales: 54, totalUnits: 9 },
        { date: "2021-11-09", totalSales: 21, totalUnits: 23 },
        { date: "2021-11-10", totalSales: 39, totalUnits: 8 },
        { date: "2021-11-11", totalSales: 79, totalUnits: 36 },
        { date: "2021-11-12", totalSales: 8, totalUnits: 44 },
        { date: "2021-11-13", totalSales: 92, totalUnits: 4 },
        { date: "2021-11-14", totalSales: 4, totalUnits: 50 },
        { date: "2021-11-15", totalSales: 48, totalUnits: 14 },
        { date: "2021-11-16", totalSales: 49, totalUnits: 42 },
        { date: "2021-11-17", totalSales: 27, totalUnits: 6 },
      ],
    },
    {
      _id: "6371259df03239bef0000198",
      productId: "63701d24f03239b7f7000017",
      yearlySalesTotal: 3238,
      yearlyTotalSoldUnits: 2564,
      monthlyData: [
        { month: "january", totalSales: 929, totalUnits: 91 },
        { month: "february", totalSales: 734, totalUnits: 44 },
        { month: "march", totalSales: 709, totalUnits: 204 },
        { month: "april", totalSales: 368, totalUnits: 268 },
        { month: "may", totalSales: 280, totalUnits: 197 },
        { month: "june", totalSales: 261, totalUnits: 388 },
        { month: "july", totalSales: 369, totalUnits: 122 },
        { month: "august", totalSales: 793, totalUnits: 78 },
        { month: "september", totalSales: 164, totalUnits: 477 },
        { month: "october", totalSales: 805, totalUnits: 349 },
        { month: "november", totalSales: 667, totalUnits: 286 },
        { month: "december", totalSales: 676, totalUnits: 498 },
      ],
      dailyData: [
        { date: "2021-01-02", totalSales: 86, totalUnits: 30 },
        { date: "2021-01-03", totalSales: 19, totalUnits: 49 },
        { date: "2021-01-04", totalSales: 20, totalUnits: 32 },
        { date: "2021-01-05", totalSales: 85, totalUnits: 1 },
        { date: "2021-01-06", totalSales: 33, totalUnits: 28 },
        { date: "2021-01-07", totalSales: 8, totalUnits: 8 },
        { date: "2021-01-08", totalSales: 13, totalUnits: 33 },
        { date: "2021-01-09", totalSales: 83, totalUnits: 50 },
        { date: "2021-01-10", totalSales: 35, totalUnits: 13 },
        { date: "2021-01-11", totalSales: 63, totalUnits: 41 },
        { date: "2021-01-12", totalSales: 10, totalUnits: 18 },
        { date: "2021-01-13", totalSales: 19, totalUnits: 21 },
        { date: "2021-01-14", totalSales: 35, totalUnits: 34 },
        { date: "2021-01-15", totalSales: 95, totalUnits: 3 },
        { date: "2021-01-16", totalSales: 85, totalUnits: 39 },
        { date: "2021-01-17", totalSales: 35, totalUnits: 17 },
        { date: "2021-01-18", totalSales: 9, totalUnits: 31 },
        { date: "2021-01-19", totalSales: 76, totalUnits: 24 },
        { date: "2021-01-20", totalSales: 51, totalUnits: 20 },
        { date: "2021-01-21", totalSales: 95, totalUnits: 28 },
        { date: "2021-01-22", totalSales: 91, totalUnits: 40 },
        { date: "2021-01-23", totalSales: 32, totalUnits: 11 },
        { date: "2021-01-24", totalSales: 47, totalUnits: 21 },
        { date: "2021-01-25", totalSales: 60, totalUnits: 16 },
        { date: "2021-01-26", totalSales: 86, totalUnits: 18 },
        { date: "2021-01-27", totalSales: 41, totalUnits: 26 },
        { date: "2021-01-28", totalSales: 54, totalUnits: 22 },
        { date: "2021-01-29", totalSales: 99, totalUnits: 29 },
        { date: "2021-01-30", totalSales: 91, totalUnits: 25 },
        { date: "2021-01-31", totalSales: 89, totalUnits: 24 },
        { date: "2021-02-01", totalSales: 24, totalUnits: 29 },
        { date: "2021-02-02", totalSales: 12, totalUnits: 49 },
        { date: "2021-02-03", totalSales: 5, totalUnits: 18 },
        { date: "2021-02-04", totalSales: 38, totalUnits: 31 },
        { date: "2021-02-05", totalSales: 6, totalUnits: 13 },
        { date: "2021-02-06", totalSales: 30, totalUnits: 38 },
        { date: "2021-02-07", totalSales: 33, totalUnits: 21 },
        { date: "2021-02-08", totalSales: 41, totalUnits: 39 },
        { date: "2021-02-09", totalSales: 58, totalUnits: 6 },
        { date: "2021-02-10", totalSales: 53, totalUnits: 14 },
        { date: "2021-02-11", totalSales: 72, totalUnits: 38 },
        { date: "2021-02-12", totalSales: 86, totalUnits: 12 },
        { date: "2021-02-13", totalSales: 77, totalUnits: 17 },
        { date: "2021-02-14", totalSales: 96, totalUnits: 32 },
        { date: "2021-02-15", totalSales: 64, totalUnits: 31 },
        { date: "2021-02-16", totalSales: 83, totalUnits: 50 },
        { date: "2021-02-17", totalSales: 65, totalUnits: 7 },
        { date: "2021-02-18", totalSales: 8, totalUnits: 10 },
        { date: "2021-02-19", totalSales: 66, totalUnits: 17 },
        { date: "2021-02-20", totalSales: 61, totalUnits: 22 },
        { date: "2021-02-21", totalSales: 69, totalUnits: 35 },
        { date: "2021-02-22", totalSales: 91, totalUnits: 46 },
        { date: "2021-02-23", totalSales: 90, totalUnits: 7 },
        { date: "2021-02-24", totalSales: 87, totalUnits: 29 },
        { date: "2021-02-25", totalSales: 14, totalUnits: 10 },
        { date: "2021-02-26", totalSales: 57, totalUnits: 10 },
        { date: "2021-02-27", totalSales: 86, totalUnits: 19 },
        { date: "2021-02-28", totalSales: 6, totalUnits: 25 },
        { date: "2021-03-01", totalSales: 71, totalUnits: 30 },
        { date: "2021-03-02", totalSales: 98, totalUnits: 50 },
        { date: "2021-03-03", totalSales: 40, totalUnits: 47 },
        { date: "2021-03-04", totalSales: 9, totalUnits: 42 },
        { date: "2021-03-05", totalSales: 96, totalUnits: 33 },
        { date: "2021-03-06", totalSales: 82, totalUnits: 10 },
        { date: "2021-03-07", totalSales: 74, totalUnits: 39 },
        { date: "2021-03-08", totalSales: 90, totalUnits: 44 },
        { date: "2021-03-09", totalSales: 74, totalUnits: 25 },
        { date: "2021-03-10", totalSales: 55, totalUnits: 19 },
        { date: "2021-03-11", totalSales: 48, totalUnits: 35 },
        { date: "2021-03-12", totalSales: 37, totalUnits: 10 },
        { date: "2021-03-13", totalSales: 31, totalUnits: 28 },
        { date: "2021-03-14", totalSales: 62, totalUnits: 20 },
        { date: "2021-03-15", totalSales: 45, totalUnits: 1 },
        { date: "2021-03-16", totalSales: 92, totalUnits: 3 },
        { date: "2021-03-17", totalSales: 70, totalUnits: 37 },
        { date: "2021-03-18", totalSales: 53, totalUnits: 46 },
        { date: "2021-03-19", totalSales: 28, totalUnits: 37 },
        { date: "2021-03-20", totalSales: 56, totalUnits: 6 },
        { date: "2021-03-21", totalSales: 88, totalUnits: 45 },
        { date: "2021-03-22", totalSales: 71, totalUnits: 34 },
        { date: "2021-03-23", totalSales: 41, totalUnits: 47 },
        { date: "2021-03-24", totalSales: 12, totalUnits: 20 },
        { date: "2021-03-25", totalSales: 22, totalUnits: 9 },
        { date: "2021-03-26", totalSales: 85, totalUnits: 25 },
        { date: "2021-03-27", totalSales: 82, totalUnits: 7 },
        { date: "2021-03-28", totalSales: 36, totalUnits: 33 },
        { date: "2021-03-29", totalSales: 91, totalUnits: 3 },
        { date: "2021-03-30", totalSales: 20, totalUnits: 3 },
        { date: "2021-03-31", totalSales: 70, totalUnits: 47 },
        { date: "2021-04-01", totalSales: 40, totalUnits: 36 },
        { date: "2021-04-02", totalSales: 74, totalUnits: 44 },
        { date: "2021-04-03", totalSales: 53, totalUnits: 49 },
        { date: "2021-04-04", totalSales: 34, totalUnits: 49 },
        { date: "2021-04-05", totalSales: 17, totalUnits: 45 },
        { date: "2021-04-06", totalSales: 47, totalUnits: 42 },
        { date: "2021-04-07", totalSales: 19, totalUnits: 25 },
        { date: "2021-04-08", totalSales: 11, totalUnits: 48 },
        { date: "2021-04-09", totalSales: 82, totalUnits: 49 },
        { date: "2021-04-10", totalSales: 27, totalUnits: 20 },
        { date: "2021-04-11", totalSales: 55, totalUnits: 49 },
        { date: "2021-04-12", totalSales: 96, totalUnits: 45 },
        { date: "2021-04-13", totalSales: 91, totalUnits: 32 },
        { date: "2021-04-14", totalSales: 23, totalUnits: 49 },
        { date: "2021-04-15", totalSales: 38, totalUnits: 40 },
        { date: "2021-04-16", totalSales: 68, totalUnits: 27 },
        { date: "2021-04-17", totalSales: 74, totalUnits: 36 },
        { date: "2021-04-18", totalSales: 37, totalUnits: 4 },
        { date: "2021-04-19", totalSales: 95, totalUnits: 16 },
        { date: "2021-04-20", totalSales: 73, totalUnits: 2 },
        { date: "2021-04-21", totalSales: 31, totalUnits: 10 },
        { date: "2021-04-22", totalSales: 14, totalUnits: 21 },
        { date: "2021-04-23", totalSales: 37, totalUnits: 34 },
        { date: "2021-04-24", totalSales: 45, totalUnits: 6 },
        { date: "2021-04-25", totalSales: 30, totalUnits: 34 },
        { date: "2021-04-26", totalSales: 80, totalUnits: 26 },
        { date: "2021-04-27", totalSales: 6, totalUnits: 23 },
        { date: "2021-04-28", totalSales: 81, totalUnits: 1 },
        { date: "2021-04-29", totalSales: 14, totalUnits: 46 },
        { date: "2021-04-30", totalSales: 22, totalUnits: 8 },
        { date: "2021-05-01", totalSales: 27, totalUnits: 46 },
        { date: "2021-05-02", totalSales: 16, totalUnits: 34 },
        { date: "2021-05-03", totalSales: 96, totalUnits: 13 },
        { date: "2021-05-04", totalSales: 83, totalUnits: 30 },
        { date: "2021-05-05", totalSales: 49, totalUnits: 48 },
        { date: "2021-05-06", totalSales: 48, totalUnits: 23 },
        { date: "2021-05-07", totalSales: 10, totalUnits: 32 },
        { date: "2021-05-08", totalSales: 19, totalUnits: 21 },
        { date: "2021-05-09", totalSales: 91, totalUnits: 27 },
        { date: "2021-05-10", totalSales: 25, totalUnits: 36 },
        { date: "2021-05-11", totalSales: 8, totalUnits: 17 },
        { date: "2021-05-12", totalSales: 39, totalUnits: 27 },
        { date: "2021-05-13", totalSales: 80, totalUnits: 49 },
        { date: "2021-05-14", totalSales: 66, totalUnits: 24 },
        { date: "2021-05-15", totalSales: 14, totalUnits: 44 },
        { date: "2021-05-16", totalSales: 9, totalUnits: 15 },
        { date: "2021-05-17", totalSales: 49, totalUnits: 30 },
        { date: "2021-05-18", totalSales: 10, totalUnits: 8 },
        { date: "2021-05-19", totalSales: 77, totalUnits: 11 },
        { date: "2021-05-20", totalSales: 99, totalUnits: 26 },
        { date: "2021-05-21", totalSales: 8, totalUnits: 34 },
        { date: "2021-05-22", totalSales: 3, totalUnits: 43 },
        { date: "2021-05-23", totalSales: 59, totalUnits: 44 },
        { date: "2021-05-24", totalSales: 72, totalUnits: 22 },
        { date: "2021-05-25", totalSales: 66, totalUnits: 28 },
        { date: "2021-05-26", totalSales: 18, totalUnits: 12 },
        { date: "2021-05-27", totalSales: 44, totalUnits: 13 },
        { date: "2021-05-28", totalSales: 51, totalUnits: 13 },
        { date: "2021-05-29", totalSales: 31, totalUnits: 2 },
        { date: "2021-05-30", totalSales: 51, totalUnits: 8 },
        { date: "2021-05-31", totalSales: 81, totalUnits: 45 },
        { date: "2021-06-01", totalSales: 45, totalUnits: 14 },
        { date: "2021-06-02", totalSales: 62, totalUnits: 5 },
        { date: "2021-06-03", totalSales: 63, totalUnits: 40 },
        { date: "2021-06-04", totalSales: 69, totalUnits: 47 },
        { date: "2021-06-05", totalSales: 45, totalUnits: 43 },
        { date: "2021-06-06", totalSales: 16, totalUnits: 31 },
        { date: "2021-06-07", totalSales: 79, totalUnits: 12 },
        { date: "2021-06-08", totalSales: 41, totalUnits: 31 },
        { date: "2021-06-09", totalSales: 37, totalUnits: 14 },
        { date: "2021-06-10", totalSales: 31, totalUnits: 33 },
        { date: "2021-06-11", totalSales: 46, totalUnits: 24 },
        { date: "2021-06-12", totalSales: 3, totalUnits: 5 },
        { date: "2021-06-13", totalSales: 15, totalUnits: 40 },
        { date: "2021-06-14", totalSales: 19, totalUnits: 22 },
        { date: "2021-06-15", totalSales: 78, totalUnits: 32 },
        { date: "2021-06-16", totalSales: 87, totalUnits: 2 },
        { date: "2021-06-17", totalSales: 78, totalUnits: 24 },
        { date: "2021-06-18", totalSales: 53, totalUnits: 4 },
        { date: "2021-06-19", totalSales: 14, totalUnits: 36 },
        { date: "2021-06-20", totalSales: 48, totalUnits: 43 },
        { date: "2021-06-21", totalSales: 52, totalUnits: 16 },
        { date: "2021-06-22", totalSales: 3, totalUnits: 1 },
        { date: "2021-06-23", totalSales: 53, totalUnits: 6 },
        { date: "2021-06-24", totalSales: 65, totalUnits: 40 },
        { date: "2021-06-25", totalSales: 19, totalUnits: 47 },
        { date: "2021-06-26", totalSales: 44, totalUnits: 37 },
        { date: "2021-06-27", totalSales: 44, totalUnits: 4 },
        { date: "2021-06-28", totalSales: 55, totalUnits: 3 },
        { date: "2021-06-29", totalSales: 28, totalUnits: 39 },
        { date: "2021-06-30", totalSales: 29, totalUnits: 3 },
        { date: "2021-07-01", totalSales: 81, totalUnits: 23 },
        { date: "2021-07-02", totalSales: 16, totalUnits: 17 },
        { date: "2021-07-03", totalSales: 29, totalUnits: 30 },
        { date: "2021-07-04", totalSales: 17, totalUnits: 14 },
        { date: "2021-07-05", totalSales: 91, totalUnits: 32 },
        { date: "2021-07-06", totalSales: 25, totalUnits: 36 },
        { date: "2021-07-07", totalSales: 76, totalUnits: 3 },
        { date: "2021-07-08", totalSales: 40, totalUnits: 43 },
        { date: "2021-07-09", totalSales: 64, totalUnits: 7 },
        { date: "2021-07-10", totalSales: 72, totalUnits: 12 },
        { date: "2021-07-11", totalSales: 56, totalUnits: 24 },
        { date: "2021-07-12", totalSales: 47, totalUnits: 40 },
        { date: "2021-07-13", totalSales: 53, totalUnits: 31 },
        { date: "2021-07-14", totalSales: 86, totalUnits: 1 },
        { date: "2021-07-15", totalSales: 18, totalUnits: 19 },
        { date: "2021-07-16", totalSales: 66, totalUnits: 44 },
        { date: "2021-07-17", totalSales: 42, totalUnits: 5 },
        { date: "2021-07-18", totalSales: 93, totalUnits: 23 },
        { date: "2021-07-19", totalSales: 25, totalUnits: 33 },
        { date: "2021-07-20", totalSales: 77, totalUnits: 18 },
        { date: "2021-07-21", totalSales: 91, totalUnits: 32 },
        { date: "2021-07-22", totalSales: 50, totalUnits: 33 },
        { date: "2021-07-23", totalSales: 43, totalUnits: 33 },
        { date: "2021-07-24", totalSales: 60, totalUnits: 34 },
        { date: "2021-07-25", totalSales: 49, totalUnits: 47 },
        { date: "2021-07-26", totalSales: 7, totalUnits: 2 },
        { date: "2021-07-27", totalSales: 77, totalUnits: 6 },
        { date: "2021-07-28", totalSales: 35, totalUnits: 35 },
        { date: "2021-07-29", totalSales: 60, totalUnits: 26 },
        { date: "2021-07-30", totalSales: 94, totalUnits: 10 },
        { date: "2021-07-31", totalSales: 23, totalUnits: 12 },
        { date: "2021-08-01", totalSales: 11, totalUnits: 37 },
        { date: "2021-08-02", totalSales: 5, totalUnits: 37 },
        { date: "2021-08-03", totalSales: 24, totalUnits: 18 },
        { date: "2021-08-04", totalSales: 31, totalUnits: 29 },
        { date: "2021-08-05", totalSales: 28, totalUnits: 29 },
        { date: "2021-08-06", totalSales: 6, totalUnits: 18 },
        { date: "2021-08-07", totalSales: 26, totalUnits: 2 },
        { date: "2021-08-08", totalSales: 60, totalUnits: 37 },
        { date: "2021-08-09", totalSales: 2, totalUnits: 28 },
        { date: "2021-08-10", totalSales: 41, totalUnits: 45 },
        { date: "2021-08-11", totalSales: 68, totalUnits: 27 },
        { date: "2021-08-12", totalSales: 88, totalUnits: 8 },
        { date: "2021-08-13", totalSales: 37, totalUnits: 47 },
        { date: "2021-08-14", totalSales: 63, totalUnits: 24 },
        { date: "2021-08-15", totalSales: 5, totalUnits: 1 },
        { date: "2021-08-16", totalSales: 92, totalUnits: 41 },
        { date: "2021-08-17", totalSales: 36, totalUnits: 25 },
        { date: "2021-08-18", totalSales: 19, totalUnits: 15 },
        { date: "2021-08-19", totalSales: 60, totalUnits: 39 },
        { date: "2021-08-20", totalSales: 82, totalUnits: 36 },
        { date: "2021-08-21", totalSales: 21, totalUnits: 16 },
        { date: "2021-08-22", totalSales: 58, totalUnits: 27 },
        { date: "2021-08-23", totalSales: 68, totalUnits: 28 },
        { date: "2021-08-24", totalSales: 7, totalUnits: 46 },
        { date: "2021-08-25", totalSales: 60, totalUnits: 1 },
        { date: "2021-08-26", totalSales: 26, totalUnits: 22 },
        { date: "2021-08-27", totalSales: 80, totalUnits: 2 },
        { date: "2021-08-28", totalSales: 70, totalUnits: 18 },
        { date: "2021-08-29", totalSales: 69, totalUnits: 17 },
        { date: "2021-08-30", totalSales: 76, totalUnits: 39 },
        { date: "2021-08-31", totalSales: 70, totalUnits: 25 },
        { date: "2021-09-01", totalSales: 38, totalUnits: 3 },
        { date: "2021-09-02", totalSales: 32, totalUnits: 18 },
        { date: "2021-09-03", totalSales: 26, totalUnits: 18 },
        { date: "2021-09-04", totalSales: 56, totalUnits: 27 },
        { date: "2021-09-05", totalSales: 76, totalUnits: 41 },
        { date: "2021-09-06", totalSales: 10, totalUnits: 3 },
        { date: "2021-09-07", totalSales: 65, totalUnits: 26 },
        { date: "2021-09-08", totalSales: 46, totalUnits: 42 },
        { date: "2021-09-09", totalSales: 30, totalUnits: 36 },
        { date: "2021-09-10", totalSales: 92, totalUnits: 3 },
        { date: "2021-09-11", totalSales: 13, totalUnits: 21 },
        { date: "2021-09-12", totalSales: 43, totalUnits: 39 },
        { date: "2021-09-13", totalSales: 90, totalUnits: 49 },
        { date: "2021-09-14", totalSales: 35, totalUnits: 9 },
        { date: "2021-09-15", totalSales: 8, totalUnits: 11 },
        { date: "2021-09-16", totalSales: 86, totalUnits: 45 },
        { date: "2021-09-17", totalSales: 62, totalUnits: 13 },
        { date: "2021-09-18", totalSales: 6, totalUnits: 26 },
        { date: "2021-09-19", totalSales: 63, totalUnits: 48 },
        { date: "2021-09-20", totalSales: 85, totalUnits: 42 },
        { date: "2021-09-21", totalSales: 59, totalUnits: 22 },
        { date: "2021-09-22", totalSales: 17, totalUnits: 44 },
        { date: "2021-09-23", totalSales: 67, totalUnits: 43 },
        { date: "2021-09-24", totalSales: 87, totalUnits: 16 },
        { date: "2021-09-25", totalSales: 90, totalUnits: 4 },
        { date: "2021-09-26", totalSales: 81, totalUnits: 20 },
        { date: "2021-09-27", totalSales: 70, totalUnits: 16 },
        { date: "2021-09-28", totalSales: 8, totalUnits: 8 },
        { date: "2021-09-29", totalSales: 32, totalUnits: 50 },
        { date: "2021-09-30", totalSales: 93, totalUnits: 6 },
        { date: "2021-10-01", totalSales: 5, totalUnits: 35 },
        { date: "2021-10-02", totalSales: 38, totalUnits: 45 },
        { date: "2021-10-03", totalSales: 40, totalUnits: 3 },
        { date: "2021-10-04", totalSales: 62, totalUnits: 10 },
        { date: "2021-10-05", totalSales: 64, totalUnits: 15 },
        { date: "2021-10-06", totalSales: 36, totalUnits: 42 },
        { date: "2021-10-07", totalSales: 71, totalUnits: 33 },
        { date: "2021-10-08", totalSales: 46, totalUnits: 20 },
        { date: "2021-10-09", totalSales: 16, totalUnits: 44 },
        { date: "2021-10-10", totalSales: 71, totalUnits: 12 },
        { date: "2021-10-11", totalSales: 7, totalUnits: 44 },
        { date: "2021-10-12", totalSales: 41, totalUnits: 38 },
        { date: "2021-10-13", totalSales: 88, totalUnits: 27 },
        { date: "2021-10-14", totalSales: 80, totalUnits: 1 },
        { date: "2021-10-15", totalSales: 11, totalUnits: 40 },
        { date: "2021-10-16", totalSales: 21, totalUnits: 41 },
        { date: "2021-10-17", totalSales: 64, totalUnits: 11 },
        { date: "2021-10-18", totalSales: 57, totalUnits: 50 },
        { date: "2021-10-19", totalSales: 80, totalUnits: 34 },
        { date: "2021-10-20", totalSales: 68, totalUnits: 13 },
        { date: "2021-10-21", totalSales: 47, totalUnits: 21 },
        { date: "2021-10-22", totalSales: 47, totalUnits: 2 },
        { date: "2021-10-23", totalSales: 87, totalUnits: 13 },
        { date: "2021-10-24", totalSales: 3, totalUnits: 29 },
        { date: "2021-10-25", totalSales: 19, totalUnits: 45 },
        { date: "2021-10-26", totalSales: 20, totalUnits: 22 },
        { date: "2021-10-27", totalSales: 34, totalUnits: 22 },
        { date: "2021-10-28", totalSales: 95, totalUnits: 41 },
        { date: "2021-10-29", totalSales: 47, totalUnits: 36 },
        { date: "2021-10-30", totalSales: 36, totalUnits: 37 },
        { date: "2021-10-31", totalSales: 95, totalUnits: 13 },
        { date: "2021-11-01", totalSales: 35, totalUnits: 39 },
        { date: "2021-11-02", totalSales: 16, totalUnits: 47 },
        { date: "2021-11-03", totalSales: 32, totalUnits: 21 },
        { date: "2021-11-04", totalSales: 9, totalUnits: 34 },
        { date: "2021-11-05", totalSales: 41, totalUnits: 25 },
        { date: "2021-11-06", totalSales: 22, totalUnits: 27 },
        { date: "2021-11-07", totalSales: 17, totalUnits: 8 },
        { date: "2021-11-08", totalSales: 72, totalUnits: 49 },
        { date: "2021-11-09", totalSales: 63, totalUnits: 42 },
        { date: "2021-11-10", totalSales: 27, totalUnits: 16 },
        { date: "2021-11-11", totalSales: 33, totalUnits: 14 },
        { date: "2021-11-12", totalSales: 77, totalUnits: 35 },
        { date: "2021-11-13", totalSales: 97, totalUnits: 24 },
        { date: "2021-11-14", totalSales: 29, totalUnits: 3 },
        { date: "2021-11-15", totalSales: 50, totalUnits: 36 },
        { date: "2021-11-16", totalSales: 34, totalUnits: 29 },
        { date: "2021-11-17", totalSales: 19, totalUnits: 27 },
      ],
    },
    {
      _id: "6371259df03239f793000002",
      productId: "63701d24f03239b7f7000018",
      yearlySalesTotal: 7954,
      yearlyTotalSoldUnits: 4999,
      monthlyData: [
        { month: "january", totalSales: 692, totalUnits: 306 },
        { month: "february", totalSales: 310, totalUnits: 286 },
        { month: "march", totalSales: 635, totalUnits: 40 },
        { month: "april", totalSales: 589, totalUnits: 60 },
        { month: "may", totalSales: 714, totalUnits: 339 },
        { month: "june", totalSales: 855, totalUnits: 357 },
        { month: "july", totalSales: 209, totalUnits: 281 },
        { month: "august", totalSales: 65, totalUnits: 106 },
        { month: "september", totalSales: 184, totalUnits: 92 },
        { month: "october", totalSales: 311, totalUnits: 418 },
        { month: "november", totalSales: 295, totalUnits: 196 },
        { month: "december", totalSales: 542, totalUnits: 414 },
      ],
      dailyData: [
        { date: "2021-01-02", totalSales: 90, totalUnits: 7 },
        { date: "2021-01-03", totalSales: 17, totalUnits: 3 },
        { date: "2021-01-04", totalSales: 55, totalUnits: 50 },
        { date: "2021-01-05", totalSales: 23, totalUnits: 10 },
        { date: "2021-01-06", totalSales: 72, totalUnits: 35 },
        { date: "2021-01-07", totalSales: 63, totalUnits: 41 },
        { date: "2021-01-08", totalSales: 46, totalUnits: 8 },
        { date: "2021-01-09", totalSales: 63, totalUnits: 36 },
        { date: "2021-01-10", totalSales: 61, totalUnits: 12 },
        { date: "2021-01-11", totalSales: 9, totalUnits: 16 },
        { date: "2021-01-12", totalSales: 59, totalUnits: 49 },
        { date: "2021-01-13", totalSales: 22, totalUnits: 41 },
        { date: "2021-01-14", totalSales: 94, totalUnits: 9 },
        { date: "2021-01-15", totalSales: 77, totalUnits: 40 },
        { date: "2021-01-16", totalSales: 92, totalUnits: 31 },
        { date: "2021-01-17", totalSales: 90, totalUnits: 46 },
        { date: "2021-01-18", totalSales: 51, totalUnits: 31 },
        { date: "2021-01-19", totalSales: 80, totalUnits: 25 },
        { date: "2021-01-20", totalSales: 54, totalUnits: 46 },
        { date: "2021-01-21", totalSales: 6, totalUnits: 36 },
        { date: "2021-01-22", totalSales: 67, totalUnits: 10 },
        { date: "2021-01-23", totalSales: 84, totalUnits: 10 },
        { date: "2021-01-24", totalSales: 95, totalUnits: 38 },
        { date: "2021-01-25", totalSales: 43, totalUnits: 20 },
        { date: "2021-01-26", totalSales: 41, totalUnits: 15 },
        { date: "2021-01-27", totalSales: 27, totalUnits: 7 },
        { date: "2021-01-28", totalSales: 37, totalUnits: 38 },
        { date: "2021-01-29", totalSales: 29, totalUnits: 24 },
        { date: "2021-01-30", totalSales: 99, totalUnits: 8 },
        { date: "2021-01-31", totalSales: 73, totalUnits: 32 },
        { date: "2021-02-01", totalSales: 28, totalUnits: 16 },
        { date: "2021-02-02", totalSales: 58, totalUnits: 31 },
        { date: "2021-02-03", totalSales: 29, totalUnits: 8 },
        { date: "2021-02-04", totalSales: 83, totalUnits: 31 },
        { date: "2021-02-05", totalSales: 53, totalUnits: 49 },
        { date: "2021-02-06", totalSales: 10, totalUnits: 50 },
        { date: "2021-02-07", totalSales: 73, totalUnits: 8 },
        { date: "2021-02-08", totalSales: 90, totalUnits: 14 },
        { date: "2021-02-09", totalSales: 20, totalUnits: 24 },
        { date: "2021-02-10", totalSales: 42, totalUnits: 4 },
        { date: "2021-02-11", totalSales: 95, totalUnits: 6 },
        { date: "2021-02-12", totalSales: 17, totalUnits: 2 },
        { date: "2021-02-13", totalSales: 98, totalUnits: 49 },
        { date: "2021-02-14", totalSales: 89, totalUnits: 1 },
        { date: "2021-02-15", totalSales: 52, totalUnits: 9 },
        { date: "2021-02-16", totalSales: 23, totalUnits: 4 },
        { date: "2021-02-17", totalSales: 64, totalUnits: 46 },
        { date: "2021-02-18", totalSales: 78, totalUnits: 16 },
        { date: "2021-02-19", totalSales: 95, totalUnits: 25 },
        { date: "2021-02-20", totalSales: 29, totalUnits: 6 },
        { date: "2021-02-21", totalSales: 87, totalUnits: 50 },
        { date: "2021-02-22", totalSales: 87, totalUnits: 43 },
        { date: "2021-02-23", totalSales: 43, totalUnits: 4 },
        { date: "2021-02-24", totalSales: 84, totalUnits: 31 },
        { date: "2021-02-25", totalSales: 94, totalUnits: 22 },
        { date: "2021-02-26", totalSales: 57, totalUnits: 40 },
        { date: "2021-02-27", totalSales: 95, totalUnits: 7 },
        { date: "2021-02-28", totalSales: 48, totalUnits: 11 },
        { date: "2021-03-01", totalSales: 76, totalUnits: 41 },
        { date: "2021-03-02", totalSales: 28, totalUnits: 8 },
        { date: "2021-03-03", totalSales: 89, totalUnits: 16 },
        { date: "2021-03-04", totalSales: 42, totalUnits: 12 },
        { date: "2021-03-05", totalSales: 48, totalUnits: 34 },
        { date: "2021-03-06", totalSales: 59, totalUnits: 15 },
        { date: "2021-03-07", totalSales: 71, totalUnits: 4 },
        { date: "2021-03-08", totalSales: 63, totalUnits: 15 },
        { date: "2021-03-09", totalSales: 92, totalUnits: 14 },
        { date: "2021-03-10", totalSales: 59, totalUnits: 25 },
        { date: "2021-03-11", totalSales: 53, totalUnits: 3 },
        { date: "2021-03-12", totalSales: 83, totalUnits: 33 },
        { date: "2021-03-13", totalSales: 15, totalUnits: 29 },
        { date: "2021-03-14", totalSales: 98, totalUnits: 12 },
        { date: "2021-03-15", totalSales: 46, totalUnits: 27 },
        { date: "2021-03-16", totalSales: 21, totalUnits: 35 },
        { date: "2021-03-17", totalSales: 69, totalUnits: 15 },
        { date: "2021-03-18", totalSales: 51, totalUnits: 32 },
        { date: "2021-03-19", totalSales: 90, totalUnits: 2 },
        { date: "2021-03-20", totalSales: 37, totalUnits: 17 },
        { date: "2021-03-21", totalSales: 68, totalUnits: 42 },
        { date: "2021-03-22", totalSales: 88, totalUnits: 1 },
        { date: "2021-03-23", totalSales: 9, totalUnits: 24 },
        { date: "2021-03-24", totalSales: 2, totalUnits: 5 },
        { date: "2021-03-25", totalSales: 40, totalUnits: 15 },
        { date: "2021-03-26", totalSales: 24, totalUnits: 10 },
        { date: "2021-03-27", totalSales: 39, totalUnits: 24 },
        { date: "2021-03-28", totalSales: 89, totalUnits: 10 },
        { date: "2021-03-29", totalSales: 54, totalUnits: 16 },
        { date: "2021-03-30", totalSales: 21, totalUnits: 7 },
        { date: "2021-03-31", totalSales: 93, totalUnits: 14 },
        { date: "2021-04-01", totalSales: 15, totalUnits: 15 },
        { date: "2021-04-02", totalSales: 35, totalUnits: 31 },
        { date: "2021-04-03", totalSales: 67, totalUnits: 27 },
        { date: "2021-04-04", totalSales: 59, totalUnits: 39 },
        { date: "2021-04-05", totalSales: 95, totalUnits: 41 },
        { date: "2021-04-06", totalSales: 1, totalUnits: 22 },
        { date: "2021-04-07", totalSales: 90, totalUnits: 22 },
        { date: "2021-04-08", totalSales: 31, totalUnits: 15 },
        { date: "2021-04-09", totalSales: 45, totalUnits: 24 },
        { date: "2021-04-10", totalSales: 34, totalUnits: 31 },
        { date: "2021-04-11", totalSales: 70, totalUnits: 33 },
        { date: "2021-04-12", totalSales: 52, totalUnits: 33 },
        { date: "2021-04-13", totalSales: 86, totalUnits: 2 },
        { date: "2021-04-14", totalSales: 31, totalUnits: 22 },
        { date: "2021-04-15", totalSales: 26, totalUnits: 12 },
        { date: "2021-04-16", totalSales: 24, totalUnits: 38 },
        { date: "2021-04-17", totalSales: 98, totalUnits: 5 },
        { date: "2021-04-18", totalSales: 58, totalUnits: 6 },
        { date: "2021-04-19", totalSales: 98, totalUnits: 27 },
        { date: "2021-04-20", totalSales: 79, totalUnits: 49 },
        { date: "2021-04-21", totalSales: 20, totalUnits: 1 },
        { date: "2021-04-22", totalSales: 65, totalUnits: 5 },
        { date: "2021-04-23", totalSales: 75, totalUnits: 46 },
        { date: "2021-04-24", totalSales: 65, totalUnits: 33 },
        { date: "2021-04-25", totalSales: 55, totalUnits: 33 },
        { date: "2021-04-26", totalSales: 19, totalUnits: 1 },
        { date: "2021-04-27", totalSales: 44, totalUnits: 25 },
        { date: "2021-04-28", totalSales: 82, totalUnits: 46 },
        { date: "2021-04-29", totalSales: 79, totalUnits: 45 },
        { date: "2021-04-30", totalSales: 4, totalUnits: 31 },
        { date: "2021-05-01", totalSales: 21, totalUnits: 30 },
        { date: "2021-05-02", totalSales: 74, totalUnits: 42 },
        { date: "2021-05-03", totalSales: 7, totalUnits: 7 },
        { date: "2021-05-04", totalSales: 47, totalUnits: 43 },
        { date: "2021-05-05", totalSales: 18, totalUnits: 34 },
        { date: "2021-05-06", totalSales: 16, totalUnits: 50 },
        { date: "2021-05-07", totalSales: 55, totalUnits: 38 },
        { date: "2021-05-08", totalSales: 20, totalUnits: 29 },
        { date: "2021-05-09", totalSales: 92, totalUnits: 11 },
        { date: "2021-05-10", totalSales: 51, totalUnits: 23 },
        { date: "2021-05-11", totalSales: 98, totalUnits: 29 },
        { date: "2021-05-12", totalSales: 73, totalUnits: 4 },
        { date: "2021-05-13", totalSales: 62, totalUnits: 33 },
        { date: "2021-05-14", totalSales: 46, totalUnits: 11 },
        { date: "2021-05-15", totalSales: 34, totalUnits: 32 },
        { date: "2021-05-16", totalSales: 61, totalUnits: 46 },
        { date: "2021-05-17", totalSales: 17, totalUnits: 46 },
        { date: "2021-05-18", totalSales: 38, totalUnits: 3 },
        { date: "2021-05-19", totalSales: 24, totalUnits: 35 },
        { date: "2021-05-20", totalSales: 41, totalUnits: 40 },
        { date: "2021-05-21", totalSales: 35, totalUnits: 8 },
        { date: "2021-05-22", totalSales: 54, totalUnits: 11 },
        { date: "2021-05-23", totalSales: 56, totalUnits: 34 },
        { date: "2021-05-24", totalSales: 57, totalUnits: 17 },
        { date: "2021-05-25", totalSales: 76, totalUnits: 50 },
        { date: "2021-05-26", totalSales: 72, totalUnits: 27 },
        { date: "2021-05-27", totalSales: 56, totalUnits: 42 },
        { date: "2021-05-28", totalSales: 62, totalUnits: 32 },
        { date: "2021-05-29", totalSales: 62, totalUnits: 48 },
        { date: "2021-05-30", totalSales: 32, totalUnits: 19 },
        { date: "2021-05-31", totalSales: 41, totalUnits: 45 },
        { date: "2021-06-01", totalSales: 70, totalUnits: 31 },
        { date: "2021-06-02", totalSales: 42, totalUnits: 3 },
        { date: "2021-06-03", totalSales: 25, totalUnits: 13 },
        { date: "2021-06-04", totalSales: 37, totalUnits: 46 },
        { date: "2021-06-05", totalSales: 86, totalUnits: 50 },
        { date: "2021-06-06", totalSales: 63, totalUnits: 37 },
        { date: "2021-06-07", totalSales: 8, totalUnits: 19 },
        { date: "2021-06-08", totalSales: 94, totalUnits: 10 },
        { date: "2021-06-09", totalSales: 89, totalUnits: 39 },
        { date: "2021-06-10", totalSales: 4, totalUnits: 18 },
        { date: "2021-06-11", totalSales: 62, totalUnits: 7 },
        { date: "2021-06-12", totalSales: 38, totalUnits: 7 },
        { date: "2021-06-13", totalSales: 79, totalUnits: 50 },
        { date: "2021-06-14", totalSales: 40, totalUnits: 41 },
        { date: "2021-06-15", totalSales: 48, totalUnits: 39 },
        { date: "2021-06-16", totalSales: 53, totalUnits: 5 },
        { date: "2021-06-17", totalSales: 73, totalUnits: 20 },
        { date: "2021-06-18", totalSales: 95, totalUnits: 4 },
        { date: "2021-06-19", totalSales: 20, totalUnits: 40 },
        { date: "2021-06-20", totalSales: 38, totalUnits: 42 },
        { date: "2021-06-21", totalSales: 25, totalUnits: 29 },
        { date: "2021-06-22", totalSales: 60, totalUnits: 38 },
        { date: "2021-06-23", totalSales: 57, totalUnits: 23 },
        { date: "2021-06-24", totalSales: 82, totalUnits: 5 },
        { date: "2021-06-25", totalSales: 24, totalUnits: 41 },
        { date: "2021-06-26", totalSales: 59, totalUnits: 26 },
        { date: "2021-06-27", totalSales: 55, totalUnits: 26 },
        { date: "2021-06-28", totalSales: 77, totalUnits: 32 },
        { date: "2021-06-29", totalSales: 74, totalUnits: 31 },
        { date: "2021-06-30", totalSales: 6, totalUnits: 11 },
        { date: "2021-07-01", totalSales: 86, totalUnits: 11 },
        { date: "2021-07-02", totalSales: 25, totalUnits: 30 },
        { date: "2021-07-03", totalSales: 91, totalUnits: 6 },
        { date: "2021-07-04", totalSales: 35, totalUnits: 42 },
        { date: "2021-07-05", totalSales: 64, totalUnits: 46 },
        { date: "2021-07-06", totalSales: 85, totalUnits: 31 },
        { date: "2021-07-07", totalSales: 20, totalUnits: 29 },
        { date: "2021-07-08", totalSales: 22, totalUnits: 13 },
        { date: "2021-07-09", totalSales: 21, totalUnits: 16 },
        { date: "2021-07-10", totalSales: 88, totalUnits: 48 },
        { date: "2021-07-11", totalSales: 11, totalUnits: 40 },
        { date: "2021-07-12", totalSales: 55, totalUnits: 47 },
        { date: "2021-07-13", totalSales: 15, totalUnits: 16 },
        { date: "2021-07-14", totalSales: 20, totalUnits: 40 },
        { date: "2021-07-15", totalSales: 74, totalUnits: 19 },
        { date: "2021-07-16", totalSales: 11, totalUnits: 4 },
        { date: "2021-07-17", totalSales: 44, totalUnits: 29 },
        { date: "2021-07-18", totalSales: 100, totalUnits: 26 },
        { date: "2021-07-19", totalSales: 63, totalUnits: 20 },
        { date: "2021-07-20", totalSales: 94, totalUnits: 3 },
        { date: "2021-07-21", totalSales: 5, totalUnits: 50 },
        { date: "2021-07-22", totalSales: 21, totalUnits: 41 },
        { date: "2021-07-23", totalSales: 51, totalUnits: 34 },
        { date: "2021-07-24", totalSales: 23, totalUnits: 8 },
        { date: "2021-07-25", totalSales: 62, totalUnits: 15 },
        { date: "2021-07-26", totalSales: 87, totalUnits: 21 },
        { date: "2021-07-27", totalSales: 70, totalUnits: 25 },
        { date: "2021-07-28", totalSales: 39, totalUnits: 17 },
        { date: "2021-07-29", totalSales: 1, totalUnits: 3 },
        { date: "2021-07-30", totalSales: 35, totalUnits: 29 },
        { date: "2021-07-31", totalSales: 44, totalUnits: 28 },
        { date: "2021-08-01", totalSales: 71, totalUnits: 33 },
        { date: "2021-08-02", totalSales: 72, totalUnits: 22 },
        { date: "2021-08-03", totalSales: 48, totalUnits: 11 },
        { date: "2021-08-04", totalSales: 36, totalUnits: 33 },
        { date: "2021-08-05", totalSales: 78, totalUnits: 24 },
        { date: "2021-08-06", totalSales: 87, totalUnits: 37 },
        { date: "2021-08-07", totalSales: 88, totalUnits: 50 },
        { date: "2021-08-08", totalSales: 14, totalUnits: 33 },
        { date: "2021-08-09", totalSales: 97, totalUnits: 35 },
        { date: "2021-08-10", totalSales: 43, totalUnits: 19 },
        { date: "2021-08-11", totalSales: 73, totalUnits: 31 },
        { date: "2021-08-12", totalSales: 98, totalUnits: 16 },
        { date: "2021-08-13", totalSales: 75, totalUnits: 19 },
        { date: "2021-08-14", totalSales: 27, totalUnits: 4 },
        { date: "2021-08-15", totalSales: 33, totalUnits: 42 },
        { date: "2021-08-16", totalSales: 65, totalUnits: 6 },
        { date: "2021-08-17", totalSales: 53, totalUnits: 50 },
        { date: "2021-08-18", totalSales: 86, totalUnits: 37 },
        { date: "2021-08-19", totalSales: 81, totalUnits: 50 },
        { date: "2021-08-20", totalSales: 35, totalUnits: 35 },
        { date: "2021-08-21", totalSales: 32, totalUnits: 25 },
        { date: "2021-08-22", totalSales: 70, totalUnits: 11 },
        { date: "2021-08-23", totalSales: 7, totalUnits: 38 },
        { date: "2021-08-24", totalSales: 97, totalUnits: 45 },
        { date: "2021-08-25", totalSales: 31, totalUnits: 21 },
        { date: "2021-08-26", totalSales: 24, totalUnits: 20 },
        { date: "2021-08-27", totalSales: 89, totalUnits: 34 },
        { date: "2021-08-28", totalSales: 62, totalUnits: 16 },
        { date: "2021-08-29", totalSales: 72, totalUnits: 35 },
        { date: "2021-08-30", totalSales: 26, totalUnits: 34 },
        { date: "2021-08-31", totalSales: 81, totalUnits: 38 },
        { date: "2021-09-01", totalSales: 98, totalUnits: 42 },
        { date: "2021-09-02", totalSales: 66, totalUnits: 48 },
        { date: "2021-09-03", totalSales: 53, totalUnits: 6 },
        { date: "2021-09-04", totalSales: 84, totalUnits: 8 },
        { date: "2021-09-05", totalSales: 68, totalUnits: 12 },
        { date: "2021-09-06", totalSales: 36, totalUnits: 47 },
        { date: "2021-09-07", totalSales: 70, totalUnits: 16 },
        { date: "2021-09-08", totalSales: 72, totalUnits: 33 },
        { date: "2021-09-09", totalSales: 8, totalUnits: 17 },
        { date: "2021-09-10", totalSales: 26, totalUnits: 23 },
        { date: "2021-09-11", totalSales: 82, totalUnits: 35 },
        { date: "2021-09-12", totalSales: 19, totalUnits: 9 },
        { date: "2021-09-13", totalSales: 55, totalUnits: 42 },
        { date: "2021-09-14", totalSales: 64, totalUnits: 1 },
        { date: "2021-09-15", totalSales: 77, totalUnits: 9 },
        { date: "2021-09-16", totalSales: 23, totalUnits: 13 },
        { date: "2021-09-17", totalSales: 33, totalUnits: 27 },
        { date: "2021-09-18", totalSales: 20, totalUnits: 26 },
        { date: "2021-09-19", totalSales: 19, totalUnits: 42 },
        { date: "2021-09-20", totalSales: 41, totalUnits: 43 },
        { date: "2021-09-21", totalSales: 5, totalUnits: 14 },
        { date: "2021-09-22", totalSales: 51, totalUnits: 8 },
        { date: "2021-09-23", totalSales: 37, totalUnits: 27 },
        { date: "2021-09-24", totalSales: 88, totalUnits: 33 },
        { date: "2021-09-25", totalSales: 78, totalUnits: 31 },
        { date: "2021-09-26", totalSales: 34, totalUnits: 14 },
        { date: "2021-09-27", totalSales: 12, totalUnits: 34 },
        { date: "2021-09-28", totalSales: 19, totalUnits: 46 },
        { date: "2021-09-29", totalSales: 33, totalUnits: 40 },
        { date: "2021-09-30", totalSales: 4, totalUnits: 23 },
        { date: "2021-10-01", totalSales: 47, totalUnits: 33 },
        { date: "2021-10-02", totalSales: 24, totalUnits: 47 },
        { date: "2021-10-03", totalSales: 49, totalUnits: 33 },
        { date: "2021-10-04", totalSales: 55, totalUnits: 30 },
        { date: "2021-10-05", totalSales: 30, totalUnits: 6 },
        { date: "2021-10-06", totalSales: 34, totalUnits: 5 },
        { date: "2021-10-07", totalSales: 69, totalUnits: 22 },
        { date: "2021-10-08", totalSales: 76, totalUnits: 36 },
        { date: "2021-10-09", totalSales: 65, totalUnits: 28 },
        { date: "2021-10-10", totalSales: 53, totalUnits: 18 },
        { date: "2021-10-11", totalSales: 74, totalUnits: 44 },
        { date: "2021-10-12", totalSales: 69, totalUnits: 45 },
        { date: "2021-10-13", totalSales: 91, totalUnits: 16 },
        { date: "2021-10-14", totalSales: 45, totalUnits: 26 },
        { date: "2021-10-15", totalSales: 36, totalUnits: 49 },
        { date: "2021-10-16", totalSales: 50, totalUnits: 29 },
        { date: "2021-10-17", totalSales: 36, totalUnits: 23 },
        { date: "2021-10-18", totalSales: 8, totalUnits: 33 },
        { date: "2021-10-19", totalSales: 49, totalUnits: 4 },
        { date: "2021-10-20", totalSales: 56, totalUnits: 13 },
        { date: "2021-10-21", totalSales: 66, totalUnits: 25 },
        { date: "2021-10-22", totalSales: 88, totalUnits: 31 },
        { date: "2021-10-23", totalSales: 69, totalUnits: 29 },
        { date: "2021-10-24", totalSales: 31, totalUnits: 50 },
        { date: "2021-10-25", totalSales: 14, totalUnits: 18 },
        { date: "2021-10-26", totalSales: 82, totalUnits: 10 },
        { date: "2021-10-27", totalSales: 87, totalUnits: 33 },
        { date: "2021-10-28", totalSales: 75, totalUnits: 30 },
        { date: "2021-10-29", totalSales: 76, totalUnits: 37 },
        { date: "2021-10-30", totalSales: 65, totalUnits: 47 },
        { date: "2021-10-31", totalSales: 85, totalUnits: 11 },
        { date: "2021-11-01", totalSales: 40, totalUnits: 1 },
        { date: "2021-11-02", totalSales: 90, totalUnits: 7 },
        { date: "2021-11-03", totalSales: 90, totalUnits: 25 },
        { date: "2021-11-04", totalSales: 46, totalUnits: 49 },
        { date: "2021-11-05", totalSales: 90, totalUnits: 21 },
        { date: "2021-11-06", totalSales: 63, totalUnits: 11 },
        { date: "2021-11-07", totalSales: 27, totalUnits: 46 },
        { date: "2021-11-08", totalSales: 85, totalUnits: 39 },
        { date: "2021-11-09", totalSales: 32, totalUnits: 24 },
        { date: "2021-11-10", totalSales: 72, totalUnits: 21 },
        { date: "2021-11-11", totalSales: 54, totalUnits: 45 },
        { date: "2021-11-12", totalSales: 31, totalUnits: 11 },
        { date: "2021-11-13", totalSales: 54, totalUnits: 47 },
        { date: "2021-11-14", totalSales: 96, totalUnits: 15 },
        { date: "2021-11-15", totalSales: 1, totalUnits: 49 },
        { date: "2021-11-16", totalSales: 26, totalUnits: 23 },
        { date: "2021-11-17", totalSales: 54, totalUnits: 12 },
      ],
    },
    {
      _id: "6371259df03239528f000083",
      productId: "63701d24f0323944410002ec",
      yearlySalesTotal: 5826,
      yearlyTotalSoldUnits: 3386,
      monthlyData: [
        { month: "january", totalSales: 760, totalUnits: 333 },
        { month: "february", totalSales: 93, totalUnits: 335 },
        { month: "march", totalSales: 594, totalUnits: 72 },
        { month: "april", totalSales: 371, totalUnits: 494 },
        { month: "may", totalSales: 892, totalUnits: 106 },
        { month: "june", totalSales: 22, totalUnits: 38 },
        { month: "july", totalSales: 556, totalUnits: 277 },
        { month: "august", totalSales: 642, totalUnits: 438 },
        { month: "september", totalSales: 755, totalUnits: 66 },
        { month: "october", totalSales: 120, totalUnits: 41 },
        { month: "november", totalSales: 534, totalUnits: 247 },
        { month: "december", totalSales: 131, totalUnits: 311 },
      ],
      dailyData: [
        { date: "2021-01-02", totalSales: 34, totalUnits: 46 },
        { date: "2021-01-03", totalSales: 44, totalUnits: 48 },
        { date: "2021-01-04", totalSales: 51, totalUnits: 15 },
        { date: "2021-01-05", totalSales: 25, totalUnits: 2 },
        { date: "2021-01-06", totalSales: 14, totalUnits: 21 },
        { date: "2021-01-07", totalSales: 16, totalUnits: 32 },
        { date: "2021-01-08", totalSales: 32, totalUnits: 22 },
        { date: "2021-01-09", totalSales: 60, totalUnits: 39 },
        { date: "2021-01-10", totalSales: 62, totalUnits: 50 },
        { date: "2021-01-11", totalSales: 64, totalUnits: 27 },
        { date: "2021-01-12", totalSales: 1, totalUnits: 29 },
        { date: "2021-01-13", totalSales: 94, totalUnits: 4 },
        { date: "2021-01-14", totalSales: 86, totalUnits: 42 },
        { date: "2021-01-15", totalSales: 53, totalUnits: 33 },
        { date: "2021-01-16", totalSales: 29, totalUnits: 4 },
        { date: "2021-01-17", totalSales: 56, totalUnits: 15 },
        { date: "2021-01-18", totalSales: 91, totalUnits: 37 },
        { date: "2021-01-19", totalSales: 71, totalUnits: 31 },
        { date: "2021-01-20", totalSales: 34, totalUnits: 6 },
        { date: "2021-01-21", totalSales: 19, totalUnits: 1 },
        { date: "2021-01-22", totalSales: 17, totalUnits: 46 },
        { date: "2021-01-23", totalSales: 48, totalUnits: 14 },
        { date: "2021-01-24", totalSales: 66, totalUnits: 2 },
        { date: "2021-01-25", totalSales: 66, totalUnits: 40 },
        { date: "2021-01-26", totalSales: 87, totalUnits: 26 },
        { date: "2021-01-27", totalSales: 18, totalUnits: 6 },
        { date: "2021-01-28", totalSales: 91, totalUnits: 48 },
        { date: "2021-01-29", totalSales: 23, totalUnits: 50 },
        { date: "2021-01-30", totalSales: 34, totalUnits: 30 },
        { date: "2021-01-31", totalSales: 79, totalUnits: 7 },
        { date: "2021-02-01", totalSales: 46, totalUnits: 2 },
        { date: "2021-02-02", totalSales: 49, totalUnits: 24 },
        { date: "2021-02-03", totalSales: 99, totalUnits: 14 },
        { date: "2021-02-04", totalSales: 6, totalUnits: 12 },
        { date: "2021-02-05", totalSales: 93, totalUnits: 18 },
        { date: "2021-02-06", totalSales: 2, totalUnits: 43 },
        { date: "2021-02-07", totalSales: 76, totalUnits: 11 },
        { date: "2021-02-08", totalSales: 60, totalUnits: 6 },
        { date: "2021-02-09", totalSales: 73, totalUnits: 25 },
        { date: "2021-02-10", totalSales: 5, totalUnits: 3 },
        { date: "2021-02-11", totalSales: 55, totalUnits: 21 },
        { date: "2021-02-12", totalSales: 19, totalUnits: 15 },
        { date: "2021-02-13", totalSales: 68, totalUnits: 38 },
        { date: "2021-02-14", totalSales: 7, totalUnits: 40 },
        { date: "2021-02-15", totalSales: 31, totalUnits: 2 },
        { date: "2021-02-16", totalSales: 69, totalUnits: 47 },
        { date: "2021-02-17", totalSales: 95, totalUnits: 7 },
        { date: "2021-02-18", totalSales: 19, totalUnits: 6 },
        { date: "2021-02-19", totalSales: 41, totalUnits: 17 },
        { date: "2021-02-20", totalSales: 60, totalUnits: 11 },
        { date: "2021-02-21", totalSales: 24, totalUnits: 41 },
        { date: "2021-02-22", totalSales: 99, totalUnits: 12 },
        { date: "2021-02-23", totalSales: 85, totalUnits: 15 },
        { date: "2021-02-24", totalSales: 49, totalUnits: 4 },
        { date: "2021-02-25", totalSales: 76, totalUnits: 4 },
        { date: "2021-02-26", totalSales: 54, totalUnits: 43 },
        { date: "2021-02-27", totalSales: 28, totalUnits: 28 },
        { date: "2021-02-28", totalSales: 61, totalUnits: 17 },
        { date: "2021-03-01", totalSales: 57, totalUnits: 50 },
        { date: "2021-03-02", totalSales: 87, totalUnits: 6 },
        { date: "2021-03-03", totalSales: 36, totalUnits: 6 },
        { date: "2021-03-04", totalSales: 27, totalUnits: 41 },
        { date: "2021-03-05", totalSales: 100, totalUnits: 48 },
        { date: "2021-03-06", totalSales: 91, totalUnits: 5 },
        { date: "2021-03-07", totalSales: 52, totalUnits: 10 },
        { date: "2021-03-08", totalSales: 66, totalUnits: 3 },
        { date: "2021-03-09", totalSales: 97, totalUnits: 8 },
        { date: "2021-03-10", totalSales: 48, totalUnits: 25 },
        { date: "2021-03-11", totalSales: 43, totalUnits: 35 },
        { date: "2021-03-12", totalSales: 93, totalUnits: 34 },
        { date: "2021-03-13", totalSales: 16, totalUnits: 26 },
        { date: "2021-03-14", totalSales: 85, totalUnits: 10 },
        { date: "2021-03-15", totalSales: 39, totalUnits: 36 },
        { date: "2021-03-16", totalSales: 69, totalUnits: 30 },
        { date: "2021-03-17", totalSales: 90, totalUnits: 19 },
        { date: "2021-03-18", totalSales: 28, totalUnits: 34 },
        { date: "2021-03-19", totalSales: 5, totalUnits: 13 },
        { date: "2021-03-20", totalSales: 85, totalUnits: 14 },
        { date: "2021-03-21", totalSales: 41, totalUnits: 50 },
        { date: "2021-03-22", totalSales: 52, totalUnits: 13 },
        { date: "2021-03-23", totalSales: 13, totalUnits: 5 },
        { date: "2021-03-24", totalSales: 15, totalUnits: 4 },
        { date: "2021-03-25", totalSales: 59, totalUnits: 36 },
        { date: "2021-03-26", totalSales: 81, totalUnits: 49 },
        { date: "2021-03-27", totalSales: 96, totalUnits: 38 },
        { date: "2021-03-28", totalSales: 31, totalUnits: 27 },
        { date: "2021-03-29", totalSales: 80, totalUnits: 8 },
        { date: "2021-03-30", totalSales: 37, totalUnits: 27 },
        { date: "2021-03-31", totalSales: 94, totalUnits: 23 },
        { date: "2021-04-01", totalSales: 82, totalUnits: 14 },
        { date: "2021-04-02", totalSales: 81, totalUnits: 27 },
        { date: "2021-04-03", totalSales: 71, totalUnits: 27 },
        { date: "2021-04-04", totalSales: 67, totalUnits: 20 },
        { date: "2021-04-05", totalSales: 9, totalUnits: 47 },
        { date: "2021-04-06", totalSales: 16, totalUnits: 12 },
        { date: "2021-04-07", totalSales: 100, totalUnits: 4 },
        { date: "2021-04-08", totalSales: 64, totalUnits: 30 },
        { date: "2021-04-09", totalSales: 73, totalUnits: 43 },
        { date: "2021-04-10", totalSales: 10, totalUnits: 1 },
        { date: "2021-04-11", totalSales: 98, totalUnits: 26 },
        { date: "2021-04-12", totalSales: 4, totalUnits: 6 },
        { date: "2021-04-13", totalSales: 6, totalUnits: 36 },
        { date: "2021-04-14", totalSales: 13, totalUnits: 35 },
        { date: "2021-04-15", totalSales: 32, totalUnits: 9 },
        { date: "2021-04-16", totalSales: 55, totalUnits: 1 },
        { date: "2021-04-17", totalSales: 51, totalUnits: 50 },
        { date: "2021-04-18", totalSales: 91, totalUnits: 6 },
        { date: "2021-04-19", totalSales: 84, totalUnits: 6 },
        { date: "2021-04-20", totalSales: 9, totalUnits: 13 },
        { date: "2021-04-21", totalSales: 64, totalUnits: 20 },
        { date: "2021-04-22", totalSales: 100, totalUnits: 41 },
        { date: "2021-04-23", totalSales: 1, totalUnits: 47 },
        { date: "2021-04-24", totalSales: 76, totalUnits: 1 },
        { date: "2021-04-25", totalSales: 73, totalUnits: 15 },
        { date: "2021-04-26", totalSales: 66, totalUnits: 16 },
        { date: "2021-04-27", totalSales: 100, totalUnits: 43 },
        { date: "2021-04-28", totalSales: 92, totalUnits: 13 },
        { date: "2021-04-29", totalSales: 45, totalUnits: 31 },
        { date: "2021-04-30", totalSales: 19, totalUnits: 42 },
        { date: "2021-05-01", totalSales: 11, totalUnits: 5 },
        { date: "2021-05-02", totalSales: 26, totalUnits: 18 },
        { date: "2021-05-03", totalSales: 62, totalUnits: 19 },
        { date: "2021-05-04", totalSales: 94, totalUnits: 48 },
        { date: "2021-05-05", totalSales: 30, totalUnits: 22 },
        { date: "2021-05-06", totalSales: 15, totalUnits: 22 },
        { date: "2021-05-07", totalSales: 51, totalUnits: 30 },
        { date: "2021-05-08", totalSales: 57, totalUnits: 3 },
        { date: "2021-05-09", totalSales: 70, totalUnits: 27 },
        { date: "2021-05-10", totalSales: 14, totalUnits: 27 },
        { date: "2021-05-11", totalSales: 40, totalUnits: 41 },
        { date: "2021-05-12", totalSales: 23, totalUnits: 22 },
        { date: "2021-05-13", totalSales: 13, totalUnits: 24 },
        { date: "2021-05-14", totalSales: 1, totalUnits: 3 },
        { date: "2021-05-15", totalSales: 22, totalUnits: 1 },
        { date: "2021-05-16", totalSales: 49, totalUnits: 14 },
        { date: "2021-05-17", totalSales: 25, totalUnits: 36 },
        { date: "2021-05-18", totalSales: 10, totalUnits: 12 },
        { date: "2021-05-19", totalSales: 56, totalUnits: 29 },
        { date: "2021-05-20", totalSales: 20, totalUnits: 32 },
        { date: "2021-05-21", totalSales: 14, totalUnits: 13 },
        { date: "2021-05-22", totalSales: 25, totalUnits: 27 },
        { date: "2021-05-23", totalSales: 1, totalUnits: 7 },
        { date: "2021-05-24", totalSales: 64, totalUnits: 18 },
        { date: "2021-05-25", totalSales: 32, totalUnits: 47 },
        { date: "2021-05-26", totalSales: 50, totalUnits: 15 },
        { date: "2021-05-27", totalSales: 33, totalUnits: 30 },
        { date: "2021-05-28", totalSales: 32, totalUnits: 22 },
        { date: "2021-05-29", totalSales: 69, totalUnits: 7 },
        { date: "2021-05-30", totalSales: 95, totalUnits: 14 },
        { date: "2021-05-31", totalSales: 49, totalUnits: 20 },
        { date: "2021-06-01", totalSales: 27, totalUnits: 34 },
        { date: "2021-06-02", totalSales: 70, totalUnits: 26 },
        { date: "2021-06-03", totalSales: 24, totalUnits: 39 },
        { date: "2021-06-04", totalSales: 47, totalUnits: 11 },
        { date: "2021-06-05", totalSales: 55, totalUnits: 11 },
        { date: "2021-06-06", totalSales: 32, totalUnits: 42 },
        { date: "2021-06-07", totalSales: 74, totalUnits: 7 },
        { date: "2021-06-08", totalSales: 11, totalUnits: 3 },
        { date: "2021-06-09", totalSales: 36, totalUnits: 14 },
        { date: "2021-06-10", totalSales: 30, totalUnits: 27 },
        { date: "2021-06-11", totalSales: 30, totalUnits: 45 },
        { date: "2021-06-12", totalSales: 77, totalUnits: 13 },
        { date: "2021-06-13", totalSales: 79, totalUnits: 25 },
        { date: "2021-06-14", totalSales: 39, totalUnits: 32 },
        { date: "2021-06-15", totalSales: 99, totalUnits: 36 },
        { date: "2021-06-16", totalSales: 48, totalUnits: 27 },
        { date: "2021-06-17", totalSales: 31, totalUnits: 33 },
        { date: "2021-06-18", totalSales: 68, totalUnits: 34 },
        { date: "2021-06-19", totalSales: 4, totalUnits: 49 },
        { date: "2021-06-20", totalSales: 76, totalUnits: 11 },
        { date: "2021-06-21", totalSales: 33, totalUnits: 29 },
        { date: "2021-06-22", totalSales: 80, totalUnits: 6 },
        { date: "2021-06-23", totalSales: 97, totalUnits: 25 },
        { date: "2021-06-24", totalSales: 3, totalUnits: 26 },
        { date: "2021-06-25", totalSales: 20, totalUnits: 18 },
        { date: "2021-06-26", totalSales: 48, totalUnits: 35 },
        { date: "2021-06-27", totalSales: 23, totalUnits: 12 },
        { date: "2021-06-28", totalSales: 64, totalUnits: 4 },
        { date: "2021-06-29", totalSales: 39, totalUnits: 20 },
        { date: "2021-06-30", totalSales: 4, totalUnits: 23 },
        { date: "2021-07-01", totalSales: 46, totalUnits: 25 },
        { date: "2021-07-02", totalSales: 4, totalUnits: 49 },
        { date: "2021-07-03", totalSales: 18, totalUnits: 15 },
        { date: "2021-07-04", totalSales: 84, totalUnits: 4 },
        { date: "2021-07-05", totalSales: 5, totalUnits: 3 },
        { date: "2021-07-06", totalSales: 65, totalUnits: 49 },
        { date: "2021-07-07", totalSales: 91, totalUnits: 36 },
        { date: "2021-07-08", totalSales: 98, totalUnits: 4 },
        { date: "2021-07-09", totalSales: 6, totalUnits: 26 },
        { date: "2021-07-10", totalSales: 38, totalUnits: 8 },
        { date: "2021-07-11", totalSales: 60, totalUnits: 20 },
        { date: "2021-07-12", totalSales: 24, totalUnits: 30 },
        { date: "2021-07-13", totalSales: 24, totalUnits: 35 },
        { date: "2021-07-14", totalSales: 44, totalUnits: 20 },
        { date: "2021-07-15", totalSales: 30, totalUnits: 22 },
        { date: "2021-07-16", totalSales: 21, totalUnits: 8 },
        { date: "2021-07-17", totalSales: 27, totalUnits: 1 },
        { date: "2021-07-18", totalSales: 85, totalUnits: 43 },
        { date: "2021-07-19", totalSales: 8, totalUnits: 11 },
        { date: "2021-07-20", totalSales: 45, totalUnits: 46 },
        { date: "2021-07-21", totalSales: 10, totalUnits: 44 },
        { date: "2021-07-22", totalSales: 76, totalUnits: 15 },
        { date: "2021-07-23", totalSales: 12, totalUnits: 25 },
        { date: "2021-07-24", totalSales: 60, totalUnits: 38 },
        { date: "2021-07-25", totalSales: 76, totalUnits: 23 },
        { date: "2021-07-26", totalSales: 72, totalUnits: 32 },
        { date: "2021-07-27", totalSales: 7, totalUnits: 14 },
        { date: "2021-07-28", totalSales: 95, totalUnits: 27 },
        { date: "2021-07-29", totalSales: 95, totalUnits: 48 },
        { date: "2021-07-30", totalSales: 3, totalUnits: 21 },
        { date: "2021-07-31", totalSales: 1, totalUnits: 30 },
        { date: "2021-08-01", totalSales: 73, totalUnits: 25 },
        { date: "2021-08-02", totalSales: 16, totalUnits: 6 },
        { date: "2021-08-03", totalSales: 41, totalUnits: 23 },
        { date: "2021-08-04", totalSales: 97, totalUnits: 47 },
        { date: "2021-08-05", totalSales: 50, totalUnits: 39 },
        { date: "2021-08-06", totalSales: 53, totalUnits: 1 },
        { date: "2021-08-07", totalSales: 86, totalUnits: 40 },
        { date: "2021-08-08", totalSales: 73, totalUnits: 35 },
        { date: "2021-08-09", totalSales: 10, totalUnits: 36 },
        { date: "2021-08-10", totalSales: 95, totalUnits: 25 },
        { date: "2021-08-11", totalSales: 27, totalUnits: 23 },
        { date: "2021-08-12", totalSales: 69, totalUnits: 45 },
        { date: "2021-08-13", totalSales: 76, totalUnits: 48 },
        { date: "2021-08-14", totalSales: 14, totalUnits: 27 },
        { date: "2021-08-15", totalSales: 83, totalUnits: 7 },
        { date: "2021-08-16", totalSales: 79, totalUnits: 24 },
        { date: "2021-08-17", totalSales: 54, totalUnits: 45 },
        { date: "2021-08-18", totalSales: 76, totalUnits: 8 },
        { date: "2021-08-19", totalSales: 98, totalUnits: 44 },
        { date: "2021-08-20", totalSales: 53, totalUnits: 26 },
        { date: "2021-08-21", totalSales: 64, totalUnits: 34 },
        { date: "2021-08-22", totalSales: 72, totalUnits: 1 },
        { date: "2021-08-23", totalSales: 40, totalUnits: 35 },
        { date: "2021-08-24", totalSales: 69, totalUnits: 33 },
        { date: "2021-08-25", totalSales: 59, totalUnits: 24 },
        { date: "2021-08-26", totalSales: 13, totalUnits: 4 },
        { date: "2021-08-27", totalSales: 98, totalUnits: 38 },
        { date: "2021-08-28", totalSales: 17, totalUnits: 10 },
        { date: "2021-08-29", totalSales: 57, totalUnits: 36 },
        { date: "2021-08-30", totalSales: 55, totalUnits: 25 },
        { date: "2021-08-31", totalSales: 96, totalUnits: 27 },
        { date: "2021-09-01", totalSales: 1, totalUnits: 45 },
        { date: "2021-09-02", totalSales: 32, totalUnits: 34 },
        { date: "2021-09-03", totalSales: 73, totalUnits: 50 },
        { date: "2021-09-04", totalSales: 21, totalUnits: 38 },
        { date: "2021-09-05", totalSales: 81, totalUnits: 21 },
        { date: "2021-09-06", totalSales: 59, totalUnits: 6 },
        { date: "2021-09-07", totalSales: 32, totalUnits: 34 },
        { date: "2021-09-08", totalSales: 46, totalUnits: 19 },
        { date: "2021-09-09", totalSales: 74, totalUnits: 13 },
        { date: "2021-09-10", totalSales: 5, totalUnits: 45 },
        { date: "2021-09-11", totalSales: 63, totalUnits: 16 },
        { date: "2021-09-12", totalSales: 74, totalUnits: 2 },
        { date: "2021-09-13", totalSales: 38, totalUnits: 10 },
        { date: "2021-09-14", totalSales: 4, totalUnits: 37 },
        { date: "2021-09-15", totalSales: 11, totalUnits: 1 },
        { date: "2021-09-16", totalSales: 84, totalUnits: 25 },
        { date: "2021-09-17", totalSales: 15, totalUnits: 19 },
        { date: "2021-09-18", totalSales: 91, totalUnits: 1 },
        { date: "2021-09-19", totalSales: 87, totalUnits: 46 },
        { date: "2021-09-20", totalSales: 100, totalUnits: 27 },
        { date: "2021-09-21", totalSales: 49, totalUnits: 37 },
        { date: "2021-09-22", totalSales: 96, totalUnits: 1 },
        { date: "2021-09-23", totalSales: 44, totalUnits: 40 },
        { date: "2021-09-24", totalSales: 85, totalUnits: 50 },
        { date: "2021-09-25", totalSales: 63, totalUnits: 11 },
        { date: "2021-09-26", totalSales: 5, totalUnits: 35 },
        { date: "2021-09-27", totalSales: 22, totalUnits: 1 },
        { date: "2021-09-28", totalSales: 100, totalUnits: 1 },
        { date: "2021-09-29", totalSales: 14, totalUnits: 45 },
        { date: "2021-09-30", totalSales: 27, totalUnits: 14 },
        { date: "2021-10-01", totalSales: 50, totalUnits: 5 },
        { date: "2021-10-02", totalSales: 24, totalUnits: 34 },
        { date: "2021-10-03", totalSales: 52, totalUnits: 22 },
        { date: "2021-10-04", totalSales: 22, totalUnits: 47 },
        { date: "2021-10-05", totalSales: 86, totalUnits: 20 },
        { date: "2021-10-06", totalSales: 65, totalUnits: 19 },
        { date: "2021-10-07", totalSales: 33, totalUnits: 23 },
        { date: "2021-10-08", totalSales: 35, totalUnits: 29 },
        { date: "2021-10-09", totalSales: 29, totalUnits: 2 },
        { date: "2021-10-10", totalSales: 60, totalUnits: 34 },
        { date: "2021-10-11", totalSales: 36, totalUnits: 21 },
        { date: "2021-10-12", totalSales: 24, totalUnits: 6 },
        { date: "2021-10-13", totalSales: 29, totalUnits: 36 },
        { date: "2021-10-14", totalSales: 25, totalUnits: 28 },
        { date: "2021-10-15", totalSales: 38, totalUnits: 40 },
        { date: "2021-10-16", totalSales: 31, totalUnits: 49 },
        { date: "2021-10-17", totalSales: 9, totalUnits: 15 },
        { date: "2021-10-18", totalSales: 14, totalUnits: 14 },
        { date: "2021-10-19", totalSales: 58, totalUnits: 1 },
        { date: "2021-10-20", totalSales: 8, totalUnits: 16 },
        { date: "2021-10-21", totalSales: 29, totalUnits: 4 },
        { date: "2021-10-22", totalSales: 97, totalUnits: 36 },
        { date: "2021-10-23", totalSales: 45, totalUnits: 11 },
        { date: "2021-10-24", totalSales: 25, totalUnits: 25 },
        { date: "2021-10-25", totalSales: 37, totalUnits: 48 },
        { date: "2021-10-26", totalSales: 79, totalUnits: 16 },
        { date: "2021-10-27", totalSales: 17, totalUnits: 29 },
        { date: "2021-10-28", totalSales: 45, totalUnits: 1 },
        { date: "2021-10-29", totalSales: 80, totalUnits: 27 },
        { date: "2021-10-30", totalSales: 68, totalUnits: 10 },
        { date: "2021-10-31", totalSales: 41, totalUnits: 36 },
        { date: "2021-11-01", totalSales: 45, totalUnits: 4 },
        { date: "2021-11-02", totalSales: 85, totalUnits: 11 },
        { date: "2021-11-03", totalSales: 75, totalUnits: 17 },
        { date: "2021-11-04", totalSales: 77, totalUnits: 35 },
        { date: "2021-11-05", totalSales: 38, totalUnits: 50 },
        { date: "2021-11-06", totalSales: 52, totalUnits: 12 },
        { date: "2021-11-07", totalSales: 40, totalUnits: 37 },
        { date: "2021-11-08", totalSales: 12, totalUnits: 42 },
        { date: "2021-11-09", totalSales: 24, totalUnits: 46 },
        { date: "2021-11-10", totalSales: 55, totalUnits: 36 },
        { date: "2021-11-11", totalSales: 37, totalUnits: 16 },
        { date: "2021-11-12", totalSales: 43, totalUnits: 19 },
        { date: "2021-11-13", totalSales: 28, totalUnits: 30 },
        { date: "2021-11-14", totalSales: 15, totalUnits: 28 },
        { date: "2021-11-15", totalSales: 99, totalUnits: 9 },
        { date: "2021-11-16", totalSales: 50, totalUnits: 16 },
        { date: "2021-11-17", totalSales: 60, totalUnits: 4 },
      ],
    },
    {
      _id: "6371259ef03239f09e0001fc",
      productId: "63701d24f0323944410002ed",
      yearlySalesTotal: 2947,
      yearlyTotalSoldUnits: 1203,
      monthlyData: [
        { month: "january", totalSales: 686, totalUnits: 154 },
        { month: "february", totalSales: 927, totalUnits: 455 },
        { month: "march", totalSales: 946, totalUnits: 227 },
        { month: "april", totalSales: 77, totalUnits: 137 },
        { month: "may", totalSales: 272, totalUnits: 72 },
        { month: "june", totalSales: 476, totalUnits: 268 },
        { month: "july", totalSales: 432, totalUnits: 71 },
        { month: "august", totalSales: 875, totalUnits: 60 },
        { month: "september", totalSales: 88, totalUnits: 418 },
        { month: "october", totalSales: 190, totalUnits: 392 },
        { month: "november", totalSales: 89, totalUnits: 199 },
        { month: "december", totalSales: 820, totalUnits: 58 },
      ],
      dailyData: [
        { date: "2021-01-02", totalSales: 86, totalUnits: 21 },
        { date: "2021-01-03", totalSales: 10, totalUnits: 39 },
        { date: "2021-01-04", totalSales: 14, totalUnits: 20 },
        { date: "2021-01-05", totalSales: 82, totalUnits: 7 },
        { date: "2021-01-06", totalSales: 30, totalUnits: 36 },
        { date: "2021-01-07", totalSales: 48, totalUnits: 28 },
        { date: "2021-01-08", totalSales: 79, totalUnits: 4 },
        { date: "2021-01-09", totalSales: 95, totalUnits: 3 },
        { date: "2021-01-10", totalSales: 77, totalUnits: 20 },
        { date: "2021-01-11", totalSales: 40, totalUnits: 47 },
        { date: "2021-01-12", totalSales: 35, totalUnits: 49 },
        { date: "2021-01-13", totalSales: 22, totalUnits: 36 },
        { date: "2021-01-14", totalSales: 17, totalUnits: 24 },
        { date: "2021-01-15", totalSales: 16, totalUnits: 15 },
        { date: "2021-01-16", totalSales: 45, totalUnits: 5 },
        { date: "2021-01-17", totalSales: 12, totalUnits: 10 },
        { date: "2021-01-18", totalSales: 5, totalUnits: 48 },
        { date: "2021-01-19", totalSales: 53, totalUnits: 5 },
        { date: "2021-01-20", totalSales: 100, totalUnits: 17 },
        { date: "2021-01-21", totalSales: 1, totalUnits: 30 },
        { date: "2021-01-22", totalSales: 19, totalUnits: 35 },
        { date: "2021-01-23", totalSales: 52, totalUnits: 24 },
        { date: "2021-01-24", totalSales: 86, totalUnits: 36 },
        { date: "2021-01-25", totalSales: 2, totalUnits: 17 },
        { date: "2021-01-26", totalSales: 84, totalUnits: 27 },
        { date: "2021-01-27", totalSales: 17, totalUnits: 27 },
        { date: "2021-01-28", totalSales: 82, totalUnits: 43 },
        { date: "2021-01-29", totalSales: 57, totalUnits: 29 },
        { date: "2021-01-30", totalSales: 45, totalUnits: 9 },
        { date: "2021-01-31", totalSales: 39, totalUnits: 36 },
        { date: "2021-02-01", totalSales: 3, totalUnits: 20 },
        { date: "2021-02-02", totalSales: 99, totalUnits: 39 },
        { date: "2021-02-03", totalSales: 66, totalUnits: 4 },
        { date: "2021-02-04", totalSales: 31, totalUnits: 2 },
        { date: "2021-02-05", totalSales: 1, totalUnits: 27 },
        { date: "2021-02-06", totalSales: 15, totalUnits: 41 },
        { date: "2021-02-07", totalSales: 93, totalUnits: 27 },
        { date: "2021-02-08", totalSales: 61, totalUnits: 24 },
        { date: "2021-02-09", totalSales: 45, totalUnits: 6 },
        { date: "2021-02-10", totalSales: 57, totalUnits: 44 },
        { date: "2021-02-11", totalSales: 13, totalUnits: 8 },
        { date: "2021-02-12", totalSales: 50, totalUnits: 2 },
        { date: "2021-02-13", totalSales: 29, totalUnits: 40 },
        { date: "2021-02-14", totalSales: 77, totalUnits: 12 },
        { date: "2021-02-15", totalSales: 35, totalUnits: 32 },
        { date: "2021-02-16", totalSales: 93, totalUnits: 32 },
        { date: "2021-02-17", totalSales: 48, totalUnits: 27 },
        { date: "2021-02-18", totalSales: 61, totalUnits: 17 },
        { date: "2021-02-19", totalSales: 43, totalUnits: 12 },
        { date: "2021-02-20", totalSales: 47, totalUnits: 37 },
        { date: "2021-02-21", totalSales: 10, totalUnits: 24 },
        { date: "2021-02-22", totalSales: 12, totalUnits: 28 },
        { date: "2021-02-23", totalSales: 41, totalUnits: 48 },
        { date: "2021-02-24", totalSales: 4, totalUnits: 45 },
        { date: "2021-02-25", totalSales: 28, totalUnits: 37 },
        { date: "2021-02-26", totalSales: 78, totalUnits: 28 },
        { date: "2021-02-27", totalSales: 4, totalUnits: 24 },
        { date: "2021-02-28", totalSales: 20, totalUnits: 41 },
        { date: "2021-03-01", totalSales: 27, totalUnits: 19 },
        { date: "2021-03-02", totalSales: 76, totalUnits: 26 },
        { date: "2021-03-03", totalSales: 99, totalUnits: 46 },
        { date: "2021-03-04", totalSales: 28, totalUnits: 39 },
        { date: "2021-03-05", totalSales: 49, totalUnits: 30 },
        { date: "2021-03-06", totalSales: 19, totalUnits: 12 },
        { date: "2021-03-07", totalSales: 93, totalUnits: 32 },
        { date: "2021-03-08", totalSales: 77, totalUnits: 21 },
        { date: "2021-03-09", totalSales: 27, totalUnits: 1 },
        { date: "2021-03-10", totalSales: 84, totalUnits: 17 },
        { date: "2021-03-11", totalSales: 99, totalUnits: 27 },
        { date: "2021-03-12", totalSales: 30, totalUnits: 37 },
        { date: "2021-03-13", totalSales: 56, totalUnits: 23 },
        { date: "2021-03-14", totalSales: 88, totalUnits: 37 },
        { date: "2021-03-15", totalSales: 2, totalUnits: 36 },
        { date: "2021-03-16", totalSales: 14, totalUnits: 25 },
        { date: "2021-03-17", totalSales: 78, totalUnits: 40 },
        { date: "2021-03-18", totalSales: 41, totalUnits: 48 },
        { date: "2021-03-19", totalSales: 100, totalUnits: 48 },
        { date: "2021-03-20", totalSales: 83, totalUnits: 50 },
        { date: "2021-03-21", totalSales: 46, totalUnits: 10 },
        { date: "2021-03-22", totalSales: 56, totalUnits: 9 },
        { date: "2021-03-23", totalSales: 85, totalUnits: 14 },
        { date: "2021-03-24", totalSales: 57, totalUnits: 7 },
        { date: "2021-03-25", totalSales: 33, totalUnits: 19 },
        { date: "2021-03-26", totalSales: 50, totalUnits: 30 },
        { date: "2021-03-27", totalSales: 65, totalUnits: 43 },
        { date: "2021-03-28", totalSales: 90, totalUnits: 36 },
        { date: "2021-03-29", totalSales: 28, totalUnits: 15 },
        { date: "2021-03-30", totalSales: 13, totalUnits: 20 },
        { date: "2021-03-31", totalSales: 51, totalUnits: 47 },
        { date: "2021-04-01", totalSales: 32, totalUnits: 20 },
        { date: "2021-04-02", totalSales: 9, totalUnits: 19 },
        { date: "2021-04-03", totalSales: 88, totalUnits: 6 },
        { date: "2021-04-04", totalSales: 30, totalUnits: 25 },
        { date: "2021-04-05", totalSales: 95, totalUnits: 37 },
        { date: "2021-04-06", totalSales: 59, totalUnits: 26 },
        { date: "2021-04-07", totalSales: 68, totalUnits: 3 },
        { date: "2021-04-08", totalSales: 15, totalUnits: 37 },
        { date: "2021-04-09", totalSales: 1, totalUnits: 40 },
        { date: "2021-04-10", totalSales: 40, totalUnits: 7 },
        { date: "2021-04-11", totalSales: 94, totalUnits: 16 },
        { date: "2021-04-12", totalSales: 27, totalUnits: 9 },
        { date: "2021-04-13", totalSales: 78, totalUnits: 44 },
        { date: "2021-04-14", totalSales: 70, totalUnits: 31 },
        { date: "2021-04-15", totalSales: 68, totalUnits: 11 },
        { date: "2021-04-16", totalSales: 26, totalUnits: 45 },
        { date: "2021-04-17", totalSales: 51, totalUnits: 19 },
        { date: "2021-04-18", totalSales: 40, totalUnits: 8 },
        { date: "2021-04-19", totalSales: 24, totalUnits: 39 },
        { date: "2021-04-20", totalSales: 17, totalUnits: 37 },
        { date: "2021-04-21", totalSales: 31, totalUnits: 41 },
        { date: "2021-04-22", totalSales: 69, totalUnits: 4 },
        { date: "2021-04-23", totalSales: 20, totalUnits: 34 },
        { date: "2021-04-24", totalSales: 49, totalUnits: 14 },
        { date: "2021-04-25", totalSales: 25, totalUnits: 32 },
        { date: "2021-04-26", totalSales: 36, totalUnits: 15 },
        { date: "2021-04-27", totalSales: 55, totalUnits: 37 },
        { date: "2021-04-28", totalSales: 94, totalUnits: 24 },
        { date: "2021-04-29", totalSales: 56, totalUnits: 2 },
        { date: "2021-04-30", totalSales: 53, totalUnits: 2 },
        { date: "2021-05-01", totalSales: 43, totalUnits: 24 },
        { date: "2021-05-02", totalSales: 42, totalUnits: 11 },
        { date: "2021-05-03", totalSales: 61, totalUnits: 48 },
        { date: "2021-05-04", totalSales: 59, totalUnits: 44 },
        { date: "2021-05-05", totalSales: 97, totalUnits: 3 },
        { date: "2021-05-06", totalSales: 18, totalUnits: 48 },
        { date: "2021-05-07", totalSales: 14, totalUnits: 9 },
        { date: "2021-05-08", totalSales: 97, totalUnits: 34 },
        { date: "2021-05-09", totalSales: 39, totalUnits: 46 },
        { date: "2021-05-10", totalSales: 98, totalUnits: 35 },
        { date: "2021-05-11", totalSales: 39, totalUnits: 2 },
        { date: "2021-05-12", totalSales: 3, totalUnits: 22 },
        { date: "2021-05-13", totalSales: 75, totalUnits: 2 },
        { date: "2021-05-14", totalSales: 15, totalUnits: 43 },
        { date: "2021-05-15", totalSales: 66, totalUnits: 11 },
        { date: "2021-05-16", totalSales: 18, totalUnits: 46 },
        { date: "2021-05-17", totalSales: 20, totalUnits: 33 },
        { date: "2021-05-18", totalSales: 65, totalUnits: 22 },
        { date: "2021-05-19", totalSales: 7, totalUnits: 4 },
        { date: "2021-05-20", totalSales: 69, totalUnits: 17 },
        { date: "2021-05-21", totalSales: 12, totalUnits: 5 },
        { date: "2021-05-22", totalSales: 76, totalUnits: 14 },
        { date: "2021-05-23", totalSales: 46, totalUnits: 18 },
        { date: "2021-05-24", totalSales: 48, totalUnits: 40 },
        { date: "2021-05-25", totalSales: 84, totalUnits: 48 },
        { date: "2021-05-26", totalSales: 73, totalUnits: 31 },
        { date: "2021-05-27", totalSales: 87, totalUnits: 19 },
        { date: "2021-05-28", totalSales: 7, totalUnits: 26 },
        { date: "2021-05-29", totalSales: 21, totalUnits: 30 },
        { date: "2021-05-30", totalSales: 26, totalUnits: 5 },
        { date: "2021-05-31", totalSales: 29, totalUnits: 20 },
        { date: "2021-06-01", totalSales: 36, totalUnits: 22 },
        { date: "2021-06-02", totalSales: 16, totalUnits: 1 },
        { date: "2021-06-03", totalSales: 65, totalUnits: 18 },
        { date: "2021-06-04", totalSales: 50, totalUnits: 36 },
        { date: "2021-06-05", totalSales: 74, totalUnits: 35 },
        { date: "2021-06-06", totalSales: 40, totalUnits: 44 },
        { date: "2021-06-07", totalSales: 70, totalUnits: 25 },
        { date: "2021-06-08", totalSales: 89, totalUnits: 21 },
        { date: "2021-06-09", totalSales: 37, totalUnits: 46 },
        { date: "2021-06-10", totalSales: 74, totalUnits: 31 },
        { date: "2021-06-11", totalSales: 71, totalUnits: 31 },
        { date: "2021-06-12", totalSales: 54, totalUnits: 39 },
        { date: "2021-06-13", totalSales: 12, totalUnits: 6 },
        { date: "2021-06-14", totalSales: 70, totalUnits: 30 },
        { date: "2021-06-15", totalSales: 80, totalUnits: 49 },
        { date: "2021-06-16", totalSales: 25, totalUnits: 15 },
        { date: "2021-06-17", totalSales: 80, totalUnits: 41 },
        { date: "2021-06-18", totalSales: 16, totalUnits: 8 },
        { date: "2021-06-19", totalSales: 14, totalUnits: 16 },
        { date: "2021-06-20", totalSales: 66, totalUnits: 41 },
        { date: "2021-06-21", totalSales: 48, totalUnits: 19 },
        { date: "2021-06-22", totalSales: 71, totalUnits: 35 },
        { date: "2021-06-23", totalSales: 65, totalUnits: 6 },
        { date: "2021-06-24", totalSales: 11, totalUnits: 13 },
        { date: "2021-06-25", totalSales: 22, totalUnits: 25 },
        { date: "2021-06-26", totalSales: 8, totalUnits: 46 },
        { date: "2021-06-27", totalSales: 75, totalUnits: 28 },
        { date: "2021-06-28", totalSales: 73, totalUnits: 9 },
        { date: "2021-06-29", totalSales: 90, totalUnits: 1 },
        { date: "2021-06-30", totalSales: 23, totalUnits: 33 },
        { date: "2021-07-01", totalSales: 9, totalUnits: 25 },
        { date: "2021-07-02", totalSales: 35, totalUnits: 29 },
        { date: "2021-07-03", totalSales: 65, totalUnits: 36 },
        { date: "2021-07-04", totalSales: 90, totalUnits: 18 },
        { date: "2021-07-05", totalSales: 36, totalUnits: 24 },
        { date: "2021-07-06", totalSales: 19, totalUnits: 2 },
        { date: "2021-07-07", totalSales: 23, totalUnits: 1 },
        { date: "2021-07-08", totalSales: 27, totalUnits: 39 },
        { date: "2021-07-09", totalSales: 33, totalUnits: 42 },
        { date: "2021-07-10", totalSales: 32, totalUnits: 46 },
        { date: "2021-07-11", totalSales: 24, totalUnits: 4 },
        { date: "2021-07-12", totalSales: 49, totalUnits: 10 },
        { date: "2021-07-13", totalSales: 43, totalUnits: 1 },
        { date: "2021-07-14", totalSales: 89, totalUnits: 24 },
        { date: "2021-07-15", totalSales: 31, totalUnits: 38 },
        { date: "2021-07-16", totalSales: 2, totalUnits: 20 },
        { date: "2021-07-17", totalSales: 29, totalUnits: 23 },
        { date: "2021-07-18", totalSales: 75, totalUnits: 8 },
        { date: "2021-07-19", totalSales: 39, totalUnits: 19 },
        { date: "2021-07-20", totalSales: 3, totalUnits: 22 },
        { date: "2021-07-21", totalSales: 13, totalUnits: 17 },
        { date: "2021-07-22", totalSales: 33, totalUnits: 22 },
        { date: "2021-07-23", totalSales: 99, totalUnits: 16 },
        { date: "2021-07-24", totalSales: 69, totalUnits: 31 },
        { date: "2021-07-25", totalSales: 98, totalUnits: 47 },
        { date: "2021-07-26", totalSales: 88, totalUnits: 42 },
        { date: "2021-07-27", totalSales: 96, totalUnits: 44 },
        { date: "2021-07-28", totalSales: 54, totalUnits: 12 },
        { date: "2021-07-29", totalSales: 47, totalUnits: 10 },
        { date: "2021-07-30", totalSales: 57, totalUnits: 22 },
        { date: "2021-07-31", totalSales: 40, totalUnits: 37 },
        { date: "2021-08-01", totalSales: 8, totalUnits: 6 },
        { date: "2021-08-02", totalSales: 26, totalUnits: 40 },
        { date: "2021-08-03", totalSales: 74, totalUnits: 8 },
        { date: "2021-08-04", totalSales: 90, totalUnits: 22 },
        { date: "2021-08-05", totalSales: 85, totalUnits: 25 },
        { date: "2021-08-06", totalSales: 52, totalUnits: 6 },
        { date: "2021-08-07", totalSales: 73, totalUnits: 49 },
        { date: "2021-08-08", totalSales: 37, totalUnits: 8 },
        { date: "2021-08-09", totalSales: 14, totalUnits: 29 },
        { date: "2021-08-10", totalSales: 28, totalUnits: 37 },
        { date: "2021-08-11", totalSales: 43, totalUnits: 22 },
        { date: "2021-08-12", totalSales: 66, totalUnits: 2 },
        { date: "2021-08-13", totalSales: 98, totalUnits: 30 },
        { date: "2021-08-14", totalSales: 5, totalUnits: 21 },
        { date: "2021-08-15", totalSales: 2, totalUnits: 24 },
        { date: "2021-08-16", totalSales: 50, totalUnits: 29 },
        { date: "2021-08-17", totalSales: 44, totalUnits: 6 },
        { date: "2021-08-18", totalSales: 12, totalUnits: 40 },
        { date: "2021-08-19", totalSales: 51, totalUnits: 48 },
        { date: "2021-08-20", totalSales: 33, totalUnits: 40 },
        { date: "2021-08-21", totalSales: 65, totalUnits: 24 },
        { date: "2021-08-22", totalSales: 23, totalUnits: 16 },
        { date: "2021-08-23", totalSales: 33, totalUnits: 23 },
        { date: "2021-08-24", totalSales: 15, totalUnits: 35 },
        { date: "2021-08-25", totalSales: 79, totalUnits: 4 },
        { date: "2021-08-26", totalSales: 9, totalUnits: 27 },
        { date: "2021-08-27", totalSales: 48, totalUnits: 29 },
        { date: "2021-08-28", totalSales: 45, totalUnits: 42 },
        { date: "2021-08-29", totalSales: 40, totalUnits: 26 },
        { date: "2021-08-30", totalSales: 32, totalUnits: 39 },
        { date: "2021-08-31", totalSales: 14, totalUnits: 10 },
        { date: "2021-09-01", totalSales: 55, totalUnits: 4 },
        { date: "2021-09-02", totalSales: 53, totalUnits: 15 },
        { date: "2021-09-03", totalSales: 75, totalUnits: 39 },
        { date: "2021-09-04", totalSales: 99, totalUnits: 6 },
        { date: "2021-09-05", totalSales: 24, totalUnits: 45 },
        { date: "2021-09-06", totalSales: 47, totalUnits: 13 },
        { date: "2021-09-07", totalSales: 21, totalUnits: 50 },
        { date: "2021-09-08", totalSales: 96, totalUnits: 43 },
        { date: "2021-09-09", totalSales: 90, totalUnits: 34 },
        { date: "2021-09-10", totalSales: 97, totalUnits: 31 },
        { date: "2021-09-11", totalSales: 17, totalUnits: 26 },
        { date: "2021-09-12", totalSales: 83, totalUnits: 7 },
        { date: "2021-09-13", totalSales: 53, totalUnits: 13 },
        { date: "2021-09-14", totalSales: 18, totalUnits: 18 },
        { date: "2021-09-15", totalSales: 57, totalUnits: 30 },
        { date: "2021-09-16", totalSales: 68, totalUnits: 24 },
        { date: "2021-09-17", totalSales: 2, totalUnits: 35 },
        { date: "2021-09-18", totalSales: 27, totalUnits: 21 },
        { date: "2021-09-19", totalSales: 5, totalUnits: 42 },
        { date: "2021-09-20", totalSales: 50, totalUnits: 7 },
        { date: "2021-09-21", totalSales: 14, totalUnits: 22 },
        { date: "2021-09-22", totalSales: 100, totalUnits: 37 },
        { date: "2021-09-23", totalSales: 3, totalUnits: 11 },
        { date: "2021-09-24", totalSales: 29, totalUnits: 17 },
        { date: "2021-09-25", totalSales: 67, totalUnits: 35 },
        { date: "2021-09-26", totalSales: 63, totalUnits: 13 },
        { date: "2021-09-27", totalSales: 57, totalUnits: 24 },
        { date: "2021-09-28", totalSales: 16, totalUnits: 47 },
        { date: "2021-09-29", totalSales: 11, totalUnits: 9 },
        { date: "2021-09-30", totalSales: 20, totalUnits: 36 },
        { date: "2021-10-01", totalSales: 60, totalUnits: 12 },
        { date: "2021-10-02", totalSales: 85, totalUnits: 6 },
        { date: "2021-10-03", totalSales: 45, totalUnits: 5 },
        { date: "2021-10-04", totalSales: 19, totalUnits: 24 },
        { date: "2021-10-05", totalSales: 61, totalUnits: 14 },
        { date: "2021-10-06", totalSales: 72, totalUnits: 13 },
        { date: "2021-10-07", totalSales: 58, totalUnits: 28 },
        { date: "2021-10-08", totalSales: 31, totalUnits: 50 },
        { date: "2021-10-09", totalSales: 95, totalUnits: 37 },
        { date: "2021-10-10", totalSales: 1, totalUnits: 12 },
        { date: "2021-10-11", totalSales: 35, totalUnits: 11 },
        { date: "2021-10-12", totalSales: 65, totalUnits: 32 },
        { date: "2021-10-13", totalSales: 5, totalUnits: 17 },
        { date: "2021-10-14", totalSales: 27, totalUnits: 3 },
        { date: "2021-10-15", totalSales: 24, totalUnits: 46 },
        { date: "2021-10-16", totalSales: 44, totalUnits: 27 },
        { date: "2021-10-17", totalSales: 53, totalUnits: 43 },
        { date: "2021-10-18", totalSales: 54, totalUnits: 34 },
        { date: "2021-10-19", totalSales: 80, totalUnits: 11 },
        { date: "2021-10-20", totalSales: 41, totalUnits: 5 },
        { date: "2021-10-21", totalSales: 82, totalUnits: 4 },
        { date: "2021-10-22", totalSales: 59, totalUnits: 6 },
        { date: "2021-10-23", totalSales: 13, totalUnits: 6 },
        { date: "2021-10-24", totalSales: 89, totalUnits: 3 },
        { date: "2021-10-25", totalSales: 9, totalUnits: 29 },
        { date: "2021-10-26", totalSales: 23, totalUnits: 28 },
        { date: "2021-10-27", totalSales: 91, totalUnits: 9 },
        { date: "2021-10-28", totalSales: 81, totalUnits: 14 },
        { date: "2021-10-29", totalSales: 97, totalUnits: 24 },
        { date: "2021-10-30", totalSales: 43, totalUnits: 2 },
        { date: "2021-10-31", totalSales: 38, totalUnits: 25 },
        { date: "2021-11-01", totalSales: 96, totalUnits: 16 },
        { date: "2021-11-02", totalSales: 87, totalUnits: 18 },
        { date: "2021-11-03", totalSales: 92, totalUnits: 14 },
        { date: "2021-11-04", totalSales: 80, totalUnits: 28 },
        { date: "2021-11-05", totalSales: 93, totalUnits: 25 },
        { date: "2021-11-06", totalSales: 20, totalUnits: 14 },
        { date: "2021-11-07", totalSales: 5, totalUnits: 34 },
        { date: "2021-11-08", totalSales: 95, totalUnits: 6 },
        { date: "2021-11-09", totalSales: 55, totalUnits: 44 },
        { date: "2021-11-10", totalSales: 10, totalUnits: 50 },
        { date: "2021-11-11", totalSales: 36, totalUnits: 30 },
        { date: "2021-11-12", totalSales: 54, totalUnits: 42 },
        { date: "2021-11-13", totalSales: 81, totalUnits: 20 },
        { date: "2021-11-14", totalSales: 64, totalUnits: 46 },
        { date: "2021-11-15", totalSales: 76, totalUnits: 21 },
        { date: "2021-11-16", totalSales: 58, totalUnits: 7 },
        { date: "2021-11-17", totalSales: 13, totalUnits: 43 },
      ],
    },
    {
      _id: "6371259df03239db69000198",
      productId: "63701d24f0323944410002ee",
      yearlySalesTotal: 2128,
      yearlyTotalSoldUnits: 703,
      monthlyData: [
        { month: "january", totalSales: 472, totalUnits: 67 },
        { month: "february", totalSales: 862, totalUnits: 24 },
        { month: "march", totalSales: 732, totalUnits: 287 },
        { month: "april", totalSales: 996, totalUnits: 210 },
        { month: "may", totalSales: 796, totalUnits: 8 },
        { month: "june", totalSales: 348, totalUnits: 71 },
        { month: "july", totalSales: 729, totalUnits: 175 },
        { month: "august", totalSales: 811, totalUnits: 313 },
        { month: "september", totalSales: 88, totalUnits: 44 },
        { month: "october", totalSales: 199, totalUnits: 24 },
        { month: "november", totalSales: 364, totalUnits: 373 },
        { month: "december", totalSales: 301, totalUnits: 85 },
      ],
      dailyData: [
        { date: "2021-01-02", totalSales: 78, totalUnits: 34 },
        { date: "2021-01-03", totalSales: 99, totalUnits: 20 },
        { date: "2021-01-04", totalSales: 28, totalUnits: 37 },
        { date: "2021-01-05", totalSales: 7, totalUnits: 35 },
        { date: "2021-01-06", totalSales: 38, totalUnits: 45 },
        { date: "2021-01-07", totalSales: 68, totalUnits: 3 },
        { date: "2021-01-08", totalSales: 37, totalUnits: 28 },
        { date: "2021-01-09", totalSales: 100, totalUnits: 42 },
        { date: "2021-01-10", totalSales: 43, totalUnits: 30 },
        { date: "2021-01-11", totalSales: 59, totalUnits: 23 },
        { date: "2021-01-12", totalSales: 77, totalUnits: 21 },
        { date: "2021-01-13", totalSales: 49, totalUnits: 24 },
        { date: "2021-01-14", totalSales: 48, totalUnits: 39 },
        { date: "2021-01-15", totalSales: 6, totalUnits: 38 },
        { date: "2021-01-16", totalSales: 99, totalUnits: 42 },
        { date: "2021-01-17", totalSales: 95, totalUnits: 16 },
        { date: "2021-01-18", totalSales: 84, totalUnits: 34 },
        { date: "2021-01-19", totalSales: 21, totalUnits: 40 },
        { date: "2021-01-20", totalSales: 58, totalUnits: 33 },
        { date: "2021-01-21", totalSales: 18, totalUnits: 50 },
        { date: "2021-01-22", totalSales: 70, totalUnits: 10 },
        { date: "2021-01-23", totalSales: 55, totalUnits: 35 },
        { date: "2021-01-24", totalSales: 72, totalUnits: 49 },
        { date: "2021-01-25", totalSales: 100, totalUnits: 48 },
        { date: "2021-01-26", totalSales: 35, totalUnits: 43 },
        { date: "2021-01-27", totalSales: 37, totalUnits: 46 },
        { date: "2021-01-28", totalSales: 46, totalUnits: 25 },
        { date: "2021-01-29", totalSales: 39, totalUnits: 26 },
        { date: "2021-01-30", totalSales: 70, totalUnits: 1 },
        { date: "2021-01-31", totalSales: 6, totalUnits: 21 },
        { date: "2021-02-01", totalSales: 93, totalUnits: 37 },
        { date: "2021-02-02", totalSales: 56, totalUnits: 32 },
        { date: "2021-02-03", totalSales: 88, totalUnits: 16 },
        { date: "2021-02-04", totalSales: 29, totalUnits: 22 },
        { date: "2021-02-05", totalSales: 18, totalUnits: 40 },
        { date: "2021-02-06", totalSales: 72, totalUnits: 10 },
        { date: "2021-02-07", totalSales: 52, totalUnits: 22 },
        { date: "2021-02-08", totalSales: 39, totalUnits: 15 },
        { date: "2021-02-09", totalSales: 98, totalUnits: 49 },
        { date: "2021-02-10", totalSales: 75, totalUnits: 21 },
        { date: "2021-02-11", totalSales: 47, totalUnits: 22 },
        { date: "2021-02-12", totalSales: 16, totalUnits: 33 },
        { date: "2021-02-13", totalSales: 84, totalUnits: 49 },
        { date: "2021-02-14", totalSales: 4, totalUnits: 3 },
        { date: "2021-02-15", totalSales: 61, totalUnits: 6 },
        { date: "2021-02-16", totalSales: 95, totalUnits: 43 },
        { date: "2021-02-17", totalSales: 40, totalUnits: 39 },
        { date: "2021-02-18", totalSales: 65, totalUnits: 35 },
        { date: "2021-02-19", totalSales: 71, totalUnits: 14 },
        { date: "2021-02-20", totalSales: 7, totalUnits: 37 },
        { date: "2021-02-21", totalSales: 14, totalUnits: 42 },
        { date: "2021-02-22", totalSales: 63, totalUnits: 26 },
        { date: "2021-02-23", totalSales: 78, totalUnits: 24 },
        { date: "2021-02-24", totalSales: 71, totalUnits: 32 },
        { date: "2021-02-25", totalSales: 35, totalUnits: 20 },
        { date: "2021-02-26", totalSales: 96, totalUnits: 15 },
        { date: "2021-02-27", totalSales: 59, totalUnits: 35 },
        { date: "2021-02-28", totalSales: 1, totalUnits: 13 },
        { date: "2021-03-01", totalSales: 18, totalUnits: 25 },
        { date: "2021-03-02", totalSales: 85, totalUnits: 3 },
        { date: "2021-03-03", totalSales: 24, totalUnits: 24 },
        { date: "2021-03-04", totalSales: 57, totalUnits: 15 },
        { date: "2021-03-05", totalSales: 64, totalUnits: 26 },
        { date: "2021-03-06", totalSales: 41, totalUnits: 49 },
        { date: "2021-03-07", totalSales: 33, totalUnits: 24 },
        { date: "2021-03-08", totalSales: 7, totalUnits: 19 },
        { date: "2021-03-09", totalSales: 65, totalUnits: 8 },
        { date: "2021-03-10", totalSales: 79, totalUnits: 38 },
        { date: "2021-03-11", totalSales: 1, totalUnits: 25 },
        { date: "2021-03-12", totalSales: 2, totalUnits: 36 },
        { date: "2021-03-13", totalSales: 44, totalUnits: 39 },
        { date: "2021-03-14", totalSales: 100, totalUnits: 35 },
        { date: "2021-03-15", totalSales: 28, totalUnits: 43 },
        { date: "2021-03-16", totalSales: 18, totalUnits: 7 },
        { date: "2021-03-17", totalSales: 90, totalUnits: 28 },
        { date: "2021-03-18", totalSales: 32, totalUnits: 30 },
        { date: "2021-03-19", totalSales: 72, totalUnits: 10 },
        { date: "2021-03-20", totalSales: 75, totalUnits: 30 },
        { date: "2021-03-21", totalSales: 23, totalUnits: 13 },
        { date: "2021-03-22", totalSales: 57, totalUnits: 40 },
        { date: "2021-03-23", totalSales: 55, totalUnits: 7 },
        { date: "2021-03-24", totalSales: 71, totalUnits: 27 },
        { date: "2021-03-25", totalSales: 56, totalUnits: 32 },
        { date: "2021-03-26", totalSales: 20, totalUnits: 12 },
        { date: "2021-03-27", totalSales: 39, totalUnits: 7 },
        { date: "2021-03-28", totalSales: 49, totalUnits: 16 },
        { date: "2021-03-29", totalSales: 91, totalUnits: 37 },
        { date: "2021-03-30", totalSales: 28, totalUnits: 22 },
        { date: "2021-03-31", totalSales: 23, totalUnits: 2 },
        { date: "2021-04-01", totalSales: 55, totalUnits: 11 },
        { date: "2021-04-02", totalSales: 56, totalUnits: 7 },
        { date: "2021-04-03", totalSales: 39, totalUnits: 11 },
        { date: "2021-04-04", totalSales: 27, totalUnits: 43 },
        { date: "2021-04-05", totalSales: 10, totalUnits: 14 },
        { date: "2021-04-06", totalSales: 73, totalUnits: 16 },
        { date: "2021-04-07", totalSales: 21, totalUnits: 37 },
        { date: "2021-04-08", totalSales: 56, totalUnits: 23 },
        { date: "2021-04-09", totalSales: 66, totalUnits: 48 },
        { date: "2021-04-10", totalSales: 6, totalUnits: 30 },
        { date: "2021-04-11", totalSales: 4, totalUnits: 48 },
        { date: "2021-04-12", totalSales: 84, totalUnits: 13 },
        { date: "2021-04-13", totalSales: 58, totalUnits: 11 },
        { date: "2021-04-14", totalSales: 75, totalUnits: 23 },
        { date: "2021-04-15", totalSales: 4, totalUnits: 19 },
        { date: "2021-04-16", totalSales: 14, totalUnits: 35 },
        { date: "2021-04-17", totalSales: 85, totalUnits: 47 },
        { date: "2021-04-18", totalSales: 51, totalUnits: 2 },
        { date: "2021-04-19", totalSales: 84, totalUnits: 34 },
        { date: "2021-04-20", totalSales: 30, totalUnits: 45 },
        { date: "2021-04-21", totalSales: 92, totalUnits: 18 },
        { date: "2021-04-22", totalSales: 73, totalUnits: 9 },
        { date: "2021-04-23", totalSales: 45, totalUnits: 40 },
        { date: "2021-04-24", totalSales: 56, totalUnits: 44 },
        { date: "2021-04-25", totalSales: 53, totalUnits: 24 },
        { date: "2021-04-26", totalSales: 86, totalUnits: 36 },
        { date: "2021-04-27", totalSales: 85, totalUnits: 38 },
        { date: "2021-04-28", totalSales: 16, totalUnits: 9 },
        { date: "2021-04-29", totalSales: 32, totalUnits: 15 },
        { date: "2021-04-30", totalSales: 41, totalUnits: 44 },
        { date: "2021-05-01", totalSales: 22, totalUnits: 30 },
        { date: "2021-05-02", totalSales: 3, totalUnits: 39 },
        { date: "2021-05-03", totalSales: 75, totalUnits: 33 },
        { date: "2021-05-04", totalSales: 14, totalUnits: 39 },
        { date: "2021-05-05", totalSales: 92, totalUnits: 45 },
        { date: "2021-05-06", totalSales: 68, totalUnits: 4 },
        { date: "2021-05-07", totalSales: 98, totalUnits: 20 },
        { date: "2021-05-08", totalSales: 15, totalUnits: 8 },
        { date: "2021-05-09", totalSales: 48, totalUnits: 12 },
        { date: "2021-05-10", totalSales: 97, totalUnits: 20 },
        { date: "2021-05-11", totalSales: 24, totalUnits: 32 },
        { date: "2021-05-12", totalSales: 54, totalUnits: 27 },
        { date: "2021-05-13", totalSales: 70, totalUnits: 5 },
        { date: "2021-05-14", totalSales: 85, totalUnits: 21 },
        { date: "2021-05-15", totalSales: 80, totalUnits: 10 },
        { date: "2021-05-16", totalSales: 81, totalUnits: 6 },
        { date: "2021-05-17", totalSales: 23, totalUnits: 8 },
        { date: "2021-05-18", totalSales: 68, totalUnits: 36 },
        { date: "2021-05-19", totalSales: 57, totalUnits: 36 },
        { date: "2021-05-20", totalSales: 60, totalUnits: 25 },
        { date: "2021-05-21", totalSales: 85, totalUnits: 45 },
        { date: "2021-05-22", totalSales: 47, totalUnits: 7 },
        { date: "2021-05-23", totalSales: 39, totalUnits: 24 },
        { date: "2021-05-24", totalSales: 66, totalUnits: 48 },
        { date: "2021-05-25", totalSales: 29, totalUnits: 2 },
        { date: "2021-05-26", totalSales: 24, totalUnits: 47 },
        { date: "2021-05-27", totalSales: 53, totalUnits: 46 },
        { date: "2021-05-28", totalSales: 37, totalUnits: 30 },
        { date: "2021-05-29", totalSales: 29, totalUnits: 29 },
        { date: "2021-05-30", totalSales: 79, totalUnits: 14 },
        { date: "2021-05-31", totalSales: 34, totalUnits: 47 },
        { date: "2021-06-01", totalSales: 67, totalUnits: 2 },
        { date: "2021-06-02", totalSales: 79, totalUnits: 31 },
        { date: "2021-06-03", totalSales: 63, totalUnits: 13 },
        { date: "2021-06-04", totalSales: 95, totalUnits: 38 },
        { date: "2021-06-05", totalSales: 94, totalUnits: 38 },
        { date: "2021-06-06", totalSales: 34, totalUnits: 13 },
        { date: "2021-06-07", totalSales: 55, totalUnits: 4 },
        { date: "2021-06-08", totalSales: 27, totalUnits: 27 },
        { date: "2021-06-09", totalSales: 30, totalUnits: 7 },
        { date: "2021-06-10", totalSales: 82, totalUnits: 50 },
        { date: "2021-06-11", totalSales: 45, totalUnits: 43 },
        { date: "2021-06-12", totalSales: 79, totalUnits: 43 },
        { date: "2021-06-13", totalSales: 62, totalUnits: 29 },
        { date: "2021-06-14", totalSales: 98, totalUnits: 12 },
        { date: "2021-06-15", totalSales: 16, totalUnits: 40 },
        { date: "2021-06-16", totalSales: 14, totalUnits: 19 },
        { date: "2021-06-17", totalSales: 30, totalUnits: 33 },
        { date: "2021-06-18", totalSales: 14, totalUnits: 19 },
        { date: "2021-06-19", totalSales: 31, totalUnits: 8 },
        { date: "2021-06-20", totalSales: 95, totalUnits: 13 },
        { date: "2021-06-21", totalSales: 71, totalUnits: 11 },
        { date: "2021-06-22", totalSales: 87, totalUnits: 39 },
        { date: "2021-06-23", totalSales: 89, totalUnits: 10 },
        { date: "2021-06-24", totalSales: 79, totalUnits: 47 },
        { date: "2021-06-25", totalSales: 21, totalUnits: 27 },
        { date: "2021-06-26", totalSales: 65, totalUnits: 42 },
        { date: "2021-06-27", totalSales: 6, totalUnits: 44 },
        { date: "2021-06-28", totalSales: 56, totalUnits: 26 },
        { date: "2021-06-29", totalSales: 80, totalUnits: 14 },
        { date: "2021-06-30", totalSales: 11, totalUnits: 38 },
        { date: "2021-07-01", totalSales: 50, totalUnits: 39 },
        { date: "2021-07-02", totalSales: 38, totalUnits: 11 },
        { date: "2021-07-03", totalSales: 50, totalUnits: 7 },
        { date: "2021-07-04", totalSales: 42, totalUnits: 12 },
        { date: "2021-07-05", totalSales: 63, totalUnits: 47 },
        { date: "2021-07-06", totalSales: 87, totalUnits: 5 },
        { date: "2021-07-07", totalSales: 44, totalUnits: 22 },
        { date: "2021-07-08", totalSales: 92, totalUnits: 42 },
        { date: "2021-07-09", totalSales: 25, totalUnits: 49 },
        { date: "2021-07-10", totalSales: 78, totalUnits: 38 },
        { date: "2021-07-11", totalSales: 98, totalUnits: 39 },
        { date: "2021-07-12", totalSales: 88, totalUnits: 14 },
        { date: "2021-07-13", totalSales: 7, totalUnits: 9 },
        { date: "2021-07-14", totalSales: 46, totalUnits: 13 },
        { date: "2021-07-15", totalSales: 81, totalUnits: 21 },
        { date: "2021-07-16", totalSales: 37, totalUnits: 3 },
        { date: "2021-07-17", totalSales: 33, totalUnits: 20 },
        { date: "2021-07-18", totalSales: 5, totalUnits: 7 },
        { date: "2021-07-19", totalSales: 24, totalUnits: 29 },
        { date: "2021-07-20", totalSales: 6, totalUnits: 15 },
        { date: "2021-07-21", totalSales: 78, totalUnits: 19 },
        { date: "2021-07-22", totalSales: 98, totalUnits: 42 },
        { date: "2021-07-23", totalSales: 97, totalUnits: 38 },
        { date: "2021-07-24", totalSales: 2, totalUnits: 33 },
        { date: "2021-07-25", totalSales: 30, totalUnits: 9 },
        { date: "2021-07-26", totalSales: 11, totalUnits: 45 },
        { date: "2021-07-27", totalSales: 81, totalUnits: 39 },
        { date: "2021-07-28", totalSales: 76, totalUnits: 24 },
        { date: "2021-07-29", totalSales: 91, totalUnits: 48 },
        { date: "2021-07-30", totalSales: 27, totalUnits: 3 },
        { date: "2021-07-31", totalSales: 54, totalUnits: 10 },
        { date: "2021-08-01", totalSales: 47, totalUnits: 4 },
        { date: "2021-08-02", totalSales: 67, totalUnits: 23 },
        { date: "2021-08-03", totalSales: 86, totalUnits: 19 },
        { date: "2021-08-04", totalSales: 65, totalUnits: 5 },
        { date: "2021-08-05", totalSales: 27, totalUnits: 26 },
        { date: "2021-08-06", totalSales: 94, totalUnits: 7 },
        { date: "2021-08-07", totalSales: 3, totalUnits: 40 },
        { date: "2021-08-08", totalSales: 81, totalUnits: 46 },
        { date: "2021-08-09", totalSales: 34, totalUnits: 48 },
        { date: "2021-08-10", totalSales: 73, totalUnits: 47 },
        { date: "2021-08-11", totalSales: 83, totalUnits: 20 },
        { date: "2021-08-12", totalSales: 58, totalUnits: 26 },
        { date: "2021-08-13", totalSales: 49, totalUnits: 33 },
        { date: "2021-08-14", totalSales: 95, totalUnits: 45 },
        { date: "2021-08-15", totalSales: 98, totalUnits: 2 },
        { date: "2021-08-16", totalSales: 86, totalUnits: 22 },
        { date: "2021-08-17", totalSales: 98, totalUnits: 6 },
        { date: "2021-08-18", totalSales: 50, totalUnits: 29 },
        { date: "2021-08-19", totalSales: 21, totalUnits: 49 },
        { date: "2021-08-20", totalSales: 34, totalUnits: 40 },
        { date: "2021-08-21", totalSales: 53, totalUnits: 33 },
        { date: "2021-08-22", totalSales: 36, totalUnits: 5 },
        { date: "2021-08-23", totalSales: 2, totalUnits: 40 },
        { date: "2021-08-24", totalSales: 36, totalUnits: 16 },
        { date: "2021-08-25", totalSales: 39, totalUnits: 40 },
        { date: "2021-08-26", totalSales: 90, totalUnits: 41 },
        { date: "2021-08-27", totalSales: 9, totalUnits: 30 },
        { date: "2021-08-28", totalSales: 23, totalUnits: 48 },
        { date: "2021-08-29", totalSales: 97, totalUnits: 22 },
        { date: "2021-08-30", totalSales: 93, totalUnits: 1 },
        { date: "2021-08-31", totalSales: 46, totalUnits: 11 },
        { date: "2021-09-01", totalSales: 92, totalUnits: 4 },
        { date: "2021-09-02", totalSales: 58, totalUnits: 41 },
        { date: "2021-09-03", totalSales: 100, totalUnits: 34 },
        { date: "2021-09-04", totalSales: 47, totalUnits: 6 },
        { date: "2021-09-05", totalSales: 98, totalUnits: 1 },
        { date: "2021-09-06", totalSales: 78, totalUnits: 22 },
        { date: "2021-09-07", totalSales: 7, totalUnits: 10 },
        { date: "2021-09-08", totalSales: 32, totalUnits: 4 },
        { date: "2021-09-09", totalSales: 74, totalUnits: 33 },
        { date: "2021-09-10", totalSales: 91, totalUnits: 39 },
        { date: "2021-09-11", totalSales: 36, totalUnits: 19 },
        { date: "2021-09-12", totalSales: 2, totalUnits: 16 },
        { date: "2021-09-13", totalSales: 11, totalUnits: 34 },
        { date: "2021-09-14", totalSales: 100, totalUnits: 14 },
        { date: "2021-09-15", totalSales: 12, totalUnits: 2 },
        { date: "2021-09-16", totalSales: 76, totalUnits: 26 },
        { date: "2021-09-17", totalSales: 29, totalUnits: 46 },
        { date: "2021-09-18", totalSales: 49, totalUnits: 47 },
        { date: "2021-09-19", totalSales: 67, totalUnits: 35 },
        { date: "2021-09-20", totalSales: 83, totalUnits: 25 },
        { date: "2021-09-21", totalSales: 54, totalUnits: 7 },
        { date: "2021-09-22", totalSales: 78, totalUnits: 1 },
        { date: "2021-09-23", totalSales: 47, totalUnits: 33 },
        { date: "2021-09-24", totalSales: 18, totalUnits: 4 },
        { date: "2021-09-25", totalSales: 25, totalUnits: 20 },
        { date: "2021-09-26", totalSales: 40, totalUnits: 19 },
        { date: "2021-09-27", totalSales: 81, totalUnits: 1 },
        { date: "2021-09-28", totalSales: 12, totalUnits: 46 },
        { date: "2021-09-29", totalSales: 65, totalUnits: 13 },
        { date: "2021-09-30", totalSales: 84, totalUnits: 44 },
        { date: "2021-10-01", totalSales: 37, totalUnits: 30 },
        { date: "2021-10-02", totalSales: 27, totalUnits: 29 },
        { date: "2021-10-03", totalSales: 81, totalUnits: 44 },
        { date: "2021-10-04", totalSales: 96, totalUnits: 13 },
        { date: "2021-10-05", totalSales: 86, totalUnits: 15 },
        { date: "2021-10-06", totalSales: 75, totalUnits: 45 },
        { date: "2021-10-07", totalSales: 37, totalUnits: 3 },
        { date: "2021-10-08", totalSales: 74, totalUnits: 15 },
        { date: "2021-10-09", totalSales: 72, totalUnits: 50 },
        { date: "2021-10-10", totalSales: 68, totalUnits: 24 },
        { date: "2021-10-11", totalSales: 55, totalUnits: 33 },
        { date: "2021-10-12", totalSales: 8, totalUnits: 21 },
        { date: "2021-10-13", totalSales: 63, totalUnits: 5 },
        { date: "2021-10-14", totalSales: 45, totalUnits: 26 },
        { date: "2021-10-15", totalSales: 22, totalUnits: 30 },
        { date: "2021-10-16", totalSales: 40, totalUnits: 48 },
        { date: "2021-10-17", totalSales: 87, totalUnits: 33 },
        { date: "2021-10-18", totalSales: 26, totalUnits: 15 },
        { date: "2021-10-19", totalSales: 14, totalUnits: 1 },
        { date: "2021-10-20", totalSales: 60, totalUnits: 25 },
        { date: "2021-10-21", totalSales: 35, totalUnits: 24 },
        { date: "2021-10-22", totalSales: 82, totalUnits: 30 },
        { date: "2021-10-23", totalSales: 9, totalUnits: 7 },
        { date: "2021-10-24", totalSales: 31, totalUnits: 50 },
        { date: "2021-10-25", totalSales: 27, totalUnits: 36 },
        { date: "2021-10-26", totalSales: 16, totalUnits: 8 },
        { date: "2021-10-27", totalSales: 83, totalUnits: 17 },
        { date: "2021-10-28", totalSales: 82, totalUnits: 25 },
        { date: "2021-10-29", totalSales: 35, totalUnits: 46 },
        { date: "2021-10-30", totalSales: 27, totalUnits: 33 },
        { date: "2021-10-31", totalSales: 18, totalUnits: 29 },
        { date: "2021-11-01", totalSales: 86, totalUnits: 6 },
        { date: "2021-11-02", totalSales: 42, totalUnits: 47 },
        { date: "2021-11-03", totalSales: 21, totalUnits: 40 },
        { date: "2021-11-04", totalSales: 64, totalUnits: 21 },
        { date: "2021-11-05", totalSales: 57, totalUnits: 32 },
        { date: "2021-11-06", totalSales: 9, totalUnits: 50 },
        { date: "2021-11-07", totalSales: 51, totalUnits: 19 },
        { date: "2021-11-08", totalSales: 7, totalUnits: 13 },
        { date: "2021-11-09", totalSales: 87, totalUnits: 35 },
        { date: "2021-11-10", totalSales: 50, totalUnits: 31 },
        { date: "2021-11-11", totalSales: 64, totalUnits: 29 },
        { date: "2021-11-12", totalSales: 16, totalUnits: 22 },
        { date: "2021-11-13", totalSales: 39, totalUnits: 33 },
        { date: "2021-11-14", totalSales: 62, totalUnits: 5 },
        { date: "2021-11-15", totalSales: 96, totalUnits: 3 },
        { date: "2021-11-16", totalSales: 32, totalUnits: 4 },
        { date: "2021-11-17", totalSales: 28, totalUnits: 28 },
      ],
    },
    {
      _id: "6371259df03239b913000083",
      productId: "63701d24f0323944410002ef",
      yearlySalesTotal: 7841,
      yearlyTotalSoldUnits: 3889,
      monthlyData: [
        { month: "january", totalSales: 489, totalUnits: 324 },
        { month: "february", totalSales: 674, totalUnits: 111 },
        { month: "march", totalSales: 600, totalUnits: 235 },
        { month: "april", totalSales: 763, totalUnits: 220 },
        { month: "may", totalSales: 943, totalUnits: 376 },
        { month: "june", totalSales: 164, totalUnits: 243 },
        { month: "july", totalSales: 119, totalUnits: 43 },
        { month: "august", totalSales: 83, totalUnits: 306 },
        { month: "september", totalSales: 574, totalUnits: 276 },
        { month: "october", totalSales: 606, totalUnits: 232 },
        { month: "november", totalSales: 971, totalUnits: 435 },
        { month: "december", totalSales: 580, totalUnits: 106 },
      ],
      dailyData: [
        { date: "2021-01-02", totalSales: 48, totalUnits: 25 },
        { date: "2021-01-03", totalSales: 75, totalUnits: 19 },
        { date: "2021-01-04", totalSales: 48, totalUnits: 31 },
        { date: "2021-01-05", totalSales: 94, totalUnits: 27 },
        { date: "2021-01-06", totalSales: 7, totalUnits: 45 },
        { date: "2021-01-07", totalSales: 21, totalUnits: 15 },
        { date: "2021-01-08", totalSales: 17, totalUnits: 30 },
        { date: "2021-01-09", totalSales: 41, totalUnits: 4 },
        { date: "2021-01-10", totalSales: 67, totalUnits: 35 },
        { date: "2021-01-11", totalSales: 100, totalUnits: 23 },
        { date: "2021-01-12", totalSales: 63, totalUnits: 36 },
        { date: "2021-01-13", totalSales: 5, totalUnits: 17 },
        { date: "2021-01-14", totalSales: 64, totalUnits: 3 },
        { date: "2021-01-15", totalSales: 62, totalUnits: 3 },
        { date: "2021-01-16", totalSales: 99, totalUnits: 30 },
        { date: "2021-01-17", totalSales: 80, totalUnits: 21 },
        { date: "2021-01-18", totalSales: 13, totalUnits: 11 },
        { date: "2021-01-19", totalSales: 84, totalUnits: 20 },
        { date: "2021-01-20", totalSales: 57, totalUnits: 43 },
        { date: "2021-01-21", totalSales: 49, totalUnits: 4 },
        { date: "2021-01-22", totalSales: 55, totalUnits: 45 },
        { date: "2021-01-23", totalSales: 45, totalUnits: 46 },
        { date: "2021-01-24", totalSales: 42, totalUnits: 7 },
        { date: "2021-01-25", totalSales: 30, totalUnits: 10 },
        { date: "2021-01-26", totalSales: 21, totalUnits: 15 },
        { date: "2021-01-27", totalSales: 41, totalUnits: 50 },
        { date: "2021-01-28", totalSales: 47, totalUnits: 47 },
        { date: "2021-01-29", totalSales: 29, totalUnits: 23 },
        { date: "2021-01-30", totalSales: 48, totalUnits: 39 },
        { date: "2021-01-31", totalSales: 90, totalUnits: 15 },
        { date: "2021-02-01", totalSales: 88, totalUnits: 6 },
        { date: "2021-02-02", totalSales: 26, totalUnits: 44 },
        { date: "2021-02-03", totalSales: 31, totalUnits: 21 },
        { date: "2021-02-04", totalSales: 16, totalUnits: 32 },
        { date: "2021-02-05", totalSales: 54, totalUnits: 35 },
        { date: "2021-02-06", totalSales: 33, totalUnits: 31 },
        { date: "2021-02-07", totalSales: 17, totalUnits: 4 },
        { date: "2021-02-08", totalSales: 24, totalUnits: 35 },
        { date: "2021-02-09", totalSales: 84, totalUnits: 50 },
        { date: "2021-02-10", totalSales: 35, totalUnits: 10 },
        { date: "2021-02-11", totalSales: 82, totalUnits: 42 },
        { date: "2021-02-12", totalSales: 34, totalUnits: 46 },
        { date: "2021-02-13", totalSales: 90, totalUnits: 14 },
        { date: "2021-02-14", totalSales: 100, totalUnits: 21 },
        { date: "2021-02-15", totalSales: 23, totalUnits: 31 },
        { date: "2021-02-16", totalSales: 90, totalUnits: 35 },
        { date: "2021-02-17", totalSales: 36, totalUnits: 35 },
        { date: "2021-02-18", totalSales: 46, totalUnits: 35 },
        { date: "2021-02-19", totalSales: 27, totalUnits: 11 },
        { date: "2021-02-20", totalSales: 91, totalUnits: 42 },
        { date: "2021-02-21", totalSales: 31, totalUnits: 9 },
        { date: "2021-02-22", totalSales: 49, totalUnits: 27 },
        { date: "2021-02-23", totalSales: 78, totalUnits: 46 },
        { date: "2021-02-24", totalSales: 67, totalUnits: 10 },
        { date: "2021-02-25", totalSales: 6, totalUnits: 41 },
        { date: "2021-02-26", totalSales: 51, totalUnits: 2 },
        { date: "2021-02-27", totalSales: 54, totalUnits: 31 },
        { date: "2021-02-28", totalSales: 49, totalUnits: 23 },
        { date: "2021-03-01", totalSales: 71, totalUnits: 12 },
        { date: "2021-03-02", totalSales: 96, totalUnits: 19 },
        { date: "2021-03-03", totalSales: 95, totalUnits: 2 },
        { date: "2021-03-04", totalSales: 99, totalUnits: 35 },
        { date: "2021-03-05", totalSales: 3, totalUnits: 39 },
        { date: "2021-03-06", totalSales: 35, totalUnits: 4 },
        { date: "2021-03-07", totalSales: 66, totalUnits: 40 },
        { date: "2021-03-08", totalSales: 64, totalUnits: 29 },
        { date: "2021-03-09", totalSales: 20, totalUnits: 45 },
        { date: "2021-03-10", totalSales: 17, totalUnits: 7 },
        { date: "2021-03-11", totalSales: 80, totalUnits: 30 },
        { date: "2021-03-12", totalSales: 22, totalUnits: 22 },
        { date: "2021-03-13", totalSales: 52, totalUnits: 50 },
        { date: "2021-03-14", totalSales: 93, totalUnits: 48 },
        { date: "2021-03-15", totalSales: 37, totalUnits: 2 },
        { date: "2021-03-16", totalSales: 89, totalUnits: 18 },
        { date: "2021-03-17", totalSales: 55, totalUnits: 27 },
        { date: "2021-03-18", totalSales: 34, totalUnits: 7 },
        { date: "2021-03-19", totalSales: 58, totalUnits: 30 },
        { date: "2021-03-20", totalSales: 58, totalUnits: 21 },
        { date: "2021-03-21", totalSales: 32, totalUnits: 29 },
        { date: "2021-03-22", totalSales: 61, totalUnits: 8 },
        { date: "2021-03-23", totalSales: 46, totalUnits: 40 },
        { date: "2021-03-24", totalSales: 10, totalUnits: 32 },
        { date: "2021-03-25", totalSales: 66, totalUnits: 18 },
        { date: "2021-03-26", totalSales: 37, totalUnits: 41 },
        { date: "2021-03-27", totalSales: 73, totalUnits: 4 },
        { date: "2021-03-28", totalSales: 13, totalUnits: 4 },
        { date: "2021-03-29", totalSales: 38, totalUnits: 36 },
        { date: "2021-03-30", totalSales: 34, totalUnits: 8 },
        { date: "2021-03-31", totalSales: 81, totalUnits: 19 },
        { date: "2021-04-01", totalSales: 74, totalUnits: 32 },
        { date: "2021-04-02", totalSales: 31, totalUnits: 21 },
        { date: "2021-04-03", totalSales: 58, totalUnits: 48 },
        { date: "2021-04-04", totalSales: 60, totalUnits: 29 },
        { date: "2021-04-05", totalSales: 96, totalUnits: 16 },
        { date: "2021-04-06", totalSales: 31, totalUnits: 37 },
        { date: "2021-04-07", totalSales: 80, totalUnits: 15 },
        { date: "2021-04-08", totalSales: 7, totalUnits: 9 },
        { date: "2021-04-09", totalSales: 53, totalUnits: 1 },
        { date: "2021-04-10", totalSales: 28, totalUnits: 40 },
        { date: "2021-04-11", totalSales: 21, totalUnits: 5 },
        { date: "2021-04-12", totalSales: 3, totalUnits: 43 },
        { date: "2021-04-13", totalSales: 58, totalUnits: 21 },
        { date: "2021-04-14", totalSales: 23, totalUnits: 22 },
        { date: "2021-04-15", totalSales: 7, totalUnits: 13 },
        { date: "2021-04-16", totalSales: 50, totalUnits: 17 },
        { date: "2021-04-17", totalSales: 74, totalUnits: 46 },
        { date: "2021-04-18", totalSales: 10, totalUnits: 35 },
        { date: "2021-04-19", totalSales: 6, totalUnits: 49 },
        { date: "2021-04-20", totalSales: 62, totalUnits: 34 },
        { date: "2021-04-21", totalSales: 30, totalUnits: 8 },
        { date: "2021-04-22", totalSales: 30, totalUnits: 8 },
        { date: "2021-04-23", totalSales: 89, totalUnits: 21 },
        { date: "2021-04-24", totalSales: 81, totalUnits: 1 },
        { date: "2021-04-25", totalSales: 58, totalUnits: 16 },
        { date: "2021-04-26", totalSales: 62, totalUnits: 42 },
        { date: "2021-04-27", totalSales: 99, totalUnits: 30 },
        { date: "2021-04-28", totalSales: 35, totalUnits: 23 },
        { date: "2021-04-29", totalSales: 71, totalUnits: 1 },
        { date: "2021-04-30", totalSales: 51, totalUnits: 28 },
        { date: "2021-05-01", totalSales: 25, totalUnits: 37 },
        { date: "2021-05-02", totalSales: 73, totalUnits: 35 },
        { date: "2021-05-03", totalSales: 58, totalUnits: 42 },
        { date: "2021-05-04", totalSales: 88, totalUnits: 25 },
        { date: "2021-05-05", totalSales: 1, totalUnits: 10 },
        { date: "2021-05-06", totalSales: 94, totalUnits: 5 },
        { date: "2021-05-07", totalSales: 85, totalUnits: 43 },
        { date: "2021-05-08", totalSales: 3, totalUnits: 29 },
        { date: "2021-05-09", totalSales: 2, totalUnits: 19 },
        { date: "2021-05-10", totalSales: 93, totalUnits: 14 },
        { date: "2021-05-11", totalSales: 94, totalUnits: 29 },
        { date: "2021-05-12", totalSales: 83, totalUnits: 22 },
        { date: "2021-05-13", totalSales: 8, totalUnits: 14 },
        { date: "2021-05-14", totalSales: 8, totalUnits: 33 },
        { date: "2021-05-15", totalSales: 69, totalUnits: 17 },
        { date: "2021-05-16", totalSales: 73, totalUnits: 42 },
        { date: "2021-05-17", totalSales: 67, totalUnits: 31 },
        { date: "2021-05-18", totalSales: 74, totalUnits: 12 },
        { date: "2021-05-19", totalSales: 15, totalUnits: 32 },
        { date: "2021-05-20", totalSales: 68, totalUnits: 4 },
        { date: "2021-05-21", totalSales: 63, totalUnits: 7 },
        { date: "2021-05-22", totalSales: 45, totalUnits: 49 },
        { date: "2021-05-23", totalSales: 46, totalUnits: 2 },
        { date: "2021-05-24", totalSales: 26, totalUnits: 50 },
        { date: "2021-05-25", totalSales: 1, totalUnits: 18 },
        { date: "2021-05-26", totalSales: 82, totalUnits: 49 },
        { date: "2021-05-27", totalSales: 41, totalUnits: 43 },
        { date: "2021-05-28", totalSales: 95, totalUnits: 14 },
        { date: "2021-05-29", totalSales: 83, totalUnits: 27 },
        { date: "2021-05-30", totalSales: 74, totalUnits: 12 },
        { date: "2021-05-31", totalSales: 55, totalUnits: 29 },
        { date: "2021-06-01", totalSales: 83, totalUnits: 40 },
        { date: "2021-06-02", totalSales: 30, totalUnits: 4 },
        { date: "2021-06-03", totalSales: 65, totalUnits: 35 },
        { date: "2021-06-04", totalSales: 9, totalUnits: 49 },
        { date: "2021-06-05", totalSales: 55, totalUnits: 4 },
        { date: "2021-06-06", totalSales: 17, totalUnits: 39 },
        { date: "2021-06-07", totalSales: 88, totalUnits: 21 },
        { date: "2021-06-08", totalSales: 95, totalUnits: 12 },
        { date: "2021-06-09", totalSales: 43, totalUnits: 37 },
        { date: "2021-06-10", totalSales: 61, totalUnits: 23 },
        { date: "2021-06-11", totalSales: 12, totalUnits: 48 },
        { date: "2021-06-12", totalSales: 70, totalUnits: 20 },
        { date: "2021-06-13", totalSales: 84, totalUnits: 8 },
        { date: "2021-06-14", totalSales: 51, totalUnits: 47 },
        { date: "2021-06-15", totalSales: 15, totalUnits: 14 },
        { date: "2021-06-16", totalSales: 23, totalUnits: 2 },
        { date: "2021-06-17", totalSales: 18, totalUnits: 28 },
        { date: "2021-06-18", totalSales: 47, totalUnits: 34 },
        { date: "2021-06-19", totalSales: 45, totalUnits: 41 },
        { date: "2021-06-20", totalSales: 73, totalUnits: 28 },
        { date: "2021-06-21", totalSales: 3, totalUnits: 50 },
        { date: "2021-06-22", totalSales: 7, totalUnits: 15 },
        { date: "2021-06-23", totalSales: 43, totalUnits: 42 },
        { date: "2021-06-24", totalSales: 73, totalUnits: 48 },
        { date: "2021-06-25", totalSales: 99, totalUnits: 25 },
        { date: "2021-06-26", totalSales: 44, totalUnits: 15 },
        { date: "2021-06-27", totalSales: 13, totalUnits: 10 },
        { date: "2021-06-28", totalSales: 65, totalUnits: 17 },
        { date: "2021-06-29", totalSales: 24, totalUnits: 15 },
        { date: "2021-06-30", totalSales: 99, totalUnits: 24 },
        { date: "2021-07-01", totalSales: 58, totalUnits: 13 },
        { date: "2021-07-02", totalSales: 2, totalUnits: 44 },
        { date: "2021-07-03", totalSales: 44, totalUnits: 27 },
        { date: "2021-07-04", totalSales: 96, totalUnits: 36 },
        { date: "2021-07-05", totalSales: 3, totalUnits: 26 },
        { date: "2021-07-06", totalSales: 92, totalUnits: 22 },
        { date: "2021-07-07", totalSales: 93, totalUnits: 41 },
        { date: "2021-07-08", totalSales: 57, totalUnits: 32 },
        { date: "2021-07-09", totalSales: 29, totalUnits: 47 },
        { date: "2021-07-10", totalSales: 86, totalUnits: 10 },
        { date: "2021-07-11", totalSales: 76, totalUnits: 24 },
        { date: "2021-07-12", totalSales: 96, totalUnits: 15 },
        { date: "2021-07-13", totalSales: 29, totalUnits: 44 },
        { date: "2021-07-14", totalSales: 82, totalUnits: 11 },
        { date: "2021-07-15", totalSales: 90, totalUnits: 30 },
        { date: "2021-07-16", totalSales: 92, totalUnits: 17 },
        { date: "2021-07-17", totalSales: 1, totalUnits: 34 },
        { date: "2021-07-18", totalSales: 93, totalUnits: 7 },
        { date: "2021-07-19", totalSales: 17, totalUnits: 34 },
        { date: "2021-07-20", totalSales: 100, totalUnits: 11 },
        { date: "2021-07-21", totalSales: 50, totalUnits: 1 },
        { date: "2021-07-22", totalSales: 95, totalUnits: 32 },
        { date: "2021-07-23", totalSales: 65, totalUnits: 45 },
        { date: "2021-07-24", totalSales: 82, totalUnits: 26 },
        { date: "2021-07-25", totalSales: 87, totalUnits: 30 },
        { date: "2021-07-26", totalSales: 7, totalUnits: 44 },
        { date: "2021-07-27", totalSales: 53, totalUnits: 35 },
        { date: "2021-07-28", totalSales: 75, totalUnits: 38 },
        { date: "2021-07-29", totalSales: 100, totalUnits: 2 },
        { date: "2021-07-30", totalSales: 59, totalUnits: 17 },
        { date: "2021-07-31", totalSales: 74, totalUnits: 36 },
        { date: "2021-08-01", totalSales: 14, totalUnits: 12 },
        { date: "2021-08-02", totalSales: 7, totalUnits: 17 },
        { date: "2021-08-03", totalSales: 21, totalUnits: 24 },
        { date: "2021-08-04", totalSales: 73, totalUnits: 4 },
        { date: "2021-08-05", totalSales: 5, totalUnits: 32 },
        { date: "2021-08-06", totalSales: 87, totalUnits: 24 },
        { date: "2021-08-07", totalSales: 38, totalUnits: 22 },
        { date: "2021-08-08", totalSales: 90, totalUnits: 30 },
        { date: "2021-08-09", totalSales: 3, totalUnits: 16 },
        { date: "2021-08-10", totalSales: 34, totalUnits: 25 },
        { date: "2021-08-11", totalSales: 10, totalUnits: 25 },
        { date: "2021-08-12", totalSales: 92, totalUnits: 39 },
        { date: "2021-08-13", totalSales: 66, totalUnits: 29 },
        { date: "2021-08-14", totalSales: 55, totalUnits: 39 },
        { date: "2021-08-15", totalSales: 49, totalUnits: 18 },
        { date: "2021-08-16", totalSales: 24, totalUnits: 11 },
        { date: "2021-08-17", totalSales: 69, totalUnits: 37 },
        { date: "2021-08-18", totalSales: 51, totalUnits: 7 },
        { date: "2021-08-19", totalSales: 41, totalUnits: 27 },
        { date: "2021-08-20", totalSales: 2, totalUnits: 26 },
        { date: "2021-08-21", totalSales: 52, totalUnits: 43 },
        { date: "2021-08-22", totalSales: 36, totalUnits: 33 },
        { date: "2021-08-23", totalSales: 13, totalUnits: 48 },
        { date: "2021-08-24", totalSales: 38, totalUnits: 11 },
        { date: "2021-08-25", totalSales: 75, totalUnits: 20 },
        { date: "2021-08-26", totalSales: 61, totalUnits: 1 },
        { date: "2021-08-27", totalSales: 64, totalUnits: 5 },
        { date: "2021-08-28", totalSales: 1, totalUnits: 29 },
        { date: "2021-08-29", totalSales: 57, totalUnits: 40 },
        { date: "2021-08-30", totalSales: 100, totalUnits: 16 },
        { date: "2021-08-31", totalSales: 78, totalUnits: 17 },
        { date: "2021-09-01", totalSales: 14, totalUnits: 22 },
        { date: "2021-09-02", totalSales: 28, totalUnits: 7 },
        { date: "2021-09-03", totalSales: 49, totalUnits: 15 },
        { date: "2021-09-04", totalSales: 40, totalUnits: 12 },
        { date: "2021-09-05", totalSales: 76, totalUnits: 37 },
        { date: "2021-09-06", totalSales: 10, totalUnits: 46 },
        { date: "2021-09-07", totalSales: 49, totalUnits: 16 },
        { date: "2021-09-08", totalSales: 15, totalUnits: 19 },
        { date: "2021-09-09", totalSales: 11, totalUnits: 6 },
        { date: "2021-09-10", totalSales: 87, totalUnits: 4 },
        { date: "2021-09-11", totalSales: 9, totalUnits: 26 },
        { date: "2021-09-12", totalSales: 95, totalUnits: 49 },
        { date: "2021-09-13", totalSales: 10, totalUnits: 40 },
        { date: "2021-09-14", totalSales: 59, totalUnits: 4 },
        { date: "2021-09-15", totalSales: 91, totalUnits: 28 },
        { date: "2021-09-16", totalSales: 29, totalUnits: 45 },
        { date: "2021-09-17", totalSales: 6, totalUnits: 14 },
        { date: "2021-09-18", totalSales: 92, totalUnits: 29 },
        { date: "2021-09-19", totalSales: 90, totalUnits: 2 },
        { date: "2021-09-20", totalSales: 35, totalUnits: 15 },
        { date: "2021-09-21", totalSales: 84, totalUnits: 26 },
        { date: "2021-09-22", totalSales: 49, totalUnits: 11 },
        { date: "2021-09-23", totalSales: 52, totalUnits: 37 },
        { date: "2021-09-24", totalSales: 71, totalUnits: 50 },
        { date: "2021-09-25", totalSales: 75, totalUnits: 30 },
        { date: "2021-09-26", totalSales: 65, totalUnits: 33 },
        { date: "2021-09-27", totalSales: 97, totalUnits: 30 },
        { date: "2021-09-28", totalSales: 30, totalUnits: 25 },
        { date: "2021-09-29", totalSales: 61, totalUnits: 50 },
        { date: "2021-09-30", totalSales: 61, totalUnits: 22 },
        { date: "2021-10-01", totalSales: 39, totalUnits: 21 },
        { date: "2021-10-02", totalSales: 48, totalUnits: 47 },
        { date: "2021-10-03", totalSales: 50, totalUnits: 46 },
        { date: "2021-10-04", totalSales: 55, totalUnits: 45 },
        { date: "2021-10-05", totalSales: 9, totalUnits: 10 },
        { date: "2021-10-06", totalSales: 25, totalUnits: 17 },
        { date: "2021-10-07", totalSales: 4, totalUnits: 8 },
        { date: "2021-10-08", totalSales: 19, totalUnits: 25 },
        { date: "2021-10-09", totalSales: 48, totalUnits: 25 },
        { date: "2021-10-10", totalSales: 22, totalUnits: 26 },
        { date: "2021-10-11", totalSales: 17, totalUnits: 49 },
        { date: "2021-10-12", totalSales: 99, totalUnits: 35 },
        { date: "2021-10-13", totalSales: 6, totalUnits: 47 },
        { date: "2021-10-14", totalSales: 16, totalUnits: 19 },
        { date: "2021-10-15", totalSales: 6, totalUnits: 5 },
        { date: "2021-10-16", totalSales: 14, totalUnits: 1 },
        { date: "2021-10-17", totalSales: 14, totalUnits: 12 },
        { date: "2021-10-18", totalSales: 92, totalUnits: 5 },
        { date: "2021-10-19", totalSales: 28, totalUnits: 21 },
        { date: "2021-10-20", totalSales: 66, totalUnits: 12 },
        { date: "2021-10-21", totalSales: 60, totalUnits: 12 },
        { date: "2021-10-22", totalSales: 3, totalUnits: 25 },
        { date: "2021-10-23", totalSales: 30, totalUnits: 40 },
        { date: "2021-10-24", totalSales: 53, totalUnits: 17 },
        { date: "2021-10-25", totalSales: 37, totalUnits: 31 },
        { date: "2021-10-26", totalSales: 100, totalUnits: 20 },
        { date: "2021-10-27", totalSales: 30, totalUnits: 23 },
        { date: "2021-10-28", totalSales: 53, totalUnits: 24 },
        { date: "2021-10-29", totalSales: 88, totalUnits: 38 },
        { date: "2021-10-30", totalSales: 71, totalUnits: 35 },
        { date: "2021-10-31", totalSales: 28, totalUnits: 5 },
        { date: "2021-11-01", totalSales: 100, totalUnits: 6 },
        { date: "2021-11-02", totalSales: 99, totalUnits: 44 },
        { date: "2021-11-03", totalSales: 59, totalUnits: 24 },
        { date: "2021-11-04", totalSales: 28, totalUnits: 10 },
        { date: "2021-11-05", totalSales: 48, totalUnits: 23 },
        { date: "2021-11-06", totalSales: 35, totalUnits: 31 },
        { date: "2021-11-07", totalSales: 13, totalUnits: 7 },
        { date: "2021-11-08", totalSales: 94, totalUnits: 31 },
        { date: "2021-11-09", totalSales: 86, totalUnits: 43 },
        { date: "2021-11-10", totalSales: 99, totalUnits: 1 },
        { date: "2021-11-11", totalSales: 26, totalUnits: 36 },
        { date: "2021-11-12", totalSales: 14, totalUnits: 39 },
        { date: "2021-11-13", totalSales: 53, totalUnits: 36 },
        { date: "2021-11-14", totalSales: 84, totalUnits: 41 },
        { date: "2021-11-15", totalSales: 86, totalUnits: 13 },
        { date: "2021-11-16", totalSales: 96, totalUnits: 49 },
        { date: "2021-11-17", totalSales: 87, totalUnits: 30 },
      ],
    },
    {
      _id: "6371259df03239cdc5000083",
      productId: "63701d24f03239d81e000015",
      yearlySalesTotal: 5994,
      yearlyTotalSoldUnits: 2338,
      monthlyData: [
        { month: "january", totalSales: 507, totalUnits: 269 },
        { month: "february", totalSales: 295, totalUnits: 22 },
        { month: "march", totalSales: 660, totalUnits: 276 },
        { month: "april", totalSales: 56, totalUnits: 483 },
        { month: "may", totalSales: 320, totalUnits: 478 },
        { month: "june", totalSales: 80, totalUnits: 480 },
        { month: "july", totalSales: 920, totalUnits: 262 },
        { month: "august", totalSales: 848, totalUnits: 38 },
        { month: "september", totalSales: 366, totalUnits: 257 },
        { month: "october", totalSales: 922, totalUnits: 46 },
        { month: "november", totalSales: 870, totalUnits: 446 },
        { month: "december", totalSales: 185, totalUnits: 385 },
      ],
      dailyData: [
        { date: "2021-01-02", totalSales: 23, totalUnits: 48 },
        { date: "2021-01-03", totalSales: 81, totalUnits: 25 },
        { date: "2021-01-04", totalSales: 22, totalUnits: 27 },
        { date: "2021-01-05", totalSales: 20, totalUnits: 38 },
        { date: "2021-01-06", totalSales: 96, totalUnits: 12 },
        { date: "2021-01-07", totalSales: 41, totalUnits: 42 },
        { date: "2021-01-08", totalSales: 12, totalUnits: 48 },
        { date: "2021-01-09", totalSales: 15, totalUnits: 24 },
        { date: "2021-01-10", totalSales: 48, totalUnits: 34 },
        { date: "2021-01-11", totalSales: 23, totalUnits: 10 },
        { date: "2021-01-12", totalSales: 58, totalUnits: 11 },
        { date: "2021-01-13", totalSales: 62, totalUnits: 18 },
        { date: "2021-01-14", totalSales: 23, totalUnits: 28 },
        { date: "2021-01-15", totalSales: 72, totalUnits: 4 },
        { date: "2021-01-16", totalSales: 49, totalUnits: 43 },
        { date: "2021-01-17", totalSales: 52, totalUnits: 31 },
        { date: "2021-01-18", totalSales: 51, totalUnits: 27 },
        { date: "2021-01-19", totalSales: 71, totalUnits: 49 },
        { date: "2021-01-20", totalSales: 61, totalUnits: 33 },
        { date: "2021-01-21", totalSales: 97, totalUnits: 11 },
        { date: "2021-01-22", totalSales: 25, totalUnits: 21 },
        { date: "2021-01-23", totalSales: 65, totalUnits: 9 },
        { date: "2021-01-24", totalSales: 91, totalUnits: 39 },
        { date: "2021-01-25", totalSales: 79, totalUnits: 22 },
        { date: "2021-01-26", totalSales: 11, totalUnits: 43 },
        { date: "2021-01-27", totalSales: 71, totalUnits: 18 },
        { date: "2021-01-28", totalSales: 49, totalUnits: 34 },
        { date: "2021-01-29", totalSales: 87, totalUnits: 9 },
        { date: "2021-01-30", totalSales: 42, totalUnits: 16 },
        { date: "2021-01-31", totalSales: 13, totalUnits: 1 },
        { date: "2021-02-01", totalSales: 13, totalUnits: 28 },
        { date: "2021-02-02", totalSales: 1, totalUnits: 22 },
        { date: "2021-02-03", totalSales: 29, totalUnits: 33 },
        { date: "2021-02-04", totalSales: 78, totalUnits: 12 },
        { date: "2021-02-05", totalSales: 51, totalUnits: 13 },
        { date: "2021-02-06", totalSales: 51, totalUnits: 4 },
        { date: "2021-02-07", totalSales: 4, totalUnits: 46 },
        { date: "2021-02-08", totalSales: 41, totalUnits: 1 },
        { date: "2021-02-09", totalSales: 84, totalUnits: 48 },
        { date: "2021-02-10", totalSales: 89, totalUnits: 41 },
        { date: "2021-02-11", totalSales: 78, totalUnits: 35 },
        { date: "2021-02-12", totalSales: 28, totalUnits: 9 },
        { date: "2021-02-13", totalSales: 54, totalUnits: 34 },
        { date: "2021-02-14", totalSales: 4, totalUnits: 4 },
        { date: "2021-02-15", totalSales: 91, totalUnits: 39 },
        { date: "2021-02-16", totalSales: 18, totalUnits: 29 },
        { date: "2021-02-17", totalSales: 73, totalUnits: 35 },
        { date: "2021-02-18", totalSales: 89, totalUnits: 13 },
        { date: "2021-02-19", totalSales: 61, totalUnits: 4 },
        { date: "2021-02-20", totalSales: 46, totalUnits: 30 },
        { date: "2021-02-21", totalSales: 87, totalUnits: 3 },
        { date: "2021-02-22", totalSales: 32, totalUnits: 15 },
        { date: "2021-02-23", totalSales: 47, totalUnits: 2 },
        { date: "2021-02-24", totalSales: 30, totalUnits: 43 },
        { date: "2021-02-25", totalSales: 18, totalUnits: 3 },
        { date: "2021-02-26", totalSales: 6, totalUnits: 30 },
        { date: "2021-02-27", totalSales: 35, totalUnits: 21 },
        { date: "2021-02-28", totalSales: 5, totalUnits: 44 },
        { date: "2021-03-01", totalSales: 7, totalUnits: 35 },
        { date: "2021-03-02", totalSales: 14, totalUnits: 34 },
        { date: "2021-03-03", totalSales: 5, totalUnits: 45 },
        { date: "2021-03-04", totalSales: 18, totalUnits: 18 },
        { date: "2021-03-05", totalSales: 80, totalUnits: 18 },
        { date: "2021-03-06", totalSales: 86, totalUnits: 32 },
        { date: "2021-03-07", totalSales: 16, totalUnits: 8 },
        { date: "2021-03-08", totalSales: 67, totalUnits: 34 },
        { date: "2021-03-09", totalSales: 43, totalUnits: 37 },
        { date: "2021-03-10", totalSales: 83, totalUnits: 31 },
        { date: "2021-03-11", totalSales: 85, totalUnits: 44 },
        { date: "2021-03-12", totalSales: 82, totalUnits: 20 },
        { date: "2021-03-13", totalSales: 34, totalUnits: 41 },
        { date: "2021-03-14", totalSales: 31, totalUnits: 30 },
        { date: "2021-03-15", totalSales: 87, totalUnits: 7 },
        { date: "2021-03-16", totalSales: 93, totalUnits: 35 },
        { date: "2021-03-17", totalSales: 73, totalUnits: 37 },
        { date: "2021-03-18", totalSales: 41, totalUnits: 26 },
        { date: "2021-03-19", totalSales: 33, totalUnits: 13 },
        { date: "2021-03-20", totalSales: 20, totalUnits: 26 },
        { date: "2021-03-21", totalSales: 39, totalUnits: 38 },
        { date: "2021-03-22", totalSales: 43, totalUnits: 43 },
        { date: "2021-03-23", totalSales: 74, totalUnits: 45 },
        { date: "2021-03-24", totalSales: 23, totalUnits: 45 },
        { date: "2021-03-25", totalSales: 91, totalUnits: 38 },
        { date: "2021-03-26", totalSales: 1, totalUnits: 35 },
        { date: "2021-03-27", totalSales: 35, totalUnits: 40 },
        { date: "2021-03-28", totalSales: 33, totalUnits: 27 },
        { date: "2021-03-29", totalSales: 29, totalUnits: 50 },
        { date: "2021-03-30", totalSales: 37, totalUnits: 6 },
        { date: "2021-03-31", totalSales: 81, totalUnits: 45 },
        { date: "2021-04-01", totalSales: 64, totalUnits: 44 },
        { date: "2021-04-02", totalSales: 78, totalUnits: 4 },
        { date: "2021-04-03", totalSales: 75, totalUnits: 6 },
        { date: "2021-04-04", totalSales: 1, totalUnits: 13 },
        { date: "2021-04-05", totalSales: 1, totalUnits: 22 },
        { date: "2021-04-06", totalSales: 48, totalUnits: 14 },
        { date: "2021-04-07", totalSales: 27, totalUnits: 17 },
        { date: "2021-04-08", totalSales: 20, totalUnits: 38 },
        { date: "2021-04-09", totalSales: 48, totalUnits: 35 },
        { date: "2021-04-10", totalSales: 19, totalUnits: 1 },
        { date: "2021-04-11", totalSales: 19, totalUnits: 45 },
        { date: "2021-04-12", totalSales: 36, totalUnits: 47 },
        { date: "2021-04-13", totalSales: 59, totalUnits: 17 },
        { date: "2021-04-14", totalSales: 4, totalUnits: 26 },
        { date: "2021-04-15", totalSales: 16, totalUnits: 35 },
        { date: "2021-04-16", totalSales: 58, totalUnits: 50 },
        { date: "2021-04-17", totalSales: 2, totalUnits: 3 },
        { date: "2021-04-18", totalSales: 62, totalUnits: 46 },
        { date: "2021-04-19", totalSales: 57, totalUnits: 40 },
        { date: "2021-04-20", totalSales: 50, totalUnits: 16 },
        { date: "2021-04-21", totalSales: 15, totalUnits: 11 },
        { date: "2021-04-22", totalSales: 32, totalUnits: 48 },
        { date: "2021-04-23", totalSales: 50, totalUnits: 40 },
        { date: "2021-04-24", totalSales: 55, totalUnits: 34 },
        { date: "2021-04-25", totalSales: 5, totalUnits: 39 },
        { date: "2021-04-26", totalSales: 81, totalUnits: 27 },
        { date: "2021-04-27", totalSales: 19, totalUnits: 24 },
        { date: "2021-04-28", totalSales: 13, totalUnits: 30 },
        { date: "2021-04-29", totalSales: 50, totalUnits: 36 },
        { date: "2021-04-30", totalSales: 57, totalUnits: 36 },
        { date: "2021-05-01", totalSales: 47, totalUnits: 14 },
        { date: "2021-05-02", totalSales: 24, totalUnits: 12 },
        { date: "2021-05-03", totalSales: 54, totalUnits: 8 },
        { date: "2021-05-04", totalSales: 98, totalUnits: 37 },
        { date: "2021-05-05", totalSales: 62, totalUnits: 31 },
        { date: "2021-05-06", totalSales: 23, totalUnits: 16 },
        { date: "2021-05-07", totalSales: 4, totalUnits: 24 },
        { date: "2021-05-08", totalSales: 62, totalUnits: 48 },
        { date: "2021-05-09", totalSales: 87, totalUnits: 39 },
        { date: "2021-05-10", totalSales: 65, totalUnits: 7 },
        { date: "2021-05-11", totalSales: 31, totalUnits: 36 },
        { date: "2021-05-12", totalSales: 86, totalUnits: 49 },
        { date: "2021-05-13", totalSales: 21, totalUnits: 46 },
        { date: "2021-05-14", totalSales: 8, totalUnits: 45 },
        { date: "2021-05-15", totalSales: 25, totalUnits: 29 },
        { date: "2021-05-16", totalSales: 70, totalUnits: 13 },
        { date: "2021-05-17", totalSales: 92, totalUnits: 17 },
        { date: "2021-05-18", totalSales: 15, totalUnits: 6 },
        { date: "2021-05-19", totalSales: 80, totalUnits: 4 },
        { date: "2021-05-20", totalSales: 67, totalUnits: 44 },
        { date: "2021-05-21", totalSales: 63, totalUnits: 8 },
        { date: "2021-05-22", totalSales: 36, totalUnits: 38 },
        { date: "2021-05-23", totalSales: 26, totalUnits: 2 },
        { date: "2021-05-24", totalSales: 27, totalUnits: 17 },
        { date: "2021-05-25", totalSales: 100, totalUnits: 2 },
        { date: "2021-05-26", totalSales: 9, totalUnits: 46 },
        { date: "2021-05-27", totalSales: 73, totalUnits: 47 },
        { date: "2021-05-28", totalSales: 16, totalUnits: 37 },
        { date: "2021-05-29", totalSales: 31, totalUnits: 16 },
        { date: "2021-05-30", totalSales: 75, totalUnits: 21 },
        { date: "2021-05-31", totalSales: 33, totalUnits: 39 },
        { date: "2021-06-01", totalSales: 47, totalUnits: 42 },
        { date: "2021-06-02", totalSales: 20, totalUnits: 23 },
        { date: "2021-06-03", totalSales: 45, totalUnits: 14 },
        { date: "2021-06-04", totalSales: 74, totalUnits: 7 },
        { date: "2021-06-05", totalSales: 34, totalUnits: 37 },
        { date: "2021-06-06", totalSales: 33, totalUnits: 46 },
        { date: "2021-06-07", totalSales: 31, totalUnits: 39 },
        { date: "2021-06-08", totalSales: 15, totalUnits: 42 },
        { date: "2021-06-09", totalSales: 51, totalUnits: 14 },
        { date: "2021-06-10", totalSales: 85, totalUnits: 4 },
        { date: "2021-06-11", totalSales: 18, totalUnits: 35 },
        { date: "2021-06-12", totalSales: 36, totalUnits: 8 },
        { date: "2021-06-13", totalSales: 79, totalUnits: 23 },
        { date: "2021-06-14", totalSales: 49, totalUnits: 29 },
        { date: "2021-06-15", totalSales: 50, totalUnits: 41 },
        { date: "2021-06-16", totalSales: 28, totalUnits: 50 },
        { date: "2021-06-17", totalSales: 4, totalUnits: 12 },
        { date: "2021-06-18", totalSales: 14, totalUnits: 10 },
        { date: "2021-06-19", totalSales: 65, totalUnits: 8 },
        { date: "2021-06-20", totalSales: 62, totalUnits: 21 },
        { date: "2021-06-21", totalSales: 83, totalUnits: 12 },
        { date: "2021-06-22", totalSales: 69, totalUnits: 2 },
        { date: "2021-06-23", totalSales: 45, totalUnits: 31 },
        { date: "2021-06-24", totalSales: 55, totalUnits: 16 },
        { date: "2021-06-25", totalSales: 18, totalUnits: 4 },
        { date: "2021-06-26", totalSales: 29, totalUnits: 28 },
        { date: "2021-06-27", totalSales: 50, totalUnits: 36 },
        { date: "2021-06-28", totalSales: 3, totalUnits: 25 },
        { date: "2021-06-29", totalSales: 59, totalUnits: 37 },
        { date: "2021-06-30", totalSales: 39, totalUnits: 36 },
        { date: "2021-07-01", totalSales: 53, totalUnits: 43 },
        { date: "2021-07-02", totalSales: 20, totalUnits: 15 },
        { date: "2021-07-03", totalSales: 92, totalUnits: 27 },
        { date: "2021-07-04", totalSales: 71, totalUnits: 50 },
        { date: "2021-07-05", totalSales: 85, totalUnits: 46 },
        { date: "2021-07-06", totalSales: 39, totalUnits: 49 },
        { date: "2021-07-07", totalSales: 80, totalUnits: 24 },
        { date: "2021-07-08", totalSales: 28, totalUnits: 29 },
        { date: "2021-07-09", totalSales: 49, totalUnits: 48 },
        { date: "2021-07-10", totalSales: 31, totalUnits: 22 },
        { date: "2021-07-11", totalSales: 50, totalUnits: 9 },
        { date: "2021-07-12", totalSales: 10, totalUnits: 41 },
        { date: "2021-07-13", totalSales: 33, totalUnits: 39 },
        { date: "2021-07-14", totalSales: 87, totalUnits: 46 },
        { date: "2021-07-15", totalSales: 29, totalUnits: 32 },
        { date: "2021-07-16", totalSales: 76, totalUnits: 34 },
        { date: "2021-07-17", totalSales: 55, totalUnits: 14 },
        { date: "2021-07-18", totalSales: 49, totalUnits: 6 },
        { date: "2021-07-19", totalSales: 20, totalUnits: 46 },
        { date: "2021-07-20", totalSales: 31, totalUnits: 17 },
        { date: "2021-07-21", totalSales: 83, totalUnits: 18 },
        { date: "2021-07-22", totalSales: 39, totalUnits: 29 },
        { date: "2021-07-23", totalSales: 18, totalUnits: 16 },
        { date: "2021-07-24", totalSales: 72, totalUnits: 37 },
        { date: "2021-07-25", totalSales: 31, totalUnits: 36 },
        { date: "2021-07-26", totalSales: 9, totalUnits: 23 },
        { date: "2021-07-27", totalSales: 73, totalUnits: 7 },
        { date: "2021-07-28", totalSales: 80, totalUnits: 15 },
        { date: "2021-07-29", totalSales: 97, totalUnits: 16 },
        { date: "2021-07-30", totalSales: 56, totalUnits: 1 },
        { date: "2021-07-31", totalSales: 86, totalUnits: 24 },
        { date: "2021-08-01", totalSales: 49, totalUnits: 10 },
        { date: "2021-08-02", totalSales: 13, totalUnits: 6 },
        { date: "2021-08-03", totalSales: 94, totalUnits: 34 },
        { date: "2021-08-04", totalSales: 78, totalUnits: 27 },
        { date: "2021-08-05", totalSales: 93, totalUnits: 27 },
        { date: "2021-08-06", totalSales: 93, totalUnits: 48 },
        { date: "2021-08-07", totalSales: 11, totalUnits: 44 },
        { date: "2021-08-08", totalSales: 30, totalUnits: 39 },
        { date: "2021-08-09", totalSales: 32, totalUnits: 40 },
        { date: "2021-08-10", totalSales: 6, totalUnits: 34 },
        { date: "2021-08-11", totalSales: 43, totalUnits: 33 },
        { date: "2021-08-12", totalSales: 16, totalUnits: 36 },
        { date: "2021-08-13", totalSales: 58, totalUnits: 15 },
        { date: "2021-08-14", totalSales: 71, totalUnits: 7 },
        { date: "2021-08-15", totalSales: 46, totalUnits: 39 },
        { date: "2021-08-16", totalSales: 70, totalUnits: 4 },
        { date: "2021-08-17", totalSales: 88, totalUnits: 23 },
        { date: "2021-08-18", totalSales: 68, totalUnits: 20 },
        { date: "2021-08-19", totalSales: 91, totalUnits: 45 },
        { date: "2021-08-20", totalSales: 32, totalUnits: 21 },
        { date: "2021-08-21", totalSales: 11, totalUnits: 26 },
        { date: "2021-08-22", totalSales: 41, totalUnits: 37 },
        { date: "2021-08-23", totalSales: 14, totalUnits: 43 },
        { date: "2021-08-24", totalSales: 89, totalUnits: 30 },
        { date: "2021-08-25", totalSales: 51, totalUnits: 9 },
        { date: "2021-08-26", totalSales: 73, totalUnits: 50 },
        { date: "2021-08-27", totalSales: 56, totalUnits: 29 },
        { date: "2021-08-28", totalSales: 11, totalUnits: 28 },
        { date: "2021-08-29", totalSales: 95, totalUnits: 50 },
        { date: "2021-08-30", totalSales: 74, totalUnits: 13 },
        { date: "2021-08-31", totalSales: 74, totalUnits: 49 },
        { date: "2021-09-01", totalSales: 99, totalUnits: 39 },
        { date: "2021-09-02", totalSales: 99, totalUnits: 5 },
        { date: "2021-09-03", totalSales: 88, totalUnits: 2 },
        { date: "2021-09-04", totalSales: 17, totalUnits: 16 },
        { date: "2021-09-05", totalSales: 9, totalUnits: 28 },
        { date: "2021-09-06", totalSales: 68, totalUnits: 27 },
        { date: "2021-09-07", totalSales: 10, totalUnits: 30 },
        { date: "2021-09-08", totalSales: 23, totalUnits: 21 },
        { date: "2021-09-09", totalSales: 7, totalUnits: 41 },
        { date: "2021-09-10", totalSales: 31, totalUnits: 29 },
        { date: "2021-09-11", totalSales: 28, totalUnits: 41 },
        { date: "2021-09-12", totalSales: 24, totalUnits: 48 },
        { date: "2021-09-13", totalSales: 77, totalUnits: 11 },
        { date: "2021-09-14", totalSales: 17, totalUnits: 30 },
        { date: "2021-09-15", totalSales: 75, totalUnits: 20 },
        { date: "2021-09-16", totalSales: 80, totalUnits: 26 },
        { date: "2021-09-17", totalSales: 8, totalUnits: 1 },
        { date: "2021-09-18", totalSales: 97, totalUnits: 49 },
        { date: "2021-09-19", totalSales: 35, totalUnits: 7 },
        { date: "2021-09-20", totalSales: 80, totalUnits: 37 },
        { date: "2021-09-21", totalSales: 24, totalUnits: 31 },
        { date: "2021-09-22", totalSales: 43, totalUnits: 49 },
        { date: "2021-09-23", totalSales: 52, totalUnits: 31 },
        { date: "2021-09-24", totalSales: 78, totalUnits: 36 },
        { date: "2021-09-25", totalSales: 37, totalUnits: 41 },
        { date: "2021-09-26", totalSales: 62, totalUnits: 2 },
        { date: "2021-09-27", totalSales: 35, totalUnits: 42 },
        { date: "2021-09-28", totalSales: 25, totalUnits: 35 },
        { date: "2021-09-29", totalSales: 35, totalUnits: 50 },
        { date: "2021-09-30", totalSales: 76, totalUnits: 11 },
        { date: "2021-10-01", totalSales: 42, totalUnits: 14 },
        { date: "2021-10-02", totalSales: 48, totalUnits: 11 },
        { date: "2021-10-03", totalSales: 27, totalUnits: 34 },
        { date: "2021-10-04", totalSales: 10, totalUnits: 37 },
        { date: "2021-10-05", totalSales: 30, totalUnits: 19 },
        { date: "2021-10-06", totalSales: 13, totalUnits: 44 },
        { date: "2021-10-07", totalSales: 80, totalUnits: 9 },
        { date: "2021-10-08", totalSales: 8, totalUnits: 23 },
        { date: "2021-10-09", totalSales: 50, totalUnits: 29 },
        { date: "2021-10-10", totalSales: 98, totalUnits: 7 },
        { date: "2021-10-11", totalSales: 28, totalUnits: 36 },
        { date: "2021-10-12", totalSales: 70, totalUnits: 21 },
        { date: "2021-10-13", totalSales: 38, totalUnits: 16 },
        { date: "2021-10-14", totalSales: 66, totalUnits: 6 },
        { date: "2021-10-15", totalSales: 73, totalUnits: 47 },
        { date: "2021-10-16", totalSales: 48, totalUnits: 6 },
        { date: "2021-10-17", totalSales: 39, totalUnits: 39 },
        { date: "2021-10-18", totalSales: 64, totalUnits: 24 },
        { date: "2021-10-19", totalSales: 79, totalUnits: 50 },
        { date: "2021-10-20", totalSales: 76, totalUnits: 38 },
        { date: "2021-10-21", totalSales: 80, totalUnits: 30 },
        { date: "2021-10-22", totalSales: 34, totalUnits: 28 },
        { date: "2021-10-23", totalSales: 37, totalUnits: 34 },
        { date: "2021-10-24", totalSales: 34, totalUnits: 15 },
        { date: "2021-10-25", totalSales: 38, totalUnits: 47 },
        { date: "2021-10-26", totalSales: 58, totalUnits: 7 },
        { date: "2021-10-27", totalSales: 21, totalUnits: 28 },
        { date: "2021-10-28", totalSales: 83, totalUnits: 50 },
        { date: "2021-10-29", totalSales: 35, totalUnits: 25 },
        { date: "2021-10-30", totalSales: 33, totalUnits: 2 },
        { date: "2021-10-31", totalSales: 54, totalUnits: 42 },
        { date: "2021-11-01", totalSales: 14, totalUnits: 2 },
        { date: "2021-11-02", totalSales: 17, totalUnits: 21 },
        { date: "2021-11-03", totalSales: 15, totalUnits: 49 },
        { date: "2021-11-04", totalSales: 44, totalUnits: 40 },
        { date: "2021-11-05", totalSales: 18, totalUnits: 8 },
        { date: "2021-11-06", totalSales: 18, totalUnits: 9 },
        { date: "2021-11-07", totalSales: 61, totalUnits: 24 },
        { date: "2021-11-08", totalSales: 69, totalUnits: 10 },
        { date: "2021-11-09", totalSales: 87, totalUnits: 10 },
        { date: "2021-11-10", totalSales: 65, totalUnits: 34 },
        { date: "2021-11-11", totalSales: 82, totalUnits: 30 },
        { date: "2021-11-12", totalSales: 27, totalUnits: 32 },
        { date: "2021-11-13", totalSales: 99, totalUnits: 29 },
        { date: "2021-11-14", totalSales: 76, totalUnits: 18 },
        { date: "2021-11-15", totalSales: 99, totalUnits: 5 },
        { date: "2021-11-16", totalSales: 12, totalUnits: 36 },
        { date: "2021-11-17", totalSales: 81, totalUnits: 2 },
      ],
    },
    {
      _id: "6371259df032399c00000198",
      productId: "63701d24f03239d81e000016",
      yearlySalesTotal: 5650,
      yearlyTotalSoldUnits: 2225,
      monthlyData: [
        { month: "january", totalSales: 119, totalUnits: 100 },
        { month: "february", totalSales: 16, totalUnits: 233 },
        { month: "march", totalSales: 30, totalUnits: 492 },
        { month: "april", totalSales: 825, totalUnits: 367 },
        { month: "may", totalSales: 901, totalUnits: 16 },
        { month: "june", totalSales: 595, totalUnits: 34 },
        { month: "july", totalSales: 309, totalUnits: 168 },
        { month: "august", totalSales: 836, totalUnits: 35 },
        { month: "september", totalSales: 594, totalUnits: 258 },
        { month: "october", totalSales: 640, totalUnits: 292 },
        { month: "november", totalSales: 707, totalUnits: 492 },
        { month: "december", totalSales: 914, totalUnits: 60 },
      ],
      dailyData: [
        { date: "2021-01-02", totalSales: 59, totalUnits: 2 },
        { date: "2021-01-03", totalSales: 96, totalUnits: 36 },
        { date: "2021-01-04", totalSales: 5, totalUnits: 33 },
        { date: "2021-01-05", totalSales: 3, totalUnits: 6 },
        { date: "2021-01-06", totalSales: 67, totalUnits: 8 },
        { date: "2021-01-07", totalSales: 30, totalUnits: 13 },
        { date: "2021-01-08", totalSales: 36, totalUnits: 18 },
        { date: "2021-01-09", totalSales: 85, totalUnits: 40 },
        { date: "2021-01-10", totalSales: 73, totalUnits: 2 },
        { date: "2021-01-11", totalSales: 83, totalUnits: 48 },
        { date: "2021-01-12", totalSales: 98, totalUnits: 26 },
        { date: "2021-01-13", totalSales: 1, totalUnits: 13 },
        { date: "2021-01-14", totalSales: 9, totalUnits: 14 },
        { date: "2021-01-15", totalSales: 54, totalUnits: 27 },
        { date: "2021-01-16", totalSales: 31, totalUnits: 38 },
        { date: "2021-01-17", totalSales: 19, totalUnits: 12 },
        { date: "2021-01-18", totalSales: 69, totalUnits: 9 },
        { date: "2021-01-19", totalSales: 74, totalUnits: 12 },
        { date: "2021-01-20", totalSales: 98, totalUnits: 44 },
        { date: "2021-01-21", totalSales: 74, totalUnits: 25 },
        { date: "2021-01-22", totalSales: 65, totalUnits: 13 },
        { date: "2021-01-23", totalSales: 50, totalUnits: 15 },
        { date: "2021-01-24", totalSales: 59, totalUnits: 17 },
        { date: "2021-01-25", totalSales: 58, totalUnits: 49 },
        { date: "2021-01-26", totalSales: 22, totalUnits: 32 },
        { date: "2021-01-27", totalSales: 42, totalUnits: 13 },
        { date: "2021-01-28", totalSales: 14, totalUnits: 25 },
        { date: "2021-01-29", totalSales: 12, totalUnits: 47 },
        { date: "2021-01-30", totalSales: 43, totalUnits: 30 },
        { date: "2021-01-31", totalSales: 40, totalUnits: 18 },
        { date: "2021-02-01", totalSales: 46, totalUnits: 22 },
        { date: "2021-02-02", totalSales: 78, totalUnits: 8 },
        { date: "2021-02-03", totalSales: 94, totalUnits: 17 },
        { date: "2021-02-04", totalSales: 70, totalUnits: 31 },
        { date: "2021-02-05", totalSales: 40, totalUnits: 42 },
        { date: "2021-02-06", totalSales: 78, totalUnits: 21 },
        { date: "2021-02-07", totalSales: 58, totalUnits: 35 },
        { date: "2021-02-08", totalSales: 94, totalUnits: 43 },
        { date: "2021-02-09", totalSales: 59, totalUnits: 36 },
        { date: "2021-02-10", totalSales: 28, totalUnits: 39 },
        { date: "2021-02-11", totalSales: 33, totalUnits: 30 },
        { date: "2021-02-12", totalSales: 4, totalUnits: 22 },
        { date: "2021-02-13", totalSales: 17, totalUnits: 21 },
        { date: "2021-02-14", totalSales: 67, totalUnits: 27 },
        { date: "2021-02-15", totalSales: 13, totalUnits: 2 },
        { date: "2021-02-16", totalSales: 36, totalUnits: 7 },
        { date: "2021-02-17", totalSales: 78, totalUnits: 50 },
        { date: "2021-02-18", totalSales: 4, totalUnits: 25 },
        { date: "2021-02-19", totalSales: 90, totalUnits: 40 },
        { date: "2021-02-20", totalSales: 7, totalUnits: 43 },
        { date: "2021-02-21", totalSales: 95, totalUnits: 26 },
        { date: "2021-02-22", totalSales: 75, totalUnits: 27 },
        { date: "2021-02-23", totalSales: 44, totalUnits: 38 },
        { date: "2021-02-24", totalSales: 86, totalUnits: 47 },
        { date: "2021-02-25", totalSales: 29, totalUnits: 39 },
        { date: "2021-02-26", totalSales: 27, totalUnits: 42 },
        { date: "2021-02-27", totalSales: 19, totalUnits: 23 },
        { date: "2021-02-28", totalSales: 75, totalUnits: 11 },
        { date: "2021-03-01", totalSales: 91, totalUnits: 47 },
        { date: "2021-03-02", totalSales: 83, totalUnits: 5 },
        { date: "2021-03-03", totalSales: 84, totalUnits: 26 },
        { date: "2021-03-04", totalSales: 88, totalUnits: 36 },
        { date: "2021-03-05", totalSales: 18, totalUnits: 47 },
        { date: "2021-03-06", totalSales: 1, totalUnits: 4 },
        { date: "2021-03-07", totalSales: 19, totalUnits: 19 },
        { date: "2021-03-08", totalSales: 99, totalUnits: 33 },
        { date: "2021-03-09", totalSales: 99, totalUnits: 44 },
        { date: "2021-03-10", totalSales: 87, totalUnits: 37 },
        { date: "2021-03-11", totalSales: 34, totalUnits: 31 },
        { date: "2021-03-12", totalSales: 68, totalUnits: 27 },
        { date: "2021-03-13", totalSales: 100, totalUnits: 38 },
        { date: "2021-03-14", totalSales: 23, totalUnits: 11 },
        { date: "2021-03-15", totalSales: 85, totalUnits: 33 },
        { date: "2021-03-16", totalSales: 7, totalUnits: 1 },
        { date: "2021-03-17", totalSales: 88, totalUnits: 38 },
        { date: "2021-03-18", totalSales: 90, totalUnits: 19 },
        { date: "2021-03-19", totalSales: 8, totalUnits: 11 },
        { date: "2021-03-20", totalSales: 34, totalUnits: 38 },
        { date: "2021-03-21", totalSales: 38, totalUnits: 48 },
        { date: "2021-03-22", totalSales: 62, totalUnits: 14 },
        { date: "2021-03-23", totalSales: 44, totalUnits: 12 },
        { date: "2021-03-24", totalSales: 32, totalUnits: 45 },
        { date: "2021-03-25", totalSales: 69, totalUnits: 21 },
        { date: "2021-03-26", totalSales: 75, totalUnits: 21 },
        { date: "2021-03-27", totalSales: 55, totalUnits: 28 },
        { date: "2021-03-28", totalSales: 16, totalUnits: 43 },
        { date: "2021-03-29", totalSales: 3, totalUnits: 5 },
        { date: "2021-03-30", totalSales: 24, totalUnits: 48 },
        { date: "2021-03-31", totalSales: 81, totalUnits: 22 },
        { date: "2021-04-01", totalSales: 87, totalUnits: 28 },
        { date: "2021-04-02", totalSales: 10, totalUnits: 21 },
        { date: "2021-04-03", totalSales: 87, totalUnits: 12 },
        { date: "2021-04-04", totalSales: 84, totalUnits: 9 },
        { date: "2021-04-05", totalSales: 50, totalUnits: 30 },
        { date: "2021-04-06", totalSales: 55, totalUnits: 16 },
        { date: "2021-04-07", totalSales: 18, totalUnits: 20 },
        { date: "2021-04-08", totalSales: 30, totalUnits: 16 },
        { date: "2021-04-09", totalSales: 53, totalUnits: 11 },
        { date: "2021-04-10", totalSales: 99, totalUnits: 42 },
        { date: "2021-04-11", totalSales: 27, totalUnits: 44 },
        { date: "2021-04-12", totalSales: 83, totalUnits: 1 },
        { date: "2021-04-13", totalSales: 57, totalUnits: 49 },
        { date: "2021-04-14", totalSales: 43, totalUnits: 30 },
        { date: "2021-04-15", totalSales: 73, totalUnits: 22 },
        { date: "2021-04-16", totalSales: 93, totalUnits: 33 },
        { date: "2021-04-17", totalSales: 70, totalUnits: 47 },
        { date: "2021-04-18", totalSales: 38, totalUnits: 39 },
        { date: "2021-04-19", totalSales: 97, totalUnits: 17 },
        { date: "2021-04-20", totalSales: 5, totalUnits: 18 },
        { date: "2021-04-21", totalSales: 91, totalUnits: 13 },
        { date: "2021-04-22", totalSales: 21, totalUnits: 50 },
        { date: "2021-04-23", totalSales: 30, totalUnits: 26 },
        { date: "2021-04-24", totalSales: 34, totalUnits: 3 },
        { date: "2021-04-25", totalSales: 63, totalUnits: 20 },
        { date: "2021-04-26", totalSales: 12, totalUnits: 8 },
        { date: "2021-04-27", totalSales: 96, totalUnits: 30 },
        { date: "2021-04-28", totalSales: 9, totalUnits: 46 },
        { date: "2021-04-29", totalSales: 61, totalUnits: 22 },
        { date: "2021-04-30", totalSales: 2, totalUnits: 17 },
        { date: "2021-05-01", totalSales: 100, totalUnits: 20 },
        { date: "2021-05-02", totalSales: 56, totalUnits: 46 },
        { date: "2021-05-03", totalSales: 31, totalUnits: 8 },
        { date: "2021-05-04", totalSales: 7, totalUnits: 48 },
        { date: "2021-05-05", totalSales: 91, totalUnits: 5 },
        { date: "2021-05-06", totalSales: 42, totalUnits: 29 },
        { date: "2021-05-07", totalSales: 23, totalUnits: 49 },
        { date: "2021-05-08", totalSales: 94, totalUnits: 36 },
        { date: "2021-05-09", totalSales: 25, totalUnits: 28 },
        { date: "2021-05-10", totalSales: 28, totalUnits: 38 },
        { date: "2021-05-11", totalSales: 35, totalUnits: 20 },
        { date: "2021-05-12", totalSales: 43, totalUnits: 17 },
        { date: "2021-05-13", totalSales: 54, totalUnits: 3 },
        { date: "2021-05-14", totalSales: 77, totalUnits: 47 },
        { date: "2021-05-15", totalSales: 11, totalUnits: 18 },
        { date: "2021-05-16", totalSales: 64, totalUnits: 3 },
        { date: "2021-05-17", totalSales: 27, totalUnits: 20 },
        { date: "2021-05-18", totalSales: 74, totalUnits: 8 },
        { date: "2021-05-19", totalSales: 58, totalUnits: 8 },
        { date: "2021-05-20", totalSales: 28, totalUnits: 13 },
        { date: "2021-05-21", totalSales: 98, totalUnits: 29 },
        { date: "2021-05-22", totalSales: 27, totalUnits: 23 },
        { date: "2021-05-23", totalSales: 8, totalUnits: 46 },
        { date: "2021-05-24", totalSales: 97, totalUnits: 3 },
        { date: "2021-05-25", totalSales: 78, totalUnits: 19 },
        { date: "2021-05-26", totalSales: 67, totalUnits: 48 },
        { date: "2021-05-27", totalSales: 45, totalUnits: 11 },
        { date: "2021-05-28", totalSales: 65, totalUnits: 5 },
        { date: "2021-05-29", totalSales: 13, totalUnits: 8 },
        { date: "2021-05-30", totalSales: 76, totalUnits: 28 },
        { date: "2021-05-31", totalSales: 38, totalUnits: 21 },
        { date: "2021-06-01", totalSales: 60, totalUnits: 12 },
        { date: "2021-06-02", totalSales: 95, totalUnits: 39 },
        { date: "2021-06-03", totalSales: 87, totalUnits: 28 },
        { date: "2021-06-04", totalSales: 37, totalUnits: 21 },
        { date: "2021-06-05", totalSales: 10, totalUnits: 34 },
        { date: "2021-06-06", totalSales: 89, totalUnits: 31 },
        { date: "2021-06-07", totalSales: 94, totalUnits: 3 },
        { date: "2021-06-08", totalSales: 92, totalUnits: 32 },
        { date: "2021-06-09", totalSales: 22, totalUnits: 32 },
        { date: "2021-06-10", totalSales: 45, totalUnits: 38 },
        { date: "2021-06-11", totalSales: 78, totalUnits: 15 },
        { date: "2021-06-12", totalSales: 48, totalUnits: 9 },
        { date: "2021-06-13", totalSales: 40, totalUnits: 4 },
        { date: "2021-06-14", totalSales: 42, totalUnits: 28 },
        { date: "2021-06-15", totalSales: 76, totalUnits: 44 },
        { date: "2021-06-16", totalSales: 58, totalUnits: 29 },
        { date: "2021-06-17", totalSales: 59, totalUnits: 45 },
        { date: "2021-06-18", totalSales: 15, totalUnits: 24 },
        { date: "2021-06-19", totalSales: 58, totalUnits: 45 },
        { date: "2021-06-20", totalSales: 93, totalUnits: 11 },
        { date: "2021-06-21", totalSales: 86, totalUnits: 17 },
        { date: "2021-06-22", totalSales: 92, totalUnits: 47 },
        { date: "2021-06-23", totalSales: 54, totalUnits: 2 },
        { date: "2021-06-24", totalSales: 50, totalUnits: 21 },
        { date: "2021-06-25", totalSales: 38, totalUnits: 39 },
        { date: "2021-06-26", totalSales: 76, totalUnits: 9 },
        { date: "2021-06-27", totalSales: 68, totalUnits: 47 },
        { date: "2021-06-28", totalSales: 6, totalUnits: 17 },
        { date: "2021-06-29", totalSales: 9, totalUnits: 42 },
        { date: "2021-06-30", totalSales: 34, totalUnits: 26 },
        { date: "2021-07-01", totalSales: 14, totalUnits: 50 },
        { date: "2021-07-02", totalSales: 77, totalUnits: 31 },
        { date: "2021-07-03", totalSales: 66, totalUnits: 17 },
        { date: "2021-07-04", totalSales: 72, totalUnits: 33 },
        { date: "2021-07-05", totalSales: 68, totalUnits: 23 },
        { date: "2021-07-06", totalSales: 12, totalUnits: 14 },
        { date: "2021-07-07", totalSales: 62, totalUnits: 50 },
        { date: "2021-07-08", totalSales: 79, totalUnits: 27 },
        { date: "2021-07-09", totalSales: 56, totalUnits: 8 },
        { date: "2021-07-10", totalSales: 1, totalUnits: 31 },
        { date: "2021-07-11", totalSales: 41, totalUnits: 5 },
        { date: "2021-07-12", totalSales: 14, totalUnits: 9 },
        { date: "2021-07-13", totalSales: 5, totalUnits: 23 },
        { date: "2021-07-14", totalSales: 66, totalUnits: 14 },
        { date: "2021-07-15", totalSales: 67, totalUnits: 19 },
        { date: "2021-07-16", totalSales: 96, totalUnits: 26 },
        { date: "2021-07-17", totalSales: 98, totalUnits: 20 },
        { date: "2021-07-18", totalSales: 21, totalUnits: 35 },
        { date: "2021-07-19", totalSales: 60, totalUnits: 23 },
        { date: "2021-07-20", totalSales: 64, totalUnits: 33 },
        { date: "2021-07-21", totalSales: 93, totalUnits: 8 },
        { date: "2021-07-22", totalSales: 19, totalUnits: 4 },
        { date: "2021-07-23", totalSales: 5, totalUnits: 19 },
        { date: "2021-07-24", totalSales: 38, totalUnits: 3 },
        { date: "2021-07-25", totalSales: 40, totalUnits: 45 },
        { date: "2021-07-26", totalSales: 37, totalUnits: 30 },
        { date: "2021-07-27", totalSales: 77, totalUnits: 4 },
        { date: "2021-07-28", totalSales: 33, totalUnits: 15 },
        { date: "2021-07-29", totalSales: 93, totalUnits: 46 },
        { date: "2021-07-30", totalSales: 100, totalUnits: 20 },
        { date: "2021-07-31", totalSales: 36, totalUnits: 26 },
        { date: "2021-08-01", totalSales: 51, totalUnits: 14 },
        { date: "2021-08-02", totalSales: 78, totalUnits: 8 },
        { date: "2021-08-03", totalSales: 71, totalUnits: 3 },
        { date: "2021-08-04", totalSales: 28, totalUnits: 50 },
        { date: "2021-08-05", totalSales: 54, totalUnits: 10 },
        { date: "2021-08-06", totalSales: 60, totalUnits: 42 },
        { date: "2021-08-07", totalSales: 26, totalUnits: 41 },
        { date: "2021-08-08", totalSales: 93, totalUnits: 44 },
        { date: "2021-08-09", totalSales: 40, totalUnits: 39 },
        { date: "2021-08-10", totalSales: 95, totalUnits: 42 },
        { date: "2021-08-11", totalSales: 71, totalUnits: 7 },
        { date: "2021-08-12", totalSales: 91, totalUnits: 22 },
        { date: "2021-08-13", totalSales: 10, totalUnits: 12 },
        { date: "2021-08-14", totalSales: 3, totalUnits: 17 },
        { date: "2021-08-15", totalSales: 95, totalUnits: 37 },
        { date: "2021-08-16", totalSales: 41, totalUnits: 49 },
        { date: "2021-08-17", totalSales: 91, totalUnits: 37 },
        { date: "2021-08-18", totalSales: 98, totalUnits: 11 },
        { date: "2021-08-19", totalSales: 64, totalUnits: 20 },
        { date: "2021-08-20", totalSales: 59, totalUnits: 50 },
        { date: "2021-08-21", totalSales: 49, totalUnits: 34 },
        { date: "2021-08-22", totalSales: 56, totalUnits: 37 },
        { date: "2021-08-23", totalSales: 76, totalUnits: 3 },
        { date: "2021-08-24", totalSales: 68, totalUnits: 31 },
        { date: "2021-08-25", totalSales: 49, totalUnits: 16 },
        { date: "2021-08-26", totalSales: 87, totalUnits: 18 },
        { date: "2021-08-27", totalSales: 99, totalUnits: 30 },
        { date: "2021-08-28", totalSales: 21, totalUnits: 9 },
        { date: "2021-08-29", totalSales: 18, totalUnits: 11 },
        { date: "2021-08-30", totalSales: 11, totalUnits: 1 },
        { date: "2021-08-31", totalSales: 52, totalUnits: 17 },
        { date: "2021-09-01", totalSales: 20, totalUnits: 1 },
        { date: "2021-09-02", totalSales: 3, totalUnits: 35 },
        { date: "2021-09-03", totalSales: 46, totalUnits: 48 },
        { date: "2021-09-04", totalSales: 26, totalUnits: 12 },
        { date: "2021-09-05", totalSales: 71, totalUnits: 8 },
        { date: "2021-09-06", totalSales: 2, totalUnits: 8 },
        { date: "2021-09-07", totalSales: 1, totalUnits: 15 },
        { date: "2021-09-08", totalSales: 3, totalUnits: 28 },
        { date: "2021-09-09", totalSales: 3, totalUnits: 47 },
        { date: "2021-09-10", totalSales: 84, totalUnits: 22 },
        { date: "2021-09-11", totalSales: 61, totalUnits: 37 },
        { date: "2021-09-12", totalSales: 64, totalUnits: 26 },
        { date: "2021-09-13", totalSales: 46, totalUnits: 35 },
        { date: "2021-09-14", totalSales: 32, totalUnits: 34 },
        { date: "2021-09-15", totalSales: 80, totalUnits: 15 },
        { date: "2021-09-16", totalSales: 72, totalUnits: 21 },
        { date: "2021-09-17", totalSales: 60, totalUnits: 3 },
        { date: "2021-09-18", totalSales: 71, totalUnits: 44 },
        { date: "2021-09-19", totalSales: 9, totalUnits: 4 },
        { date: "2021-09-20", totalSales: 58, totalUnits: 14 },
        { date: "2021-09-21", totalSales: 39, totalUnits: 44 },
        { date: "2021-09-22", totalSales: 46, totalUnits: 47 },
        { date: "2021-09-23", totalSales: 86, totalUnits: 29 },
        { date: "2021-09-24", totalSales: 79, totalUnits: 2 },
        { date: "2021-09-25", totalSales: 12, totalUnits: 20 },
        { date: "2021-09-26", totalSales: 18, totalUnits: 4 },
        { date: "2021-09-27", totalSales: 48, totalUnits: 7 },
        { date: "2021-09-28", totalSales: 40, totalUnits: 7 },
        { date: "2021-09-29", totalSales: 13, totalUnits: 17 },
        { date: "2021-09-30", totalSales: 77, totalUnits: 18 },
        { date: "2021-10-01", totalSales: 61, totalUnits: 39 },
        { date: "2021-10-02", totalSales: 100, totalUnits: 42 },
        { date: "2021-10-03", totalSales: 10, totalUnits: 33 },
        { date: "2021-10-04", totalSales: 29, totalUnits: 13 },
        { date: "2021-10-05", totalSales: 14, totalUnits: 37 },
        { date: "2021-10-06", totalSales: 54, totalUnits: 4 },
        { date: "2021-10-07", totalSales: 46, totalUnits: 1 },
        { date: "2021-10-08", totalSales: 50, totalUnits: 32 },
        { date: "2021-10-09", totalSales: 26, totalUnits: 40 },
        { date: "2021-10-10", totalSales: 26, totalUnits: 8 },
        { date: "2021-10-11", totalSales: 12, totalUnits: 46 },
        { date: "2021-10-12", totalSales: 16, totalUnits: 3 },
        { date: "2021-10-13", totalSales: 72, totalUnits: 9 },
        { date: "2021-10-14", totalSales: 3, totalUnits: 17 },
        { date: "2021-10-15", totalSales: 30, totalUnits: 7 },
        { date: "2021-10-16", totalSales: 5, totalUnits: 20 },
        { date: "2021-10-17", totalSales: 38, totalUnits: 39 },
        { date: "2021-10-18", totalSales: 70, totalUnits: 3 },
        { date: "2021-10-19", totalSales: 41, totalUnits: 11 },
        { date: "2021-10-20", totalSales: 70, totalUnits: 27 },
        { date: "2021-10-21", totalSales: 38, totalUnits: 26 },
        { date: "2021-10-22", totalSales: 29, totalUnits: 1 },
        { date: "2021-10-23", totalSales: 17, totalUnits: 9 },
        { date: "2021-10-24", totalSales: 86, totalUnits: 14 },
        { date: "2021-10-25", totalSales: 12, totalUnits: 20 },
        { date: "2021-10-26", totalSales: 74, totalUnits: 19 },
        { date: "2021-10-27", totalSales: 72, totalUnits: 43 },
        { date: "2021-10-28", totalSales: 24, totalUnits: 43 },
        { date: "2021-10-29", totalSales: 72, totalUnits: 5 },
        { date: "2021-10-30", totalSales: 48, totalUnits: 6 },
        { date: "2021-10-31", totalSales: 2, totalUnits: 25 },
        { date: "2021-11-01", totalSales: 86, totalUnits: 32 },
        { date: "2021-11-02", totalSales: 3, totalUnits: 1 },
        { date: "2021-11-03", totalSales: 77, totalUnits: 45 },
        { date: "2021-11-04", totalSales: 6, totalUnits: 19 },
        { date: "2021-11-05", totalSales: 39, totalUnits: 19 },
        { date: "2021-11-06", totalSales: 13, totalUnits: 18 },
        { date: "2021-11-07", totalSales: 49, totalUnits: 28 },
        { date: "2021-11-08", totalSales: 44, totalUnits: 31 },
        { date: "2021-11-09", totalSales: 96, totalUnits: 41 },
        { date: "2021-11-10", totalSales: 88, totalUnits: 28 },
        { date: "2021-11-11", totalSales: 51, totalUnits: 22 },
        { date: "2021-11-12", totalSales: 35, totalUnits: 34 },
        { date: "2021-11-13", totalSales: 53, totalUnits: 3 },
        { date: "2021-11-14", totalSales: 1, totalUnits: 41 },
        { date: "2021-11-15", totalSales: 66, totalUnits: 32 },
        { date: "2021-11-16", totalSales: 65, totalUnits: 20 },
        { date: "2021-11-17", totalSales: 45, totalUnits: 15 },
      ],
    },
    {
      _id: "6371259df0323986f3000198",
      productId: "63701d24f03239d81e000017",
      yearlySalesTotal: 1016,
      yearlyTotalSoldUnits: 2672,
      monthlyData: [
        { month: "january", totalSales: 121, totalUnits: 281 },
        { month: "february", totalSales: 616, totalUnits: 295 },
        { month: "march", totalSales: 605, totalUnits: 79 },
        { month: "april", totalSales: 143, totalUnits: 333 },
        { month: "may", totalSales: 685, totalUnits: 269 },
        { month: "june", totalSales: 953, totalUnits: 94 },
        { month: "july", totalSales: 426, totalUnits: 100 },
        { month: "august", totalSales: 467, totalUnits: 96 },
        { month: "september", totalSales: 376, totalUnits: 45 },
        { month: "october", totalSales: 727, totalUnits: 46 },
        { month: "november", totalSales: 774, totalUnits: 240 },
        { month: "december", totalSales: 451, totalUnits: 377 },
      ],
      dailyData: [
        { date: "2021-01-02", totalSales: 23, totalUnits: 8 },
        { date: "2021-01-03", totalSales: 14, totalUnits: 46 },
        { date: "2021-01-04", totalSales: 20, totalUnits: 23 },
        { date: "2021-01-05", totalSales: 91, totalUnits: 15 },
        { date: "2021-01-06", totalSales: 85, totalUnits: 42 },
        { date: "2021-01-07", totalSales: 18, totalUnits: 47 },
        { date: "2021-01-08", totalSales: 48, totalUnits: 16 },
        { date: "2021-01-09", totalSales: 93, totalUnits: 45 },
        { date: "2021-01-10", totalSales: 79, totalUnits: 28 },
        { date: "2021-01-11", totalSales: 61, totalUnits: 41 },
        { date: "2021-01-12", totalSales: 42, totalUnits: 23 },
        { date: "2021-01-13", totalSales: 89, totalUnits: 2 },
        { date: "2021-01-14", totalSales: 72, totalUnits: 47 },
        { date: "2021-01-15", totalSales: 93, totalUnits: 14 },
        { date: "2021-01-16", totalSales: 29, totalUnits: 9 },
        { date: "2021-01-17", totalSales: 17, totalUnits: 17 },
        { date: "2021-01-18", totalSales: 62, totalUnits: 8 },
        { date: "2021-01-19", totalSales: 50, totalUnits: 8 },
        { date: "2021-01-20", totalSales: 72, totalUnits: 44 },
        { date: "2021-01-21", totalSales: 24, totalUnits: 39 },
        { date: "2021-01-22", totalSales: 19, totalUnits: 24 },
        { date: "2021-01-23", totalSales: 68, totalUnits: 34 },
        { date: "2021-01-24", totalSales: 16, totalUnits: 21 },
        { date: "2021-01-25", totalSales: 87, totalUnits: 27 },
        { date: "2021-01-26", totalSales: 59, totalUnits: 19 },
        { date: "2021-01-27", totalSales: 75, totalUnits: 5 },
        { date: "2021-01-28", totalSales: 53, totalUnits: 33 },
        { date: "2021-01-29", totalSales: 58, totalUnits: 25 },
        { date: "2021-01-30", totalSales: 72, totalUnits: 37 },
        { date: "2021-01-31", totalSales: 2, totalUnits: 24 },
        { date: "2021-02-01", totalSales: 17, totalUnits: 35 },
        { date: "2021-02-02", totalSales: 78, totalUnits: 23 },
        { date: "2021-02-03", totalSales: 75, totalUnits: 15 },
        { date: "2021-02-04", totalSales: 30, totalUnits: 24 },
        { date: "2021-02-05", totalSales: 45, totalUnits: 19 },
        { date: "2021-02-06", totalSales: 88, totalUnits: 3 },
        { date: "2021-02-07", totalSales: 43, totalUnits: 33 },
        { date: "2021-02-08", totalSales: 47, totalUnits: 23 },
        { date: "2021-02-09", totalSales: 28, totalUnits: 49 },
        { date: "2021-02-10", totalSales: 65, totalUnits: 29 },
        { date: "2021-02-11", totalSales: 5, totalUnits: 35 },
        { date: "2021-02-12", totalSales: 74, totalUnits: 1 },
        { date: "2021-02-13", totalSales: 19, totalUnits: 35 },
        { date: "2021-02-14", totalSales: 88, totalUnits: 20 },
        { date: "2021-02-15", totalSales: 84, totalUnits: 45 },
        { date: "2021-02-16", totalSales: 69, totalUnits: 1 },
        { date: "2021-02-17", totalSales: 53, totalUnits: 13 },
        { date: "2021-02-18", totalSales: 64, totalUnits: 30 },
        { date: "2021-02-19", totalSales: 36, totalUnits: 48 },
        { date: "2021-02-20", totalSales: 20, totalUnits: 35 },
        { date: "2021-02-21", totalSales: 37, totalUnits: 13 },
        { date: "2021-02-22", totalSales: 57, totalUnits: 42 },
        { date: "2021-02-23", totalSales: 65, totalUnits: 34 },
        { date: "2021-02-24", totalSales: 70, totalUnits: 34 },
        { date: "2021-02-25", totalSales: 81, totalUnits: 44 },
        { date: "2021-02-26", totalSales: 27, totalUnits: 14 },
        { date: "2021-02-27", totalSales: 89, totalUnits: 11 },
        { date: "2021-02-28", totalSales: 87, totalUnits: 43 },
        { date: "2021-03-01", totalSales: 3, totalUnits: 40 },
        { date: "2021-03-02", totalSales: 23, totalUnits: 30 },
        { date: "2021-03-03", totalSales: 76, totalUnits: 17 },
        { date: "2021-03-04", totalSales: 50, totalUnits: 36 },
        { date: "2021-03-05", totalSales: 40, totalUnits: 29 },
        { date: "2021-03-06", totalSales: 48, totalUnits: 1 },
        { date: "2021-03-07", totalSales: 40, totalUnits: 24 },
        { date: "2021-03-08", totalSales: 6, totalUnits: 13 },
        { date: "2021-03-09", totalSales: 89, totalUnits: 23 },
        { date: "2021-03-10", totalSales: 34, totalUnits: 37 },
        { date: "2021-03-11", totalSales: 81, totalUnits: 13 },
        { date: "2021-03-12", totalSales: 9, totalUnits: 25 },
        { date: "2021-03-13", totalSales: 10, totalUnits: 21 },
        { date: "2021-03-14", totalSales: 78, totalUnits: 48 },
        { date: "2021-03-15", totalSales: 77, totalUnits: 46 },
        { date: "2021-03-16", totalSales: 89, totalUnits: 32 },
        { date: "2021-03-17", totalSales: 79, totalUnits: 24 },
        { date: "2021-03-18", totalSales: 53, totalUnits: 7 },
        { date: "2021-03-19", totalSales: 5, totalUnits: 33 },
        { date: "2021-03-20", totalSales: 85, totalUnits: 7 },
        { date: "2021-03-21", totalSales: 16, totalUnits: 19 },
        { date: "2021-03-22", totalSales: 18, totalUnits: 33 },
        { date: "2021-03-23", totalSales: 59, totalUnits: 37 },
        { date: "2021-03-24", totalSales: 5, totalUnits: 3 },
        { date: "2021-03-25", totalSales: 60, totalUnits: 27 },
        { date: "2021-03-26", totalSales: 51, totalUnits: 7 },
        { date: "2021-03-27", totalSales: 89, totalUnits: 4 },
        { date: "2021-03-28", totalSales: 76, totalUnits: 28 },
        { date: "2021-03-29", totalSales: 67, totalUnits: 17 },
        { date: "2021-03-30", totalSales: 100, totalUnits: 25 },
        { date: "2021-03-31", totalSales: 72, totalUnits: 49 },
        { date: "2021-04-01", totalSales: 79, totalUnits: 34 },
        { date: "2021-04-02", totalSales: 59, totalUnits: 24 },
        { date: "2021-04-03", totalSales: 81, totalUnits: 26 },
        { date: "2021-04-04", totalSales: 19, totalUnits: 44 },
        { date: "2021-04-05", totalSales: 91, totalUnits: 49 },
        { date: "2021-04-06", totalSales: 51, totalUnits: 22 },
        { date: "2021-04-07", totalSales: 13, totalUnits: 45 },
        { date: "2021-04-08", totalSales: 8, totalUnits: 30 },
        { date: "2021-04-09", totalSales: 50, totalUnits: 43 },
        { date: "2021-04-10", totalSales: 41, totalUnits: 48 },
        { date: "2021-04-11", totalSales: 44, totalUnits: 8 },
        { date: "2021-04-12", totalSales: 92, totalUnits: 47 },
        { date: "2021-04-13", totalSales: 95, totalUnits: 18 },
        { date: "2021-04-14", totalSales: 78, totalUnits: 19 },
        { date: "2021-04-15", totalSales: 83, totalUnits: 31 },
        { date: "2021-04-16", totalSales: 42, totalUnits: 13 },
        { date: "2021-04-17", totalSales: 14, totalUnits: 19 },
        { date: "2021-04-18", totalSales: 91, totalUnits: 31 },
        { date: "2021-04-19", totalSales: 85, totalUnits: 38 },
        { date: "2021-04-20", totalSales: 81, totalUnits: 12 },
        { date: "2021-04-21", totalSales: 8, totalUnits: 42 },
        { date: "2021-04-22", totalSales: 80, totalUnits: 34 },
        { date: "2021-04-23", totalSales: 2, totalUnits: 29 },
        { date: "2021-04-24", totalSales: 7, totalUnits: 16 },
        { date: "2021-04-25", totalSales: 2, totalUnits: 5 },
        { date: "2021-04-26", totalSales: 26, totalUnits: 37 },
        { date: "2021-04-27", totalSales: 42, totalUnits: 25 },
        { date: "2021-04-28", totalSales: 25, totalUnits: 42 },
        { date: "2021-04-29", totalSales: 86, totalUnits: 26 },
        { date: "2021-04-30", totalSales: 99, totalUnits: 22 },
        { date: "2021-05-01", totalSales: 55, totalUnits: 31 },
        { date: "2021-05-02", totalSales: 65, totalUnits: 49 },
        { date: "2021-05-03", totalSales: 45, totalUnits: 4 },
        { date: "2021-05-04", totalSales: 28, totalUnits: 11 },
        { date: "2021-05-05", totalSales: 73, totalUnits: 25 },
        { date: "2021-05-06", totalSales: 40, totalUnits: 14 },
        { date: "2021-05-07", totalSales: 88, totalUnits: 14 },
        { date: "2021-05-08", totalSales: 69, totalUnits: 12 },
        { date: "2021-05-09", totalSales: 66, totalUnits: 41 },
        { date: "2021-05-10", totalSales: 5, totalUnits: 15 },
        { date: "2021-05-11", totalSales: 67, totalUnits: 3 },
        { date: "2021-05-12", totalSales: 64, totalUnits: 25 },
        { date: "2021-05-13", totalSales: 54, totalUnits: 31 },
        { date: "2021-05-14", totalSales: 67, totalUnits: 3 },
        { date: "2021-05-15", totalSales: 73, totalUnits: 33 },
        { date: "2021-05-16", totalSales: 99, totalUnits: 5 },
        { date: "2021-05-17", totalSales: 34, totalUnits: 30 },
        { date: "2021-05-18", totalSales: 76, totalUnits: 23 },
        { date: "2021-05-19", totalSales: 26, totalUnits: 7 },
        { date: "2021-05-20", totalSales: 12, totalUnits: 19 },
        { date: "2021-05-21", totalSales: 20, totalUnits: 45 },
        { date: "2021-05-22", totalSales: 43, totalUnits: 31 },
        { date: "2021-05-23", totalSales: 52, totalUnits: 46 },
        { date: "2021-05-24", totalSales: 34, totalUnits: 48 },
        { date: "2021-05-25", totalSales: 79, totalUnits: 46 },
        { date: "2021-05-26", totalSales: 28, totalUnits: 33 },
        { date: "2021-05-27", totalSales: 54, totalUnits: 21 },
        { date: "2021-05-28", totalSales: 97, totalUnits: 36 },
        { date: "2021-05-29", totalSales: 7, totalUnits: 15 },
        { date: "2021-05-30", totalSales: 34, totalUnits: 16 },
        { date: "2021-05-31", totalSales: 84, totalUnits: 40 },
        { date: "2021-06-01", totalSales: 22, totalUnits: 17 },
        { date: "2021-06-02", totalSales: 10, totalUnits: 17 },
        { date: "2021-06-03", totalSales: 76, totalUnits: 20 },
        { date: "2021-06-04", totalSales: 64, totalUnits: 1 },
        { date: "2021-06-05", totalSales: 32, totalUnits: 20 },
        { date: "2021-06-06", totalSales: 100, totalUnits: 15 },
        { date: "2021-06-07", totalSales: 64, totalUnits: 47 },
        { date: "2021-06-08", totalSales: 93, totalUnits: 36 },
        { date: "2021-06-09", totalSales: 89, totalUnits: 22 },
        { date: "2021-06-10", totalSales: 47, totalUnits: 39 },
        { date: "2021-06-11", totalSales: 44, totalUnits: 41 },
        { date: "2021-06-12", totalSales: 7, totalUnits: 36 },
        { date: "2021-06-13", totalSales: 96, totalUnits: 12 },
        { date: "2021-06-14", totalSales: 23, totalUnits: 17 },
        { date: "2021-06-15", totalSales: 55, totalUnits: 36 },
        { date: "2021-06-16", totalSales: 8, totalUnits: 20 },
        { date: "2021-06-17", totalSales: 37, totalUnits: 49 },
        { date: "2021-06-18", totalSales: 100, totalUnits: 21 },
        { date: "2021-06-19", totalSales: 97, totalUnits: 19 },
        { date: "2021-06-20", totalSales: 72, totalUnits: 42 },
        { date: "2021-06-21", totalSales: 91, totalUnits: 38 },
        { date: "2021-06-22", totalSales: 68, totalUnits: 2 },
        { date: "2021-06-23", totalSales: 8, totalUnits: 24 },
        { date: "2021-06-24", totalSales: 88, totalUnits: 41 },
        { date: "2021-06-25", totalSales: 80, totalUnits: 49 },
        { date: "2021-06-26", totalSales: 29, totalUnits: 5 },
        { date: "2021-06-27", totalSales: 7, totalUnits: 43 },
        { date: "2021-06-28", totalSales: 39, totalUnits: 16 },
        { date: "2021-06-29", totalSales: 53, totalUnits: 2 },
        { date: "2021-06-30", totalSales: 69, totalUnits: 20 },
        { date: "2021-07-01", totalSales: 46, totalUnits: 32 },
        { date: "2021-07-02", totalSales: 39, totalUnits: 11 },
        { date: "2021-07-03", totalSales: 11, totalUnits: 7 },
        { date: "2021-07-04", totalSales: 14, totalUnits: 38 },
        { date: "2021-07-05", totalSales: 57, totalUnits: 16 },
        { date: "2021-07-06", totalSales: 9, totalUnits: 22 },
        { date: "2021-07-07", totalSales: 45, totalUnits: 13 },
        { date: "2021-07-08", totalSales: 25, totalUnits: 31 },
        { date: "2021-07-09", totalSales: 66, totalUnits: 33 },
        { date: "2021-07-10", totalSales: 90, totalUnits: 30 },
        { date: "2021-07-11", totalSales: 41, totalUnits: 41 },
        { date: "2021-07-12", totalSales: 82, totalUnits: 39 },
        { date: "2021-07-13", totalSales: 3, totalUnits: 44 },
        { date: "2021-07-14", totalSales: 32, totalUnits: 11 },
        { date: "2021-07-15", totalSales: 7, totalUnits: 46 },
        { date: "2021-07-16", totalSales: 31, totalUnits: 38 },
        { date: "2021-07-17", totalSales: 56, totalUnits: 36 },
        { date: "2021-07-18", totalSales: 92, totalUnits: 39 },
        { date: "2021-07-19", totalSales: 59, totalUnits: 9 },
        { date: "2021-07-20", totalSales: 31, totalUnits: 14 },
        { date: "2021-07-21", totalSales: 70, totalUnits: 48 },
        { date: "2021-07-22", totalSales: 58, totalUnits: 50 },
        { date: "2021-07-23", totalSales: 88, totalUnits: 35 },
        { date: "2021-07-24", totalSales: 44, totalUnits: 9 },
        { date: "2021-07-25", totalSales: 99, totalUnits: 3 },
        { date: "2021-07-26", totalSales: 81, totalUnits: 49 },
        { date: "2021-07-27", totalSales: 52, totalUnits: 39 },
        { date: "2021-07-28", totalSales: 28, totalUnits: 20 },
        { date: "2021-07-29", totalSales: 40, totalUnits: 19 },
        { date: "2021-07-30", totalSales: 74, totalUnits: 20 },
        { date: "2021-07-31", totalSales: 73, totalUnits: 7 },
        { date: "2021-08-01", totalSales: 58, totalUnits: 8 },
        { date: "2021-08-02", totalSales: 36, totalUnits: 13 },
        { date: "2021-08-03", totalSales: 100, totalUnits: 33 },
        { date: "2021-08-04", totalSales: 15, totalUnits: 3 },
        { date: "2021-08-05", totalSales: 88, totalUnits: 10 },
        { date: "2021-08-06", totalSales: 3, totalUnits: 5 },
        { date: "2021-08-07", totalSales: 34, totalUnits: 49 },
        { date: "2021-08-08", totalSales: 11, totalUnits: 29 },
        { date: "2021-08-09", totalSales: 12, totalUnits: 3 },
        { date: "2021-08-10", totalSales: 91, totalUnits: 16 },
        { date: "2021-08-11", totalSales: 44, totalUnits: 1 },
        { date: "2021-08-12", totalSales: 18, totalUnits: 35 },
        { date: "2021-08-13", totalSales: 30, totalUnits: 11 },
        { date: "2021-08-14", totalSales: 67, totalUnits: 9 },
        { date: "2021-08-15", totalSales: 90, totalUnits: 11 },
        { date: "2021-08-16", totalSales: 57, totalUnits: 17 },
        { date: "2021-08-17", totalSales: 62, totalUnits: 7 },
        { date: "2021-08-18", totalSales: 46, totalUnits: 43 },
        { date: "2021-08-19", totalSales: 15, totalUnits: 47 },
        { date: "2021-08-20", totalSales: 78, totalUnits: 2 },
        { date: "2021-08-21", totalSales: 26, totalUnits: 30 },
        { date: "2021-08-22", totalSales: 65, totalUnits: 19 },
        { date: "2021-08-23", totalSales: 32, totalUnits: 43 },
        { date: "2021-08-24", totalSales: 67, totalUnits: 27 },
        { date: "2021-08-25", totalSales: 58, totalUnits: 2 },
        { date: "2021-08-26", totalSales: 43, totalUnits: 39 },
        { date: "2021-08-27", totalSales: 59, totalUnits: 32 },
        { date: "2021-08-28", totalSales: 66, totalUnits: 42 },
        { date: "2021-08-29", totalSales: 96, totalUnits: 25 },
        { date: "2021-08-30", totalSales: 43, totalUnits: 32 },
        { date: "2021-08-31", totalSales: 54, totalUnits: 22 },
        { date: "2021-09-01", totalSales: 89, totalUnits: 46 },
        { date: "2021-09-02", totalSales: 40, totalUnits: 33 },
        { date: "2021-09-03", totalSales: 94, totalUnits: 2 },
        { date: "2021-09-04", totalSales: 77, totalUnits: 6 },
        { date: "2021-09-05", totalSales: 26, totalUnits: 26 },
        { date: "2021-09-06", totalSales: 69, totalUnits: 42 },
        { date: "2021-09-07", totalSales: 94, totalUnits: 35 },
        { date: "2021-09-08", totalSales: 68, totalUnits: 26 },
        { date: "2021-09-09", totalSales: 5, totalUnits: 5 },
        { date: "2021-09-10", totalSales: 19, totalUnits: 46 },
        { date: "2021-09-11", totalSales: 9, totalUnits: 49 },
        { date: "2021-09-12", totalSales: 47, totalUnits: 22 },
        { date: "2021-09-13", totalSales: 64, totalUnits: 8 },
        { date: "2021-09-14", totalSales: 83, totalUnits: 1 },
        { date: "2021-09-15", totalSales: 86, totalUnits: 48 },
        { date: "2021-09-16", totalSales: 63, totalUnits: 8 },
        { date: "2021-09-17", totalSales: 73, totalUnits: 4 },
        { date: "2021-09-18", totalSales: 44, totalUnits: 9 },
        { date: "2021-09-19", totalSales: 75, totalUnits: 42 },
        { date: "2021-09-20", totalSales: 59, totalUnits: 29 },
        { date: "2021-09-21", totalSales: 24, totalUnits: 38 },
        { date: "2021-09-22", totalSales: 7, totalUnits: 9 },
        { date: "2021-09-23", totalSales: 19, totalUnits: 48 },
        { date: "2021-09-24", totalSales: 30, totalUnits: 30 },
        { date: "2021-09-25", totalSales: 63, totalUnits: 48 },
        { date: "2021-09-26", totalSales: 16, totalUnits: 8 },
        { date: "2021-09-27", totalSales: 65, totalUnits: 50 },
        { date: "2021-09-28", totalSales: 77, totalUnits: 12 },
        { date: "2021-09-29", totalSales: 39, totalUnits: 21 },
        { date: "2021-09-30", totalSales: 97, totalUnits: 9 },
        { date: "2021-10-01", totalSales: 50, totalUnits: 40 },
        { date: "2021-10-02", totalSales: 17, totalUnits: 14 },
        { date: "2021-10-03", totalSales: 75, totalUnits: 7 },
        { date: "2021-10-04", totalSales: 73, totalUnits: 33 },
        { date: "2021-10-05", totalSales: 67, totalUnits: 26 },
        { date: "2021-10-06", totalSales: 42, totalUnits: 37 },
        { date: "2021-10-07", totalSales: 78, totalUnits: 42 },
        { date: "2021-10-08", totalSales: 94, totalUnits: 5 },
        { date: "2021-10-09", totalSales: 80, totalUnits: 44 },
        { date: "2021-10-10", totalSales: 59, totalUnits: 2 },
        { date: "2021-10-11", totalSales: 7, totalUnits: 39 },
        { date: "2021-10-12", totalSales: 45, totalUnits: 5 },
        { date: "2021-10-13", totalSales: 85, totalUnits: 48 },
        { date: "2021-10-14", totalSales: 23, totalUnits: 43 },
        { date: "2021-10-15", totalSales: 17, totalUnits: 45 },
        { date: "2021-10-16", totalSales: 61, totalUnits: 32 },
        { date: "2021-10-17", totalSales: 58, totalUnits: 37 },
        { date: "2021-10-18", totalSales: 33, totalUnits: 42 },
        { date: "2021-10-19", totalSales: 52, totalUnits: 3 },
        { date: "2021-10-20", totalSales: 60, totalUnits: 32 },
        { date: "2021-10-21", totalSales: 81, totalUnits: 4 },
        { date: "2021-10-22", totalSales: 16, totalUnits: 32 },
        { date: "2021-10-23", totalSales: 21, totalUnits: 23 },
        { date: "2021-10-24", totalSales: 47, totalUnits: 27 },
        { date: "2021-10-25", totalSales: 99, totalUnits: 27 },
        { date: "2021-10-26", totalSales: 78, totalUnits: 23 },
        { date: "2021-10-27", totalSales: 31, totalUnits: 17 },
        { date: "2021-10-28", totalSales: 73, totalUnits: 40 },
        { date: "2021-10-29", totalSales: 5, totalUnits: 19 },
        { date: "2021-10-30", totalSales: 76, totalUnits: 33 },
        { date: "2021-10-31", totalSales: 13, totalUnits: 7 },
        { date: "2021-11-01", totalSales: 23, totalUnits: 40 },
        { date: "2021-11-02", totalSales: 34, totalUnits: 7 },
        { date: "2021-11-03", totalSales: 46, totalUnits: 49 },
        { date: "2021-11-04", totalSales: 84, totalUnits: 16 },
        { date: "2021-11-05", totalSales: 52, totalUnits: 23 },
        { date: "2021-11-06", totalSales: 26, totalUnits: 36 },
        { date: "2021-11-07", totalSales: 25, totalUnits: 23 },
        { date: "2021-11-08", totalSales: 16, totalUnits: 34 },
        { date: "2021-11-09", totalSales: 69, totalUnits: 11 },
        { date: "2021-11-10", totalSales: 70, totalUnits: 1 },
        { date: "2021-11-11", totalSales: 88, totalUnits: 14 },
        { date: "2021-11-12", totalSales: 84, totalUnits: 31 },
        { date: "2021-11-13", totalSales: 20, totalUnits: 36 },
        { date: "2021-11-14", totalSales: 67, totalUnits: 1 },
        { date: "2021-11-15", totalSales: 62, totalUnits: 34 },
        { date: "2021-11-16", totalSales: 20, totalUnits: 31 },
        { date: "2021-11-17", totalSales: 94, totalUnits: 8 },
      ],
    },
    {
      _id: "6371259df03239d40b0000d3",
      productId: "63701d24f03239d81e000018",
      yearlySalesTotal: 7368,
      yearlyTotalSoldUnits: 1734,
      monthlyData: [
        { month: "january", totalSales: 301, totalUnits: 330 },
        { month: "february", totalSales: 46, totalUnits: 405 },
        { month: "march", totalSales: 729, totalUnits: 258 },
        { month: "april", totalSales: 369, totalUnits: 227 },
        { month: "may", totalSales: 428, totalUnits: 433 },
        { month: "june", totalSales: 864, totalUnits: 180 },
        { month: "july", totalSales: 56, totalUnits: 283 },
        { month: "august", totalSales: 212, totalUnits: 257 },
        { month: "september", totalSales: 494, totalUnits: 143 },
        { month: "october", totalSales: 983, totalUnits: 125 },
        { month: "november", totalSales: 58, totalUnits: 473 },
        { month: "december", totalSales: 896, totalUnits: 479 },
      ],
      dailyData: [
        { date: "2021-01-02", totalSales: 40, totalUnits: 25 },
        { date: "2021-01-03", totalSales: 1, totalUnits: 4 },
        { date: "2021-01-04", totalSales: 87, totalUnits: 12 },
        { date: "2021-01-05", totalSales: 5, totalUnits: 17 },
        { date: "2021-01-06", totalSales: 95, totalUnits: 35 },
        { date: "2021-01-07", totalSales: 73, totalUnits: 38 },
        { date: "2021-01-08", totalSales: 35, totalUnits: 37 },
        { date: "2021-01-09", totalSales: 13, totalUnits: 42 },
        { date: "2021-01-10", totalSales: 96, totalUnits: 11 },
        { date: "2021-01-11", totalSales: 89, totalUnits: 21 },
        { date: "2021-01-12", totalSales: 5, totalUnits: 1 },
        { date: "2021-01-13", totalSales: 4, totalUnits: 1 },
        { date: "2021-01-14", totalSales: 56, totalUnits: 4 },
        { date: "2021-01-15", totalSales: 61, totalUnits: 24 },
        { date: "2021-01-16", totalSales: 73, totalUnits: 37 },
        { date: "2021-01-17", totalSales: 79, totalUnits: 2 },
        { date: "2021-01-18", totalSales: 86, totalUnits: 47 },
        { date: "2021-01-19", totalSales: 93, totalUnits: 19 },
        { date: "2021-01-20", totalSales: 100, totalUnits: 9 },
        { date: "2021-01-21", totalSales: 86, totalUnits: 40 },
        { date: "2021-01-22", totalSales: 79, totalUnits: 40 },
        { date: "2021-01-23", totalSales: 1, totalUnits: 41 },
        { date: "2021-01-24", totalSales: 99, totalUnits: 33 },
        { date: "2021-01-25", totalSales: 2, totalUnits: 49 },
        { date: "2021-01-26", totalSales: 59, totalUnits: 25 },
        { date: "2021-01-27", totalSales: 18, totalUnits: 9 },
        { date: "2021-01-28", totalSales: 33, totalUnits: 31 },
        { date: "2021-01-29", totalSales: 5, totalUnits: 42 },
        { date: "2021-01-30", totalSales: 27, totalUnits: 41 },
        { date: "2021-01-31", totalSales: 20, totalUnits: 34 },
        { date: "2021-02-01", totalSales: 91, totalUnits: 11 },
        { date: "2021-02-02", totalSales: 28, totalUnits: 34 },
        { date: "2021-02-03", totalSales: 76, totalUnits: 36 },
        { date: "2021-02-04", totalSales: 36, totalUnits: 32 },
        { date: "2021-02-05", totalSales: 57, totalUnits: 20 },
        { date: "2021-02-06", totalSales: 8, totalUnits: 40 },
        { date: "2021-02-07", totalSales: 89, totalUnits: 25 },
        { date: "2021-02-08", totalSales: 66, totalUnits: 37 },
        { date: "2021-02-09", totalSales: 95, totalUnits: 4 },
        { date: "2021-02-10", totalSales: 32, totalUnits: 6 },
        { date: "2021-02-11", totalSales: 42, totalUnits: 33 },
        { date: "2021-02-12", totalSales: 45, totalUnits: 43 },
        { date: "2021-02-13", totalSales: 64, totalUnits: 13 },
        { date: "2021-02-14", totalSales: 99, totalUnits: 25 },
        { date: "2021-02-15", totalSales: 40, totalUnits: 5 },
        { date: "2021-02-16", totalSales: 79, totalUnits: 36 },
        { date: "2021-02-17", totalSales: 77, totalUnits: 33 },
        { date: "2021-02-18", totalSales: 57, totalUnits: 33 },
        { date: "2021-02-19", totalSales: 26, totalUnits: 2 },
        { date: "2021-02-20", totalSales: 81, totalUnits: 10 },
        { date: "2021-02-21", totalSales: 14, totalUnits: 3 },
        { date: "2021-02-22", totalSales: 4, totalUnits: 31 },
        { date: "2021-02-23", totalSales: 46, totalUnits: 43 },
        { date: "2021-02-24", totalSales: 72, totalUnits: 1 },
        { date: "2021-02-25", totalSales: 31, totalUnits: 15 },
        { date: "2021-02-26", totalSales: 53, totalUnits: 3 },
        { date: "2021-02-27", totalSales: 72, totalUnits: 42 },
        { date: "2021-02-28", totalSales: 12, totalUnits: 28 },
        { date: "2021-03-01", totalSales: 100, totalUnits: 43 },
        { date: "2021-03-02", totalSales: 76, totalUnits: 19 },
        { date: "2021-03-03", totalSales: 6, totalUnits: 50 },
        { date: "2021-03-04", totalSales: 80, totalUnits: 11 },
        { date: "2021-03-05", totalSales: 10, totalUnits: 49 },
        { date: "2021-03-06", totalSales: 85, totalUnits: 1 },
        { date: "2021-03-07", totalSales: 26, totalUnits: 24 },
        { date: "2021-03-08", totalSales: 99, totalUnits: 41 },
        { date: "2021-03-09", totalSales: 9, totalUnits: 29 },
        { date: "2021-03-10", totalSales: 38, totalUnits: 3 },
        { date: "2021-03-11", totalSales: 50, totalUnits: 12 },
        { date: "2021-03-12", totalSales: 5, totalUnits: 15 },
        { date: "2021-03-13", totalSales: 53, totalUnits: 30 },
        { date: "2021-03-14", totalSales: 14, totalUnits: 1 },
        { date: "2021-03-15", totalSales: 45, totalUnits: 39 },
        { date: "2021-03-16", totalSales: 59, totalUnits: 23 },
        { date: "2021-03-17", totalSales: 54, totalUnits: 34 },
        { date: "2021-03-18", totalSales: 12, totalUnits: 25 },
        { date: "2021-03-19", totalSales: 74, totalUnits: 15 },
        { date: "2021-03-20", totalSales: 83, totalUnits: 19 },
        { date: "2021-03-21", totalSales: 83, totalUnits: 19 },
        { date: "2021-03-22", totalSales: 25, totalUnits: 38 },
        { date: "2021-03-23", totalSales: 46, totalUnits: 46 },
        { date: "2021-03-24", totalSales: 65, totalUnits: 43 },
        { date: "2021-03-25", totalSales: 4, totalUnits: 28 },
        { date: "2021-03-26", totalSales: 71, totalUnits: 21 },
        { date: "2021-03-27", totalSales: 22, totalUnits: 6 },
        { date: "2021-03-28", totalSales: 21, totalUnits: 50 },
        { date: "2021-03-29", totalSales: 59, totalUnits: 5 },
        { date: "2021-03-30", totalSales: 75, totalUnits: 37 },
        { date: "2021-03-31", totalSales: 7, totalUnits: 49 },
        { date: "2021-04-01", totalSales: 70, totalUnits: 28 },
        { date: "2021-04-02", totalSales: 50, totalUnits: 6 },
        { date: "2021-04-03", totalSales: 39, totalUnits: 6 },
        { date: "2021-04-04", totalSales: 78, totalUnits: 30 },
        { date: "2021-04-05", totalSales: 54, totalUnits: 43 },
        { date: "2021-04-06", totalSales: 39, totalUnits: 49 },
        { date: "2021-04-07", totalSales: 11, totalUnits: 4 },
        { date: "2021-04-08", totalSales: 36, totalUnits: 10 },
        { date: "2021-04-09", totalSales: 94, totalUnits: 24 },
        { date: "2021-04-10", totalSales: 85, totalUnits: 20 },
        { date: "2021-04-11", totalSales: 94, totalUnits: 28 },
        { date: "2021-04-12", totalSales: 82, totalUnits: 35 },
        { date: "2021-04-13", totalSales: 29, totalUnits: 38 },
        { date: "2021-04-14", totalSales: 80, totalUnits: 30 },
        { date: "2021-04-15", totalSales: 96, totalUnits: 48 },
        { date: "2021-04-16", totalSales: 19, totalUnits: 3 },
        { date: "2021-04-17", totalSales: 8, totalUnits: 44 },
        { date: "2021-04-18", totalSales: 71, totalUnits: 24 },
        { date: "2021-04-19", totalSales: 36, totalUnits: 30 },
        { date: "2021-04-20", totalSales: 48, totalUnits: 36 },
        { date: "2021-04-21", totalSales: 76, totalUnits: 41 },
        { date: "2021-04-22", totalSales: 99, totalUnits: 23 },
        { date: "2021-04-23", totalSales: 94, totalUnits: 27 },
        { date: "2021-04-24", totalSales: 7, totalUnits: 23 },
        { date: "2021-04-25", totalSales: 20, totalUnits: 5 },
        { date: "2021-04-26", totalSales: 39, totalUnits: 13 },
        { date: "2021-04-27", totalSales: 24, totalUnits: 37 },
        { date: "2021-04-28", totalSales: 33, totalUnits: 2 },
        { date: "2021-04-29", totalSales: 5, totalUnits: 22 },
        { date: "2021-04-30", totalSales: 3, totalUnits: 39 },
        { date: "2021-05-01", totalSales: 58, totalUnits: 35 },
        { date: "2021-05-02", totalSales: 19, totalUnits: 8 },
        { date: "2021-05-03", totalSales: 48, totalUnits: 48 },
        { date: "2021-05-04", totalSales: 62, totalUnits: 6 },
        { date: "2021-05-05", totalSales: 91, totalUnits: 13 },
        { date: "2021-05-06", totalSales: 29, totalUnits: 45 },
        { date: "2021-05-07", totalSales: 35, totalUnits: 26 },
        { date: "2021-05-08", totalSales: 31, totalUnits: 36 },
        { date: "2021-05-09", totalSales: 95, totalUnits: 33 },
        { date: "2021-05-10", totalSales: 18, totalUnits: 5 },
        { date: "2021-05-11", totalSales: 20, totalUnits: 15 },
        { date: "2021-05-12", totalSales: 8, totalUnits: 26 },
        { date: "2021-05-13", totalSales: 68, totalUnits: 31 },
        { date: "2021-05-14", totalSales: 79, totalUnits: 37 },
        { date: "2021-05-15", totalSales: 18, totalUnits: 7 },
        { date: "2021-05-16", totalSales: 40, totalUnits: 7 },
        { date: "2021-05-17", totalSales: 87, totalUnits: 43 },
        { date: "2021-05-18", totalSales: 64, totalUnits: 40 },
        { date: "2021-05-19", totalSales: 45, totalUnits: 9 },
        { date: "2021-05-20", totalSales: 58, totalUnits: 1 },
        { date: "2021-05-21", totalSales: 4, totalUnits: 42 },
        { date: "2021-05-22", totalSales: 4, totalUnits: 2 },
        { date: "2021-05-23", totalSales: 70, totalUnits: 5 },
        { date: "2021-05-24", totalSales: 63, totalUnits: 44 },
        { date: "2021-05-25", totalSales: 62, totalUnits: 23 },
        { date: "2021-05-26", totalSales: 66, totalUnits: 1 },
        { date: "2021-05-27", totalSales: 66, totalUnits: 18 },
        { date: "2021-05-28", totalSales: 32, totalUnits: 47 },
        { date: "2021-05-29", totalSales: 5, totalUnits: 30 },
        { date: "2021-05-30", totalSales: 16, totalUnits: 31 },
        { date: "2021-05-31", totalSales: 78, totalUnits: 6 },
        { date: "2021-06-01", totalSales: 50, totalUnits: 42 },
        { date: "2021-06-02", totalSales: 9, totalUnits: 37 },
        { date: "2021-06-03", totalSales: 92, totalUnits: 30 },
        { date: "2021-06-04", totalSales: 29, totalUnits: 21 },
        { date: "2021-06-05", totalSales: 81, totalUnits: 47 },
        { date: "2021-06-06", totalSales: 67, totalUnits: 36 },
        { date: "2021-06-07", totalSales: 100, totalUnits: 15 },
        { date: "2021-06-08", totalSales: 16, totalUnits: 35 },
        { date: "2021-06-09", totalSales: 10, totalUnits: 30 },
        { date: "2021-06-10", totalSales: 26, totalUnits: 27 },
        { date: "2021-06-11", totalSales: 51, totalUnits: 17 },
        { date: "2021-06-12", totalSales: 73, totalUnits: 43 },
        { date: "2021-06-13", totalSales: 91, totalUnits: 33 },
        { date: "2021-06-14", totalSales: 85, totalUnits: 15 },
        { date: "2021-06-15", totalSales: 78, totalUnits: 32 },
        { date: "2021-06-16", totalSales: 4, totalUnits: 16 },
        { date: "2021-06-17", totalSales: 25, totalUnits: 18 },
        { date: "2021-06-18", totalSales: 12, totalUnits: 38 },
        { date: "2021-06-19", totalSales: 11, totalUnits: 36 },
        { date: "2021-06-20", totalSales: 5, totalUnits: 42 },
        { date: "2021-06-21", totalSales: 84, totalUnits: 32 },
        { date: "2021-06-22", totalSales: 82, totalUnits: 25 },
        { date: "2021-06-23", totalSales: 77, totalUnits: 40 },
        { date: "2021-06-24", totalSales: 33, totalUnits: 48 },
        { date: "2021-06-25", totalSales: 5, totalUnits: 1 },
        { date: "2021-06-26", totalSales: 22, totalUnits: 46 },
        { date: "2021-06-27", totalSales: 81, totalUnits: 9 },
        { date: "2021-06-28", totalSales: 58, totalUnits: 46 },
        { date: "2021-06-29", totalSales: 13, totalUnits: 12 },
        { date: "2021-06-30", totalSales: 77, totalUnits: 40 },
        { date: "2021-07-01", totalSales: 55, totalUnits: 31 },
        { date: "2021-07-02", totalSales: 85, totalUnits: 41 },
        { date: "2021-07-03", totalSales: 17, totalUnits: 31 },
        { date: "2021-07-04", totalSales: 83, totalUnits: 34 },
        { date: "2021-07-05", totalSales: 5, totalUnits: 50 },
        { date: "2021-07-06", totalSales: 80, totalUnits: 13 },
        { date: "2021-07-07", totalSales: 91, totalUnits: 12 },
        { date: "2021-07-08", totalSales: 40, totalUnits: 44 },
        { date: "2021-07-09", totalSales: 76, totalUnits: 9 },
        { date: "2021-07-10", totalSales: 24, totalUnits: 49 },
        { date: "2021-07-11", totalSales: 19, totalUnits: 32 },
        { date: "2021-07-12", totalSales: 86, totalUnits: 46 },
        { date: "2021-07-13", totalSales: 66, totalUnits: 39 },
        { date: "2021-07-14", totalSales: 58, totalUnits: 41 },
        { date: "2021-07-15", totalSales: 56, totalUnits: 34 },
        { date: "2021-07-16", totalSales: 12, totalUnits: 46 },
        { date: "2021-07-17", totalSales: 89, totalUnits: 49 },
        { date: "2021-07-18", totalSales: 63, totalUnits: 4 },
        { date: "2021-07-19", totalSales: 35, totalUnits: 47 },
        { date: "2021-07-20", totalSales: 85, totalUnits: 49 },
        { date: "2021-07-21", totalSales: 40, totalUnits: 13 },
        { date: "2021-07-22", totalSales: 59, totalUnits: 36 },
        { date: "2021-07-23", totalSales: 66, totalUnits: 29 },
        { date: "2021-07-24", totalSales: 21, totalUnits: 6 },
        { date: "2021-07-25", totalSales: 50, totalUnits: 31 },
        { date: "2021-07-26", totalSales: 69, totalUnits: 15 },
        { date: "2021-07-27", totalSales: 97, totalUnits: 9 },
        { date: "2021-07-28", totalSales: 10, totalUnits: 30 },
        { date: "2021-07-29", totalSales: 99, totalUnits: 11 },
        { date: "2021-07-30", totalSales: 20, totalUnits: 27 },
        { date: "2021-07-31", totalSales: 12, totalUnits: 14 },
        { date: "2021-08-01", totalSales: 97, totalUnits: 20 },
        { date: "2021-08-02", totalSales: 21, totalUnits: 28 },
        { date: "2021-08-03", totalSales: 70, totalUnits: 5 },
        { date: "2021-08-04", totalSales: 38, totalUnits: 38 },
        { date: "2021-08-05", totalSales: 11, totalUnits: 49 },
        { date: "2021-08-06", totalSales: 59, totalUnits: 40 },
        { date: "2021-08-07", totalSales: 49, totalUnits: 42 },
        { date: "2021-08-08", totalSales: 8, totalUnits: 30 },
        { date: "2021-08-09", totalSales: 61, totalUnits: 44 },
        { date: "2021-08-10", totalSales: 31, totalUnits: 31 },
        { date: "2021-08-11", totalSales: 19, totalUnits: 3 },
        { date: "2021-08-12", totalSales: 58, totalUnits: 35 },
        { date: "2021-08-13", totalSales: 73, totalUnits: 10 },
        { date: "2021-08-14", totalSales: 92, totalUnits: 41 },
        { date: "2021-08-15", totalSales: 23, totalUnits: 17 },
        { date: "2021-08-16", totalSales: 91, totalUnits: 24 },
        { date: "2021-08-17", totalSales: 48, totalUnits: 1 },
        { date: "2021-08-18", totalSales: 62, totalUnits: 24 },
        { date: "2021-08-19", totalSales: 99, totalUnits: 13 },
        { date: "2021-08-20", totalSales: 75, totalUnits: 25 },
        { date: "2021-08-21", totalSales: 52, totalUnits: 19 },
        { date: "2021-08-22", totalSales: 90, totalUnits: 15 },
        { date: "2021-08-23", totalSales: 44, totalUnits: 18 },
        { date: "2021-08-24", totalSales: 82, totalUnits: 15 },
        { date: "2021-08-25", totalSales: 30, totalUnits: 15 },
        { date: "2021-08-26", totalSales: 72, totalUnits: 1 },
        { date: "2021-08-27", totalSales: 45, totalUnits: 5 },
        { date: "2021-08-28", totalSales: 60, totalUnits: 3 },
        { date: "2021-08-29", totalSales: 17, totalUnits: 45 },
        { date: "2021-08-30", totalSales: 82, totalUnits: 14 },
        { date: "2021-08-31", totalSales: 78, totalUnits: 30 },
        { date: "2021-09-01", totalSales: 61, totalUnits: 35 },
        { date: "2021-09-02", totalSales: 34, totalUnits: 37 },
        { date: "2021-09-03", totalSales: 22, totalUnits: 50 },
        { date: "2021-09-04", totalSales: 35, totalUnits: 3 },
        { date: "2021-09-05", totalSales: 11, totalUnits: 2 },
        { date: "2021-09-06", totalSales: 31, totalUnits: 35 },
        { date: "2021-09-07", totalSales: 55, totalUnits: 27 },
        { date: "2021-09-08", totalSales: 88, totalUnits: 48 },
        { date: "2021-09-09", totalSales: 87, totalUnits: 50 },
        { date: "2021-09-10", totalSales: 97, totalUnits: 13 },
        { date: "2021-09-11", totalSales: 73, totalUnits: 49 },
        { date: "2021-09-12", totalSales: 13, totalUnits: 44 },
        { date: "2021-09-13", totalSales: 70, totalUnits: 26 },
        { date: "2021-09-14", totalSales: 26, totalUnits: 2 },
        { date: "2021-09-15", totalSales: 47, totalUnits: 23 },
        { date: "2021-09-16", totalSales: 93, totalUnits: 40 },
        { date: "2021-09-17", totalSales: 99, totalUnits: 27 },
        { date: "2021-09-18", totalSales: 75, totalUnits: 8 },
        { date: "2021-09-19", totalSales: 38, totalUnits: 33 },
        { date: "2021-09-20", totalSales: 67, totalUnits: 41 },
        { date: "2021-09-21", totalSales: 80, totalUnits: 34 },
        { date: "2021-09-22", totalSales: 2, totalUnits: 26 },
        { date: "2021-09-23", totalSales: 47, totalUnits: 8 },
        { date: "2021-09-24", totalSales: 64, totalUnits: 42 },
        { date: "2021-09-25", totalSales: 68, totalUnits: 4 },
        { date: "2021-09-26", totalSales: 91, totalUnits: 32 },
        { date: "2021-09-27", totalSales: 15, totalUnits: 16 },
        { date: "2021-09-28", totalSales: 38, totalUnits: 45 },
        { date: "2021-09-29", totalSales: 5, totalUnits: 47 },
        { date: "2021-09-30", totalSales: 46, totalUnits: 49 },
        { date: "2021-10-01", totalSales: 59, totalUnits: 41 },
        { date: "2021-10-02", totalSales: 79, totalUnits: 45 },
        { date: "2021-10-03", totalSales: 1, totalUnits: 4 },
        { date: "2021-10-04", totalSales: 28, totalUnits: 38 },
        { date: "2021-10-05", totalSales: 90, totalUnits: 8 },
        { date: "2021-10-06", totalSales: 80, totalUnits: 23 },
        { date: "2021-10-07", totalSales: 44, totalUnits: 21 },
        { date: "2021-10-08", totalSales: 99, totalUnits: 20 },
        { date: "2021-10-09", totalSales: 94, totalUnits: 34 },
        { date: "2021-10-10", totalSales: 62, totalUnits: 35 },
        { date: "2021-10-11", totalSales: 64, totalUnits: 19 },
        { date: "2021-10-12", totalSales: 70, totalUnits: 28 },
        { date: "2021-10-13", totalSales: 37, totalUnits: 18 },
        { date: "2021-10-14", totalSales: 38, totalUnits: 43 },
        { date: "2021-10-15", totalSales: 1, totalUnits: 33 },
        { date: "2021-10-16", totalSales: 66, totalUnits: 20 },
        { date: "2021-10-17", totalSales: 68, totalUnits: 31 },
        { date: "2021-10-18", totalSales: 30, totalUnits: 10 },
        { date: "2021-10-19", totalSales: 47, totalUnits: 11 },
        { date: "2021-10-20", totalSales: 61, totalUnits: 4 },
        { date: "2021-10-21", totalSales: 13, totalUnits: 40 },
        { date: "2021-10-22", totalSales: 60, totalUnits: 3 },
        { date: "2021-10-23", totalSales: 28, totalUnits: 20 },
        { date: "2021-10-24", totalSales: 7, totalUnits: 17 },
        { date: "2021-10-25", totalSales: 15, totalUnits: 40 },
        { date: "2021-10-26", totalSales: 90, totalUnits: 32 },
        { date: "2021-10-27", totalSales: 99, totalUnits: 37 },
        { date: "2021-10-28", totalSales: 82, totalUnits: 20 },
        { date: "2021-10-29", totalSales: 66, totalUnits: 22 },
        { date: "2021-10-30", totalSales: 56, totalUnits: 44 },
        { date: "2021-10-31", totalSales: 81, totalUnits: 38 },
        { date: "2021-11-01", totalSales: 30, totalUnits: 28 },
        { date: "2021-11-02", totalSales: 53, totalUnits: 2 },
        { date: "2021-11-03", totalSales: 7, totalUnits: 24 },
        { date: "2021-11-04", totalSales: 23, totalUnits: 6 },
        { date: "2021-11-05", totalSales: 60, totalUnits: 9 },
        { date: "2021-11-06", totalSales: 20, totalUnits: 34 },
        { date: "2021-11-07", totalSales: 20, totalUnits: 27 },
        { date: "2021-11-08", totalSales: 6, totalUnits: 13 },
        { date: "2021-11-09", totalSales: 93, totalUnits: 45 },
        { date: "2021-11-10", totalSales: 93, totalUnits: 27 },
        { date: "2021-11-11", totalSales: 63, totalUnits: 2 },
        { date: "2021-11-12", totalSales: 10, totalUnits: 2 },
        { date: "2021-11-13", totalSales: 19, totalUnits: 20 },
        { date: "2021-11-14", totalSales: 100, totalUnits: 45 },
        { date: "2021-11-15", totalSales: 94, totalUnits: 38 },
        { date: "2021-11-16", totalSales: 77, totalUnits: 37 },
        { date: "2021-11-17", totalSales: 2, totalUnits: 47 },
      ],
    },
    {
      _id: "6371259df03239d40b0000d4",
      productId: "63701d24f032390a34000327",
      yearlySalesTotal: 7667,
      yearlyTotalSoldUnits: 2377,
      monthlyData: [
        { month: "january", totalSales: 674, totalUnits: 279 },
        { month: "february", totalSales: 625, totalUnits: 480 },
        { month: "march", totalSales: 897, totalUnits: 199 },
        { month: "april", totalSales: 236, totalUnits: 94 },
        { month: "may", totalSales: 365, totalUnits: 277 },
        { month: "june", totalSales: 86, totalUnits: 281 },
        { month: "july", totalSales: 919, totalUnits: 370 },
        { month: "august", totalSales: 876, totalUnits: 415 },
        { month: "september", totalSales: 892, totalUnits: 435 },
        { month: "october", totalSales: 904, totalUnits: 238 },
        { month: "november", totalSales: 969, totalUnits: 227 },
        { month: "december", totalSales: 248, totalUnits: 321 },
      ],
      dailyData: [
        { date: "2021-01-02", totalSales: 10, totalUnits: 8 },
        { date: "2021-01-03", totalSales: 45, totalUnits: 12 },
        { date: "2021-01-04", totalSales: 54, totalUnits: 1 },
        { date: "2021-01-05", totalSales: 11, totalUnits: 48 },
        { date: "2021-01-06", totalSales: 92, totalUnits: 24 },
        { date: "2021-01-07", totalSales: 54, totalUnits: 14 },
        { date: "2021-01-08", totalSales: 17, totalUnits: 25 },
        { date: "2021-01-09", totalSales: 6, totalUnits: 29 },
        { date: "2021-01-10", totalSales: 98, totalUnits: 11 },
        { date: "2021-01-11", totalSales: 68, totalUnits: 13 },
        { date: "2021-01-12", totalSales: 4, totalUnits: 39 },
        { date: "2021-01-13", totalSales: 100, totalUnits: 13 },
        { date: "2021-01-14", totalSales: 13, totalUnits: 28 },
        { date: "2021-01-15", totalSales: 33, totalUnits: 1 },
        { date: "2021-01-16", totalSales: 62, totalUnits: 9 },
        { date: "2021-01-17", totalSales: 10, totalUnits: 49 },
        { date: "2021-01-18", totalSales: 38, totalUnits: 18 },
        { date: "2021-01-19", totalSales: 84, totalUnits: 19 },
        { date: "2021-01-20", totalSales: 34, totalUnits: 42 },
        { date: "2021-01-21", totalSales: 15, totalUnits: 25 },
        { date: "2021-01-22", totalSales: 32, totalUnits: 32 },
        { date: "2021-01-23", totalSales: 8, totalUnits: 29 },
        { date: "2021-01-24", totalSales: 41, totalUnits: 33 },
        { date: "2021-01-25", totalSales: 21, totalUnits: 12 },
        { date: "2021-01-26", totalSales: 56, totalUnits: 26 },
        { date: "2021-01-27", totalSales: 30, totalUnits: 14 },
        { date: "2021-01-28", totalSales: 70, totalUnits: 39 },
        { date: "2021-01-29", totalSales: 11, totalUnits: 12 },
        { date: "2021-01-30", totalSales: 98, totalUnits: 41 },
        { date: "2021-01-31", totalSales: 64, totalUnits: 20 },
        { date: "2021-02-01", totalSales: 99, totalUnits: 50 },
        { date: "2021-02-02", totalSales: 66, totalUnits: 17 },
        { date: "2021-02-03", totalSales: 24, totalUnits: 37 },
        { date: "2021-02-04", totalSales: 74, totalUnits: 47 },
        { date: "2021-02-05", totalSales: 33, totalUnits: 5 },
        { date: "2021-02-06", totalSales: 75, totalUnits: 8 },
        { date: "2021-02-07", totalSales: 1, totalUnits: 34 },
        { date: "2021-02-08", totalSales: 44, totalUnits: 5 },
        { date: "2021-02-09", totalSales: 51, totalUnits: 41 },
        { date: "2021-02-10", totalSales: 93, totalUnits: 29 },
        { date: "2021-02-11", totalSales: 97, totalUnits: 14 },
        { date: "2021-02-12", totalSales: 89, totalUnits: 21 },
        { date: "2021-02-13", totalSales: 45, totalUnits: 37 },
        { date: "2021-02-14", totalSales: 3, totalUnits: 15 },
        { date: "2021-02-15", totalSales: 64, totalUnits: 25 },
        { date: "2021-02-16", totalSales: 48, totalUnits: 6 },
        { date: "2021-02-17", totalSales: 43, totalUnits: 27 },
        { date: "2021-02-18", totalSales: 85, totalUnits: 48 },
        { date: "2021-02-19", totalSales: 86, totalUnits: 44 },
        { date: "2021-02-20", totalSales: 12, totalUnits: 30 },
        { date: "2021-02-21", totalSales: 55, totalUnits: 39 },
        { date: "2021-02-22", totalSales: 92, totalUnits: 10 },
        { date: "2021-02-23", totalSales: 23, totalUnits: 14 },
        { date: "2021-02-24", totalSales: 45, totalUnits: 3 },
        { date: "2021-02-25", totalSales: 9, totalUnits: 29 },
        { date: "2021-02-26", totalSales: 5, totalUnits: 17 },
        { date: "2021-02-27", totalSales: 29, totalUnits: 3 },
        { date: "2021-02-28", totalSales: 89, totalUnits: 50 },
        { date: "2021-03-01", totalSales: 77, totalUnits: 47 },
        { date: "2021-03-02", totalSales: 12, totalUnits: 2 },
        { date: "2021-03-03", totalSales: 6, totalUnits: 10 },
        { date: "2021-03-04", totalSales: 63, totalUnits: 35 },
        { date: "2021-03-05", totalSales: 98, totalUnits: 4 },
        { date: "2021-03-06", totalSales: 18, totalUnits: 9 },
        { date: "2021-03-07", totalSales: 25, totalUnits: 9 },
        { date: "2021-03-08", totalSales: 53, totalUnits: 49 },
        { date: "2021-03-09", totalSales: 77, totalUnits: 33 },
        { date: "2021-03-10", totalSales: 80, totalUnits: 18 },
        { date: "2021-03-11", totalSales: 26, totalUnits: 11 },
        { date: "2021-03-12", totalSales: 27, totalUnits: 25 },
        { date: "2021-03-13", totalSales: 81, totalUnits: 19 },
        { date: "2021-03-14", totalSales: 75, totalUnits: 42 },
        { date: "2021-03-15", totalSales: 69, totalUnits: 12 },
        { date: "2021-03-16", totalSales: 18, totalUnits: 3 },
        { date: "2021-03-17", totalSales: 48, totalUnits: 47 },
        { date: "2021-03-18", totalSales: 86, totalUnits: 43 },
        { date: "2021-03-19", totalSales: 55, totalUnits: 46 },
        { date: "2021-03-20", totalSales: 55, totalUnits: 1 },
        { date: "2021-03-21", totalSales: 29, totalUnits: 44 },
        { date: "2021-03-22", totalSales: 96, totalUnits: 24 },
        { date: "2021-03-23", totalSales: 65, totalUnits: 15 },
        { date: "2021-03-24", totalSales: 8, totalUnits: 25 },
        { date: "2021-03-25", totalSales: 90, totalUnits: 10 },
        { date: "2021-03-26", totalSales: 54, totalUnits: 22 },
        { date: "2021-03-27", totalSales: 39, totalUnits: 17 },
        { date: "2021-03-28", totalSales: 50, totalUnits: 42 },
        { date: "2021-03-29", totalSales: 42, totalUnits: 25 },
        { date: "2021-03-30", totalSales: 48, totalUnits: 41 },
        { date: "2021-03-31", totalSales: 60, totalUnits: 15 },
        { date: "2021-04-01", totalSales: 72, totalUnits: 49 },
        { date: "2021-04-02", totalSales: 45, totalUnits: 3 },
        { date: "2021-04-03", totalSales: 26, totalUnits: 41 },
        { date: "2021-04-04", totalSales: 4, totalUnits: 45 },
        { date: "2021-04-05", totalSales: 29, totalUnits: 37 },
        { date: "2021-04-06", totalSales: 46, totalUnits: 11 },
        { date: "2021-04-07", totalSales: 87, totalUnits: 47 },
        { date: "2021-04-08", totalSales: 10, totalUnits: 19 },
        { date: "2021-04-09", totalSales: 32, totalUnits: 38 },
        { date: "2021-04-10", totalSales: 45, totalUnits: 40 },
        { date: "2021-04-11", totalSales: 5, totalUnits: 34 },
        { date: "2021-04-12", totalSales: 38, totalUnits: 42 },
        { date: "2021-04-13", totalSales: 55, totalUnits: 15 },
        { date: "2021-04-14", totalSales: 81, totalUnits: 15 },
        { date: "2021-04-15", totalSales: 18, totalUnits: 28 },
        { date: "2021-04-16", totalSales: 22, totalUnits: 9 },
        { date: "2021-04-17", totalSales: 33, totalUnits: 33 },
        { date: "2021-04-18", totalSales: 48, totalUnits: 40 },
        { date: "2021-04-19", totalSales: 60, totalUnits: 4 },
        { date: "2021-04-20", totalSales: 55, totalUnits: 32 },
        { date: "2021-04-21", totalSales: 80, totalUnits: 48 },
        { date: "2021-04-22", totalSales: 99, totalUnits: 49 },
        { date: "2021-04-23", totalSales: 62, totalUnits: 32 },
        { date: "2021-04-24", totalSales: 98, totalUnits: 50 },
        { date: "2021-04-25", totalSales: 13, totalUnits: 9 },
        { date: "2021-04-26", totalSales: 7, totalUnits: 10 },
        { date: "2021-04-27", totalSales: 87, totalUnits: 34 },
        { date: "2021-04-28", totalSales: 85, totalUnits: 32 },
        { date: "2021-04-29", totalSales: 6, totalUnits: 34 },
        { date: "2021-04-30", totalSales: 18, totalUnits: 42 },
        { date: "2021-05-01", totalSales: 65, totalUnits: 47 },
        { date: "2021-05-02", totalSales: 15, totalUnits: 9 },
        { date: "2021-05-03", totalSales: 24, totalUnits: 16 },
        { date: "2021-05-04", totalSales: 79, totalUnits: 13 },
        { date: "2021-05-05", totalSales: 32, totalUnits: 21 },
        { date: "2021-05-06", totalSales: 66, totalUnits: 47 },
        { date: "2021-05-07", totalSales: 3, totalUnits: 25 },
        { date: "2021-05-08", totalSales: 72, totalUnits: 21 },
        { date: "2021-05-09", totalSales: 85, totalUnits: 31 },
        { date: "2021-05-10", totalSales: 15, totalUnits: 15 },
        { date: "2021-05-11", totalSales: 51, totalUnits: 27 },
        { date: "2021-05-12", totalSales: 45, totalUnits: 38 },
        { date: "2021-05-13", totalSales: 88, totalUnits: 2 },
        { date: "2021-05-14", totalSales: 73, totalUnits: 38 },
        { date: "2021-05-15", totalSales: 49, totalUnits: 35 },
        { date: "2021-05-16", totalSales: 29, totalUnits: 41 },
        { date: "2021-05-17", totalSales: 81, totalUnits: 33 },
        { date: "2021-05-18", totalSales: 75, totalUnits: 35 },
        { date: "2021-05-19", totalSales: 7, totalUnits: 12 },
        { date: "2021-05-20", totalSales: 82, totalUnits: 5 },
        { date: "2021-05-21", totalSales: 52, totalUnits: 2 },
        { date: "2021-05-22", totalSales: 20, totalUnits: 2 },
        { date: "2021-05-23", totalSales: 50, totalUnits: 46 },
        { date: "2021-05-24", totalSales: 10, totalUnits: 10 },
        { date: "2021-05-25", totalSales: 67, totalUnits: 49 },
        { date: "2021-05-26", totalSales: 79, totalUnits: 49 },
        { date: "2021-05-27", totalSales: 98, totalUnits: 49 },
        { date: "2021-05-28", totalSales: 43, totalUnits: 4 },
        { date: "2021-05-29", totalSales: 80, totalUnits: 41 },
        { date: "2021-05-30", totalSales: 15, totalUnits: 46 },
        { date: "2021-05-31", totalSales: 92, totalUnits: 49 },
        { date: "2021-06-01", totalSales: 45, totalUnits: 28 },
        { date: "2021-06-02", totalSales: 72, totalUnits: 5 },
        { date: "2021-06-03", totalSales: 30, totalUnits: 36 },
        { date: "2021-06-04", totalSales: 70, totalUnits: 39 },
        { date: "2021-06-05", totalSales: 96, totalUnits: 46 },
        { date: "2021-06-06", totalSales: 3, totalUnits: 2 },
        { date: "2021-06-07", totalSales: 51, totalUnits: 24 },
        { date: "2021-06-08", totalSales: 38, totalUnits: 24 },
        { date: "2021-06-09", totalSales: 59, totalUnits: 33 },
        { date: "2021-06-10", totalSales: 25, totalUnits: 34 },
        { date: "2021-06-11", totalSales: 68, totalUnits: 50 },
        { date: "2021-06-12", totalSales: 81, totalUnits: 21 },
        { date: "2021-06-13", totalSales: 42, totalUnits: 49 },
        { date: "2021-06-14", totalSales: 31, totalUnits: 24 },
        { date: "2021-06-15", totalSales: 91, totalUnits: 9 },
        { date: "2021-06-16", totalSales: 70, totalUnits: 44 },
        { date: "2021-06-17", totalSales: 90, totalUnits: 13 },
        { date: "2021-06-18", totalSales: 14, totalUnits: 13 },
        { date: "2021-06-19", totalSales: 96, totalUnits: 12 },
        { date: "2021-06-20", totalSales: 47, totalUnits: 50 },
        { date: "2021-06-21", totalSales: 21, totalUnits: 7 },
        { date: "2021-06-22", totalSales: 72, totalUnits: 6 },
        { date: "2021-06-23", totalSales: 8, totalUnits: 7 },
        { date: "2021-06-24", totalSales: 92, totalUnits: 42 },
        { date: "2021-06-25", totalSales: 32, totalUnits: 16 },
        { date: "2021-06-26", totalSales: 23, totalUnits: 33 },
        { date: "2021-06-27", totalSales: 69, totalUnits: 5 },
        { date: "2021-06-28", totalSales: 26, totalUnits: 37 },
        { date: "2021-06-29", totalSales: 7, totalUnits: 13 },
        { date: "2021-06-30", totalSales: 19, totalUnits: 49 },
        { date: "2021-07-01", totalSales: 90, totalUnits: 4 },
        { date: "2021-07-02", totalSales: 46, totalUnits: 21 },
        { date: "2021-07-03", totalSales: 79, totalUnits: 15 },
        { date: "2021-07-04", totalSales: 73, totalUnits: 14 },
        { date: "2021-07-05", totalSales: 24, totalUnits: 44 },
        { date: "2021-07-06", totalSales: 19, totalUnits: 22 },
        { date: "2021-07-07", totalSales: 77, totalUnits: 31 },
        { date: "2021-07-08", totalSales: 70, totalUnits: 35 },
        { date: "2021-07-09", totalSales: 88, totalUnits: 44 },
        { date: "2021-07-10", totalSales: 33, totalUnits: 9 },
        { date: "2021-07-11", totalSales: 78, totalUnits: 9 },
        { date: "2021-07-12", totalSales: 8, totalUnits: 7 },
        { date: "2021-07-13", totalSales: 63, totalUnits: 4 },
        { date: "2021-07-14", totalSales: 24, totalUnits: 14 },
        { date: "2021-07-15", totalSales: 81, totalUnits: 6 },
        { date: "2021-07-16", totalSales: 17, totalUnits: 6 },
        { date: "2021-07-17", totalSales: 45, totalUnits: 36 },
        { date: "2021-07-18", totalSales: 95, totalUnits: 17 },
        { date: "2021-07-19", totalSales: 86, totalUnits: 22 },
        { date: "2021-07-20", totalSales: 100, totalUnits: 28 },
        { date: "2021-07-21", totalSales: 64, totalUnits: 20 },
        { date: "2021-07-22", totalSales: 7, totalUnits: 8 },
        { date: "2021-07-23", totalSales: 31, totalUnits: 37 },
        { date: "2021-07-24", totalSales: 39, totalUnits: 21 },
        { date: "2021-07-25", totalSales: 82, totalUnits: 20 },
        { date: "2021-07-26", totalSales: 2, totalUnits: 35 },
        { date: "2021-07-27", totalSales: 8, totalUnits: 11 },
        { date: "2021-07-28", totalSales: 59, totalUnits: 24 },
        { date: "2021-07-29", totalSales: 33, totalUnits: 43 },
        { date: "2021-07-30", totalSales: 29, totalUnits: 41 },
        { date: "2021-07-31", totalSales: 94, totalUnits: 28 },
        { date: "2021-08-01", totalSales: 39, totalUnits: 8 },
        { date: "2021-08-02", totalSales: 55, totalUnits: 43 },
        { date: "2021-08-03", totalSales: 44, totalUnits: 24 },
        { date: "2021-08-04", totalSales: 100, totalUnits: 25 },
        { date: "2021-08-05", totalSales: 82, totalUnits: 44 },
        { date: "2021-08-06", totalSales: 52, totalUnits: 3 },
        { date: "2021-08-07", totalSales: 41, totalUnits: 12 },
        { date: "2021-08-08", totalSales: 20, totalUnits: 25 },
        { date: "2021-08-09", totalSales: 78, totalUnits: 42 },
        { date: "2021-08-10", totalSales: 89, totalUnits: 12 },
        { date: "2021-08-11", totalSales: 12, totalUnits: 32 },
        { date: "2021-08-12", totalSales: 98, totalUnits: 48 },
        { date: "2021-08-13", totalSales: 66, totalUnits: 2 },
        { date: "2021-08-14", totalSales: 41, totalUnits: 44 },
        { date: "2021-08-15", totalSales: 65, totalUnits: 16 },
        { date: "2021-08-16", totalSales: 39, totalUnits: 2 },
        { date: "2021-08-17", totalSales: 38, totalUnits: 43 },
        { date: "2021-08-18", totalSales: 82, totalUnits: 50 },
        { date: "2021-08-19", totalSales: 11, totalUnits: 8 },
        { date: "2021-08-20", totalSales: 3, totalUnits: 45 },
        { date: "2021-08-21", totalSales: 69, totalUnits: 1 },
        { date: "2021-08-22", totalSales: 25, totalUnits: 7 },
        { date: "2021-08-23", totalSales: 19, totalUnits: 28 },
        { date: "2021-08-24", totalSales: 4, totalUnits: 30 },
        { date: "2021-08-25", totalSales: 22, totalUnits: 1 },
        { date: "2021-08-26", totalSales: 16, totalUnits: 18 },
        { date: "2021-08-27", totalSales: 94, totalUnits: 16 },
        { date: "2021-08-28", totalSales: 94, totalUnits: 29 },
        { date: "2021-08-29", totalSales: 88, totalUnits: 8 },
        { date: "2021-08-30", totalSales: 7, totalUnits: 16 },
        { date: "2021-08-31", totalSales: 6, totalUnits: 17 },
        { date: "2021-09-01", totalSales: 35, totalUnits: 13 },
        { date: "2021-09-02", totalSales: 8, totalUnits: 45 },
        { date: "2021-09-03", totalSales: 24, totalUnits: 39 },
        { date: "2021-09-04", totalSales: 89, totalUnits: 23 },
        { date: "2021-09-05", totalSales: 99, totalUnits: 5 },
        { date: "2021-09-06", totalSales: 80, totalUnits: 35 },
        { date: "2021-09-07", totalSales: 18, totalUnits: 3 },
        { date: "2021-09-08", totalSales: 53, totalUnits: 39 },
        { date: "2021-09-09", totalSales: 87, totalUnits: 17 },
        { date: "2021-09-10", totalSales: 45, totalUnits: 3 },
        { date: "2021-09-11", totalSales: 61, totalUnits: 24 },
        { date: "2021-09-12", totalSales: 89, totalUnits: 21 },
        { date: "2021-09-13", totalSales: 88, totalUnits: 16 },
        { date: "2021-09-14", totalSales: 62, totalUnits: 28 },
        { date: "2021-09-15", totalSales: 13, totalUnits: 49 },
        { date: "2021-09-16", totalSales: 78, totalUnits: 9 },
        { date: "2021-09-17", totalSales: 24, totalUnits: 7 },
        { date: "2021-09-18", totalSales: 4, totalUnits: 10 },
        { date: "2021-09-19", totalSales: 50, totalUnits: 21 },
        { date: "2021-09-20", totalSales: 60, totalUnits: 42 },
        { date: "2021-09-21", totalSales: 6, totalUnits: 27 },
        { date: "2021-09-22", totalSales: 5, totalUnits: 19 },
        { date: "2021-09-23", totalSales: 22, totalUnits: 4 },
        { date: "2021-09-24", totalSales: 66, totalUnits: 18 },
        { date: "2021-09-25", totalSales: 22, totalUnits: 11 },
        { date: "2021-09-26", totalSales: 98, totalUnits: 6 },
        { date: "2021-09-27", totalSales: 5, totalUnits: 7 },
        { date: "2021-09-28", totalSales: 97, totalUnits: 23 },
        { date: "2021-09-29", totalSales: 71, totalUnits: 9 },
        { date: "2021-09-30", totalSales: 98, totalUnits: 3 },
        { date: "2021-10-01", totalSales: 95, totalUnits: 9 },
        { date: "2021-10-02", totalSales: 19, totalUnits: 31 },
        { date: "2021-10-03", totalSales: 85, totalUnits: 35 },
        { date: "2021-10-04", totalSales: 10, totalUnits: 32 },
        { date: "2021-10-05", totalSales: 6, totalUnits: 32 },
        { date: "2021-10-06", totalSales: 56, totalUnits: 38 },
        { date: "2021-10-07", totalSales: 5, totalUnits: 43 },
        { date: "2021-10-08", totalSales: 12, totalUnits: 20 },
        { date: "2021-10-09", totalSales: 2, totalUnits: 24 },
        { date: "2021-10-10", totalSales: 28, totalUnits: 1 },
        { date: "2021-10-11", totalSales: 87, totalUnits: 29 },
        { date: "2021-10-12", totalSales: 43, totalUnits: 19 },
        { date: "2021-10-13", totalSales: 3, totalUnits: 21 },
        { date: "2021-10-14", totalSales: 73, totalUnits: 29 },
        { date: "2021-10-15", totalSales: 53, totalUnits: 41 },
        { date: "2021-10-16", totalSales: 26, totalUnits: 8 },
        { date: "2021-10-17", totalSales: 74, totalUnits: 3 },
        { date: "2021-10-18", totalSales: 60, totalUnits: 12 },
        { date: "2021-10-19", totalSales: 37, totalUnits: 7 },
        { date: "2021-10-20", totalSales: 48, totalUnits: 41 },
        { date: "2021-10-21", totalSales: 1, totalUnits: 19 },
        { date: "2021-10-22", totalSales: 47, totalUnits: 2 },
        { date: "2021-10-23", totalSales: 28, totalUnits: 16 },
        { date: "2021-10-24", totalSales: 50, totalUnits: 45 },
        { date: "2021-10-25", totalSales: 56, totalUnits: 33 },
        { date: "2021-10-26", totalSales: 9, totalUnits: 10 },
        { date: "2021-10-27", totalSales: 54, totalUnits: 30 },
        { date: "2021-10-28", totalSales: 39, totalUnits: 50 },
        { date: "2021-10-29", totalSales: 2, totalUnits: 23 },
        { date: "2021-10-30", totalSales: 97, totalUnits: 36 },
        { date: "2021-10-31", totalSales: 70, totalUnits: 10 },
        { date: "2021-11-01", totalSales: 29, totalUnits: 44 },
        { date: "2021-11-02", totalSales: 54, totalUnits: 47 },
        { date: "2021-11-03", totalSales: 82, totalUnits: 28 },
        { date: "2021-11-04", totalSales: 58, totalUnits: 42 },
        { date: "2021-11-05", totalSales: 80, totalUnits: 12 },
        { date: "2021-11-06", totalSales: 72, totalUnits: 2 },
        { date: "2021-11-07", totalSales: 76, totalUnits: 36 },
        { date: "2021-11-08", totalSales: 70, totalUnits: 40 },
        { date: "2021-11-09", totalSales: 5, totalUnits: 43 },
        { date: "2021-11-10", totalSales: 85, totalUnits: 3 },
        { date: "2021-11-11", totalSales: 56, totalUnits: 3 },
        { date: "2021-11-12", totalSales: 18, totalUnits: 8 },
        { date: "2021-11-13", totalSales: 77, totalUnits: 36 },
        { date: "2021-11-14", totalSales: 28, totalUnits: 47 },
        { date: "2021-11-15", totalSales: 69, totalUnits: 3 },
        { date: "2021-11-16", totalSales: 62, totalUnits: 49 },
        { date: "2021-11-17", totalSales: 95, totalUnits: 50 },
      ],
    },
    {
      _id: "6371259ef03239d40b0000d5",
      productId: "63701d24f032390a34000328",
      yearlySalesTotal: 6058,
      yearlyTotalSoldUnits: 4381,
      monthlyData: [
        { month: "january", totalSales: 312, totalUnits: 75 },
        { month: "february", totalSales: 601, totalUnits: 128 },
        { month: "march", totalSales: 498, totalUnits: 284 },
        { month: "april", totalSales: 336, totalUnits: 145 },
        { month: "may", totalSales: 584, totalUnits: 323 },
        { month: "june", totalSales: 345, totalUnits: 136 },
        { month: "july", totalSales: 334, totalUnits: 356 },
        { month: "august", totalSales: 496, totalUnits: 124 },
        { month: "september", totalSales: 720, totalUnits: 347 },
        { month: "october", totalSales: 699, totalUnits: 476 },
        { month: "november", totalSales: 436, totalUnits: 485 },
        { month: "december", totalSales: 610, totalUnits: 46 },
      ],
      dailyData: [
        { date: "2021-01-02", totalSales: 59, totalUnits: 50 },
        { date: "2021-01-03", totalSales: 86, totalUnits: 12 },
        { date: "2021-01-04", totalSales: 3, totalUnits: 46 },
        { date: "2021-01-05", totalSales: 64, totalUnits: 27 },
        { date: "2021-01-06", totalSales: 25, totalUnits: 27 },
        { date: "2021-01-07", totalSales: 87, totalUnits: 3 },
        { date: "2021-01-08", totalSales: 76, totalUnits: 31 },
        { date: "2021-01-09", totalSales: 58, totalUnits: 20 },
        { date: "2021-01-10", totalSales: 97, totalUnits: 27 },
        { date: "2021-01-11", totalSales: 37, totalUnits: 40 },
        { date: "2021-01-12", totalSales: 89, totalUnits: 40 },
        { date: "2021-01-13", totalSales: 47, totalUnits: 45 },
        { date: "2021-01-14", totalSales: 3, totalUnits: 47 },
        { date: "2021-01-15", totalSales: 80, totalUnits: 26 },
        { date: "2021-01-16", totalSales: 12, totalUnits: 24 },
        { date: "2021-01-17", totalSales: 14, totalUnits: 1 },
        { date: "2021-01-18", totalSales: 14, totalUnits: 39 },
        { date: "2021-01-19", totalSales: 78, totalUnits: 6 },
        { date: "2021-01-20", totalSales: 14, totalUnits: 11 },
        { date: "2021-01-21", totalSales: 71, totalUnits: 45 },
        { date: "2021-01-22", totalSales: 7, totalUnits: 46 },
        { date: "2021-01-23", totalSales: 16, totalUnits: 2 },
        { date: "2021-01-24", totalSales: 31, totalUnits: 45 },
        { date: "2021-01-25", totalSales: 36, totalUnits: 29 },
        { date: "2021-01-26", totalSales: 45, totalUnits: 19 },
        { date: "2021-01-27", totalSales: 60, totalUnits: 49 },
        { date: "2021-01-28", totalSales: 65, totalUnits: 33 },
        { date: "2021-01-29", totalSales: 64, totalUnits: 44 },
        { date: "2021-01-30", totalSales: 71, totalUnits: 10 },
        { date: "2021-01-31", totalSales: 54, totalUnits: 21 },
        { date: "2021-02-01", totalSales: 2, totalUnits: 12 },
        { date: "2021-02-02", totalSales: 81, totalUnits: 12 },
        { date: "2021-02-03", totalSales: 59, totalUnits: 15 },
        { date: "2021-02-04", totalSales: 98, totalUnits: 28 },
        { date: "2021-02-05", totalSales: 75, totalUnits: 8 },
        { date: "2021-02-06", totalSales: 37, totalUnits: 29 },
        { date: "2021-02-07", totalSales: 42, totalUnits: 45 },
        { date: "2021-02-08", totalSales: 4, totalUnits: 42 },
        { date: "2021-02-09", totalSales: 77, totalUnits: 44 },
        { date: "2021-02-10", totalSales: 9, totalUnits: 41 },
        { date: "2021-02-11", totalSales: 35, totalUnits: 41 },
        { date: "2021-02-12", totalSales: 75, totalUnits: 22 },
        { date: "2021-02-13", totalSales: 57, totalUnits: 39 },
        { date: "2021-02-14", totalSales: 35, totalUnits: 5 },
        { date: "2021-02-15", totalSales: 16, totalUnits: 43 },
        { date: "2021-02-16", totalSales: 53, totalUnits: 13 },
        { date: "2021-02-17", totalSales: 88, totalUnits: 33 },
        { date: "2021-02-18", totalSales: 25, totalUnits: 40 },
        { date: "2021-02-19", totalSales: 87, totalUnits: 19 },
        { date: "2021-02-20", totalSales: 40, totalUnits: 27 },
        { date: "2021-02-21", totalSales: 66, totalUnits: 22 },
        { date: "2021-02-22", totalSales: 19, totalUnits: 35 },
        { date: "2021-02-23", totalSales: 59, totalUnits: 19 },
        { date: "2021-02-24", totalSales: 81, totalUnits: 39 },
        { date: "2021-02-25", totalSales: 90, totalUnits: 5 },
        { date: "2021-02-26", totalSales: 67, totalUnits: 21 },
        { date: "2021-02-27", totalSales: 17, totalUnits: 40 },
        { date: "2021-02-28", totalSales: 50, totalUnits: 23 },
        { date: "2021-03-01", totalSales: 53, totalUnits: 35 },
        { date: "2021-03-02", totalSales: 50, totalUnits: 9 },
        { date: "2021-03-03", totalSales: 16, totalUnits: 9 },
        { date: "2021-03-04", totalSales: 66, totalUnits: 46 },
        { date: "2021-03-05", totalSales: 52, totalUnits: 31 },
        { date: "2021-03-06", totalSales: 30, totalUnits: 15 },
        { date: "2021-03-07", totalSales: 88, totalUnits: 25 },
        { date: "2021-03-08", totalSales: 95, totalUnits: 31 },
        { date: "2021-03-09", totalSales: 54, totalUnits: 35 },
        { date: "2021-03-10", totalSales: 83, totalUnits: 40 },
        { date: "2021-03-11", totalSales: 63, totalUnits: 44 },
        { date: "2021-03-12", totalSales: 14, totalUnits: 45 },
        { date: "2021-03-13", totalSales: 54, totalUnits: 10 },
        { date: "2021-03-14", totalSales: 47, totalUnits: 7 },
        { date: "2021-03-15", totalSales: 89, totalUnits: 31 },
        { date: "2021-03-16", totalSales: 93, totalUnits: 11 },
        { date: "2021-03-17", totalSales: 49, totalUnits: 26 },
        { date: "2021-03-18", totalSales: 13, totalUnits: 18 },
        { date: "2021-03-19", totalSales: 42, totalUnits: 13 },
        { date: "2021-03-20", totalSales: 16, totalUnits: 3 },
        { date: "2021-03-21", totalSales: 10, totalUnits: 30 },
        { date: "2021-03-22", totalSales: 64, totalUnits: 38 },
        { date: "2021-03-23", totalSales: 13, totalUnits: 18 },
        { date: "2021-03-24", totalSales: 75, totalUnits: 31 },
        { date: "2021-03-25", totalSales: 75, totalUnits: 7 },
        { date: "2021-03-26", totalSales: 40, totalUnits: 33 },
        { date: "2021-03-27", totalSales: 1, totalUnits: 48 },
        { date: "2021-03-28", totalSales: 88, totalUnits: 8 },
        { date: "2021-03-29", totalSales: 28, totalUnits: 3 },
        { date: "2021-03-30", totalSales: 97, totalUnits: 36 },
        { date: "2021-03-31", totalSales: 98, totalUnits: 5 },
        { date: "2021-04-01", totalSales: 81, totalUnits: 4 },
        { date: "2021-04-02", totalSales: 63, totalUnits: 12 },
        { date: "2021-04-03", totalSales: 6, totalUnits: 33 },
        { date: "2021-04-04", totalSales: 84, totalUnits: 7 },
        { date: "2021-04-05", totalSales: 91, totalUnits: 35 },
        { date: "2021-04-06", totalSales: 44, totalUnits: 42 },
        { date: "2021-04-07", totalSales: 48, totalUnits: 28 },
        { date: "2021-04-08", totalSales: 9, totalUnits: 3 },
        { date: "2021-04-09", totalSales: 80, totalUnits: 2 },
        { date: "2021-04-10", totalSales: 93, totalUnits: 11 },
        { date: "2021-04-11", totalSales: 100, totalUnits: 36 },
        { date: "2021-04-12", totalSales: 83, totalUnits: 26 },
        { date: "2021-04-13", totalSales: 19, totalUnits: 45 },
        { date: "2021-04-14", totalSales: 79, totalUnits: 34 },
        { date: "2021-04-15", totalSales: 58, totalUnits: 31 },
        { date: "2021-04-16", totalSales: 34, totalUnits: 42 },
        { date: "2021-04-17", totalSales: 12, totalUnits: 10 },
        { date: "2021-04-18", totalSales: 87, totalUnits: 10 },
        { date: "2021-04-19", totalSales: 83, totalUnits: 34 },
        { date: "2021-04-20", totalSales: 95, totalUnits: 40 },
        { date: "2021-04-21", totalSales: 27, totalUnits: 1 },
        { date: "2021-04-22", totalSales: 98, totalUnits: 45 },
        { date: "2021-04-23", totalSales: 28, totalUnits: 22 },
        { date: "2021-04-24", totalSales: 67, totalUnits: 44 },
        { date: "2021-04-25", totalSales: 17, totalUnits: 27 },
        { date: "2021-04-26", totalSales: 65, totalUnits: 31 },
        { date: "2021-04-27", totalSales: 94, totalUnits: 5 },
        { date: "2021-04-28", totalSales: 5, totalUnits: 29 },
        { date: "2021-04-29", totalSales: 10, totalUnits: 31 },
        { date: "2021-04-30", totalSales: 41, totalUnits: 49 },
        { date: "2021-05-01", totalSales: 16, totalUnits: 10 },
        { date: "2021-05-02", totalSales: 14, totalUnits: 5 },
        { date: "2021-05-03", totalSales: 27, totalUnits: 2 },
        { date: "2021-05-04", totalSales: 90, totalUnits: 35 },
        { date: "2021-05-05", totalSales: 11, totalUnits: 48 },
        { date: "2021-05-06", totalSales: 96, totalUnits: 29 },
        { date: "2021-05-07", totalSales: 38, totalUnits: 3 },
        { date: "2021-05-08", totalSales: 19, totalUnits: 49 },
        { date: "2021-05-09", totalSales: 96, totalUnits: 39 },
        { date: "2021-05-10", totalSales: 39, totalUnits: 30 },
        { date: "2021-05-11", totalSales: 90, totalUnits: 47 },
        { date: "2021-05-12", totalSales: 96, totalUnits: 29 },
        { date: "2021-05-13", totalSales: 46, totalUnits: 49 },
        { date: "2021-05-14", totalSales: 24, totalUnits: 19 },
        { date: "2021-05-15", totalSales: 12, totalUnits: 28 },
        { date: "2021-05-16", totalSales: 1, totalUnits: 24 },
        { date: "2021-05-17", totalSales: 99, totalUnits: 25 },
        { date: "2021-05-18", totalSales: 64, totalUnits: 31 },
        { date: "2021-05-19", totalSales: 97, totalUnits: 29 },
        { date: "2021-05-20", totalSales: 26, totalUnits: 31 },
        { date: "2021-05-21", totalSales: 7, totalUnits: 30 },
        { date: "2021-05-22", totalSales: 44, totalUnits: 8 },
        { date: "2021-05-23", totalSales: 70, totalUnits: 33 },
        { date: "2021-05-24", totalSales: 32, totalUnits: 5 },
        { date: "2021-05-25", totalSales: 98, totalUnits: 24 },
        { date: "2021-05-26", totalSales: 1, totalUnits: 15 },
        { date: "2021-05-27", totalSales: 86, totalUnits: 3 },
        { date: "2021-05-28", totalSales: 98, totalUnits: 8 },
        { date: "2021-05-29", totalSales: 21, totalUnits: 39 },
        { date: "2021-05-30", totalSales: 55, totalUnits: 8 },
        { date: "2021-05-31", totalSales: 87, totalUnits: 25 },
        { date: "2021-06-01", totalSales: 44, totalUnits: 31 },
        { date: "2021-06-02", totalSales: 35, totalUnits: 12 },
        { date: "2021-06-03", totalSales: 4, totalUnits: 32 },
        { date: "2021-06-04", totalSales: 7, totalUnits: 27 },
        { date: "2021-06-05", totalSales: 43, totalUnits: 15 },
        { date: "2021-06-06", totalSales: 81, totalUnits: 23 },
        { date: "2021-06-07", totalSales: 71, totalUnits: 46 },
        { date: "2021-06-08", totalSales: 14, totalUnits: 4 },
        { date: "2021-06-09", totalSales: 66, totalUnits: 29 },
        { date: "2021-06-10", totalSales: 92, totalUnits: 27 },
        { date: "2021-06-11", totalSales: 17, totalUnits: 8 },
        { date: "2021-06-12", totalSales: 75, totalUnits: 46 },
        { date: "2021-06-13", totalSales: 96, totalUnits: 33 },
        { date: "2021-06-14", totalSales: 88, totalUnits: 36 },
        { date: "2021-06-15", totalSales: 30, totalUnits: 49 },
        { date: "2021-06-16", totalSales: 42, totalUnits: 6 },
        { date: "2021-06-17", totalSales: 47, totalUnits: 24 },
        { date: "2021-06-18", totalSales: 95, totalUnits: 9 },
        { date: "2021-06-19", totalSales: 47, totalUnits: 24 },
        { date: "2021-06-20", totalSales: 28, totalUnits: 19 },
        { date: "2021-06-21", totalSales: 38, totalUnits: 8 },
        { date: "2021-06-22", totalSales: 86, totalUnits: 6 },
        { date: "2021-06-23", totalSales: 60, totalUnits: 43 },
        { date: "2021-06-24", totalSales: 26, totalUnits: 33 },
        { date: "2021-06-25", totalSales: 84, totalUnits: 26 },
        { date: "2021-06-26", totalSales: 35, totalUnits: 13 },
        { date: "2021-06-27", totalSales: 44, totalUnits: 7 },
        { date: "2021-06-28", totalSales: 56, totalUnits: 46 },
        { date: "2021-06-29", totalSales: 90, totalUnits: 14 },
        { date: "2021-06-30", totalSales: 32, totalUnits: 24 },
        { date: "2021-07-01", totalSales: 49, totalUnits: 33 },
        { date: "2021-07-02", totalSales: 41, totalUnits: 8 },
        { date: "2021-07-03", totalSales: 63, totalUnits: 42 },
        { date: "2021-07-04", totalSales: 55, totalUnits: 39 },
        { date: "2021-07-05", totalSales: 21, totalUnits: 30 },
        { date: "2021-07-06", totalSales: 20, totalUnits: 39 },
        { date: "2021-07-07", totalSales: 46, totalUnits: 48 },
        { date: "2021-07-08", totalSales: 67, totalUnits: 43 },
        { date: "2021-07-09", totalSales: 73, totalUnits: 45 },
        { date: "2021-07-10", totalSales: 39, totalUnits: 22 },
        { date: "2021-07-11", totalSales: 52, totalUnits: 49 },
        { date: "2021-07-12", totalSales: 70, totalUnits: 20 },
        { date: "2021-07-13", totalSales: 12, totalUnits: 24 },
        { date: "2021-07-14", totalSales: 10, totalUnits: 9 },
        { date: "2021-07-15", totalSales: 3, totalUnits: 35 },
        { date: "2021-07-16", totalSales: 51, totalUnits: 12 },
        { date: "2021-07-17", totalSales: 88, totalUnits: 17 },
        { date: "2021-07-18", totalSales: 11, totalUnits: 15 },
        { date: "2021-07-19", totalSales: 4, totalUnits: 1 },
        { date: "2021-07-20", totalSales: 51, totalUnits: 14 },
        { date: "2021-07-21", totalSales: 81, totalUnits: 45 },
        { date: "2021-07-22", totalSales: 21, totalUnits: 28 },
        { date: "2021-07-23", totalSales: 28, totalUnits: 10 },
        { date: "2021-07-24", totalSales: 42, totalUnits: 8 },
        { date: "2021-07-25", totalSales: 20, totalUnits: 20 },
        { date: "2021-07-26", totalSales: 60, totalUnits: 15 },
        { date: "2021-07-27", totalSales: 20, totalUnits: 15 },
        { date: "2021-07-28", totalSales: 26, totalUnits: 24 },
        { date: "2021-07-29", totalSales: 3, totalUnits: 50 },
        { date: "2021-07-30", totalSales: 67, totalUnits: 23 },
        { date: "2021-07-31", totalSales: 73, totalUnits: 33 },
        { date: "2021-08-01", totalSales: 42, totalUnits: 10 },
        { date: "2021-08-02", totalSales: 56, totalUnits: 13 },
        { date: "2021-08-03", totalSales: 12, totalUnits: 15 },
        { date: "2021-08-04", totalSales: 30, totalUnits: 11 },
        { date: "2021-08-05", totalSales: 70, totalUnits: 46 },
        { date: "2021-08-06", totalSales: 97, totalUnits: 48 },
        { date: "2021-08-07", totalSales: 73, totalUnits: 8 },
        { date: "2021-08-08", totalSales: 25, totalUnits: 34 },
        { date: "2021-08-09", totalSales: 96, totalUnits: 7 },
        { date: "2021-08-10", totalSales: 65, totalUnits: 44 },
        { date: "2021-08-11", totalSales: 28, totalUnits: 41 },
        { date: "2021-08-12", totalSales: 18, totalUnits: 20 },
        { date: "2021-08-13", totalSales: 87, totalUnits: 23 },
        { date: "2021-08-14", totalSales: 67, totalUnits: 12 },
        { date: "2021-08-15", totalSales: 35, totalUnits: 37 },
        { date: "2021-08-16", totalSales: 89, totalUnits: 17 },
        { date: "2021-08-17", totalSales: 83, totalUnits: 22 },
        { date: "2021-08-18", totalSales: 4, totalUnits: 34 },
        { date: "2021-08-19", totalSales: 4, totalUnits: 10 },
        { date: "2021-08-20", totalSales: 47, totalUnits: 27 },
        { date: "2021-08-21", totalSales: 8, totalUnits: 31 },
        { date: "2021-08-22", totalSales: 55, totalUnits: 40 },
        { date: "2021-08-23", totalSales: 32, totalUnits: 25 },
        { date: "2021-08-24", totalSales: 50, totalUnits: 25 },
        { date: "2021-08-25", totalSales: 43, totalUnits: 12 },
        { date: "2021-08-26", totalSales: 37, totalUnits: 38 },
        { date: "2021-08-27", totalSales: 86, totalUnits: 7 },
        { date: "2021-08-28", totalSales: 98, totalUnits: 3 },
        { date: "2021-08-29", totalSales: 3, totalUnits: 23 },
        { date: "2021-08-30", totalSales: 71, totalUnits: 11 },
        { date: "2021-08-31", totalSales: 27, totalUnits: 18 },
        { date: "2021-09-01", totalSales: 60, totalUnits: 41 },
        { date: "2021-09-02", totalSales: 94, totalUnits: 27 },
        { date: "2021-09-03", totalSales: 85, totalUnits: 39 },
        { date: "2021-09-04", totalSales: 96, totalUnits: 11 },
        { date: "2021-09-05", totalSales: 74, totalUnits: 40 },
        { date: "2021-09-06", totalSales: 60, totalUnits: 21 },
        { date: "2021-09-07", totalSales: 100, totalUnits: 6 },
        { date: "2021-09-08", totalSales: 34, totalUnits: 5 },
        { date: "2021-09-09", totalSales: 31, totalUnits: 13 },
        { date: "2021-09-10", totalSales: 1, totalUnits: 37 },
        { date: "2021-09-11", totalSales: 62, totalUnits: 22 },
        { date: "2021-09-12", totalSales: 71, totalUnits: 9 },
        { date: "2021-09-13", totalSales: 10, totalUnits: 34 },
        { date: "2021-09-14", totalSales: 40, totalUnits: 27 },
        { date: "2021-09-15", totalSales: 30, totalUnits: 10 },
        { date: "2021-09-16", totalSales: 74, totalUnits: 48 },
        { date: "2021-09-17", totalSales: 4, totalUnits: 7 },
        { date: "2021-09-18", totalSales: 57, totalUnits: 34 },
        { date: "2021-09-19", totalSales: 51, totalUnits: 15 },
        { date: "2021-09-20", totalSales: 96, totalUnits: 48 },
        { date: "2021-09-21", totalSales: 15, totalUnits: 22 },
        { date: "2021-09-22", totalSales: 95, totalUnits: 40 },
        { date: "2021-09-23", totalSales: 38, totalUnits: 37 },
        { date: "2021-09-24", totalSales: 30, totalUnits: 16 },
        { date: "2021-09-25", totalSales: 94, totalUnits: 50 },
        { date: "2021-09-26", totalSales: 90, totalUnits: 14 },
        { date: "2021-09-27", totalSales: 56, totalUnits: 12 },
        { date: "2021-09-28", totalSales: 61, totalUnits: 29 },
        { date: "2021-09-29", totalSales: 52, totalUnits: 24 },
        { date: "2021-09-30", totalSales: 66, totalUnits: 44 },
        { date: "2021-10-01", totalSales: 25, totalUnits: 7 },
        { date: "2021-10-02", totalSales: 58, totalUnits: 27 },
        { date: "2021-10-03", totalSales: 53, totalUnits: 19 },
        { date: "2021-10-04", totalSales: 17, totalUnits: 14 },
        { date: "2021-10-05", totalSales: 56, totalUnits: 31 },
        { date: "2021-10-06", totalSales: 40, totalUnits: 19 },
        { date: "2021-10-07", totalSales: 48, totalUnits: 41 },
        { date: "2021-10-08", totalSales: 12, totalUnits: 34 },
        { date: "2021-10-09", totalSales: 89, totalUnits: 48 },
        { date: "2021-10-10", totalSales: 1, totalUnits: 28 },
        { date: "2021-10-11", totalSales: 36, totalUnits: 46 },
        { date: "2021-10-12", totalSales: 23, totalUnits: 34 },
        { date: "2021-10-13", totalSales: 46, totalUnits: 49 },
        { date: "2021-10-14", totalSales: 79, totalUnits: 34 },
        { date: "2021-10-15", totalSales: 89, totalUnits: 49 },
        { date: "2021-10-16", totalSales: 12, totalUnits: 7 },
        { date: "2021-10-17", totalSales: 46, totalUnits: 24 },
        { date: "2021-10-18", totalSales: 84, totalUnits: 38 },
        { date: "2021-10-19", totalSales: 12, totalUnits: 12 },
        { date: "2021-10-20", totalSales: 34, totalUnits: 5 },
        { date: "2021-10-21", totalSales: 70, totalUnits: 48 },
        { date: "2021-10-22", totalSales: 11, totalUnits: 17 },
        { date: "2021-10-23", totalSales: 89, totalUnits: 29 },
        { date: "2021-10-24", totalSales: 89, totalUnits: 6 },
        { date: "2021-10-25", totalSales: 59, totalUnits: 3 },
        { date: "2021-10-26", totalSales: 24, totalUnits: 25 },
        { date: "2021-10-27", totalSales: 55, totalUnits: 11 },
        { date: "2021-10-28", totalSales: 58, totalUnits: 7 },
        { date: "2021-10-29", totalSales: 21, totalUnits: 47 },
        { date: "2021-10-30", totalSales: 54, totalUnits: 6 },
        { date: "2021-10-31", totalSales: 43, totalUnits: 27 },
        { date: "2021-11-01", totalSales: 87, totalUnits: 34 },
        { date: "2021-11-02", totalSales: 88, totalUnits: 45 },
        { date: "2021-11-03", totalSales: 17, totalUnits: 34 },
        { date: "2021-11-04", totalSales: 52, totalUnits: 50 },
        { date: "2021-11-05", totalSales: 94, totalUnits: 48 },
        { date: "2021-11-06", totalSales: 75, totalUnits: 33 },
        { date: "2021-11-07", totalSales: 41, totalUnits: 42 },
        { date: "2021-11-08", totalSales: 40, totalUnits: 45 },
        { date: "2021-11-09", totalSales: 66, totalUnits: 13 },
        { date: "2021-11-10", totalSales: 79, totalUnits: 34 },
        { date: "2021-11-11", totalSales: 20, totalUnits: 32 },
        { date: "2021-11-12", totalSales: 22, totalUnits: 47 },
        { date: "2021-11-13", totalSales: 39, totalUnits: 35 },
        { date: "2021-11-14", totalSales: 55, totalUnits: 38 },
        { date: "2021-11-15", totalSales: 31, totalUnits: 48 },
        { date: "2021-11-16", totalSales: 46, totalUnits: 19 },
        { date: "2021-11-17", totalSales: 52, totalUnits: 37 },
      ],
    },
    {
      _id: "6371259ef03239d40b0000d6",
      productId: "63701d24f032390a34000329",
      yearlySalesTotal: 6371,
      yearlyTotalSoldUnits: 68,
      monthlyData: [
        { month: "january", totalSales: 213, totalUnits: 431 },
        { month: "february", totalSales: 162, totalUnits: 361 },
        { month: "march", totalSales: 208, totalUnits: 289 },
        { month: "april", totalSales: 725, totalUnits: 180 },
        { month: "may", totalSales: 923, totalUnits: 345 },
        { month: "june", totalSales: 492, totalUnits: 322 },
        { month: "july", totalSales: 380, totalUnits: 190 },
        { month: "august", totalSales: 303, totalUnits: 15 },
        { month: "september", totalSales: 165, totalUnits: 39 },
        { month: "october", totalSales: 240, totalUnits: 354 },
        { month: "november", totalSales: 17, totalUnits: 411 },
        { month: "december", totalSales: 478, totalUnits: 146 },
      ],
      dailyData: [
        { date: "2021-01-02", totalSales: 72, totalUnits: 42 },
        { date: "2021-01-03", totalSales: 84, totalUnits: 16 },
        { date: "2021-01-04", totalSales: 22, totalUnits: 17 },
        { date: "2021-01-05", totalSales: 87, totalUnits: 6 },
        { date: "2021-01-06", totalSales: 84, totalUnits: 17 },
        { date: "2021-01-07", totalSales: 66, totalUnits: 25 },
        { date: "2021-01-08", totalSales: 22, totalUnits: 25 },
        { date: "2021-01-09", totalSales: 63, totalUnits: 24 },
        { date: "2021-01-10", totalSales: 52, totalUnits: 47 },
        { date: "2021-01-11", totalSales: 65, totalUnits: 20 },
        { date: "2021-01-12", totalSales: 88, totalUnits: 27 },
        { date: "2021-01-13", totalSales: 26, totalUnits: 36 },
        { date: "2021-01-14", totalSales: 49, totalUnits: 12 },
        { date: "2021-01-15", totalSales: 99, totalUnits: 12 },
        { date: "2021-01-16", totalSales: 57, totalUnits: 43 },
        { date: "2021-01-17", totalSales: 38, totalUnits: 12 },
        { date: "2021-01-18", totalSales: 56, totalUnits: 20 },
        { date: "2021-01-19", totalSales: 15, totalUnits: 4 },
        { date: "2021-01-20", totalSales: 8, totalUnits: 2 },
        { date: "2021-01-21", totalSales: 54, totalUnits: 26 },
        { date: "2021-01-22", totalSales: 96, totalUnits: 25 },
        { date: "2021-01-23", totalSales: 86, totalUnits: 2 },
        { date: "2021-01-24", totalSales: 13, totalUnits: 28 },
        { date: "2021-01-25", totalSales: 79, totalUnits: 21 },
        { date: "2021-01-26", totalSales: 90, totalUnits: 48 },
        { date: "2021-01-27", totalSales: 36, totalUnits: 16 },
        { date: "2021-01-28", totalSales: 100, totalUnits: 40 },
        { date: "2021-01-29", totalSales: 22, totalUnits: 7 },
        { date: "2021-01-30", totalSales: 44, totalUnits: 25 },
        { date: "2021-01-31", totalSales: 32, totalUnits: 18 },
        { date: "2021-02-01", totalSales: 23, totalUnits: 9 },
        { date: "2021-02-02", totalSales: 29, totalUnits: 6 },
        { date: "2021-02-03", totalSales: 56, totalUnits: 29 },
        { date: "2021-02-04", totalSales: 31, totalUnits: 33 },
        { date: "2021-02-05", totalSales: 11, totalUnits: 39 },
        { date: "2021-02-06", totalSales: 27, totalUnits: 22 },
        { date: "2021-02-07", totalSales: 44, totalUnits: 39 },
        { date: "2021-02-08", totalSales: 68, totalUnits: 45 },
        { date: "2021-02-09", totalSales: 2, totalUnits: 49 },
        { date: "2021-02-10", totalSales: 58, totalUnits: 47 },
        { date: "2021-02-11", totalSales: 97, totalUnits: 8 },
        { date: "2021-02-12", totalSales: 23, totalUnits: 47 },
        { date: "2021-02-13", totalSales: 29, totalUnits: 1 },
        { date: "2021-02-14", totalSales: 50, totalUnits: 13 },
        { date: "2021-02-15", totalSales: 57, totalUnits: 3 },
        { date: "2021-02-16", totalSales: 10, totalUnits: 26 },
        { date: "2021-02-17", totalSales: 25, totalUnits: 29 },
        { date: "2021-02-18", totalSales: 82, totalUnits: 10 },
        { date: "2021-02-19", totalSales: 64, totalUnits: 29 },
        { date: "2021-02-20", totalSales: 96, totalUnits: 33 },
        { date: "2021-02-21", totalSales: 61, totalUnits: 3 },
        { date: "2021-02-22", totalSales: 92, totalUnits: 17 },
        { date: "2021-02-23", totalSales: 89, totalUnits: 16 },
        { date: "2021-02-24", totalSales: 93, totalUnits: 25 },
        { date: "2021-02-25", totalSales: 26, totalUnits: 8 },
        { date: "2021-02-26", totalSales: 38, totalUnits: 43 },
        { date: "2021-02-27", totalSales: 22, totalUnits: 6 },
        { date: "2021-02-28", totalSales: 81, totalUnits: 32 },
        { date: "2021-03-01", totalSales: 61, totalUnits: 12 },
        { date: "2021-03-02", totalSales: 95, totalUnits: 35 },
        { date: "2021-03-03", totalSales: 15, totalUnits: 39 },
        { date: "2021-03-04", totalSales: 23, totalUnits: 45 },
        { date: "2021-03-05", totalSales: 28, totalUnits: 41 },
        { date: "2021-03-06", totalSales: 21, totalUnits: 20 },
        { date: "2021-03-07", totalSales: 96, totalUnits: 26 },
        { date: "2021-03-08", totalSales: 72, totalUnits: 46 },
        { date: "2021-03-09", totalSales: 1, totalUnits: 47 },
        { date: "2021-03-10", totalSales: 54, totalUnits: 16 },
        { date: "2021-03-11", totalSales: 81, totalUnits: 13 },
        { date: "2021-03-12", totalSales: 53, totalUnits: 18 },
        { date: "2021-03-13", totalSales: 29, totalUnits: 45 },
        { date: "2021-03-14", totalSales: 19, totalUnits: 11 },
        { date: "2021-03-15", totalSales: 42, totalUnits: 15 },
        { date: "2021-03-16", totalSales: 43, totalUnits: 48 },
        { date: "2021-03-17", totalSales: 87, totalUnits: 21 },
        { date: "2021-03-18", totalSales: 79, totalUnits: 2 },
        { date: "2021-03-19", totalSales: 74, totalUnits: 39 },
        { date: "2021-03-20", totalSales: 17, totalUnits: 21 },
        { date: "2021-03-21", totalSales: 72, totalUnits: 15 },
        { date: "2021-03-22", totalSales: 36, totalUnits: 3 },
        { date: "2021-03-23", totalSales: 81, totalUnits: 35 },
        { date: "2021-03-24", totalSales: 57, totalUnits: 20 },
        { date: "2021-03-25", totalSales: 45, totalUnits: 26 },
        { date: "2021-03-26", totalSales: 6, totalUnits: 45 },
        { date: "2021-03-27", totalSales: 99, totalUnits: 2 },
        { date: "2021-03-28", totalSales: 80, totalUnits: 40 },
        { date: "2021-03-29", totalSales: 14, totalUnits: 28 },
        { date: "2021-03-30", totalSales: 92, totalUnits: 40 },
        { date: "2021-03-31", totalSales: 75, totalUnits: 26 },
        { date: "2021-04-01", totalSales: 15, totalUnits: 20 },
        { date: "2021-04-02", totalSales: 5, totalUnits: 14 },
        { date: "2021-04-03", totalSales: 67, totalUnits: 6 },
        { date: "2021-04-04", totalSales: 4, totalUnits: 32 },
        { date: "2021-04-05", totalSales: 42, totalUnits: 34 },
        { date: "2021-04-06", totalSales: 78, totalUnits: 49 },
        { date: "2021-04-07", totalSales: 65, totalUnits: 28 },
        { date: "2021-04-08", totalSales: 57, totalUnits: 15 },
        { date: "2021-04-09", totalSales: 15, totalUnits: 8 },
        { date: "2021-04-10", totalSales: 36, totalUnits: 6 },
        { date: "2021-04-11", totalSales: 33, totalUnits: 1 },
        { date: "2021-04-12", totalSales: 72, totalUnits: 17 },
        { date: "2021-04-13", totalSales: 37, totalUnits: 30 },
        { date: "2021-04-14", totalSales: 43, totalUnits: 43 },
        { date: "2021-04-15", totalSales: 20, totalUnits: 8 },
        { date: "2021-04-16", totalSales: 33, totalUnits: 18 },
        { date: "2021-04-17", totalSales: 36, totalUnits: 34 },
        { date: "2021-04-18", totalSales: 27, totalUnits: 24 },
        { date: "2021-04-19", totalSales: 50, totalUnits: 11 },
        { date: "2021-04-20", totalSales: 59, totalUnits: 45 },
        { date: "2021-04-21", totalSales: 39, totalUnits: 40 },
        { date: "2021-04-22", totalSales: 58, totalUnits: 27 },
        { date: "2021-04-23", totalSales: 24, totalUnits: 39 },
        { date: "2021-04-24", totalSales: 78, totalUnits: 40 },
        { date: "2021-04-25", totalSales: 56, totalUnits: 3 },
        { date: "2021-04-26", totalSales: 83, totalUnits: 40 },
        { date: "2021-04-27", totalSales: 19, totalUnits: 35 },
        { date: "2021-04-28", totalSales: 98, totalUnits: 47 },
        { date: "2021-04-29", totalSales: 25, totalUnits: 45 },
        { date: "2021-04-30", totalSales: 29, totalUnits: 12 },
        { date: "2021-05-01", totalSales: 62, totalUnits: 24 },
        { date: "2021-05-02", totalSales: 4, totalUnits: 10 },
        { date: "2021-05-03", totalSales: 78, totalUnits: 47 },
        { date: "2021-05-04", totalSales: 19, totalUnits: 43 },
        { date: "2021-05-05", totalSales: 9, totalUnits: 8 },
        { date: "2021-05-06", totalSales: 40, totalUnits: 13 },
        { date: "2021-05-07", totalSales: 91, totalUnits: 22 },
        { date: "2021-05-08", totalSales: 64, totalUnits: 48 },
        { date: "2021-05-09", totalSales: 59, totalUnits: 12 },
        { date: "2021-05-10", totalSales: 46, totalUnits: 1 },
        { date: "2021-05-11", totalSales: 87, totalUnits: 8 },
        { date: "2021-05-12", totalSales: 87, totalUnits: 16 },
        { date: "2021-05-13", totalSales: 95, totalUnits: 8 },
        { date: "2021-05-14", totalSales: 47, totalUnits: 46 },
        { date: "2021-05-15", totalSales: 69, totalUnits: 44 },
        { date: "2021-05-16", totalSales: 52, totalUnits: 17 },
        { date: "2021-05-17", totalSales: 36, totalUnits: 49 },
        { date: "2021-05-18", totalSales: 33, totalUnits: 5 },
        { date: "2021-05-19", totalSales: 46, totalUnits: 22 },
        { date: "2021-05-20", totalSales: 13, totalUnits: 23 },
        { date: "2021-05-21", totalSales: 46, totalUnits: 19 },
        { date: "2021-05-22", totalSales: 17, totalUnits: 11 },
        { date: "2021-05-23", totalSales: 71, totalUnits: 23 },
        { date: "2021-05-24", totalSales: 23, totalUnits: 16 },
        { date: "2021-05-25", totalSales: 71, totalUnits: 41 },
        { date: "2021-05-26", totalSales: 65, totalUnits: 14 },
        { date: "2021-05-27", totalSales: 30, totalUnits: 30 },
        { date: "2021-05-28", totalSales: 75, totalUnits: 30 },
        { date: "2021-05-29", totalSales: 37, totalUnits: 27 },
        { date: "2021-05-30", totalSales: 56, totalUnits: 41 },
        { date: "2021-05-31", totalSales: 75, totalUnits: 34 },
        { date: "2021-06-01", totalSales: 60, totalUnits: 34 },
        { date: "2021-06-02", totalSales: 90, totalUnits: 37 },
        { date: "2021-06-03", totalSales: 35, totalUnits: 37 },
        { date: "2021-06-04", totalSales: 50, totalUnits: 42 },
        { date: "2021-06-05", totalSales: 12, totalUnits: 2 },
        { date: "2021-06-06", totalSales: 16, totalUnits: 21 },
        { date: "2021-06-07", totalSales: 97, totalUnits: 7 },
        { date: "2021-06-08", totalSales: 47, totalUnits: 18 },
        { date: "2021-06-09", totalSales: 99, totalUnits: 16 },
        { date: "2021-06-10", totalSales: 39, totalUnits: 6 },
        { date: "2021-06-11", totalSales: 60, totalUnits: 48 },
        { date: "2021-06-12", totalSales: 70, totalUnits: 1 },
        { date: "2021-06-13", totalSales: 46, totalUnits: 45 },
        { date: "2021-06-14", totalSales: 51, totalUnits: 20 },
        { date: "2021-06-15", totalSales: 10, totalUnits: 8 },
        { date: "2021-06-16", totalSales: 48, totalUnits: 6 },
        { date: "2021-06-17", totalSales: 8, totalUnits: 35 },
        { date: "2021-06-18", totalSales: 15, totalUnits: 41 },
        { date: "2021-06-19", totalSales: 89, totalUnits: 24 },
        { date: "2021-06-20", totalSales: 39, totalUnits: 6 },
        { date: "2021-06-21", totalSales: 95, totalUnits: 2 },
        { date: "2021-06-22", totalSales: 74, totalUnits: 42 },
        { date: "2021-06-23", totalSales: 71, totalUnits: 7 },
        { date: "2021-06-24", totalSales: 100, totalUnits: 37 },
        { date: "2021-06-25", totalSales: 81, totalUnits: 41 },
        { date: "2021-06-26", totalSales: 68, totalUnits: 43 },
        { date: "2021-06-27", totalSales: 17, totalUnits: 21 },
        { date: "2021-06-28", totalSales: 18, totalUnits: 1 },
        { date: "2021-06-29", totalSales: 52, totalUnits: 25 },
        { date: "2021-06-30", totalSales: 21, totalUnits: 47 },
        { date: "2021-07-01", totalSales: 42, totalUnits: 23 },
        { date: "2021-07-02", totalSales: 74, totalUnits: 32 },
        { date: "2021-07-03", totalSales: 3, totalUnits: 33 },
        { date: "2021-07-04", totalSales: 87, totalUnits: 46 },
        { date: "2021-07-05", totalSales: 67, totalUnits: 27 },
        { date: "2021-07-06", totalSales: 68, totalUnits: 41 },
        { date: "2021-07-07", totalSales: 36, totalUnits: 1 },
        { date: "2021-07-08", totalSales: 61, totalUnits: 35 },
        { date: "2021-07-09", totalSales: 78, totalUnits: 46 },
        { date: "2021-07-10", totalSales: 75, totalUnits: 11 },
        { date: "2021-07-11", totalSales: 51, totalUnits: 13 },
        { date: "2021-07-12", totalSales: 76, totalUnits: 5 },
        { date: "2021-07-13", totalSales: 96, totalUnits: 20 },
        { date: "2021-07-14", totalSales: 18, totalUnits: 31 },
        { date: "2021-07-15", totalSales: 61, totalUnits: 43 },
        { date: "2021-07-16", totalSales: 61, totalUnits: 36 },
        { date: "2021-07-17", totalSales: 30, totalUnits: 26 },
        { date: "2021-07-18", totalSales: 50, totalUnits: 47 },
        { date: "2021-07-19", totalSales: 49, totalUnits: 30 },
        { date: "2021-07-20", totalSales: 8, totalUnits: 4 },
        { date: "2021-07-21", totalSales: 79, totalUnits: 17 },
        { date: "2021-07-22", totalSales: 31, totalUnits: 18 },
        { date: "2021-07-23", totalSales: 70, totalUnits: 31 },
        { date: "2021-07-24", totalSales: 83, totalUnits: 37 },
        { date: "2021-07-25", totalSales: 58, totalUnits: 42 },
        { date: "2021-07-26", totalSales: 34, totalUnits: 30 },
        { date: "2021-07-27", totalSales: 94, totalUnits: 13 },
        { date: "2021-07-28", totalSales: 70, totalUnits: 40 },
        { date: "2021-07-29", totalSales: 64, totalUnits: 25 },
        { date: "2021-07-30", totalSales: 44, totalUnits: 41 },
        { date: "2021-07-31", totalSales: 53, totalUnits: 45 },
        { date: "2021-08-01", totalSales: 72, totalUnits: 25 },
        { date: "2021-08-02", totalSales: 42, totalUnits: 31 },
        { date: "2021-08-03", totalSales: 41, totalUnits: 6 },
        { date: "2021-08-04", totalSales: 15, totalUnits: 13 },
        { date: "2021-08-05", totalSales: 16, totalUnits: 32 },
        { date: "2021-08-06", totalSales: 81, totalUnits: 18 },
        { date: "2021-08-07", totalSales: 94, totalUnits: 44 },
        { date: "2021-08-08", totalSales: 74, totalUnits: 15 },
        { date: "2021-08-09", totalSales: 39, totalUnits: 10 },
        { date: "2021-08-10", totalSales: 98, totalUnits: 19 },
        { date: "2021-08-11", totalSales: 24, totalUnits: 31 },
        { date: "2021-08-12", totalSales: 7, totalUnits: 5 },
        { date: "2021-08-13", totalSales: 14, totalUnits: 23 },
        { date: "2021-08-14", totalSales: 62, totalUnits: 31 },
        { date: "2021-08-15", totalSales: 43, totalUnits: 21 },
        { date: "2021-08-16", totalSales: 37, totalUnits: 26 },
        { date: "2021-08-17", totalSales: 52, totalUnits: 32 },
        { date: "2021-08-18", totalSales: 38, totalUnits: 19 },
        { date: "2021-08-19", totalSales: 87, totalUnits: 36 },
        { date: "2021-08-20", totalSales: 46, totalUnits: 25 },
        { date: "2021-08-21", totalSales: 64, totalUnits: 31 },
        { date: "2021-08-22", totalSales: 57, totalUnits: 11 },
        { date: "2021-08-23", totalSales: 77, totalUnits: 42 },
        { date: "2021-08-24", totalSales: 5, totalUnits: 10 },
        { date: "2021-08-25", totalSales: 5, totalUnits: 49 },
        { date: "2021-08-26", totalSales: 89, totalUnits: 10 },
        { date: "2021-08-27", totalSales: 61, totalUnits: 20 },
        { date: "2021-08-28", totalSales: 61, totalUnits: 21 },
        { date: "2021-08-29", totalSales: 32, totalUnits: 5 },
        { date: "2021-08-30", totalSales: 86, totalUnits: 7 },
        { date: "2021-08-31", totalSales: 74, totalUnits: 17 },
        { date: "2021-09-01", totalSales: 93, totalUnits: 46 },
        { date: "2021-09-02", totalSales: 28, totalUnits: 5 },
        { date: "2021-09-03", totalSales: 40, totalUnits: 49 },
        { date: "2021-09-04", totalSales: 49, totalUnits: 7 },
        { date: "2021-09-05", totalSales: 41, totalUnits: 32 },
        { date: "2021-09-06", totalSales: 25, totalUnits: 37 },
        { date: "2021-09-07", totalSales: 93, totalUnits: 5 },
        { date: "2021-09-08", totalSales: 58, totalUnits: 33 },
        { date: "2021-09-09", totalSales: 48, totalUnits: 35 },
        { date: "2021-09-10", totalSales: 47, totalUnits: 23 },
        { date: "2021-09-11", totalSales: 87, totalUnits: 9 },
        { date: "2021-09-12", totalSales: 88, totalUnits: 31 },
        { date: "2021-09-13", totalSales: 33, totalUnits: 50 },
        { date: "2021-09-14", totalSales: 81, totalUnits: 10 },
        { date: "2021-09-15", totalSales: 28, totalUnits: 6 },
        { date: "2021-09-16", totalSales: 25, totalUnits: 10 },
        { date: "2021-09-17", totalSales: 7, totalUnits: 9 },
        { date: "2021-09-18", totalSales: 3, totalUnits: 19 },
        { date: "2021-09-19", totalSales: 95, totalUnits: 47 },
        { date: "2021-09-20", totalSales: 96, totalUnits: 45 },
        { date: "2021-09-21", totalSales: 99, totalUnits: 35 },
        { date: "2021-09-22", totalSales: 71, totalUnits: 24 },
        { date: "2021-09-23", totalSales: 83, totalUnits: 4 },
        { date: "2021-09-24", totalSales: 28, totalUnits: 1 },
        { date: "2021-09-25", totalSales: 88, totalUnits: 38 },
        { date: "2021-09-26", totalSales: 41, totalUnits: 19 },
        { date: "2021-09-27", totalSales: 39, totalUnits: 8 },
        { date: "2021-09-28", totalSales: 19, totalUnits: 26 },
        { date: "2021-09-29", totalSales: 48, totalUnits: 35 },
        { date: "2021-09-30", totalSales: 70, totalUnits: 3 },
        { date: "2021-10-01", totalSales: 97, totalUnits: 4 },
        { date: "2021-10-02", totalSales: 41, totalUnits: 35 },
        { date: "2021-10-03", totalSales: 16, totalUnits: 39 },
        { date: "2021-10-04", totalSales: 80, totalUnits: 26 },
        { date: "2021-10-05", totalSales: 20, totalUnits: 23 },
        { date: "2021-10-06", totalSales: 31, totalUnits: 8 },
        { date: "2021-10-07", totalSales: 91, totalUnits: 26 },
        { date: "2021-10-08", totalSales: 57, totalUnits: 10 },
        { date: "2021-10-09", totalSales: 61, totalUnits: 46 },
        { date: "2021-10-10", totalSales: 79, totalUnits: 10 },
        { date: "2021-10-11", totalSales: 46, totalUnits: 41 },
        { date: "2021-10-12", totalSales: 59, totalUnits: 31 },
        { date: "2021-10-13", totalSales: 47, totalUnits: 21 },
        { date: "2021-10-14", totalSales: 22, totalUnits: 4 },
        { date: "2021-10-15", totalSales: 14, totalUnits: 25 },
        { date: "2021-10-16", totalSales: 27, totalUnits: 32 },
        { date: "2021-10-17", totalSales: 9, totalUnits: 48 },
        { date: "2021-10-18", totalSales: 83, totalUnits: 44 },
        { date: "2021-10-19", totalSales: 67, totalUnits: 44 },
        { date: "2021-10-20", totalSales: 89, totalUnits: 23 },
        { date: "2021-10-21", totalSales: 20, totalUnits: 15 },
        { date: "2021-10-22", totalSales: 37, totalUnits: 33 },
        { date: "2021-10-23", totalSales: 77, totalUnits: 24 },
        { date: "2021-10-24", totalSales: 30, totalUnits: 4 },
        { date: "2021-10-25", totalSales: 36, totalUnits: 45 },
        { date: "2021-10-26", totalSales: 58, totalUnits: 47 },
        { date: "2021-10-27", totalSales: 52, totalUnits: 42 },
        { date: "2021-10-28", totalSales: 58, totalUnits: 39 },
        { date: "2021-10-29", totalSales: 17, totalUnits: 37 },
        { date: "2021-10-30", totalSales: 31, totalUnits: 46 },
        { date: "2021-10-31", totalSales: 49, totalUnits: 20 },
        { date: "2021-11-01", totalSales: 75, totalUnits: 48 },
        { date: "2021-11-02", totalSales: 51, totalUnits: 36 },
        { date: "2021-11-03", totalSales: 46, totalUnits: 8 },
        { date: "2021-11-04", totalSales: 61, totalUnits: 26 },
        { date: "2021-11-05", totalSales: 11, totalUnits: 3 },
        { date: "2021-11-06", totalSales: 19, totalUnits: 21 },
        { date: "2021-11-07", totalSales: 90, totalUnits: 16 },
        { date: "2021-11-08", totalSales: 38, totalUnits: 36 },
        { date: "2021-11-09", totalSales: 54, totalUnits: 49 },
        { date: "2021-11-10", totalSales: 21, totalUnits: 49 },
        { date: "2021-11-11", totalSales: 48, totalUnits: 42 },
        { date: "2021-11-12", totalSales: 34, totalUnits: 8 },
        { date: "2021-11-13", totalSales: 95, totalUnits: 27 },
        { date: "2021-11-14", totalSales: 92, totalUnits: 16 },
        { date: "2021-11-15", totalSales: 93, totalUnits: 39 },
        { date: "2021-11-16", totalSales: 64, totalUnits: 30 },
        { date: "2021-11-17", totalSales: 97, totalUnits: 37 },
      ],
    },
    {
      _id: "6371259ef03239d40b0000d7",
      productId: "63701d24f032390a3400032a",
      yearlySalesTotal: 6612,
      yearlyTotalSoldUnits: 2642,
      monthlyData: [
        { month: "january", totalSales: 173, totalUnits: 340 },
        { month: "february", totalSales: 996, totalUnits: 188 },
        { month: "march", totalSales: 442, totalUnits: 74 },
        { month: "april", totalSales: 387, totalUnits: 281 },
        { month: "may", totalSales: 256, totalUnits: 257 },
        { month: "june", totalSales: 799, totalUnits: 270 },
        { month: "july", totalSales: 594, totalUnits: 58 },
        { month: "august", totalSales: 207, totalUnits: 181 },
        { month: "september", totalSales: 147, totalUnits: 236 },
        { month: "october", totalSales: 681, totalUnits: 99 },
        { month: "november", totalSales: 272, totalUnits: 157 },
        { month: "december", totalSales: 880, totalUnits: 303 },
      ],
      dailyData: [
        { date: "2021-01-02", totalSales: 67, totalUnits: 33 },
        { date: "2021-01-03", totalSales: 60, totalUnits: 30 },
        { date: "2021-01-04", totalSales: 98, totalUnits: 31 },
        { date: "2021-01-05", totalSales: 55, totalUnits: 26 },
        { date: "2021-01-06", totalSales: 3, totalUnits: 13 },
        { date: "2021-01-07", totalSales: 51, totalUnits: 30 },
        { date: "2021-01-08", totalSales: 89, totalUnits: 31 },
        { date: "2021-01-09", totalSales: 93, totalUnits: 13 },
        { date: "2021-01-10", totalSales: 56, totalUnits: 12 },
        { date: "2021-01-11", totalSales: 94, totalUnits: 38 },
        { date: "2021-01-12", totalSales: 14, totalUnits: 8 },
        { date: "2021-01-13", totalSales: 75, totalUnits: 35 },
        { date: "2021-01-14", totalSales: 19, totalUnits: 28 },
        { date: "2021-01-15", totalSales: 23, totalUnits: 31 },
        { date: "2021-01-16", totalSales: 89, totalUnits: 19 },
        { date: "2021-01-17", totalSales: 20, totalUnits: 25 },
        { date: "2021-01-18", totalSales: 35, totalUnits: 11 },
        { date: "2021-01-19", totalSales: 42, totalUnits: 3 },
        { date: "2021-01-20", totalSales: 55, totalUnits: 49 },
        { date: "2021-01-21", totalSales: 81, totalUnits: 30 },
        { date: "2021-01-22", totalSales: 61, totalUnits: 34 },
        { date: "2021-01-23", totalSales: 18, totalUnits: 6 },
        { date: "2021-01-24", totalSales: 17, totalUnits: 9 },
        { date: "2021-01-25", totalSales: 48, totalUnits: 35 },
        { date: "2021-01-26", totalSales: 97, totalUnits: 5 },
        { date: "2021-01-27", totalSales: 65, totalUnits: 37 },
        { date: "2021-01-28", totalSales: 95, totalUnits: 26 },
        { date: "2021-01-29", totalSales: 10, totalUnits: 2 },
        { date: "2021-01-30", totalSales: 15, totalUnits: 18 },
        { date: "2021-01-31", totalSales: 75, totalUnits: 10 },
        { date: "2021-02-01", totalSales: 46, totalUnits: 17 },
        { date: "2021-02-02", totalSales: 81, totalUnits: 37 },
        { date: "2021-02-03", totalSales: 86, totalUnits: 21 },
        { date: "2021-02-04", totalSales: 69, totalUnits: 2 },
        { date: "2021-02-05", totalSales: 81, totalUnits: 28 },
        { date: "2021-02-06", totalSales: 55, totalUnits: 4 },
        { date: "2021-02-07", totalSales: 87, totalUnits: 9 },
        { date: "2021-02-08", totalSales: 15, totalUnits: 20 },
        { date: "2021-02-09", totalSales: 36, totalUnits: 33 },
        { date: "2021-02-10", totalSales: 65, totalUnits: 12 },
        { date: "2021-02-11", totalSales: 89, totalUnits: 8 },
        { date: "2021-02-12", totalSales: 37, totalUnits: 48 },
        { date: "2021-02-13", totalSales: 59, totalUnits: 39 },
        { date: "2021-02-14", totalSales: 71, totalUnits: 2 },
        { date: "2021-02-15", totalSales: 13, totalUnits: 40 },
        { date: "2021-02-16", totalSales: 27, totalUnits: 20 },
        { date: "2021-02-17", totalSales: 13, totalUnits: 42 },
        { date: "2021-02-18", totalSales: 35, totalUnits: 20 },
        { date: "2021-02-19", totalSales: 83, totalUnits: 10 },
        { date: "2021-02-20", totalSales: 58, totalUnits: 36 },
        { date: "2021-02-21", totalSales: 38, totalUnits: 24 },
        { date: "2021-02-22", totalSales: 58, totalUnits: 31 },
        { date: "2021-02-23", totalSales: 42, totalUnits: 1 },
        { date: "2021-02-24", totalSales: 59, totalUnits: 17 },
        { date: "2021-02-25", totalSales: 42, totalUnits: 36 },
        { date: "2021-02-26", totalSales: 23, totalUnits: 42 },
        { date: "2021-02-27", totalSales: 81, totalUnits: 48 },
        { date: "2021-02-28", totalSales: 65, totalUnits: 4 },
        { date: "2021-03-01", totalSales: 100, totalUnits: 7 },
        { date: "2021-03-02", totalSales: 31, totalUnits: 43 },
        { date: "2021-03-03", totalSales: 87, totalUnits: 21 },
        { date: "2021-03-04", totalSales: 83, totalUnits: 26 },
        { date: "2021-03-05", totalSales: 16, totalUnits: 9 },
        { date: "2021-03-06", totalSales: 72, totalUnits: 29 },
        { date: "2021-03-07", totalSales: 43, totalUnits: 9 },
        { date: "2021-03-08", totalSales: 1, totalUnits: 14 },
        { date: "2021-03-09", totalSales: 24, totalUnits: 23 },
        { date: "2021-03-10", totalSales: 23, totalUnits: 15 },
        { date: "2021-03-11", totalSales: 38, totalUnits: 18 },
        { date: "2021-03-12", totalSales: 22, totalUnits: 38 },
        { date: "2021-03-13", totalSales: 35, totalUnits: 14 },
        { date: "2021-03-14", totalSales: 39, totalUnits: 36 },
        { date: "2021-03-15", totalSales: 89, totalUnits: 38 },
        { date: "2021-03-16", totalSales: 77, totalUnits: 17 },
        { date: "2021-03-17", totalSales: 41, totalUnits: 3 },
        { date: "2021-03-18", totalSales: 12, totalUnits: 16 },
        { date: "2021-03-19", totalSales: 48, totalUnits: 31 },
        { date: "2021-03-20", totalSales: 16, totalUnits: 3 },
        { date: "2021-03-21", totalSales: 5, totalUnits: 5 },
        { date: "2021-03-22", totalSales: 83, totalUnits: 41 },
        { date: "2021-03-23", totalSales: 57, totalUnits: 43 },
        { date: "2021-03-24", totalSales: 64, totalUnits: 22 },
        { date: "2021-03-25", totalSales: 14, totalUnits: 1 },
        { date: "2021-03-26", totalSales: 15, totalUnits: 44 },
        { date: "2021-03-27", totalSales: 17, totalUnits: 27 },
        { date: "2021-03-28", totalSales: 72, totalUnits: 12 },
        { date: "2021-03-29", totalSales: 23, totalUnits: 11 },
        { date: "2021-03-30", totalSales: 66, totalUnits: 13 },
        { date: "2021-03-31", totalSales: 61, totalUnits: 20 },
        { date: "2021-04-01", totalSales: 40, totalUnits: 13 },
        { date: "2021-04-02", totalSales: 12, totalUnits: 24 },
        { date: "2021-04-03", totalSales: 79, totalUnits: 46 },
        { date: "2021-04-04", totalSales: 86, totalUnits: 39 },
        { date: "2021-04-05", totalSales: 23, totalUnits: 36 },
        { date: "2021-04-06", totalSales: 61, totalUnits: 25 },
        { date: "2021-04-07", totalSales: 65, totalUnits: 13 },
        { date: "2021-04-08", totalSales: 20, totalUnits: 33 },
        { date: "2021-04-09", totalSales: 54, totalUnits: 37 },
        { date: "2021-04-10", totalSales: 22, totalUnits: 46 },
        { date: "2021-04-11", totalSales: 62, totalUnits: 48 },
        { date: "2021-04-12", totalSales: 7, totalUnits: 41 },
        { date: "2021-04-13", totalSales: 64, totalUnits: 45 },
        { date: "2021-04-14", totalSales: 4, totalUnits: 12 },
        { date: "2021-04-15", totalSales: 91, totalUnits: 9 },
        { date: "2021-04-16", totalSales: 75, totalUnits: 47 },
        { date: "2021-04-17", totalSales: 78, totalUnits: 45 },
        { date: "2021-04-18", totalSales: 58, totalUnits: 46 },
        { date: "2021-04-19", totalSales: 43, totalUnits: 10 },
        { date: "2021-04-20", totalSales: 76, totalUnits: 34 },
        { date: "2021-04-21", totalSales: 67, totalUnits: 9 },
        { date: "2021-04-22", totalSales: 4, totalUnits: 18 },
        { date: "2021-04-23", totalSales: 65, totalUnits: 34 },
        { date: "2021-04-24", totalSales: 94, totalUnits: 42 },
        { date: "2021-04-25", totalSales: 4, totalUnits: 35 },
        { date: "2021-04-26", totalSales: 90, totalUnits: 40 },
        { date: "2021-04-27", totalSales: 14, totalUnits: 39 },
        { date: "2021-04-28", totalSales: 87, totalUnits: 47 },
        { date: "2021-04-29", totalSales: 60, totalUnits: 13 },
        { date: "2021-04-30", totalSales: 21, totalUnits: 13 },
        { date: "2021-05-01", totalSales: 21, totalUnits: 5 },
        { date: "2021-05-02", totalSales: 3, totalUnits: 38 },
        { date: "2021-05-03", totalSales: 97, totalUnits: 35 },
        { date: "2021-05-04", totalSales: 98, totalUnits: 18 },
        { date: "2021-05-05", totalSales: 8, totalUnits: 43 },
        { date: "2021-05-06", totalSales: 33, totalUnits: 38 },
        { date: "2021-05-07", totalSales: 76, totalUnits: 29 },
        { date: "2021-05-08", totalSales: 47, totalUnits: 43 },
        { date: "2021-05-09", totalSales: 92, totalUnits: 13 },
        { date: "2021-05-10", totalSales: 68, totalUnits: 16 },
        { date: "2021-05-11", totalSales: 49, totalUnits: 21 },
        { date: "2021-05-12", totalSales: 9, totalUnits: 8 },
        { date: "2021-05-13", totalSales: 99, totalUnits: 6 },
        { date: "2021-05-14", totalSales: 51, totalUnits: 37 },
        { date: "2021-05-15", totalSales: 84, totalUnits: 21 },
        { date: "2021-05-16", totalSales: 47, totalUnits: 39 },
        { date: "2021-05-17", totalSales: 16, totalUnits: 7 },
        { date: "2021-05-18", totalSales: 20, totalUnits: 47 },
        { date: "2021-05-19", totalSales: 14, totalUnits: 11 },
        { date: "2021-05-20", totalSales: 1, totalUnits: 20 },
        { date: "2021-05-21", totalSales: 75, totalUnits: 26 },
        { date: "2021-05-22", totalSales: 46, totalUnits: 1 },
        { date: "2021-05-23", totalSales: 56, totalUnits: 29 },
        { date: "2021-05-24", totalSales: 52, totalUnits: 28 },
        { date: "2021-05-25", totalSales: 88, totalUnits: 17 },
        { date: "2021-05-26", totalSales: 62, totalUnits: 11 },
        { date: "2021-05-27", totalSales: 55, totalUnits: 33 },
        { date: "2021-05-28", totalSales: 69, totalUnits: 13 },
        { date: "2021-05-29", totalSales: 33, totalUnits: 22 },
        { date: "2021-05-30", totalSales: 83, totalUnits: 23 },
        { date: "2021-05-31", totalSales: 86, totalUnits: 33 },
        { date: "2021-06-01", totalSales: 94, totalUnits: 40 },
        { date: "2021-06-02", totalSales: 78, totalUnits: 40 },
        { date: "2021-06-03", totalSales: 68, totalUnits: 40 },
        { date: "2021-06-04", totalSales: 31, totalUnits: 48 },
        { date: "2021-06-05", totalSales: 27, totalUnits: 11 },
        { date: "2021-06-06", totalSales: 96, totalUnits: 39 },
        { date: "2021-06-07", totalSales: 28, totalUnits: 17 },
        { date: "2021-06-08", totalSales: 96, totalUnits: 12 },
        { date: "2021-06-09", totalSales: 62, totalUnits: 7 },
        { date: "2021-06-10", totalSales: 54, totalUnits: 3 },
        { date: "2021-06-11", totalSales: 49, totalUnits: 10 },
        { date: "2021-06-12", totalSales: 48, totalUnits: 35 },
        { date: "2021-06-13", totalSales: 72, totalUnits: 48 },
        { date: "2021-06-14", totalSales: 88, totalUnits: 16 },
        { date: "2021-06-15", totalSales: 95, totalUnits: 49 },
        { date: "2021-06-16", totalSales: 18, totalUnits: 32 },
        { date: "2021-06-17", totalSales: 100, totalUnits: 20 },
        { date: "2021-06-18", totalSales: 35, totalUnits: 29 },
        { date: "2021-06-19", totalSales: 83, totalUnits: 5 },
        { date: "2021-06-20", totalSales: 93, totalUnits: 43 },
        { date: "2021-06-21", totalSales: 18, totalUnits: 50 },
        { date: "2021-06-22", totalSales: 81, totalUnits: 33 },
        { date: "2021-06-23", totalSales: 65, totalUnits: 42 },
        { date: "2021-06-24", totalSales: 94, totalUnits: 30 },
        { date: "2021-06-25", totalSales: 78, totalUnits: 17 },
        { date: "2021-06-26", totalSales: 81, totalUnits: 13 },
        { date: "2021-06-27", totalSales: 99, totalUnits: 10 },
        { date: "2021-06-28", totalSales: 39, totalUnits: 10 },
        { date: "2021-06-29", totalSales: 90, totalUnits: 31 },
        { date: "2021-06-30", totalSales: 76, totalUnits: 25 },
        { date: "2021-07-01", totalSales: 40, totalUnits: 8 },
        { date: "2021-07-02", totalSales: 98, totalUnits: 21 },
        { date: "2021-07-03", totalSales: 83, totalUnits: 35 },
        { date: "2021-07-04", totalSales: 27, totalUnits: 34 },
        { date: "2021-07-05", totalSales: 38, totalUnits: 45 },
        { date: "2021-07-06", totalSales: 5, totalUnits: 4 },
        { date: "2021-07-07", totalSales: 45, totalUnits: 23 },
        { date: "2021-07-08", totalSales: 1, totalUnits: 34 },
        { date: "2021-07-09", totalSales: 44, totalUnits: 33 },
        { date: "2021-07-10", totalSales: 94, totalUnits: 7 },
        { date: "2021-07-11", totalSales: 50, totalUnits: 44 },
        { date: "2021-07-12", totalSales: 83, totalUnits: 10 },
        { date: "2021-07-13", totalSales: 4, totalUnits: 6 },
        { date: "2021-07-14", totalSales: 5, totalUnits: 19 },
        { date: "2021-07-15", totalSales: 65, totalUnits: 35 },
        { date: "2021-07-16", totalSales: 43, totalUnits: 1 },
        { date: "2021-07-17", totalSales: 98, totalUnits: 38 },
        { date: "2021-07-18", totalSales: 65, totalUnits: 44 },
        { date: "2021-07-19", totalSales: 74, totalUnits: 14 },
        { date: "2021-07-20", totalSales: 31, totalUnits: 21 },
        { date: "2021-07-21", totalSales: 85, totalUnits: 40 },
        { date: "2021-07-22", totalSales: 94, totalUnits: 26 },
        { date: "2021-07-23", totalSales: 80, totalUnits: 34 },
        { date: "2021-07-24", totalSales: 68, totalUnits: 11 },
        { date: "2021-07-25", totalSales: 9, totalUnits: 30 },
        { date: "2021-07-26", totalSales: 67, totalUnits: 33 },
        { date: "2021-07-27", totalSales: 89, totalUnits: 2 },
        { date: "2021-07-28", totalSales: 66, totalUnits: 41 },
        { date: "2021-07-29", totalSales: 71, totalUnits: 38 },
        { date: "2021-07-30", totalSales: 44, totalUnits: 46 },
        { date: "2021-07-31", totalSales: 54, totalUnits: 13 },
        { date: "2021-08-01", totalSales: 97, totalUnits: 28 },
        { date: "2021-08-02", totalSales: 48, totalUnits: 33 },
        { date: "2021-08-03", totalSales: 68, totalUnits: 36 },
        { date: "2021-08-04", totalSales: 91, totalUnits: 30 },
        { date: "2021-08-05", totalSales: 100, totalUnits: 38 },
        { date: "2021-08-06", totalSales: 50, totalUnits: 18 },
        { date: "2021-08-07", totalSales: 56, totalUnits: 39 },
        { date: "2021-08-08", totalSales: 85, totalUnits: 27 },
        { date: "2021-08-09", totalSales: 82, totalUnits: 37 },
        { date: "2021-08-10", totalSales: 6, totalUnits: 14 },
        { date: "2021-08-11", totalSales: 31, totalUnits: 29 },
        { date: "2021-08-12", totalSales: 84, totalUnits: 38 },
        { date: "2021-08-13", totalSales: 96, totalUnits: 8 },
        { date: "2021-08-14", totalSales: 88, totalUnits: 27 },
        { date: "2021-08-15", totalSales: 26, totalUnits: 12 },
        { date: "2021-08-16", totalSales: 80, totalUnits: 43 },
        { date: "2021-08-17", totalSales: 77, totalUnits: 45 },
        { date: "2021-08-18", totalSales: 1, totalUnits: 22 },
        { date: "2021-08-19", totalSales: 78, totalUnits: 11 },
        { date: "2021-08-20", totalSales: 81, totalUnits: 50 },
        { date: "2021-08-21", totalSales: 40, totalUnits: 14 },
        { date: "2021-08-22", totalSales: 85, totalUnits: 47 },
        { date: "2021-08-23", totalSales: 58, totalUnits: 41 },
        { date: "2021-08-24", totalSales: 52, totalUnits: 8 },
        { date: "2021-08-25", totalSales: 22, totalUnits: 38 },
        { date: "2021-08-26", totalSales: 28, totalUnits: 31 },
        { date: "2021-08-27", totalSales: 44, totalUnits: 29 },
        { date: "2021-08-28", totalSales: 67, totalUnits: 32 },
        { date: "2021-08-29", totalSales: 15, totalUnits: 5 },
        { date: "2021-08-30", totalSales: 55, totalUnits: 20 },
        { date: "2021-08-31", totalSales: 93, totalUnits: 17 },
        { date: "2021-09-01", totalSales: 3, totalUnits: 48 },
        { date: "2021-09-02", totalSales: 30, totalUnits: 32 },
        { date: "2021-09-03", totalSales: 57, totalUnits: 31 },
        { date: "2021-09-04", totalSales: 68, totalUnits: 50 },
        { date: "2021-09-05", totalSales: 97, totalUnits: 47 },
        { date: "2021-09-06", totalSales: 52, totalUnits: 49 },
        { date: "2021-09-07", totalSales: 74, totalUnits: 41 },
        { date: "2021-09-08", totalSales: 36, totalUnits: 32 },
        { date: "2021-09-09", totalSales: 53, totalUnits: 48 },
        { date: "2021-09-10", totalSales: 38, totalUnits: 2 },
        { date: "2021-09-11", totalSales: 59, totalUnits: 22 },
        { date: "2021-09-12", totalSales: 20, totalUnits: 19 },
        { date: "2021-09-13", totalSales: 82, totalUnits: 25 },
        { date: "2021-09-14", totalSales: 74, totalUnits: 3 },
        { date: "2021-09-15", totalSales: 88, totalUnits: 11 },
        { date: "2021-09-16", totalSales: 37, totalUnits: 34 },
        { date: "2021-09-17", totalSales: 92, totalUnits: 16 },
        { date: "2021-09-18", totalSales: 37, totalUnits: 20 },
        { date: "2021-09-19", totalSales: 73, totalUnits: 21 },
        { date: "2021-09-20", totalSales: 86, totalUnits: 6 },
        { date: "2021-09-21", totalSales: 34, totalUnits: 47 },
        { date: "2021-09-22", totalSales: 69, totalUnits: 43 },
        { date: "2021-09-23", totalSales: 2, totalUnits: 41 },
        { date: "2021-09-24", totalSales: 56, totalUnits: 47 },
        { date: "2021-09-25", totalSales: 85, totalUnits: 4 },
        { date: "2021-09-26", totalSales: 53, totalUnits: 5 },
        { date: "2021-09-27", totalSales: 89, totalUnits: 4 },
        { date: "2021-09-28", totalSales: 70, totalUnits: 5 },
        { date: "2021-09-29", totalSales: 31, totalUnits: 27 },
        { date: "2021-09-30", totalSales: 70, totalUnits: 10 },
        { date: "2021-10-01", totalSales: 18, totalUnits: 43 },
        { date: "2021-10-02", totalSales: 10, totalUnits: 1 },
        { date: "2021-10-03", totalSales: 65, totalUnits: 19 },
        { date: "2021-10-04", totalSales: 33, totalUnits: 37 },
        { date: "2021-10-05", totalSales: 90, totalUnits: 8 },
        { date: "2021-10-06", totalSales: 58, totalUnits: 19 },
        { date: "2021-10-07", totalSales: 38, totalUnits: 7 },
        { date: "2021-10-08", totalSales: 13, totalUnits: 13 },
        { date: "2021-10-09", totalSales: 52, totalUnits: 14 },
        { date: "2021-10-10", totalSales: 65, totalUnits: 34 },
        { date: "2021-10-11", totalSales: 47, totalUnits: 6 },
        { date: "2021-10-12", totalSales: 49, totalUnits: 38 },
        { date: "2021-10-13", totalSales: 42, totalUnits: 46 },
        { date: "2021-10-14", totalSales: 4, totalUnits: 13 },
        { date: "2021-10-15", totalSales: 33, totalUnits: 32 },
        { date: "2021-10-16", totalSales: 53, totalUnits: 25 },
        { date: "2021-10-17", totalSales: 61, totalUnits: 6 },
        { date: "2021-10-18", totalSales: 47, totalUnits: 50 },
        { date: "2021-10-19", totalSales: 41, totalUnits: 9 },
        { date: "2021-10-20", totalSales: 74, totalUnits: 49 },
        { date: "2021-10-21", totalSales: 8, totalUnits: 42 },
        { date: "2021-10-22", totalSales: 3, totalUnits: 10 },
        { date: "2021-10-23", totalSales: 33, totalUnits: 19 },
        { date: "2021-10-24", totalSales: 55, totalUnits: 31 },
        { date: "2021-10-25", totalSales: 76, totalUnits: 46 },
        { date: "2021-10-26", totalSales: 17, totalUnits: 38 },
        { date: "2021-10-27", totalSales: 90, totalUnits: 3 },
        { date: "2021-10-28", totalSales: 4, totalUnits: 44 },
        { date: "2021-10-29", totalSales: 9, totalUnits: 42 },
        { date: "2021-10-30", totalSales: 27, totalUnits: 3 },
        { date: "2021-10-31", totalSales: 19, totalUnits: 28 },
        { date: "2021-11-01", totalSales: 30, totalUnits: 45 },
        { date: "2021-11-02", totalSales: 7, totalUnits: 23 },
        { date: "2021-11-03", totalSales: 93, totalUnits: 37 },
        { date: "2021-11-04", totalSales: 37, totalUnits: 36 },
        { date: "2021-11-05", totalSales: 90, totalUnits: 4 },
        { date: "2021-11-06", totalSales: 24, totalUnits: 2 },
        { date: "2021-11-07", totalSales: 60, totalUnits: 30 },
        { date: "2021-11-08", totalSales: 16, totalUnits: 30 },
        { date: "2021-11-09", totalSales: 22, totalUnits: 35 },
        { date: "2021-11-10", totalSales: 5, totalUnits: 33 },
        { date: "2021-11-11", totalSales: 82, totalUnits: 44 },
        { date: "2021-11-12", totalSales: 99, totalUnits: 42 },
        { date: "2021-11-13", totalSales: 73, totalUnits: 36 },
        { date: "2021-11-14", totalSales: 85, totalUnits: 16 },
        { date: "2021-11-15", totalSales: 67, totalUnits: 13 },
        { date: "2021-11-16", totalSales: 80, totalUnits: 6 },
        { date: "2021-11-17", totalSales: 71, totalUnits: 23 },
      ],
    },
    {
      _id: "6371259ef03239d40b0000d8",
      productId: "63701d24f032395b3300012a",
      yearlySalesTotal: 2803,
      yearlyTotalSoldUnits: 2247,
      monthlyData: [
        { month: "january", totalSales: 391, totalUnits: 252 },
        { month: "february", totalSales: 453, totalUnits: 117 },
        { month: "march", totalSales: 664, totalUnits: 208 },
        { month: "april", totalSales: 79, totalUnits: 196 },
        { month: "may", totalSales: 49, totalUnits: 433 },
        { month: "june", totalSales: 400, totalUnits: 37 },
        { month: "july", totalSales: 278, totalUnits: 387 },
        { month: "august", totalSales: 591, totalUnits: 226 },
        { month: "september", totalSales: 125, totalUnits: 480 },
        { month: "october", totalSales: 129, totalUnits: 84 },
        { month: "november", totalSales: 183, totalUnits: 452 },
        { month: "december", totalSales: 518, totalUnits: 72 },
      ],
      dailyData: [
        { date: "2021-01-02", totalSales: 24, totalUnits: 37 },
        { date: "2021-01-03", totalSales: 10, totalUnits: 48 },
        { date: "2021-01-04", totalSales: 58, totalUnits: 19 },
        { date: "2021-01-05", totalSales: 53, totalUnits: 28 },
        { date: "2021-01-06", totalSales: 37, totalUnits: 41 },
        { date: "2021-01-07", totalSales: 91, totalUnits: 46 },
        { date: "2021-01-08", totalSales: 23, totalUnits: 3 },
        { date: "2021-01-09", totalSales: 28, totalUnits: 2 },
        { date: "2021-01-10", totalSales: 30, totalUnits: 7 },
        { date: "2021-01-11", totalSales: 22, totalUnits: 35 },
        { date: "2021-01-12", totalSales: 64, totalUnits: 32 },
        { date: "2021-01-13", totalSales: 8, totalUnits: 19 },
        { date: "2021-01-14", totalSales: 30, totalUnits: 14 },
        { date: "2021-01-15", totalSales: 64, totalUnits: 7 },
        { date: "2021-01-16", totalSales: 36, totalUnits: 23 },
        { date: "2021-01-17", totalSales: 7, totalUnits: 29 },
        { date: "2021-01-18", totalSales: 78, totalUnits: 38 },
        { date: "2021-01-19", totalSales: 8, totalUnits: 38 },
        { date: "2021-01-20", totalSales: 46, totalUnits: 16 },
        { date: "2021-01-21", totalSales: 55, totalUnits: 50 },
        { date: "2021-01-22", totalSales: 13, totalUnits: 2 },
        { date: "2021-01-23", totalSales: 15, totalUnits: 18 },
        { date: "2021-01-24", totalSales: 63, totalUnits: 1 },
        { date: "2021-01-25", totalSales: 31, totalUnits: 36 },
        { date: "2021-01-26", totalSales: 29, totalUnits: 4 },
        { date: "2021-01-27", totalSales: 64, totalUnits: 18 },
        { date: "2021-01-28", totalSales: 60, totalUnits: 30 },
        { date: "2021-01-29", totalSales: 76, totalUnits: 22 },
        { date: "2021-01-30", totalSales: 63, totalUnits: 5 },
        { date: "2021-01-31", totalSales: 25, totalUnits: 25 },
        { date: "2021-02-01", totalSales: 41, totalUnits: 38 },
        { date: "2021-02-02", totalSales: 97, totalUnits: 42 },
        { date: "2021-02-03", totalSales: 57, totalUnits: 4 },
        { date: "2021-02-04", totalSales: 92, totalUnits: 1 },
        { date: "2021-02-05", totalSales: 21, totalUnits: 34 },
        { date: "2021-02-06", totalSales: 10, totalUnits: 31 },
        { date: "2021-02-07", totalSales: 6, totalUnits: 42 },
        { date: "2021-02-08", totalSales: 54, totalUnits: 3 },
        { date: "2021-02-09", totalSales: 31, totalUnits: 21 },
        { date: "2021-02-10", totalSales: 24, totalUnits: 39 },
        { date: "2021-02-11", totalSales: 71, totalUnits: 11 },
        { date: "2021-02-12", totalSales: 8, totalUnits: 42 },
        { date: "2021-02-13", totalSales: 83, totalUnits: 20 },
        { date: "2021-02-14", totalSales: 98, totalUnits: 47 },
        { date: "2021-02-15", totalSales: 97, totalUnits: 6 },
        { date: "2021-02-16", totalSales: 98, totalUnits: 45 },
        { date: "2021-02-17", totalSales: 87, totalUnits: 2 },
        { date: "2021-02-18", totalSales: 80, totalUnits: 9 },
        { date: "2021-02-19", totalSales: 5, totalUnits: 20 },
        { date: "2021-02-20", totalSales: 61, totalUnits: 11 },
        { date: "2021-02-21", totalSales: 57, totalUnits: 46 },
        { date: "2021-02-22", totalSales: 8, totalUnits: 34 },
        { date: "2021-02-23", totalSales: 96, totalUnits: 18 },
        { date: "2021-02-24", totalSales: 25, totalUnits: 6 },
        { date: "2021-02-25", totalSales: 98, totalUnits: 46 },
        { date: "2021-02-26", totalSales: 92, totalUnits: 1 },
        { date: "2021-02-27", totalSales: 35, totalUnits: 19 },
        { date: "2021-02-28", totalSales: 80, totalUnits: 27 },
        { date: "2021-03-01", totalSales: 90, totalUnits: 21 },
        { date: "2021-03-02", totalSales: 94, totalUnits: 10 },
        { date: "2021-03-03", totalSales: 46, totalUnits: 33 },
        { date: "2021-03-04", totalSales: 77, totalUnits: 38 },
        { date: "2021-03-05", totalSales: 25, totalUnits: 10 },
        { date: "2021-03-06", totalSales: 73, totalUnits: 41 },
        { date: "2021-03-07", totalSales: 71, totalUnits: 41 },
        { date: "2021-03-08", totalSales: 84, totalUnits: 3 },
        { date: "2021-03-09", totalSales: 30, totalUnits: 46 },
        { date: "2021-03-10", totalSales: 17, totalUnits: 15 },
        { date: "2021-03-11", totalSales: 43, totalUnits: 33 },
        { date: "2021-03-12", totalSales: 42, totalUnits: 42 },
        { date: "2021-03-13", totalSales: 78, totalUnits: 39 },
        { date: "2021-03-14", totalSales: 91, totalUnits: 18 },
        { date: "2021-03-15", totalSales: 12, totalUnits: 41 },
        { date: "2021-03-16", totalSales: 51, totalUnits: 12 },
        { date: "2021-03-17", totalSales: 65, totalUnits: 3 },
        { date: "2021-03-18", totalSales: 60, totalUnits: 29 },
        { date: "2021-03-19", totalSales: 19, totalUnits: 20 },
        { date: "2021-03-20", totalSales: 12, totalUnits: 22 },
        { date: "2021-03-21", totalSales: 97, totalUnits: 29 },
        { date: "2021-03-22", totalSales: 36, totalUnits: 20 },
        { date: "2021-03-23", totalSales: 69, totalUnits: 1 },
        { date: "2021-03-24", totalSales: 18, totalUnits: 8 },
        { date: "2021-03-25", totalSales: 58, totalUnits: 42 },
        { date: "2021-03-26", totalSales: 64, totalUnits: 46 },
        { date: "2021-03-27", totalSales: 1, totalUnits: 36 },
        { date: "2021-03-28", totalSales: 1, totalUnits: 26 },
        { date: "2021-03-29", totalSales: 87, totalUnits: 12 },
        { date: "2021-03-30", totalSales: 19, totalUnits: 19 },
        { date: "2021-03-31", totalSales: 19, totalUnits: 21 },
        { date: "2021-04-01", totalSales: 50, totalUnits: 23 },
        { date: "2021-04-02", totalSales: 55, totalUnits: 11 },
        { date: "2021-04-03", totalSales: 76, totalUnits: 20 },
        { date: "2021-04-04", totalSales: 59, totalUnits: 11 },
        { date: "2021-04-05", totalSales: 43, totalUnits: 4 },
        { date: "2021-04-06", totalSales: 28, totalUnits: 48 },
        { date: "2021-04-07", totalSales: 21, totalUnits: 13 },
        { date: "2021-04-08", totalSales: 60, totalUnits: 31 },
        { date: "2021-04-09", totalSales: 39, totalUnits: 10 },
        { date: "2021-04-10", totalSales: 62, totalUnits: 30 },
        { date: "2021-04-11", totalSales: 28, totalUnits: 1 },
        { date: "2021-04-12", totalSales: 72, totalUnits: 21 },
        { date: "2021-04-13", totalSales: 43, totalUnits: 50 },
        { date: "2021-04-14", totalSales: 99, totalUnits: 7 },
        { date: "2021-04-15", totalSales: 99, totalUnits: 8 },
        { date: "2021-04-16", totalSales: 70, totalUnits: 33 },
        { date: "2021-04-17", totalSales: 34, totalUnits: 3 },
        { date: "2021-04-18", totalSales: 78, totalUnits: 40 },
        { date: "2021-04-19", totalSales: 39, totalUnits: 30 },
        { date: "2021-04-20", totalSales: 84, totalUnits: 17 },
        { date: "2021-04-21", totalSales: 11, totalUnits: 2 },
        { date: "2021-04-22", totalSales: 51, totalUnits: 41 },
        { date: "2021-04-23", totalSales: 77, totalUnits: 16 },
        { date: "2021-04-24", totalSales: 21, totalUnits: 33 },
        { date: "2021-04-25", totalSales: 18, totalUnits: 39 },
        { date: "2021-04-26", totalSales: 53, totalUnits: 17 },
        { date: "2021-04-27", totalSales: 48, totalUnits: 26 },
        { date: "2021-04-28", totalSales: 6, totalUnits: 26 },
        { date: "2021-04-29", totalSales: 14, totalUnits: 28 },
        { date: "2021-04-30", totalSales: 96, totalUnits: 13 },
        { date: "2021-05-01", totalSales: 14, totalUnits: 30 },
        { date: "2021-05-02", totalSales: 97, totalUnits: 43 },
        { date: "2021-05-03", totalSales: 41, totalUnits: 32 },
        { date: "2021-05-04", totalSales: 21, totalUnits: 6 },
        { date: "2021-05-05", totalSales: 13, totalUnits: 39 },
        { date: "2021-05-06", totalSales: 23, totalUnits: 15 },
        { date: "2021-05-07", totalSales: 98, totalUnits: 47 },
        { date: "2021-05-08", totalSales: 69, totalUnits: 49 },
        { date: "2021-05-09", totalSales: 74, totalUnits: 16 },
        { date: "2021-05-10", totalSales: 72, totalUnits: 4 },
        { date: "2021-05-11", totalSales: 54, totalUnits: 18 },
        { date: "2021-05-12", totalSales: 78, totalUnits: 33 },
        { date: "2021-05-13", totalSales: 17, totalUnits: 44 },
        { date: "2021-05-14", totalSales: 14, totalUnits: 47 },
        { date: "2021-05-15", totalSales: 61, totalUnits: 7 },
        { date: "2021-05-16", totalSales: 27, totalUnits: 16 },
        { date: "2021-05-17", totalSales: 60, totalUnits: 35 },
        { date: "2021-05-18", totalSales: 69, totalUnits: 32 },
        { date: "2021-05-19", totalSales: 77, totalUnits: 37 },
        { date: "2021-05-20", totalSales: 53, totalUnits: 34 },
        { date: "2021-05-21", totalSales: 53, totalUnits: 36 },
        { date: "2021-05-22", totalSales: 66, totalUnits: 31 },
        { date: "2021-05-23", totalSales: 50, totalUnits: 23 },
        { date: "2021-05-24", totalSales: 62, totalUnits: 9 },
        { date: "2021-05-25", totalSales: 6, totalUnits: 34 },
        { date: "2021-05-26", totalSales: 15, totalUnits: 15 },
        { date: "2021-05-27", totalSales: 57, totalUnits: 11 },
        { date: "2021-05-28", totalSales: 3, totalUnits: 9 },
        { date: "2021-05-29", totalSales: 68, totalUnits: 19 },
        { date: "2021-05-30", totalSales: 79, totalUnits: 24 },
        { date: "2021-05-31", totalSales: 33, totalUnits: 16 },
        { date: "2021-06-01", totalSales: 44, totalUnits: 22 },
        { date: "2021-06-02", totalSales: 66, totalUnits: 34 },
        { date: "2021-06-03", totalSales: 43, totalUnits: 43 },
        { date: "2021-06-04", totalSales: 40, totalUnits: 22 },
        { date: "2021-06-05", totalSales: 39, totalUnits: 3 },
        { date: "2021-06-06", totalSales: 44, totalUnits: 38 },
        { date: "2021-06-07", totalSales: 30, totalUnits: 10 },
        { date: "2021-06-08", totalSales: 77, totalUnits: 7 },
        { date: "2021-06-09", totalSales: 87, totalUnits: 19 },
        { date: "2021-06-10", totalSales: 69, totalUnits: 38 },
        { date: "2021-06-11", totalSales: 6, totalUnits: 11 },
        { date: "2021-06-12", totalSales: 59, totalUnits: 20 },
        { date: "2021-06-13", totalSales: 91, totalUnits: 37 },
        { date: "2021-06-14", totalSales: 35, totalUnits: 47 },
        { date: "2021-06-15", totalSales: 28, totalUnits: 19 },
        { date: "2021-06-16", totalSales: 93, totalUnits: 46 },
        { date: "2021-06-17", totalSales: 44, totalUnits: 1 },
        { date: "2021-06-18", totalSales: 96, totalUnits: 34 },
        { date: "2021-06-19", totalSales: 8, totalUnits: 9 },
        { date: "2021-06-20", totalSales: 77, totalUnits: 34 },
        { date: "2021-06-21", totalSales: 90, totalUnits: 19 },
        { date: "2021-06-22", totalSales: 53, totalUnits: 42 },
        { date: "2021-06-23", totalSales: 81, totalUnits: 47 },
        { date: "2021-06-24", totalSales: 8, totalUnits: 34 },
        { date: "2021-06-25", totalSales: 16, totalUnits: 38 },
        { date: "2021-06-26", totalSales: 24, totalUnits: 36 },
        { date: "2021-06-27", totalSales: 22, totalUnits: 45 },
        { date: "2021-06-28", totalSales: 7, totalUnits: 24 },
        { date: "2021-06-29", totalSales: 10, totalUnits: 34 },
        { date: "2021-06-30", totalSales: 97, totalUnits: 17 },
        { date: "2021-07-01", totalSales: 50, totalUnits: 33 },
        { date: "2021-07-02", totalSales: 94, totalUnits: 37 },
        { date: "2021-07-03", totalSales: 26, totalUnits: 39 },
        { date: "2021-07-04", totalSales: 21, totalUnits: 20 },
        { date: "2021-07-05", totalSales: 2, totalUnits: 19 },
        { date: "2021-07-06", totalSales: 97, totalUnits: 9 },
        { date: "2021-07-07", totalSales: 28, totalUnits: 27 },
        { date: "2021-07-08", totalSales: 72, totalUnits: 46 },
        { date: "2021-07-09", totalSales: 99, totalUnits: 12 },
        { date: "2021-07-10", totalSales: 27, totalUnits: 49 },
        { date: "2021-07-11", totalSales: 93, totalUnits: 5 },
        { date: "2021-07-12", totalSales: 12, totalUnits: 14 },
        { date: "2021-07-13", totalSales: 93, totalUnits: 32 },
        { date: "2021-07-14", totalSales: 1, totalUnits: 45 },
        { date: "2021-07-15", totalSales: 38, totalUnits: 37 },
        { date: "2021-07-16", totalSales: 67, totalUnits: 26 },
        { date: "2021-07-17", totalSales: 62, totalUnits: 48 },
        { date: "2021-07-18", totalSales: 51, totalUnits: 13 },
        { date: "2021-07-19", totalSales: 3, totalUnits: 33 },
        { date: "2021-07-20", totalSales: 100, totalUnits: 26 },
        { date: "2021-07-21", totalSales: 64, totalUnits: 2 },
        { date: "2021-07-22", totalSales: 96, totalUnits: 29 },
        { date: "2021-07-23", totalSales: 26, totalUnits: 40 },
        { date: "2021-07-24", totalSales: 73, totalUnits: 40 },
        { date: "2021-07-25", totalSales: 20, totalUnits: 8 },
        { date: "2021-07-26", totalSales: 25, totalUnits: 6 },
        { date: "2021-07-27", totalSales: 9, totalUnits: 6 },
        { date: "2021-07-28", totalSales: 76, totalUnits: 45 },
        { date: "2021-07-29", totalSales: 61, totalUnits: 27 },
        { date: "2021-07-30", totalSales: 79, totalUnits: 35 },
        { date: "2021-07-31", totalSales: 13, totalUnits: 26 },
        { date: "2021-08-01", totalSales: 51, totalUnits: 7 },
        { date: "2021-08-02", totalSales: 52, totalUnits: 11 },
        { date: "2021-08-03", totalSales: 34, totalUnits: 44 },
        { date: "2021-08-04", totalSales: 35, totalUnits: 27 },
        { date: "2021-08-05", totalSales: 47, totalUnits: 24 },
        { date: "2021-08-06", totalSales: 77, totalUnits: 6 },
        { date: "2021-08-07", totalSales: 91, totalUnits: 29 },
        { date: "2021-08-08", totalSales: 52, totalUnits: 36 },
        { date: "2021-08-09", totalSales: 75, totalUnits: 23 },
        { date: "2021-08-10", totalSales: 35, totalUnits: 21 },
        { date: "2021-08-11", totalSales: 24, totalUnits: 40 },
        { date: "2021-08-12", totalSales: 62, totalUnits: 9 },
        { date: "2021-08-13", totalSales: 20, totalUnits: 8 },
        { date: "2021-08-14", totalSales: 95, totalUnits: 14 },
        { date: "2021-08-15", totalSales: 73, totalUnits: 27 },
        { date: "2021-08-16", totalSales: 51, totalUnits: 16 },
        { date: "2021-08-17", totalSales: 33, totalUnits: 47 },
        { date: "2021-08-18", totalSales: 100, totalUnits: 33 },
        { date: "2021-08-19", totalSales: 87, totalUnits: 17 },
        { date: "2021-08-20", totalSales: 50, totalUnits: 19 },
        { date: "2021-08-21", totalSales: 90, totalUnits: 30 },
        { date: "2021-08-22", totalSales: 36, totalUnits: 29 },
        { date: "2021-08-23", totalSales: 53, totalUnits: 21 },
        { date: "2021-08-24", totalSales: 16, totalUnits: 18 },
        { date: "2021-08-25", totalSales: 30, totalUnits: 19 },
        { date: "2021-08-26", totalSales: 11, totalUnits: 37 },
        { date: "2021-08-27", totalSales: 29, totalUnits: 25 },
        { date: "2021-08-28", totalSales: 56, totalUnits: 42 },
        { date: "2021-08-29", totalSales: 5, totalUnits: 29 },
        { date: "2021-08-30", totalSales: 35, totalUnits: 35 },
        { date: "2021-08-31", totalSales: 69, totalUnits: 44 },
        { date: "2021-09-01", totalSales: 18, totalUnits: 40 },
        { date: "2021-09-02", totalSales: 27, totalUnits: 33 },
        { date: "2021-09-03", totalSales: 59, totalUnits: 28 },
        { date: "2021-09-04", totalSales: 17, totalUnits: 49 },
        { date: "2021-09-05", totalSales: 51, totalUnits: 34 },
        { date: "2021-09-06", totalSales: 65, totalUnits: 28 },
        { date: "2021-09-07", totalSales: 17, totalUnits: 45 },
        { date: "2021-09-08", totalSales: 82, totalUnits: 40 },
        { date: "2021-09-09", totalSales: 99, totalUnits: 3 },
        { date: "2021-09-10", totalSales: 51, totalUnits: 26 },
        { date: "2021-09-11", totalSales: 54, totalUnits: 27 },
        { date: "2021-09-12", totalSales: 42, totalUnits: 31 },
        { date: "2021-09-13", totalSales: 43, totalUnits: 21 },
        { date: "2021-09-14", totalSales: 70, totalUnits: 28 },
        { date: "2021-09-15", totalSales: 10, totalUnits: 31 },
        { date: "2021-09-16", totalSales: 11, totalUnits: 34 },
        { date: "2021-09-17", totalSales: 43, totalUnits: 21 },
        { date: "2021-09-18", totalSales: 56, totalUnits: 19 },
        { date: "2021-09-19", totalSales: 36, totalUnits: 7 },
        { date: "2021-09-20", totalSales: 85, totalUnits: 33 },
        { date: "2021-09-21", totalSales: 78, totalUnits: 42 },
        { date: "2021-09-22", totalSales: 96, totalUnits: 2 },
        { date: "2021-09-23", totalSales: 67, totalUnits: 22 },
        { date: "2021-09-24", totalSales: 48, totalUnits: 27 },
        { date: "2021-09-25", totalSales: 81, totalUnits: 21 },
        { date: "2021-09-26", totalSales: 16, totalUnits: 5 },
        { date: "2021-09-27", totalSales: 98, totalUnits: 20 },
        { date: "2021-09-28", totalSales: 82, totalUnits: 14 },
        { date: "2021-09-29", totalSales: 39, totalUnits: 40 },
        { date: "2021-09-30", totalSales: 27, totalUnits: 10 },
        { date: "2021-10-01", totalSales: 76, totalUnits: 18 },
        { date: "2021-10-02", totalSales: 22, totalUnits: 22 },
        { date: "2021-10-03", totalSales: 38, totalUnits: 7 },
        { date: "2021-10-04", totalSales: 98, totalUnits: 28 },
        { date: "2021-10-05", totalSales: 12, totalUnits: 47 },
        { date: "2021-10-06", totalSales: 6, totalUnits: 49 },
        { date: "2021-10-07", totalSales: 78, totalUnits: 23 },
        { date: "2021-10-08", totalSales: 23, totalUnits: 22 },
        { date: "2021-10-09", totalSales: 40, totalUnits: 32 },
        { date: "2021-10-10", totalSales: 14, totalUnits: 15 },
        { date: "2021-10-11", totalSales: 17, totalUnits: 17 },
        { date: "2021-10-12", totalSales: 94, totalUnits: 6 },
        { date: "2021-10-13", totalSales: 17, totalUnits: 49 },
        { date: "2021-10-14", totalSales: 40, totalUnits: 50 },
        { date: "2021-10-15", totalSales: 36, totalUnits: 32 },
        { date: "2021-10-16", totalSales: 27, totalUnits: 7 },
        { date: "2021-10-17", totalSales: 86, totalUnits: 24 },
        { date: "2021-10-18", totalSales: 48, totalUnits: 4 },
        { date: "2021-10-19", totalSales: 45, totalUnits: 38 },
        { date: "2021-10-20", totalSales: 2, totalUnits: 24 },
        { date: "2021-10-21", totalSales: 97, totalUnits: 27 },
        { date: "2021-10-22", totalSales: 89, totalUnits: 12 },
        { date: "2021-10-23", totalSales: 30, totalUnits: 34 },
        { date: "2021-10-24", totalSales: 6, totalUnits: 34 },
        { date: "2021-10-25", totalSales: 16, totalUnits: 46 },
        { date: "2021-10-26", totalSales: 36, totalUnits: 36 },
        { date: "2021-10-27", totalSales: 21, totalUnits: 25 },
        { date: "2021-10-28", totalSales: 7, totalUnits: 32 },
        { date: "2021-10-29", totalSales: 42, totalUnits: 31 },
        { date: "2021-10-30", totalSales: 48, totalUnits: 34 },
        { date: "2021-10-31", totalSales: 69, totalUnits: 31 },
        { date: "2021-11-01", totalSales: 85, totalUnits: 24 },
        { date: "2021-11-02", totalSales: 89, totalUnits: 36 },
        { date: "2021-11-03", totalSales: 5, totalUnits: 33 },
        { date: "2021-11-04", totalSales: 2, totalUnits: 49 },
        { date: "2021-11-05", totalSales: 60, totalUnits: 49 },
        { date: "2021-11-06", totalSales: 60, totalUnits: 35 },
        { date: "2021-11-07", totalSales: 40, totalUnits: 47 },
        { date: "2021-11-08", totalSales: 57, totalUnits: 8 },
        { date: "2021-11-09", totalSales: 89, totalUnits: 35 },
        { date: "2021-11-10", totalSales: 39, totalUnits: 6 },
        { date: "2021-11-11", totalSales: 100, totalUnits: 18 },
        { date: "2021-11-12", totalSales: 62, totalUnits: 25 },
        { date: "2021-11-13", totalSales: 29, totalUnits: 8 },
        { date: "2021-11-14", totalSales: 27, totalUnits: 23 },
        { date: "2021-11-15", totalSales: 26, totalUnits: 9 },
        { date: "2021-11-16", totalSales: 26, totalUnits: 31 },
        { date: "2021-11-17", totalSales: 89, totalUnits: 9 },
      ],
    },
    {
      _id: "6371259ff03239d40b0000d9",
      productId: "63701d24f032395b3300012b",
      yearlySalesTotal: 9751,
      yearlyTotalSoldUnits: 1501,
      monthlyData: [
        { month: "january", totalSales: 947, totalUnits: 116 },
        { month: "february", totalSales: 312, totalUnits: 53 },
        { month: "march", totalSales: 382, totalUnits: 134 },
        { month: "april", totalSales: 469, totalUnits: 313 },
        { month: "may", totalSales: 884, totalUnits: 461 },
        { month: "june", totalSales: 786, totalUnits: 256 },
        { month: "july", totalSales: 683, totalUnits: 409 },
        { month: "august", totalSales: 109, totalUnits: 2 },
        { month: "september", totalSales: 954, totalUnits: 157 },
        { month: "october", totalSales: 528, totalUnits: 206 },
        { month: "november", totalSales: 193, totalUnits: 486 },
        { month: "december", totalSales: 768, totalUnits: 407 },
      ],
      dailyData: [
        { date: "2021-01-02", totalSales: 62, totalUnits: 1 },
        { date: "2021-01-03", totalSales: 97, totalUnits: 13 },
        { date: "2021-01-04", totalSales: 56, totalUnits: 19 },
        { date: "2021-01-05", totalSales: 50, totalUnits: 20 },
        { date: "2021-01-06", totalSales: 72, totalUnits: 1 },
        { date: "2021-01-07", totalSales: 25, totalUnits: 28 },
        { date: "2021-01-08", totalSales: 57, totalUnits: 39 },
        { date: "2021-01-09", totalSales: 11, totalUnits: 35 },
        { date: "2021-01-10", totalSales: 69, totalUnits: 33 },
        { date: "2021-01-11", totalSales: 13, totalUnits: 46 },
        { date: "2021-01-12", totalSales: 62, totalUnits: 19 },
        { date: "2021-01-13", totalSales: 100, totalUnits: 21 },
        { date: "2021-01-14", totalSales: 84, totalUnits: 17 },
        { date: "2021-01-15", totalSales: 21, totalUnits: 15 },
        { date: "2021-01-16", totalSales: 43, totalUnits: 50 },
        { date: "2021-01-17", totalSales: 57, totalUnits: 3 },
        { date: "2021-01-18", totalSales: 82, totalUnits: 35 },
        { date: "2021-01-19", totalSales: 50, totalUnits: 22 },
        { date: "2021-01-20", totalSales: 2, totalUnits: 19 },
        { date: "2021-01-21", totalSales: 25, totalUnits: 12 },
        { date: "2021-01-22", totalSales: 57, totalUnits: 4 },
        { date: "2021-01-23", totalSales: 33, totalUnits: 12 },
        { date: "2021-01-24", totalSales: 36, totalUnits: 5 },
        { date: "2021-01-25", totalSales: 58, totalUnits: 14 },
        { date: "2021-01-26", totalSales: 22, totalUnits: 46 },
        { date: "2021-01-27", totalSales: 24, totalUnits: 41 },
        { date: "2021-01-28", totalSales: 35, totalUnits: 31 },
        { date: "2021-01-29", totalSales: 72, totalUnits: 49 },
        { date: "2021-01-30", totalSales: 82, totalUnits: 34 },
        { date: "2021-01-31", totalSales: 53, totalUnits: 41 },
        { date: "2021-02-01", totalSales: 58, totalUnits: 2 },
        { date: "2021-02-02", totalSales: 72, totalUnits: 50 },
        { date: "2021-02-03", totalSales: 63, totalUnits: 44 },
        { date: "2021-02-04", totalSales: 49, totalUnits: 45 },
        { date: "2021-02-05", totalSales: 38, totalUnits: 43 },
        { date: "2021-02-06", totalSales: 4, totalUnits: 16 },
        { date: "2021-02-07", totalSales: 30, totalUnits: 37 },
        { date: "2021-02-08", totalSales: 31, totalUnits: 11 },
        { date: "2021-02-09", totalSales: 75, totalUnits: 36 },
        { date: "2021-02-10", totalSales: 73, totalUnits: 48 },
        { date: "2021-02-11", totalSales: 36, totalUnits: 38 },
        { date: "2021-02-12", totalSales: 5, totalUnits: 4 },
        { date: "2021-02-13", totalSales: 3, totalUnits: 22 },
        { date: "2021-02-14", totalSales: 28, totalUnits: 46 },
        { date: "2021-02-15", totalSales: 6, totalUnits: 46 },
        { date: "2021-02-16", totalSales: 46, totalUnits: 9 },
        { date: "2021-02-17", totalSales: 60, totalUnits: 39 },
        { date: "2021-02-18", totalSales: 50, totalUnits: 1 },
        { date: "2021-02-19", totalSales: 8, totalUnits: 50 },
        { date: "2021-02-20", totalSales: 51, totalUnits: 30 },
        { date: "2021-02-21", totalSales: 83, totalUnits: 19 },
        { date: "2021-02-22", totalSales: 77, totalUnits: 10 },
        { date: "2021-02-23", totalSales: 6, totalUnits: 28 },
        { date: "2021-02-24", totalSales: 86, totalUnits: 17 },
        { date: "2021-02-25", totalSales: 18, totalUnits: 5 },
        { date: "2021-02-26", totalSales: 17, totalUnits: 2 },
        { date: "2021-02-27", totalSales: 77, totalUnits: 31 },
        { date: "2021-02-28", totalSales: 23, totalUnits: 26 },
        { date: "2021-03-01", totalSales: 52, totalUnits: 12 },
        { date: "2021-03-02", totalSales: 100, totalUnits: 30 },
        { date: "2021-03-03", totalSales: 11, totalUnits: 5 },
        { date: "2021-03-04", totalSales: 2, totalUnits: 1 },
        { date: "2021-03-05", totalSales: 99, totalUnits: 31 },
        { date: "2021-03-06", totalSales: 36, totalUnits: 21 },
        { date: "2021-03-07", totalSales: 8, totalUnits: 4 },
        { date: "2021-03-08", totalSales: 70, totalUnits: 39 },
        { date: "2021-03-09", totalSales: 71, totalUnits: 33 },
        { date: "2021-03-10", totalSales: 71, totalUnits: 48 },
        { date: "2021-03-11", totalSales: 56, totalUnits: 3 },
        { date: "2021-03-12", totalSales: 32, totalUnits: 50 },
        { date: "2021-03-13", totalSales: 41, totalUnits: 26 },
        { date: "2021-03-14", totalSales: 68, totalUnits: 47 },
        { date: "2021-03-15", totalSales: 91, totalUnits: 14 },
        { date: "2021-03-16", totalSales: 44, totalUnits: 16 },
        { date: "2021-03-17", totalSales: 1, totalUnits: 7 },
        { date: "2021-03-18", totalSales: 93, totalUnits: 40 },
        { date: "2021-03-19", totalSales: 3, totalUnits: 1 },
        { date: "2021-03-20", totalSales: 83, totalUnits: 3 },
        { date: "2021-03-21", totalSales: 70, totalUnits: 12 },
        { date: "2021-03-22", totalSales: 7, totalUnits: 34 },
        { date: "2021-03-23", totalSales: 55, totalUnits: 3 },
        { date: "2021-03-24", totalSales: 3, totalUnits: 35 },
        { date: "2021-03-25", totalSales: 21, totalUnits: 10 },
        { date: "2021-03-26", totalSales: 98, totalUnits: 37 },
        { date: "2021-03-27", totalSales: 48, totalUnits: 3 },
        { date: "2021-03-28", totalSales: 98, totalUnits: 49 },
        { date: "2021-03-29", totalSales: 86, totalUnits: 18 },
        { date: "2021-03-30", totalSales: 29, totalUnits: 21 },
        { date: "2021-03-31", totalSales: 76, totalUnits: 30 },
        { date: "2021-04-01", totalSales: 48, totalUnits: 43 },
        { date: "2021-04-02", totalSales: 48, totalUnits: 46 },
        { date: "2021-04-03", totalSales: 5, totalUnits: 44 },
        { date: "2021-04-04", totalSales: 11, totalUnits: 34 },
        { date: "2021-04-05", totalSales: 34, totalUnits: 7 },
        { date: "2021-04-06", totalSales: 52, totalUnits: 19 },
        { date: "2021-04-07", totalSales: 47, totalUnits: 21 },
        { date: "2021-04-08", totalSales: 8, totalUnits: 47 },
        { date: "2021-04-09", totalSales: 96, totalUnits: 1 },
        { date: "2021-04-10", totalSales: 6, totalUnits: 3 },
        { date: "2021-04-11", totalSales: 85, totalUnits: 42 },
        { date: "2021-04-12", totalSales: 67, totalUnits: 24 },
        { date: "2021-04-13", totalSales: 58, totalUnits: 43 },
        { date: "2021-04-14", totalSales: 1, totalUnits: 35 },
        { date: "2021-04-15", totalSales: 29, totalUnits: 1 },
        { date: "2021-04-16", totalSales: 26, totalUnits: 50 },
        { date: "2021-04-17", totalSales: 74, totalUnits: 11 },
        { date: "2021-04-18", totalSales: 63, totalUnits: 13 },
        { date: "2021-04-19", totalSales: 76, totalUnits: 13 },
        { date: "2021-04-20", totalSales: 70, totalUnits: 27 },
        { date: "2021-04-21", totalSales: 70, totalUnits: 41 },
        { date: "2021-04-22", totalSales: 18, totalUnits: 15 },
        { date: "2021-04-23", totalSales: 88, totalUnits: 47 },
        { date: "2021-04-24", totalSales: 20, totalUnits: 16 },
        { date: "2021-04-25", totalSales: 65, totalUnits: 20 },
        { date: "2021-04-26", totalSales: 1, totalUnits: 35 },
        { date: "2021-04-27", totalSales: 71, totalUnits: 4 },
        { date: "2021-04-28", totalSales: 37, totalUnits: 25 },
        { date: "2021-04-29", totalSales: 6, totalUnits: 41 },
        { date: "2021-04-30", totalSales: 16, totalUnits: 18 },
        { date: "2021-05-01", totalSales: 27, totalUnits: 44 },
        { date: "2021-05-02", totalSales: 45, totalUnits: 45 },
        { date: "2021-05-03", totalSales: 9, totalUnits: 23 },
        { date: "2021-05-04", totalSales: 31, totalUnits: 20 },
        { date: "2021-05-05", totalSales: 83, totalUnits: 16 },
        { date: "2021-05-06", totalSales: 32, totalUnits: 25 },
        { date: "2021-05-07", totalSales: 69, totalUnits: 39 },
        { date: "2021-05-08", totalSales: 43, totalUnits: 20 },
        { date: "2021-05-09", totalSales: 12, totalUnits: 38 },
        { date: "2021-05-10", totalSales: 34, totalUnits: 18 },
        { date: "2021-05-11", totalSales: 4, totalUnits: 15 },
        { date: "2021-05-12", totalSales: 92, totalUnits: 36 },
        { date: "2021-05-13", totalSales: 3, totalUnits: 29 },
        { date: "2021-05-14", totalSales: 97, totalUnits: 5 },
        { date: "2021-05-15", totalSales: 45, totalUnits: 23 },
        { date: "2021-05-16", totalSales: 24, totalUnits: 40 },
        { date: "2021-05-17", totalSales: 64, totalUnits: 5 },
        { date: "2021-05-18", totalSales: 100, totalUnits: 24 },
        { date: "2021-05-19", totalSales: 10, totalUnits: 46 },
        { date: "2021-05-20", totalSales: 8, totalUnits: 16 },
        { date: "2021-05-21", totalSales: 42, totalUnits: 1 },
        { date: "2021-05-22", totalSales: 40, totalUnits: 13 },
        { date: "2021-05-23", totalSales: 22, totalUnits: 24 },
        { date: "2021-05-24", totalSales: 47, totalUnits: 27 },
        { date: "2021-05-25", totalSales: 36, totalUnits: 40 },
        { date: "2021-05-26", totalSales: 15, totalUnits: 25 },
        { date: "2021-05-27", totalSales: 27, totalUnits: 15 },
        { date: "2021-05-28", totalSales: 12, totalUnits: 49 },
        { date: "2021-05-29", totalSales: 15, totalUnits: 2 },
        { date: "2021-05-30", totalSales: 56, totalUnits: 21 },
        { date: "2021-05-31", totalSales: 22, totalUnits: 23 },
        { date: "2021-06-01", totalSales: 35, totalUnits: 29 },
        { date: "2021-06-02", totalSales: 67, totalUnits: 28 },
        { date: "2021-06-03", totalSales: 68, totalUnits: 38 },
        { date: "2021-06-04", totalSales: 44, totalUnits: 47 },
        { date: "2021-06-05", totalSales: 22, totalUnits: 43 },
        { date: "2021-06-06", totalSales: 67, totalUnits: 3 },
        { date: "2021-06-07", totalSales: 50, totalUnits: 36 },
        { date: "2021-06-08", totalSales: 55, totalUnits: 30 },
        { date: "2021-06-09", totalSales: 62, totalUnits: 23 },
        { date: "2021-06-10", totalSales: 73, totalUnits: 50 },
        { date: "2021-06-11", totalSales: 87, totalUnits: 30 },
        { date: "2021-06-12", totalSales: 63, totalUnits: 2 },
        { date: "2021-06-13", totalSales: 73, totalUnits: 14 },
        { date: "2021-06-14", totalSales: 87, totalUnits: 7 },
        { date: "2021-06-15", totalSales: 61, totalUnits: 38 },
        { date: "2021-06-16", totalSales: 29, totalUnits: 23 },
        { date: "2021-06-17", totalSales: 21, totalUnits: 47 },
        { date: "2021-06-18", totalSales: 96, totalUnits: 2 },
        { date: "2021-06-19", totalSales: 56, totalUnits: 41 },
        { date: "2021-06-20", totalSales: 37, totalUnits: 38 },
        { date: "2021-06-21", totalSales: 65, totalUnits: 36 },
        { date: "2021-06-22", totalSales: 29, totalUnits: 42 },
        { date: "2021-06-23", totalSales: 75, totalUnits: 6 },
        { date: "2021-06-24", totalSales: 41, totalUnits: 14 },
        { date: "2021-06-25", totalSales: 98, totalUnits: 37 },
        { date: "2021-06-26", totalSales: 44, totalUnits: 15 },
        { date: "2021-06-27", totalSales: 91, totalUnits: 5 },
        { date: "2021-06-28", totalSales: 60, totalUnits: 30 },
        { date: "2021-06-29", totalSales: 21, totalUnits: 9 },
        { date: "2021-06-30", totalSales: 96, totalUnits: 7 },
        { date: "2021-07-01", totalSales: 64, totalUnits: 45 },
        { date: "2021-07-02", totalSales: 4, totalUnits: 4 },
        { date: "2021-07-03", totalSales: 95, totalUnits: 7 },
        { date: "2021-07-04", totalSales: 31, totalUnits: 50 },
        { date: "2021-07-05", totalSales: 33, totalUnits: 3 },
        { date: "2021-07-06", totalSales: 18, totalUnits: 27 },
        { date: "2021-07-07", totalSales: 12, totalUnits: 36 },
        { date: "2021-07-08", totalSales: 6, totalUnits: 47 },
        { date: "2021-07-09", totalSales: 15, totalUnits: 29 },
        { date: "2021-07-10", totalSales: 27, totalUnits: 33 },
        { date: "2021-07-11", totalSales: 47, totalUnits: 24 },
        { date: "2021-07-12", totalSales: 84, totalUnits: 3 },
        { date: "2021-07-13", totalSales: 53, totalUnits: 10 },
        { date: "2021-07-14", totalSales: 5, totalUnits: 46 },
        { date: "2021-07-15", totalSales: 90, totalUnits: 37 },
        { date: "2021-07-16", totalSales: 60, totalUnits: 38 },
        { date: "2021-07-17", totalSales: 30, totalUnits: 43 },
        { date: "2021-07-18", totalSales: 8, totalUnits: 22 },
        { date: "2021-07-19", totalSales: 40, totalUnits: 3 },
        { date: "2021-07-20", totalSales: 26, totalUnits: 18 },
        { date: "2021-07-21", totalSales: 95, totalUnits: 15 },
        { date: "2021-07-22", totalSales: 6, totalUnits: 42 },
        { date: "2021-07-23", totalSales: 80, totalUnits: 23 },
        { date: "2021-07-24", totalSales: 61, totalUnits: 49 },
        { date: "2021-07-25", totalSales: 42, totalUnits: 41 },
        { date: "2021-07-26", totalSales: 67, totalUnits: 22 },
        { date: "2021-07-27", totalSales: 71, totalUnits: 14 },
        { date: "2021-07-28", totalSales: 49, totalUnits: 34 },
        { date: "2021-07-29", totalSales: 98, totalUnits: 31 },
        { date: "2021-07-30", totalSales: 73, totalUnits: 1 },
        { date: "2021-07-31", totalSales: 31, totalUnits: 24 },
        { date: "2021-08-01", totalSales: 90, totalUnits: 9 },
        { date: "2021-08-02", totalSales: 86, totalUnits: 29 },
        { date: "2021-08-03", totalSales: 37, totalUnits: 7 },
        { date: "2021-08-04", totalSales: 96, totalUnits: 9 },
        { date: "2021-08-05", totalSales: 50, totalUnits: 37 },
        { date: "2021-08-06", totalSales: 23, totalUnits: 20 },
        { date: "2021-08-07", totalSales: 87, totalUnits: 9 },
        { date: "2021-08-08", totalSales: 100, totalUnits: 7 },
        { date: "2021-08-09", totalSales: 61, totalUnits: 20 },
        { date: "2021-08-10", totalSales: 93, totalUnits: 11 },
        { date: "2021-08-11", totalSales: 72, totalUnits: 49 },
        { date: "2021-08-12", totalSales: 81, totalUnits: 43 },
        { date: "2021-08-13", totalSales: 21, totalUnits: 22 },
        { date: "2021-08-14", totalSales: 70, totalUnits: 29 },
        { date: "2021-08-15", totalSales: 73, totalUnits: 10 },
        { date: "2021-08-16", totalSales: 96, totalUnits: 8 },
        { date: "2021-08-17", totalSales: 57, totalUnits: 25 },
        { date: "2021-08-18", totalSales: 89, totalUnits: 22 },
        { date: "2021-08-19", totalSales: 88, totalUnits: 31 },
        { date: "2021-08-20", totalSales: 60, totalUnits: 33 },
        { date: "2021-08-21", totalSales: 4, totalUnits: 2 },
        { date: "2021-08-22", totalSales: 70, totalUnits: 13 },
        { date: "2021-08-23", totalSales: 13, totalUnits: 36 },
        { date: "2021-08-24", totalSales: 86, totalUnits: 2 },
        { date: "2021-08-25", totalSales: 41, totalUnits: 49 },
        { date: "2021-08-26", totalSales: 6, totalUnits: 25 },
        { date: "2021-08-27", totalSales: 100, totalUnits: 10 },
        { date: "2021-08-28", totalSales: 44, totalUnits: 24 },
        { date: "2021-08-29", totalSales: 55, totalUnits: 9 },
        { date: "2021-08-30", totalSales: 45, totalUnits: 8 },
        { date: "2021-08-31", totalSales: 70, totalUnits: 5 },
        { date: "2021-09-01", totalSales: 37, totalUnits: 14 },
        { date: "2021-09-02", totalSales: 17, totalUnits: 42 },
        { date: "2021-09-03", totalSales: 52, totalUnits: 14 },
        { date: "2021-09-04", totalSales: 78, totalUnits: 45 },
        { date: "2021-09-05", totalSales: 90, totalUnits: 19 },
        { date: "2021-09-06", totalSales: 32, totalUnits: 24 },
        { date: "2021-09-07", totalSales: 28, totalUnits: 22 },
        { date: "2021-09-08", totalSales: 82, totalUnits: 44 },
        { date: "2021-09-09", totalSales: 22, totalUnits: 23 },
        { date: "2021-09-10", totalSales: 37, totalUnits: 43 },
        { date: "2021-09-11", totalSales: 13, totalUnits: 8 },
        { date: "2021-09-12", totalSales: 86, totalUnits: 39 },
        { date: "2021-09-13", totalSales: 37, totalUnits: 29 },
        { date: "2021-09-14", totalSales: 91, totalUnits: 29 },
        { date: "2021-09-15", totalSales: 86, totalUnits: 37 },
        { date: "2021-09-16", totalSales: 13, totalUnits: 21 },
        { date: "2021-09-17", totalSales: 28, totalUnits: 14 },
        { date: "2021-09-18", totalSales: 37, totalUnits: 26 },
        { date: "2021-09-19", totalSales: 89, totalUnits: 19 },
        { date: "2021-09-20", totalSales: 41, totalUnits: 46 },
        { date: "2021-09-21", totalSales: 98, totalUnits: 23 },
        { date: "2021-09-22", totalSales: 35, totalUnits: 21 },
        { date: "2021-09-23", totalSales: 47, totalUnits: 46 },
        { date: "2021-09-24", totalSales: 95, totalUnits: 44 },
        { date: "2021-09-25", totalSales: 90, totalUnits: 19 },
        { date: "2021-09-26", totalSales: 95, totalUnits: 17 },
        { date: "2021-09-27", totalSales: 51, totalUnits: 32 },
        { date: "2021-09-28", totalSales: 19, totalUnits: 19 },
        { date: "2021-09-29", totalSales: 98, totalUnits: 19 },
        { date: "2021-09-30", totalSales: 46, totalUnits: 3 },
        { date: "2021-10-01", totalSales: 73, totalUnits: 12 },
        { date: "2021-10-02", totalSales: 94, totalUnits: 6 },
        { date: "2021-10-03", totalSales: 52, totalUnits: 43 },
        { date: "2021-10-04", totalSales: 74, totalUnits: 40 },
        { date: "2021-10-05", totalSales: 16, totalUnits: 18 },
        { date: "2021-10-06", totalSales: 62, totalUnits: 49 },
        { date: "2021-10-07", totalSales: 6, totalUnits: 2 },
        { date: "2021-10-08", totalSales: 9, totalUnits: 1 },
        { date: "2021-10-09", totalSales: 2, totalUnits: 2 },
        { date: "2021-10-10", totalSales: 78, totalUnits: 36 },
        { date: "2021-10-11", totalSales: 7, totalUnits: 27 },
        { date: "2021-10-12", totalSales: 9, totalUnits: 40 },
        { date: "2021-10-13", totalSales: 4, totalUnits: 45 },
        { date: "2021-10-14", totalSales: 99, totalUnits: 49 },
        { date: "2021-10-15", totalSales: 16, totalUnits: 47 },
        { date: "2021-10-16", totalSales: 39, totalUnits: 10 },
        { date: "2021-10-17", totalSales: 90, totalUnits: 26 },
        { date: "2021-10-18", totalSales: 69, totalUnits: 37 },
        { date: "2021-10-19", totalSales: 2, totalUnits: 12 },
        { date: "2021-10-20", totalSales: 97, totalUnits: 22 },
        { date: "2021-10-21", totalSales: 60, totalUnits: 41 },
        { date: "2021-10-22", totalSales: 63, totalUnits: 49 },
        { date: "2021-10-23", totalSales: 20, totalUnits: 46 },
        { date: "2021-10-24", totalSales: 81, totalUnits: 27 },
        { date: "2021-10-25", totalSales: 6, totalUnits: 10 },
        { date: "2021-10-26", totalSales: 91, totalUnits: 8 },
        { date: "2021-10-27", totalSales: 94, totalUnits: 11 },
        { date: "2021-10-28", totalSales: 77, totalUnits: 39 },
        { date: "2021-10-29", totalSales: 62, totalUnits: 29 },
        { date: "2021-10-30", totalSales: 3, totalUnits: 21 },
        { date: "2021-10-31", totalSales: 13, totalUnits: 12 },
        { date: "2021-11-01", totalSales: 53, totalUnits: 42 },
        { date: "2021-11-02", totalSales: 63, totalUnits: 48 },
        { date: "2021-11-03", totalSales: 18, totalUnits: 35 },
        { date: "2021-11-04", totalSales: 70, totalUnits: 2 },
        { date: "2021-11-05", totalSales: 8, totalUnits: 25 },
        { date: "2021-11-06", totalSales: 62, totalUnits: 15 },
        { date: "2021-11-07", totalSales: 86, totalUnits: 45 },
        { date: "2021-11-08", totalSales: 90, totalUnits: 7 },
        { date: "2021-11-09", totalSales: 45, totalUnits: 23 },
        { date: "2021-11-10", totalSales: 7, totalUnits: 38 },
        { date: "2021-11-11", totalSales: 2, totalUnits: 27 },
        { date: "2021-11-12", totalSales: 42, totalUnits: 1 },
        { date: "2021-11-13", totalSales: 31, totalUnits: 46 },
        { date: "2021-11-14", totalSales: 33, totalUnits: 33 },
        { date: "2021-11-15", totalSales: 65, totalUnits: 33 },
        { date: "2021-11-16", totalSales: 84, totalUnits: 41 },
        { date: "2021-11-17", totalSales: 65, totalUnits: 40 },
      ],
    },
    {
      _id: "6371259ff03239d40b0000da",
      productId: "63701d24f032395b3300012c",
      yearlySalesTotal: 1810,
      yearlyTotalSoldUnits: 4730,
      monthlyData: [
        { month: "january", totalSales: 50, totalUnits: 164 },
        { month: "february", totalSales: 61, totalUnits: 232 },
        { month: "march", totalSales: 75, totalUnits: 54 },
        { month: "april", totalSales: 996, totalUnits: 272 },
        { month: "may", totalSales: 193, totalUnits: 393 },
        { month: "june", totalSales: 176, totalUnits: 274 },
        { month: "july", totalSales: 742, totalUnits: 158 },
        { month: "august", totalSales: 242, totalUnits: 294 },
        { month: "september", totalSales: 440, totalUnits: 230 },
        { month: "october", totalSales: 105, totalUnits: 175 },
        { month: "november", totalSales: 578, totalUnits: 31 },
        { month: "december", totalSales: 935, totalUnits: 387 },
      ],
      dailyData: [
        { date: "2021-01-02", totalSales: 17, totalUnits: 4 },
        { date: "2021-01-03", totalSales: 62, totalUnits: 36 },
        { date: "2021-01-04", totalSales: 87, totalUnits: 15 },
        { date: "2021-01-05", totalSales: 1, totalUnits: 8 },
        { date: "2021-01-06", totalSales: 18, totalUnits: 11 },
        { date: "2021-01-07", totalSales: 75, totalUnits: 42 },
        { date: "2021-01-08", totalSales: 72, totalUnits: 9 },
        { date: "2021-01-09", totalSales: 11, totalUnits: 32 },
        { date: "2021-01-10", totalSales: 51, totalUnits: 29 },
        { date: "2021-01-11", totalSales: 43, totalUnits: 4 },
        { date: "2021-01-12", totalSales: 24, totalUnits: 37 },
        { date: "2021-01-13", totalSales: 82, totalUnits: 16 },
        { date: "2021-01-14", totalSales: 62, totalUnits: 2 },
        { date: "2021-01-15", totalSales: 62, totalUnits: 45 },
        { date: "2021-01-16", totalSales: 70, totalUnits: 10 },
        { date: "2021-01-17", totalSales: 16, totalUnits: 36 },
        { date: "2021-01-18", totalSales: 70, totalUnits: 50 },
        { date: "2021-01-19", totalSales: 18, totalUnits: 8 },
        { date: "2021-01-20", totalSales: 98, totalUnits: 13 },
        { date: "2021-01-21", totalSales: 2, totalUnits: 24 },
        { date: "2021-01-22", totalSales: 70, totalUnits: 26 },
        { date: "2021-01-23", totalSales: 19, totalUnits: 38 },
        { date: "2021-01-24", totalSales: 79, totalUnits: 5 },
        { date: "2021-01-25", totalSales: 54, totalUnits: 35 },
        { date: "2021-01-26", totalSales: 30, totalUnits: 12 },
        { date: "2021-01-27", totalSales: 79, totalUnits: 40 },
        { date: "2021-01-28", totalSales: 70, totalUnits: 42 },
        { date: "2021-01-29", totalSales: 36, totalUnits: 37 },
        { date: "2021-01-30", totalSales: 92, totalUnits: 18 },
        { date: "2021-01-31", totalSales: 20, totalUnits: 23 },
        { date: "2021-02-01", totalSales: 23, totalUnits: 19 },
        { date: "2021-02-02", totalSales: 24, totalUnits: 32 },
        { date: "2021-02-03", totalSales: 18, totalUnits: 27 },
        { date: "2021-02-04", totalSales: 76, totalUnits: 23 },
        { date: "2021-02-05", totalSales: 29, totalUnits: 44 },
        { date: "2021-02-06", totalSales: 35, totalUnits: 41 },
        { date: "2021-02-07", totalSales: 64, totalUnits: 43 },
        { date: "2021-02-08", totalSales: 28, totalUnits: 2 },
        { date: "2021-02-09", totalSales: 54, totalUnits: 6 },
        { date: "2021-02-10", totalSales: 37, totalUnits: 44 },
        { date: "2021-02-11", totalSales: 50, totalUnits: 25 },
        { date: "2021-02-12", totalSales: 99, totalUnits: 15 },
        { date: "2021-02-13", totalSales: 84, totalUnits: 45 },
        { date: "2021-02-14", totalSales: 44, totalUnits: 13 },
        { date: "2021-02-15", totalSales: 38, totalUnits: 33 },
        { date: "2021-02-16", totalSales: 39, totalUnits: 27 },
        { date: "2021-02-17", totalSales: 33, totalUnits: 36 },
        { date: "2021-02-18", totalSales: 5, totalUnits: 25 },
        { date: "2021-02-19", totalSales: 51, totalUnits: 39 },
        { date: "2021-02-20", totalSales: 40, totalUnits: 47 },
        { date: "2021-02-21", totalSales: 51, totalUnits: 37 },
        { date: "2021-02-22", totalSales: 16, totalUnits: 26 },
        { date: "2021-02-23", totalSales: 96, totalUnits: 45 },
        { date: "2021-02-24", totalSales: 70, totalUnits: 6 },
        { date: "2021-02-25", totalSales: 38, totalUnits: 26 },
        { date: "2021-02-26", totalSales: 30, totalUnits: 33 },
        { date: "2021-02-27", totalSales: 12, totalUnits: 46 },
        { date: "2021-02-28", totalSales: 41, totalUnits: 14 },
        { date: "2021-03-01", totalSales: 38, totalUnits: 27 },
        { date: "2021-03-02", totalSales: 27, totalUnits: 27 },
        { date: "2021-03-03", totalSales: 81, totalUnits: 37 },
        { date: "2021-03-04", totalSales: 76, totalUnits: 2 },
        { date: "2021-03-05", totalSales: 22, totalUnits: 30 },
        { date: "2021-03-06", totalSales: 59, totalUnits: 37 },
        { date: "2021-03-07", totalSales: 94, totalUnits: 19 },
        { date: "2021-03-08", totalSales: 79, totalUnits: 39 },
        { date: "2021-03-09", totalSales: 79, totalUnits: 9 },
        { date: "2021-03-10", totalSales: 77, totalUnits: 2 },
        { date: "2021-03-11", totalSales: 31, totalUnits: 34 },
        { date: "2021-03-12", totalSales: 25, totalUnits: 26 },
        { date: "2021-03-13", totalSales: 90, totalUnits: 26 },
        { date: "2021-03-14", totalSales: 72, totalUnits: 16 },
        { date: "2021-03-15", totalSales: 86, totalUnits: 3 },
        { date: "2021-03-16", totalSales: 25, totalUnits: 11 },
        { date: "2021-03-17", totalSales: 18, totalUnits: 16 },
        { date: "2021-03-18", totalSales: 28, totalUnits: 44 },
        { date: "2021-03-19", totalSales: 94, totalUnits: 47 },
        { date: "2021-03-20", totalSales: 63, totalUnits: 1 },
        { date: "2021-03-21", totalSales: 75, totalUnits: 45 },
        { date: "2021-03-22", totalSales: 80, totalUnits: 27 },
        { date: "2021-03-23", totalSales: 62, totalUnits: 46 },
        { date: "2021-03-24", totalSales: 75, totalUnits: 40 },
        { date: "2021-03-25", totalSales: 59, totalUnits: 16 },
        { date: "2021-03-26", totalSales: 66, totalUnits: 48 },
        { date: "2021-03-27", totalSales: 9, totalUnits: 34 },
        { date: "2021-03-28", totalSales: 67, totalUnits: 25 },
        { date: "2021-03-29", totalSales: 97, totalUnits: 16 },
        { date: "2021-03-30", totalSales: 89, totalUnits: 32 },
        { date: "2021-03-31", totalSales: 24, totalUnits: 41 },
        { date: "2021-04-01", totalSales: 40, totalUnits: 26 },
        { date: "2021-04-02", totalSales: 98, totalUnits: 43 },
        { date: "2021-04-03", totalSales: 100, totalUnits: 45 },
        { date: "2021-04-04", totalSales: 15, totalUnits: 18 },
        { date: "2021-04-05", totalSales: 100, totalUnits: 49 },
        { date: "2021-04-06", totalSales: 84, totalUnits: 47 },
        { date: "2021-04-07", totalSales: 87, totalUnits: 41 },
        { date: "2021-04-08", totalSales: 2, totalUnits: 27 },
        { date: "2021-04-09", totalSales: 75, totalUnits: 15 },
        { date: "2021-04-10", totalSales: 96, totalUnits: 11 },
        { date: "2021-04-11", totalSales: 82, totalUnits: 47 },
        { date: "2021-04-12", totalSales: 64, totalUnits: 8 },
        { date: "2021-04-13", totalSales: 30, totalUnits: 2 },
        { date: "2021-04-14", totalSales: 52, totalUnits: 34 },
        { date: "2021-04-15", totalSales: 33, totalUnits: 17 },
        { date: "2021-04-16", totalSales: 76, totalUnits: 13 },
        { date: "2021-04-17", totalSales: 15, totalUnits: 35 },
        { date: "2021-04-18", totalSales: 20, totalUnits: 34 },
        { date: "2021-04-19", totalSales: 38, totalUnits: 38 },
        { date: "2021-04-20", totalSales: 79, totalUnits: 37 },
        { date: "2021-04-21", totalSales: 73, totalUnits: 25 },
        { date: "2021-04-22", totalSales: 48, totalUnits: 15 },
        { date: "2021-04-23", totalSales: 64, totalUnits: 16 },
        { date: "2021-04-24", totalSales: 5, totalUnits: 4 },
        { date: "2021-04-25", totalSales: 40, totalUnits: 35 },
        { date: "2021-04-26", totalSales: 13, totalUnits: 8 },
        { date: "2021-04-27", totalSales: 2, totalUnits: 35 },
        { date: "2021-04-28", totalSales: 8, totalUnits: 50 },
        { date: "2021-04-29", totalSales: 7, totalUnits: 9 },
        { date: "2021-04-30", totalSales: 3, totalUnits: 12 },
        { date: "2021-05-01", totalSales: 18, totalUnits: 7 },
        { date: "2021-05-02", totalSales: 18, totalUnits: 13 },
        { date: "2021-05-03", totalSales: 7, totalUnits: 24 },
        { date: "2021-05-04", totalSales: 58, totalUnits: 44 },
        { date: "2021-05-05", totalSales: 51, totalUnits: 34 },
        { date: "2021-05-06", totalSales: 81, totalUnits: 47 },
        { date: "2021-05-07", totalSales: 39, totalUnits: 15 },
        { date: "2021-05-08", totalSales: 34, totalUnits: 21 },
        { date: "2021-05-09", totalSales: 34, totalUnits: 26 },
        { date: "2021-05-10", totalSales: 37, totalUnits: 3 },
        { date: "2021-05-11", totalSales: 50, totalUnits: 7 },
        { date: "2021-05-12", totalSales: 60, totalUnits: 15 },
        { date: "2021-05-13", totalSales: 53, totalUnits: 26 },
        { date: "2021-05-14", totalSales: 91, totalUnits: 23 },
        { date: "2021-05-15", totalSales: 62, totalUnits: 45 },
        { date: "2021-05-16", totalSales: 12, totalUnits: 44 },
        { date: "2021-05-17", totalSales: 13, totalUnits: 12 },
        { date: "2021-05-18", totalSales: 74, totalUnits: 26 },
        { date: "2021-05-19", totalSales: 97, totalUnits: 1 },
        { date: "2021-05-20", totalSales: 25, totalUnits: 6 },
        { date: "2021-05-21", totalSales: 75, totalUnits: 3 },
        { date: "2021-05-22", totalSales: 85, totalUnits: 22 },
        { date: "2021-05-23", totalSales: 10, totalUnits: 27 },
        { date: "2021-05-24", totalSales: 89, totalUnits: 49 },
        { date: "2021-05-25", totalSales: 24, totalUnits: 34 },
        { date: "2021-05-26", totalSales: 39, totalUnits: 26 },
        { date: "2021-05-27", totalSales: 54, totalUnits: 1 },
        { date: "2021-05-28", totalSales: 71, totalUnits: 43 },
        { date: "2021-05-29", totalSales: 65, totalUnits: 4 },
        { date: "2021-05-30", totalSales: 83, totalUnits: 39 },
        { date: "2021-05-31", totalSales: 17, totalUnits: 27 },
        { date: "2021-06-01", totalSales: 63, totalUnits: 32 },
        { date: "2021-06-02", totalSales: 74, totalUnits: 7 },
        { date: "2021-06-03", totalSales: 85, totalUnits: 3 },
        { date: "2021-06-04", totalSales: 45, totalUnits: 23 },
        { date: "2021-06-05", totalSales: 69, totalUnits: 5 },
        { date: "2021-06-06", totalSales: 82, totalUnits: 38 },
        { date: "2021-06-07", totalSales: 100, totalUnits: 30 },
        { date: "2021-06-08", totalSales: 10, totalUnits: 48 },
        { date: "2021-06-09", totalSales: 47, totalUnits: 31 },
        { date: "2021-06-10", totalSales: 57, totalUnits: 14 },
        { date: "2021-06-11", totalSales: 32, totalUnits: 42 },
        { date: "2021-06-12", totalSales: 64, totalUnits: 14 },
        { date: "2021-06-13", totalSales: 82, totalUnits: 15 },
        { date: "2021-06-14", totalSales: 28, totalUnits: 12 },
        { date: "2021-06-15", totalSales: 14, totalUnits: 12 },
        { date: "2021-06-16", totalSales: 54, totalUnits: 9 },
        { date: "2021-06-17", totalSales: 75, totalUnits: 44 },
        { date: "2021-06-18", totalSales: 34, totalUnits: 44 },
        { date: "2021-06-19", totalSales: 7, totalUnits: 21 },
        { date: "2021-06-20", totalSales: 80, totalUnits: 33 },
        { date: "2021-06-21", totalSales: 42, totalUnits: 42 },
        { date: "2021-06-22", totalSales: 24, totalUnits: 6 },
        { date: "2021-06-23", totalSales: 18, totalUnits: 2 },
        { date: "2021-06-24", totalSales: 92, totalUnits: 25 },
        { date: "2021-06-25", totalSales: 26, totalUnits: 19 },
        { date: "2021-06-26", totalSales: 32, totalUnits: 43 },
        { date: "2021-06-27", totalSales: 47, totalUnits: 4 },
        { date: "2021-06-28", totalSales: 27, totalUnits: 49 },
        { date: "2021-06-29", totalSales: 93, totalUnits: 4 },
        { date: "2021-06-30", totalSales: 85, totalUnits: 13 },
        { date: "2021-07-01", totalSales: 3, totalUnits: 14 },
        { date: "2021-07-02", totalSales: 55, totalUnits: 13 },
        { date: "2021-07-03", totalSales: 70, totalUnits: 41 },
        { date: "2021-07-04", totalSales: 72, totalUnits: 2 },
        { date: "2021-07-05", totalSales: 75, totalUnits: 14 },
        { date: "2021-07-06", totalSales: 6, totalUnits: 7 },
        { date: "2021-07-07", totalSales: 42, totalUnits: 34 },
        { date: "2021-07-08", totalSales: 27, totalUnits: 15 },
        { date: "2021-07-09", totalSales: 2, totalUnits: 30 },
        { date: "2021-07-10", totalSales: 10, totalUnits: 50 },
        { date: "2021-07-11", totalSales: 70, totalUnits: 30 },
        { date: "2021-07-12", totalSales: 29, totalUnits: 48 },
        { date: "2021-07-13", totalSales: 1, totalUnits: 15 },
        { date: "2021-07-14", totalSales: 12, totalUnits: 27 },
        { date: "2021-07-15", totalSales: 57, totalUnits: 50 },
        { date: "2021-07-16", totalSales: 73, totalUnits: 40 },
        { date: "2021-07-17", totalSales: 72, totalUnits: 13 },
        { date: "2021-07-18", totalSales: 69, totalUnits: 3 },
        { date: "2021-07-19", totalSales: 40, totalUnits: 2 },
        { date: "2021-07-20", totalSales: 23, totalUnits: 7 },
        { date: "2021-07-21", totalSales: 25, totalUnits: 29 },
        { date: "2021-07-22", totalSales: 4, totalUnits: 5 },
        { date: "2021-07-23", totalSales: 24, totalUnits: 8 },
        { date: "2021-07-24", totalSales: 36, totalUnits: 22 },
        { date: "2021-07-25", totalSales: 14, totalUnits: 14 },
        { date: "2021-07-26", totalSales: 74, totalUnits: 42 },
        { date: "2021-07-27", totalSales: 35, totalUnits: 10 },
        { date: "2021-07-28", totalSales: 84, totalUnits: 31 },
        { date: "2021-07-29", totalSales: 90, totalUnits: 33 },
        { date: "2021-07-30", totalSales: 4, totalUnits: 37 },
        { date: "2021-07-31", totalSales: 1, totalUnits: 6 },
        { date: "2021-08-01", totalSales: 14, totalUnits: 20 },
        { date: "2021-08-02", totalSales: 50, totalUnits: 44 },
        { date: "2021-08-03", totalSales: 79, totalUnits: 45 },
        { date: "2021-08-04", totalSales: 31, totalUnits: 20 },
        { date: "2021-08-05", totalSales: 13, totalUnits: 18 },
        { date: "2021-08-06", totalSales: 69, totalUnits: 36 },
        { date: "2021-08-07", totalSales: 36, totalUnits: 21 },
        { date: "2021-08-08", totalSales: 72, totalUnits: 24 },
        { date: "2021-08-09", totalSales: 42, totalUnits: 11 },
        { date: "2021-08-10", totalSales: 14, totalUnits: 18 },
        { date: "2021-08-11", totalSales: 16, totalUnits: 31 },
        { date: "2021-08-12", totalSales: 77, totalUnits: 13 },
        { date: "2021-08-13", totalSales: 26, totalUnits: 37 },
        { date: "2021-08-14", totalSales: 95, totalUnits: 3 },
        { date: "2021-08-15", totalSales: 88, totalUnits: 10 },
        { date: "2021-08-16", totalSales: 87, totalUnits: 25 },
        { date: "2021-08-17", totalSales: 55, totalUnits: 34 },
        { date: "2021-08-18", totalSales: 42, totalUnits: 13 },
        { date: "2021-08-19", totalSales: 64, totalUnits: 46 },
        { date: "2021-08-20", totalSales: 62, totalUnits: 32 },
        { date: "2021-08-21", totalSales: 78, totalUnits: 1 },
        { date: "2021-08-22", totalSales: 48, totalUnits: 13 },
        { date: "2021-08-23", totalSales: 24, totalUnits: 17 },
        { date: "2021-08-24", totalSales: 19, totalUnits: 7 },
        { date: "2021-08-25", totalSales: 43, totalUnits: 11 },
        { date: "2021-08-26", totalSales: 68, totalUnits: 49 },
        { date: "2021-08-27", totalSales: 29, totalUnits: 13 },
        { date: "2021-08-28", totalSales: 3, totalUnits: 14 },
        { date: "2021-08-29", totalSales: 91, totalUnits: 18 },
        { date: "2021-08-30", totalSales: 71, totalUnits: 46 },
        { date: "2021-08-31", totalSales: 36, totalUnits: 23 },
        { date: "2021-09-01", totalSales: 76, totalUnits: 12 },
        { date: "2021-09-02", totalSales: 63, totalUnits: 40 },
        { date: "2021-09-03", totalSales: 62, totalUnits: 28 },
        { date: "2021-09-04", totalSales: 72, totalUnits: 19 },
        { date: "2021-09-05", totalSales: 25, totalUnits: 23 },
        { date: "2021-09-06", totalSales: 20, totalUnits: 25 },
        { date: "2021-09-07", totalSales: 91, totalUnits: 28 },
        { date: "2021-09-08", totalSales: 13, totalUnits: 7 },
        { date: "2021-09-09", totalSales: 47, totalUnits: 40 },
        { date: "2021-09-10", totalSales: 26, totalUnits: 9 },
        { date: "2021-09-11", totalSales: 50, totalUnits: 41 },
        { date: "2021-09-12", totalSales: 40, totalUnits: 4 },
        { date: "2021-09-13", totalSales: 44, totalUnits: 28 },
        { date: "2021-09-14", totalSales: 58, totalUnits: 14 },
        { date: "2021-09-15", totalSales: 26, totalUnits: 43 },
        { date: "2021-09-16", totalSales: 65, totalUnits: 35 },
        { date: "2021-09-17", totalSales: 87, totalUnits: 49 },
        { date: "2021-09-18", totalSales: 84, totalUnits: 38 },
        { date: "2021-09-19", totalSales: 56, totalUnits: 15 },
        { date: "2021-09-20", totalSales: 94, totalUnits: 24 },
        { date: "2021-09-21", totalSales: 89, totalUnits: 40 },
        { date: "2021-09-22", totalSales: 74, totalUnits: 12 },
        { date: "2021-09-23", totalSales: 20, totalUnits: 36 },
        { date: "2021-09-24", totalSales: 86, totalUnits: 9 },
        { date: "2021-09-25", totalSales: 9, totalUnits: 8 },
        { date: "2021-09-26", totalSales: 31, totalUnits: 11 },
        { date: "2021-09-27", totalSales: 2, totalUnits: 7 },
        { date: "2021-09-28", totalSales: 13, totalUnits: 12 },
        { date: "2021-09-29", totalSales: 5, totalUnits: 16 },
        { date: "2021-09-30", totalSales: 83, totalUnits: 39 },
        { date: "2021-10-01", totalSales: 78, totalUnits: 30 },
        { date: "2021-10-02", totalSales: 45, totalUnits: 24 },
        { date: "2021-10-03", totalSales: 60, totalUnits: 13 },
        { date: "2021-10-04", totalSales: 29, totalUnits: 46 },
        { date: "2021-10-05", totalSales: 85, totalUnits: 12 },
        { date: "2021-10-06", totalSales: 94, totalUnits: 48 },
        { date: "2021-10-07", totalSales: 61, totalUnits: 42 },
        { date: "2021-10-08", totalSales: 20, totalUnits: 6 },
        { date: "2021-10-09", totalSales: 57, totalUnits: 25 },
        { date: "2021-10-10", totalSales: 1, totalUnits: 40 },
        { date: "2021-10-11", totalSales: 21, totalUnits: 50 },
        { date: "2021-10-12", totalSales: 48, totalUnits: 39 },
        { date: "2021-10-13", totalSales: 75, totalUnits: 46 },
        { date: "2021-10-14", totalSales: 83, totalUnits: 16 },
        { date: "2021-10-15", totalSales: 18, totalUnits: 28 },
        { date: "2021-10-16", totalSales: 82, totalUnits: 47 },
        { date: "2021-10-17", totalSales: 57, totalUnits: 39 },
        { date: "2021-10-18", totalSales: 55, totalUnits: 44 },
        { date: "2021-10-19", totalSales: 81, totalUnits: 49 },
        { date: "2021-10-20", totalSales: 65, totalUnits: 12 },
        { date: "2021-10-21", totalSales: 39, totalUnits: 34 },
        { date: "2021-10-22", totalSales: 59, totalUnits: 6 },
        { date: "2021-10-23", totalSales: 59, totalUnits: 33 },
        { date: "2021-10-24", totalSales: 100, totalUnits: 45 },
        { date: "2021-10-25", totalSales: 51, totalUnits: 26 },
        { date: "2021-10-26", totalSales: 22, totalUnits: 34 },
        { date: "2021-10-27", totalSales: 19, totalUnits: 16 },
        { date: "2021-10-28", totalSales: 81, totalUnits: 50 },
        { date: "2021-10-29", totalSales: 23, totalUnits: 25 },
        { date: "2021-10-30", totalSales: 28, totalUnits: 49 },
        { date: "2021-10-31", totalSales: 97, totalUnits: 10 },
        { date: "2021-11-01", totalSales: 74, totalUnits: 12 },
        { date: "2021-11-02", totalSales: 13, totalUnits: 14 },
        { date: "2021-11-03", totalSales: 43, totalUnits: 21 },
        { date: "2021-11-04", totalSales: 53, totalUnits: 24 },
        { date: "2021-11-05", totalSales: 37, totalUnits: 13 },
        { date: "2021-11-06", totalSales: 33, totalUnits: 44 },
        { date: "2021-11-07", totalSales: 26, totalUnits: 6 },
        { date: "2021-11-08", totalSales: 55, totalUnits: 32 },
        { date: "2021-11-09", totalSales: 43, totalUnits: 45 },
        { date: "2021-11-10", totalSales: 97, totalUnits: 13 },
        { date: "2021-11-11", totalSales: 66, totalUnits: 22 },
        { date: "2021-11-12", totalSales: 83, totalUnits: 5 },
        { date: "2021-11-13", totalSales: 80, totalUnits: 5 },
        { date: "2021-11-14", totalSales: 97, totalUnits: 26 },
        { date: "2021-11-15", totalSales: 14, totalUnits: 37 },
        { date: "2021-11-16", totalSales: 87, totalUnits: 20 },
        { date: "2021-11-17", totalSales: 23, totalUnits: 6 },
      ],
    },
    {
      _id: "6371259ff03239d40b0000db",
      productId: "63701d24f032395b3300012d",
      yearlySalesTotal: 5256,
      yearlyTotalSoldUnits: 4776,
      monthlyData: [
        { month: "january", totalSales: 909, totalUnits: 122 },
        { month: "february", totalSales: 677, totalUnits: 182 },
        { month: "march", totalSales: 832, totalUnits: 259 },
        { month: "april", totalSales: 780, totalUnits: 153 },
        { month: "may", totalSales: 537, totalUnits: 421 },
        { month: "june", totalSales: 103, totalUnits: 461 },
        { month: "july", totalSales: 931, totalUnits: 270 },
        { month: "august", totalSales: 309, totalUnits: 330 },
        { month: "september", totalSales: 206, totalUnits: 100 },
        { month: "october", totalSales: 634, totalUnits: 79 },
        { month: "november", totalSales: 269, totalUnits: 110 },
        { month: "december", totalSales: 892, totalUnits: 228 },
      ],
      dailyData: [
        { date: "2021-01-02", totalSales: 53, totalUnits: 22 },
        { date: "2021-01-03", totalSales: 1, totalUnits: 42 },
        { date: "2021-01-04", totalSales: 81, totalUnits: 33 },
        { date: "2021-01-05", totalSales: 83, totalUnits: 45 },
        { date: "2021-01-06", totalSales: 39, totalUnits: 20 },
        { date: "2021-01-07", totalSales: 36, totalUnits: 2 },
        { date: "2021-01-08", totalSales: 46, totalUnits: 1 },
        { date: "2021-01-09", totalSales: 71, totalUnits: 42 },
        { date: "2021-01-10", totalSales: 92, totalUnits: 29 },
        { date: "2021-01-11", totalSales: 25, totalUnits: 26 },
        { date: "2021-01-12", totalSales: 58, totalUnits: 35 },
        { date: "2021-01-13", totalSales: 51, totalUnits: 23 },
        { date: "2021-01-14", totalSales: 68, totalUnits: 49 },
        { date: "2021-01-15", totalSales: 70, totalUnits: 6 },
        { date: "2021-01-16", totalSales: 35, totalUnits: 41 },
        { date: "2021-01-17", totalSales: 8, totalUnits: 18 },
        { date: "2021-01-18", totalSales: 61, totalUnits: 36 },
        { date: "2021-01-19", totalSales: 43, totalUnits: 35 },
        { date: "2021-01-20", totalSales: 91, totalUnits: 23 },
        { date: "2021-01-21", totalSales: 68, totalUnits: 32 },
        { date: "2021-01-22", totalSales: 35, totalUnits: 41 },
        { date: "2021-01-23", totalSales: 53, totalUnits: 48 },
        { date: "2021-01-24", totalSales: 3, totalUnits: 49 },
        { date: "2021-01-25", totalSales: 95, totalUnits: 16 },
        { date: "2021-01-26", totalSales: 71, totalUnits: 47 },
        { date: "2021-01-27", totalSales: 7, totalUnits: 4 },
        { date: "2021-01-28", totalSales: 19, totalUnits: 27 },
        { date: "2021-01-29", totalSales: 94, totalUnits: 3 },
        { date: "2021-01-30", totalSales: 81, totalUnits: 30 },
        { date: "2021-01-31", totalSales: 35, totalUnits: 4 },
        { date: "2021-02-01", totalSales: 38, totalUnits: 48 },
        { date: "2021-02-02", totalSales: 61, totalUnits: 3 },
        { date: "2021-02-03", totalSales: 99, totalUnits: 23 },
        { date: "2021-02-04", totalSales: 49, totalUnits: 9 },
        { date: "2021-02-05", totalSales: 81, totalUnits: 28 },
        { date: "2021-02-06", totalSales: 67, totalUnits: 21 },
        { date: "2021-02-07", totalSales: 84, totalUnits: 38 },
        { date: "2021-02-08", totalSales: 66, totalUnits: 35 },
        { date: "2021-02-09", totalSales: 45, totalUnits: 7 },
        { date: "2021-02-10", totalSales: 79, totalUnits: 36 },
        { date: "2021-02-11", totalSales: 51, totalUnits: 2 },
        { date: "2021-02-12", totalSales: 7, totalUnits: 43 },
        { date: "2021-02-13", totalSales: 18, totalUnits: 37 },
        { date: "2021-02-14", totalSales: 82, totalUnits: 47 },
        { date: "2021-02-15", totalSales: 100, totalUnits: 10 },
        { date: "2021-02-16", totalSales: 42, totalUnits: 25 },
        { date: "2021-02-17", totalSales: 44, totalUnits: 9 },
        { date: "2021-02-18", totalSales: 47, totalUnits: 12 },
        { date: "2021-02-19", totalSales: 31, totalUnits: 35 },
        { date: "2021-02-20", totalSales: 67, totalUnits: 16 },
        { date: "2021-02-21", totalSales: 64, totalUnits: 4 },
        { date: "2021-02-22", totalSales: 40, totalUnits: 42 },
        { date: "2021-02-23", totalSales: 84, totalUnits: 47 },
        { date: "2021-02-24", totalSales: 83, totalUnits: 26 },
        { date: "2021-02-25", totalSales: 87, totalUnits: 30 },
        { date: "2021-02-26", totalSales: 97, totalUnits: 20 },
        { date: "2021-02-27", totalSales: 20, totalUnits: 18 },
        { date: "2021-02-28", totalSales: 61, totalUnits: 38 },
        { date: "2021-03-01", totalSales: 62, totalUnits: 48 },
        { date: "2021-03-02", totalSales: 77, totalUnits: 1 },
        { date: "2021-03-03", totalSales: 23, totalUnits: 22 },
        { date: "2021-03-04", totalSales: 77, totalUnits: 38 },
        { date: "2021-03-05", totalSales: 42, totalUnits: 21 },
        { date: "2021-03-06", totalSales: 85, totalUnits: 18 },
        { date: "2021-03-07", totalSales: 86, totalUnits: 47 },
        { date: "2021-03-08", totalSales: 63, totalUnits: 26 },
        { date: "2021-03-09", totalSales: 96, totalUnits: 3 },
        { date: "2021-03-10", totalSales: 35, totalUnits: 15 },
        { date: "2021-03-11", totalSales: 71, totalUnits: 29 },
        { date: "2021-03-12", totalSales: 94, totalUnits: 22 },
        { date: "2021-03-13", totalSales: 48, totalUnits: 50 },
        { date: "2021-03-14", totalSales: 52, totalUnits: 37 },
        { date: "2021-03-15", totalSales: 32, totalUnits: 28 },
        { date: "2021-03-16", totalSales: 100, totalUnits: 27 },
        { date: "2021-03-17", totalSales: 10, totalUnits: 16 },
        { date: "2021-03-18", totalSales: 95, totalUnits: 36 },
        { date: "2021-03-19", totalSales: 25, totalUnits: 42 },
        { date: "2021-03-20", totalSales: 51, totalUnits: 43 },
        { date: "2021-03-21", totalSales: 75, totalUnits: 38 },
        { date: "2021-03-22", totalSales: 52, totalUnits: 10 },
        { date: "2021-03-23", totalSales: 41, totalUnits: 26 },
        { date: "2021-03-24", totalSales: 53, totalUnits: 13 },
        { date: "2021-03-25", totalSales: 35, totalUnits: 33 },
        { date: "2021-03-26", totalSales: 41, totalUnits: 9 },
        { date: "2021-03-27", totalSales: 3, totalUnits: 3 },
        { date: "2021-03-28", totalSales: 18, totalUnits: 46 },
        { date: "2021-03-29", totalSales: 20, totalUnits: 12 },
        { date: "2021-03-30", totalSales: 28, totalUnits: 28 },
        { date: "2021-03-31", totalSales: 2, totalUnits: 36 },
        { date: "2021-04-01", totalSales: 37, totalUnits: 25 },
        { date: "2021-04-02", totalSales: 37, totalUnits: 47 },
        { date: "2021-04-03", totalSales: 100, totalUnits: 14 },
        { date: "2021-04-04", totalSales: 59, totalUnits: 4 },
        { date: "2021-04-05", totalSales: 16, totalUnits: 38 },
        { date: "2021-04-06", totalSales: 97, totalUnits: 14 },
        { date: "2021-04-07", totalSales: 65, totalUnits: 30 },
        { date: "2021-04-08", totalSales: 62, totalUnits: 37 },
        { date: "2021-04-09", totalSales: 90, totalUnits: 35 },
        { date: "2021-04-10", totalSales: 3, totalUnits: 40 },
        { date: "2021-04-11", totalSales: 47, totalUnits: 48 },
        { date: "2021-04-12", totalSales: 97, totalUnits: 11 },
        { date: "2021-04-13", totalSales: 77, totalUnits: 12 },
        { date: "2021-04-14", totalSales: 60, totalUnits: 22 },
        { date: "2021-04-15", totalSales: 10, totalUnits: 13 },
        { date: "2021-04-16", totalSales: 69, totalUnits: 28 },
        { date: "2021-04-17", totalSales: 68, totalUnits: 16 },
        { date: "2021-04-18", totalSales: 51, totalUnits: 29 },
        { date: "2021-04-19", totalSales: 26, totalUnits: 18 },
        { date: "2021-04-20", totalSales: 36, totalUnits: 16 },
        { date: "2021-04-21", totalSales: 90, totalUnits: 29 },
        { date: "2021-04-22", totalSales: 99, totalUnits: 28 },
        { date: "2021-04-23", totalSales: 50, totalUnits: 20 },
        { date: "2021-04-24", totalSales: 46, totalUnits: 3 },
        { date: "2021-04-25", totalSales: 72, totalUnits: 3 },
        { date: "2021-04-26", totalSales: 43, totalUnits: 24 },
        { date: "2021-04-27", totalSales: 99, totalUnits: 1 },
        { date: "2021-04-28", totalSales: 5, totalUnits: 18 },
        { date: "2021-04-29", totalSales: 69, totalUnits: 27 },
        { date: "2021-04-30", totalSales: 21, totalUnits: 12 },
        { date: "2021-05-01", totalSales: 82, totalUnits: 12 },
        { date: "2021-05-02", totalSales: 3, totalUnits: 41 },
        { date: "2021-05-03", totalSales: 82, totalUnits: 41 },
        { date: "2021-05-04", totalSales: 43, totalUnits: 28 },
        { date: "2021-05-05", totalSales: 58, totalUnits: 37 },
        { date: "2021-05-06", totalSales: 27, totalUnits: 14 },
        { date: "2021-05-07", totalSales: 75, totalUnits: 26 },
        { date: "2021-05-08", totalSales: 51, totalUnits: 39 },
        { date: "2021-05-09", totalSales: 56, totalUnits: 38 },
        { date: "2021-05-10", totalSales: 30, totalUnits: 35 },
        { date: "2021-05-11", totalSales: 80, totalUnits: 36 },
        { date: "2021-05-12", totalSales: 51, totalUnits: 11 },
        { date: "2021-05-13", totalSales: 65, totalUnits: 9 },
        { date: "2021-05-14", totalSales: 97, totalUnits: 25 },
        { date: "2021-05-15", totalSales: 82, totalUnits: 19 },
        { date: "2021-05-16", totalSales: 31, totalUnits: 7 },
        { date: "2021-05-17", totalSales: 11, totalUnits: 42 },
        { date: "2021-05-18", totalSales: 41, totalUnits: 5 },
        { date: "2021-05-19", totalSales: 34, totalUnits: 34 },
        { date: "2021-05-20", totalSales: 19, totalUnits: 1 },
        { date: "2021-05-21", totalSales: 59, totalUnits: 44 },
        { date: "2021-05-22", totalSales: 54, totalUnits: 5 },
        { date: "2021-05-23", totalSales: 91, totalUnits: 14 },
        { date: "2021-05-24", totalSales: 36, totalUnits: 31 },
        { date: "2021-05-25", totalSales: 51, totalUnits: 2 },
        { date: "2021-05-26", totalSales: 23, totalUnits: 44 },
        { date: "2021-05-27", totalSales: 65, totalUnits: 16 },
        { date: "2021-05-28", totalSales: 4, totalUnits: 17 },
        { date: "2021-05-29", totalSales: 84, totalUnits: 25 },
        { date: "2021-05-30", totalSales: 79, totalUnits: 47 },
        { date: "2021-05-31", totalSales: 41, totalUnits: 13 },
        { date: "2021-06-01", totalSales: 8, totalUnits: 39 },
        { date: "2021-06-02", totalSales: 75, totalUnits: 6 },
        { date: "2021-06-03", totalSales: 67, totalUnits: 28 },
        { date: "2021-06-04", totalSales: 67, totalUnits: 41 },
        { date: "2021-06-05", totalSales: 14, totalUnits: 13 },
        { date: "2021-06-06", totalSales: 14, totalUnits: 28 },
        { date: "2021-06-07", totalSales: 17, totalUnits: 30 },
        { date: "2021-06-08", totalSales: 18, totalUnits: 26 },
        { date: "2021-06-09", totalSales: 40, totalUnits: 15 },
        { date: "2021-06-10", totalSales: 91, totalUnits: 4 },
        { date: "2021-06-11", totalSales: 3, totalUnits: 20 },
        { date: "2021-06-12", totalSales: 98, totalUnits: 29 },
        { date: "2021-06-13", totalSales: 2, totalUnits: 15 },
        { date: "2021-06-14", totalSales: 2, totalUnits: 12 },
        { date: "2021-06-15", totalSales: 96, totalUnits: 34 },
        { date: "2021-06-16", totalSales: 95, totalUnits: 14 },
        { date: "2021-06-17", totalSales: 71, totalUnits: 37 },
        { date: "2021-06-18", totalSales: 33, totalUnits: 18 },
        { date: "2021-06-19", totalSales: 90, totalUnits: 6 },
        { date: "2021-06-20", totalSales: 42, totalUnits: 5 },
        { date: "2021-06-21", totalSales: 85, totalUnits: 36 },
        { date: "2021-06-22", totalSales: 39, totalUnits: 33 },
        { date: "2021-06-23", totalSales: 79, totalUnits: 5 },
        { date: "2021-06-24", totalSales: 88, totalUnits: 14 },
        { date: "2021-06-25", totalSales: 2, totalUnits: 15 },
        { date: "2021-06-26", totalSales: 11, totalUnits: 29 },
        { date: "2021-06-27", totalSales: 84, totalUnits: 39 },
        { date: "2021-06-28", totalSales: 17, totalUnits: 28 },
        { date: "2021-06-29", totalSales: 35, totalUnits: 14 },
        { date: "2021-06-30", totalSales: 93, totalUnits: 44 },
        { date: "2021-07-01", totalSales: 69, totalUnits: 30 },
        { date: "2021-07-02", totalSales: 40, totalUnits: 13 },
        { date: "2021-07-03", totalSales: 49, totalUnits: 5 },
        { date: "2021-07-04", totalSales: 72, totalUnits: 18 },
        { date: "2021-07-05", totalSales: 79, totalUnits: 34 },
        { date: "2021-07-06", totalSales: 15, totalUnits: 25 },
        { date: "2021-07-07", totalSales: 27, totalUnits: 7 },
        { date: "2021-07-08", totalSales: 23, totalUnits: 27 },
        { date: "2021-07-09", totalSales: 88, totalUnits: 22 },
        { date: "2021-07-10", totalSales: 39, totalUnits: 15 },
        { date: "2021-07-11", totalSales: 2, totalUnits: 13 },
        { date: "2021-07-12", totalSales: 32, totalUnits: 24 },
        { date: "2021-07-13", totalSales: 46, totalUnits: 39 },
        { date: "2021-07-14", totalSales: 93, totalUnits: 4 },
        { date: "2021-07-15", totalSales: 24, totalUnits: 48 },
        { date: "2021-07-16", totalSales: 13, totalUnits: 11 },
        { date: "2021-07-17", totalSales: 85, totalUnits: 28 },
        { date: "2021-07-18", totalSales: 60, totalUnits: 24 },
        { date: "2021-07-19", totalSales: 13, totalUnits: 47 },
        { date: "2021-07-20", totalSales: 46, totalUnits: 13 },
        { date: "2021-07-21", totalSales: 70, totalUnits: 21 },
        { date: "2021-07-22", totalSales: 86, totalUnits: 6 },
        { date: "2021-07-23", totalSales: 90, totalUnits: 15 },
        { date: "2021-07-24", totalSales: 16, totalUnits: 45 },
        { date: "2021-07-25", totalSales: 54, totalUnits: 9 },
        { date: "2021-07-26", totalSales: 69, totalUnits: 42 },
        { date: "2021-07-27", totalSales: 32, totalUnits: 34 },
        { date: "2021-07-28", totalSales: 41, totalUnits: 16 },
        { date: "2021-07-29", totalSales: 25, totalUnits: 13 },
        { date: "2021-07-30", totalSales: 18, totalUnits: 12 },
        { date: "2021-07-31", totalSales: 61, totalUnits: 3 },
        { date: "2021-08-01", totalSales: 25, totalUnits: 42 },
        { date: "2021-08-02", totalSales: 25, totalUnits: 28 },
        { date: "2021-08-03", totalSales: 91, totalUnits: 37 },
        { date: "2021-08-04", totalSales: 46, totalUnits: 18 },
        { date: "2021-08-05", totalSales: 3, totalUnits: 29 },
        { date: "2021-08-06", totalSales: 7, totalUnits: 2 },
        { date: "2021-08-07", totalSales: 28, totalUnits: 6 },
        { date: "2021-08-08", totalSales: 3, totalUnits: 33 },
        { date: "2021-08-09", totalSales: 39, totalUnits: 11 },
        { date: "2021-08-10", totalSales: 5, totalUnits: 21 },
        { date: "2021-08-11", totalSales: 62, totalUnits: 6 },
        { date: "2021-08-12", totalSales: 42, totalUnits: 33 },
        { date: "2021-08-13", totalSales: 63, totalUnits: 2 },
        { date: "2021-08-14", totalSales: 51, totalUnits: 25 },
        { date: "2021-08-15", totalSales: 96, totalUnits: 6 },
        { date: "2021-08-16", totalSales: 88, totalUnits: 22 },
        { date: "2021-08-17", totalSales: 19, totalUnits: 8 },
        { date: "2021-08-18", totalSales: 75, totalUnits: 47 },
        { date: "2021-08-19", totalSales: 34, totalUnits: 20 },
        { date: "2021-08-20", totalSales: 9, totalUnits: 22 },
        { date: "2021-08-21", totalSales: 51, totalUnits: 6 },
        { date: "2021-08-22", totalSales: 47, totalUnits: 47 },
        { date: "2021-08-23", totalSales: 74, totalUnits: 30 },
        { date: "2021-08-24", totalSales: 49, totalUnits: 42 },
        { date: "2021-08-25", totalSales: 24, totalUnits: 45 },
        { date: "2021-08-26", totalSales: 24, totalUnits: 13 },
        { date: "2021-08-27", totalSales: 98, totalUnits: 28 },
        { date: "2021-08-28", totalSales: 93, totalUnits: 26 },
        { date: "2021-08-29", totalSales: 83, totalUnits: 22 },
        { date: "2021-08-30", totalSales: 58, totalUnits: 49 },
        { date: "2021-08-31", totalSales: 59, totalUnits: 40 },
        { date: "2021-09-01", totalSales: 86, totalUnits: 33 },
        { date: "2021-09-02", totalSales: 62, totalUnits: 9 },
        { date: "2021-09-03", totalSales: 72, totalUnits: 15 },
        { date: "2021-09-04", totalSales: 32, totalUnits: 12 },
        { date: "2021-09-05", totalSales: 19, totalUnits: 36 },
        { date: "2021-09-06", totalSales: 33, totalUnits: 48 },
        { date: "2021-09-07", totalSales: 8, totalUnits: 38 },
        { date: "2021-09-08", totalSales: 8, totalUnits: 46 },
        { date: "2021-09-09", totalSales: 58, totalUnits: 45 },
        { date: "2021-09-10", totalSales: 15, totalUnits: 24 },
        { date: "2021-09-11", totalSales: 6, totalUnits: 7 },
        { date: "2021-09-12", totalSales: 4, totalUnits: 48 },
        { date: "2021-09-13", totalSales: 8, totalUnits: 10 },
        { date: "2021-09-14", totalSales: 22, totalUnits: 14 },
        { date: "2021-09-15", totalSales: 77, totalUnits: 9 },
        { date: "2021-09-16", totalSales: 69, totalUnits: 13 },
        { date: "2021-09-17", totalSales: 81, totalUnits: 44 },
        { date: "2021-09-18", totalSales: 66, totalUnits: 18 },
        { date: "2021-09-19", totalSales: 87, totalUnits: 8 },
        { date: "2021-09-20", totalSales: 7, totalUnits: 8 },
        { date: "2021-09-21", totalSales: 99, totalUnits: 26 },
        { date: "2021-09-22", totalSales: 28, totalUnits: 26 },
        { date: "2021-09-23", totalSales: 43, totalUnits: 45 },
        { date: "2021-09-24", totalSales: 72, totalUnits: 2 },
        { date: "2021-09-25", totalSales: 31, totalUnits: 28 },
        { date: "2021-09-26", totalSales: 11, totalUnits: 38 },
        { date: "2021-09-27", totalSales: 70, totalUnits: 31 },
        { date: "2021-09-28", totalSales: 84, totalUnits: 19 },
        { date: "2021-09-29", totalSales: 11, totalUnits: 34 },
        { date: "2021-09-30", totalSales: 47, totalUnits: 42 },
        { date: "2021-10-01", totalSales: 53, totalUnits: 34 },
        { date: "2021-10-02", totalSales: 42, totalUnits: 43 },
        { date: "2021-10-03", totalSales: 15, totalUnits: 1 },
        { date: "2021-10-04", totalSales: 94, totalUnits: 41 },
        { date: "2021-10-05", totalSales: 25, totalUnits: 27 },
        { date: "2021-10-06", totalSales: 35, totalUnits: 9 },
        { date: "2021-10-07", totalSales: 35, totalUnits: 32 },
        { date: "2021-10-08", totalSales: 85, totalUnits: 38 },
        { date: "2021-10-09", totalSales: 30, totalUnits: 35 },
        { date: "2021-10-10", totalSales: 50, totalUnits: 2 },
        { date: "2021-10-11", totalSales: 98, totalUnits: 49 },
        { date: "2021-10-12", totalSales: 31, totalUnits: 48 },
        { date: "2021-10-13", totalSales: 66, totalUnits: 3 },
        { date: "2021-10-14", totalSales: 14, totalUnits: 18 },
        { date: "2021-10-15", totalSales: 27, totalUnits: 5 },
        { date: "2021-10-16", totalSales: 97, totalUnits: 18 },
        { date: "2021-10-17", totalSales: 57, totalUnits: 22 },
        { date: "2021-10-18", totalSales: 17, totalUnits: 12 },
        { date: "2021-10-19", totalSales: 80, totalUnits: 42 },
        { date: "2021-10-20", totalSales: 87, totalUnits: 32 },
        { date: "2021-10-21", totalSales: 32, totalUnits: 40 },
        { date: "2021-10-22", totalSales: 2, totalUnits: 12 },
        { date: "2021-10-23", totalSales: 32, totalUnits: 4 },
        { date: "2021-10-24", totalSales: 39, totalUnits: 14 },
        { date: "2021-10-25", totalSales: 15, totalUnits: 1 },
        { date: "2021-10-26", totalSales: 86, totalUnits: 41 },
        { date: "2021-10-27", totalSales: 2, totalUnits: 10 },
        { date: "2021-10-28", totalSales: 56, totalUnits: 31 },
        { date: "2021-10-29", totalSales: 85, totalUnits: 41 },
        { date: "2021-10-30", totalSales: 90, totalUnits: 3 },
        { date: "2021-10-31", totalSales: 32, totalUnits: 14 },
        { date: "2021-11-01", totalSales: 22, totalUnits: 47 },
        { date: "2021-11-02", totalSales: 99, totalUnits: 13 },
        { date: "2021-11-03", totalSales: 20, totalUnits: 23 },
        { date: "2021-11-04", totalSales: 35, totalUnits: 46 },
        { date: "2021-11-05", totalSales: 83, totalUnits: 31 },
        { date: "2021-11-06", totalSales: 41, totalUnits: 23 },
        { date: "2021-11-07", totalSales: 80, totalUnits: 5 },
        { date: "2021-11-08", totalSales: 67, totalUnits: 40 },
        { date: "2021-11-09", totalSales: 83, totalUnits: 19 },
        { date: "2021-11-10", totalSales: 11, totalUnits: 43 },
        { date: "2021-11-11", totalSales: 71, totalUnits: 5 },
        { date: "2021-11-12", totalSales: 59, totalUnits: 22 },
        { date: "2021-11-13", totalSales: 58, totalUnits: 39 },
        { date: "2021-11-14", totalSales: 43, totalUnits: 30 },
        { date: "2021-11-15", totalSales: 9, totalUnits: 35 },
        { date: "2021-11-16", totalSales: 7, totalUnits: 40 },
        { date: "2021-11-17", totalSales: 10, totalUnits: 19 },
      ],
    },
    {
      _id: "637125a0f03239d40b0000dc",
      productId: "63701d25f03239d591000327",
      yearlySalesTotal: 2421,
      yearlyTotalSoldUnits: 4366,
      monthlyData: [
        { month: "january", totalSales: 647, totalUnits: 221 },
        { month: "february", totalSales: 507, totalUnits: 286 },
        { month: "march", totalSales: 47, totalUnits: 235 },
        { month: "april", totalSales: 535, totalUnits: 446 },
        { month: "may", totalSales: 488, totalUnits: 416 },
        { month: "june", totalSales: 312, totalUnits: 400 },
        { month: "july", totalSales: 713, totalUnits: 54 },
        { month: "august", totalSales: 751, totalUnits: 11 },
        { month: "september", totalSales: 726, totalUnits: 44 },
        { month: "october", totalSales: 466, totalUnits: 79 },
        { month: "november", totalSales: 483, totalUnits: 270 },
        { month: "december", totalSales: 983, totalUnits: 392 },
      ],
      dailyData: [
        { date: "2021-01-02", totalSales: 17, totalUnits: 21 },
        { date: "2021-01-03", totalSales: 91, totalUnits: 47 },
        { date: "2021-01-04", totalSales: 91, totalUnits: 19 },
        { date: "2021-01-05", totalSales: 22, totalUnits: 11 },
        { date: "2021-01-06", totalSales: 31, totalUnits: 40 },
        { date: "2021-01-07", totalSales: 75, totalUnits: 11 },
        { date: "2021-01-08", totalSales: 79, totalUnits: 7 },
        { date: "2021-01-09", totalSales: 57, totalUnits: 15 },
        { date: "2021-01-10", totalSales: 26, totalUnits: 3 },
        { date: "2021-01-11", totalSales: 64, totalUnits: 38 },
        { date: "2021-01-12", totalSales: 35, totalUnits: 46 },
        { date: "2021-01-13", totalSales: 4, totalUnits: 29 },
        { date: "2021-01-14", totalSales: 98, totalUnits: 24 },
        { date: "2021-01-15", totalSales: 42, totalUnits: 13 },
        { date: "2021-01-16", totalSales: 69, totalUnits: 49 },
        { date: "2021-01-17", totalSales: 71, totalUnits: 5 },
        { date: "2021-01-18", totalSales: 55, totalUnits: 43 },
        { date: "2021-01-19", totalSales: 66, totalUnits: 45 },
        { date: "2021-01-20", totalSales: 5, totalUnits: 4 },
        { date: "2021-01-21", totalSales: 91, totalUnits: 20 },
        { date: "2021-01-22", totalSales: 54, totalUnits: 4 },
        { date: "2021-01-23", totalSales: 53, totalUnits: 17 },
        { date: "2021-01-24", totalSales: 75, totalUnits: 20 },
        { date: "2021-01-25", totalSales: 25, totalUnits: 50 },
        { date: "2021-01-26", totalSales: 9, totalUnits: 6 },
        { date: "2021-01-27", totalSales: 21, totalUnits: 35 },
        { date: "2021-01-28", totalSales: 74, totalUnits: 30 },
        { date: "2021-01-29", totalSales: 100, totalUnits: 11 },
        { date: "2021-01-30", totalSales: 100, totalUnits: 15 },
        { date: "2021-01-31", totalSales: 72, totalUnits: 49 },
        { date: "2021-02-01", totalSales: 27, totalUnits: 10 },
        { date: "2021-02-02", totalSales: 96, totalUnits: 19 },
        { date: "2021-02-03", totalSales: 20, totalUnits: 12 },
        { date: "2021-02-04", totalSales: 47, totalUnits: 17 },
        { date: "2021-02-05", totalSales: 43, totalUnits: 41 },
        { date: "2021-02-06", totalSales: 33, totalUnits: 46 },
        { date: "2021-02-07", totalSales: 3, totalUnits: 13 },
        { date: "2021-02-08", totalSales: 96, totalUnits: 26 },
        { date: "2021-02-09", totalSales: 39, totalUnits: 19 },
        { date: "2021-02-10", totalSales: 65, totalUnits: 11 },
        { date: "2021-02-11", totalSales: 67, totalUnits: 11 },
        { date: "2021-02-12", totalSales: 76, totalUnits: 6 },
        { date: "2021-02-13", totalSales: 79, totalUnits: 25 },
        { date: "2021-02-14", totalSales: 64, totalUnits: 43 },
        { date: "2021-02-15", totalSales: 44, totalUnits: 43 },
        { date: "2021-02-16", totalSales: 23, totalUnits: 37 },
        { date: "2021-02-17", totalSales: 10, totalUnits: 20 },
        { date: "2021-02-18", totalSales: 83, totalUnits: 42 },
        { date: "2021-02-19", totalSales: 73, totalUnits: 26 },
        { date: "2021-02-20", totalSales: 20, totalUnits: 45 },
        { date: "2021-02-21", totalSales: 63, totalUnits: 31 },
        { date: "2021-02-22", totalSales: 25, totalUnits: 18 },
        { date: "2021-02-23", totalSales: 85, totalUnits: 17 },
        { date: "2021-02-24", totalSales: 70, totalUnits: 31 },
        { date: "2021-02-25", totalSales: 74, totalUnits: 9 },
        { date: "2021-02-26", totalSales: 72, totalUnits: 10 },
        { date: "2021-02-27", totalSales: 94, totalUnits: 25 },
        { date: "2021-02-28", totalSales: 24, totalUnits: 37 },
        { date: "2021-03-01", totalSales: 99, totalUnits: 39 },
        { date: "2021-03-02", totalSales: 28, totalUnits: 48 },
        { date: "2021-03-03", totalSales: 81, totalUnits: 47 },
        { date: "2021-03-04", totalSales: 90, totalUnits: 15 },
        { date: "2021-03-05", totalSales: 43, totalUnits: 34 },
        { date: "2021-03-06", totalSales: 75, totalUnits: 10 },
        { date: "2021-03-07", totalSales: 44, totalUnits: 47 },
        { date: "2021-03-08", totalSales: 72, totalUnits: 24 },
        { date: "2021-03-09", totalSales: 54, totalUnits: 29 },
        { date: "2021-03-10", totalSales: 35, totalUnits: 21 },
        { date: "2021-03-11", totalSales: 91, totalUnits: 17 },
        { date: "2021-03-12", totalSales: 20, totalUnits: 19 },
        { date: "2021-03-13", totalSales: 49, totalUnits: 17 },
        { date: "2021-03-14", totalSales: 61, totalUnits: 1 },
        { date: "2021-03-15", totalSales: 31, totalUnits: 6 },
        { date: "2021-03-16", totalSales: 96, totalUnits: 47 },
        { date: "2021-03-17", totalSales: 27, totalUnits: 47 },
        { date: "2021-03-18", totalSales: 65, totalUnits: 21 },
        { date: "2021-03-19", totalSales: 96, totalUnits: 18 },
        { date: "2021-03-20", totalSales: 62, totalUnits: 23 },
        { date: "2021-03-21", totalSales: 62, totalUnits: 44 },
        { date: "2021-03-22", totalSales: 83, totalUnits: 30 },
        { date: "2021-03-23", totalSales: 70, totalUnits: 21 },
        { date: "2021-03-24", totalSales: 52, totalUnits: 17 },
        { date: "2021-03-25", totalSales: 69, totalUnits: 39 },
        { date: "2021-03-26", totalSales: 79, totalUnits: 29 },
        { date: "2021-03-27", totalSales: 11, totalUnits: 3 },
        { date: "2021-03-28", totalSales: 74, totalUnits: 16 },
        { date: "2021-03-29", totalSales: 24, totalUnits: 42 },
        { date: "2021-03-30", totalSales: 7, totalUnits: 6 },
        { date: "2021-03-31", totalSales: 51, totalUnits: 23 },
        { date: "2021-04-01", totalSales: 7, totalUnits: 16 },
        { date: "2021-04-02", totalSales: 99, totalUnits: 41 },
        { date: "2021-04-03", totalSales: 87, totalUnits: 36 },
        { date: "2021-04-04", totalSales: 76, totalUnits: 47 },
        { date: "2021-04-05", totalSales: 88, totalUnits: 27 },
        { date: "2021-04-06", totalSales: 100, totalUnits: 33 },
        { date: "2021-04-07", totalSales: 62, totalUnits: 15 },
        { date: "2021-04-08", totalSales: 25, totalUnits: 42 },
        { date: "2021-04-09", totalSales: 76, totalUnits: 29 },
        { date: "2021-04-10", totalSales: 76, totalUnits: 43 },
        { date: "2021-04-11", totalSales: 82, totalUnits: 17 },
        { date: "2021-04-12", totalSales: 67, totalUnits: 19 },
        { date: "2021-04-13", totalSales: 57, totalUnits: 42 },
        { date: "2021-04-14", totalSales: 12, totalUnits: 10 },
        { date: "2021-04-15", totalSales: 59, totalUnits: 46 },
        { date: "2021-04-16", totalSales: 7, totalUnits: 27 },
        { date: "2021-04-17", totalSales: 54, totalUnits: 31 },
        { date: "2021-04-18", totalSales: 61, totalUnits: 44 },
        { date: "2021-04-19", totalSales: 85, totalUnits: 17 },
        { date: "2021-04-20", totalSales: 5, totalUnits: 22 },
        { date: "2021-04-21", totalSales: 52, totalUnits: 12 },
        { date: "2021-04-22", totalSales: 55, totalUnits: 17 },
        { date: "2021-04-23", totalSales: 39, totalUnits: 46 },
        { date: "2021-04-24", totalSales: 20, totalUnits: 14 },
        { date: "2021-04-25", totalSales: 29, totalUnits: 5 },
        { date: "2021-04-26", totalSales: 72, totalUnits: 22 },
        { date: "2021-04-27", totalSales: 42, totalUnits: 49 },
        { date: "2021-04-28", totalSales: 19, totalUnits: 27 },
        { date: "2021-04-29", totalSales: 89, totalUnits: 32 },
        { date: "2021-04-30", totalSales: 55, totalUnits: 46 },
        { date: "2021-05-01", totalSales: 35, totalUnits: 23 },
        { date: "2021-05-02", totalSales: 43, totalUnits: 30 },
        { date: "2021-05-03", totalSales: 51, totalUnits: 18 },
        { date: "2021-05-04", totalSales: 94, totalUnits: 7 },
        { date: "2021-05-05", totalSales: 89, totalUnits: 34 },
        { date: "2021-05-06", totalSales: 72, totalUnits: 30 },
        { date: "2021-05-07", totalSales: 24, totalUnits: 30 },
        { date: "2021-05-08", totalSales: 24, totalUnits: 42 },
        { date: "2021-05-09", totalSales: 16, totalUnits: 46 },
        { date: "2021-05-10", totalSales: 14, totalUnits: 3 },
        { date: "2021-05-11", totalSales: 46, totalUnits: 31 },
        { date: "2021-05-12", totalSales: 46, totalUnits: 20 },
        { date: "2021-05-13", totalSales: 8, totalUnits: 28 },
        { date: "2021-05-14", totalSales: 10, totalUnits: 47 },
        { date: "2021-05-15", totalSales: 46, totalUnits: 28 },
        { date: "2021-05-16", totalSales: 38, totalUnits: 37 },
        { date: "2021-05-17", totalSales: 43, totalUnits: 20 },
        { date: "2021-05-18", totalSales: 23, totalUnits: 38 },
        { date: "2021-05-19", totalSales: 39, totalUnits: 1 },
        { date: "2021-05-20", totalSales: 42, totalUnits: 50 },
        { date: "2021-05-21", totalSales: 63, totalUnits: 32 },
        { date: "2021-05-22", totalSales: 81, totalUnits: 20 },
        { date: "2021-05-23", totalSales: 95, totalUnits: 25 },
        { date: "2021-05-24", totalSales: 10, totalUnits: 34 },
        { date: "2021-05-25", totalSales: 35, totalUnits: 15 },
        { date: "2021-05-26", totalSales: 86, totalUnits: 14 },
        { date: "2021-05-27", totalSales: 46, totalUnits: 16 },
        { date: "2021-05-28", totalSales: 65, totalUnits: 44 },
        { date: "2021-05-29", totalSales: 95, totalUnits: 29 },
        { date: "2021-05-30", totalSales: 69, totalUnits: 17 },
        { date: "2021-05-31", totalSales: 70, totalUnits: 3 },
        { date: "2021-06-01", totalSales: 62, totalUnits: 4 },
        { date: "2021-06-02", totalSales: 84, totalUnits: 17 },
        { date: "2021-06-03", totalSales: 77, totalUnits: 23 },
        { date: "2021-06-04", totalSales: 60, totalUnits: 45 },
        { date: "2021-06-05", totalSales: 76, totalUnits: 30 },
        { date: "2021-06-06", totalSales: 38, totalUnits: 20 },
        { date: "2021-06-07", totalSales: 73, totalUnits: 41 },
        { date: "2021-06-08", totalSales: 60, totalUnits: 43 },
        { date: "2021-06-09", totalSales: 94, totalUnits: 43 },
        { date: "2021-06-10", totalSales: 20, totalUnits: 5 },
        { date: "2021-06-11", totalSales: 58, totalUnits: 34 },
        { date: "2021-06-12", totalSales: 26, totalUnits: 49 },
        { date: "2021-06-13", totalSales: 97, totalUnits: 17 },
        { date: "2021-06-14", totalSales: 37, totalUnits: 21 },
        { date: "2021-06-15", totalSales: 42, totalUnits: 38 },
        { date: "2021-06-16", totalSales: 26, totalUnits: 9 },
        { date: "2021-06-17", totalSales: 55, totalUnits: 26 },
        { date: "2021-06-18", totalSales: 30, totalUnits: 14 },
        { date: "2021-06-19", totalSales: 28, totalUnits: 7 },
        { date: "2021-06-20", totalSales: 93, totalUnits: 44 },
        { date: "2021-06-21", totalSales: 74, totalUnits: 30 },
        { date: "2021-06-22", totalSales: 19, totalUnits: 39 },
        { date: "2021-06-23", totalSales: 74, totalUnits: 49 },
        { date: "2021-06-24", totalSales: 87, totalUnits: 12 },
        { date: "2021-06-25", totalSales: 90, totalUnits: 4 },
        { date: "2021-06-26", totalSales: 76, totalUnits: 30 },
        { date: "2021-06-27", totalSales: 86, totalUnits: 3 },
        { date: "2021-06-28", totalSales: 26, totalUnits: 49 },
        { date: "2021-06-29", totalSales: 43, totalUnits: 46 },
        { date: "2021-06-30", totalSales: 10, totalUnits: 39 },
        { date: "2021-07-01", totalSales: 65, totalUnits: 42 },
        { date: "2021-07-02", totalSales: 66, totalUnits: 9 },
        { date: "2021-07-03", totalSales: 3, totalUnits: 5 },
        { date: "2021-07-04", totalSales: 72, totalUnits: 45 },
        { date: "2021-07-05", totalSales: 27, totalUnits: 28 },
        { date: "2021-07-06", totalSales: 30, totalUnits: 29 },
        { date: "2021-07-07", totalSales: 16, totalUnits: 43 },
        { date: "2021-07-08", totalSales: 68, totalUnits: 33 },
        { date: "2021-07-09", totalSales: 30, totalUnits: 17 },
        { date: "2021-07-10", totalSales: 54, totalUnits: 22 },
        { date: "2021-07-11", totalSales: 15, totalUnits: 11 },
        { date: "2021-07-12", totalSales: 39, totalUnits: 48 },
        { date: "2021-07-13", totalSales: 22, totalUnits: 47 },
        { date: "2021-07-14", totalSales: 47, totalUnits: 23 },
        { date: "2021-07-15", totalSales: 29, totalUnits: 3 },
        { date: "2021-07-16", totalSales: 15, totalUnits: 43 },
        { date: "2021-07-17", totalSales: 8, totalUnits: 5 },
        { date: "2021-07-18", totalSales: 44, totalUnits: 41 },
        { date: "2021-07-19", totalSales: 27, totalUnits: 11 },
        { date: "2021-07-20", totalSales: 69, totalUnits: 36 },
        { date: "2021-07-21", totalSales: 40, totalUnits: 19 },
        { date: "2021-07-22", totalSales: 53, totalUnits: 44 },
        { date: "2021-07-23", totalSales: 29, totalUnits: 48 },
        { date: "2021-07-24", totalSales: 72, totalUnits: 48 },
        { date: "2021-07-25", totalSales: 59, totalUnits: 47 },
        { date: "2021-07-26", totalSales: 95, totalUnits: 36 },
        { date: "2021-07-27", totalSales: 98, totalUnits: 22 },
        { date: "2021-07-28", totalSales: 14, totalUnits: 17 },
        { date: "2021-07-29", totalSales: 20, totalUnits: 3 },
        { date: "2021-07-30", totalSales: 64, totalUnits: 27 },
        { date: "2021-07-31", totalSales: 51, totalUnits: 22 },
        { date: "2021-08-01", totalSales: 87, totalUnits: 49 },
        { date: "2021-08-02", totalSales: 27, totalUnits: 18 },
        { date: "2021-08-03", totalSales: 25, totalUnits: 46 },
        { date: "2021-08-04", totalSales: 47, totalUnits: 9 },
        { date: "2021-08-05", totalSales: 44, totalUnits: 25 },
        { date: "2021-08-06", totalSales: 76, totalUnits: 30 },
        { date: "2021-08-07", totalSales: 84, totalUnits: 42 },
        { date: "2021-08-08", totalSales: 33, totalUnits: 19 },
        { date: "2021-08-09", totalSales: 69, totalUnits: 10 },
        { date: "2021-08-10", totalSales: 92, totalUnits: 4 },
        { date: "2021-08-11", totalSales: 17, totalUnits: 50 },
        { date: "2021-08-12", totalSales: 1, totalUnits: 48 },
        { date: "2021-08-13", totalSales: 5, totalUnits: 8 },
        { date: "2021-08-14", totalSales: 18, totalUnits: 8 },
        { date: "2021-08-15", totalSales: 36, totalUnits: 5 },
        { date: "2021-08-16", totalSales: 86, totalUnits: 19 },
        { date: "2021-08-17", totalSales: 1, totalUnits: 3 },
        { date: "2021-08-18", totalSales: 9, totalUnits: 33 },
        { date: "2021-08-19", totalSales: 20, totalUnits: 7 },
        { date: "2021-08-20", totalSales: 65, totalUnits: 30 },
        { date: "2021-08-21", totalSales: 51, totalUnits: 34 },
        { date: "2021-08-22", totalSales: 55, totalUnits: 6 },
        { date: "2021-08-23", totalSales: 63, totalUnits: 43 },
        { date: "2021-08-24", totalSales: 14, totalUnits: 12 },
        { date: "2021-08-25", totalSales: 58, totalUnits: 28 },
        { date: "2021-08-26", totalSales: 96, totalUnits: 13 },
        { date: "2021-08-27", totalSales: 99, totalUnits: 42 },
        { date: "2021-08-28", totalSales: 81, totalUnits: 15 },
        { date: "2021-08-29", totalSales: 34, totalUnits: 35 },
        { date: "2021-08-30", totalSales: 32, totalUnits: 18 },
        { date: "2021-08-31", totalSales: 48, totalUnits: 48 },
        { date: "2021-09-01", totalSales: 92, totalUnits: 22 },
        { date: "2021-09-02", totalSales: 21, totalUnits: 17 },
        { date: "2021-09-03", totalSales: 86, totalUnits: 49 },
        { date: "2021-09-04", totalSales: 55, totalUnits: 29 },
        { date: "2021-09-05", totalSales: 36, totalUnits: 48 },
        { date: "2021-09-06", totalSales: 45, totalUnits: 13 },
        { date: "2021-09-07", totalSales: 6, totalUnits: 28 },
        { date: "2021-09-08", totalSales: 69, totalUnits: 34 },
        { date: "2021-09-09", totalSales: 52, totalUnits: 40 },
        { date: "2021-09-10", totalSales: 54, totalUnits: 36 },
        { date: "2021-09-11", totalSales: 26, totalUnits: 2 },
        { date: "2021-09-12", totalSales: 89, totalUnits: 33 },
        { date: "2021-09-13", totalSales: 19, totalUnits: 42 },
        { date: "2021-09-14", totalSales: 72, totalUnits: 14 },
        { date: "2021-09-15", totalSales: 31, totalUnits: 42 },
        { date: "2021-09-16", totalSales: 73, totalUnits: 4 },
        { date: "2021-09-17", totalSales: 63, totalUnits: 24 },
        { date: "2021-09-18", totalSales: 73, totalUnits: 7 },
        { date: "2021-09-19", totalSales: 20, totalUnits: 45 },
        { date: "2021-09-20", totalSales: 9, totalUnits: 16 },
        { date: "2021-09-21", totalSales: 18, totalUnits: 21 },
        { date: "2021-09-22", totalSales: 64, totalUnits: 13 },
        { date: "2021-09-23", totalSales: 84, totalUnits: 16 },
        { date: "2021-09-24", totalSales: 94, totalUnits: 29 },
        { date: "2021-09-25", totalSales: 44, totalUnits: 17 },
        { date: "2021-09-26", totalSales: 35, totalUnits: 13 },
        { date: "2021-09-27", totalSales: 1, totalUnits: 14 },
        { date: "2021-09-28", totalSales: 79, totalUnits: 5 },
        { date: "2021-09-29", totalSales: 11, totalUnits: 43 },
        { date: "2021-09-30", totalSales: 71, totalUnits: 25 },
        { date: "2021-10-01", totalSales: 17, totalUnits: 14 },
        { date: "2021-10-02", totalSales: 17, totalUnits: 2 },
        { date: "2021-10-03", totalSales: 29, totalUnits: 31 },
        { date: "2021-10-04", totalSales: 25, totalUnits: 7 },
        { date: "2021-10-05", totalSales: 75, totalUnits: 38 },
        { date: "2021-10-06", totalSales: 65, totalUnits: 17 },
        { date: "2021-10-07", totalSales: 33, totalUnits: 50 },
        { date: "2021-10-08", totalSales: 13, totalUnits: 17 },
        { date: "2021-10-09", totalSales: 65, totalUnits: 6 },
        { date: "2021-10-10", totalSales: 98, totalUnits: 40 },
        { date: "2021-10-11", totalSales: 54, totalUnits: 26 },
        { date: "2021-10-12", totalSales: 8, totalUnits: 23 },
        { date: "2021-10-13", totalSales: 80, totalUnits: 15 },
        { date: "2021-10-14", totalSales: 88, totalUnits: 8 },
        { date: "2021-10-15", totalSales: 93, totalUnits: 33 },
        { date: "2021-10-16", totalSales: 17, totalUnits: 37 },
        { date: "2021-10-17", totalSales: 18, totalUnits: 22 },
        { date: "2021-10-18", totalSales: 41, totalUnits: 21 },
        { date: "2021-10-19", totalSales: 86, totalUnits: 36 },
        { date: "2021-10-20", totalSales: 38, totalUnits: 38 },
        { date: "2021-10-21", totalSales: 99, totalUnits: 26 },
        { date: "2021-10-22", totalSales: 33, totalUnits: 10 },
        { date: "2021-10-23", totalSales: 17, totalUnits: 23 },
        { date: "2021-10-24", totalSales: 18, totalUnits: 47 },
        { date: "2021-10-25", totalSales: 77, totalUnits: 23 },
        { date: "2021-10-26", totalSales: 93, totalUnits: 46 },
        { date: "2021-10-27", totalSales: 44, totalUnits: 42 },
        { date: "2021-10-28", totalSales: 78, totalUnits: 4 },
        { date: "2021-10-29", totalSales: 67, totalUnits: 16 },
        { date: "2021-10-30", totalSales: 77, totalUnits: 8 },
        { date: "2021-10-31", totalSales: 84, totalUnits: 50 },
        { date: "2021-11-01", totalSales: 13, totalUnits: 15 },
        { date: "2021-11-02", totalSales: 41, totalUnits: 11 },
        { date: "2021-11-03", totalSales: 75, totalUnits: 43 },
        { date: "2021-11-04", totalSales: 72, totalUnits: 45 },
        { date: "2021-11-05", totalSales: 2, totalUnits: 25 },
        { date: "2021-11-06", totalSales: 15, totalUnits: 35 },
        { date: "2021-11-07", totalSales: 20, totalUnits: 18 },
        { date: "2021-11-08", totalSales: 94, totalUnits: 42 },
        { date: "2021-11-09", totalSales: 65, totalUnits: 2 },
        { date: "2021-11-10", totalSales: 95, totalUnits: 18 },
        { date: "2021-11-11", totalSales: 39, totalUnits: 16 },
        { date: "2021-11-12", totalSales: 25, totalUnits: 7 },
        { date: "2021-11-13", totalSales: 14, totalUnits: 42 },
        { date: "2021-11-14", totalSales: 47, totalUnits: 19 },
        { date: "2021-11-15", totalSales: 52, totalUnits: 38 },
        { date: "2021-11-16", totalSales: 78, totalUnits: 33 },
        { date: "2021-11-17", totalSales: 5, totalUnits: 9 },
      ],
    },
    {
      _id: "637125a0f03239d40b0000dd",
      productId: "63701d25f03239d591000328",
      yearlySalesTotal: 9959,
      yearlyTotalSoldUnits: 2071,
      monthlyData: [
        { month: "january", totalSales: 401, totalUnits: 451 },
        { month: "february", totalSales: 894, totalUnits: 403 },
        { month: "march", totalSales: 821, totalUnits: 136 },
        { month: "april", totalSales: 873, totalUnits: 123 },
        { month: "may", totalSales: 852, totalUnits: 410 },
        { month: "june", totalSales: 166, totalUnits: 39 },
        { month: "july", totalSales: 955, totalUnits: 189 },
        { month: "august", totalSales: 648, totalUnits: 28 },
        { month: "september", totalSales: 34, totalUnits: 271 },
        { month: "october", totalSales: 622, totalUnits: 417 },
        { month: "november", totalSales: 658, totalUnits: 439 },
        { month: "december", totalSales: 250, totalUnits: 67 },
      ],
      dailyData: [
        { date: "2021-01-02", totalSales: 15, totalUnits: 19 },
        { date: "2021-01-03", totalSales: 91, totalUnits: 13 },
        { date: "2021-01-04", totalSales: 25, totalUnits: 34 },
        { date: "2021-01-05", totalSales: 53, totalUnits: 40 },
        { date: "2021-01-06", totalSales: 44, totalUnits: 31 },
        { date: "2021-01-07", totalSales: 14, totalUnits: 6 },
        { date: "2021-01-08", totalSales: 7, totalUnits: 48 },
        { date: "2021-01-09", totalSales: 96, totalUnits: 15 },
        { date: "2021-01-10", totalSales: 42, totalUnits: 12 },
        { date: "2021-01-11", totalSales: 90, totalUnits: 31 },
        { date: "2021-01-12", totalSales: 22, totalUnits: 49 },
        { date: "2021-01-13", totalSales: 82, totalUnits: 1 },
        { date: "2021-01-14", totalSales: 15, totalUnits: 24 },
        { date: "2021-01-15", totalSales: 61, totalUnits: 31 },
        { date: "2021-01-16", totalSales: 46, totalUnits: 22 },
        { date: "2021-01-17", totalSales: 84, totalUnits: 6 },
        { date: "2021-01-18", totalSales: 25, totalUnits: 32 },
        { date: "2021-01-19", totalSales: 50, totalUnits: 28 },
        { date: "2021-01-20", totalSales: 91, totalUnits: 20 },
        { date: "2021-01-21", totalSales: 16, totalUnits: 19 },
        { date: "2021-01-22", totalSales: 18, totalUnits: 49 },
        { date: "2021-01-23", totalSales: 4, totalUnits: 41 },
        { date: "2021-01-24", totalSales: 14, totalUnits: 33 },
        { date: "2021-01-25", totalSales: 8, totalUnits: 26 },
        { date: "2021-01-26", totalSales: 7, totalUnits: 14 },
        { date: "2021-01-27", totalSales: 12, totalUnits: 24 },
        { date: "2021-01-28", totalSales: 86, totalUnits: 25 },
        { date: "2021-01-29", totalSales: 83, totalUnits: 25 },
        { date: "2021-01-30", totalSales: 29, totalUnits: 37 },
        { date: "2021-01-31", totalSales: 60, totalUnits: 41 },
        { date: "2021-02-01", totalSales: 39, totalUnits: 6 },
        { date: "2021-02-02", totalSales: 94, totalUnits: 21 },
        { date: "2021-02-03", totalSales: 41, totalUnits: 28 },
        { date: "2021-02-04", totalSales: 24, totalUnits: 39 },
        { date: "2021-02-05", totalSales: 1, totalUnits: 21 },
        { date: "2021-02-06", totalSales: 69, totalUnits: 11 },
        { date: "2021-02-07", totalSales: 67, totalUnits: 8 },
        { date: "2021-02-08", totalSales: 9, totalUnits: 9 },
        { date: "2021-02-09", totalSales: 7, totalUnits: 16 },
        { date: "2021-02-10", totalSales: 51, totalUnits: 3 },
        { date: "2021-02-11", totalSales: 83, totalUnits: 40 },
        { date: "2021-02-12", totalSales: 68, totalUnits: 5 },
        { date: "2021-02-13", totalSales: 100, totalUnits: 16 },
        { date: "2021-02-14", totalSales: 96, totalUnits: 17 },
        { date: "2021-02-15", totalSales: 20, totalUnits: 30 },
        { date: "2021-02-16", totalSales: 23, totalUnits: 33 },
        { date: "2021-02-17", totalSales: 79, totalUnits: 29 },
        { date: "2021-02-18", totalSales: 75, totalUnits: 21 },
        { date: "2021-02-19", totalSales: 70, totalUnits: 14 },
        { date: "2021-02-20", totalSales: 20, totalUnits: 1 },
        { date: "2021-02-21", totalSales: 56, totalUnits: 21 },
        { date: "2021-02-22", totalSales: 39, totalUnits: 23 },
        { date: "2021-02-23", totalSales: 99, totalUnits: 22 },
        { date: "2021-02-24", totalSales: 43, totalUnits: 45 },
        { date: "2021-02-25", totalSales: 88, totalUnits: 48 },
        { date: "2021-02-26", totalSales: 33, totalUnits: 45 },
        { date: "2021-02-27", totalSales: 71, totalUnits: 50 },
        { date: "2021-02-28", totalSales: 49, totalUnits: 4 },
        { date: "2021-03-01", totalSales: 95, totalUnits: 38 },
        { date: "2021-03-02", totalSales: 46, totalUnits: 45 },
        { date: "2021-03-03", totalSales: 24, totalUnits: 13 },
        { date: "2021-03-04", totalSales: 1, totalUnits: 17 },
        { date: "2021-03-05", totalSales: 79, totalUnits: 1 },
        { date: "2021-03-06", totalSales: 51, totalUnits: 8 },
        { date: "2021-03-07", totalSales: 51, totalUnits: 10 },
        { date: "2021-03-08", totalSales: 33, totalUnits: 47 },
        { date: "2021-03-09", totalSales: 62, totalUnits: 16 },
        { date: "2021-03-10", totalSales: 65, totalUnits: 20 },
        { date: "2021-03-11", totalSales: 96, totalUnits: 9 },
        { date: "2021-03-12", totalSales: 48, totalUnits: 12 },
        { date: "2021-03-13", totalSales: 3, totalUnits: 8 },
        { date: "2021-03-14", totalSales: 44, totalUnits: 47 },
        { date: "2021-03-15", totalSales: 62, totalUnits: 5 },
        { date: "2021-03-16", totalSales: 54, totalUnits: 26 },
        { date: "2021-03-17", totalSales: 5, totalUnits: 13 },
        { date: "2021-03-18", totalSales: 94, totalUnits: 49 },
        { date: "2021-03-19", totalSales: 22, totalUnits: 5 },
        { date: "2021-03-20", totalSales: 89, totalUnits: 32 },
        { date: "2021-03-21", totalSales: 3, totalUnits: 10 },
        { date: "2021-03-22", totalSales: 70, totalUnits: 28 },
        { date: "2021-03-23", totalSales: 92, totalUnits: 38 },
        { date: "2021-03-24", totalSales: 67, totalUnits: 16 },
        { date: "2021-03-25", totalSales: 20, totalUnits: 20 },
        { date: "2021-03-26", totalSales: 28, totalUnits: 7 },
        { date: "2021-03-27", totalSales: 67, totalUnits: 6 },
        { date: "2021-03-28", totalSales: 69, totalUnits: 45 },
        { date: "2021-03-29", totalSales: 26, totalUnits: 17 },
        { date: "2021-03-30", totalSales: 12, totalUnits: 13 },
        { date: "2021-03-31", totalSales: 84, totalUnits: 40 },
        { date: "2021-04-01", totalSales: 53, totalUnits: 39 },
        { date: "2021-04-02", totalSales: 38, totalUnits: 36 },
        { date: "2021-04-03", totalSales: 3, totalUnits: 22 },
        { date: "2021-04-04", totalSales: 22, totalUnits: 47 },
        { date: "2021-04-05", totalSales: 93, totalUnits: 3 },
        { date: "2021-04-06", totalSales: 76, totalUnits: 24 },
        { date: "2021-04-07", totalSales: 40, totalUnits: 45 },
        { date: "2021-04-08", totalSales: 26, totalUnits: 25 },
        { date: "2021-04-09", totalSales: 94, totalUnits: 15 },
        { date: "2021-04-10", totalSales: 3, totalUnits: 9 },
        { date: "2021-04-11", totalSales: 75, totalUnits: 6 },
        { date: "2021-04-12", totalSales: 69, totalUnits: 11 },
        { date: "2021-04-13", totalSales: 60, totalUnits: 26 },
        { date: "2021-04-14", totalSales: 49, totalUnits: 8 },
        { date: "2021-04-15", totalSales: 9, totalUnits: 13 },
        { date: "2021-04-16", totalSales: 4, totalUnits: 18 },
        { date: "2021-04-17", totalSales: 8, totalUnits: 47 },
        { date: "2021-04-18", totalSales: 10, totalUnits: 29 },
        { date: "2021-04-19", totalSales: 76, totalUnits: 41 },
        { date: "2021-04-20", totalSales: 91, totalUnits: 16 },
        { date: "2021-04-21", totalSales: 15, totalUnits: 42 },
        { date: "2021-04-22", totalSales: 99, totalUnits: 36 },
        { date: "2021-04-23", totalSales: 90, totalUnits: 16 },
        { date: "2021-04-24", totalSales: 99, totalUnits: 7 },
        { date: "2021-04-25", totalSales: 57, totalUnits: 20 },
        { date: "2021-04-26", totalSales: 96, totalUnits: 27 },
        { date: "2021-04-27", totalSales: 20, totalUnits: 34 },
        { date: "2021-04-28", totalSales: 47, totalUnits: 1 },
        { date: "2021-04-29", totalSales: 54, totalUnits: 27 },
        { date: "2021-04-30", totalSales: 1, totalUnits: 36 },
        { date: "2021-05-01", totalSales: 26, totalUnits: 11 },
        { date: "2021-05-02", totalSales: 12, totalUnits: 30 },
        { date: "2021-05-03", totalSales: 75, totalUnits: 28 },
        { date: "2021-05-04", totalSales: 42, totalUnits: 48 },
        { date: "2021-05-05", totalSales: 71, totalUnits: 27 },
        { date: "2021-05-06", totalSales: 74, totalUnits: 29 },
        { date: "2021-05-07", totalSales: 66, totalUnits: 45 },
        { date: "2021-05-08", totalSales: 2, totalUnits: 38 },
        { date: "2021-05-09", totalSales: 85, totalUnits: 8 },
        { date: "2021-05-10", totalSales: 64, totalUnits: 25 },
        { date: "2021-05-11", totalSales: 63, totalUnits: 10 },
        { date: "2021-05-12", totalSales: 23, totalUnits: 19 },
        { date: "2021-05-13", totalSales: 96, totalUnits: 22 },
        { date: "2021-05-14", totalSales: 56, totalUnits: 12 },
        { date: "2021-05-15", totalSales: 90, totalUnits: 1 },
        { date: "2021-05-16", totalSales: 70, totalUnits: 41 },
        { date: "2021-05-17", totalSales: 70, totalUnits: 1 },
        { date: "2021-05-18", totalSales: 76, totalUnits: 27 },
        { date: "2021-05-19", totalSales: 100, totalUnits: 26 },
        { date: "2021-05-20", totalSales: 86, totalUnits: 31 },
        { date: "2021-05-21", totalSales: 13, totalUnits: 33 },
        { date: "2021-05-22", totalSales: 93, totalUnits: 48 },
        { date: "2021-05-23", totalSales: 50, totalUnits: 14 },
        { date: "2021-05-24", totalSales: 54, totalUnits: 30 },
        { date: "2021-05-25", totalSales: 40, totalUnits: 49 },
        { date: "2021-05-26", totalSales: 68, totalUnits: 49 },
        { date: "2021-05-27", totalSales: 77, totalUnits: 21 },
        { date: "2021-05-28", totalSales: 47, totalUnits: 6 },
        { date: "2021-05-29", totalSales: 87, totalUnits: 42 },
        { date: "2021-05-30", totalSales: 68, totalUnits: 16 },
        { date: "2021-05-31", totalSales: 26, totalUnits: 2 },
        { date: "2021-06-01", totalSales: 31, totalUnits: 39 },
        { date: "2021-06-02", totalSales: 22, totalUnits: 24 },
        { date: "2021-06-03", totalSales: 94, totalUnits: 25 },
        { date: "2021-06-04", totalSales: 54, totalUnits: 22 },
        { date: "2021-06-05", totalSales: 86, totalUnits: 34 },
        { date: "2021-06-06", totalSales: 4, totalUnits: 2 },
        { date: "2021-06-07", totalSales: 54, totalUnits: 45 },
        { date: "2021-06-08", totalSales: 23, totalUnits: 49 },
        { date: "2021-06-09", totalSales: 4, totalUnits: 20 },
        { date: "2021-06-10", totalSales: 76, totalUnits: 31 },
        { date: "2021-06-11", totalSales: 44, totalUnits: 39 },
        { date: "2021-06-12", totalSales: 33, totalUnits: 45 },
        { date: "2021-06-13", totalSales: 17, totalUnits: 22 },
        { date: "2021-06-14", totalSales: 46, totalUnits: 6 },
        { date: "2021-06-15", totalSales: 98, totalUnits: 49 },
        { date: "2021-06-16", totalSales: 3, totalUnits: 11 },
        { date: "2021-06-17", totalSales: 2, totalUnits: 34 },
        { date: "2021-06-18", totalSales: 21, totalUnits: 23 },
        { date: "2021-06-19", totalSales: 30, totalUnits: 22 },
        { date: "2021-06-20", totalSales: 87, totalUnits: 5 },
        { date: "2021-06-21", totalSales: 1, totalUnits: 49 },
        { date: "2021-06-22", totalSales: 59, totalUnits: 18 },
        { date: "2021-06-23", totalSales: 73, totalUnits: 13 },
        { date: "2021-06-24", totalSales: 41, totalUnits: 5 },
        { date: "2021-06-25", totalSales: 10, totalUnits: 16 },
        { date: "2021-06-26", totalSales: 100, totalUnits: 21 },
        { date: "2021-06-27", totalSales: 4, totalUnits: 34 },
        { date: "2021-06-28", totalSales: 4, totalUnits: 50 },
        { date: "2021-06-29", totalSales: 96, totalUnits: 22 },
        { date: "2021-06-30", totalSales: 19, totalUnits: 17 },
        { date: "2021-07-01", totalSales: 56, totalUnits: 7 },
        { date: "2021-07-02", totalSales: 62, totalUnits: 21 },
        { date: "2021-07-03", totalSales: 55, totalUnits: 49 },
        { date: "2021-07-04", totalSales: 11, totalUnits: 24 },
        { date: "2021-07-05", totalSales: 40, totalUnits: 1 },
        { date: "2021-07-06", totalSales: 33, totalUnits: 11 },
        { date: "2021-07-07", totalSales: 53, totalUnits: 38 },
        { date: "2021-07-08", totalSales: 48, totalUnits: 17 },
        { date: "2021-07-09", totalSales: 75, totalUnits: 46 },
        { date: "2021-07-10", totalSales: 49, totalUnits: 32 },
        { date: "2021-07-11", totalSales: 52, totalUnits: 2 },
        { date: "2021-07-12", totalSales: 21, totalUnits: 17 },
        { date: "2021-07-13", totalSales: 95, totalUnits: 14 },
        { date: "2021-07-14", totalSales: 5, totalUnits: 48 },
        { date: "2021-07-15", totalSales: 53, totalUnits: 48 },
        { date: "2021-07-16", totalSales: 46, totalUnits: 10 },
        { date: "2021-07-17", totalSales: 79, totalUnits: 24 },
        { date: "2021-07-18", totalSales: 72, totalUnits: 29 },
        { date: "2021-07-19", totalSales: 23, totalUnits: 49 },
        { date: "2021-07-20", totalSales: 55, totalUnits: 50 },
        { date: "2021-07-21", totalSales: 5, totalUnits: 48 },
        { date: "2021-07-22", totalSales: 31, totalUnits: 35 },
        { date: "2021-07-23", totalSales: 40, totalUnits: 31 },
        { date: "2021-07-24", totalSales: 63, totalUnits: 13 },
        { date: "2021-07-25", totalSales: 77, totalUnits: 6 },
        { date: "2021-07-26", totalSales: 17, totalUnits: 2 },
        { date: "2021-07-27", totalSales: 69, totalUnits: 45 },
        { date: "2021-07-28", totalSales: 46, totalUnits: 40 },
        { date: "2021-07-29", totalSales: 57, totalUnits: 34 },
        { date: "2021-07-30", totalSales: 23, totalUnits: 50 },
        { date: "2021-07-31", totalSales: 31, totalUnits: 17 },
        { date: "2021-08-01", totalSales: 45, totalUnits: 1 },
        { date: "2021-08-02", totalSales: 33, totalUnits: 24 },
        { date: "2021-08-03", totalSales: 65, totalUnits: 27 },
        { date: "2021-08-04", totalSales: 48, totalUnits: 22 },
        { date: "2021-08-05", totalSales: 77, totalUnits: 8 },
        { date: "2021-08-06", totalSales: 16, totalUnits: 3 },
        { date: "2021-08-07", totalSales: 55, totalUnits: 50 },
        { date: "2021-08-08", totalSales: 90, totalUnits: 42 },
        { date: "2021-08-09", totalSales: 3, totalUnits: 17 },
        { date: "2021-08-10", totalSales: 30, totalUnits: 30 },
        { date: "2021-08-11", totalSales: 1, totalUnits: 48 },
        { date: "2021-08-12", totalSales: 66, totalUnits: 38 },
        { date: "2021-08-13", totalSales: 37, totalUnits: 14 },
        { date: "2021-08-14", totalSales: 84, totalUnits: 36 },
        { date: "2021-08-15", totalSales: 86, totalUnits: 31 },
        { date: "2021-08-16", totalSales: 9, totalUnits: 45 },
        { date: "2021-08-17", totalSales: 96, totalUnits: 16 },
        { date: "2021-08-18", totalSales: 54, totalUnits: 37 },
        { date: "2021-08-19", totalSales: 32, totalUnits: 45 },
        { date: "2021-08-20", totalSales: 13, totalUnits: 39 },
        { date: "2021-08-21", totalSales: 88, totalUnits: 5 },
        { date: "2021-08-22", totalSales: 21, totalUnits: 21 },
        { date: "2021-08-23", totalSales: 100, totalUnits: 24 },
        { date: "2021-08-24", totalSales: 73, totalUnits: 24 },
        { date: "2021-08-25", totalSales: 62, totalUnits: 43 },
        { date: "2021-08-26", totalSales: 26, totalUnits: 2 },
        { date: "2021-08-27", totalSales: 42, totalUnits: 38 },
        { date: "2021-08-28", totalSales: 41, totalUnits: 9 },
        { date: "2021-08-29", totalSales: 70, totalUnits: 29 },
        { date: "2021-08-30", totalSales: 41, totalUnits: 34 },
        { date: "2021-08-31", totalSales: 8, totalUnits: 45 },
        { date: "2021-09-01", totalSales: 57, totalUnits: 7 },
        { date: "2021-09-02", totalSales: 97, totalUnits: 30 },
        { date: "2021-09-03", totalSales: 83, totalUnits: 12 },
        { date: "2021-09-04", totalSales: 49, totalUnits: 4 },
        { date: "2021-09-05", totalSales: 8, totalUnits: 18 },
        { date: "2021-09-06", totalSales: 75, totalUnits: 49 },
        { date: "2021-09-07", totalSales: 71, totalUnits: 49 },
        { date: "2021-09-08", totalSales: 27, totalUnits: 43 },
        { date: "2021-09-09", totalSales: 89, totalUnits: 37 },
        { date: "2021-09-10", totalSales: 39, totalUnits: 50 },
        { date: "2021-09-11", totalSales: 62, totalUnits: 10 },
        { date: "2021-09-12", totalSales: 14, totalUnits: 40 },
        { date: "2021-09-13", totalSales: 22, totalUnits: 18 },
        { date: "2021-09-14", totalSales: 29, totalUnits: 5 },
        { date: "2021-09-15", totalSales: 38, totalUnits: 18 },
        { date: "2021-09-16", totalSales: 50, totalUnits: 21 },
        { date: "2021-09-17", totalSales: 79, totalUnits: 8 },
        { date: "2021-09-18", totalSales: 21, totalUnits: 39 },
        { date: "2021-09-19", totalSales: 22, totalUnits: 50 },
        { date: "2021-09-20", totalSales: 26, totalUnits: 6 },
        { date: "2021-09-21", totalSales: 100, totalUnits: 2 },
        { date: "2021-09-22", totalSales: 25, totalUnits: 47 },
        { date: "2021-09-23", totalSales: 24, totalUnits: 8 },
        { date: "2021-09-24", totalSales: 52, totalUnits: 16 },
        { date: "2021-09-25", totalSales: 27, totalUnits: 14 },
        { date: "2021-09-26", totalSales: 4, totalUnits: 49 },
        { date: "2021-09-27", totalSales: 65, totalUnits: 26 },
        { date: "2021-09-28", totalSales: 61, totalUnits: 41 },
        { date: "2021-09-29", totalSales: 51, totalUnits: 5 },
        { date: "2021-09-30", totalSales: 27, totalUnits: 16 },
        { date: "2021-10-01", totalSales: 82, totalUnits: 9 },
        { date: "2021-10-02", totalSales: 96, totalUnits: 22 },
        { date: "2021-10-03", totalSales: 63, totalUnits: 32 },
        { date: "2021-10-04", totalSales: 13, totalUnits: 36 },
        { date: "2021-10-05", totalSales: 8, totalUnits: 45 },
        { date: "2021-10-06", totalSales: 14, totalUnits: 21 },
        { date: "2021-10-07", totalSales: 12, totalUnits: 22 },
        { date: "2021-10-08", totalSales: 85, totalUnits: 10 },
        { date: "2021-10-09", totalSales: 88, totalUnits: 13 },
        { date: "2021-10-10", totalSales: 37, totalUnits: 48 },
        { date: "2021-10-11", totalSales: 28, totalUnits: 9 },
        { date: "2021-10-12", totalSales: 97, totalUnits: 32 },
        { date: "2021-10-13", totalSales: 96, totalUnits: 36 },
        { date: "2021-10-14", totalSales: 33, totalUnits: 47 },
        { date: "2021-10-15", totalSales: 92, totalUnits: 1 },
        { date: "2021-10-16", totalSales: 62, totalUnits: 5 },
        { date: "2021-10-17", totalSales: 48, totalUnits: 3 },
        { date: "2021-10-18", totalSales: 13, totalUnits: 28 },
        { date: "2021-10-19", totalSales: 67, totalUnits: 35 },
        { date: "2021-10-20", totalSales: 57, totalUnits: 15 },
        { date: "2021-10-21", totalSales: 29, totalUnits: 30 },
        { date: "2021-10-22", totalSales: 77, totalUnits: 16 },
        { date: "2021-10-23", totalSales: 90, totalUnits: 4 },
        { date: "2021-10-24", totalSales: 98, totalUnits: 24 },
        { date: "2021-10-25", totalSales: 63, totalUnits: 50 },
        { date: "2021-10-26", totalSales: 93, totalUnits: 34 },
        { date: "2021-10-27", totalSales: 24, totalUnits: 27 },
        { date: "2021-10-28", totalSales: 15, totalUnits: 19 },
        { date: "2021-10-29", totalSales: 89, totalUnits: 50 },
        { date: "2021-10-30", totalSales: 48, totalUnits: 50 },
        { date: "2021-10-31", totalSales: 73, totalUnits: 49 },
        { date: "2021-11-01", totalSales: 6, totalUnits: 25 },
        { date: "2021-11-02", totalSales: 90, totalUnits: 37 },
        { date: "2021-11-03", totalSales: 96, totalUnits: 7 },
        { date: "2021-11-04", totalSales: 82, totalUnits: 28 },
        { date: "2021-11-05", totalSales: 82, totalUnits: 3 },
        { date: "2021-11-06", totalSales: 83, totalUnits: 35 },
        { date: "2021-11-07", totalSales: 11, totalUnits: 48 },
        { date: "2021-11-08", totalSales: 88, totalUnits: 18 },
        { date: "2021-11-09", totalSales: 30, totalUnits: 20 },
        { date: "2021-11-10", totalSales: 94, totalUnits: 24 },
        { date: "2021-11-11", totalSales: 47, totalUnits: 19 },
        { date: "2021-11-12", totalSales: 61, totalUnits: 31 },
        { date: "2021-11-13", totalSales: 77, totalUnits: 12 },
        { date: "2021-11-14", totalSales: 19, totalUnits: 27 },
        { date: "2021-11-15", totalSales: 6, totalUnits: 28 },
        { date: "2021-11-16", totalSales: 33, totalUnits: 5 },
        { date: "2021-11-17", totalSales: 36, totalUnits: 22 },
      ],
    },
  ];
  
  export const dataTransaction = [
    {
      _id: "63701d74f03239c72c000192",
      userId: "63701cc1f032390a34000319",
      cost: 3584.18,
      products: [
        "63701d24f03239db6900012a",
        "63701d24f03239c72c00018e",
        "63701d24f03239f09e00018f",
        "63701d24f03239867500012d",
      ],
    },
    {
      _id: "63701d74f03239c72c000193",
      userId: "63701cc1f032398675000129",
      cost: 2872.78,
      products: ["63701d24f03239d40b00004c"],
    },
    {
      _id: "63701d74f03239c72c000194",
      userId: "63701cc1f03239528f00000d",
      cost: 3215.35,
      products: [
        "63701d25f03239d591000327",
        "63701d24f03239bef000012b",
        "63701d24f032396b8e000018",
      ],
    },
    {
      _id: "63701d74f03239c72c000195",
      userId: "63701cc1f03239f09e000184",
      cost: 2639.18,
      products: ["63701d24f03239867500012c", "63701d24f03239d40b000053"],
    },
    {
      _id: "63701d74f03239c72c000196",
      userId: "63701cc1f032396b8e000007",
      cost: 3944.07,
      products: [
        "63701d24f0323986f300012a",
        "63701d24f03239b913000016",
        "63701d25f03239d591000329",
      ],
    },
    {
      _id: "63701d74f03239c72c000197",
      userId: "63701cc1f0323986f300011c",
      cost: 2828.05,
      products: [
        "63701d24f0323944410002ed",
        "63701d24f03239d40b00004a",
        "63701d24f0323944410002ee",
      ],
    },
    {
      _id: "63701d74f03239c72c000198",
      userId: "63701cc1f03239528f000014",
      cost: 3898.69,
      products: [
        "63701d25f03239d59100032a",
        "63701d24f0323944410002ec",
        "63701d24f032399c0000012a",
        "63701d24f03239d40b00004e",
      ],
    },
    {
      _id: "63701d74f03239c72c000199",
      userId: "63701cc1f03239f09e00018c",
      cost: 2838.72,
      products: [
        "63701d24f032394c4900012c",
        "63701d24f03239d40b000050",
        "63701d24f03239db6900012b",
        "63701d24f03239d40b00004f",
        "63701d24f03239528f000017",
      ],
    },
    {
      _id: "63701d74f03239c72c00019a",
      userId: "63701cc1f0323986f3000120",
      cost: 2113.01,
      products: ["63701d24f032395b3300012d"],
    },
    {
      _id: "63701d74f03239c72c00019b",
      userId: "63701cc1f03239528f00000c",
      cost: 526.17,
      products: [
        "63701d24f03239db6900012c",
        "63701d24f03239f09e000190",
        "63701d24f03239d81e000016",
        "63701d24f032396b8e000017",
        "63701d24f03239d40b000054",
      ],
    },
    {
      _id: "63701d74f03239c72c00019c",
      userId: "63701cc1f032390a34000322",
      cost: 2455.22,
      products: [
        "63701d24f032399c0000012c",
        "63701d24f03239cdc5000015",
        "63701d24f032394c4900012b",
        "63701d24f03239d40b000049",
      ],
    },
    {
      _id: "63701d74f03239c72c00019d",
      userId: "63701cc1f03239cdc5000006",
      cost: 479.22,
      products: [
        "63701d24f032395b3300012a",
        "63701d24f0323944410002ef",
        "63701d24f03239b7f7000015",
      ],
    },
    {
      _id: "63701d74f03239c72c00019e",
      userId: "63701cc1f03239569400000b",
      cost: 2678.42,
      products: [
        "63701d24f03239b913000018",
        "63701d24f03239c72c00018f",
        "63701d24f032395694000016",
        "63701d24f032396b8e000016",
      ],
    },
    {
      _id: "63701d74f03239c72c00019f",
      userId: "63701cc1f032394c4900011e",
      cost: 1213.83,
      products: [
        "63701d24f032399c0000012b",
        "63701d24f03239d81e000015",
        "63701d24f03239d40b000047",
        "63701d24f03239d40b000052",
        "63701d24f03239b7f7000016",
      ],
    },
    {
      _id: "63701d74f03239c72c0001a0",
      userId: "63701cc1f032390a34000320",
      cost: 350.07,
      products: [
        "63701d24f03239c72c000191",
        "63701d24f032395694000018",
        "63701d24f03239528f000015",
      ],
    },
    {
      _id: "63701d74f03239c72c0001a1",
      userId: "63701cc1f03239b91300000f",
      cost: 2640.21,
      products: ["63701d24f03239bef000012a", "63701d24f03239528f000018"],
    },
    {
      _id: "63701d74f03239c72c0001a2",
      userId: "63701cc1f03239db69000128",
      cost: 2719.34,
      products: ["63701d24f03239db6900012d"],
    },
    {
      _id: "63701d74f03239c72c0001a3",
      userId: "63701cc1f03239bef0000127",
      cost: 2010.31,
      products: ["63701d24f032390a34000329", "63701d24f03239d40b000051"],
    },
    {
      _id: "63701d74f03239c72c0001a4",
      userId: "63701cc1f03239bef0000129",
      cost: 3332.39,
      products: [
        "63701d24f03239bef000012d",
        "63701d24f03239d40b00004d",
        "63701d24f032395694000017",
        "63701d24f03239c72c000190",
        "63701d24f032395b3300012c",
      ],
    },
    {
      _id: "63701d74f03239c72c0001a5",
      userId: "63701cc1f03239d81e000014",
      cost: 1417.86,
      products: ["63701d24f03239b913000015"],
    },
    {
      _id: "63701d74f03239c72c0001a6",
      userId: "63701cc1f032390a3400031f",
      cost: 2771.08,
      products: [
        "63701d24f03239d81e000017",
        "63701d24f03239bef000012c",
        "63701d24f03239d40b000048",
      ],
    },
    {
      _id: "63701d74f03239c72c0001a7",
      userId: "63701cc1f03239c72c000181",
      cost: 2866.23,
      products: [
        "63701d24f03239d81e000018",
        "63701d24f0323986f300012b",
        "63701d24f03239867500012a",
      ],
    },
    {
      _id: "63701d74f03239c72c0001a8",
      userId: "63701cc1f0323944410002de",
      cost: 3430.65,
      products: ["63701d24f03239b913000017", "63701d24f032390a34000327"],
    },
    {
      _id: "63701d74f03239c72c0001a9",
      userId: "63701cc1f03239d591000323",
      cost: 1012.62,
      products: ["63701d24f032394c4900012d"],
    },
    {
      _id: "63701d74f03239c72c0001aa",
      userId: "63701cc1f03239bef0000124",
      cost: 2666,
      products: ["63701d24f03239f09e000191", "63701d24f03239f09e00018e"],
    },
    {
      _id: "63701d74f03239c72c0001ab",
      userId: "63701cc1f03239d40b00003c",
      cost: 39.18,
      products: ["63701d24f03239c72c00018e"],
    },
    {
      _id: "63701d74f03239c72c0001ac",
      userId: "63701cc1f032395b33000128",
      cost: 2028.64,
      products: [
        "63701d24f03239c72c000190",
        "63701d24f03239b7f7000017",
        "63701d24f03239b913000016",
        "63701d24f03239cdc5000017",
        "63701d24f03239d40b000055",
      ],
    },
    {
      _id: "63701d74f03239c72c0001ad",
      userId: "63701cc1f032390a34000319",
      cost: 2666.12,
      products: ["63701d24f03239db6900012d"],
    },
    {
      _id: "63701d74f03239c72c0001ae",
      userId: "63701cc1f03239b7f700000e",
      cost: 601.72,
      products: [
        "63701d24f032399c0000012c",
        "63701d24f03239db6900012b",
        "63701d24f032394c4900012d",
        "63701d24f03239f09e000191",
      ],
    },
    {
      _id: "63701d74f03239c72c0001af",
      userId: "63701cc1f032398675000122",
      cost: 2163.31,
      products: ["63701d24f03239cdc5000016"],
    },
    {
      _id: "63701d74f03239c72c0001b0",
      userId: "63701cc1f032398675000126",
      cost: 2146.86,
      products: [
        "63701d24f032395694000018",
        "63701d24f03239d40b000052",
        "63701d25f03239d591000328",
      ],
    },
    {
      _id: "63701d74f03239c72c0001b1",
      userId: "63701cc1f03239bef0000125",
      cost: 3531.1,
      products: [
        "63701d24f03239bef000012a",
        "63701d24f03239db6900012c",
        "63701d24f032396b8e000017",
        "63701d24f03239c72c00018f",
      ],
    },
    {
      _id: "63701d74f03239c72c0001b2",
      userId: "63701cc1f03239bef0000120",
      cost: 1702.37,
      products: ["63701d24f032395b3300012c", "63701d24f032395694000015"],
    },
    {
      _id: "63701d74f03239c72c0001b3",
      userId: "63701cc1f032396b8e000013",
      cost: 1681.56,
      products: [
        "63701d24f03239f09e000190",
        "63701d24f03239b7f7000018",
        "63701d24f03239d40b00004e",
        "63701d24f03239d40b00004f",
        "63701d24f03239d81e000016",
      ],
    },
    {
      _id: "63701d74f03239c72c0001b4",
      userId: "63701cc1f032396b8e00000b",
      cost: 1530.11,
      products: [
        "63701d24f03239d40b00004d",
        "63701d24f03239d81e000017",
        "63701d24f032390a3400032a",
      ],
    },
    {
      _id: "63701d74f03239c72c0001b5",
      userId: "63701cc1f03239f09e000183",
      cost: 394.26,
      products: ["63701d24f03239d40b000050", "63701d24f032399c0000012b"],
    },
    {
      _id: "63701d74f03239c72c0001b6",
      userId: "63701cc1f03239b91300000b",
      cost: 2979.19,
      products: ["63701d25f03239d591000329"],
    },
    {
      _id: "63701d74f03239c72c0001b7",
      userId: "63701cc1f032395b33000120",
      cost: 1277.12,
      products: [
        "63701d24f03239cdc5000018",
        "63701d24f03239bef000012d",
        "63701d24f03239d40b000056",
        "63701d24f03239867500012a",
      ],
    },
    {
      _id: "63701d74f03239c72c0001b8",
      userId: "63701cc1f032399c00000124",
      cost: 46.81,
      products: ["63701d25f03239d591000327"],
    },
    {
      _id: "63701d74f03239c72c0001b9",
      userId: "63701cc1f032390a34000325",
      cost: 2664.34,
      products: [
        "63701d24f03239cdc5000015",
        "63701d24f03239d81e000015",
        "63701d24f03239d40b000053",
        "63701d24f032395b3300012a",
        "63701d24f032396b8e000018",
      ],
    },
    {
      _id: "63701d74f03239c72c0001ba",
      userId: "63701cc1f03239b7f7000011",
      cost: 3066.85,
      products: ["63701d24f03239528f000017", "63701d24f0323944410002ef"],
    },
    {
      _id: "63701d74f03239c72c0001bb",
      userId: "63701cc1f03239db69000123",
      cost: 1638.82,
      products: ["63701d24f03239b913000017", "63701d24f0323944410002ec"],
    },
    {
      _id: "63701d74f03239c72c0001bc",
      userId: "63701cc1f03239db69000127",
      cost: 1165.64,
      products: ["63701d24f032394c4900012a", "63701d24f03239b7f7000016"],
    },
    {
      _id: "63701d74f03239c72c0001bd",
      userId: "63701cc1f0323944410002e2",
      cost: 2329.2,
      products: [
        "63701d24f03239d40b00004c",
        "63701d24f03239867500012b",
        "63701d24f03239b7f7000015",
        "63701d24f0323944410002ee",
        "63701d24f03239d40b000051",
      ],
    },
    {
      _id: "63701d74f03239c72c0001be",
      userId: "63701cc1f032395b33000121",
      cost: 1378.31,
      products: [
        "63701d24f03239d40b00004b",
        "63701d24f0323986f300012d",
        "63701d24f03239db6900012a",
        "63701d24f032394c4900012c",
      ],
    },
    {
      _id: "63701d74f03239c72c0001bf",
      userId: "63701cc1f0323944410002e8",
      cost: 3395.92,
      products: [
        "63701d24f03239d40b000048",
        "63701d24f03239bef000012b",
        "63701d24f032390a34000329",
        "63701d24f03239867500012c",
      ],
    },
    {
      _id: "63701d74f03239867500012e",
      userId: "63701cc1f03239b7f7000014",
      cost: 3934.55,
      products: ["63701d24f03239b913000018", "63701d24f03239d81e000018"],
    },
    {
      _id: "63701d74f03239867500012f",
      userId: "63701cc1f03239d81e00000b",
      cost: 1650.67,
      products: ["63701d24f032390a34000327"],
    },
    {
      _id: "63701d74f032398675000130",
      userId: "63701cc1f032394c49000129",
      cost: 2428.57,
      products: [
        "63701d24f032394c4900012b",
        "63701d24f03239f09e00018e",
        "63701d24f032399c0000012a",
        "63701d24f03239b913000015",
        "63701d24f032390a34000328",
      ],
    },
    {
      _id: "63701d74f032398675000131",
      userId: "63701cc1f03239528f000010",
      cost: 2996.52,
      products: [
        "63701d24f032395694000017",
        "63701d24f03239f09e00018f",
        "63701d24f03239c72c000191",
      ],
    },
    {
      _id: "63701d74f032398675000132",
      userId: "63701cc1f03239b7f700000f",
      cost: 1028.7,
      products: [
        "63701d24f03239b913000015",
        "63701d24f03239b7f7000015",
        "63701d24f032395b3300012a",
        "63701d24f03239d40b00004c",
      ],
    },
    {
      _id: "63701d74f032398675000133",
      userId: "63701cc1f032394c4900011e",
      cost: 3463.58,
      products: [
        "63701d24f03239d40b000055",
        "63701d24f03239cdc5000015",
        "63701d24f03239bef000012c",
        "63701d24f03239867500012b",
        "63701d24f03239d40b00004e",
      ],
    },
    {
      _id: "63701d74f032398675000134",
      userId: "63701cc1f03239c72c000188",
      cost: 1434.83,
      products: [
        "63701d24f0323986f300012b",
        "63701d24f03239bef000012a",
        "63701d24f03239867500012d",
        "63701d24f0323944410002ed",
        "63701d24f03239d81e000015",
      ],
    },
    {
      _id: "63701d74f032398675000135",
      userId: "63701cc1f03239db69000120",
      cost: 3925.03,
      products: [
        "63701d24f03239db6900012a",
        "63701d24f03239c72c00018f",
        "63701d24f03239d40b000056",
      ],
    },
    {
      _id: "63701d74f032398675000136",
      userId: "63701cc1f03239f09e00018d",
      cost: 2473.8,
      products: [
        "63701d24f032395694000015",
        "63701d24f03239f09e00018e",
        "63701d24f03239d81e000016",
        "63701d24f03239b913000018",
        "63701d24f0323944410002ef",
      ],
    },
    {
      _id: "63701d74f032398675000137",
      userId: "63701cc1f032390a34000318",
      cost: 3117.84,
      products: [
        "63701d24f032394c4900012a",
        "63701d24f03239db6900012b",
        "63701d24f0323944410002ee",
        "63701d24f03239528f000018",
        "63701d24f032394c4900012c",
      ],
    },
    {
      _id: "63701d74f032398675000138",
      userId: "63701cc1f03239528f000014",
      cost: 15.81,
      products: [
        "63701d24f032390a3400032a",
        "63701d24f03239d40b000050",
        "63701d24f0323986f300012c",
        "63701d24f032394c4900012d",
      ],
    },
    {
      _id: "63701d74f032398675000139",
      userId: "63701cc1f0323986f3000122",
      cost: 2986.56,
      products: ["63701d24f03239d40b000051"],
    },
    {
      _id: "63701d74f03239867500013a",
      userId: "63701cc1f0323986f300011f",
      cost: 3280.18,
      products: [
        "63701d24f032394c4900012b",
        "63701d24f03239b7f7000016",
        "63701d24f03239d40b00004f",
        "63701d24f03239d40b00004b",
      ],
    },
    {
      _id: "63701d74f03239867500013b",
      userId: "63701cc1f03239d59100031e",
      cost: 448.24,
      products: ["63701d24f03239f09e000190"],
    },
    {
      _id: "63701d74f03239867500013c",
      userId: "63701cc1f03239bef000011f",
      cost: 252.67,
      products: [
        "63701d24f032396b8e000017",
        "63701d24f032399c0000012d",
        "63701d24f03239d81e000017",
        "63701d24f03239b7f7000017",
        "63701d24f03239c72c000191",
      ],
    },
    {
      _id: "63701d74f03239867500013d",
      userId: "63701cc1f03239c72c000189",
      cost: 1047.45,
      products: [
        "63701d24f032395b3300012d",
        "63701d24f032390a34000329",
        "63701d24f03239bef000012b",
        "63701d24f03239528f000015",
        "63701d24f03239d40b00004d",
      ],
    },
    {
      _id: "63701d74f03239867500013e",
      userId: "63701cc1f03239db6900011f",
      cost: 1004.06,
      products: [
        "63701d24f03239d40b000054",
        "63701d24f03239b7f7000018",
        "63701d24f0323944410002ec",
        "63701d24f03239528f000017",
      ],
    },
    {
      _id: "63701d74f03239867500013f",
      userId: "63701cc1f03239b913000010",
      cost: 322.72,
      products: [
        "63701d24f032395b3300012c",
        "63701d24f032390a34000328",
        "63701d25f03239d591000328",
        "63701d25f03239d591000329",
        "63701d24f032396b8e000015",
      ],
    },
    {
      _id: "63701d74f032398675000140",
      userId: "63701cc1f0323944410002de",
      cost: 404.7,
      products: [
        "63701d24f03239d40b000053",
        "63701d24f032395b3300012b",
        "63701d24f03239c72c000190",
      ],
    },
    {
      _id: "63701d74f032398675000141",
      userId: "63701cc1f03239d59100031d",
      cost: 1349.65,
      products: [
        "63701d24f03239d40b000048",
        "63701d24f032399c0000012c",
        "63701d24f0323986f300012d",
        "63701d24f032395694000016",
      ],
    },
    {
      _id: "63701d74f032398675000142",
      userId: "63701cc1f032396b8e000006",
      cost: 311.93,
      products: ["63701d24f03239f09e00018f"],
    },
    {
      _id: "63701d74f032398675000143",
      userId: "63701cc1f03239b913000009",
      cost: 3087.45,
      products: [
        "63701d24f03239b913000017",
        "63701d24f032390a34000327",
        "63701d24f032395694000017",
        "63701d24f032396b8e000018",
      ],
    },
    {
      _id: "63701d74f032398675000144",
      userId: "63701cc1f03239f09e000184",
      cost: 1824.33,
      products: ["63701d24f032399c0000012a"],
    },
    {
      _id: "63701d74f032398675000145",
      userId: "63701cc1f032390a34000319",
      cost: 3238.44,
      products: [
        "63701d24f03239867500012a",
        "63701d24f03239d40b00004a",
        "63701d24f03239d40b000047",
        "63701d24f03239d81e000018",
      ],
    },
    {
      _id: "63701d74f032398675000146",
      userId: "63701cc1f032390a34000324",
      cost: 741.08,
      products: [
        "63701d24f03239cdc5000018",
        "63701d24f03239d40b000049",
        "63701d24f03239cdc5000016",
        "63701d24f03239528f000016",
      ],
    },
    {
      _id: "63701d74f032398675000147",
      userId: "63701cc1f0323986f3000124",
      cost: 1416.51,
      products: ["63701d24f03239c72c00018e"],
    },
    {
      _id: "63701d74f032398675000148",
      userId: "63701cc1f03239d40b000046",
      cost: 2765.52,
      products: [
        "63701d24f03239867500012c",
        "63701d24f0323986f300012a",
        "63701d24f032396b8e000016",
      ],
    },
    {
      _id: "63701d74f032398675000149",
      userId: "63701cc1f03239c72c00018c",
      cost: 3616.77,
      products: ["63701d24f03239bef000012d"],
    },
    {
      _id: "63701d74f03239867500014a",
      userId: "63701cc1f03239d591000320",
      cost: 2867.59,
      products: ["63701d24f032399c0000012b", "63701d24f03239db6900012d"],
    },
    {
      _id: "63701d74f03239867500014b",
      userId: "63701cc1f03239d59100031e",
      cost: 1856.78,
      products: [
        "63701d24f0323986f300012d",
        "63701d25f03239d59100032a",
        "63701d24f03239d40b00004e",
        "63701d24f03239cdc5000018",
      ],
    },
    {
      _id: "63701d74f03239867500014c",
      userId: "63701cc1f032390a3400031f",
      cost: 1895.99,
      products: [
        "63701d24f032394c4900012b",
        "63701d24f03239f09e000191",
        "63701d24f032390a34000327",
      ],
    },
    {
      _id: "63701d74f03239867500014d",
      userId: "63701cc1f03239b913000007",
      cost: 2642.94,
      products: ["63701d24f03239b913000018"],
    },
    {
      _id: "63701d74f03239867500014e",
      userId: "63701cc1f0323944410002eb",
      cost: 1513.8,
      products: [
        "63701d24f03239c72c00018e",
        "63701d24f032395694000018",
        "63701d24f032399c0000012a",
        "63701d25f03239d591000327",
        "63701d24f032395b3300012b",
      ],
    },
    {
      _id: "63701d74f03239867500014f",
      userId: "63701cc1f03239b91300000d",
      cost: 1729.13,
      products: [
        "63701d24f03239c72c00018f",
        "63701d24f03239d81e000018",
        "63701d24f03239d40b000054",
      ],
    },
    {
      _id: "63701d74f032398675000150",
      userId: "63701cc1f032390a34000318",
      cost: 2249.24,
      products: ["63701d24f03239d40b00004b"],
    },
    {
      _id: "63701d74f032398675000151",
      userId: "63701cc1f0323986f300011b",
      cost: 326.45,
      products: ["63701d24f03239f09e00018e", "63701d24f03239d40b000051"],
    },
    {
      _id: "63701d74f032398675000152",
      userId: "63701cc1f03239d81e000010",
      cost: 442.46,
      products: ["63701d24f03239bef000012a", "63701d24f03239d40b000056"],
    },
    {
      _id: "63701d74f032398675000153",
      userId: "63701cc1f03239d81e000007",
      cost: 1839.71,
      products: [
        "63701d24f03239867500012c",
        "63701d24f03239c72c000190",
        "63701d24f03239d40b000055",
        "63701d24f03239bef000012c",
      ],
    },
    {
      _id: "63701d74f032398675000154",
      userId: "63701cc1f03239cdc500000f",
      cost: 1984.49,
      products: ["63701d24f0323986f300012c", "63701d24f03239b913000017"],
    },
    {
      _id: "63701d74f032398675000155",
      userId: "63701cc1f032396b8e000012",
      cost: 740.68,
      products: ["63701d24f032395b3300012a", "63701d24f032390a34000328"],
    },
    {
      _id: "63701d74f032398675000156",
      userId: "63701cc1f03239cdc5000014",
      cost: 326.64,
      products: ["63701d24f03239f09e000190", "63701d24f03239f09e00018f"],
    },
    {
      _id: "63701d74f032398675000157",
      userId: "63701cc1f03239db69000120",
      cost: 12.77,
      products: ["63701d24f03239db6900012d", "63701d24f03239db6900012a"],
    },
    {
      _id: "63701d74f032398675000158",
      userId: "63701cc1f03239d40b000040",
      cost: 1669.08,
      products: [
        "63701d24f032390a34000329",
        "63701d24f03239b7f7000017",
        "63701d24f03239528f000018",
      ],
    },
    {
      _id: "63701d74f032398675000159",
      userId: "63701cc1f03239b7f7000008",
      cost: 3730.68,
      products: [
        "63701d24f03239867500012a",
        "63701d24f03239528f000017",
        "63701d24f03239b913000016",
        "63701d24f03239cdc5000017",
      ],
    },
    {
      _id: "63701d74f03239867500015a",
      userId: "63701cc1f03239b7f700000e",
      cost: 2928.08,
      products: ["63701d24f03239d81e000017", "63701d24f0323944410002ed"],
    },
    {
      _id: "63701d74f03239867500015b",
      userId: "63701cc1f03239cdc500000a",
      cost: 2068.11,
      products: ["63701d24f03239d81e000016"],
    },
    {
      _id: "63701d74f03239b7f7000019",
      userId: "63701cc1f03239569400000d",
      cost: 2503.88,
      products: [
        "63701d25f03239d591000328",
        "63701d24f032396b8e000016",
        "63701d24f03239d40b000053",
      ],
    },
    {
      _id: "63701d74f03239b7f700001a",
      userId: "63701cc1f032395b33000123",
      cost: 2318.07,
      products: ["63701d24f032394c4900012c", "63701d24f03239b7f7000015"],
    },
    {
      _id: "63701d74f03239b7f700001b",
      userId: "63701cc1f03239528f000007",
      cost: 3282.35,
      products: [
        "63701d24f032399c0000012b",
        "63701d24f03239d40b000049",
        "63701d24f03239db6900012c",
        "63701d24f032395694000017",
      ],
    },
    {
      _id: "63701d74f03239b7f700001c",
      userId: "63701cc1f03239c72c000182",
      cost: 1347.43,
      products: ["63701d24f032399c0000012d"],
    },
    {
      _id: "63701d74f03239b7f700001d",
      userId: "63701cc1f032399c0000011b",
      cost: 874.77,
      products: [
        "63701d24f03239867500012d",
        "63701d24f03239db6900012b",
        "63701d24f03239c72c000191",
        "63701d24f03239b913000015",
      ],
    },
    {
      _id: "63701d74f03239b7f700001e",
      userId: "63701cc1f032394c4900011b",
      cost: 2835.28,
      products: [
        "63701d24f032395694000016",
        "63701d24f03239d40b00004f",
        "63701d24f03239cdc5000015",
        "63701d24f03239bef000012d",
        "63701d24f03239d81e000015",
      ],
    },
    {
      _id: "63701d74f03239b7f700001f",
      userId: "63701cc1f03239db69000127",
      cost: 2192.19,
      products: ["63701d24f03239528f000016", "63701d24f0323944410002ee"],
    },
    {
      _id: "63701d74f03239b7f7000020",
      userId: "63701cc1f03239db6900011d",
      cost: 669.23,
      products: ["63701d24f032396b8e000018"],
    },
    {
      _id: "63701d74f03239b7f7000021",
      userId: "63701cc1f0323944410002e0",
      cost: 1093.3,
      products: [
        "63701d24f032395694000015",
        "63701d24f03239d40b00004d",
        "63701d24f03239db6900012b",
        "63701d24f03239d40b000054",
        "63701d24f032396b8e000017",
      ],
    },
    {
      _id: "63701d74f03239b7f7000022",
      userId: "63701cc1f03239bef0000123",
      cost: 1630.72,
      products: [
        "63701d24f0323944410002ef",
        "63701d24f03239cdc5000016",
        "63701d24f03239d40b000055",
        "63701d24f03239d40b000053",
      ],
    },
    {
      _id: "63701d74f03239b7f7000023",
      userId: "63701cc1f032396b8e00000f",
      cost: 776.76,
      products: [
        "63701d24f032396b8e000018",
        "63701d24f03239b913000015",
        "63701d24f03239bef000012a",
      ],
    },
    {
      _id: "63701d74f03239b7f7000024",
      userId: "63701cc1f032395694000012",
      cost: 2559.5,
      products: ["63701d24f032394c4900012c"],
    },
    {
      _id: "63701d74f03239b7f7000025",
      userId: "63701cc1f03239db69000123",
      cost: 83.04,
      products: ["63701d24f03239b7f7000018"],
    },
    {
      _id: "63701d74f03239b7f7000026",
      userId: "63701cc1f03239db69000125",
      cost: 2729.82,
      products: ["63701d24f0323986f300012d", "63701d24f03239b913000018"],
    },
    {
      _id: "63701d74f03239b7f7000027",
      userId: "63701cc1f03239528f00000b",
      cost: 3419.77,
      products: [
        "63701d24f032396b8e000015",
        "63701d24f0323986f300012a",
        "63701d24f03239f09e000190",
        "63701d24f032394c4900012d",
        "63701d24f032399c0000012c",
      ],
    },
    {
      _id: "63701d74f03239b7f7000028",
      userId: "63701cc1f03239d591000320",
      cost: 1219.98,
      products: ["63701d24f032390a34000327"],
    },
    {
      _id: "63701d74f03239b7f7000029",
      userId: "63701cc1f03239d81e00000c",
      cost: 2797.14,
      products: [
        "63701d24f03239d40b00004c",
        "63701d24f03239db6900012c",
        "63701d24f03239c72c000191",
        "63701d25f03239d591000327",
      ],
    },
    {
      _id: "63701d74f03239b7f700002a",
      userId: "63701cc1f03239b7f7000011",
      cost: 3971.67,
      products: [
        "63701d24f03239bef000012b",
        "63701d24f03239cdc5000018",
        "63701d24f032399c0000012a",
        "63701d24f032394c4900012a",
      ],
    },
    {
      _id: "63701d74f03239b7f700002b",
      userId: "63701cc1f03239f09e00018a",
      cost: 923.63,
      products: ["63701d24f03239d40b000051", "63701d24f03239867500012d"],
    },
    {
      _id: "63701d74f03239b7f700002c",
      userId: "63701cc1f03239f09e00017f",
      cost: 1756.36,
      products: [
        "63701d24f03239cdc5000015",
        "63701d24f032395b3300012d",
        "63701d24f03239b913000017",
        "63701d24f03239528f000018",
        "63701d24f03239d40b00004f",
      ],
    },
    {
      _id: "63701d74f03239b7f700002d",
      userId: "63701cc1f0323986f300011d",
      cost: 3323.5,
      products: ["63701d25f03239d59100032a", "63701d24f03239d40b000056"],
    },
    {
      _id: "63701d74f03239b7f700002e",
      userId: "63701cc1f03239d591000326",
      cost: 2546.93,
      products: [
        "63701d24f03239d81e000018",
        "63701d24f032395b3300012a",
        "63701d24f03239d40b000052",
      ],
    },
    {
      _id: "63701d74f03239b7f700002f",
      userId: "63701cc1f032399c00000123",
      cost: 1720.08,
      products: ["63701d24f032399c0000012b"],
    },
    {
      _id: "63701d74f03239b7f7000030",
      userId: "63701cc1f03239cdc500000c",
      cost: 1035.65,
      products: ["63701d25f03239d591000329", "63701d24f03239b7f7000017"],
    },
    {
      _id: "63701d74f03239b7f7000031",
      userId: "63701cc1f0323986f3000122",
      cost: 223.87,
      products: [
        "63701d24f032395694000018",
        "63701d24f03239d40b000050",
        "63701d24f032395b3300012c",
      ],
    },
    {
      _id: "63701d74f03239b7f7000032",
      userId: "63701cc1f03239d59100031d",
      cost: 2962.55,
      products: [
        "63701d24f032399c0000012d",
        "63701d24f03239867500012b",
        "63701d25f03239d591000328",
        "63701d24f03239bef000012c",
        "63701d24f03239528f000017",
      ],
    },
    {
      _id: "63701d74f03239b7f7000033",
      userId: "63701cc1f032390a34000326",
      cost: 3538.76,
      products: [
        "63701d24f03239db6900012a",
        "63701d24f03239d40b000047",
        "63701d24f03239d40b00004a",
        "63701d24f032394c4900012b",
        "63701d24f03239d40b000048",
      ],
    },
    {
      _id: "63701d74f03239b7f7000034",
      userId: "63701cc1f032394c4900011b",
      cost: 3134.54,
      products: ["63701d24f0323944410002ec"],
    },
    {
      _id: "63701d74f03239b7f7000035",
      userId: "63701cc1f03239528f00000c",
      cost: 1017.55,
      products: [
        "63701d24f03239db6900012d",
        "63701d24f03239d40b00004b",
        "63701d24f03239b7f7000015",
      ],
    },
    {
      _id: "63701d74f03239b7f7000036",
      userId: "63701cc1f03239db69000120",
      cost: 1800.07,
      products: ["63701d24f03239f09e00018f"],
    },
    {
      _id: "63701d74f03239b7f7000037",
      userId: "63701cc1f03239528f00000a",
      cost: 2370.96,
      products: [
        "63701d24f032396b8e000016",
        "63701d24f032390a34000328",
        "63701d24f032390a3400032a",
      ],
    },
    {
      _id: "63701d74f03239b7f7000038",
      userId: "63701cc1f032394c49000121",
      cost: 3861.7,
      products: [
        "63701d24f03239528f000015",
        "63701d24f03239d40b00004e",
        "63701d24f032395b3300012b",
      ],
    },
    {
      _id: "63701d74f03239b7f7000039",
      userId: "63701cc1f032390a3400031f",
      cost: 1701.46,
      products: ["63701d24f032390a34000329", "63701d24f03239c72c00018e"],
    },
    {
      _id: "63701d74f03239b7f700003a",
      userId: "63701cc1f032395694000013",
      cost: 2136.5,
      products: [
        "63701d24f03239d81e000015",
        "63701d24f032399c0000012b",
        "63701d24f03239b913000017",
        "63701d24f0323986f300012d",
        "63701d24f03239c72c000191",
      ],
    },
    {
      _id: "63701d74f03239b7f700003b",
      userId: "63701cc1f03239cdc5000012",
      cost: 2035.98,
      products: [
        "63701d24f03239d40b00004f",
        "63701d24f03239cdc5000018",
        "63701d24f03239f09e00018e",
      ],
    },
    {
      _id: "63701d74f03239b7f700003c",
      userId: "63701cc1f03239f09e00018b",
      cost: 61.48,
      products: [
        "63701d24f032390a34000329",
        "63701d24f03239bef000012a",
        "63701d24f03239d40b000051",
        "63701d24f032394c4900012d",
        "63701d24f03239d40b000050",
      ],
    },
    {
      _id: "63701d74f03239b7f700003d",
      userId: "63701cc1f03239cdc5000014",
      cost: 2872.61,
      products: ["63701d24f032390a3400032a", "63701d24f03239867500012c"],
    },
    {
      _id: "63701d74f03239b7f700003e",
      userId: "63701cc1f032396b8e000010",
      cost: 1588.75,
      products: [
        "63701d24f03239867500012b",
        "63701d25f03239d591000327",
        "63701d24f03239d81e000018",
      ],
    },
    {
      _id: "63701d74f03239b7f700003f",
      userId: "63701cc1f032396b8e00000c",
      cost: 1521.71,
      products: [
        "63701d24f03239db6900012c",
        "63701d24f032395b3300012a",
        "63701d24f032394c4900012c",
        "63701d24f032394c4900012b",
      ],
    },
    {
      _id: "63701d74f03239b7f7000040",
      userId: "63701cc1f0323986f300011d",
      cost: 1589.39,
      products: [
        "63701d24f03239528f000016",
        "63701d24f032395b3300012d",
        "63701d24f03239cdc5000016",
        "63701d24f032390a34000327",
        "63701d24f032399c0000012c",
      ],
    },
    {
      _id: "63701d74f03239b7f7000041",
      userId: "63701cc1f0323944410002df",
      cost: 2292.43,
      products: ["63701d24f03239bef000012b", "63701d24f032395694000016"],
    },
    {
      _id: "63701d74f03239b7f7000042",
      userId: "63701cc1f03239d81e000014",
      cost: 2654.51,
      products: [
        "63701d24f0323986f300012c",
        "63701d24f03239d81e000017",
        "63701d24f032399c0000012a",
        "63701d24f03239d40b000054",
      ],
    },
    {
      _id: "63701d74f03239b7f7000043",
      userId: "63701cc1f032394c49000129",
      cost: 3021.81,
      products: ["63701d24f03239d40b00004c", "63701d24f03239db6900012d"],
    },
    {
      _id: "63701d74f03239b7f7000044",
      userId: "63701cc1f032394c49000121",
      cost: 1008.2,
      products: ["63701d24f03239d40b000056", "63701d24f03239b913000015"],
    },
    {
      _id: "63701d74f03239b7f7000045",
      userId: "63701cc1f03239b7f700000b",
      cost: 3199.09,
      products: ["63701d24f032396b8e000018"],
    },
    {
      _id: "63701d74f03239b7f7000046",
      userId: "63701cc1f03239bef000011e",
      cost: 2457.04,
      products: [
        "63701d24f03239d40b000053",
        "63701d24f03239d40b000052",
        "63701d24f03239bef000012c",
      ],
    },
    {
      _id: "63701d74f0323944410002f0",
      userId: "63701cc1f032394c49000127",
      cost: 1011.46,
      products: [
        "63701d25f03239d59100032a",
        "63701d24f032395694000015",
        "63701d24f03239b7f7000016",
        "63701d24f0323944410002ee",
      ],
    },
    {
      _id: "63701d74f0323944410002f1",
      userId: "63701cc1f03239867500011d",
      cost: 400.92,
      products: ["63701d24f032395694000017"],
    },
    {
      _id: "63701d74f0323944410002f2",
      userId: "63701cc1f03239d81e000007",
      cost: 272.9,
      products: ["63701d24f03239f09e000190", "63701d24f03239867500012a"],
    },
    {
      _id: "63701d74f0323944410002f3",
      userId: "63701cc1f03239b913000007",
      cost: 1751.19,
      products: [
        "63701d24f03239bef000012d",
        "63701d24f03239d40b00004a",
        "63701d24f032394c4900012a",
        "63701d24f03239db6900012a",
        "63701d24f03239cdc5000015",
      ],
    },
    {
      _id: "63701d74f0323944410002f4",
      userId: "63701cc1f03239b7f700000f",
      cost: 1045.99,
      products: ["63701d24f03239528f000015"],
    },
    {
      _id: "63701d74f0323944410002f5",
      userId: "63701cc1f03239bef0000128",
      cost: 1720.34,
      products: [
        "63701d24f0323944410002ef",
        "63701d24f03239b7f7000015",
        "63701d24f0323986f300012b",
        "63701d24f032396b8e000017",
        "63701d24f03239d40b000055",
      ],
    },
    {
      _id: "63701d74f0323944410002f6",
      userId: "63701cc1f03239cdc500000c",
      cost: 3682.05,
      products: ["63701d25f03239d591000329", "63701d25f03239d591000328"],
    },
    {
      _id: "63701d74f0323944410002f7",
      userId: "63701cc1f03239d40b000045",
      cost: 711.15,
      products: ["63701d24f03239528f000017"],
    },
    {
      _id: "63701d74f0323944410002f8",
      userId: "63701cc1f03239d81e000013",
      cost: 192.99,
      products: [
        "63701d24f03239d40b000047",
        "63701d24f03239c72c00018e",
        "63701d24f032395b3300012b",
        "63701d24f032396b8e000016",
        "63701d24f03239f09e000191",
      ],
    },
    {
      _id: "63701d74f0323944410002f9",
      userId: "63701cc1f03239d40b00003d",
      cost: 1498.53,
      products: [
        "63701d24f032396b8e000015",
        "63701d24f03239d40b00004b",
        "63701d24f03239c72c00018f",
      ],
    },
    {
      _id: "63701d74f0323944410002fa",
      userId: "63701cc1f03239d40b00003b",
      cost: 937.92,
      products: [
        "63701d24f032399c0000012d",
        "63701d24f03239d40b00004e",
        "63701d24f0323944410002ec",
      ],
    },
    {
      _id: "63701d74f0323944410002fb",
      userId: "63701cc1f0323944410002e9",
      cost: 2191.37,
      products: [
        "63701d24f03239b7f7000017",
        "63701d24f03239f09e00018f",
        "63701d24f03239c72c000190",
      ],
    },
    {
      _id: "63701d74f0323944410002fc",
      userId: "63701cc1f03239d81e00000c",
      cost: 1696.79,
      products: ["63701d24f03239b913000018", "63701d24f03239d40b000051"],
    },
    {
      _id: "63701d74f0323944410002fd",
      userId: "63701cc1f03239867500011e",
      cost: 341.97,
      products: ["63701d24f03239867500012c"],
    },
    {
      _id: "63701d74f0323944410002fe",
      userId: "63701cc1f032398675000123",
      cost: 1379.87,
      products: [
        "63701d24f032395694000017",
        "63701d24f032396b8e000018",
        "63701d24f03239d40b00004f",
        "63701d24f03239c72c00018e",
        "63701d24f03239db6900012b",
      ],
    },
    {
      _id: "63701d74f0323944410002ff",
      userId: "63701cc1f03239b913000008",
      cost: 180.64,
      products: [
        "63701d24f03239867500012d",
        "63701d24f03239c72c000191",
        "63701d24f03239d40b00004b",
        "63701d24f03239f09e000190",
      ],
    },
    {
      _id: "63701d74f032394441000300",
      userId: "63701cc1f032394c4900011c",
      cost: 145.14,
      products: [
        "63701d24f03239d40b00004a",
        "63701d24f03239f09e00018f",
        "63701d24f032394c4900012a",
        "63701d24f03239bef000012c",
        "63701d24f03239867500012b",
      ],
    },
    {
      _id: "63701d74f032394441000301",
      userId: "63701cc1f03239d591000322",
      cost: 3881.29,
      products: [
        "63701d24f032395b3300012d",
        "63701d24f032390a34000329",
        "63701d24f03239cdc5000017",
        "63701d24f0323986f300012a",
      ],
    },
    {
      _id: "63701d74f032394441000302",
      userId: "63701cc1f03239b913000011",
      cost: 24.01,
      products: ["63701d25f03239d591000329"],
    },
    {
      _id: "63701d74f032394441000303",
      userId: "63701cc1f03239528f00000d",
      cost: 1988.69,
      products: [
        "63701d24f032394c4900012d",
        "63701d24f03239b913000017",
        "63701d24f032390a3400032a",
        "63701d24f03239d40b000053",
      ],
    },
    {
      _id: "63701d74f032394441000304",
      userId: "63701cc1f032398675000125",
      cost: 3909.76,
      products: ["63701d24f03239c72c000190", "63701d24f032396b8e000015"],
    },
    {
      _id: "63701d74f032394441000305",
      userId: "63701cc1f03239d59100031c",
      cost: 20.45,
      products: [
        "63701d24f03239b7f7000015",
        "63701d24f032394c4900012c",
        "63701d24f03239cdc5000015",
        "63701d24f032395694000016",
        "63701d24f03239b7f7000016",
      ],
    },
    {
      _id: "63701d74f032394441000306",
      userId: "63701cc1f03239f09e000181",
      cost: 52.32,
      products: [
        "63701d24f03239528f000015",
        "63701d24f03239cdc5000018",
        "63701d24f03239bef000012d",
      ],
    },
    {
      _id: "63701d74f032394441000307",
      userId: "63701cc1f03239c72c000185",
      cost: 2395.14,
      products: [
        "63701d24f03239cdc5000016",
        "63701d24f032390a34000328",
        "63701d24f03239b913000016",
        "63701d24f03239d40b000047",
      ],
    },
    {
      _id: "63701d74f032394441000308",
      userId: "63701cc1f03239569400000c",
      cost: 393.18,
      products: [
        "63701d24f032395694000015",
        "63701d24f032396b8e000016",
        "63701d24f03239f09e000191",
        "63701d24f0323986f300012c",
        "63701d24f032399c0000012d",
      ],
    },
    {
      _id: "63701d74f032394441000309",
      userId: "63701cc1f03239c72c00017f",
      cost: 1668.42,
      products: ["63701d24f03239d40b000050"],
    },
    {
      _id: "63701d74f03239444100030a",
      userId: "63701cc1f03239b91300000e",
      cost: 2774.08,
      products: [
        "63701d24f032390a34000327",
        "63701d24f032399c0000012c",
        "63701d24f03239c72c00018f",
        "63701d24f03239db6900012c",
        "63701d24f03239d40b000055",
      ],
    },
    {
      _id: "63701d74f03239444100030b",
      userId: "63701cc1f03239d81e00000b",
      cost: 3241.98,
      products: [
        "63701d24f032399c0000012b",
        "63701d24f03239528f000017",
        "63701d24f03239d81e000018",
        "63701d24f03239db6900012d",
      ],
    },
    {
      _id: "63701d74f03239444100030c",
      userId: "63701cc1f032390a3400031e",
      cost: 537.57,
      products: [
        "63701d24f032395b3300012c",
        "63701d24f03239d40b00004e",
        "63701d24f0323944410002ed",
        "63701d24f03239528f000016",
      ],
    },
    {
      _id: "63701d74f03239444100030d",
      userId: "63701cc1f032396b8e00000a",
      cost: 3024.75,
      products: ["63701d24f03239b7f7000018"],
    },
    {
      _id: "63701d74f03239444100030e",
      userId: "63701cc1f03239528f000009",
      cost: 882.19,
      products: [
        "63701d24f03239b913000015",
        "63701d24f0323944410002ee",
        "63701d24f032395b3300012a",
        "63701d24f03239bef000012b",
      ],
    },
    {
      _id: "63701d74f03239444100030f",
      userId: "63701cc1f0323944410002dd",
      cost: 3720.71,
      products: [
        "63701d24f03239d81e000016",
        "63701d24f03239d81e000015",
        "63701d24f032396b8e000017",
      ],
    },
    {
      _id: "63701d74f032394441000310",
      userId: "63701cc1f03239c72c000188",
      cost: 3040.09,
      products: ["63701d24f03239d40b000048"],
    },
    {
      _id: "63701d74f032394441000311",
      userId: "63701cc1f0323944410002e5",
      cost: 273.86,
      products: [
        "63701d24f032394c4900012b",
        "63701d24f03239b7f7000017",
        "63701d24f03239d81e000017",
        "63701d24f0323986f300012b",
      ],
    },
    {
      _id: "63701d74f032394441000312",
      userId: "63701cc1f032395b3300011e",
      cost: 1751.67,
      products: [
        "63701d24f03239d40b000056",
        "63701d24f03239528f000018",
        "63701d24f03239d40b000054",
        "63701d25f03239d59100032a",
        "63701d24f03239bef000012a",
      ],
    },
    {
      _id: "63701d74f032394441000313",
      userId: "63701cc1f032395b3300011f",
      cost: 698.12,
      products: [
        "63701d24f0323986f300012d",
        "63701d24f0323944410002ec",
        "63701d24f03239db6900012a",
      ],
    },
    {
      _id: "63701d74f032394441000314",
      userId: "63701cc1f03239d81e000006",
      cost: 562.1,
      products: ["63701d24f03239d40b000052"],
    },
    {
      _id: "63701d74f032394441000315",
      userId: "63701cc1f0323986f300011e",
      cost: 323.69,
      products: ["63701d24f032399c0000012c", "63701d24f03239d40b000056"],
    },
    {
      _id: "63701d74f032394441000316",
      userId: "63701cc1f0323944410002de",
      cost: 1783.11,
      products: [
        "63701d24f0323944410002ef",
        "63701d24f03239cdc5000015",
        "63701d24f0323986f300012b",
        "63701d24f032395b3300012a",
        "63701d24f03239cdc5000018",
      ],
    },
    {
      _id: "63701d74f032394441000317",
      userId: "63701cc1f03239d81e000007",
      cost: 307.78,
      products: ["63701d24f03239b913000018", "63701d24f03239d81e000016"],
    },
    {
      _id: "63701d74f032394441000318",
      userId: "63701cc1f03239c72c000186",
      cost: 1941.33,
      products: ["63701d24f032394c4900012d", "63701d24f03239b913000015"],
    },
    {
      _id: "63701d74f032394441000319",
      userId: "63701cc1f03239c72c000189",
      cost: 777.82,
      products: [
        "63701d24f032390a34000327",
        "63701d24f03239c72c00018e",
        "63701d24f03239cdc5000016",
        "63701d24f03239b7f7000017",
        "63701d24f03239d40b000047",
      ],
    },
    {
      _id: "63701d74f03239444100031a",
      userId: "63701cc1f0323986f3000129",
      cost: 896.38,
      products: ["63701d24f03239867500012a"],
    },
    {
      _id: "63701d74f03239444100031b",
      userId: "63701cc1f032390a3400031b",
      cost: 3993.14,
      products: [
        "63701d24f03239b913000016",
        "63701d24f03239b7f7000018",
        "63701d24f032395694000015",
        "63701d24f032396b8e000017",
      ],
    },
    {
      _id: "63701d74f03239444100031c",
      userId: "63701cc1f03239867500011f",
      cost: 2104.01,
      products: [
        "63701d24f032395b3300012c",
        "63701d24f03239d40b00004c",
        "63701d24f032394c4900012a",
      ],
    },
    {
      _id: "63701d74f03239444100031d",
      userId: "63701cc1f03239bef000011b",
      cost: 1424.53,
      products: ["63701d24f03239c72c00018f"],
    },
    {
      _id: "63701d74f03239d81e000019",
      userId: "63701cc1f03239b91300000b",
      cost: 1206.91,
      products: ["63701d24f032399c0000012b"],
    },
    {
      _id: "63701d74f03239d81e00001a",
      userId: "63701cc1f03239db69000128",
      cost: 2593.32,
      products: [
        "63701d24f03239528f000016",
        "63701d24f03239528f000017",
        "63701d24f032399c0000012a",
        "63701d24f03239b7f7000015",
        "63701d24f032395b3300012b",
      ],
    },
    {
      _id: "63701d74f03239d81e00001b",
      userId: "63701cc1f032399c00000127",
      cost: 441.63,
      products: [
        "63701d24f03239bef000012b",
        "63701d24f03239f09e000191",
        "63701d24f03239d40b00004b",
        "63701d24f032399c0000012d",
      ],
    },
    {
      _id: "63701d74f03239d81e00001c",
      userId: "63701cc1f03239f09e000185",
      cost: 3543.34,
      products: [
        "63701d24f03239db6900012c",
        "63701d24f032396b8e000015",
        "63701d24f03239867500012c",
        "63701d24f03239d40b000054",
        "63701d24f032396b8e000016",
      ],
    },
    {
      _id: "63701d74f03239d81e00001d",
      userId: "63701cc1f03239528f00000f",
      cost: 927.82,
      products: [
        "63701d24f03239c72c000190",
        "63701d24f03239867500012b",
        "63701d24f03239528f000018",
        "63701d24f03239bef000012a",
        "63701d24f032390a34000328",
      ],
    },
    {
      _id: "63701d74f03239d81e00001e",
      userId: "63701cc1f03239c72c000180",
      cost: 659.42,
      products: ["63701d24f032395694000017", "63701d25f03239d591000327"],
    },
    {
      _id: "63701d74f03239d81e00001f",
      userId: "63701cc1f0323944410002eb",
      cost: 1523.55,
      products: ["63701d24f03239d40b00004e"],
    },
    {
      _id: "63701d74f03239d81e000020",
      userId: "63701cc1f032395b3300011b",
      cost: 1236.25,
      products: [
        "63701d24f03239b7f7000016",
        "63701d24f03239d40b00004d",
        "63701d24f03239bef000012c",
      ],
    },
    {
      _id: "63701d74f03239d81e000021",
      userId: "63701cc1f032399c00000128",
      cost: 2512.96,
      products: [
        "63701d24f03239f09e000190",
        "63701d24f032394c4900012c",
        "63701d24f032390a3400032a",
        "63701d24f03239d40b000050",
        "63701d24f03239d40b000053",
      ],
    },
    {
      _id: "63701d74f03239d81e000022",
      userId: "63701cc1f03239b7f700000b",
      cost: 2015.04,
      products: [
        "63701d24f03239f09e00018e",
        "63701d25f03239d59100032a",
        "63701d24f03239d40b000052",
        "63701d24f03239b913000017",
      ],
    },
    {
      _id: "63701d74f03239d81e000023",
      userId: "63701cc1f032390a3400031e",
      cost: 1171.28,
      products: ["63701d24f03239d81e000017"],
    },
    {
      _id: "63701d74f03239d81e000024",
      userId: "63701cc1f03239db69000129",
      cost: 2576.39,
      products: [
        "63701d25f03239d591000329",
        "63701d24f03239d40b000051",
        "63701d24f032395694000018",
        "63701d24f032390a34000329",
      ],
    },
    {
      _id: "63701d74f03239d81e000025",
      userId: "63701cc1f03239b7f7000012",
      cost: 479,
      products: [
        "63701d24f0323986f300012c",
        "63701d24f03239cdc5000017",
        "63701d24f03239db6900012b",
        "63701d24f03239bef000012d",
        "63701d24f03239f09e00018f",
      ],
    },
    {
      _id: "63701d74f03239d81e000026",
      userId: "63701cc1f03239b913000010",
      cost: 658.96,
      products: [
        "63701d24f03239db6900012a",
        "63701d24f03239d40b000049",
        "63701d24f032395b3300012d",
      ],
    },
    {
      _id: "63701d74f03239d81e000027",
      userId: "63701cc1f032396b8e000012",
      cost: 3673.32,
      products: ["63701d24f0323944410002ee", "63701d24f03239d40b000055"],
    },
    {
      _id: "63701d74f03239d81e000028",
      userId: "63701cc1f03239f09e00018c",
      cost: 3012.39,
      products: ["63701d24f0323986f300012a", "63701d24f032395694000016"],
    },
    {
      _id: "63701d74f03239d81e000029",
      userId: "63701cc1f032395694000010",
      cost: 3655.64,
      products: [
        "63701d24f03239b7f7000017",
        "63701d24f03239b7f7000016",
        "63701d24f03239d40b000054",
      ],
    },
    {
      _id: "63701d74f03239d81e00002a",
      userId: "63701cc1f03239cdc500000f",
      cost: 2519.39,
      products: [
        "63701d24f03239528f000018",
        "63701d24f03239528f000015",
        "63701d24f03239867500012c",
      ],
    },
    {
      _id: "63701d74f03239d81e00002b",
      userId: "63701cc1f03239d40b000038",
      cost: 3852.49,
      products: ["63701d24f032395b3300012b"],
    },
    {
      _id: "63701d74f03239d81e00002c",
      userId: "63701cc1f032395b3300011b",
      cost: 1390.8,
      products: ["63701d24f032395694000018"],
    },
    {
      _id: "63701d74f03239d81e00002d",
      userId: "63701cc1f03239528f000008",
      cost: 3458.65,
      products: ["63701d24f032394c4900012a"],
    },
    {
      _id: "63701d74f03239d81e00002e",
      userId: "63701cc1f03239528f000012",
      cost: 1891.32,
      products: [
        "63701d24f03239bef000012b",
        "63701d24f03239db6900012d",
        "63701d24f0323986f300012b",
      ],
    },
    {
      _id: "63701d74f03239d81e00002f",
      userId: "63701cc1f03239bef000011d",
      cost: 175.66,
      products: ["63701d24f03239cdc5000016"],
    },
    {
      _id: "63701d74f03239d81e000030",
      userId: "63701cc1f0323986f300011b",
      cost: 3556.56,
      products: ["63701d24f03239867500012b", "63701d24f032394c4900012b"],
    },
    {
      _id: "63701d74f03239d81e000031",
      userId: "63701cc1f03239b7f7000013",
      cost: 255.71,
      products: [
        "63701d24f032399c0000012d",
        "63701d24f032395b3300012a",
        "63701d25f03239d59100032a",
        "63701d24f03239bef000012c",
        "63701d24f03239d40b00004f",
      ],
    },
    {
      _id: "63701d74f03239d81e000032",
      userId: "63701cc1f03239bef000011b",
      cost: 2976.32,
      products: [
        "63701d24f03239d40b00004b",
        "63701d24f03239cdc5000015",
        "63701d24f03239d40b000055",
        "63701d24f03239c72c00018f",
        "63701d24f032395694000016",
      ],
    },
    {
      _id: "63701d74f03239d81e000033",
      userId: "63701cc1f03239cdc5000013",
      cost: 2149.4,
      products: [
        "63701d24f03239f09e000191",
        "63701d24f032390a34000327",
        "63701d24f03239d40b000053",
      ],
    },
    {
      _id: "63701d74f03239d81e000034",
      userId: "63701cc1f032390a34000326",
      cost: 742.71,
      products: ["63701d24f032395694000015"],
    },
    {
      _id: "63701d74f03239d81e000035",
      userId: "63701cc1f032394c4900011c",
      cost: 2371.02,
      products: [
        "63701d24f032390a34000328",
        "63701d24f03239cdc5000018",
        "63701d24f03239d40b00004a",
        "63701d24f03239b913000018",
      ],
    },
    {
      _id: "63701d74f03239d81e000036",
      userId: "63701cc1f03239d40b000046",
      cost: 494.3,
      products: ["63701d24f03239867500012d", "63701d24f0323944410002ed"],
    },
    {
      _id: "63701d74f03239d81e000037",
      userId: "63701cc1f0323986f3000120",
      cost: 1794.9,
      products: [
        "63701d24f03239d81e000017",
        "63701d24f03239b913000015",
        "63701d24f03239d40b000052",
        "63701d24f032394c4900012c",
      ],
    },
    {
      _id: "63701d74f03239d81e000038",
      userId: "63701cc1f03239d591000322",
      cost: 2760.45,
      products: [
        "63701d24f032396b8e000017",
        "63701d24f03239f09e00018e",
        "63701d24f03239b7f7000018",
        "63701d24f0323944410002ee",
      ],
    },
    {
      _id: "63701d74f03239d81e000039",
      userId: "63701cc1f03239c72c000181",
      cost: 1961.93,
      products: ["63701d24f03239d81e000018"],
    },
    {
      _id: "63701d74f03239d81e00003a",
      userId: "63701cc1f03239d59100031b",
      cost: 1201.56,
      products: [
        "63701d24f03239b913000017",
        "63701d24f03239db6900012a",
        "63701d24f03239b7f7000015",
        "63701d25f03239d591000328",
      ],
    },
    {
      _id: "63701d74f03239d81e00003b",
      userId: "63701cc1f03239d591000323",
      cost: 1550.04,
      products: [
        "63701d24f03239d40b000047",
        "63701d24f03239c72c000190",
        "63701d24f032396b8e000015",
        "63701d24f03239528f000016",
      ],
    },
    {
      _id: "63701d74f03239d81e00003c",
      userId: "63701cc1f03239cdc5000014",
      cost: 2215.73,
      products: [
        "63701d24f03239d40b000049",
        "63701d24f032396b8e000018",
        "63701d24f03239d81e000016",
        "63701d24f032390a3400032a",
        "63701d24f03239cdc5000017",
      ],
    },
    {
      _id: "63701d74f03239d81e00003d",
      userId: "63701cc1f032399c0000011b",
      cost: 3155.56,
      products: ["63701d24f03239528f000017", "63701d24f0323986f300012c"],
    },
    {
      _id: "63701d74f03239d81e00003e",
      userId: "63701cc1f03239569400000c",
      cost: 3956.27,
      products: ["63701d24f03239d81e000015", "63701d24f03239c72c00018e"],
    },
    {
      _id: "63701d74f03239d81e00003f",
      userId: "63701cc1f03239f09e000181",
      cost: 1177.57,
      products: [
        "63701d24f03239bef000012a",
        "63701d24f0323944410002ef",
        "63701d24f03239d40b00004d",
        "63701d24f032399c0000012b",
      ],
    },
    {
      _id: "63701d74f03239d81e000040",
      userId: "63701cc1f03239c72c000182",
      cost: 3532.94,
      products: [
        "63701d24f03239f09e000190",
        "63701d24f032395694000017",
        "63701d24f032399c0000012c",
      ],
    },
    {
      _id: "63701d74f03239d81e000041",
      userId: "63701cc1f03239f09e000189",
      cost: 2818.98,
      products: [
        "63701d24f032399c0000012a",
        "63701d25f03239d591000329",
        "63701d24f032396b8e000016",
        "63701d24f0323986f300012a",
        "63701d24f032395b3300012c",
      ],
    },
    {
      _id: "63701d74f03239d81e000042",
      userId: "63701cc1f03239d81e00000c",
      cost: 1308.84,
      products: [
        "63701d24f03239d40b00004f",
        "63701d24f03239f09e000190",
        "63701d24f03239d40b00004b",
      ],
    },
    {
      _id: "63701d74f03239d81e000043",
      userId: "63701cc1f03239bef000011e",
      cost: 944.22,
      products: ["63701d24f03239d40b000049", "63701d24f032395694000016"],
    },
    {
      _id: "63701d74f03239d81e000044",
      userId: "63701cc1f032390a34000319",
      cost: 607.91,
      products: [
        "63701d24f03239d40b00004c",
        "63701d24f03239db6900012c",
        "63701d24f03239d40b000050",
        "63701d24f032390a34000328",
        "63701d24f0323986f300012d",
      ],
    },
    {
      _id: "63701d74f03239d81e000045",
      userId: "63701cc1f032394c49000124",
      cost: 493.94,
      products: [
        "63701d24f03239d40b000054",
        "63701d25f03239d591000329",
        "63701d24f032396b8e000015",
      ],
    },
    {
      _id: "63701d74f03239d81e000046",
      userId: "63701cc1f03239b7f700000a",
      cost: 2758.74,
      products: ["63701d24f03239f09e00018e"],
    },
    {
      _id: "63701d74f032390a3400032b",
      userId: "63701cc1f032399c0000011d",
      cost: 2727.46,
      products: ["63701d24f032394c4900012b"],
    },
    {
      _id: "63701d74f032390a3400032c",
      userId: "63701cc1f032396b8e000011",
      cost: 1298.33,
      products: [
        "63701d24f03239f09e00018f",
        "63701d24f03239d40b000048",
        "63701d24f03239867500012a",
      ],
    },
    {
      _id: "63701d74f032390a3400032d",
      userId: "63701cc1f032390a34000326",
      cost: 366.28,
      products: ["63701d24f03239f09e000191", "63701d24f032395694000018"],
    },
    {
      _id: "63701d74f032390a3400032e",
      userId: "63701cc1f03239d40b00003c",
      cost: 1003.36,
      products: [
        "63701d24f032394c4900012c",
        "63701d24f032396b8e000016",
        "63701d24f0323944410002ef",
        "63701d24f032399c0000012a",
      ],
    },
    {
      _id: "63701d74f032390a3400032f",
      userId: "63701cc1f03239db6900011c",
      cost: 412.99,
      products: [
        "63701d24f03239bef000012d",
        "63701d24f0323944410002ee",
        "63701d24f03239d40b000053",
      ],
    },
    {
      _id: "63701d74f032390a34000330",
      userId: "63701cc1f032398675000125",
      cost: 3800.1,
      products: [
        "63701d24f03239d40b000047",
        "63701d24f03239b7f7000017",
        "63701d24f03239c72c000190",
      ],
    },
    {
      _id: "63701d74f032390a34000331",
      userId: "63701cc1f03239bef0000128",
      cost: 491.56,
      products: [
        "63701d24f032390a34000327",
        "63701d24f03239867500012b",
        "63701d24f03239d81e000015",
      ],
    },
    {
      _id: "63701d74f032390a34000332",
      userId: "63701cc1f03239b91300000e",
      cost: 2596.99,
      products: ["63701d25f03239d591000327", "63701d24f032395b3300012b"],
    },
    {
      _id: "63701d74f032390a34000333",
      userId: "63701cc1f03239d40b000039",
      cost: 2502.79,
      products: ["63701d24f03239b7f7000018"],
    },
    {
      _id: "63701d74f032390a34000334",
      userId: "63701cc1f03239f09e000189",
      cost: 219.07,
      products: [
        "63701d24f032394c4900012d",
        "63701d24f03239d81e000018",
        "63701d24f03239db6900012d",
        "63701d24f032396b8e000017",
      ],
    },
    {
      _id: "63701d74f032390a34000335",
      userId: "63701cc1f03239b7f700000c",
      cost: 929.8,
      products: ["63701d24f03239528f000017", "63701d24f03239d81e000017"],
    },
    {
      _id: "63701d74f032390a34000336",
      userId: "63701cc1f03239d40b00003a",
      cost: 1933.72,
      products: [
        "63701d24f03239d81e000016",
        "63701d24f032399c0000012d",
        "63701d24f03239bef000012a",
        "63701d24f03239d40b000056",
        "63701d24f03239b913000016",
      ],
    },
    {
      _id: "63701d74f032390a34000337",
      userId: "63701cc1f032396b8e00000b",
      cost: 619.13,
      products: [
        "63701d24f03239b7f7000015",
        "63701d24f032399c0000012b",
        "63701d24f032395b3300012d",
        "63701d24f03239c72c00018e",
      ],
    },
    {
      _id: "63701d74f032390a34000338",
      userId: "63701cc1f03239f09e000188",
      cost: 1036.87,
      products: ["63701d24f03239db6900012b"],
    },
    {
      _id: "63701d74f032390a34000339",
      userId: "63701cc1f0323944410002de",
      cost: 2839.16,
      products: ["63701d24f03239d40b00004a", "63701d24f03239528f000018"],
    },
    {
      _id: "63701d74f032390a3400033a",
      userId: "63701cc1f032399c00000127",
      cost: 1732.47,
      products: ["63701d24f03239d40b00004e"],
    },
    {
      _id: "63701d74f032390a3400033b",
      userId: "63701cc1f03239f09e00017f",
      cost: 3183.64,
      products: [
        "63701d24f032396b8e000018",
        "63701d24f03239b7f7000016",
        "63701d24f032399c0000012c",
        "63701d24f032395b3300012a",
        "63701d24f03239cdc5000015",
      ],
    },
    {
      _id: "63701d74f032390a3400033c",
      userId: "63701cc1f03239cdc5000009",
      cost: 847.35,
      products: [
        "63701d24f0323986f300012b",
        "63701d24f0323986f300012a",
        "63701d24f032390a3400032a",
        "63701d24f03239867500012c",
        "63701d24f03239d40b000052",
      ],
    },
    {
      _id: "63701d74f032390a3400033d",
      userId: "63701cc1f03239bef000011c",
      cost: 2369.72,
      products: [
        "63701d24f03239b913000018",
        "63701d24f0323944410002ed",
        "63701d25f03239d59100032a",
        "63701d24f03239db6900012a",
      ],
    },
    {
      _id: "63701d74f032390a3400033e",
      userId: "63701cc1f032398675000127",
      cost: 526.81,
      products: [
        "63701d24f03239c72c00018f",
        "63701d24f03239528f000016",
        "63701d24f03239528f000015",
        "63701d24f03239cdc5000017",
      ],
    },
    {
      _id: "63701d74f032390a3400033f",
      userId: "63701cc1f03239b7f7000011",
      cost: 789.3,
      products: [
        "63701d24f032399c0000012b",
        "63701d24f03239d40b00004a",
        "63701d24f03239b7f7000017",
        "63701d24f0323944410002ef",
      ],
    },
    {
      _id: "63701d74f032390a34000340",
      userId: "63701cc1f032396b8e00000b",
      cost: 522.18,
      products: ["63701d24f03239867500012d", "63701d24f03239867500012b"],
    },
    {
      _id: "63701d74f032390a34000341",
      userId: "63701cc1f03239b913000009",
      cost: 2198.03,
      products: [
        "63701d24f0323944410002ec",
        "63701d25f03239d591000328",
        "63701d24f03239d40b000055",
      ],
    },
    {
      _id: "63701d74f032390a34000342",
      userId: "63701cc1f032390a34000320",
      cost: 2863.68,
      products: [
        "63701d24f03239db6900012c",
        "63701d24f03239528f000018",
        "63701d24f03239d81e000016",
        "63701d24f032395b3300012b",
      ],
    },
    {
      _id: "63701d74f032390a34000343",
      userId: "63701cc1f03239b91300000f",
      cost: 451.44,
      products: ["63701d24f03239d81e000017", "63701d24f032395694000016"],
    },
    {
      _id: "63701d74f032390a34000344",
      userId: "63701cc1f03239d81e00000f",
      cost: 3278.33,
      products: [
        "63701d24f03239d81e000018",
        "63701d24f03239d40b000047",
        "63701d24f03239867500012c",
        "63701d24f032394c4900012a",
      ],
    },
    {
      _id: "63701d74f032390a34000345",
      userId: "63701cc1f03239f09e000185",
      cost: 3301.41,
      products: [
        "63701d24f03239528f000015",
        "63701d24f032390a34000328",
        "63701d24f03239b7f7000015",
        "63701d24f03239d40b000049",
      ],
    },
    {
      _id: "63701d74f032390a34000346",
      userId: "63701cc1f032396b8e000010",
      cost: 3120.14,
      products: ["63701d24f03239bef000012b", "63701d24f032395694000018"],
    },
    {
      _id: "63701d74f032390a34000347",
      userId: "63701cc1f03239d591000321",
      cost: 3018.79,
      products: [
        "63701d24f03239c72c000190",
        "63701d24f03239528f000016",
        "63701d25f03239d591000327",
        "63701d24f03239bef000012a",
      ],
    },
    {
      _id: "63701d74f032390a34000348",
      userId: "63701cc1f032395694000013",
      cost: 3694.83,
      products: [
        "63701d24f03239c72c00018f",
        "63701d24f032399c0000012a",
        "63701d24f03239d40b000048",
        "63701d24f03239528f000017",
        "63701d24f03239cdc5000016",
      ],
    },
    {
      _id: "63701d74f032390a34000349",
      userId: "63701cc1f032395b33000120",
      cost: 2077.81,
      products: [
        "63701d24f03239b913000018",
        "63701d24f03239db6900012d",
        "63701d24f032395694000015",
        "63701d24f032395694000017",
        "63701d25f03239d591000329",
      ],
    },
    {
      _id: "63701d74f032390a3400034a",
      userId: "63701cc1f032395b33000126",
      cost: 879.42,
      products: [
        "63701d24f032395b3300012a",
        "63701d24f03239bef000012d",
        "63701d24f032399c0000012d",
        "63701d24f0323986f300012d",
      ],
    },
    {
      _id: "63701d74f032390a3400034b",
      userId: "63701cc1f03239d40b000039",
      cost: 364.65,
      products: ["63701d24f03239cdc5000017", "63701d24f032396b8e000017"],
    },
    {
      _id: "63701d74f032390a3400034c",
      userId: "63701cc1f03239cdc5000010",
      cost: 661.95,
      products: ["63701d24f032394c4900012b", "63701d24f03239d40b000056"],
    },
    {
      _id: "63701d74f032390a3400034d",
      userId: "63701cc1f03239bef000011f",
      cost: 270.33,
      products: ["63701d24f0323986f300012b", "63701d24f03239d40b000052"],
    },
    {
      _id: "63701d74f032390a3400034e",
      userId: "63701cc1f03239d81e000010",
      cost: 1059.47,
      products: [
        "63701d24f032395b3300012d",
        "63701d24f032396b8e000016",
        "63701d24f0323944410002ee",
        "63701d24f03239d40b000051",
      ],
    },
    {
      _id: "63701d74f032390a3400034f",
      userId: "63701cc1f03239d40b000046",
      cost: 424.78,
      products: [
        "63701d24f03239d40b00004d",
        "63701d24f03239d40b000053",
        "63701d24f03239b913000016",
      ],
    },
    {
      _id: "63701d74f032390a34000350",
      userId: "63701cc1f032396b8e00000d",
      cost: 3340.88,
      products: [
        "63701d24f03239cdc5000015",
        "63701d24f03239d40b00004c",
        "63701d24f032390a34000327",
        "63701d24f03239db6900012a",
        "63701d24f03239f09e00018f",
      ],
    },
    {
      _id: "63701d74f032390a34000351",
      userId: "63701cc1f032395694000008",
      cost: 1271.59,
      products: [
        "63701d24f0323944410002ed",
        "63701d25f03239d59100032a",
        "63701d24f032396b8e000015",
        "63701d24f032390a34000329",
      ],
    },
    {
      _id: "63701d74f032390a34000352",
      userId: "63701cc1f03239528f00000e",
      cost: 1011.56,
      products: [
        "63701d24f03239d81e000015",
        "63701d24f03239d40b00004b",
        "63701d24f03239d40b000050",
        "63701d24f0323986f300012c",
        "63701d24f032394c4900012d",
      ],
    },
    {
      _id: "63701d74f032390a34000353",
      userId: "63701cc1f0323944410002e9",
      cost: 2356.11,
      products: ["63701d24f032390a3400032a"],
    },
    {
      _id: "63701d74f032390a34000354",
      userId: "63701cc1f03239b7f7000006",
      cost: 2921.72,
      products: [
        "63701d24f03239cdc5000018",
        "63701d24f032399c0000012c",
        "63701d24f03239db6900012b",
        "63701d24f03239d40b000054",
        "63701d24f03239b913000015",
      ],
    },
    {
      _id: "63701d74f032390a34000355",
      userId: "63701cc1f03239528f000011",
      cost: 915.05,
      products: [
        "63701d24f03239b7f7000018",
        "63701d24f03239f09e00018e",
        "63701d24f03239d40b00004e",
      ],
    },
    {
      _id: "63701d74f032390a34000356",
      userId: "63701cc1f0323944410002ea",
      cost: 3176.67,
      products: [
        "63701d24f03239c72c00018e",
        "63701d24f03239867500012a",
        "63701d24f032396b8e000018",
        "63701d24f0323986f300012a",
      ],
    },
    {
      _id: "63701d74f032390a34000357",
      userId: "63701cc1f03239cdc500000b",
      cost: 1513.85,
      products: [
        "63701d24f03239b7f7000016",
        "63701d24f032395b3300012c",
        "63701d24f03239c72c000191",
        "63701d24f03239bef000012c",
        "63701d24f03239f09e000190",
      ],
    },
    {
      _id: "63701d74f032390a34000358",
      userId: "63701cc1f032390a3400031c",
      cost: 1689.74,
      products: [
        "63701d24f0323986f300012d",
        "63701d24f032395b3300012b",
        "63701d24f032396b8e000015",
        "63701d24f03239d40b000052",
      ],
    },
    {
      _id: "63701d74f032395b3300012e",
      userId: "63701cc1f0323944410002e4",
      cost: 838.14,
      products: [
        "63701d24f032395694000015",
        "63701d24f032395b3300012a",
        "63701d24f03239d40b00004e",
        "63701d24f03239b7f7000015",
      ],
    },
    {
      _id: "63701d74f032395b3300012f",
      userId: "63701cc1f032394c49000129",
      cost: 3253.24,
      products: [
        "63701d24f03239d40b000053",
        "63701d24f03239f09e00018f",
        "63701d24f03239d40b00004c",
      ],
    },
    {
      _id: "63701d74f032395b33000130",
      userId: "63701cc1f0323944410002e7",
      cost: 3550.63,
      products: [
        "63701d24f03239cdc5000015",
        "63701d24f03239d81e000016",
        "63701d24f032394c4900012b",
        "63701d24f03239d40b000051",
      ],
    },
    {
      _id: "63701d74f032395b33000131",
      userId: "63701cc1f03239d591000319",
      cost: 107.48,
      products: [
        "63701d24f03239c72c00018f",
        "63701d24f0323986f300012b",
        "63701d25f03239d591000328",
      ],
    },
    {
      _id: "63701d74f032395b33000132",
      userId: "63701cc1f03239d591000318",
      cost: 3072.8,
      products: [
        "63701d24f03239b913000017",
        "63701d24f03239bef000012d",
        "63701d24f032395b3300012c",
        "63701d24f032394c4900012c",
        "63701d24f032399c0000012d",
      ],
    },
    {
      _id: "63701d74f032395b33000133",
      userId: "63701cc1f032390a34000324",
      cost: 2916.45,
      products: [
        "63701d24f03239d40b00004f",
        "63701d24f032395b3300012d",
        "63701d24f03239d40b000050",
      ],
    },
    {
      _id: "63701d74f032395b33000134",
      userId: "63701cc1f0323986f3000121",
      cost: 3647.7,
      products: [
        "63701d24f03239db6900012c",
        "63701d25f03239d59100032a",
        "63701d24f032394c4900012d",
      ],
    },
    {
      _id: "63701d74f032395b33000135",
      userId: "63701cc1f03239bef0000124",
      cost: 3782.1,
      products: [
        "63701d24f03239bef000012c",
        "63701d24f03239d40b000054",
        "63701d24f032399c0000012c",
        "63701d24f03239d40b00004d",
      ],
    },
    {
      _id: "63701d74f032395b33000136",
      userId: "63701cc1f03239bef000011f",
      cost: 235.02,
      products: ["63701d24f03239d40b00004a", "63701d24f03239bef000012b"],
    },
    {
      _id: "63701d74f032395b33000137",
      userId: "63701cc1f032398675000127",
      cost: 2687.49,
      products: [
        "63701d24f0323986f300012a",
        "63701d24f03239528f000016",
        "63701d24f03239c72c00018e",
        "63701d24f032390a34000329",
      ],
    },
    {
      _id: "63701d74f032395b33000138",
      userId: "63701cc1f03239528f000006",
      cost: 1427.24,
      products: [
        "63701d24f03239d81e000018",
        "63701d24f032395694000018",
        "63701d24f0323944410002ec",
        "63701d24f03239d40b000048",
        "63701d24f0323986f300012c",
      ],
    },
    {
      _id: "63701d74f032395b33000139",
      userId: "63701cc1f03239c72c00018b",
      cost: 2828.47,
      products: ["63701d24f03239867500012c", "63701d24f03239cdc5000017"],
    },
    {
      _id: "63701d74f032395b3300013a",
      userId: "63701cc1f03239cdc5000009",
      cost: 1252.87,
      products: [
        "63701d24f0323944410002ef",
        "63701d24f03239cdc5000016",
        "63701d24f032395694000016",
        "63701d24f03239867500012d",
        "63701d24f032390a34000328",
      ],
    },
    {
      _id: "63701d74f032395b3300013b",
      userId: "63701cc1f03239db69000126",
      cost: 3285.66,
      products: [
        "63701d24f032396b8e000018",
        "63701d24f03239db6900012b",
        "63701d25f03239d591000329",
        "63701d24f03239867500012a",
        "63701d24f03239d40b000049",
      ],
    },
    {
      _id: "63701d74f032395b3300013c",
      userId: "63701cc1f03239db6900011d",
      cost: 543.75,
      products: [
        "63701d24f03239b913000018",
        "63701d24f032396b8e000017",
        "63701d24f03239f09e000190",
        "63701d24f03239b7f7000017",
        "63701d24f032399c0000012a",
      ],
    },
    {
      _id: "63701d74f032395b3300013d",
      userId: "63701cc1f03239d81e00000a",
      cost: 2169.95,
      products: [
        "63701d24f03239528f000017",
        "63701d24f032396b8e000016",
        "63701d24f03239f09e00018e",
        "63701d24f03239d40b000047",
      ],
    },
    {
      _id: "63701d74f032395b3300013e",
      userId: "63701cc1f03239528f00000b",
      cost: 751.81,
      products: ["63701d24f03239c72c000190"],
    },
    {
      _id: "63701d74f032395b3300013f",
      userId: "63701cc1f032395b33000129",
      cost: 774.09,
      products: ["63701d24f0323944410002ed"],
    },
    {
      _id: "63701d74f032395b33000140",
      userId: "63701cc1f03239db69000122",
      cost: 783.69,
      products: ["63701d24f032399c0000012b"],
    },
    {
      _id: "63701d74f032395b33000141",
      userId: "63701cc1f032399c00000129",
      cost: 3808.22,
      products: [
        "63701d24f03239d81e000017",
        "63701d24f03239f09e000191",
        "63701d24f03239bef000012a",
        "63701d24f03239db6900012a",
        "63701d24f0323944410002ee",
      ],
    },
    {
      _id: "63701d74f032395b33000142",
      userId: "63701cc1f032396b8e000009",
      cost: 2868.43,
      products: ["63701d24f03239d40b000056"],
    },
    {
      _id: "63701d74f032395b33000143",
      userId: "63701cc1f03239d81e00000e",
      cost: 583.34,
      products: [
        "63701d24f032395694000017",
        "63701d24f03239cdc5000018",
        "63701d24f03239867500012b",
      ],
    },
    {
      _id: "63701d74f032395b33000144",
      userId: "63701cc1f03239bef000011d",
      cost: 2701.65,
      products: [
        "63701d24f03239528f000018",
        "63701d24f03239b913000016",
        "63701d24f032390a34000327",
        "63701d24f03239c72c000191",
      ],
    },
    {
      _id: "63701d74f032395b33000145",
      userId: "63701cc1f032396b8e000011",
      cost: 2951.06,
      products: [
        "63701d24f032390a3400032a",
        "63701d24f03239b7f7000016",
        "63701d24f03239528f000015",
        "63701d24f03239d81e000015",
        "63701d24f03239db6900012d",
      ],
    },
    {
      _id: "63701d74f032395b33000146",
      userId: "63701cc1f03239c72c000181",
      cost: 830.15,
      products: ["63701d24f03239d81e000015"],
    },
    {
      _id: "63701d74f032395b33000147",
      userId: "63701cc1f03239db69000126",
      cost: 3313.44,
      products: [
        "63701d24f03239b7f7000018",
        "63701d24f032395b3300012d",
        "63701d24f03239d81e000017",
      ],
    },
    {
      _id: "63701d74f032395b33000148",
      userId: "63701cc1f03239d81e000007",
      cost: 1205.8,
      products: ["63701d24f0323986f300012c", "63701d24f03239db6900012a"],
    },
    {
      _id: "63701d74f032395b33000149",
      userId: "63701cc1f032395b3300011d",
      cost: 2824.68,
      products: [
        "63701d24f03239b913000017",
        "63701d24f032399c0000012b",
        "63701d24f03239d40b000056",
        "63701d24f03239d40b00004a",
        "63701d24f03239b7f7000017",
      ],
    },
    {
      _id: "63701d74f032395b3300014a",
      userId: "63701cc1f03239cdc500000a",
      cost: 108.35,
      products: [
        "63701d24f032390a3400032a",
        "63701d24f03239d40b000051",
        "63701d24f03239cdc5000018",
        "63701d24f03239f09e00018e",
      ],
    },
    {
      _id: "63701d74f032395b3300014b",
      userId: "63701cc1f03239f09e000184",
      cost: 2417.55,
      products: [
        "63701d24f03239db6900012c",
        "63701d24f03239db6900012d",
        "63701d24f03239c72c000191",
        "63701d24f0323944410002ec",
      ],
    },
    {
      _id: "63701d74f032395b3300014c",
      userId: "63701cc1f03239cdc500000e",
      cost: 2570.97,
      products: [
        "63701d24f03239bef000012d",
        "63701d24f032390a34000329",
        "63701d24f032399c0000012c",
        "63701d24f032394c4900012d",
        "63701d24f032396b8e000017",
      ],
    },
    {
      _id: "63701d74f032395b3300014d",
      userId: "63701cc1f03239b91300000b",
      cost: 810.78,
      products: ["63701d24f03239c72c00018f"],
    },
    {
      _id: "63701d74f032395b3300014e",
      userId: "63701cc1f0323986f3000122",
      cost: 3025.73,
      products: ["63701d24f032390a34000328", "63701d24f03239d40b00004e"],
    },
    {
      _id: "63701d74f032395b3300014f",
      userId: "63701cc1f03239d40b00003d",
      cost: 1846.55,
      products: ["63701d24f03239f09e000190"],
    },
    {
      _id: "63701d74f032395b33000150",
      userId: "63701cc1f03239cdc5000012",
      cost: 2832.48,
      products: [
        "63701d24f0323986f300012d",
        "63701d24f0323986f300012a",
        "63701d24f03239c72c000190",
      ],
    },
    {
      _id: "63701d74f032395b33000151",
      userId: "63701cc1f032395b3300011f",
      cost: 2903.88,
      products: [
        "63701d24f03239d40b000049",
        "63701d24f03239cdc5000016",
        "63701d24f03239d40b000048",
        "63701d24f032396b8e000018",
        "63701d24f03239528f000017",
      ],
    },
    {
      _id: "63701d74f032395b33000152",
      userId: "63701cc1f0323986f300011f",
      cost: 2254.13,
      products: ["63701d24f032395694000015"],
    },
    {
      _id: "63701d74f032395b33000153",
      userId: "63701cc1f03239d40b000044",
      cost: 2493.86,
      products: [
        "63701d24f0323944410002ed",
        "63701d24f03239bef000012c",
        "63701d24f0323986f300012b",
      ],
    },
    {
      _id: "63701d74f032395b33000154",
      userId: "63701cc1f03239d81e00000e",
      cost: 3231.81,
      products: ["63701d24f03239cdc5000015"],
    },
    {
      _id: "63701d74f032395b33000155",
      userId: "63701cc1f03239db69000129",
      cost: 3487.3,
      products: [
        "63701d24f03239d81e000016",
        "63701d24f03239cdc5000017",
        "63701d24f032395694000016",
      ],
    },
    {
      _id: "63701d74f032395b33000156",
      userId: "63701cc1f03239d591000324",
      cost: 2745.09,
      products: ["63701d24f03239bef000012b"],
    },
    {
      _id: "63701d74f032395b33000157",
      userId: "63701cc1f03239f09e000180",
      cost: 3031.51,
      products: ["63701d25f03239d59100032a", "63701d24f03239528f000015"],
    },
    {
      _id: "63701d74f032395b33000158",
      userId: "63701cc1f03239c72c00018a",
      cost: 1693.53,
      products: [
        "63701d24f03239b7f7000015",
        "63701d24f032399c0000012a",
        "63701d24f032396b8e000015",
      ],
    },
    {
      _id: "63701d74f032395b33000159",
      userId: "63701cc1f0323986f3000128",
      cost: 1446.87,
      products: [
        "63701d24f03239867500012d",
        "63701d25f03239d591000328",
        "63701d24f03239d40b00004f",
        "63701d24f032394c4900012c",
      ],
    },
    {
      _id: "63701d74f032395b3300015a",
      userId: "63701cc1f032395694000007",
      cost: 2192.21,
      products: [
        "63701d24f032394c4900012b",
        "63701d24f03239867500012a",
        "63701d24f03239867500012c",
      ],
    },
    {
      _id: "63701d74f032395b3300015b",
      userId: "63701cc1f032395694000008",
      cost: 899.75,
      products: [
        "63701d24f03239f09e00018f",
        "63701d24f03239b7f7000016",
        "63701d24f03239d81e000018",
        "63701d25f03239d591000329",
      ],
    },
    {
      _id: "63701d74f03239d59100032b",
      userId: "63701cc1f03239cdc500000d",
      cost: 1225.16,
      products: ["63701d24f03239d40b00004c"],
    },
    {
      _id: "63701d74f03239d59100032c",
      userId: "63701cc1f03239569400000a",
      cost: 502.51,
      products: ["63701d24f03239867500012b"],
    },
    {
      _id: "63701d74f03239d59100032d",
      userId: "63701cc1f032399c00000129",
      cost: 1740.06,
      products: [
        "63701d24f03239d40b000052",
        "63701d24f03239d40b000047",
        "63701d24f03239d40b000054",
        "63701d24f032390a34000327",
      ],
    },
    {
      _id: "63701d74f03239d59100032e",
      userId: "63701cc1f03239b7f700000a",
      cost: 1894.09,
      products: [
        "63701d24f032396b8e000015",
        "63701d24f032394c4900012a",
        "63701d24f032395694000015",
        "63701d24f03239d40b000048",
      ],
    },
    {
      _id: "63701d74f03239d59100032f",
      userId: "63701cc1f032394c49000125",
      cost: 1604.44,
      products: ["63701d24f032396b8e000016", "63701d24f03239d40b000051"],
    },
    {
      _id: "63701d74f03239d591000330",
      userId: "63701cc1f03239867500011b",
      cost: 273.52,
      products: ["63701d24f03239bef000012c"],
    },
    {
      _id: "63701d74f03239d591000331",
      userId: "63701cc1f03239db69000123",
      cost: 1141.49,
      products: [
        "63701d24f0323986f300012c",
        "63701d24f032399c0000012c",
        "63701d24f03239d81e000018",
        "63701d24f03239b7f7000015",
        "63701d24f03239d81e000015",
      ],
    },
    {
      _id: "63701d74f03239d591000332",
      userId: "63701cc1f032396b8e00000a",
      cost: 3994.9,
      products: ["63701d24f03239d40b00004d", "63701d24f03239d40b000056"],
    },
    {
      _id: "63701d74f03239d591000333",
      userId: "63701cc1f03239b7f7000007",
      cost: 878.2,
      products: ["63701d24f032395b3300012d"],
    },
    {
      _id: "63701d74f03239d591000334",
      userId: "63701cc1f03239867500011c",
      cost: 1358.84,
      products: ["63701d24f03239b913000018", "63701d24f032395b3300012a"],
    },
    {
      _id: "63701d74f03239d591000335",
      userId: "63701cc1f0323944410002ea",
      cost: 1372.83,
      products: ["63701d24f03239867500012b"],
    },
    {
      _id: "63701d74f03239d591000336",
      userId: "63701cc1f032396b8e00000e",
      cost: 559.15,
      products: [
        "63701d24f032396b8e000018",
        "63701d24f03239d40b00004c",
        "63701d24f03239867500012a",
      ],
    },
    {
      _id: "63701d74f03239d591000337",
      userId: "63701cc1f03239c72c000187",
      cost: 2297.98,
      products: [
        "63701d24f0323986f300012b",
        "63701d24f032390a34000328",
        "63701d24f03239867500012d",
      ],
    },
    {
      _id: "63701d74f03239d591000338",
      userId: "63701cc1f03239528f00000b",
      cost: 1142.63,
      products: ["63701d24f03239f09e000190"],
    },
    {
      _id: "63701d74f03239d591000339",
      userId: "63701cc1f03239bef000011b",
      cost: 1303.19,
      products: ["63701d24f03239b913000015", "63701d24f03239d40b000052"],
    },
    {
      _id: "63701d74f03239d59100033a",
      userId: "63701cc1f032395b33000129",
      cost: 3228.67,
      products: [
        "63701d24f032395b3300012c",
        "63701d24f032395694000016",
        "63701d24f03239bef000012d",
      ],
    },
    {
      _id: "63701d74f03239d59100033b",
      userId: "63701cc1f03239c72c000183",
      cost: 3502.96,
      products: ["63701d24f03239d40b00004e", "63701d24f0323986f300012d"],
    },
    {
      _id: "63701d74f03239d59100033c",
      userId: "63701cc1f03239d59100031d",
      cost: 2033.74,
      products: [
        "63701d24f03239f09e00018f",
        "63701d24f0323944410002ec",
        "63701d24f03239bef000012a",
        "63701d25f03239d59100032a",
        "63701d24f03239d40b000054",
      ],
    },
    {
      _id: "63701d74f03239d59100033d",
      userId: "63701cc1f03239b913000011",
      cost: 2510.55,
      products: ["63701d24f03239528f000017"],
    },
    {
      _id: "63701d74f03239d59100033e",
      userId: "63701cc1f03239528f00000e",
      cost: 124.21,
      products: [
        "63701d24f032394c4900012b",
        "63701d24f032399c0000012b",
        "63701d24f03239cdc5000018",
        "63701d24f03239d40b000053",
        "63701d24f03239867500012c",
      ],
    },
    {
      _id: "63701d74f03239d59100033f",
      userId: "63701cc1f032399c00000124",
      cost: 3844.04,
      products: [
        "63701d24f032395b3300012b",
        "63701d24f03239b7f7000017",
        "63701d24f032395694000018",
        "63701d24f03239db6900012c",
        "63701d24f03239d40b000055",
      ],
    },
    {
      _id: "63701d74f03239d591000340",
      userId: "63701cc1f03239d40b000042",
      cost: 1073.24,
      products: [
        "63701d24f03239cdc5000015",
        "63701d24f0323944410002ee",
        "63701d24f03239db6900012b",
        "63701d24f03239c72c00018e",
        "63701d24f03239b913000017",
      ],
    },
    {
      _id: "63701d74f03239d591000341",
      userId: "63701cc1f0323944410002e8",
      cost: 2570.3,
      products: ["63701d24f032399c0000012d"],
    },
    {
      _id: "63701d74f03239d591000342",
      userId: "63701cc1f03239d40b00003b",
      cost: 2894.43,
      products: ["63701d24f03239f09e00018e", "63701d24f03239d40b000050"],
    },
    {
      _id: "63701d74f03239d591000343",
      userId: "63701cc1f03239b91300000b",
      cost: 1231.1,
      products: [
        "63701d24f03239d40b00004a",
        "63701d24f0323944410002ef",
        "63701d24f03239f09e000191",
        "63701d24f03239bef000012b",
        "63701d24f03239d81e000017",
      ],
    },
    {
      _id: "63701d74f03239d591000344",
      userId: "63701cc1f0323986f3000122",
      cost: 252.61,
      products: ["63701d24f03239d40b00004b", "63701d24f03239cdc5000016"],
    },
    {
      _id: "63701d74f03239d591000345",
      userId: "63701cc1f032394c49000127",
      cost: 752.29,
      products: [
        "63701d24f03239d81e000016",
        "63701d24f032390a3400032a",
        "63701d24f03239b7f7000016",
        "63701d24f03239c72c000190",
      ],
    },
    {
      _id: "63701d74f03239d591000346",
      userId: "63701cc1f032390a34000325",
      cost: 1699.17,
      products: [
        "63701d24f03239db6900012a",
        "63701d24f03239c72c00018f",
        "63701d24f03239b7f7000018",
        "63701d25f03239d591000329",
      ],
    },
    {
      _id: "63701d74f03239d591000347",
      userId: "63701cc1f032395694000013",
      cost: 3423.15,
      products: [
        "63701d24f03239bef000012b",
        "63701d24f03239528f000018",
        "63701d24f03239d40b000056",
      ],
    },
    {
      _id: "63701d74f03239d591000348",
      userId: "63701cc1f032399c00000122",
      cost: 2499.55,
      products: [
        "63701d24f032396b8e000018",
        "63701d24f032395b3300012b",
        "63701d24f03239d40b000048",
      ],
    },
    {
      _id: "63701d74f03239d591000349",
      userId: "63701cc1f03239c72c000180",
      cost: 226.39,
      products: [
        "63701d24f03239d40b000053",
        "63701d24f032395694000015",
        "63701d24f03239c72c000190",
        "63701d24f032396b8e000016",
      ],
    },
    {
      _id: "63701d74f03239d59100034a",
      userId: "63701cc1f03239f09e000181",
      cost: 1149.82,
      products: ["63701d24f0323986f300012b"],
    },
    {
      _id: "63701d74f03239d59100034b",
      userId: "63701cc1f032399c00000126",
      cost: 1802.53,
      products: ["63701d24f032390a34000328", "63701d24f032396b8e000017"],
    },
    {
      _id: "63701d74f03239d59100034c",
      userId: "63701cc1f0323986f300011c",
      cost: 2128.92,
      products: ["63701d24f03239d40b000050"],
    },
    {
      _id: "63701d74f03239d59100034d",
      userId: "63701cc1f0323986f300011d",
      cost: 3647.52,
      products: [
        "63701d24f03239b913000015",
        "63701d24f03239528f000017",
        "63701d24f03239d81e000017",
        "63701d24f03239f09e00018f",
      ],
    },
    {
      _id: "63701d74f03239d59100034e",
      userId: "63701cc1f03239f09e00018d",
      cost: 2001.58,
      products: [
        "63701d24f03239b913000017",
        "63701d24f03239d40b000051",
        "63701d24f03239cdc5000017",
        "63701d24f032395694000016",
        "63701d24f032394c4900012c",
      ],
    },
    {
      _id: "63701d74f03239d59100034f",
      userId: "63701cc1f032398675000125",
      cost: 99.52,
      products: [
        "63701d24f03239db6900012c",
        "63701d24f0323944410002ef",
        "63701d25f03239d591000327",
        "63701d24f03239528f000015",
        "63701d24f032395694000018",
      ],
    },
    {
      _id: "63701d74f03239d591000350",
      userId: "63701cc1f03239b91300000f",
      cost: 1428.08,
      products: [
        "63701d24f03239d40b00004b",
        "63701d24f03239b7f7000016",
        "63701d24f03239cdc5000016",
        "63701d24f0323944410002ed",
        "63701d24f03239d40b000047",
      ],
    },
    {
      _id: "63701d74f03239d591000351",
      userId: "63701cc1f032398675000123",
      cost: 2584.93,
      products: [
        "63701d24f03239b913000018",
        "63701d24f03239d81e000015",
        "63701d24f0323986f300012d",
        "63701d24f03239b7f7000017",
        "63701d24f03239d40b000049",
      ],
    },
    {
      _id: "63701d74f03239d591000352",
      userId: "63701cc1f032395b33000128",
      cost: 3011.03,
      products: [
        "63701d24f03239c72c00018f",
        "63701d24f032390a34000327",
        "63701d24f03239d40b00004a",
        "63701d24f03239d40b00004e",
      ],
    },
    {
      _id: "63701d74f03239d591000353",
      userId: "63701cc1f032390a3400031a",
      cost: 3648.94,
      products: ["63701d24f03239db6900012a", "63701d24f03239cdc5000015"],
    },
    {
      _id: "63701d74f03239d591000354",
      userId: "63701cc1f03239c72c000181",
      cost: 2447.29,
      products: [
        "63701d24f03239528f000016",
        "63701d24f03239c72c000191",
        "63701d24f03239867500012c",
      ],
    },
    {
      _id: "63701d74f03239d591000355",
      userId: "63701cc1f03239d81e000008",
      cost: 3542.2,
      products: ["63701d24f03239b7f7000015", "63701d24f03239d81e000016"],
    },
    {
      _id: "63701d74f03239d591000356",
      userId: "63701cc1f03239b7f7000010",
      cost: 2636.43,
      products: ["63701d24f032396b8e000015", "63701d25f03239d59100032a"],
    },
    {
      _id: "63701d74f03239d591000357",
      userId: "63701cc1f03239b7f7000013",
      cost: 22.7,
      products: ["63701d24f03239f09e000191"],
    },
    {
      _id: "63701d74f03239d591000358",
      userId: "63701cc1f032399c00000123",
      cost: 1254.83,
      products: ["63701d24f032395694000017"],
    },
    {
      _id: "63701d74f032395694000019",
      userId: "63701cc1f03239f09e000187",
      cost: 1006.17,
      products: ["63701d24f032395b3300012d"],
    },
    {
      _id: "63701d74f03239569400001a",
      userId: "63701cc1f032390a34000321",
      cost: 3788.51,
      products: ["63701d24f03239f09e00018e", "63701d25f03239d591000328"],
    },
    {
      _id: "63701d74f03239569400001b",
      userId: "63701cc1f03239d81e00000a",
      cost: 1191.14,
      products: [
        "63701d24f032395b3300012a",
        "63701d24f032394c4900012d",
        "63701d24f03239f09e000190",
      ],
    },
    {
      _id: "63701d74f03239569400001c",
      userId: "63701cc1f03239528f00000a",
      cost: 824.22,
      products: [
        "63701d24f03239db6900012b",
        "63701d24f032399c0000012b",
        "63701d24f03239d40b000054",
        "63701d24f0323944410002ec",
      ],
    },
    {
      _id: "63701d74f03239569400001d",
      userId: "63701cc1f03239d591000322",
      cost: 1918.67,
      products: [
        "63701d24f03239867500012b",
        "63701d24f0323986f300012c",
        "63701d24f03239d40b00004d",
        "63701d24f032399c0000012c",
        "63701d24f03239d81e000018",
      ],
    },
    {
      _id: "63701d74f03239569400001e",
      userId: "63701cc1f03239cdc5000008",
      cost: 1178.68,
      products: ["63701d24f032390a3400032a", "63701d24f032394c4900012b"],
    },
    {
      _id: "63701d74f03239569400001f",
      userId: "63701cc1f032399c0000011e",
      cost: 3525.19,
      products: [
        "63701d24f03239b913000016",
        "63701d24f03239d40b000052",
        "63701d24f03239b7f7000018",
        "63701d24f03239bef000012d",
      ],
    },
    {
      _id: "63701d74f032395694000020",
      userId: "63701cc1f032398675000122",
      cost: 2029.59,
      products: ["63701d24f03239528f000016", "63701d24f032399c0000012b"],
    },
    {
      _id: "63701d74f032395694000021",
      userId: "63701cc1f032396b8e000009",
      cost: 2611.36,
      products: [
        "63701d24f03239f09e00018f",
        "63701d24f03239d40b000048",
        "63701d24f03239db6900012d",
      ],
    },
    {
      _id: "63701d74f032395694000022",
      userId: "63701cc1f032396b8e000013",
      cost: 1342.61,
      products: [
        "63701d24f0323944410002ed",
        "63701d24f03239d81e000017",
        "63701d24f03239867500012d",
        "63701d24f03239b7f7000016",
      ],
    },
    {
      _id: "63701d74f032395694000023",
      userId: "63701cc1f03239cdc500000e",
      cost: 864.03,
      products: [
        "63701d24f03239d40b000053",
        "63701d24f032396b8e000015",
        "63701d24f03239d40b00004c",
        "63701d24f03239c72c00018e",
        "63701d24f03239528f000017",
      ],
    },
    {
      _id: "63701d74f032395694000024",
      userId: "63701cc1f03239b7f7000011",
      cost: 2269.3,
      products: [
        "63701d24f03239c72c00018f",
        "63701d24f03239bef000012d",
        "63701d24f032396b8e000016",
      ],
    },
    {
      _id: "63701d74f032395694000025",
      userId: "63701cc1f0323986f300011f",
      cost: 2879.31,
      products: [
        "63701d24f03239d40b000051",
        "63701d24f03239d40b000055",
        "63701d24f03239d40b00004d",
        "63701d24f03239bef000012b",
        "63701d24f0323986f300012c",
      ],
    },
    {
      _id: "63701d74f032395694000026",
      userId: "63701cc1f03239f09e000183",
      cost: 1952.66,
      products: [
        "63701d24f03239b913000015",
        "63701d24f03239d40b00004b",
        "63701d24f03239d40b000056",
        "63701d24f03239d81e000018",
        "63701d24f03239cdc5000016",
      ],
    },
    {
      _id: "63701d74f032395694000027",
      userId: "63701cc1f032396b8e00000c",
      cost: 3286.44,
      products: [
        "63701d24f03239f09e00018e",
        "63701d24f03239db6900012c",
        "63701d24f03239d40b00004e",
        "63701d24f03239b913000018",
        "63701d24f03239d40b000052",
      ],
    },
    {
      _id: "63701d74f032395694000028",
      userId: "63701cc1f03239528f000007",
      cost: 1210.4,
      products: [
        "63701d24f032395b3300012d",
        "63701d24f032395b3300012b",
        "63701d24f03239cdc5000017",
        "63701d24f032396b8e000018",
      ],
    },
    {
      _id: "63701d74f032395694000029",
      userId: "63701cc1f03239b913000011",
      cost: 456.8,
      products: ["63701d24f03239db6900012b", "63701d24f03239d81e000016"],
    },
    {
      _id: "63701d74f03239569400002a",
      userId: "63701cc1f0323986f300011b",
      cost: 2965.69,
      products: ["63701d24f03239cdc5000015", "63701d24f032395b3300012c"],
    },
    {
      _id: "63701d74f03239569400002b",
      userId: "63701cc1f032395b33000127",
      cost: 3961.87,
      products: [
        "63701d24f0323986f300012b",
        "63701d24f03239c72c000191",
        "63701d24f032399c0000012d",
        "63701d24f032395694000016",
      ],
    },
    {
      _id: "63701d74f03239569400002c",
      userId: "63701cc1f03239d40b000043",
      cost: 1587.09,
      products: ["63701d24f032394c4900012b"],
    },
    {
      _id: "63701d74f03239569400002d",
      userId: "63701cc1f03239db6900011b",
      cost: 229.26,
      products: ["63701d24f03239d40b000047"],
    },
    {
      _id: "63701d74f03239569400002e",
      userId: "63701cc1f03239867500011d",
      cost: 501.37,
      products: ["63701d24f03239b7f7000015"],
    },
    {
      _id: "63701d74f03239569400002f",
      userId: "63701cc1f03239d81e000012",
      cost: 3787.19,
      products: ["63701d24f03239d40b000050", "63701d24f032395694000015"],
    },
    {
      _id: "63701d74f032395694000030",
      userId: "63701cc1f032398675000120",
      cost: 2269.68,
      products: [
        "63701d24f03239db6900012a",
        "63701d24f03239867500012c",
        "63701d24f032390a34000328",
      ],
    },
    {
      _id: "63701d74f032395694000031",
      userId: "63701cc1f03239867500011e",
      cost: 2374.64,
      products: [
        "63701d24f03239d40b00004f",
        "63701d24f032396b8e000017",
        "63701d24f03239d40b000049",
      ],
    },
    {
      _id: "63701d74f032395694000032",
      userId: "63701cc1f03239d81e00000a",
      cost: 1999.86,
      products: ["63701d25f03239d59100032a", "63701d24f03239f09e000191"],
    },
    {
      _id: "63701d74f032395694000033",
      userId: "63701cc1f03239b7f7000007",
      cost: 1829.97,
      products: ["63701d24f03239b913000016", "63701d24f03239d40b00004a"],
    },
    {
      _id: "63701d74f032395694000034",
      userId: "63701cc1f032394c49000129",
      cost: 542.47,
      products: [
        "63701d25f03239d591000328",
        "63701d24f032399c0000012c",
        "63701d25f03239d591000329",
      ],
    },
    {
      _id: "63701d74f032395694000035",
      userId: "63701cc1f03239d40b000040",
      cost: 2028.57,
      products: ["63701d24f032390a3400032a", "63701d24f03239cdc5000018"],
    },
    {
      _id: "63701d74f032395694000036",
      userId: "63701cc1f03239d59100031b",
      cost: 1959.18,
      products: [
        "63701d24f03239528f000018",
        "63701d24f03239bef000012a",
        "63701d24f03239b913000017",
        "63701d24f032390a34000329",
      ],
    },
    {
      _id: "63701d74f032395694000037",
      userId: "63701cc1f03239b7f7000006",
      cost: 3990.02,
      products: ["63701d24f03239b7f7000018"],
    },
    {
      _id: "63701d74f032395694000038",
      userId: "63701cc1f03239d591000322",
      cost: 1878.32,
      products: ["63701d24f032394c4900012a", "63701d24f032390a34000327"],
    },
    {
      _id: "63701d74f032395694000039",
      userId: "63701cc1f03239db69000128",
      cost: 3976.65,
      products: [
        "63701d24f03239d81e000017",
        "63701d24f03239867500012c",
        "63701d24f03239c72c000190",
        "63701d24f032390a34000328",
        "63701d24f03239cdc5000017",
      ],
    },
    {
      _id: "63701d74f03239569400003a",
      userId: "63701cc1f03239f09e000182",
      cost: 933.48,
      products: [
        "63701d24f03239f09e00018e",
        "63701d24f03239d40b00004e",
        "63701d24f03239867500012a",
        "63701d24f03239c72c00018f",
      ],
    },
    {
      _id: "63701d74f03239569400003b",
      userId: "63701cc1f03239c72c000181",
      cost: 585.64,
      products: ["63701d24f032390a34000327"],
    },
    {
      _id: "63701d74f03239569400003c",
      userId: "63701cc1f03239c72c00018c",
      cost: 2818.55,
      products: [
        "63701d24f032394c4900012c",
        "63701d24f032399c0000012b",
        "63701d24f0323986f300012a",
        "63701d24f0323986f300012c",
        "63701d24f03239f09e000191",
      ],
    },
    {
      _id: "63701d74f03239569400003d",
      userId: "63701cc1f03239d591000318",
      cost: 3816.89,
      products: ["63701d24f03239d40b000051", "63701d24f03239d40b000050"],
    },
    {
      _id: "63701d74f03239569400003e",
      userId: "63701cc1f03239db69000127",
      cost: 3830.6,
      products: [
        "63701d24f032399c0000012a",
        "63701d24f03239867500012d",
        "63701d24f03239cdc5000015",
        "63701d24f032396b8e000016",
        "63701d24f03239d40b00004d",
      ],
    },
    {
      _id: "63701d74f03239569400003f",
      userId: "63701cc1f032399c00000122",
      cost: 2530.27,
      products: ["63701d24f032396b8e000018"],
    },
    {
      _id: "63701d74f032395694000040",
      userId: "63701cc1f032399c00000121",
      cost: 1557.75,
      products: ["63701d24f03239bef000012c", "63701d24f03239b7f7000016"],
    },
    {
      _id: "63701d74f032395694000041",
      userId: "63701cc1f032395b33000122",
      cost: 1031.98,
      products: [
        "63701d24f032395694000015",
        "63701d25f03239d59100032a",
        "63701d24f03239f09e000190",
        "63701d24f032395b3300012b",
      ],
    },
    {
      _id: "63701d74f032395694000042",
      userId: "63701cc1f032394c4900011f",
      cost: 2382.42,
      products: [
        "63701d24f03239bef000012b",
        "63701d24f03239d81e000015",
        "63701d24f03239d40b000047",
        "63701d24f03239d40b000048",
        "63701d24f032395b3300012c",
      ],
    },
    {
      _id: "63701d74f032395694000043",
      userId: "63701cc1f03239db6900011b",
      cost: 1592.8,
      products: [
        "63701d24f03239b913000017",
        "63701d24f032395b3300012d",
        "63701d24f0323944410002ed",
        "63701d24f03239b913000016",
        "63701d24f03239db6900012c",
      ],
    },
    {
      _id: "63701d74f032395694000044",
      userId: "63701cc1f03239b913000006",
      cost: 3855.51,
      products: ["63701d24f0323986f300012d"],
    },
    {
      _id: "63701d74f032395694000045",
      userId: "63701cc1f032399c0000011d",
      cost: 3061.74,
      products: [
        "63701d24f03239528f000017",
        "63701d24f03239c72c000191",
        "63701d24f032396b8e000015",
      ],
    },
    {
      _id: "63701d74f032395694000046",
      userId: "63701cc1f03239bef000011b",
      cost: 545.97,
      products: ["63701d24f03239528f000018", "63701d24f03239867500012b"],
    },
    {
      _id: "63701d74f032396b8e000019",
      userId: "63701cc1f032396b8e00000a",
      cost: 531.23,
      products: ["63701d24f032394c4900012b"],
    },
    {
      _id: "63701d74f032396b8e00001a",
      userId: "63701cc1f032394c4900011e",
      cost: 833.05,
      products: [
        "63701d24f032395694000017",
        "63701d24f0323944410002ee",
        "63701d24f03239d40b000049",
        "63701d24f03239b913000018",
        "63701d24f03239b7f7000017",
      ],
    },
    {
      _id: "63701d74f032396b8e00001b",
      userId: "63701cc1f03239d81e00000e",
      cost: 1000.84,
      products: [
        "63701d24f03239d40b000053",
        "63701d24f03239cdc5000018",
        "63701d24f0323944410002ec",
        "63701d24f03239c72c00018e",
        "63701d24f03239d40b00004f",
      ],
    },
    {
      _id: "63701d74f032396b8e00001c",
      userId: "63701cc1f03239b913000011",
      cost: 3514.81,
      products: ["63701d24f03239d81e000016"],
    },
    {
      _id: "63701d74f032396b8e00001d",
      userId: "63701cc1f032396b8e00000c",
      cost: 732.46,
      products: [
        "63701d24f032394c4900012a",
        "63701d24f032395694000016",
        "63701d24f0323944410002ef",
        "63701d24f032394c4900012d",
        "63701d24f03239d40b00004a",
      ],
    },
    {
      _id: "63701d74f032396b8e00001e",
      userId: "63701cc1f032396b8e000009",
      cost: 1846.95,
      products: [
        "63701d24f03239db6900012b",
        "63701d24f03239d40b000055",
        "63701d24f0323986f300012b",
        "63701d24f03239d40b00004b",
        "63701d24f03239b7f7000015",
      ],
    },
    {
      _id: "63701d74f032396b8e00001f",
      userId: "63701cc1f03239cdc5000012",
      cost: 478.68,
      products: ["63701d24f03239528f000015", "63701d24f032399c0000012c"],
    },
    {
      _id: "63701d74f032396b8e000020",
      userId: "63701cc1f032399c0000011e",
      cost: 2963.61,
      products: [
        "63701d24f032396b8e000017",
        "63701d25f03239d591000327",
        "63701d24f032395694000018",
        "63701d24f03239f09e00018f",
      ],
    },
    {
      _id: "63701d74f032396b8e000021",
      userId: "63701cc1f03239b7f700000e",
      cost: 3396.07,
      products: [
        "63701d24f03239db6900012d",
        "63701d24f03239d40b000054",
        "63701d24f03239db6900012a",
        "63701d24f03239cdc5000016",
      ],
    },
    {
      _id: "63701d74f032396b8e000022",
      userId: "63701cc1f03239b7f7000008",
      cost: 1104.58,
      products: [
        "63701d24f03239b7f7000018",
        "63701d24f032399c0000012d",
        "63701d24f03239bef000012a",
        "63701d24f03239bef000012d",
        "63701d25f03239d591000328",
      ],
    },
    {
      _id: "63701d74f032396b8e000023",
      userId: "63701cc1f03239b7f7000010",
      cost: 668.7,
      products: ["63701d24f032390a34000329"],
    },
    {
      _id: "63701d74f032396b8e000024",
      userId: "63701cc1f03239d591000323",
      cost: 3888.08,
      products: ["63701d24f032399c0000012b", "63701d24f03239d40b000054"],
    },
    {
      _id: "63701d74f032396b8e000025",
      userId: "63701cc1f03239b91300000a",
      cost: 88.81,
      products: ["63701d24f03239bef000012c", "63701d24f032394c4900012a"],
    },
    {
      _id: "63701d74f032396b8e000026",
      userId: "63701cc1f03239cdc500000e",
      cost: 3277.91,
      products: [
        "63701d24f03239d40b000049",
        "63701d24f03239d81e000018",
        "63701d24f03239528f000015",
      ],
    },
    {
      _id: "63701d74f032396b8e000027",
      userId: "63701cc1f032395b33000124",
      cost: 2457.33,
      products: [
        "63701d24f03239528f000018",
        "63701d24f03239cdc5000018",
        "63701d24f03239528f000017",
        "63701d24f03239867500012c",
      ],
    },
    {
      _id: "63701d74f032396b8e000028",
      userId: "63701cc1f0323944410002e5",
      cost: 118.18,
      products: ["63701d24f0323944410002ed", "63701d24f03239c72c000191"],
    },
    {
      _id: "63701d74f032396b8e000029",
      userId: "63701cc1f03239bef000011c",
      cost: 3361.11,
      products: [
        "63701d24f03239d40b00004d",
        "63701d24f03239cdc5000015",
        "63701d24f03239c72c00018f",
        "63701d24f03239d81e000017",
        "63701d24f03239c72c00018e",
      ],
    },
    {
      _id: "63701d74f032396b8e00002a",
      userId: "63701cc1f03239528f00000a",
      cost: 621.51,
      products: ["63701d24f03239bef000012b"],
    },
    {
      _id: "63701d74f032396b8e00002b",
      userId: "63701cc1f03239528f00000f",
      cost: 2036.19,
      products: [
        "63701d24f03239d40b000047",
        "63701d24f0323986f300012b",
        "63701d24f03239d40b00004a",
      ],
    },
    {
      _id: "63701d74f032396b8e00002c",
      userId: "63701cc1f03239c72c000188",
      cost: 3971,
      products: ["63701d24f03239b7f7000016", "63701d24f032395694000018"],
    },
    {
      _id: "63701d74f032396b8e00002d",
      userId: "63701cc1f03239bef000011b",
      cost: 596.77,
      products: [
        "63701d24f032395694000015",
        "63701d24f032395b3300012d",
        "63701d24f03239528f000016",
        "63701d24f032395694000017",
      ],
    },
    {
      _id: "63701d74f032396b8e00002e",
      userId: "63701cc1f03239cdc500000d",
      cost: 1729.43,
      products: ["63701d24f03239f09e000191"],
    },
    {
      _id: "63701d74f032396b8e00002f",
      userId: "63701cc1f0323944410002e8",
      cost: 2709.97,
      products: [
        "63701d24f032395b3300012b",
        "63701d24f0323944410002ec",
        "63701d24f03239db6900012a",
        "63701d24f03239cdc5000017",
      ],
    },
    {
      _id: "63701d74f032396b8e000030",
      userId: "63701cc1f0323986f300011f",
      cost: 3812.92,
      products: [
        "63701d24f03239b913000016",
        "63701d24f0323944410002ee",
        "63701d24f03239d81e000016",
        "63701d24f03239b913000017",
        "63701d24f032394c4900012d",
      ],
    },
    {
      _id: "63701d74f032396b8e000031",
      userId: "63701cc1f0323944410002e1",
      cost: 2163.93,
      products: [
        "63701d24f03239d40b00004e",
        "63701d24f032390a34000329",
        "63701d24f032399c0000012c",
        "63701d24f03239bef000012a",
      ],
    },
    {
      _id: "63701d74f032396b8e000032",
      userId: "63701cc1f03239bef0000128",
      cost: 62.48,
      products: [
        "63701d24f03239867500012b",
        "63701d24f0323986f300012a",
        "63701d24f03239cdc5000016",
        "63701d24f03239db6900012d",
        "63701d24f03239db6900012c",
      ],
    },
    {
      _id: "63701d74f032396b8e000033",
      userId: "63701cc1f03239d81e00000e",
      cost: 41.64,
      products: [
        "63701d24f032394c4900012b",
        "63701d24f032390a3400032a",
        "63701d24f032395b3300012a",
        "63701d24f03239b913000015",
      ],
    },
    {
      _id: "63701d74f032396b8e000034",
      userId: "63701cc1f032390a3400031e",
      cost: 1159.29,
      products: [
        "63701d24f03239f09e00018f",
        "63701d25f03239d59100032a",
        "63701d24f03239d40b00004f",
      ],
    },
    {
      _id: "63701d74f032396b8e000035",
      userId: "63701cc1f03239b7f7000008",
      cost: 2479.46,
      products: ["63701d24f03239d40b000053"],
    },
    {
      _id: "63701d74f032396b8e000036",
      userId: "63701cc1f0323944410002e7",
      cost: 1712.97,
      products: [
        "63701d24f032390a34000328",
        "63701d24f032395b3300012c",
        "63701d24f0323986f300012d",
      ],
    },
    {
      _id: "63701d74f032396b8e000037",
      userId: "63701cc1f03239cdc5000011",
      cost: 1845.49,
      products: [
        "63701d24f032396b8e000015",
        "63701d24f032394c4900012c",
        "63701d24f03239d40b000050",
      ],
    },
    {
      _id: "63701d74f032396b8e000038",
      userId: "63701cc1f03239c72c000184",
      cost: 33.34,
      products: [
        "63701d24f032399c0000012d",
        "63701d24f03239d40b000056",
        "63701d24f03239c72c000190",
        "63701d24f03239d40b000048",
        "63701d24f03239867500012d",
      ],
    },
    {
      _id: "63701d74f032396b8e000039",
      userId: "63701cc1f032395b33000120",
      cost: 1349.24,
      products: [
        "63701d24f03239f09e000190",
        "63701d25f03239d591000329",
        "63701d24f03239d40b000051",
        "63701d24f03239b7f7000017",
        "63701d24f03239bef000012d",
      ],
    },
    {
      _id: "63701d74f032396b8e00003a",
      userId: "63701cc1f032395b33000121",
      cost: 3790.45,
      products: ["63701d24f03239db6900012b"],
    },
    {
      _id: "63701d74f032396b8e00003b",
      userId: "63701cc1f03239867500011b",
      cost: 3013.88,
      products: [
        "63701d24f032395694000016",
        "63701d24f032396b8e000017",
        "63701d24f03239b7f7000018",
        "63701d24f0323944410002ef",
      ],
    },
    {
      _id: "63701d74f032396b8e00003c",
      userId: "63701cc1f03239d59100031d",
      cost: 1159.62,
      products: ["63701d24f03239b913000018", "63701d25f03239d591000328"],
    },
    {
      _id: "63701d74f032396b8e00003d",
      userId: "63701cc1f03239d81e000008",
      cost: 2747.76,
      products: [
        "63701d25f03239d591000329",
        "63701d24f03239cdc5000017",
        "63701d24f03239cdc5000016",
      ],
    },
    {
      _id: "63701d74f032396b8e00003e",
      userId: "63701cc1f03239c72c00018c",
      cost: 1677,
      products: ["63701d24f032395b3300012c"],
    },
    {
      _id: "63701d74f032396b8e00003f",
      userId: "63701cc1f03239528f000011",
      cost: 1406.13,
      products: [
        "63701d25f03239d59100032a",
        "63701d24f03239c72c00018e",
        "63701d24f03239867500012c",
        "63701d24f03239b913000015",
      ],
    },
    {
      _id: "63701d74f032396b8e000040",
      userId: "63701cc1f03239d591000321",
      cost: 1844.95,
      products: [
        "63701d24f03239db6900012c",
        "63701d24f03239bef000012d",
        "63701d24f032390a34000327",
        "63701d24f032394c4900012a",
        "63701d24f032396b8e000018",
      ],
    },
    {
      _id: "63701d74f032396b8e000041",
      userId: "63701cc1f03239b7f7000007",
      cost: 1058.08,
      products: ["63701d24f0323944410002ef"],
    },
    {
      _id: "63701d74f032396b8e000042",
      userId: "63701cc1f03239f09e000188",
      cost: 1290.81,
      products: ["63701d24f032395694000017"],
    },
    {
      _id: "63701d74f032396b8e000043",
      userId: "63701cc1f03239bef000011d",
      cost: 3808.93,
      products: [
        "63701d24f03239db6900012d",
        "63701d24f032399c0000012d",
        "63701d24f03239bef000012b",
      ],
    },
    {
      _id: "63701d74f032396b8e000044",
      userId: "63701cc1f032398675000122",
      cost: 1230.6,
      products: [
        "63701d24f03239d40b00004d",
        "63701d24f03239f09e00018e",
        "63701d24f0323944410002ed",
        "63701d24f03239d40b000050",
      ],
    },
    {
      _id: "63701d74f032396b8e000045",
      userId: "63701cc1f032399c0000011c",
      cost: 2460.5,
      products: ["63701d24f0323986f300012b"],
    },
    {
      _id: "63701d74f032396b8e000046",
      userId: "63701cc1f03239cdc500000c",
      cost: 1664.34,
      products: ["63701d24f0323944410002ee"],
    },
    {
      _id: "63701d74f03239bef000012e",
      userId: "63701cc1f032396b8e00000d",
      cost: 1109.75,
      products: ["63701d24f0323986f300012c", "63701d24f032390a34000329"],
    },
    {
      _id: "63701d74f03239bef000012f",
      userId: "63701cc1f032399c00000129",
      cost: 3075.49,
      products: [
        "63701d24f03239b913000017",
        "63701d24f03239d81e000018",
        "63701d24f03239cdc5000015",
        "63701d24f03239d40b000047",
        "63701d24f032395694000018",
      ],
    },
    {
      _id: "63701d74f03239bef0000130",
      userId: "63701cc1f03239b7f700000c",
      cost: 3219.87,
      products: [
        "63701d24f03239d81e000017",
        "63701d24f032394c4900012b",
        "63701d24f032390a34000328",
      ],
    },
    {
      _id: "63701d74f03239bef0000131",
      userId: "63701cc1f03239cdc5000009",
      cost: 554.41,
      products: [
        "63701d24f03239b7f7000018",
        "63701d24f03239d40b00004e",
        "63701d24f03239d40b00004a",
      ],
    },
    {
      _id: "63701d74f03239bef0000132",
      userId: "63701cc1f03239b7f7000008",
      cost: 2694.52,
      products: [
        "63701d24f03239528f000018",
        "63701d24f03239d40b000053",
        "63701d24f03239c72c000190",
        "63701d24f032396b8e000015",
      ],
    },
    {
      _id: "63701d74f03239bef0000133",
      userId: "63701cc1f03239d40b000041",
      cost: 1937.53,
      products: [
        "63701d25f03239d591000328",
        "63701d24f03239c72c000191",
        "63701d24f03239d40b000055",
        "63701d24f03239d81e000015",
      ],
    },
    {
      _id: "63701d74f03239bef0000134",
      userId: "63701cc1f03239867500011f",
      cost: 2182.98,
      products: ["63701d24f03239867500012d"],
    },
    {
      _id: "63701d74f03239bef0000135",
      userId: "63701cc1f03239cdc500000b",
      cost: 616.02,
      products: [
        "63701d24f03239f09e000190",
        "63701d24f03239b7f7000016",
        "63701d24f0323944410002ec",
        "63701d24f03239867500012b",
      ],
    },
    {
      _id: "63701d74f03239bef0000136",
      userId: "63701cc1f032398675000126",
      cost: 3358.05,
      products: ["63701d24f032399c0000012c", "63701d24f03239d40b00004c"],
    },
    {
      _id: "63701d74f03239bef0000137",
      userId: "63701cc1f03239c72c000181",
      cost: 2612.1,
      products: ["63701d24f0323986f300012d", "63701d24f032395b3300012b"],
    },
    {
      _id: "63701d74f03239bef0000138",
      userId: "63701cc1f032395694000010",
      cost: 2963.93,
      products: ["63701d24f03239d81e000016"],
    },
    {
      _id: "63701d74f03239bef0000139",
      userId: "63701cc1f03239c72c000189",
      cost: 2691.9,
      products: ["63701d24f03239528f000017", "63701d24f0323986f300012a"],
    },
    {
      _id: "63701d74f03239bef000013a",
      userId: "63701cc1f03239528f00000b",
      cost: 666.35,
      products: ["63701d25f03239d591000327", "63701d24f032394c4900012c"],
    },
    {
      _id: "63701d74f03239bef000013b",
      userId: "63701cc1f032399c00000127",
      cost: 2033.47,
      products: [
        "63701d24f03239d40b000056",
        "63701d24f032395b3300012d",
        "63701d24f032395694000016",
        "63701d24f03239bef000012c",
        "63701d24f03239d40b000049",
      ],
    },
    {
      _id: "63701d74f03239bef000013c",
      userId: "63701cc1f03239bef0000129",
      cost: 1484.96,
      products: [
        "63701d24f032395b3300012a",
        "63701d24f03239528f000015",
        "63701d24f032395694000015",
        "63701d24f03239528f000016",
        "63701d24f032396b8e000017",
      ],
    },
    {
      _id: "63701d74f03239bef000013d",
      userId: "63701cc1f032396b8e000012",
      cost: 2263.82,
      products: [
        "63701d24f03239d40b000047",
        "63701d24f0323986f300012a",
        "63701d24f03239d40b000048",
      ],
    },
    {
      _id: "63701d74f03239bef000013e",
      userId: "63701cc1f03239d81e000007",
      cost: 3432.11,
      products: [
        "63701d24f0323944410002ed",
        "63701d24f03239528f000017",
        "63701d24f03239d40b000054",
        "63701d24f03239d40b00004c",
        "63701d24f03239db6900012d",
      ],
    },
    {
      _id: "63701d74f03239bef000013f",
      userId: "63701cc1f03239d40b000039",
      cost: 2686.67,
      products: [
        "63701d24f032396b8e000017",
        "63701d24f03239d40b000056",
        "63701d24f03239867500012d",
        "63701d24f0323986f300012c",
      ],
    },
    {
      _id: "63701d74f03239bef0000140",
      userId: "63701cc1f032395b33000128",
      cost: 2674.7,
      products: ["63701d24f032395b3300012c", "63701d24f03239db6900012a"],
    },
    {
      _id: "63701d74f03239bef0000141",
      userId: "63701cc1f03239f09e000187",
      cost: 2984.15,
      products: [
        "63701d24f032390a34000328",
        "63701d24f03239b913000016",
        "63701d24f03239b7f7000017",
        "63701d24f03239867500012b",
      ],
    },
    {
      _id: "63701d74f03239bef0000142",
      userId: "63701cc1f03239867500011b",
      cost: 2261.28,
      products: ["63701d24f03239867500012a"],
    },
    {
      _id: "63701d74f03239bef0000143",
      userId: "63701cc1f03239cdc5000010",
      cost: 3740.97,
      products: ["63701d24f03239d81e000018", "63701d24f03239d40b000050"],
    },
    {
      _id: "63701d74f03239bef0000144",
      userId: "63701cc1f03239d40b000040",
      cost: 3276.83,
      products: [
        "63701d24f03239f09e000191",
        "63701d24f0323986f300012d",
        "63701d25f03239d591000327",
      ],
    },
    {
      _id: "63701d74f03239bef0000145",
      userId: "63701cc1f032399c00000123",
      cost: 3004.11,
      products: [
        "63701d24f03239b913000018",
        "63701d24f032395694000018",
        "63701d24f032390a34000327",
        "63701d24f032395b3300012b",
      ],
    },
    {
      _id: "63701d74f03239bef0000146",
      userId: "63701cc1f0323944410002ea",
      cost: 1232.26,
      products: [
        "63701d24f03239c72c00018f",
        "63701d24f032396b8e000015",
        "63701d25f03239d591000328",
        "63701d24f032394c4900012d",
        "63701d24f03239d40b000051",
      ],
    },
    {
      _id: "63701d74f03239bef0000147",
      userId: "63701cc1f032395694000012",
      cost: 3716.79,
      products: ["63701d25f03239d59100032a"],
    },
    {
      _id: "63701d74f03239bef0000148",
      userId: "63701cc1f03239d81e00000f",
      cost: 2715.02,
      products: [
        "63701d24f032399c0000012c",
        "63701d24f03239f09e00018e",
        "63701d24f03239d40b000053",
        "63701d24f032390a3400032a",
        "63701d24f03239d40b00004b",
      ],
    },
    {
      _id: "63701d74f03239bef0000149",
      userId: "63701cc1f03239db69000128",
      cost: 2683.83,
      products: [
        "63701d24f03239d81e000015",
        "63701d24f03239b7f7000016",
        "63701d24f032395b3300012d",
      ],
    },
    {
      _id: "63701d74f03239bef000014a",
      userId: "63701cc1f03239d81e000008",
      cost: 2538.89,
      products: ["63701d24f032399c0000012b", "63701d24f03239d40b00004a"],
    },
    {
      _id: "63701d74f03239bef000014b",
      userId: "63701cc1f03239867500011e",
      cost: 808.18,
      products: [
        "63701d24f03239bef000012d",
        "63701d24f03239d40b00004e",
        "63701d24f032395694000017",
        "63701d24f03239d40b00004d",
        "63701d24f03239c72c00018e",
      ],
    },
    {
      _id: "63701d74f03239bef000014c",
      userId: "63701cc1f032395b33000126",
      cost: 1124.55,
      products: [
        "63701d24f032396b8e000018",
        "63701d24f03239cdc5000016",
        "63701d24f03239528f000018",
      ],
    },
    {
      _id: "63701d74f03239bef000014d",
      userId: "63701cc1f032390a34000321",
      cost: 1471.05,
      products: ["63701d24f032390a34000329", "63701d24f032396b8e000016"],
    },
    {
      _id: "63701d74f03239bef000014e",
      userId: "63701cc1f0323986f300011f",
      cost: 2403.19,
      products: ["63701d24f03239c72c000190"],
    },
    {
      _id: "63701d74f03239bef000014f",
      userId: "63701cc1f032396b8e00000e",
      cost: 1702.69,
      products: ["63701d24f03239db6900012b", "63701d24f0323944410002ec"],
    },
    {
      _id: "63701d74f03239bef0000150",
      userId: "63701cc1f03239528f000013",
      cost: 1864.03,
      products: ["63701d24f0323986f300012b"],
    },
    {
      _id: "63701d74f03239bef0000151",
      userId: "63701cc1f03239f09e000186",
      cost: 3880.97,
      products: [
        "63701d24f03239bef000012b",
        "63701d24f03239867500012c",
        "63701d24f032394c4900012c",
      ],
    },
    {
      _id: "63701d74f03239bef0000152",
      userId: "63701cc1f032390a3400031a",
      cost: 919.82,
      products: [
        "63701d24f032395694000016",
        "63701d24f03239db6900012c",
        "63701d25f03239d591000329",
      ],
    },
    {
      _id: "63701d74f03239bef0000153",
      userId: "63701cc1f032394c49000125",
      cost: 968.95,
      products: [
        "63701d24f03239d40b00004f",
        "63701d24f032394c4900012a",
        "63701d24f03239d40b000049",
        "63701d24f032399c0000012d",
        "63701d24f032395694000015",
      ],
    },
    {
      _id: "63701d74f03239bef0000154",
      userId: "63701cc1f03239d40b000043",
      cost: 3889.06,
      products: [
        "63701d24f03239f09e000190",
        "63701d24f03239bef000012c",
        "63701d24f03239b913000017",
        "63701d24f03239d81e000017",
      ],
    },
    {
      _id: "63701d74f03239bef0000155",
      userId: "63701cc1f03239d40b00003e",
      cost: 1720.85,
      products: [
        "63701d24f03239cdc5000017",
        "63701d24f03239bef000012a",
        "63701d24f03239cdc5000015",
      ],
    },
  ];
  
  export const dataUser = [
    {
      _id: "63701cc1f03239c72c00017f",
      name: "Konstantine",
      email: "kranstead0@narod.ru",
      password: "omMDCh",
      city: "Nurabelen",
      state: null,
      country: "ID",
      occupation: "Computer Systems Analyst I",
      phoneNumber: "8346315874",
      transactions: [
        "63701d74f0323986f3000158",
        "63701d74f03239d40b00007e",
        "63701d74f03239867500014b",
        "63701d74f032398675000152",
      ],
      role: "superadmin",
    },
    {
      _id: "63701cc1f03239c72c000180",
      name: "Marilyn",
      email: "mdonlon1@hostgator.com",
      password: "XRYBnKAfm",
      city: "Zhanghekou",
      state: null,
      country: "CN",
      occupation: "Food Chemist",
      phoneNumber: "9981906117",
      transactions: [
        "63701d74f03239b7f7000027",
        "63701d74f03239db69000153",
        "63701d74f03239569400002d",
        "63701d74f032394c4900014b",
      ],
      role: "user",
    },
    {
      _id: "63701cc1f03239c72c000181",
      name: "Olly",
      email: "oveneur2@marketwatch.com",
      password: "WwDjOlH",
      city: "Muang Sam Sip",
      state: null,
      country: "TH",
      occupation: "Staff Scientist",
      phoneNumber: "3868813669",
      transactions: [
        "63701d74f03239d40b00008c",
        "63701d74f03239b7f700001e",
        "63701d74f03239867500012e",
        "63701d74f03239db69000132",
        "63701d74f032390a34000340",
        "63701d74f03239d40b000087",
      ],
      role: "admin",
    },
    {
      _id: "63701cc1f03239c72c000182",
      name: "Hale",
      email: "hpyrah3@bbc.co.uk",
      password: "vojl4bBDJ",
      city: "San Luis",
      state: null,
      country: "AR",
      occupation: "Associate Professor",
      phoneNumber: "8535391908",
      transactions: [
        "63701d74f032390a3400032f",
        "63701d74f032390a3400033f",
        "63701d74f03239d59100034c",
        "63701d74f03239569400001a",
        "63701d74f03239c72c0001a0",
        "63701d74f032399c0000013d",
        "63701d74f03239db69000152",
        "63701d74f03239b91300001c",
        "63701d74f03239cdc500003f",
        "63701d74f03239bef0000159",
      ],
      role: "superadmin",
    },
    {
      _id: "63701cc1f03239c72c000183",
      name: "Allie",
      email: "afranzschoninger4@simplemachines.org",
      password: "zocih1DjIv",
      city: "Osieck",
      state: null,
      country: "PL",
      occupation: "Senior Cost Accountant",
      phoneNumber: "5367727534",
      transactions: [
        "63701d74f032395694000036",
        "63701d74f032395b33000138",
        "63701d74f032394441000314",
      ],
      role: "superadmin",
    },
    {
      _id: "63701cc1f03239c72c000184",
      name: "Donelle",
      email: "dcrossgrove5@constantcontact.com",
      password: "Q81bu6JV",
      city: "São Jerônimo",
      state: null,
      country: "BR",
      occupation: "Chemical Engineer",
      phoneNumber: "8601650433",
      transactions: [
        "63701d74f03239d40b000078",
        "63701d74f03239db69000157",
        "63701d74f03239b7f7000025",
        "63701d74f032395694000042",
        "63701d74f03239d591000339",
        "63701d74f03239b7f700003d",
        "63701d74f032396b8e000029",
        "63701d74f03239d81e00003e",
        "63701d74f03239d81e000032",
        "63701d74f03239db6900013d",
      ],
      role: "user",
    },
    {
      _id: "63701cc1f03239c72c000185",
      name: "Westbrook",
      email: "wsiddon6@state.tx.us",
      password: "PVfV72mNxb4",
      city: "Hanjiashu",
      state: null,
      country: "CN",
      occupation: "Quality Engineer",
      phoneNumber: "3096621613",
      transactions: [
        "63701d74f0323944410002fa",
        "63701d74f03239f09e0001ab",
        "63701d74f03239db6900014e",
        "63701d74f032395b33000158",
        "63701d74f032390a3400034c",
        "63701d74f0323986f3000151",
        "63701d74f0323986f3000145",
        "63701d74f03239867500012f",
        "63701d74f03239f09e0001ad",
      ],
      role: "superadmin",
    },
    {
      _id: "63701cc1f03239c72c000186",
      name: "Paola",
      email: "pledger7@freewebs.com",
      password: "L6mw336",
      city: "Xian’an",
      state: null,
      country: "CN",
      occupation: "Senior Quality Engineer",
      phoneNumber: "2982518057",
      transactions: [
        "63701d74f03239d81e000044",
        "63701d74f03239bef0000155",
        "63701d74f03239d81e00001e",
      ],
      role: "user",
    },
    {
      _id: "63701cc1f03239c72c000187",
      name: "Whit",
      email: "wrenols8@webeden.co.uk",
      password: "TnE8Lbb",
      city: "Oganlima",
      state: null,
      country: "ID",
      occupation: "Office Assistant IV",
      phoneNumber: "5967740518",
      transactions: [
        "63701d74f032395694000041",
        "63701d74f032395b33000144",
        "63701d74f032398675000130",
        "63701d74f032399c00000154",
        "63701d74f03239d81e000020",
        "63701d74f03239f09e000196",
        "63701d74f03239d591000349",
      ],
      role: "superadmin",
    },
    {
      _id: "63701cc1f03239c72c000188",
      name: "Shayna",
      email: "sradcliffe9@nytimes.com",
      password: "S7uupsmLnj6",
      city: "Longshan",
      state: null,
      country: "CN",
      occupation: "Analog Circuit Design manager",
      phoneNumber: "6052810930",
      transactions: [
        "63701d74f0323986f3000152",
        "63701d74f032399c0000014b",
        "63701d74f03239867500015b",
        "63701d74f03239cdc500002c",
        "63701d74f0323986f3000134",
        "63701d74f03239cdc5000032",
      ],
      role: "superadmin",
    },
    {
      _id: "63701cc1f03239c72c000189",
      name: "Donnamarie",
      email: "dkelfa@cam.ac.uk",
      password: "VygsdES",
      city: "Buraen",
      state: null,
      country: "ID",
      occupation: "Food Chemist",
      phoneNumber: "8395198999",
      transactions: [
        "63701d74f0323986f3000131",
        "63701d74f032399c0000014c",
        "63701d74f03239db69000133",
        "63701d74f03239bef000013c",
        "63701d74f03239bef0000147",
        "63701d74f03239b913000040",
      ],
      role: "superadmin",
    },
    {
      _id: "63701cc1f03239c72c00018a",
      name: "Felice",
      email: "fleivesleyb@liveinternet.ru",
      password: "vDE7jo",
      city: "Hrušica",
      state: null,
      country: "SI",
      occupation: "Administrative Assistant III",
      phoneNumber: "2401478620",
      transactions: [
        "63701d74f03239d81e00003a",
        "63701d74f03239cdc5000037",
        "63701d74f03239cdc5000046",
        "63701d74f03239cdc5000045",
        "63701d74f03239d40b00005d",
        "63701d74f03239528f000041",
      ],
      role: "user",
    },
    {
      _id: "63701cc1f03239c72c00018b",
      name: "Fan",
      email: "fmarttc@java.com",
      password: "6MbbkQdEUIU",
      city: "Gueset",
      state: null,
      country: "PH",
      occupation: "Senior Quality Engineer",
      phoneNumber: "7394223360",
      transactions: [
        "63701d74f03239c72c0001a8",
        "63701d74f032399c0000013c",
        "63701d74f03239db69000155",
      ],
      role: "admin",
    },
    {
      _id: "63701cc1f03239c72c00018c",
      name: "Jack",
      email: "jmattiazzid@amazon.co.uk",
      password: "QVqoVN",
      city: "Ar Ramthā",
      state: null,
      country: "JO",
      occupation: "Health Coach I",
      phoneNumber: "8815565181",
      transactions: [
        "63701d74f03239b913000027",
        "63701d74f032390a3400033e",
        "63701d74f03239528f000036",
        "63701d74f03239444100031c",
        "63701d74f032395b33000139",
        "63701d74f03239db69000143",
        "63701d74f03239569400001b",
      ],
      role: "admin",
    },
    {
      _id: "63701cc1f03239c72c00018d",
      name: "Ive",
      email: "istraceye@weather.com",
      password: "okzBTuP",
      city: "Umbuldamar",
      state: null,
      country: "ID",
      occupation: "Research Associate",
      phoneNumber: "9889514743",
      transactions: ["63701d74f032394441000305"],
      role: "user",
    },
    {
      _id: "63701cc1f03239867500011b",
      name: "May",
      email: "mpatchettf@drupal.org",
      password: "2c2sbTe",
      city: "Jianchang",
      state: null,
      country: "CN",
      occupation: "Professor",
      phoneNumber: "1711601856",
      transactions: [
        "63701d74f03239f09e0001bd",
        "63701d74f03239b7f7000029",
        "63701d74f032395b33000153",
        "63701d74f032390a34000347",
        "63701d74f032395b3300012e",
        "63701d74f03239569400001b",
        "63701d74f03239d591000330",
      ],
      role: "admin",
    },
    {
      _id: "63701cc1f03239867500011c",
      name: "Wendel",
      email: "wdutchburng@nationalgeographic.com",
      password: "kmi0faeWBx1G",
      city: "Anáfi",
      state: null,
      country: "GR",
      occupation: "Product Engineer",
      phoneNumber: "9765815561",
      transactions: [
        "63701d74f032394441000319",
        "63701d74f03239528f00003e",
        "63701d74f03239bef000014e",
        "63701d74f03239d81e00002e",
        "63701d74f03239d59100034b",
        "63701d74f03239bef0000149",
        "63701d74f03239d40b00008c",
        "63701d74f03239d81e00003f",
        "63701d74f03239867500014c",
      ],
      role: "admin",
    },
    {
      _id: "63701cc1f03239867500011d",
      name: "Ruddie",
      email: "rradolfh@webeden.co.uk",
      password: "Fo6oBx",
      city: "Onega",
      state: null,
      country: "RU",
      occupation: "Health Coach I",
      phoneNumber: "8958889697",
      transactions: ["63701d74f0323944410002fc"],
      role: "user",
    },
    {
      _id: "63701cc1f03239867500011e",
      name: "Marsiella",
      email: "mduckiti@cyberchimps.com",
      password: "e3EXvP",
      city: "Qiujia",
      state: null,
      country: "CN",
      occupation: "Programmer II",
      phoneNumber: "1904503194",
      transactions: ["63701d74f032395b33000132"],
      role: "admin",
    },
    {
      _id: "63701cc1f03239867500011f",
      name: "Ardys",
      email: "achallensj@slideshare.net",
      password: "z3dWORN4DR",
      city: "Nova Venécia",
      state: null,
      country: "BR",
      occupation: "Mechanical Systems Engineer",
      phoneNumber: "2849094457",
      transactions: [
        "63701d74f032398675000148",
        "63701d74f032390a34000339",
        "63701d74f03239db69000141",
        "63701d74f032395b3300014f",
        "63701d74f032394441000318",
      ],
      role: "admin",
    },
    {
      _id: "63701cc1f032398675000120",
      name: "Annora",
      email: "aezzellk@dell.com",
      password: "r4BBJbD",
      city: "Asino",
      state: null,
      country: "RU",
      occupation: "Compensation Analyst",
      phoneNumber: "8057932279",
      transactions: [
        "63701d74f032394441000317",
        "63701d74f03239f09e0001a5",
        "63701d74f032394441000313",
        "63701d74f03239867500013e",
      ],
      role: "superadmin",
    },
    {
      _id: "63701cc1f032398675000121",
      name: "Donnie",
      email: "dwhyel@icio.us",
      password: "PUX9ly",
      city: "Sofrino",
      state: null,
      country: "RU",
      occupation: "Legal Assistant",
      phoneNumber: "9871632129",
      transactions: [
        "63701d74f03239d40b000064",
        "63701d74f03239f09e000194",
        "63701d74f03239d59100034d",
        "63701d74f032395b3300013a",
        "63701d74f03239cdc500002f",
        "63701d74f032399c00000141",
        "63701d74f03239b7f7000041",
        "63701d74f032390a34000348",
        "63701d74f03239bef0000153",
      ],
      role: "admin",
    },
    {
      _id: "63701cc1f032398675000122",
      name: "Putnem",
      email: "pklimam@hubpages.com",
      password: "DjNXXzYKZpr",
      city: "Walichnowy",
      state: null,
      country: "PL",
      occupation: "Design Engineer",
      phoneNumber: "2019015578",
      transactions: ["63701d74f03239bef0000140"],
      role: "admin",
    },
    {
      _id: "63701cc1f032398675000123",
      name: "Cassius",
      email: "cwaben@discovery.com",
      password: "2FLtGooM",
      city: "Si Mahosot",
      state: null,
      country: "TH",
      occupation: "Technical Writer",
      phoneNumber: "6912362416",
      transactions: [
        "63701d74f032396b8e000035",
        "63701d74f03239db69000130",
        "63701d74f03239f09e000192",
        "63701d74f032394c4900014f",
      ],
      role: "superadmin",
    },
    {
      _id: "63701cc1f032398675000124",
      name: "Elsi",
      email: "ehazeldeneo@ezinearticles.com",
      password: "FCWiZT12E",
      city: "Vũng Tàu",
      state: null,
      country: "VN",
      occupation: "Chemical Engineer",
      phoneNumber: "5725023513",
      transactions: [
        "63701d74f032398675000130",
        "63701d74f032398675000155",
        "63701d74f03239528f000026",
        "63701d74f03239444100030d",
        "63701d74f03239bef000014a",
        "63701d74f0323986f3000130",
        "63701d74f03239d81e000022",
        "63701d74f032390a3400032b",
        "63701d74f032394441000303",
      ],
      role: "user",
    },
    {
      _id: "63701cc1f032398675000125",
      name: "Dacey",
      email: "domohunp@youku.com",
      password: "c9DQGaI",
      city: "Solntsevo",
      state: null,
      country: "RU",
      occupation: "VP Accounting",
      phoneNumber: "3653765798",
      transactions: [
        "63701d74f03239d40b000080",
        "63701d74f032390a3400034d",
        "63701d74f03239c72c0001a0",
        "63701d74f03239b7f7000039",
        "63701d74f032396b8e000041",
        "63701d74f03239c72c000196",
        "63701d74f03239db69000148",
        "63701d74f03239db6900014d",
        "63701d74f03239d81e000027",
        "63701d74f032395694000045",
      ],
      role: "superadmin",
    },
    {
      _id: "63701cc1f032398675000126",
      name: "Baxter",
      email: "babramovitzq@oaic.gov.au",
      password: "Y3XCoCOQ7",
      city: "Orléans",
      state: "A3",
      country: "FR",
      occupation: "Librarian",
      phoneNumber: "9841492249",
      transactions: [
        "63701d74f03239bef0000157",
        "63701d74f032396b8e00003a",
        "63701d74f032390a34000337",
        "63701d74f03239c72c0001b7",
        "63701d74f03239c72c0001be",
        "63701d74f032396b8e000025",
      ],
      role: "user",
    },
    {
      _id: "63701cc1f032398675000127",
      name: "Claudette",
      email: "cjentr@meetup.com",
      password: "BXhdT5Gy",
      city: "Langenburg",
      state: "SK",
      country: "CA",
      occupation: "Analyst Programmer",
      phoneNumber: "4165319154",
      transactions: [
        "63701d74f03239528f000024",
        "63701d74f03239b913000046",
        "63701d74f03239d591000352",
        "63701d74f032399c00000143",
        "63701d74f032394c49000152",
        "63701d74f03239528f000021",
        "63701d74f0323986f300014d",
        "63701d74f032398675000154",
        "63701d74f03239528f00001c",
        "63701d74f03239cdc500001a",
      ],
      role: "user",
    },
    {
      _id: "63701cc1f032398675000128",
      name: "Tully",
      email: "tmushrows@timesonline.co.uk",
      password: "osjFXkw31d",
      city: "La Laja",
      state: null,
      country: "CL",
      occupation: "Human Resources Manager",
      phoneNumber: "7832710010",
      transactions: ["63701d74f03239b91300002c"],
      role: "admin",
    },
    {
      _id: "63701cc1f032398675000129",
      name: "Clarey",
      email: "ccoastert@walmart.com",
      password: "YALFgb5K0eMw",
      city: "El Rosario",
      state: null,
      country: "SV",
      occupation: "Dental Hygienist",
      phoneNumber: "9031861313",
      transactions: [
        "63701d74f03239d591000348",
        "63701d74f032395b33000147",
        "63701d74f032390a3400033f",
        "63701d74f03239f09e0001a8",
        "63701d74f032395694000028",
        "63701d74f03239b91300003e",
        "63701d74f032390a3400034b",
      ],
      role: "admin",
    },
    {
      _id: "63701cc1f03239b7f7000006",
      name: "Catrina",
      email: "cstroderu@list-manage.com",
      password: "GmZQaLqe",
      city: "Nossebro",
      state: "O",
      country: "SE",
      occupation: "Help Desk Operator",
      phoneNumber: "5849922301",
      transactions: ["63701d74f03239b91300001a"],
      role: "admin",
    },
    {
      _id: "63701cc1f03239b7f7000007",
      name: "Karoline",
      email: "kbahikev@dmoz.org",
      password: "lDNqwWtH89",
      city: "Nanxinxiang",
      state: null,
      country: "CN",
      occupation: "Senior Developer",
      phoneNumber: "6492193450",
      transactions: [
        "63701d74f03239cdc500003a",
        "63701d74f03239db69000132",
        "63701d74f03239bef0000153",
        "63701d74f03239bef000014d",
        "63701d74f03239d40b000071",
        "63701d74f03239528f00003f",
      ],
      role: "superadmin",
    },
    {
      _id: "63701cc1f03239b7f7000008",
      name: "Elwood",
      email: "einkpenw@mysql.com",
      password: "Tco5HF0DgN28",
      city: "Ban Khlong Bang Sao Thong",
      state: null,
      country: "TH",
      occupation: "Help Desk Technician",
      phoneNumber: "7662486646",
      transactions: [
        "63701d74f03239f09e0001ab",
        "63701d74f032396b8e000034",
        "63701d74f03239db69000153",
        "63701d74f03239b7f700001e",
        "63701d74f032395b3300012f",
        "63701d74f03239c72c0001b3",
        "63701d74f032395b33000147",
        "63701d74f03239b7f7000031",
      ],
      role: "admin",
    },
    {
      _id: "63701cc1f03239b7f7000009",
      name: "Catina",
      email: "cgookeyx@upenn.edu",
      password: "gSN5MQ0j",
      city: "Iberia",
      state: null,
      country: "PE",
      occupation: "Librarian",
      phoneNumber: "1431906173",
      transactions: [
        "63701d74f032395b3300015b",
        "63701d74f032396b8e00001a",
        "63701d74f03239c72c000199",
        "63701d74f032395b33000152",
        "63701d74f03239bef0000131",
      ],
      role: "superadmin",
    },
    {
      _id: "63701cc1f03239b7f700000a",
      name: "Josh",
      email: "jpearsony@godaddy.com",
      password: "SV5HATy",
      city: "Phúc Yên",
      state: null,
      country: "VN",
      occupation: "VP Accounting",
      phoneNumber: "9157315270",
      transactions: [
        "63701d74f032395694000030",
        "63701d74f032399c0000014d",
        "63701d74f032394c49000157",
        "63701d74f03239f09e0001a2",
        "63701d74f03239d81e000024",
        "63701d74f03239d591000343",
        "63701d74f0323986f3000135",
        "63701d74f0323986f300013b",
      ],
      role: "user",
    },
    {
      _id: "63701cc1f03239b7f700000b",
      name: "Johannah",
      email: "jpulbrookz@addthis.com",
      password: "EaMwB8azB",
      city: "Starcevica",
      state: null,
      country: "BA",
      occupation: "Sales Representative",
      phoneNumber: "1798809437",
      transactions: [
        "63701d74f03239d40b00006d",
        "63701d74f03239b91300002d",
        "63701d74f03239d40b000068",
        "63701d74f03239d81e00003e",
        "63701d74f032394c49000153",
      ],
      role: "user",
    },
    {
      _id: "63701cc1f03239b7f700000c",
      name: "Svend",
      email: "swalcher10@soundcloud.com",
      password: "AUXlFAx",
      city: "Neuzina",
      state: null,
      country: "RS",
      occupation: "Associate Professor",
      phoneNumber: "5644476178",
      transactions: [
        "63701d74f032390a34000350",
        "63701d74f032398675000145",
        "63701d74f032390a34000338",
        "63701d74f03239f09e0001a7",
        "63701d74f032395694000032",
      ],
      role: "admin",
    },
    {
      _id: "63701cc1f03239b7f700000d",
      name: "Sosanna",
      email: "smaskew11@cloudflare.com",
      password: "JwJ8KAu",
      city: "Gulong",
      state: null,
      country: "CN",
      occupation: "Occupational Therapist",
      phoneNumber: "1837060566",
      transactions: [
        "63701d74f03239bef000013e",
        "63701d74f03239f09e00019c",
        "63701d74f032398675000144",
        "63701d74f03239f09e0001a4",
        "63701d74f03239c72c0001b6",
      ],
      role: "user",
    },
    {
      _id: "63701cc1f03239b7f700000e",
      name: "Shelly",
      email: "swelbeck12@ycombinator.com",
      password: "RSjzmAjnq",
      city: "Sangoleng",
      state: null,
      country: "ID",
      occupation: "Pharmacist",
      phoneNumber: "7036619983",
      transactions: [
        "63701d74f03239d81e000027",
        "63701d74f032396b8e00002c",
        "63701d74f032396b8e000037",
        "63701d74f03239d81e00002a",
        "63701d74f03239c72c0001ba",
        "63701d74f032399c00000151",
        "63701d74f03239c72c0001a1",
      ],
      role: "superadmin",
    },
    {
      _id: "63701cc1f03239b7f700000f",
      name: "Amil",
      email: "aweben13@feedburner.com",
      password: "GpOhlbh0G",
      city: "Primorskiy",
      state: null,
      country: "RU",
      occupation: "Administrative Officer",
      phoneNumber: "4707334512",
      transactions: [
        "63701d74f03239bef0000133",
        "63701d74f032396b8e00003c",
        "63701d74f0323986f3000156",
        "63701d74f03239d591000334",
      ],
      role: "superadmin",
    },
    {
      _id: "63701cc1f03239b7f7000010",
      name: "Hugh",
      email: "hainscow14@themeforest.net",
      password: "Ss5r1aRDRri",
      city: "Krajan Dermawuharjo",
      state: null,
      country: "ID",
      occupation: "Librarian",
      phoneNumber: "6834096034",
      transactions: [
        "63701d74f03239528f000045",
        "63701d74f03239db69000140",
        "63701d74f03239db69000150",
      ],
      role: "admin",
    },
    {
      _id: "63701cc1f03239b7f7000011",
      name: "Allissa",
      email: "ahacker15@illinois.edu",
      password: "4VjqD2Nn8",
      city: "Hongshan",
      state: null,
      country: "CN",
      occupation: "Software Test Engineer III",
      phoneNumber: "9202297858",
      transactions: [
        "63701d74f032396b8e00002a",
        "63701d74f03239528f00003e",
        "63701d74f03239d59100032b",
        "63701d74f03239b7f700003c",
        "63701d74f032390a34000351",
        "63701d74f03239b91300003b",
        "63701d74f03239cdc500001b",
        "63701d74f03239b7f700003d",
      ],
      role: "admin",
    },
    {
      _id: "63701cc1f03239b7f7000012",
      name: "Teodoro",
      email: "tkeenleyside16@chron.com",
      password: "TrAxjYR54",
      city: "Ambian",
      state: null,
      country: "ID",
      occupation: "Assistant Media Planner",
      phoneNumber: "6985339606",
      transactions: [
        "63701d74f03239cdc5000029",
        "63701d74f03239db6900012f",
        "63701d74f03239b913000035",
      ],
      role: "admin",
    },
    {
      _id: "63701cc1f03239b7f7000013",
      name: "Chickie",
      email: "cdebill17@cnn.com",
      password: "of0RjLpP",
      city: "Xingpinglu",
      state: null,
      country: "CN",
      occupation: "Pharmacist",
      phoneNumber: "6998313608",
      transactions: [
        "63701d74f032394441000301",
        "63701d74f03239d40b00006f",
        "63701d74f03239d40b00007f",
        "63701d74f03239bef000013b",
        "63701d74f03239db69000145",
      ],
      role: "admin",
    },
    {
      _id: "63701cc1f03239b7f7000014",
      name: "Yardley",
      email: "yrestieaux18@google.com.hk",
      password: "6HDQYk",
      city: "Kirovsk",
      state: null,
      country: "RU",
      occupation: "Office Assistant III",
      phoneNumber: "2634455004",
      transactions: [
        "63701d74f0323944410002f8",
        "63701d74f03239569400001e",
        "63701d74f032395b33000138",
        "63701d74f03239d40b00007e",
        "63701d74f03239444100031d",
        "63701d74f03239b913000036",
        "63701d74f032396b8e000029",
        "63701d74f03239f09e00019f",
        "63701d74f03239528f00001b",
      ],
      role: "user",
    },
    {
      _id: "63701cc1f0323944410002dd",
      name: "Micheline",
      email: "mbarajaz19@nhs.uk",
      password: "tPQCVZTA",
      city: "Krasnyy Luch",
      state: null,
      country: "UA",
      occupation: "Tax Accountant",
      phoneNumber: "5491175476",
      transactions: [
        "63701d74f03239c72c0001be",
        "63701d74f03239f09e0001b6",
        "63701d74f03239db69000130",
        "63701d74f032394441000300",
        "63701d74f032394441000309",
        "63701d74f03239d40b000067",
        "63701d74f03239b91300002f",
      ],
      role: "user",
    },
    {
      _id: "63701cc1f0323944410002de",
      name: "Darrin",
      email: "dmylechreest1a@sohu.com",
      password: "V9L2N2bQm6j9",
      city: "Rakai",
      state: null,
      country: "UG",
      occupation: "Nurse Practicioner",
      phoneNumber: "7998057020",
      transactions: [
        "63701d74f03239d81e000038",
        "63701d74f03239f09e0001b2",
        "63701d74f03239db69000158",
        "63701d74f03239db69000149",
        "63701d74f032396b8e000035",
      ],
      role: "admin",
    },
    {
      _id: "63701cc1f0323944410002df",
      name: "Burr",
      email: "bshellshear1b@hibu.com",
      password: "MafICMthnVZd",
      city: "Gwandu",
      state: null,
      country: "NG",
      occupation: "Graphic Designer",
      phoneNumber: "9558909811",
      transactions: ["63701d74f03239444100030c", "63701d74f03239569400002b"],
      role: "superadmin",
    },
    {
      _id: "63701cc1f0323944410002e0",
      name: "Ring",
      email: "rwollaston1c@slashdot.org",
      password: "V8opKuIyr8S",
      city: "Buenos Aires",
      state: null,
      country: "HN",
      occupation: "Senior Editor",
      phoneNumber: "7693297972",
      transactions: [
        "63701d74f032394441000306",
        "63701d74f03239867500014b",
        "63701d74f03239d81e00003d",
        "63701d74f032390a3400033b",
        "63701d74f032399c00000159",
        "63701d74f032394c49000155",
        "63701d74f03239d591000335",
        "63701d74f03239d40b000083",
        "63701d74f03239c72c0001b6",
        "63701d74f03239569400001d",
      ],
      role: "user",
    },
    {
      _id: "63701cc1f0323944410002e1",
      name: "Carce",
      email: "cgedney1d@google.com",
      password: "PPQPu37zpWxI",
      city: "Lagny-sur-Marne",
      state: "A8",
      country: "FR",
      occupation: "Payment Adjustment Coordinator",
      phoneNumber: "2303787795",
      transactions: [
        "63701d74f03239528f000019",
        "63701d74f03239b7f7000043",
        "63701d74f032390a34000338",
        "63701d74f0323986f3000153",
        "63701d74f032394c49000146",
        "63701d74f03239db69000138",
        "63701d74f03239528f000022",
        "63701d74f032390a3400034c",
        "63701d74f03239b913000030",
        "63701d74f03239cdc500001b",
      ],
      role: "user",
    },
    {
      _id: "63701cc1f0323944410002e2",
      name: "Betteanne",
      email: "bhitcham1e@soundcloud.com",
      password: "0KtiRgeY",
      city: "Ngou",
      state: null,
      country: "CM",
      occupation: "Safety Technician I",
      phoneNumber: "2589001309",
      transactions: [
        "63701d74f03239d591000349",
        "63701d74f03239bef000013a",
        "63701d74f032399c00000149",
        "63701d74f032395694000028",
        "63701d74f03239d40b000058",
      ],
      role: "admin",
    },
    {
      _id: "63701cc1f0323944410002e3",
      name: "Jamison",
      email: "jsiggers1f@amazon.co.jp",
      password: "RjP40jSKi",
      city: "Lyon",
      state: "B9",
      country: "FR",
      occupation: "Financial Analyst",
      phoneNumber: "3972807132",
      transactions: [
        "63701d74f03239f09e0001a6",
        "63701d74f032395694000042",
        "63701d74f03239db6900015b",
        "63701d74f032395b33000135",
        "63701d74f032390a3400032e",
      ],
      role: "admin",
    },
    {
      _id: "63701cc1f0323944410002e4",
      name: "Mickie",
      email: "mtaill1g@newsvine.com",
      password: "OPUob50iBIbS",
      city: "‘Alāqahdārī Kirān wa Munjān",
      state: null,
      country: "AF",
      occupation: "Librarian",
      phoneNumber: "2967030879",
      transactions: [
        "63701d74f032396b8e000036",
        "63701d74f03239bef0000153",
        "63701d74f032399c00000146",
        "63701d74f03239cdc5000041",
        "63701d74f032394c4900013c",
        "63701d74f0323944410002f9",
        "63701d74f03239d81e00001f",
        "63701d74f03239d40b000087",
        "63701d74f032395694000045",
        "63701d74f03239528f000042",
      ],
      role: "user",
    },
    {
      _id: "63701cc1f0323944410002e5",
      name: "Suki",
      email: "sondrak1h@sciencedirect.com",
      password: "KUPXyFLRW8A",
      city: "Boston",
      state: "MA",
      country: "US",
      occupation: "Recruiter",
      phoneNumber: "6172973376",
      transactions: [
        "63701d74f03239b7f7000033",
        "63701d74f03239b7f7000030",
        "63701d74f032395b33000137",
        "63701d74f03239867500013f",
        "63701d74f032399c0000014f",
        "63701d74f032394441000303",
      ],
      role: "superadmin",
    },
    {
      _id: "63701cc1f0323944410002e6",
      name: "Brynna",
      email: "bluebbert1i@mac.com",
      password: "16FBKEbQF",
      city: "Pakel",
      state: null,
      country: "ID",
      occupation: "Operator",
      phoneNumber: "4774537814",
      transactions: [
        "63701d74f03239569400002d",
        "63701d74f032395b33000158",
        "63701d74f03239d59100032f",
        "63701d74f032390a34000341",
        "63701d74f03239d40b000078",
        "63701d74f03239b91300003c",
        "63701d74f032396b8e000034",
        "63701d74f03239867500013e",
      ],
      role: "superadmin",
    },
    {
      _id: "63701cc1f0323944410002e7",
      name: "Larine",
      email: "lcivitillo1j@weibo.com",
      password: "P5YPy95",
      city: "Kumba",
      state: null,
      country: "CM",
      occupation: "Geologist III",
      phoneNumber: "8998444141",
      transactions: [
        "63701d74f0323944410002f5",
        "63701d74f03239b913000022",
        "63701d74f03239d591000352",
        "63701d74f032394c4900012e",
      ],
      role: "admin",
    },
    {
      _id: "63701cc1f0323944410002e8",
      name: "Crin",
      email: "cburniston1k@opera.com",
      password: "DoUGAfWA",
      city: "Portela",
      state: "06",
      country: "PT",
      occupation: "Chief Design Engineer",
      phoneNumber: "7476816241",
      transactions: [
        "63701d74f03239cdc500003d",
        "63701d74f03239d40b000057",
        "63701d74f03239bef0000143",
        "63701d74f032396b8e000029",
      ],
      role: "user",
    },
    {
      _id: "63701cc1f0323944410002e9",
      name: "Garrett",
      email: "gklassmann1l@vistaprint.com",
      password: "nIaVyzp8M1",
      city: "Ajaccio",
      state: "A5",
      country: "FR",
      occupation: "Associate Professor",
      phoneNumber: "3539813742",
      transactions: [
        "63701d74f03239b7f700003b",
        "63701d74f032395b3300013e",
        "63701d74f03239b7f700003e",
        "63701d74f03239d81e00003f",
      ],
      role: "admin",
    },
    {
      _id: "63701cc1f0323944410002ea",
      name: "Daron",
      email: "dolochan1m@parallels.com",
      password: "UTviIGfwFM6A",
      city: "Magtaking",
      state: null,
      country: "PH",
      occupation: "Graphic Designer",
      phoneNumber: "8442463887",
      transactions: [
        "63701d74f032395b3300014c",
        "63701d74f03239b913000029",
        "63701d74f03239d591000344",
      ],
      role: "superadmin",
    },
    {
      _id: "63701cc1f0323944410002eb",
      name: "Karmen",
      email: "kspoor1n@msu.edu",
      password: "c0kFujPKV",
      city: "Paris 19",
      state: "A8",
      country: "FR",
      occupation: "Clinical Specialist",
      phoneNumber: "6146081308",
      transactions: [
        "63701d74f032398675000145",
        "63701d74f032394441000319",
        "63701d74f03239db69000143",
        "63701d74f03239d40b000089",
        "63701d74f0323986f300014c",
        "63701d74f03239d59100033c",
        "63701d74f03239444100030f",
        "63701d74f03239f09e0001a0",
        "63701d74f032395b33000142",
        "63701d74f03239d81e000024",
      ],
      role: "superadmin",
    },
    {
      _id: "63701cc1f03239d81e000006",
      name: "Zorana",
      email: "zkoppen1o@printfriendly.com",
      password: "bd3t1lx",
      city: "Yaguarón",
      state: null,
      country: "PY",
      occupation: "Librarian",
      phoneNumber: "9207617212",
      transactions: [
        "63701d74f032396b8e000039",
        "63701d74f032396b8e000019",
        "63701d74f03239cdc500002b",
        "63701d74f03239528f000026",
        "63701d74f03239cdc5000045",
        "63701d74f03239d81e000037",
        "63701d74f032394c49000135",
        "63701d74f032396b8e000025",
      ],
      role: "superadmin",
    },
    {
      _id: "63701cc1f03239d81e000007",
      name: "Sabina",
      email: "stearney1p@prlog.org",
      password: "a9ACXn0ocWe",
      city: "Boavista",
      state: "03",
      country: "PT",
      occupation: "Junior Executive",
      phoneNumber: "6543510407",
      transactions: ["63701d74f032396b8e00001f", "63701d74f032396b8e000033"],
      role: "superadmin",
    },
    {
      _id: "63701cc1f03239d81e000008",
      name: "Cyndia",
      email: "cmarquet1q@zimbio.com",
      password: "hX2qMjGXic",
      city: "Santa Cruz de la Sierra",
      state: null,
      country: "BO",
      occupation: "Sales Representative",
      phoneNumber: "4107831964",
      transactions: [
        "63701d74f03239b913000030",
        "63701d74f03239c72c000199",
        "63701d74f032396b8e000046",
        "63701d74f032396b8e00003c",
        "63701d74f032394441000300",
        "63701d74f03239d40b00005f",
        "63701d74f03239bef0000147",
      ],
      role: "user",
    },
    {
      _id: "63701cc1f03239d81e000009",
      name: "Swen",
      email: "skalaher1r@amazonaws.com",
      password: "1vDUOkJO",
      city: "Tongquan",
      state: null,
      country: "CN",
      occupation: "Junior Executive",
      phoneNumber: "5395020807",
      transactions: [
        "63701d74f03239bef0000131",
        "63701d74f03239d591000342",
        "63701d74f0323986f3000158",
        "63701d74f03239b7f7000032",
        "63701d74f03239569400001b",
        "63701d74f032399c00000151",
        "63701d74f03239cdc5000046",
      ],
      role: "user",
    },
    {
      _id: "63701cc1f03239d81e00000a",
      name: "Britte",
      email: "bmacmichael1s@archive.org",
      password: "3QiIYPcq7KTV",
      city: "Dolo",
      state: null,
      country: "PH",
      occupation: "Systems Administrator IV",
      phoneNumber: "3351773602",
      transactions: [
        "63701d74f03239f09e0001bb",
        "63701d74f03239db69000146",
        "63701d74f03239d40b00006e",
      ],
      role: "user",
    },
    {
      _id: "63701cc1f03239d81e00000b",
      name: "Ara",
      email: "afozzard1t@japanpost.jp",
      password: "lEJfuI7V",
      city: "Cincinnati",
      state: "OH",
      country: "US",
      occupation: "Desktop Support Technician",
      phoneNumber: "5131816328",
      transactions: [
        "63701d74f03239c72c0001bf",
        "63701d74f032395694000041",
        "63701d74f032396b8e000020",
      ],
      role: "user",
    },
    {
      _id: "63701cc1f03239d81e00000c",
      name: "Arv",
      email: "ahouseman1u@usa.gov",
      password: "Tdj392C7Cz",
      city: "Lamovita",
      state: null,
      country: "BA",
      occupation: "Environmental Tech",
      phoneNumber: "6425378915",
      transactions: [
        "63701d74f03239b7f700002f",
        "63701d74f032394c49000144",
        "63701d74f03239d81e000036",
        "63701d74f03239c72c0001a7",
        "63701d74f0323944410002f0",
        "63701d74f03239569400003a",
        "63701d74f03239b7f700002a",
      ],
      role: "admin",
    },
    {
      _id: "63701cc1f03239d81e00000d",
      name: "Fernanda",
      email: "fcoye1v@flickr.com",
      password: "Sh63Kwbl8pM",
      city: "Taikang",
      state: null,
      country: "CN",
      occupation: "Chief Design Engineer",
      phoneNumber: "7296895830",
      transactions: ["63701d74f03239bef0000141"],
      role: "user",
    },
    {
      _id: "63701cc1f03239d81e00000e",
      name: "Berenice",
      email: "bpedgrift1w@europa.eu",
      password: "KwHuinZ1EKM",
      city: "Kusak",
      state: null,
      country: "RU",
      occupation: "Budget/Accounting Analyst I",
      phoneNumber: "3533101907",
      transactions: [
        "63701d74f03239db69000130",
        "63701d74f03239b7f700001a",
        "63701d74f032396b8e000021",
        "63701d74f032394c49000147",
        "63701d74f03239f09e0001a3",
        "63701d74f03239db69000141",
        "63701d74f03239d59100032e",
      ],
      role: "superadmin",
    },
    {
      _id: "63701cc1f03239d81e00000f",
      name: "Juan",
      email: "jtyre1x@biblegateway.com",
      password: "1SzKUUzdFZ0x",
      city: "Orleans",
      state: null,
      country: "BR",
      occupation: "Civil Engineer",
      phoneNumber: "3529096801",
      transactions: [
        "63701d74f03239569400001a",
        "63701d74f03239d40b000067",
        "63701d74f032399c0000013b",
        "63701d74f032395b33000157",
        "63701d74f03239528f000043",
        "63701d74f0323986f300013c",
        "63701d74f032398675000138",
        "63701d74f032390a34000332",
        "63701d74f032394c49000132",
      ],
      role: "admin",
    },
    {
      _id: "63701cc1f03239d81e000010",
      name: "Dael",
      email: "dheaton1y@php.net",
      password: "62nv1o",
      city: "Dongfanghong",
      state: null,
      country: "CN",
      occupation: "Engineer IV",
      phoneNumber: "2398256034",
      transactions: ["63701d74f03239b7f700003d", "63701d74f03239867500013f"],
      role: "user",
    },
    {
      _id: "63701cc1f03239d81e000011",
      name: "Creigh",
      email: "ckopta1z@weather.com",
      password: "OKFu5rviF",
      city: "Sandy Bay",
      state: null,
      country: "JM",
      occupation: "Automation Specialist II",
      phoneNumber: "6422803157",
      transactions: [
        "63701d74f03239d81e00002c",
        "63701d74f0323944410002f4",
        "63701d74f03239c72c0001b5",
        "63701d74f03239bef0000139",
        "63701d74f03239867500014c",
        "63701d74f03239d59100034a",
      ],
      role: "superadmin",
    },
    {
      _id: "63701cc1f03239d81e000012",
      name: "Ad",
      email: "aguare20@shinystat.com",
      password: "L0BIFD5IakBc",
      city: "Kadubera",
      state: null,
      country: "ID",
      occupation: "Librarian",
      phoneNumber: "7245543213",
      transactions: [
        "63701d74f03239b913000040",
        "63701d74f03239bef000013f",
        "63701d74f03239c72c000196",
        "63701d74f03239b7f700003c",
        "63701d74f03239d40b000083",
        "63701d74f032399c0000014d",
        "63701d74f0323944410002f9",
        "63701d74f03239b7f700002e",
      ],
      role: "user",
    },
    {
      _id: "63701cc1f03239d81e000013",
      name: "Pedro",
      email: "psplevins21@delicious.com",
      password: "bKVRSxbldcHH",
      city: "Preobrazhenka",
      state: null,
      country: "UA",
      occupation: "Electrical Engineer",
      phoneNumber: "9727176356",
      transactions: ["63701d74f0323986f3000143", "63701d74f032395694000022"],
      role: "user",
    },
    {
      _id: "63701cc1f03239d81e000014",
      name: "Grannie",
      email: "gstaton22@bluehost.com",
      password: "txoJym1U363",
      city: "Taboão da Serra",
      state: null,
      country: "BR",
      occupation: "VP Product Management",
      phoneNumber: "2336512526",
      transactions: [
        "63701d74f03239f09e0001ae",
        "63701d74f03239b91300003a",
        "63701d74f03239d591000344",
        "63701d74f032398675000133",
      ],
      role: "superadmin",
    },
    {
      _id: "63701cc1f032390a34000318",
      name: "Adan",
      email: "atheodore23@china.com.cn",
      password: "uJ3n7oROznmN",
      city: "Boncong",
      state: null,
      country: "ID",
      occupation: "Senior Financial Analyst",
      phoneNumber: "3363114409",
      transactions: ["63701d74f032396b8e000036", "63701d74f032396b8e00001a"],
      role: "admin",
    },
    {
      _id: "63701cc1f032390a34000319",
      name: "Wakefield",
      email: "wfri24@ovh.net",
      password: "FWpvBG",
      city: "Pantanal",
      state: null,
      country: "BR",
      occupation: "Structural Analysis Engineer",
      phoneNumber: "8867064598",
      transactions: ["63701d74f03239c72c0001aa", "63701d74f03239cdc5000044"],
      role: "admin",
    },
    {
      _id: "63701cc1f032390a3400031a",
      name: "Noami",
      email: "nsnoxell25@bing.com",
      password: "4nWHfBnL",
      city: "Margahayukencana",
      state: null,
      country: "ID",
      occupation: "Director of Sales",
      phoneNumber: "8921142758",
      transactions: [
        "63701d74f0323944410002f1",
        "63701d74f03239db6900012e",
        "63701d74f032399c00000132",
        "63701d74f0323986f3000150",
        "63701d74f032396b8e00003d",
        "63701d74f032395b33000131",
        "63701d74f03239528f000032",
      ],
      role: "superadmin",
    },
    {
      _id: "63701cc1f032390a3400031b",
      name: "Ina",
      email: "icooksey26@sfgate.com",
      password: "nkdwh8TvnhQ",
      city: "Outapi",
      state: null,
      country: "NA",
      occupation: "Registered Nurse",
      phoneNumber: "4006862957",
      transactions: ["63701d74f032399c00000147"],
      role: "user",
    },
    {
      _id: "63701cc1f032390a3400031c",
      name: "Donielle",
      email: "djeannin27@ebay.co.uk",
      password: "k88MiJtJ",
      city: "Sakaraha",
      state: null,
      country: "MG",
      occupation: "Civil Engineer",
      phoneNumber: "1939969138",
      transactions: ["63701d74f03239c72c0001a0", "63701d74f032396b8e000042"],
      role: "admin",
    },
    {
      _id: "63701cc1f032390a3400031d",
      name: "Rubi",
      email: "rtritton28@skype.com",
      password: "YLRuKAPSWu",
      city: "Damu",
      state: null,
      country: "CN",
      occupation: "Mechanical Systems Engineer",
      phoneNumber: "6981182224",
      transactions: [
        "63701d74f03239d40b000067",
        "63701d74f03239444100030d",
        "63701d74f0323986f3000142",
        "63701d74f03239b7f7000027",
      ],
      role: "superadmin",
    },
    {
      _id: "63701cc1f032390a3400031e",
      name: "Baxie",
      email: "bpentycost29@mashable.com",
      password: "3wXPmvUZ",
      city: "Gunungkencana",
      state: null,
      country: "ID",
      occupation: "Automation Specialist III",
      phoneNumber: "8117671938",
      transactions: [
        "63701d74f0323986f300014c",
        "63701d74f03239569400001b",
        "63701d74f03239d81e000043",
        "63701d74f0323986f3000134",
      ],
      role: "user",
    },
    {
      _id: "63701cc1f032390a3400031f",
      name: "Vidovic",
      email: "vralfe2a@icio.us",
      password: "sxeFizpMRz8",
      city: "Luleå",
      state: "BD",
      country: "SE",
      occupation: "Financial Analyst",
      phoneNumber: "6583737701",
      transactions: [
        "63701d74f03239db69000146",
        "63701d74f03239d591000349",
        "63701d74f032396b8e000043",
        "63701d74f0323986f300012e",
        "63701d74f03239d591000336",
        "63701d74f032394441000313",
        "63701d74f03239b91300001f",
        "63701d74f032394c4900014a",
        "63701d74f03239db69000159",
      ],
      role: "user",
    },
    {
      _id: "63701cc1f032390a34000320",
      name: "Raviv",
      email: "rbarbour2b@amazon.co.jp",
      password: "evZ8FG",
      city: "Mayrtup",
      state: null,
      country: "RU",
      occupation: "Technical Writer",
      phoneNumber: "3701230076",
      transactions: [
        "63701d74f03239db69000147",
        "63701d74f032394c4900014e",
        "63701d74f03239d59100034a",
        "63701d74f03239d59100034f",
        "63701d74f03239f09e0001ab",
        "63701d74f0323986f300013e",
      ],
      role: "user",
    },
    {
      _id: "63701cc1f032390a34000321",
      name: "Bailey",
      email: "btremblett2c@census.gov",
      password: "dHArqNqFk",
      city: "Geshan",
      state: null,
      country: "CN",
      occupation: "General Manager",
      phoneNumber: "1882605759",
      transactions: ["63701d74f03239d591000330", "63701d74f032399c00000153"],
      role: "user",
    },
    {
      _id: "63701cc1f032390a34000322",
      name: "Normand",
      email: "npollok2d@plala.or.jp",
      password: "Rz5uz4F8BeP5",
      city: "Samborondón",
      state: null,
      country: "EC",
      occupation: "Speech Pathologist",
      phoneNumber: "3148704138",
      transactions: [
        "63701d74f032390a3400033c",
        "63701d74f03239f09e0001a5",
        "63701d74f032396b8e000020",
        "63701d74f03239867500014c",
        "63701d74f03239d81e00001a",
        "63701d74f032395b3300014d",
        "63701d74f032394c4900015b",
      ],
      role: "user",
    },
    {
      _id: "63701cc1f032390a34000323",
      name: "Danna",
      email: "doshavlan2e@biblegateway.com",
      password: "cRmlahK1P",
      city: "Jdaidet el Matn",
      state: null,
      country: "LB",
      occupation: "Research Assistant I",
      phoneNumber: "9382253782",
      transactions: [
        "63701d74f03239db6900014a",
        "63701d74f032390a3400032f",
        "63701d74f0323986f300013a",
      ],
      role: "user",
    },
    {
      _id: "63701cc1f032390a34000324",
      name: "Roselia",
      email: "rwoonton2f@instagram.com",
      password: "78F0NR",
      city: "Montpellier",
      state: "A9",
      country: "FR",
      occupation: "Automation Specialist III",
      phoneNumber: "4508799028",
      transactions: [
        "63701d74f032394c49000134",
        "63701d74f03239b7f700001c",
        "63701d74f032395694000045",
        "63701d74f03239d81e00003d",
        "63701d74f03239db69000135",
        "63701d74f032399c0000014b",
        "63701d74f03239569400001a",
      ],
      role: "user",
    },
    {
      _id: "63701cc1f032390a34000325",
      name: "Martynne",
      email: "mfritter2g@google.ru",
      password: "idi4yUOLGK",
      city: "Renhe",
      state: null,
      country: "CN",
      occupation: "Financial Advisor",
      phoneNumber: "6224197604",
      transactions: [
        "63701d74f03239f09e000197",
        "63701d74f032399c00000157",
        "63701d74f03239d591000352",
      ],
      role: "user",
    },
    {
      _id: "63701cc1f032390a34000326",
      name: "Latia",
      email: "lfarrier2h@bravesites.com",
      password: "Xu9203L8Sg",
      city: "Moroni",
      state: null,
      country: "KM",
      occupation: "Executive Secretary",
      phoneNumber: "9419588325",
      transactions: [
        "63701d74f032396b8e000028",
        "63701d74f03239d40b000083",
        "63701d74f03239b7f700003b",
        "63701d74f032399c00000159",
        "63701d74f03239f09e0001b5",
        "63701d74f032399c0000015b",
        "63701d74f032390a34000331",
        "63701d74f03239db69000155",
        "63701d74f03239b7f700002b",
        "63701d74f03239d40b000060",
      ],
      role: "user",
    },
    {
      _id: "63701cc1f032395b3300011b",
      name: "Ariela",
      email: "aepinoy2i@imdb.com",
      password: "M2dUoTH",
      city: "Mutā Khān",
      state: null,
      country: "AF",
      occupation: "Editor",
      phoneNumber: "1985831106",
      transactions: ["63701d74f03239c72c0001b2", "63701d74f03239bef000012f"],
      role: "user",
    },
    {
      _id: "63701cc1f032395b3300011c",
      name: "Farr",
      email: "fcahn2j@e-recht24.de",
      password: "W58OwTJiC",
      city: "Lushuihe",
      state: null,
      country: "CN",
      occupation: "Tax Accountant",
      phoneNumber: "7095138328",
      transactions: [
        "63701d74f03239d40b00007a",
        "63701d74f03239d81e000046",
        "63701d74f03239528f000037",
        "63701d74f03239db69000137",
        "63701d74f03239cdc500002d",
        "63701d74f032396b8e000023",
      ],
      role: "admin",
    },
    {
      _id: "63701cc1f032395b3300011d",
      name: "Jehu",
      email: "jvitall2k@behance.net",
      password: "Z33ZpDgTR",
      city: "Waterloo",
      state: "QC",
      country: "CA",
      occupation: "Teacher",
      phoneNumber: "1999229985",
      transactions: [
        "63701d74f032396b8e000035",
        "63701d74f0323986f3000153",
        "63701d74f032398675000143",
        "63701d74f032390a34000357",
        "63701d74f03239d81e000020",
      ],
      role: "admin",
    },
    {
      _id: "63701cc1f032395b3300011e",
      name: "Rosemary",
      email: "rseden2l@aboutads.info",
      password: "vSfBeEJmd",
      city: "Gondifelos",
      state: "03",
      country: "PT",
      occupation: "Financial Analyst",
      phoneNumber: "3121990932",
      transactions: ["63701d74f03239bef0000158", "63701d74f03239cdc500001f"],
      role: "user",
    },
    {
      _id: "63701cc1f032395b3300011f",
      name: "June",
      email: "jhornig2m@webnode.com",
      password: "VKK2BM",
      city: "Lukhovka",
      state: null,
      country: "RU",
      occupation: "Safety Technician II",
      phoneNumber: "6898002758",
      transactions: ["63701d74f03239c72c0001ba", "63701d74f032395694000037"],
      role: "superadmin",
    },
    {
      _id: "63701cc1f032395b33000120",
      name: "Reggie",
      email: "rlynagh2n@rediff.com",
      password: "8SHPGTq55uP",
      city: "Dohār",
      state: null,
      country: "BD",
      occupation: "Sales Associate",
      phoneNumber: "7786587768",
      transactions: [
        "63701d74f03239db69000133",
        "63701d74f03239d591000339",
        "63701d74f03239f09e0001a4",
        "63701d74f032399c00000133",
        "63701d74f03239528f000040",
        "63701d74f032396b8e00002a",
        "63701d74f03239b913000025",
        "63701d74f03239569400001a",
        "63701d74f03239cdc500001d",
        "63701d74f03239d40b00006f",
      ],
      role: "admin",
    },
    {
      _id: "63701cc1f032395b33000121",
      name: "Darcy",
      email: "dfrancie2o@infoseek.co.jp",
      password: "ITUsiwYCSe",
      city: "Huesca",
      state: "AR",
      country: "ES",
      occupation: "Systems Administrator I",
      phoneNumber: "7416440343",
      transactions: [
        "63701d74f03239d81e00002f",
        "63701d74f03239528f000039",
        "63701d74f03239f09e0001aa",
        "63701d74f03239528f000046",
        "63701d74f03239f09e000197",
        "63701d74f03239b7f7000046",
        "63701d74f032394441000316",
        "63701d74f032398675000154",
      ],
      role: "superadmin",
    },
    {
      _id: "63701cc1f032395b33000122",
      name: "Gilemette",
      email: "gkitney2p@salon.com",
      password: "Y4nNPJIqUc",
      city: "Kasturi",
      state: null,
      country: "ID",
      occupation: "Project Manager",
      phoneNumber: "5779240200",
      transactions: ["63701d74f03239d81e000026", "63701d74f032394441000315"],
      role: "admin",
    },
    {
      _id: "63701cc1f032395b33000123",
      name: "Marley",
      email: "mbottomer2q@netlog.com",
      password: "qvtTuRh1XC",
      city: "Shuanghe",
      state: null,
      country: "CN",
      occupation: "GIS Technical Architect",
      phoneNumber: "6724144982",
      transactions: [
        "63701d74f0323986f300015a",
        "63701d74f03239b7f7000026",
        "63701d74f03239cdc500003b",
        "63701d74f0323986f3000154",
        "63701d74f032399c00000159",
        "63701d74f03239d40b00005e",
        "63701d74f032395b3300013f",
      ],
      role: "user",
    },
    {
      _id: "63701cc1f032395b33000124",
      name: "Daune",
      email: "dfeetham2r@ca.gov",
      password: "S18btJ",
      city: "Keffi",
      state: null,
      country: "NG",
      occupation: "Nurse",
      phoneNumber: "1187156433",
      transactions: [
        "63701d74f03239528f000035",
        "63701d74f03239b913000046",
        "63701d74f032396b8e00003d",
        "63701d74f03239d40b000085",
        "63701d74f032394c49000151",
      ],
      role: "admin",
    },
    {
      _id: "63701cc1f032395b33000125",
      name: "Reese",
      email: "rsturridge2s@posterous.com",
      password: "YYXxL9QA8Bi",
      city: "Guanli",
      state: null,
      country: "CN",
      occupation: "Biostatistician I",
      phoneNumber: "6033400991",
      transactions: [
        "63701d74f03239b7f7000034",
        "63701d74f032394c49000135",
        "63701d74f03239b7f7000021",
        "63701d74f03239b7f7000031",
        "63701d74f03239d591000345",
      ],
      role: "admin",
    },
    {
      _id: "63701cc1f032395b33000126",
      name: "Nanine",
      email: "ncockshot2t@aol.com",
      password: "4hF6YU9",
      city: "An Naşr",
      state: null,
      country: "PS",
      occupation: "Legal Assistant",
      phoneNumber: "6137536796",
      transactions: ["63701d74f03239528f000022", "63701d74f032390a3400033d"],
      role: "user",
    },
    {
      _id: "63701cc1f032395b33000127",
      name: "Holly-anne",
      email: "hvellden2u@canalblog.com",
      password: "td9XFYJyb",
      city: "Klatovy",
      state: null,
      country: "CZ",
      occupation: "Assistant Professor",
      phoneNumber: "3821687133",
      transactions: [
        "63701d74f032396b8e000029",
        "63701d74f032398675000157",
        "63701d74f03239f09e00019d",
        "63701d74f03239d40b000072",
        "63701d74f03239d591000352",
        "63701d74f03239f09e0001a5",
        "63701d74f032399c0000013a",
        "63701d74f03239c72c0001b4",
      ],
      role: "superadmin",
    },
    {
      _id: "63701cc1f032395b33000128",
      name: "Agna",
      email: "atoten2v@multiply.com",
      password: "KrMmUt4G",
      city: "Néa Smýrni",
      state: null,
      country: "GR",
      occupation: "Pharmacist",
      phoneNumber: "6037858916",
      transactions: [
        "63701d74f03239444100031b",
        "63701d74f03239b7f700003b",
        "63701d74f03239c72c0001ab",
        "63701d74f032398675000151",
        "63701d74f03239f09e0001bf",
        "63701d74f032395694000044",
      ],
      role: "admin",
    },
    {
      _id: "63701cc1f032395b33000129",
      name: "Marlie",
      email: "mkearey2w@netscape.com",
      password: "QfyGnAZuf77",
      city: "Tagbacan Ibaba",
      state: null,
      country: "PH",
      occupation: "Senior Quality Engineer",
      phoneNumber: "1852280527",
      transactions: [
        "63701d74f03239d40b00005b",
        "63701d74f03239569400001e",
        "63701d74f032398675000156",
        "63701d74f0323986f300012f",
        "63701d74f03239d81e00002d",
        "63701d74f03239528f00003a",
        "63701d74f03239f09e000195",
        "63701d74f03239c72c000197",
        "63701d74f0323944410002f8",
      ],
      role: "admin",
    },
    {
      _id: "63701cc1f03239d591000318",
      name: "Naoma",
      email: "nshutler2x@stanford.edu",
      password: "BDqrNY6",
      city: "Eisen",
      state: null,
      country: "KR",
      occupation: "Quality Control Specialist",
      phoneNumber: "9696292224",
      transactions: [
        "63701d74f03239db69000146",
        "63701d74f03239867500013c",
        "63701d74f032398675000134",
        "63701d74f032394c49000155",
      ],
      role: "admin",
    },
    {
      _id: "63701cc1f03239d591000319",
      name: "Nicholle",
      email: "nducarel2y@sourceforge.net",
      password: "Xto6DJlbDQW",
      city: "Ryazan’",
      state: null,
      country: "RU",
      occupation: "Safety Technician IV",
      phoneNumber: "1356228398",
      transactions: [
        "63701d74f03239d40b00008f",
        "63701d74f03239c72c00019a",
        "63701d74f032390a3400033d",
        "63701d74f03239bef0000140",
      ],
      role: "superadmin",
    },
    {
      _id: "63701cc1f03239d59100031a",
      name: "Trista",
      email: "tponter2z@dailymail.co.uk",
      password: "ci3nFCSgW",
      city: "Santo António",
      state: "18",
      country: "PT",
      occupation: "Sales Representative",
      phoneNumber: "1555067306",
      transactions: [
        "63701d74f0323986f3000130",
        "63701d74f03239528f00001f",
        "63701d74f032399c00000148",
        "63701d74f032396b8e000030",
        "63701d74f03239528f00002f",
        "63701d74f03239cdc5000044",
        "63701d74f032390a34000333",
      ],
      role: "superadmin",
    },
    {
      _id: "63701cc1f03239d59100031b",
      name: "Westleigh",
      email: "wmedlin30@newsvine.com",
      password: "63jUIO1",
      city: "Chum Phae",
      state: null,
      country: "TH",
      occupation: "Analog Circuit Design manager",
      phoneNumber: "5605137846",
      transactions: [
        "63701d74f03239bef0000137",
        "63701d74f032396b8e00003f",
        "63701d74f03239f09e0001aa",
        "63701d74f032395b33000130",
        "63701d74f03239528f00001c",
      ],
      role: "superadmin",
    },
    {
      _id: "63701cc1f03239d59100031c",
      name: "Rickert",
      email: "rliggins31@photobucket.com",
      password: "3QDXzlM77H0N",
      city: "Salavat",
      state: null,
      country: "RU",
      occupation: "Research Nurse",
      phoneNumber: "1041333724",
      transactions: [
        "63701d74f03239b913000038",
        "63701d74f03239f09e000193",
        "63701d74f03239d81e00003c",
        "63701d74f032395b33000158",
        "63701d74f032399c0000013f",
        "63701d74f03239bef0000131",
      ],
      role: "user",
    },
    {
      _id: "63701cc1f03239d59100031d",
      name: "Buckie",
      email: "bstuther32@dell.com",
      password: "7OD3NQJiGyE",
      city: "Sparks",
      state: "NV",
      country: "US",
      occupation: "VP Quality Control",
      phoneNumber: "7753956205",
      transactions: [
        "63701d74f03239867500014e",
        "63701d74f03239b7f700002a",
        "63701d74f03239c72c000198",
        "63701d74f032394c49000141",
      ],
      role: "superadmin",
    },
    {
      _id: "63701cc1f03239d59100031e",
      name: "Ryan",
      email: "rbourton33@sogou.com",
      password: "x9kJJU1RCQc",
      city: "Eadestown",
      state: null,
      country: "IE",
      occupation: "Staff Scientist",
      phoneNumber: "8117488476",
      transactions: [
        "63701d74f0323986f300012e",
        "63701d74f03239d40b00005e",
        "63701d74f032395694000044",
        "63701d74f032399c00000144",
        "63701d74f03239c72c0001b9",
        "63701d74f03239b913000042",
        "63701d74f03239528f00003c",
        "63701d74f032396b8e000021",
        "63701d74f032395b33000154",
        "63701d74f03239b7f7000030",
      ],
      role: "admin",
    },
    {
      _id: "63701cc1f03239d59100031f",
      name: "Lilian",
      email: "ldaines34@wordpress.com",
      password: "Te6Xd0",
      city: "Siqiao",
      state: null,
      country: "CN",
      occupation: "Accounting Assistant I",
      phoneNumber: "3718592948",
      transactions: [
        "63701d74f03239d40b000085",
        "63701d74f032396b8e000022",
        "63701d74f032390a34000343",
        "63701d74f03239db69000156",
        "63701d74f03239c72c0001a8",
        "63701d74f03239569400002a",
      ],
      role: "admin",
    },
    {
      _id: "63701cc1f03239d591000320",
      name: "Rene",
      email: "rhearnaman35@techcrunch.com",
      password: "lAV8WJRM",
      city: "Dongqu",
      state: null,
      country: "CN",
      occupation: "Analyst Programmer",
      phoneNumber: "9749285416",
      transactions: [
        "63701d74f03239cdc5000041",
        "63701d74f032396b8e00002d",
        "63701d74f03239b913000045",
        "63701d74f032395b33000134",
      ],
      role: "admin",
    },
    {
      _id: "63701cc1f03239d591000321",
      name: "Caesar",
      email: "cridwood36@w3.org",
      password: "axjZaQ6DR",
      city: "Mella",
      state: null,
      country: "DO",
      occupation: "Geological Engineer",
      phoneNumber: "5475430164",
      transactions: [
        "63701d74f03239c72c0001bb",
        "63701d74f032398675000142",
        "63701d74f03239b7f7000031",
        "63701d74f03239867500014d",
        "63701d74f03239f09e0001b3",
        "63701d74f03239b913000044",
        "63701d74f03239867500014f",
        "63701d74f03239cdc5000035",
        "63701d74f0323986f3000141",
      ],
      role: "user",
    },
    {
      _id: "63701cc1f03239d591000322",
      name: "Catriona",
      email: "cwormell37@prnewswire.com",
      password: "7Yo0coFxq",
      city: "Morrito",
      state: null,
      country: "NI",
      occupation: "Assistant Media Planner",
      phoneNumber: "5983301528",
      transactions: ["63701d74f032398675000133"],
      role: "superadmin",
    },
    {
      _id: "63701cc1f03239d591000323",
      name: "Constantino",
      email: "cmarcam38@opensource.org",
      password: "S7xFukckSS",
      city: "Gryfów Śląski",
      state: null,
      country: "PL",
      occupation: "Sales Representative",
      phoneNumber: "3253849168",
      transactions: [
        "63701d74f032399c0000014e",
        "63701d74f03239c72c000199",
        "63701d74f032396b8e00002a",
      ],
      role: "admin",
    },
    {
      _id: "63701cc1f03239d591000324",
      name: "Sarine",
      email: "sfaughnan39@homestead.com",
      password: "FTnB07H65C26",
      city: "Saint-Brieuc",
      state: "A2",
      country: "FR",
      occupation: "Administrative Officer",
      phoneNumber: "1704930868",
      transactions: ["63701d74f03239528f00001e"],
      role: "superadmin",
    },
    {
      _id: "63701cc1f03239d591000325",
      name: "Hobie",
      email: "hditt3a@eepurl.com",
      password: "1DtYlOGa",
      city: "Toba",
      state: null,
      country: "JP",
      occupation: "Senior Quality Engineer",
      phoneNumber: "3603446896",
      transactions: [
        "63701d74f032396b8e00003c",
        "63701d74f03239b91300001d",
        "63701d74f032398675000155",
        "63701d74f03239cdc500001b",
      ],
      role: "admin",
    },
    {
      _id: "63701cc1f03239d591000326",
      name: "Steward",
      email: "swoolford3b@blogspot.com",
      password: "YogoVS9wrgZ",
      city: "Charlton",
      state: "ENG",
      country: "GB",
      occupation: "Sales Associate",
      phoneNumber: "7072856622",
      transactions: [
        "63701d74f03239cdc5000038",
        "63701d74f03239d40b000060",
        "63701d74f03239db69000155",
        "63701d74f032395b33000141",
        "63701d74f032394c49000159",
        "63701d74f03239d40b000079",
        "63701d74f03239c72c0001a0",
      ],
      role: "user",
    },
    {
      _id: "63701cc1f032395694000006",
      name: "Randall",
      email: "rmathivat3c@yolasite.com",
      password: "siGOrj04Q",
      city: "Abiko",
      state: null,
      country: "JP",
      occupation: "VP Quality Control",
      phoneNumber: "8018242131",
      transactions: ["63701d74f03239d40b000088"],
      role: "superadmin",
    },
    {
      _id: "63701cc1f032395694000007",
      name: "Melloney",
      email: "mreynoldson3d@cmu.edu",
      password: "xOvuLdoie",
      city: "Fumin",
      state: null,
      country: "CN",
      occupation: "Programmer Analyst III",
      phoneNumber: "9953853099",
      transactions: ["63701d74f03239d81e000022", "63701d74f03239d591000356"],
      role: "user",
    },
    {
      _id: "63701cc1f032395694000008",
      name: "Onida",
      email: "oaherne3e@gmpg.org",
      password: "GKUSDad106",
      city: "Wum",
      state: null,
      country: "CM",
      occupation: "Developer III",
      phoneNumber: "7619742687",
      transactions: [
        "63701d74f03239bef0000148",
        "63701d74f03239444100031b",
        "63701d74f03239569400003d",
        "63701d74f03239db6900012f",
        "63701d74f0323986f300013c",
        "63701d74f03239f09e00019a",
        "63701d74f03239d40b000072",
        "63701d74f03239569400001e",
        "63701d74f03239528f000032",
        "63701d74f03239d40b00007c",
      ],
      role: "superadmin",
    },
    {
      _id: "63701cc1f032395694000009",
      name: "Winny",
      email: "wbicknell3f@taobao.com",
      password: "EJRM6LjGs",
      city: "Singgugu",
      state: null,
      country: "ID",
      occupation: "Electrical Engineer",
      phoneNumber: "2301162603",
      transactions: [
        "63701d74f032396b8e000035",
        "63701d74f03239d40b000064",
        "63701d74f03239c72c0001ab",
        "63701d74f03239867500013f",
        "63701d74f032395b33000134",
        "63701d74f03239d81e00001a",
        "63701d74f03239b913000022",
      ],
      role: "superadmin",
    },
    {
      _id: "63701cc1f03239569400000a",
      name: "Dunn",
      email: "dgores3g@marriott.com",
      password: "kM964VZQ5p",
      city: "Ala-Buka",
      state: null,
      country: "KG",
      occupation: "Paralegal",
      phoneNumber: "8256109065",
      transactions: ["63701d74f03239c72c000198", "63701d74f03239f09e0001ad"],
      role: "superadmin",
    },
    {
      _id: "63701cc1f03239569400000b",
      name: "Hamilton",
      email: "hrowledge3h@geocities.com",
      password: "xE5x1IlUV1jB",
      city: "Maputsoe",
      state: null,
      country: "LS",
      occupation: "Staff Scientist",
      phoneNumber: "6014630516",
      transactions: [
        "63701d74f03239d81e000046",
        "63701d74f03239b7f700001f",
        "63701d74f03239bef0000152",
        "63701d74f032399c00000149",
        "63701d74f03239d40b000067",
        "63701d74f032396b8e00001f",
        "63701d74f03239d81e00001b",
        "63701d74f03239d40b000071",
        "63701d74f03239d40b000080",
        "63701d74f032395694000033",
      ],
      role: "admin",
    },
    {
      _id: "63701cc1f03239569400000c",
      name: "Giorgio",
      email: "ghelin3i@youtube.com",
      password: "g7ry43mPzW",
      city: "Viljoenskroon",
      state: null,
      country: "ZA",
      occupation: "Geological Engineer",
      phoneNumber: "5699300741",
      transactions: [
        "63701d74f03239528f000043",
        "63701d74f03239bef0000145",
        "63701d74f03239cdc500003e",
        "63701d74f03239d591000353",
      ],
      role: "user",
    },
    {
      _id: "63701cc1f03239569400000d",
      name: "Devland",
      email: "ddennington3j@stumbleupon.com",
      password: "culgefrU",
      city: "Tiaong",
      state: null,
      country: "PH",
      occupation: "Nurse",
      phoneNumber: "7415327989",
      transactions: [
        "63701d74f032396b8e000020",
        "63701d74f032394441000317",
        "63701d74f032390a34000333",
        "63701d74f03239db6900013f",
        "63701d74f03239bef0000137",
        "63701d74f03239cdc5000045",
        "63701d74f032390a3400034a",
        "63701d74f0323986f300014f",
      ],
      role: "user",
    },
    {
      _id: "63701cc1f03239569400000e",
      name: "Barrett",
      email: "bchasle3k@jugem.jp",
      password: "qtZqLy",
      city: "Paclolo",
      state: null,
      country: "PH",
      occupation: "Web Developer II",
      phoneNumber: "2094454888",
      transactions: [
        "63701d74f03239528f00001e",
        "63701d74f03239b7f700001b",
        "63701d74f032390a3400032d",
      ],
      role: "superadmin",
    },
    {
      _id: "63701cc1f03239569400000f",
      name: "Kipp",
      email: "ksieve3l@elegantthemes.com",
      password: "1ZUpaYYgpN4q",
      city: "Aheloy",
      state: null,
      country: "BG",
      occupation: "Programmer III",
      phoneNumber: "2655848073",
      transactions: [
        "63701d74f03239528f00002e",
        "63701d74f03239f09e0001b2",
        "63701d74f032390a34000335",
        "63701d74f03239f09e0001a2",
        "63701d74f03239867500014a",
        "63701d74f03239d81e000044",
        "63701d74f0323986f3000149",
        "63701d74f03239db69000144",
        "63701d74f03239bef0000144",
      ],
      role: "user",
    },
    {
      _id: "63701cc1f032395694000010",
      name: "Luca",
      email: "llandreth3m@sfgate.com",
      password: "hmlKklk",
      city: "Breu",
      state: null,
      country: "PE",
      occupation: "Research Assistant III",
      phoneNumber: "6918035213",
      transactions: [
        "63701d74f0323986f3000154",
        "63701d74f03239c72c0001b5",
        "63701d74f03239569400002f",
        "63701d74f0323986f300014e",
        "63701d74f0323944410002f4",
        "63701d74f032394c4900014c",
      ],
      role: "admin",
    },
    {
      _id: "63701cc1f032395694000011",
      name: "Aline",
      email: "acrossby3n@telegraph.co.uk",
      password: "EigEwd1M",
      city: "Lengshuijing",
      state: null,
      country: "CN",
      occupation: "Technical Writer",
      phoneNumber: "3439067141",
      transactions: [
        "63701d74f0323986f3000131",
        "63701d74f032390a34000357",
        "63701d74f032395694000046",
        "63701d74f03239b913000029",
        "63701d74f03239c72c0001b1",
        "63701d74f03239b913000020",
        "63701d74f03239bef000014c",
        "63701d74f032394c4900013f",
        "63701d74f03239d81e000019",
        "63701d74f03239444100030e",
      ],
      role: "superadmin",
    },
    {
      _id: "63701cc1f032395694000012",
      name: "Emelen",
      email: "ependleberry3o@google.com.br",
      password: "iduXoB",
      city: "Darfield",
      state: null,
      country: "NZ",
      occupation: "Mechanical Systems Engineer",
      phoneNumber: "4482405446",
      transactions: [
        "63701d74f032398675000144",
        "63701d74f03239d59100033b",
        "63701d74f032394c4900014d",
        "63701d74f03239b91300002a",
        "63701d74f03239c72c0001be",
        "63701d74f032395b3300013a",
        "63701d74f032390a3400032e",
        "63701d74f0323986f300013d",
        "63701d74f03239c72c00019b",
        "63701d74f03239db6900015a",
      ],
      role: "user",
    },
    {
      _id: "63701cc1f032395694000013",
      name: "Tarrah",
      email: "tbussey3p@cloudflare.com",
      password: "c4HOhf24lu",
      city: "Kinlough",
      state: null,
      country: "IE",
      occupation: "Help Desk Operator",
      phoneNumber: "2339365013",
      transactions: [
        "63701d74f03239cdc5000036",
        "63701d74f03239bef000013b",
        "63701d74f03239b7f7000033",
        "63701d74f032399c0000014e",
        "63701d74f03239b7f7000040",
      ],
      role: "superadmin",
    },
    {
      _id: "63701cc1f032395694000014",
      name: "Hazel",
      email: "hlittlekit3q@smugmug.com",
      password: "jvVjNUYzxA",
      city: "Mariestad",
      state: "O",
      country: "SE",
      occupation: "Social Worker",
      phoneNumber: "8559449812",
      transactions: [
        "63701d74f03239867500014e",
        "63701d74f03239d81e00003a",
        "63701d74f03239f09e0001b4",
        "63701d74f03239b7f700003e",
        "63701d74f03239d591000349",
        "63701d74f032394c49000141",
        "63701d74f03239d81e000021",
      ],
      role: "superadmin",
    },
    {
      _id: "63701cc1f032396b8e000006",
      name: "Cassy",
      email: "cmardle3r@webmd.com",
      password: "5zJn7Ox",
      city: "Silae",
      state: null,
      country: "PH",
      occupation: "Assistant Media Planner",
      phoneNumber: "6306556173",
      transactions: [
        "63701d74f03239db69000133",
        "63701d74f03239528f000044",
        "63701d74f03239d81e000027",
      ],
      role: "user",
    },
    {
      _id: "63701cc1f032396b8e000007",
      name: "Felecia",
      email: "fofarris3s@yale.edu",
      password: "HFgT33jb",
      city: "Västerås",
      state: "U",
      country: "SE",
      occupation: "Marketing Assistant",
      phoneNumber: "4484662304",
      transactions: [
        "63701d74f03239c72c0001bf",
        "63701d74f032396b8e000023",
        "63701d74f03239d81e000033",
        "63701d74f0323986f3000151",
        "63701d74f032394c49000142",
        "63701d74f03239d591000351",
        "63701d74f03239528f000043",
        "63701d74f032390a34000354",
        "63701d74f0323986f300013f",
        "63701d74f03239f09e00019f",
      ],
      role: "admin",
    },
    {
      _id: "63701cc1f032396b8e000008",
      name: "Cathee",
      email: "cmccarrison3t@youtu.be",
      password: "4wC6xJZ6",
      city: "Yaojiagou",
      state: null,
      country: "CN",
      occupation: "Nurse Practicioner",
      phoneNumber: "2736698532",
      transactions: [
        "63701d74f03239d40b000069",
        "63701d74f03239d81e000025",
        "63701d74f03239d81e00001e",
      ],
      role: "superadmin",
    },
    {
      _id: "63701cc1f032396b8e000009",
      name: "Stevy",
      email: "smugglestone3u@icio.us",
      password: "SQWNnZ7xg",
      city: "La Libertad",
      state: null,
      country: "HN",
      occupation: "Operator",
      phoneNumber: "2732328689",
      transactions: [
        "63701d74f032395694000023",
        "63701d74f0323986f300013a",
        "63701d74f03239bef0000141",
        "63701d74f03239d81e00001c",
        "63701d74f032399c00000130",
      ],
      role: "superadmin",
    },
    {
      _id: "63701cc1f032396b8e00000a",
      name: "Salvador",
      email: "sspinelli3v@icq.com",
      password: "sR3JsfGn",
      city: "Yelets",
      state: null,
      country: "RU",
      occupation: "Software Engineer II",
      phoneNumber: "8921442343",
      transactions: [
        "63701d74f03239b913000044",
        "63701d74f03239b7f7000046",
        "63701d74f03239f09e0001b1",
        "63701d74f032394c4900014a",
        "63701d74f03239b7f7000039",
        "63701d74f032395b33000141",
        "63701d74f03239cdc5000044",
        "63701d74f032396b8e000029",
        "63701d74f03239444100030c",
      ],
      role: "superadmin",
    },
    {
      _id: "63701cc1f032396b8e00000b",
      name: "Lorena",
      email: "lneem3w@ucsd.edu",
      password: "pTeETT3UBT",
      city: "Chenchang",
      state: null,
      country: "CN",
      occupation: "Tax Accountant",
      phoneNumber: "4265153214",
      transactions: [
        "63701d74f032395b33000144",
        "63701d74f032390a34000341",
        "63701d74f03239c72c0001b7",
        "63701d74f03239c72c000192",
        "63701d74f03239528f000028",
      ],
      role: "superadmin",
    },
    {
      _id: "63701cc1f032396b8e00000c",
      name: "Virge",
      email: "vstevenson3x@stanford.edu",
      password: "s2Tnn6WAO0Am",
      city: "Megulung",
      state: null,
      country: "ID",
      occupation: "Registered Nurse",
      phoneNumber: "9605925245",
      transactions: [
        "63701d74f03239867500014e",
        "63701d74f032394441000313",
        "63701d74f03239b7f7000021",
        "63701d74f032396b8e000034",
        "63701d74f03239f09e0001b5",
        "63701d74f032395b3300015a",
        "63701d74f03239d40b000083",
      ],
      role: "user",
    },
    {
      _id: "63701cc1f032396b8e00000d",
      name: "Justine",
      email: "jkohneke3y@addthis.com",
      password: "fEUSPd0F",
      city: "Tangqian",
      state: null,
      country: "CN",
      occupation: "Account Executive",
      phoneNumber: "6615477949",
      transactions: [
        "63701d74f03239d40b00007c",
        "63701d74f032394441000304",
        "63701d74f0323986f3000146",
        "63701d74f0323986f3000133",
        "63701d74f032390a3400034c",
      ],
      role: "superadmin",
    },
    {
      _id: "63701cc1f032396b8e00000e",
      name: "Drucill",
      email: "dellingworth3z@alexa.com",
      password: "prdjVFT",
      city: "Soa",
      state: null,
      country: "ID",
      occupation: "Recruiting Manager",
      phoneNumber: "9031059880",
      transactions: [
        "63701d74f032396b8e00002e",
        "63701d74f03239d40b00005d",
        "63701d74f032390a34000350",
        "63701d74f03239cdc500003e",
        "63701d74f032395b33000159",
        "63701d74f03239528f000021",
        "63701d74f032395b33000138",
        "63701d74f03239bef0000158",
        "63701d74f032395b3300014c",
      ],
      role: "admin",
    },
    {
      _id: "63701cc1f032396b8e00000f",
      name: "Hughie",
      email: "hlowsely40@netlog.com",
      password: "PjkI7RoDLDg4",
      city: "Jubao",
      state: null,
      country: "CN",
      occupation: "VP Product Management",
      phoneNumber: "9343614857",
      transactions: [
        "63701d74f03239d81e000038",
        "63701d74f03239569400001e",
        "63701d74f03239528f000033",
        "63701d74f03239d40b00006e",
        "63701d74f0323944410002fb",
        "63701d74f03239b7f7000027",
        "63701d74f03239cdc5000035",
        "63701d74f03239f09e0001b3",
        "63701d74f03239d81e00002c",
      ],
      role: "superadmin",
    },
    {
      _id: "63701cc1f032396b8e000010",
      name: "Barbee",
      email: "bsleith41@indiatimes.com",
      password: "5q8c1w3cj5QV",
      city: "Bāsht",
      state: null,
      country: "IR",
      occupation: "Assistant Manager",
      phoneNumber: "6262613312",
      transactions: [
        "63701d74f032396b8e000024",
        "63701d74f03239528f000039",
        "63701d74f032394441000307",
        "63701d74f03239bef0000154",
        "63701d74f03239b913000021",
        "63701d74f032398675000143",
        "63701d74f03239f09e00019e",
        "63701d74f032399c00000139",
      ],
      role: "admin",
    },
    {
      _id: "63701cc1f032396b8e000011",
      name: "Ibbie",
      email: "ibelt42@marketwatch.com",
      password: "RR3uTU",
      city: "Guaraciaba do Norte",
      state: null,
      country: "BR",
      occupation: "Design Engineer",
      phoneNumber: "3371795826",
      transactions: [
        "63701d74f03239bef000012e",
        "63701d74f03239bef0000153",
        "63701d74f032394c49000136",
        "63701d74f03239f09e000198",
      ],
      role: "superadmin",
    },
    {
      _id: "63701cc1f032396b8e000012",
      name: "Kayne",
      email: "kfronks43@about.me",
      password: "OjxqE3fqmH",
      city: "Krasnohrad",
      state: null,
      country: "UA",
      occupation: "Community Outreach Specialist",
      phoneNumber: "3395557818",
      transactions: [
        "63701d74f032396b8e00003e",
        "63701d74f032396b8e000043",
        "63701d74f03239569400002d",
        "63701d74f032396b8e000039",
        "63701d74f03239d81e00001f",
        "63701d74f032396b8e00001b",
      ],
      role: "superadmin",
    },
    {
      _id: "63701cc1f032396b8e000013",
      name: "Gradeigh",
      email: "gonions44@utexas.edu",
      password: "M8OkFdv0a",
      city: "Hīsh",
      state: null,
      country: "SY",
      occupation: "Assistant Professor",
      phoneNumber: "1789497142",
      transactions: [
        "63701d74f0323986f3000139",
        "63701d74f03239d81e000024",
        "63701d74f03239f09e0001a0",
        "63701d74f032394c49000146",
        "63701d74f03239d81e00002f",
        "63701d74f032399c00000152",
        "63701d74f032395b33000150",
      ],
      role: "admin",
    },
    {
      _id: "63701cc1f032396b8e000014",
      name: "Bev",
      email: "bandriessen45@japanpost.jp",
      password: "zKd7mUrrHI",
      city: "Johnson City",
      state: "TN",
      country: "US",
      occupation: "VP Accounting",
      phoneNumber: "4238320854",
      transactions: [
        "63701d74f03239867500014f",
        "63701d74f03239db6900013b",
        "63701d74f032395694000030",
      ],
      role: "user",
    },
    {
      _id: "63701cc1f03239bef000011b",
      name: "Gaylord",
      email: "gkitteringham46@youku.com",
      password: "0MgXUN",
      city: "Ash Shajarah",
      state: null,
      country: "SY",
      occupation: "Social Worker",
      phoneNumber: "7859555742",
      transactions: [
        "63701d74f032390a3400034d",
        "63701d74f03239b91300002e",
        "63701d74f0323986f3000134",
        "63701d74f032399c00000142",
        "63701d74f03239f09e0001a3",
        "63701d74f032399c0000014b",
        "63701d74f032390a34000336",
        "63701d74f03239f09e0001bf",
        "63701d74f03239569400002a",
      ],
      role: "admin",
    },
    {
      _id: "63701cc1f03239bef000011c",
      name: "Terrance",
      email: "tcars47@smugmug.com",
      password: "JbUdjNEa",
      city: "Mazamet",
      state: "B3",
      country: "FR",
      occupation: "Payment Adjustment Coordinator",
      phoneNumber: "1465365517",
      transactions: [
        "63701d74f03239bef000015a",
        "63701d74f03239cdc500003a",
        "63701d74f03239cdc5000032",
        "63701d74f032390a34000337",
      ],
      role: "superadmin",
    },
    {
      _id: "63701cc1f03239bef000011d",
      name: "Melania",
      email: "mmenaul48@360.cn",
      password: "2zQ9orB",
      city: "E’zhou",
      state: null,
      country: "CN",
      occupation: "Mechanical Systems Engineer",
      phoneNumber: "4964737668",
      transactions: [
        "63701d74f03239d81e000036",
        "63701d74f03239569400003b",
        "63701d74f03239cdc500003f",
        "63701d74f03239f09e0001aa",
        "63701d74f03239528f000026",
        "63701d74f03239d81e00003f",
        "63701d74f032390a3400032e",
        "63701d74f03239d81e00001c",
      ],
      role: "admin",
    },
    {
      _id: "63701cc1f03239bef000011e",
      name: "Ferdie",
      email: "fanthon49@ed.gov",
      password: "9lAbUy",
      city: "København",
      state: "1084",
      country: "DK",
      occupation: "Senior Financial Analyst",
      phoneNumber: "5698456614",
      transactions: [
        "63701d74f032399c0000015b",
        "63701d74f03239d591000336",
        "63701d74f03239f09e0001b7",
        "63701d74f03239d81e000040",
        "63701d74f032390a34000334",
        "63701d74f03239db69000152",
        "63701d74f03239d591000335",
        "63701d74f03239bef000013a",
        "63701d74f032398675000141",
        "63701d74f03239bef0000156",
      ],
      role: "admin",
    },
    {
      _id: "63701cc1f03239bef000011f",
      name: "Jasmina",
      email: "jchatwood4a@istockphoto.com",
      password: "vL5A2uJ",
      city: "Guadalupe",
      state: "OAX",
      country: "MX",
      occupation: "Assistant Professor",
      phoneNumber: "4011804307",
      transactions: [
        "63701d74f03239d40b00008e",
        "63701d74f03239b7f700002b",
        "63701d74f03239c72c0001b2",
        "63701d74f0323986f3000158",
        "63701d74f03239d59100032f",
        "63701d74f03239d591000349",
      ],
      role: "admin",
    },
    {
      _id: "63701cc1f03239bef0000120",
      name: "Remy",
      email: "rwiseman4b@nymag.com",
      password: "I2ndvKcd4ADe",
      city: "Марино",
      state: null,
      country: "MK",
      occupation: "Computer Systems Analyst II",
      phoneNumber: "2414514554",
      transactions: [
        "63701d74f03239d40b000059",
        "63701d74f032395b3300015a",
        "63701d74f032394c49000133",
        "63701d74f03239b7f700003e",
        "63701d74f0323944410002f1",
      ],
      role: "user",
    },
    {
      _id: "63701cc1f03239bef0000121",
      name: "Costa",
      email: "cdayer4c@hatena.ne.jp",
      password: "Zn0O8SPY",
      city: "Malá Strana",
      state: null,
      country: "CZ",
      occupation: "Assistant Professor",
      phoneNumber: "4089485198",
      transactions: [
        "63701d74f03239f09e0001b8",
        "63701d74f03239d59100032b",
        "63701d74f03239f09e00019e",
        "63701d74f03239cdc500001f",
        "63701d74f032399c0000014a",
        "63701d74f032390a34000335",
        "63701d74f0323986f300014b",
        "63701d74f032399c0000013b",
        "63701d74f03239bef0000150",
      ],
      role: "user",
    },
    {
      _id: "63701cc1f03239bef0000122",
      name: "Anallese",
      email: "astollberg4d@flickr.com",
      password: "jBpneOlhg",
      city: "Pingle",
      state: null,
      country: "CN",
      occupation: "Sales Associate",
      phoneNumber: "9578254739",
      transactions: [
        "63701d74f03239c72c0001b0",
        "63701d74f03239b7f7000033",
        "63701d74f032394c49000148",
        "63701d74f032390a3400032c",
        "63701d74f03239bef000014b",
        "63701d74f03239d81e00002c",
        "63701d74f03239d59100034c",
        "63701d74f03239b91300002c",
        "63701d74f032394c4900013e",
        "63701d74f03239f09e0001a0",
      ],
      role: "user",
    },
    {
      _id: "63701cc1f03239bef0000123",
      name: "Whitney",
      email: "wbradshaw4e@hubpages.com",
      password: "tcmX48S",
      city: "Orléans",
      state: "A3",
      country: "FR",
      occupation: "Clinical Specialist",
      phoneNumber: "1931490915",
      transactions: [
        "63701d74f0323986f3000151",
        "63701d74f03239b7f7000045",
        "63701d74f0323986f300012e",
        "63701d74f032390a3400033c",
        "63701d74f032396b8e000036",
        "63701d74f03239cdc500001a",
        "63701d74f03239d81e000031",
        "63701d74f03239d591000340",
        "63701d74f03239528f00003d",
        "63701d74f032395b3300014b",
      ],
      role: "superadmin",
    },
    {
      _id: "63701cc1f03239bef0000124",
      name: "Sheffy",
      email: "svittore4f@google.de",
      password: "N2bbr5",
      city: "Calvário",
      state: "03",
      country: "PT",
      occupation: "Automation Specialist IV",
      phoneNumber: "3116252189",
      transactions: [
        "63701d74f03239b913000041",
        "63701d74f03239b7f7000043",
        "63701d74f032390a3400034b",
        "63701d74f03239b7f700003b",
        "63701d74f03239db6900014a",
        "63701d74f032395694000040",
        "63701d74f032394441000319",
        "63701d74f03239b7f7000026",
        "63701d74f032394441000310",
      ],
      role: "user",
    },
    {
      _id: "63701cc1f03239bef0000125",
      name: "Danette",
      email: "druter4g@bbb.org",
      password: "nMuzWfYIQphI",
      city: "Xiushi",
      state: null,
      country: "CN",
      occupation: "Safety Technician III",
      phoneNumber: "5498736984",
      transactions: ["63701d74f032399c00000156"],
      role: "user",
    },
    {
      _id: "63701cc1f03239bef0000126",
      name: "Kalina",
      email: "klhommee4h@who.int",
      password: "JtRw3O",
      city: "Wurigelebur",
      state: null,
      country: "ID",
      occupation: "Senior Developer",
      phoneNumber: "9499366779",
      transactions: ["63701d74f03239d81e000033", "63701d74f03239c72c0001a5"],
      role: "user",
    },
    {
      _id: "63701cc1f03239bef0000127",
      name: "Roseline",
      email: "rraycroft4i@indiatimes.com",
      password: "OvqxlzU",
      city: "Mayhan",
      state: null,
      country: "MN",
      occupation: "Marketing Assistant",
      phoneNumber: "4424591122",
      transactions: [
        "63701d74f03239b91300003d",
        "63701d74f03239f09e0001ba",
        "63701d74f03239867500013f",
        "63701d74f03239d59100033c",
      ],
      role: "admin",
    },
    {
      _id: "63701cc1f03239bef0000128",
      name: "Terence",
      email: "tdyhouse4j@whitehouse.gov",
      password: "ffwaZkz",
      city: "Lazaro Cardenas",
      state: "TAB",
      country: "MX",
      occupation: "Chief Design Engineer",
      phoneNumber: "8236731636",
      transactions: [
        "63701d74f032396b8e000033",
        "63701d74f03239d59100033f",
        "63701d74f03239d40b000067",
        "63701d74f032390a34000345",
        "63701d74f03239528f000044",
        "63701d74f03239db69000130",
        "63701d74f03239569400003e",
        "63701d74f03239d40b000072",
        "63701d74f032394441000303",
      ],
      role: "admin",
    },
    {
      _id: "63701cc1f03239bef0000129",
      name: "Haily",
      email: "hdurie4k@opensource.org",
      password: "2xQMMuqQklK",
      city: "Putatbasiun",
      state: null,
      country: "ID",
      occupation: "Assistant Media Planner",
      phoneNumber: "3708160950",
      transactions: [
        "63701d74f0323944410002f9",
        "63701d74f03239569400002e",
        "63701d74f03239b7f7000021",
        "63701d74f03239d40b00006f",
        "63701d74f032395b3300012f",
      ],
      role: "superadmin",
    },
    {
      _id: "63701cc1f032394c4900011b",
      name: "Joell",
      email: "jaldus4l@exblog.jp",
      password: "kibbK26n",
      city: "Chocianów",
      state: null,
      country: "PL",
      occupation: "Accounting Assistant I",
      phoneNumber: "1582510979",
      transactions: [
        "63701d74f03239c72c0001ba",
        "63701d74f032396b8e00003e",
        "63701d74f032395b33000136",
        "63701d74f0323986f3000136",
        "63701d74f0323944410002f1",
        "63701d74f03239528f000019",
      ],
      role: "admin",
    },
    {
      _id: "63701cc1f032394c4900011c",
      name: "Mindy",
      email: "mbestwerthick4m@over-blog.com",
      password: "Mef2ml",
      city: "Hannō",
      state: null,
      country: "JP",
      occupation: "Computer Systems Analyst II",
      phoneNumber: "8012406017",
      transactions: [
        "63701d74f032390a34000356",
        "63701d74f03239d591000332",
        "63701d74f03239867500014d",
        "63701d74f03239cdc5000034",
        "63701d74f032396b8e00002b",
        "63701d74f032390a3400033b",
      ],
      role: "user",
    },
    {
      _id: "63701cc1f032394c4900011d",
      name: "Lib",
      email: "lgutridge4n@cloudflare.com",
      password: "1uZqjLMsg",
      city: "Maki",
      state: null,
      country: "JP",
      occupation: "Financial Advisor",
      phoneNumber: "2309923598",
      transactions: [
        "63701d74f032394c49000151",
        "63701d74f032394c49000148",
        "63701d74f032390a34000333",
        "63701d74f03239bef000014c",
        "63701d74f03239569400001f",
      ],
      role: "user",
    },
    {
      _id: "63701cc1f032394c4900011e",
      name: "Melisa",
      email: "meagland4o@homestead.com",
      password: "9AaVQYZeSv",
      city: "Ouani",
      state: null,
      country: "KM",
      occupation: "Marketing Assistant",
      phoneNumber: "9251077758",
      transactions: [
        "63701d74f032399c00000138",
        "63701d74f03239bef000012e",
        "63701d74f03239bef000014e",
        "63701d74f03239d591000354",
        "63701d74f032399c00000151",
        "63701d74f032390a3400034f",
        "63701d74f03239cdc500002e",
        "63701d74f032395b33000147",
        "63701d74f03239569400002c",
      ],
      role: "admin",
    },
    {
      _id: "63701cc1f032394c4900011f",
      name: "Laurie",
      email: "lragg4p@paginegialle.it",
      password: "aw3d8uBd0ly",
      city: "Khoyniki",
      state: null,
      country: "BY",
      occupation: "Information Systems Manager",
      phoneNumber: "2275289998",
      transactions: ["63701d74f03239db69000137", "63701d74f032394c49000134"],
      role: "user",
    },
    {
      _id: "63701cc1f032394c49000120",
      name: "Seamus",
      email: "slabbati4q@hao123.com",
      password: "jIXcqz1dhEof",
      city: "Arnelas",
      state: "13",
      country: "PT",
      occupation: "Legal Assistant",
      phoneNumber: "9106965949",
      transactions: [
        "63701d74f032396b8e00001f",
        "63701d74f032394c4900015a",
        "63701d74f03239d591000347",
        "63701d74f032390a34000355",
      ],
      role: "admin",
    },
    {
      _id: "63701cc1f032394c49000121",
      name: "Clarissa",
      email: "cfarguhar4r@wunderground.com",
      password: "Oaeu2i",
      city: "Nizao",
      state: null,
      country: "DO",
      occupation: "Structural Analysis Engineer",
      phoneNumber: "2093465942",
      transactions: [
        "63701d74f032390a34000357",
        "63701d74f032396b8e000026",
        "63701d74f03239d591000351",
        "63701d74f032395694000020",
        "63701d74f032399c00000154",
      ],
      role: "user",
    },
    {
      _id: "63701cc1f032394c49000122",
      name: "Eldredge",
      email: "eokker4s@cnbc.com",
      password: "7ajSQnklyex",
      city: "Kuta",
      state: null,
      country: "NG",
      occupation: "Operator",
      phoneNumber: "7153715824",
      transactions: [
        "63701d74f03239f09e00019f",
        "63701d74f0323986f3000140",
        "63701d74f0323944410002fe",
      ],
      role: "superadmin",
    },
    {
      _id: "63701cc1f032394c49000123",
      name: "Stanislaw",
      email: "smeese4t@dot.gov",
      password: "CnrcjaTecsWg",
      city: "Pyatovskiy",
      state: null,
      country: "RU",
      occupation: "Desktop Support Technician",
      phoneNumber: "2856031437",
      transactions: [
        "63701d74f03239d81e000023",
        "63701d74f03239d81e000024",
        "63701d74f032399c00000141",
        "63701d74f0323986f3000144",
        "63701d74f032394c4900014f",
        "63701d74f03239d81e000039",
        "63701d74f03239528f000024",
        "63701d74f032394c49000135",
        "63701d74f03239d591000331",
      ],
      role: "superadmin",
    },
    {
      _id: "63701cc1f032394c49000124",
      name: "Cassius",
      email: "ccardiff4u@si.edu",
      password: "eoYmlT",
      city: "Soroti",
      state: null,
      country: "UG",
      occupation: "GIS Technical Architect",
      phoneNumber: "6789537591",
      transactions: ["63701d74f03239f09e0001aa"],
      role: "admin",
    },
    {
      _id: "63701cc1f032394c49000125",
      name: "Vlad",
      email: "vsackler4v@simplemachines.org",
      password: "UrG0pJLe",
      city: "Kiernozia",
      state: null,
      country: "PL",
      occupation: "Structural Analysis Engineer",
      phoneNumber: "2808160883",
      transactions: [
        "63701d74f03239d81e00002b",
        "63701d74f03239db69000143",
        "63701d74f032399c00000155",
      ],
      role: "admin",
    },
    {
      _id: "63701cc1f032394c49000126",
      name: "Rita",
      email: "rbrann4w@csmonitor.com",
      password: "8FgzHT",
      city: "Bowang",
      state: null,
      country: "CN",
      occupation: "Teacher",
      phoneNumber: "8182331761",
      transactions: ["63701d74f03239528f00003f"],
      role: "admin",
    },
    {
      _id: "63701cc1f032394c49000127",
      name: "Ianthe",
      email: "ikeeffe4x@indiatimes.com",
      password: "nHsjad98",
      city: "Sepekov",
      state: null,
      country: "CZ",
      occupation: "Food Chemist",
      phoneNumber: "1746964138",
      transactions: [
        "63701d74f032399c00000152",
        "63701d74f03239d81e000043",
        "63701d74f03239cdc5000027",
        "63701d74f032395b3300013e",
        "63701d74f032395694000036",
        "63701d74f03239bef0000140",
        "63701d74f03239528f000031",
      ],
      role: "user",
    },
    {
      _id: "63701cc1f032394c49000128",
      name: "Findley",
      email: "fmaccracken4y@1und1.de",
      password: "FMthqF75",
      city: "Canedo",
      state: "01",
      country: "PT",
      occupation: "Graphic Designer",
      phoneNumber: "4954233926",
      transactions: ["63701d74f0323986f3000158"],
      role: "admin",
    },
    {
      _id: "63701cc1f032394c49000129",
      name: "Myron",
      email: "mguilliland4z@woothemes.com",
      password: "tYZgNq5aIdS",
      city: "Al Ḩarāk",
      state: null,
      country: "SY",
      occupation: "Human Resources Assistant II",
      phoneNumber: "2194717059",
      transactions: [
        "63701d74f03239db6900014b",
        "63701d74f032395b33000152",
        "63701d74f03239528f00001b",
        "63701d74f03239c72c0001b2",
        "63701d74f03239cdc500002d",
      ],
      role: "superadmin",
    },
    {
      _id: "63701cc1f03239528f000006",
      name: "Melicent",
      email: "mvernazza50@nydailynews.com",
      password: "SR5Nd4WHr",
      city: "Longotea",
      state: null,
      country: "PE",
      occupation: "Statistician IV",
      phoneNumber: "5178518229",
      transactions: [
        "63701d74f03239db69000153",
        "63701d74f032395694000026",
        "63701d74f03239cdc500001d",
        "63701d74f03239b913000035",
        "63701d74f032394c4900015b",
        "63701d74f03239db69000156",
        "63701d74f032394c49000153",
        "63701d74f03239db6900014a",
        "63701d74f03239bef000014e",
      ],
      role: "admin",
    },
    {
      _id: "63701cc1f03239528f000007",
      name: "Wilhelm",
      email: "wwonter51@dion.ne.jp",
      password: "ZyH44FdQ1N",
      city: "Pathein",
      state: null,
      country: "MM",
      occupation: "Staff Scientist",
      phoneNumber: "8407684689",
      transactions: [
        "63701d74f03239528f00003c",
        "63701d74f03239b7f7000033",
        "63701d74f03239d81e000031",
        "63701d74f032398675000132",
        "63701d74f03239d40b000089",
        "63701d74f032390a3400033d",
        "63701d74f03239f09e0001a4",
      ],
      role: "superadmin",
    },
    {
      _id: "63701cc1f03239528f000008",
      name: "Alejandro",
      email: "awathell52@craigslist.org",
      password: "T1fePLCv3",
      city: "Taling Chan",
      state: null,
      country: "TH",
      occupation: "Account Executive",
      phoneNumber: "1151128382",
      transactions: [
        "63701d74f0323986f3000144",
        "63701d74f032394441000311",
        "63701d74f03239cdc5000022",
        "63701d74f03239528f000027",
        "63701d74f03239b7f7000024",
      ],
      role: "admin",
    },
    {
      _id: "63701cc1f03239528f000009",
      name: "Taffy",
      email: "tduthy53@mozilla.com",
      password: "UO2nBF2PG",
      city: "Yili",
      state: null,
      country: "CN",
      occupation: "Programmer III",
      phoneNumber: "5251776383",
      transactions: [
        "63701d74f03239cdc5000031",
        "63701d74f03239c72c0001a3",
        "63701d74f03239c72c0001b4",
        "63701d74f032399c00000133",
        "63701d74f032394c49000145",
        "63701d74f03239bef000013c",
        "63701d74f032395b33000130",
        "63701d74f032396b8e000041",
        "63701d74f03239b91300003d",
      ],
      role: "superadmin",
    },
    {
      _id: "63701cc1f03239528f00000a",
      name: "Margarita",
      email: "mnancarrow54@tinypic.com",
      password: "EohJN94F",
      city: "Haebaru",
      state: null,
      country: "JP",
      occupation: "Clinical Specialist",
      phoneNumber: "7552610177",
      transactions: ["63701d74f03239d591000330"],
      role: "admin",
    },
    {
      _id: "63701cc1f03239528f00000b",
      name: "Titos",
      email: "tsimkiss55@cocolog-nifty.com",
      password: "u4jf4zaUSx",
      city: "Caomiao",
      state: null,
      country: "CN",
      occupation: "VP Sales",
      phoneNumber: "3663656410",
      transactions: ["63701d74f03239d591000331", "63701d74f03239b7f700003c"],
      role: "user",
    },
    {
      _id: "63701cc1f03239528f00000c",
      name: "Delcine",
      email: "dcaton56@plala.or.jp",
      password: "RMJAwlLkrO6D",
      city: "Stockholm",
      state: "AB",
      country: "SE",
      occupation: "Senior Financial Analyst",
      phoneNumber: "1769093878",
      transactions: [
        "63701d74f032396b8e00003f",
        "63701d74f03239f09e00019d",
        "63701d74f03239d40b000063",
      ],
      role: "superadmin",
    },
    {
      _id: "63701cc1f03239528f00000d",
      name: "Zora",
      email: "zfratczak57@mail.ru",
      password: "VGPlFF",
      city: "Troitsk",
      state: null,
      country: "RU",
      occupation: "Structural Engineer",
      phoneNumber: "5823912564",
      transactions: ["63701d74f032396b8e000031", "63701d74f032399c0000014f"],
      role: "admin",
    },
    {
      _id: "63701cc1f03239528f00000e",
      name: "Connor",
      email: "cmonget58@technorati.com",
      password: "ckV0HOb1jd",
      city: "Mmathubudukwane",
      state: null,
      country: "BW",
      occupation: "Dental Hygienist",
      phoneNumber: "1084138384",
      transactions: [
        "63701d74f03239cdc500001f",
        "63701d74f03239d40b000061",
        "63701d74f032396b8e000028",
        "63701d74f03239db6900015a",
        "63701d74f032395694000024",
        "63701d74f03239f09e000198",
        "63701d74f032396b8e000044",
      ],
      role: "superadmin",
    },
    {
      _id: "63701cc1f03239528f00000f",
      name: "Mordy",
      email: "mfass59@skyrock.com",
      password: "d956iJrXt",
      city: "Kanturk",
      state: null,
      country: "IE",
      occupation: "Developer I",
      phoneNumber: "4125426191",
      transactions: [
        "63701d74f032399c00000152",
        "63701d74f03239db69000157",
        "63701d74f032394c49000143",
        "63701d74f03239db69000131",
        "63701d74f03239c72c000195",
        "63701d74f032398675000150",
      ],
      role: "admin",
    },
    {
      _id: "63701cc1f03239528f000010",
      name: "Murdock",
      email: "mdary5a@comsenz.com",
      password: "vOYXsMa",
      city: "Yancheng",
      state: null,
      country: "CN",
      occupation: "Librarian",
      phoneNumber: "7102447299",
      transactions: [
        "63701d74f032390a34000355",
        "63701d74f032394c4900015a",
        "63701d74f03239b7f700003a",
        "63701d74f032398675000157",
        "63701d74f03239d59100033a",
        "63701d74f03239528f000044",
        "63701d74f03239d591000335",
      ],
      role: "superadmin",
    },
    {
      _id: "63701cc1f03239528f000011",
      name: "Worthy",
      email: "wgawn5b@symantec.com",
      password: "zZ5h25",
      city: "Montpellier",
      state: "A9",
      country: "FR",
      occupation: "Technical Writer",
      phoneNumber: "2974742370",
      transactions: [
        "63701d74f03239d40b00005c",
        "63701d74f032395b33000139",
        "63701d74f032390a3400033f",
        "63701d74f032396b8e00003d",
        "63701d74f03239528f00002a",
        "63701d74f032395b3300014c",
        "63701d74f03239d59100034d",
        "63701d74f03239cdc500002a",
      ],
      role: "user",
    },
    {
      _id: "63701cc1f03239528f000012",
      name: "Olenolin",
      email: "olaverty5c@networkadvertising.org",
      password: "Ezd5bHCy",
      city: "Gopaan",
      state: null,
      country: "ID",
      occupation: "Analyst Programmer",
      phoneNumber: "2824294579",
      transactions: [
        "63701d74f03239f09e0001ba",
        "63701d74f03239528f000021",
        "63701d74f0323944410002f0",
        "63701d74f03239528f00001c",
        "63701d74f03239f09e0001b7",
        "63701d74f0323986f3000152",
      ],
      role: "user",
    },
    {
      _id: "63701cc1f03239528f000013",
      name: "Leilah",
      email: "lcrosse5d@google.com.hk",
      password: "sfFhchYqoJ6",
      city: "Turochak",
      state: null,
      country: "RU",
      occupation: "Information Systems Manager",
      phoneNumber: "2028158686",
      transactions: [
        "63701d74f03239bef000014b",
        "63701d74f032396b8e000026",
        "63701d74f032394c49000131",
      ],
      role: "user",
    },
    {
      _id: "63701cc1f03239528f000014",
      name: "Finley",
      email: "fgrieger5e@wikimedia.org",
      password: "azQNkwXmsfFl",
      city: "Yaroslavl",
      state: null,
      country: "RU",
      occupation: "Budget/Accounting Analyst III",
      phoneNumber: "6172153852",
      transactions: [
        "63701d74f03239528f00002f",
        "63701d74f03239c72c00019d",
        "63701d74f03239b7f700001f",
        "63701d74f03239444100030d",
        "63701d74f03239d81e000043",
        "63701d74f0323986f300014f",
        "63701d74f03239528f00001e",
        "63701d74f03239c72c0001b1",
        "63701d74f032394c49000136",
      ],
      role: "user",
    },
    {
      _id: "63701cc1f03239f09e00017f",
      name: "Leda",
      email: "lemery5f@xrea.com",
      password: "4A33FZ",
      city: "Merapit",
      state: null,
      country: "ID",
      occupation: "Speech Pathologist",
      phoneNumber: "4441745606",
      transactions: [
        "63701d74f032394c4900014f",
        "63701d74f032395b33000139",
        "63701d74f032395b33000137",
        "63701d74f032394441000303",
        "63701d74f03239b7f700003e",
      ],
      role: "user",
    },
    {
      _id: "63701cc1f03239f09e000180",
      name: "Oralle",
      email: "oclixby5g@instagram.com",
      password: "7GVtz79GSA",
      city: "Yajiwa",
      state: null,
      country: "NG",
      occupation: "Administrative Officer",
      phoneNumber: "2949542247",
      transactions: [
        "63701d74f03239b913000019",
        "63701d74f03239b7f7000029",
        "63701d74f032394c4900014c",
        "63701d74f03239f09e0001b4",
        "63701d74f03239f09e0001ae",
        "63701d74f03239f09e0001b7",
        "63701d74f0323986f3000145",
        "63701d74f03239db6900014d",
      ],
      role: "user",
    },
    {
      _id: "63701cc1f03239f09e000181",
      name: "Teodora",
      email: "tleyzell5h@cbsnews.com",
      password: "FQhIoy",
      city: "Mmathubudukwane",
      state: null,
      country: "BW",
      occupation: "Help Desk Operator",
      phoneNumber: "1173556780",
      transactions: ["63701d74f032398675000157"],
      role: "admin",
    },
    {
      _id: "63701cc1f03239f09e000182",
      name: "Muffin",
      email: "mdyble5i@loc.gov",
      password: "fawYMjt",
      city: "Ruy Barbosa",
      state: null,
      country: "BR",
      occupation: "Financial Analyst",
      phoneNumber: "4005528996",
      transactions: [
        "63701d74f03239b91300002b",
        "63701d74f032396b8e00002b",
        "63701d74f03239d59100034a",
        "63701d74f032394c49000134",
        "63701d74f032396b8e000038",
      ],
      role: "admin",
    },
    {
      _id: "63701cc1f03239f09e000183",
      name: "Lily",
      email: "lshackleton5j@hp.com",
      password: "K7PfmI8",
      city: "Châu Thành",
      state: null,
      country: "VN",
      occupation: "Senior Financial Analyst",
      phoneNumber: "1759249891",
      transactions: [
        "63701d74f032390a3400032f",
        "63701d74f03239d591000341",
        "63701d74f03239d591000346",
        "63701d74f032395b33000147",
        "63701d74f03239bef000013a",
        "63701d74f032390a3400034a",
        "63701d74f032396b8e000032",
      ],
      role: "superadmin",
    },
    {
      _id: "63701cc1f03239f09e000184",
      name: "Jenda",
      email: "jcromarty5k@infoseek.co.jp",
      password: "J0CkgoQfCAG",
      city: "Kupchino",
      state: null,
      country: "RU",
      occupation: "Engineer II",
      phoneNumber: "5133052964",
      transactions: [
        "63701d74f0323986f3000139",
        "63701d74f032396b8e000027",
        "63701d74f03239db69000146",
        "63701d74f03239d591000332",
        "63701d74f032395b33000145",
        "63701d74f03239528f000021",
        "63701d74f03239b7f7000025",
        "63701d74f032395b3300013c",
      ],
      role: "user",
    },
    {
      _id: "63701cc1f03239f09e000185",
      name: "Wenda",
      email: "wespinheira5l@bluehost.com",
      password: "ZsEWOWTsBd",
      city: "Rublëvo",
      state: null,
      country: "RU",
      occupation: "Budget/Accounting Analyst IV",
      phoneNumber: "7532752819",
      transactions: [
        "63701d74f03239c72c000199",
        "63701d74f032395b3300012f",
        "63701d74f032395694000043",
      ],
      role: "superadmin",
    },
    {
      _id: "63701cc1f03239f09e000186",
      name: "Banky",
      email: "bmacdermid5m@friendfeed.com",
      password: "1H8Fz5N3i",
      city: "Fengxizhai",
      state: null,
      country: "CN",
      occupation: "VP Sales",
      phoneNumber: "1549139775",
      transactions: [
        "63701d74f03239db6900013d",
        "63701d74f032394c4900013d",
        "63701d74f03239d40b00007a",
        "63701d74f03239d81e000030",
        "63701d74f032394441000312",
        "63701d74f03239c72c0001bd",
        "63701d74f03239528f000019",
        "63701d74f03239d81e000031",
      ],
      role: "user",
    },
    {
      _id: "63701cc1f03239f09e000187",
      name: "Philippa",
      email: "pbottinelli5n@aboutads.info",
      password: "vTZjKR",
      city: "Zhangting",
      state: null,
      country: "CN",
      occupation: "Data Coordiator",
      phoneNumber: "3105428793",
      transactions: [
        "63701d74f03239db69000159",
        "63701d74f03239528f000034",
        "63701d74f03239c72c000195",
        "63701d74f03239d59100033a",
        "63701d74f03239444100031b",
        "63701d74f03239f09e0001be",
        "63701d74f03239b913000025",
      ],
      role: "admin",
    },
    {
      _id: "63701cc1f03239f09e000188",
      name: "Uta",
      email: "ubrickhill5o@amazon.de",
      password: "GVmSGHJTk",
      city: "Jinglongqiao",
      state: null,
      country: "CN",
      occupation: "Web Designer IV",
      phoneNumber: "8757912496",
      transactions: [
        "63701d74f03239b91300001b",
        "63701d74f03239528f000038",
        "63701d74f032395694000032",
        "63701d74f03239b913000038",
        "63701d74f0323986f3000150",
        "63701d74f03239d40b000058",
        "63701d74f03239569400003f",
        "63701d74f032399c0000014e",
        "63701d74f032390a34000336",
      ],
      role: "user",
    },
    {
      _id: "63701cc1f03239f09e000189",
      name: "Leela",
      email: "lpietruschka5p@blog.com",
      password: "xt8ZJG8",
      city: "Bundoc",
      state: null,
      country: "PH",
      occupation: "Human Resources Manager",
      phoneNumber: "7699277602",
      transactions: ["63701d74f032395694000024", "63701d74f03239569400002c"],
      role: "admin",
    },
    {
      _id: "63701cc1f03239f09e00018a",
      name: "Franciska",
      email: "fhartzog5q@wsj.com",
      password: "Gbu0dgwBqM0",
      city: "Ashford",
      state: null,
      country: "IE",
      occupation: "Account Representative II",
      phoneNumber: "7229851270",
      transactions: ["63701d74f032394c49000131", "63701d74f032394441000301"],
      role: "superadmin",
    },
    {
      _id: "63701cc1f03239f09e00018b",
      name: "Jacquetta",
      email: "jphysick5r@nsw.gov.au",
      password: "diX6aKF2w",
      city: "Bīleh Savār",
      state: null,
      country: "IR",
      occupation: "Programmer Analyst III",
      phoneNumber: "9134600793",
      transactions: [
        "63701d74f032395694000044",
        "63701d74f03239d591000353",
        "63701d74f032390a34000337",
        "63701d74f032395b3300012e",
        "63701d74f03239d59100032f",
        "63701d74f032396b8e000025",
        "63701d74f032399c00000154",
        "63701d74f032395694000023",
      ],
      role: "admin",
    },
    {
      _id: "63701cc1f03239f09e00018c",
      name: "Myranda",
      email: "mandrewartha5s@biblegateway.com",
      password: "laXTNM6",
      city: "Aryiropoúlion",
      state: null,
      country: "GR",
      occupation: "Geological Engineer",
      phoneNumber: "1966060890",
      transactions: ["63701d74f03239b7f700002b"],
      role: "admin",
    },
    {
      _id: "63701cc1f03239f09e00018d",
      name: "Vonni",
      email: "vbestwall5t@twitpic.com",
      password: "IYHe7XPDvx",
      city: "Montpellier",
      state: "A9",
      country: "FR",
      occupation: "Media Manager II",
      phoneNumber: "2938795844",
      transactions: [
        "63701d74f0323986f300013e",
        "63701d74f03239db6900012e",
        "63701d74f032398675000134",
        "63701d74f03239d40b000084",
        "63701d74f03239d591000354",
        "63701d74f032395b33000157",
        "63701d74f03239b913000027",
        "63701d74f03239b913000023",
        "63701d74f03239d591000350",
      ],
      role: "admin",
    },
    {
      _id: "63701cc1f03239db6900011b",
      name: "Hilda",
      email: "hdarragon5u@slate.com",
      password: "4XZkipBg",
      city: "Santo Tomás",
      state: null,
      country: "CO",
      occupation: "Senior Sales Associate",
      phoneNumber: "9501955139",
      transactions: [
        "63701d74f032399c00000142",
        "63701d74f03239c72c00019b",
        "63701d74f03239db69000144",
        "63701d74f03239444100030e",
        "63701d74f03239867500013e",
        "63701d74f03239c72c0001a0",
        "63701d74f03239c72c000199",
      ],
      role: "superadmin",
    },
    {
      _id: "63701cc1f03239db6900011c",
      name: "Sigvard",
      email: "slacroce5v@nps.gov",
      password: "ELp5RYekdu",
      city: "Concepcion",
      state: null,
      country: "PH",
      occupation: "Graphic Designer",
      phoneNumber: "6651455730",
      transactions: [
        "63701d74f03239c72c0001b7",
        "63701d74f03239db69000152",
        "63701d74f03239d81e000040",
        "63701d74f032394c4900012f",
        "63701d74f0323944410002fe",
      ],
      role: "admin",
    },
    {
      _id: "63701cc1f03239db6900011d",
      name: "Burk",
      email: "bduplan5w@dion.ne.jp",
      password: "FHWVqL",
      city: "Pong",
      state: null,
      country: "TH",
      occupation: "Biostatistician III",
      phoneNumber: "6265850585",
      transactions: [
        "63701d74f03239b913000037",
        "63701d74f03239867500014d",
        "63701d74f03239d40b00007e",
        "63701d74f03239569400001d",
        "63701d74f032395694000026",
        "63701d74f03239d81e000041",
      ],
      role: "superadmin",
    },
    {
      _id: "63701cc1f03239db6900011e",
      name: "Artemas",
      email: "askym5x@yolasite.com",
      password: "COfBiI",
      city: "Al Jubayl",
      state: null,
      country: "SA",
      occupation: "Statistician I",
      phoneNumber: "1363061978",
      transactions: ["63701d74f032396b8e00003c", "63701d74f03239d81e00001e"],
      role: "user",
    },
    {
      _id: "63701cc1f03239db6900011f",
      name: "Patricio",
      email: "pjudron5y@marketwatch.com",
      password: "V0bw0d",
      city: "Bolszewo",
      state: null,
      country: "PL",
      occupation: "Nurse Practicioner",
      phoneNumber: "4261666753",
      transactions: [
        "63701d74f0323944410002fd",
        "63701d74f03239528f000033",
        "63701d74f0323986f3000158",
        "63701d74f03239528f000045",
        "63701d74f032390a3400034f",
        "63701d74f03239d81e000026",
        "63701d74f03239db6900013a",
        "63701d74f03239528f000040",
        "63701d74f03239bef0000151",
        "63701d74f03239cdc500003d",
      ],
      role: "admin",
    },
    {
      _id: "63701cc1f03239db69000120",
      name: "Bil",
      email: "bbickerdike5z@cnet.com",
      password: "eQUWtbbRo",
      city: "Goiás",
      state: null,
      country: "BR",
      occupation: "Help Desk Technician",
      phoneNumber: "8124690297",
      transactions: [
        "63701d74f03239b913000032",
        "63701d74f03239f09e0001ae",
        "63701d74f03239d40b00008f",
        "63701d74f03239c72c0001aa",
        "63701d74f032395694000038",
      ],
      role: "admin",
    },
    {
      _id: "63701cc1f03239db69000121",
      name: "Fayre",
      email: "flangstone60@jalbum.net",
      password: "1WtkPmy",
      city: "Sokoto",
      state: null,
      country: "NG",
      occupation: "Food Chemist",
      phoneNumber: "4354770989",
      transactions: [
        "63701d74f03239d59100033f",
        "63701d74f032398675000144",
        "63701d74f03239c72c000193",
        "63701d74f03239d40b00006b",
        "63701d74f03239f09e0001b0",
        "63701d74f03239444100030f",
        "63701d74f03239b7f7000043",
        "63701d74f03239d81e00003d",
        "63701d74f03239cdc5000035",
        "63701d74f03239bef000013d",
      ],
      role: "admin",
    },
    {
      _id: "63701cc1f03239db69000122",
      name: "Wendi",
      email: "wtwoohy61@tamu.edu",
      password: "vlEpEeI3OTU",
      city: "Pompano Beach",
      state: "FL",
      country: "US",
      occupation: "Recruiting Manager",
      phoneNumber: "7549360846",
      transactions: ["63701d74f03239b7f700003f", "63701d74f032395b33000147"],
      role: "user",
    },
    {
      _id: "63701cc1f03239db69000123",
      name: "Leshia",
      email: "ltomasz62@washingtonpost.com",
      password: "ARbjc1",
      city: "Margasana",
      state: null,
      country: "ID",
      occupation: "Recruiting Manager",
      phoneNumber: "6607612018",
      transactions: [
        "63701d74f03239528f000039",
        "63701d74f03239f09e00019a",
        "63701d74f03239f09e0001b4",
        "63701d74f032395694000033",
        "63701d74f03239db69000148",
        "63701d74f03239d40b00008d",
        "63701d74f032394441000300",
        "63701d74f03239867500012e",
        "63701d74f03239cdc5000031",
        "63701d74f03239d40b00005e",
      ],
      role: "admin",
    },
    {
      _id: "63701cc1f03239db69000124",
      name: "Levon",
      email: "lreader63@skype.com",
      password: "9LQ5wD",
      city: "Sobral",
      state: null,
      country: "BR",
      occupation: "Dental Hygienist",
      phoneNumber: "9878239334",
      transactions: [
        "63701d74f03239d591000333",
        "63701d74f03239867500014e",
        "63701d74f032395694000037",
        "63701d74f03239528f00002f",
      ],
      role: "admin",
    },
    {
      _id: "63701cc1f03239db69000125",
      name: "Raimund",
      email: "rhanbidge64@devhub.com",
      password: "MzDUcggLI",
      city: "Maduao",
      state: null,
      country: "PH",
      occupation: "Operator",
      phoneNumber: "7328227068",
      transactions: ["63701d74f0323986f3000144", "63701d74f03239f09e0001ad"],
      role: "superadmin",
    },
    {
      _id: "63701cc1f03239db69000126",
      name: "Sonnnie",
      email: "sburdess65@over-blog.com",
      password: "OnYtKa",
      city: "Yaozhanzi",
      state: null,
      country: "CN",
      occupation: "Software Test Engineer IV",
      phoneNumber: "6382906360",
      transactions: [
        "63701d74f03239528f00001e",
        "63701d74f03239569400003a",
        "63701d74f03239cdc5000019",
        "63701d74f03239569400001c",
      ],
      role: "superadmin",
    },
    {
      _id: "63701cc1f03239db69000127",
      name: "Othilie",
      email: "oemmott66@indiatimes.com",
      password: "i4f5UE",
      city: "Khiv",
      state: null,
      country: "RU",
      occupation: "Human Resources Manager",
      phoneNumber: "1742030156",
      transactions: [
        "63701d74f0323944410002f5",
        "63701d74f032396b8e000020",
        "63701d74f03239d81e00001f",
        "63701d74f03239c72c0001ba",
        "63701d74f03239d81e000028",
        "63701d74f0323986f300013f",
        "63701d74f03239d40b00007c",
        "63701d74f03239cdc500003c",
        "63701d74f03239db69000159",
        "63701d74f03239528f00002a",
      ],
      role: "admin",
    },
    {
      _id: "63701cc1f03239db69000128",
      name: "Gabriela",
      email: "gpretty67@prnewswire.com",
      password: "qG6KNu1",
      city: "Lubaczów",
      state: null,
      country: "PL",
      occupation: "Internal Auditor",
      phoneNumber: "9366408044",
      transactions: [
        "63701d74f032396b8e00001e",
        "63701d74f032399c00000152",
        "63701d74f03239db69000131",
        "63701d74f03239d81e000046",
      ],
      role: "admin",
    },
    {
      _id: "63701cc1f03239db69000129",
      name: "Melodie",
      email: "mbraganca68@globo.com",
      password: "tHHev45",
      city: "Jindaoxia",
      state: null,
      country: "CN",
      occupation: "Automation Specialist I",
      phoneNumber: "5008392811",
      transactions: [
        "63701d74f03239867500013f",
        "63701d74f03239528f00001d",
        "63701d74f03239b913000035",
        "63701d74f032394c49000156",
        "63701d74f032394c49000154",
        "63701d74f032390a3400034b",
        "63701d74f03239db6900012e",
        "63701d74f032399c00000146",
        "63701d74f032398675000149",
      ],
      role: "user",
    },
    {
      _id: "63701cc1f03239b913000006",
      name: "Gladys",
      email: "gmcgeraghty69@google.com.au",
      password: "18sGltgeVVA",
      city: "Bordeaux",
      state: "97",
      country: "FR",
      occupation: "Software Test Engineer III",
      phoneNumber: "5527391141",
      transactions: [
        "63701d74f03239c72c0001a3",
        "63701d74f03239bef000013e",
        "63701d74f032396b8e00003c",
        "63701d74f03239b7f7000040",
        "63701d74f032399c00000134",
      ],
      role: "superadmin",
    },
    {
      _id: "63701cc1f03239b913000007",
      name: "Venus",
      email: "vbenninger6a@flickr.com",
      password: "jZupjE",
      city: "Salinas",
      state: null,
      country: "PH",
      occupation: "Account Representative III",
      phoneNumber: "1405174082",
      transactions: ["63701d74f0323986f300015a"],
      role: "user",
    },
    {
      _id: "63701cc1f03239b913000008",
      name: "Cassaundra",
      email: "cpickard6b@guardian.co.uk",
      password: "7oFBm9",
      city: "Ōita",
      state: null,
      country: "JP",
      occupation: "Marketing Manager",
      phoneNumber: "8719646791",
      transactions: [
        "63701d74f03239b7f700001a",
        "63701d74f032395b33000142",
        "63701d74f03239528f000024",
      ],
      role: "superadmin",
    },
    {
      _id: "63701cc1f03239b913000009",
      name: "Grace",
      email: "glodge6c@pinterest.com",
      password: "HkgJLpuoDKP",
      city: "Danyang",
      state: null,
      country: "CN",
      occupation: "Automation Specialist III",
      phoneNumber: "6994420029",
      transactions: ["63701d74f032398675000132"],
      role: "superadmin",
    },
    {
      _id: "63701cc1f03239b91300000a",
      name: "Merrielle",
      email: "mdreus6d@altervista.org",
      password: "CEttQSx2W",
      city: "Jiabeiyan",
      state: null,
      country: "CN",
      occupation: "Technical Writer",
      phoneNumber: "2682969782",
      transactions: [
        "63701d74f03239b7f7000030",
        "63701d74f032399c00000156",
        "63701d74f03239d81e000040",
        "63701d74f032398675000130",
        "63701d74f03239b7f7000029",
        "63701d74f0323986f300012f",
        "63701d74f032395b33000149",
        "63701d74f032390a3400033c",
        "63701d74f03239d59100032c",
      ],
      role: "superadmin",
    },
    {
      _id: "63701cc1f03239b91300000b",
      name: "Derward",
      email: "dstannah6e@nbcnews.com",
      password: "HfVKoeDRlz9j",
      city: "Jieduo",
      state: null,
      country: "CN",
      occupation: "Account Coordinator",
      phoneNumber: "2403130928",
      transactions: [
        "63701d74f03239db69000150",
        "63701d74f032390a3400032d",
        "63701d74f03239d81e00001c",
        "63701d74f032394441000319",
        "63701d74f032396b8e000041",
        "63701d74f03239d591000341",
        "63701d74f03239444100031a",
        "63701d74f03239f09e000192",
      ],
      role: "superadmin",
    },
    {
      _id: "63701cc1f03239b91300000c",
      name: "Novelia",
      email: "ncossentine6f@free.fr",
      password: "bdhdWjbqdf3",
      city: "Banjarejo",
      state: null,
      country: "ID",
      occupation: "Office Assistant IV",
      phoneNumber: "9917697014",
      transactions: [
        "63701d74f03239cdc5000042",
        "63701d74f03239cdc500002f",
        "63701d74f032399c00000150",
        "63701d74f032395b33000155",
        "63701d74f03239b7f700002d",
        "63701d74f032395b3300014f",
      ],
      role: "superadmin",
    },
    {
      _id: "63701cc1f03239b91300000d",
      name: "Odo",
      email: "orochewell6g@dion.ne.jp",
      password: "dPF6mLBv0SuY",
      city: "Janiuay",
      state: null,
      country: "PH",
      occupation: "Nurse Practicioner",
      phoneNumber: "5203905716",
      transactions: [
        "63701d74f03239b7f7000041",
        "63701d74f03239528f00002b",
        "63701d74f032396b8e000028",
        "63701d74f03239c72c0001ad",
        "63701d74f032394c49000153",
        "63701d74f0323944410002f0",
        "63701d74f03239b91300003b",
        "63701d74f03239b913000038",
      ],
      role: "admin",
    },
    {
      _id: "63701cc1f03239b91300000e",
      name: "Torey",
      email: "twalcher6h@friendfeed.com",
      password: "A5buke",
      city: "Paris 19",
      state: "A8",
      country: "FR",
      occupation: "Marketing Manager",
      phoneNumber: "8607459755",
      transactions: [
        "63701d74f0323986f300013c",
        "63701d74f03239db6900013b",
        "63701d74f03239d591000335",
        "63701d74f03239c72c0001b5",
      ],
      role: "user",
    },
    {
      _id: "63701cc1f03239b91300000f",
      name: "Bryce",
      email: "basipenko6i@ebay.com",
      password: "7VKYN5h",
      city: "Raofeng",
      state: null,
      country: "CN",
      occupation: "Quality Engineer",
      phoneNumber: "8639238777",
      transactions: [
        "63701d74f03239d591000343",
        "63701d74f0323986f3000148",
        "63701d74f03239d40b00008f",
        "63701d74f03239b7f700003b",
      ],
      role: "superadmin",
    },
    {
      _id: "63701cc1f03239b913000010",
      name: "Freedman",
      email: "fhollingsby6j@moonfruit.com",
      password: "CQ2p8noYx",
      city: "Shisui",
      state: null,
      country: "JP",
      occupation: "Accounting Assistant I",
      phoneNumber: "4401038462",
      transactions: [
        "63701d74f03239bef0000139",
        "63701d74f03239b7f700002a",
        "63701d74f03239f09e0001bc",
        "63701d74f032398675000146",
        "63701d74f032394c49000144",
        "63701d74f032390a34000338",
      ],
      role: "user",
    },
    {
      _id: "63701cc1f03239b913000011",
      name: "Traci",
      email: "twilmore6k@csmonitor.com",
      password: "rf6p2O4",
      city: "Tulay na Lupa",
      state: null,
      country: "PH",
      occupation: "Biostatistician IV",
      phoneNumber: "8377177996",
      transactions: [
        "63701d74f03239d40b000061",
        "63701d74f03239db6900013f",
        "63701d74f032396b8e000019",
        "63701d74f03239d81e000025",
      ],
      role: "admin",
    },
    {
      _id: "63701cc1f03239b913000012",
      name: "Umberto",
      email: "ugrinyov6l@dropbox.com",
      password: "Wq0cc3",
      city: "Jinshan",
      state: null,
      country: "CN",
      occupation: "Food Chemist",
      phoneNumber: "3431559118",
      transactions: [
        "63701d74f032395b3300014a",
        "63701d74f03239d40b00006a",
        "63701d74f03239c72c00019a",
        "63701d74f03239d40b00005d",
        "63701d74f03239d591000334",
      ],
      role: "user",
    },
    {
      _id: "63701cc1f03239b913000013",
      name: "Honor",
      email: "hridoutt6m@networksolutions.com",
      password: "5I2Pe8",
      city: "Tyazhinskiy",
      state: null,
      country: "RU",
      occupation: "Environmental Specialist",
      phoneNumber: "8971477869",
      transactions: [
        "63701d74f0323986f300013e",
        "63701d74f0323944410002fb",
        "63701d74f03239b7f7000027",
        "63701d74f03239d59100032d",
        "63701d74f03239d40b000088",
      ],
      role: "admin",
    },
    {
      _id: "63701cc1f03239b913000014",
      name: "Daffy",
      email: "dveltmann6n@t-online.de",
      password: "DBQMiS0fN",
      city: "Karata",
      state: null,
      country: "RU",
      occupation: "Recruiting Manager",
      phoneNumber: "5344323867",
      transactions: [
        "63701d74f03239d591000344",
        "63701d74f032398675000143",
        "63701d74f032390a34000335",
        "63701d74f03239528f000031",
        "63701d74f03239db6900014d",
        "63701d74f03239bef000014c",
        "63701d74f03239b7f7000046",
        "63701d74f03239bef0000145",
        "63701d74f032395b3300013a",
        "63701d74f03239d591000333",
      ],
      role: "superadmin",
    },
    {
      _id: "63701cc1f03239cdc5000006",
      name: "Rachael",
      email: "rgoddman6o@mlb.com",
      password: "UG57wcIt7",
      city: "Río Guayabal de Yateras",
      state: null,
      country: "CU",
      occupation: "Senior Editor",
      phoneNumber: "1771102859",
      transactions: [
        "63701d74f03239b7f7000039",
        "63701d74f0323986f3000133",
        "63701d74f03239528f00003b",
      ],
      role: "superadmin",
    },
    {
      _id: "63701cc1f03239cdc5000007",
      name: "Juan",
      email: "jdewilde6p@cam.ac.uk",
      password: "PZYXE7ax",
      city: "Longqiao",
      state: null,
      country: "CN",
      occupation: "Registered Nurse",
      phoneNumber: "4314563977",
      transactions: ["63701d74f032399c0000012f", "63701d74f032390a34000350"],
      role: "user",
    },
    {
      _id: "63701cc1f03239cdc5000008",
      name: "Jecho",
      email: "jgolthorpp6q@quantcast.com",
      password: "6NqJWNf",
      city: "Krasnogvardeyets",
      state: null,
      country: "RU",
      occupation: "Financial Analyst",
      phoneNumber: "5978225150",
      transactions: [
        "63701d74f032396b8e000031",
        "63701d74f0323944410002f6",
        "63701d74f03239f09e0001a3",
        "63701d74f032399c0000015b",
        "63701d74f03239569400001f",
        "63701d74f03239c72c0001b9",
      ],
      role: "user",
    },
    {
      _id: "63701cc1f03239cdc5000009",
      name: "Shanda",
      email: "spumfrett6r@skyrock.com",
      password: "qwjl5mvTIUA",
      city: "Paratunka",
      state: null,
      country: "RU",
      occupation: "Senior Developer",
      phoneNumber: "8132295154",
      transactions: [
        "63701d74f03239cdc5000031",
        "63701d74f032398675000157",
        "63701d74f03239528f00003e",
      ],
      role: "admin",
    },
    {
      _id: "63701cc1f03239cdc500000a",
      name: "Tait",
      email: "tmartynka6s@linkedin.com",
      password: "heNoyOjX",
      city: "Cangkuang",
      state: null,
      country: "ID",
      occupation: "Assistant Manager",
      phoneNumber: "8138111612",
      transactions: [
        "63701d74f03239c72c0001a0",
        "63701d74f032390a34000333",
        "63701d74f03239b7f700003a",
        "63701d74f032399c00000139",
        "63701d74f03239c72c0001bd",
        "63701d74f03239d40b00005a",
      ],
      role: "admin",
    },
    {
      _id: "63701cc1f03239cdc500000b",
      name: "Helli",
      email: "hdmitr6t@harvard.edu",
      password: "EHv2GQ",
      city: "Jadi",
      state: null,
      country: "ID",
      occupation: "Junior Executive",
      phoneNumber: "2391023260",
      transactions: ["63701d74f032395b3300014a", "63701d74f03239d40b00008e"],
      role: "user",
    },
    {
      _id: "63701cc1f03239cdc500000c",
      name: "Christiane",
      email: "crenihan6u@utexas.edu",
      password: "T4atNfiQoC",
      city: "Joubb Jannîne",
      state: null,
      country: "LB",
      occupation: "Staff Accountant IV",
      phoneNumber: "8452757871",
      transactions: [
        "63701d74f032390a34000353",
        "63701d74f03239d59100032c",
        "63701d74f032399c00000145",
        "63701d74f03239db6900013a",
      ],
      role: "superadmin",
    },
    {
      _id: "63701cc1f03239cdc500000d",
      name: "Hurley",
      email: "htante6v@toplist.cz",
      password: "LYdD0i",
      city: "Vera",
      state: null,
      country: "AR",
      occupation: "Payment Adjustment Coordinator",
      phoneNumber: "4946177794",
      transactions: ["63701d74f03239f09e0001ae"],
      role: "user",
    },
    {
      _id: "63701cc1f03239cdc500000e",
      name: "Lammond",
      email: "lcoward6w@simplemachines.org",
      password: "fye3ajD6",
      city: "Vysočany",
      state: null,
      country: "CZ",
      occupation: "Software Test Engineer III",
      phoneNumber: "6319197062",
      transactions: [
        "63701d74f032390a34000336",
        "63701d74f03239db69000157",
        "63701d74f03239444100030a",
        "63701d74f03239cdc5000040",
        "63701d74f03239c72c0001a9",
        "63701d74f03239b7f7000020",
        "63701d74f0323986f300013d",
        "63701d74f03239cdc5000039",
        "63701d74f03239b91300002e",
      ],
      role: "superadmin",
    },
    {
      _id: "63701cc1f03239cdc500000f",
      name: "Keri",
      email: "kharrie6x@vinaora.com",
      password: "g2rp1kbSE",
      city: "Yatunpu",
      state: null,
      country: "CN",
      occupation: "Automation Specialist IV",
      phoneNumber: "6926244944",
      transactions: ["63701d74f032394c4900014a", "63701d74f03239528f00002c"],
      role: "admin",
    },
    {
      _id: "63701cc1f03239cdc5000010",
      name: "Kristopher",
      email: "kmoodie6y@4shared.com",
      password: "oF4TyvfF",
      city: "Stanišić",
      state: null,
      country: "RS",
      occupation: "Internal Auditor",
      phoneNumber: "7416336142",
      transactions: [
        "63701d74f03239b913000036",
        "63701d74f03239cdc5000036",
        "63701d74f032396b8e00002f",
        "63701d74f03239c72c0001b7",
        "63701d74f032399c00000131",
        "63701d74f032390a34000339",
        "63701d74f03239d40b00008b",
        "63701d74f03239bef000013d",
        "63701d74f032396b8e000038",
        "63701d74f03239cdc5000035",
      ],
      role: "superadmin",
    },
    {
      _id: "63701cc1f03239cdc5000011",
      name: "Marigold",
      email: "mbowller6z@sourceforge.net",
      password: "mKk4sHhRtOCS",
      city: "Wielka Wieś",
      state: null,
      country: "PL",
      occupation: "Environmental Specialist",
      phoneNumber: "6592858577",
      transactions: [
        "63701d74f032399c00000142",
        "63701d74f032395b3300015b",
        "63701d74f032394c49000155",
      ],
      role: "admin",
    },
    {
      _id: "63701cc1f03239cdc5000012",
      name: "Dirk",
      email: "dromain70@comsenz.com",
      password: "vVwud6Xeji9Z",
      city: "Zhongzhai",
      state: null,
      country: "CN",
      occupation: "Senior Editor",
      phoneNumber: "6617428670",
      transactions: [
        "63701d74f03239db69000140",
        "63701d74f03239c72c000199",
        "63701d74f03239d40b00005c",
        "63701d74f032399c00000133",
        "63701d74f032390a34000338",
      ],
      role: "admin",
    },
    {
      _id: "63701cc1f03239cdc5000013",
      name: "Faina",
      email: "fcaunt71@abc.net.au",
      password: "PRcPvQsyb",
      city: "Senovo",
      state: null,
      country: "SI",
      occupation: "Dental Hygienist",
      phoneNumber: "1415070380",
      transactions: [
        "63701d74f032399c0000013a",
        "63701d74f03239bef0000152",
        "63701d74f03239bef000014c",
        "63701d74f032390a3400033f",
        "63701d74f032398675000155",
        "63701d74f03239cdc500003a",
        "63701d74f032398675000151",
      ],
      role: "user",
    },
    {
      _id: "63701cc1f03239cdc5000014",
      name: "Wenona",
      email: "wmattisssen72@squidoo.com",
      password: "uv17LQLm",
      city: "Bahía Blanca",
      state: null,
      country: "AR",
      occupation: "Structural Engineer",
      phoneNumber: "7062098184",
      transactions: ["63701d74f032396b8e000040", "63701d74f03239b91300002d"],
      role: "user",
    },
    {
      _id: "63701cc1f032399c0000011b",
      name: "Andros",
      email: "awastie73@mapy.cz",
      password: "wXkNiGhehc1q",
      city: "Vale da Pedra",
      state: "10",
      country: "PT",
      occupation: "Statistician IV",
      phoneNumber: "2149891338",
      transactions: [
        "63701d74f03239b7f7000045",
        "63701d74f032398675000151",
        "63701d74f03239d591000349",
        "63701d74f0323986f3000138",
        "63701d74f0323986f3000157",
        "63701d74f03239bef0000143",
        "63701d74f03239528f000042",
        "63701d74f03239bef0000140",
        "63701d74f032390a34000330",
      ],
      role: "admin",
    },
    {
      _id: "63701cc1f032399c0000011c",
      name: "Doralin",
      email: "dleall74@photobucket.com",
      password: "YKkgQygCO",
      city: "Sacramento",
      state: "CA",
      country: "US",
      occupation: "Chief Design Engineer",
      phoneNumber: "9168358666",
      transactions: [
        "63701d74f03239d81e00001c",
        "63701d74f032399c00000151",
        "63701d74f03239d40b00006a",
        "63701d74f032395b3300014b",
      ],
      role: "superadmin",
    },
    {
      _id: "63701cc1f032399c0000011d",
      name: "Cynthea",
      email: "cbellwood75@cmu.edu",
      password: "QVo1Wn",
      city: "Jalgung",
      state: null,
      country: "ID",
      occupation: "Marketing Manager",
      phoneNumber: "5721620329",
      transactions: [
        "63701d74f0323986f3000137",
        "63701d74f03239c72c000193",
        "63701d74f03239d40b000063",
        "63701d74f03239b7f700002c",
        "63701d74f03239d81e000044",
        "63701d74f032395694000021",
        "63701d74f03239db6900014e",
        "63701d74f03239b91300001d",
        "63701d74f03239db69000137",
        "63701d74f03239c72c0001b3",
      ],
      role: "superadmin",
    },
    {
      _id: "63701cc1f032399c0000011e",
      name: "Aleece",
      email: "acashen76@narod.ru",
      password: "XpjUraCqjx9g",
      city: "Tomaszów Lubelski",
      state: null,
      country: "PL",
      occupation: "Software Engineer I",
      phoneNumber: "5624141422",
      transactions: [
        "63701d74f03239c72c0001be",
        "63701d74f032394c49000146",
        "63701d74f032394441000306",
        "63701d74f032394c49000154",
        "63701d74f032390a3400034c",
        "63701d74f03239528f000034",
        "63701d74f03239f09e0001ac",
        "63701d74f032395694000032",
        "63701d74f03239528f00003f",
        "63701d74f03239db6900014a",
      ],
      role: "user",
    },
    {
      _id: "63701cc1f032399c0000011f",
      name: "Zsazsa",
      email: "zmessenger77@cam.ac.uk",
      password: "xJAg4J",
      city: "Bagnolet",
      state: "A8",
      country: "FR",
      occupation: "General Manager",
      phoneNumber: "4367703353",
      transactions: [
        "63701d74f03239b913000034",
        "63701d74f03239c72c0001a8",
        "63701d74f03239d81e00003d",
        "63701d74f032394441000309",
        "63701d74f03239528f000037",
      ],
      role: "superadmin",
    },
    {
      _id: "63701cc1f032399c00000120",
      name: "Corbin",
      email: "cdienes78@facebook.com",
      password: "ZwRcxCor",
      city: "San Vicente",
      state: null,
      country: "PH",
      occupation: "Recruiter",
      phoneNumber: "5203611244",
      transactions: ["63701d74f03239d40b00008b", "63701d74f03239db69000145"],
      role: "admin",
    },
    {
      _id: "63701cc1f032399c00000121",
      name: "Aarika",
      email: "asmalley79@businessinsider.com",
      password: "vrf1gh8",
      city: "Weizheng",
      state: null,
      country: "CN",
      occupation: "Help Desk Operator",
      phoneNumber: "6796306973",
      transactions: [
        "63701d74f03239f09e0001a4",
        "63701d74f03239db6900013d",
        "63701d74f03239cdc500002c",
        "63701d74f03239db6900014d",
        "63701d74f03239b7f7000020",
        "63701d74f03239528f00003e",
      ],
      role: "superadmin",
    },
    {
      _id: "63701cc1f032399c00000122",
      name: "Bendix",
      email: "btwitching7a@vk.com",
      password: "0YLx0gBC",
      city: "Changdai",
      state: null,
      country: "CN",
      occupation: "Human Resources Manager",
      phoneNumber: "6342507788",
      transactions: [
        "63701d74f03239d40b000073",
        "63701d74f032394c49000145",
        "63701d74f03239d40b00006e",
        "63701d74f032396b8e00001a",
        "63701d74f032394c4900014b",
        "63701d74f03239f09e000196",
        "63701d74f032395694000041",
      ],
      role: "superadmin",
    },
    {
      _id: "63701cc1f032399c00000123",
      name: "Laurent",
      email: "lgarvin7b@macromedia.com",
      password: "iKXC61drX5Xn",
      city: "Dawuhan",
      state: null,
      country: "ID",
      occupation: "Marketing Manager",
      phoneNumber: "1194681935",
      transactions: [
        "63701d74f032399c00000147",
        "63701d74f03239bef0000148",
        "63701d74f032396b8e000029",
        "63701d74f032390a3400032f",
        "63701d74f032394c49000131",
      ],
      role: "user",
    },
    {
      _id: "63701cc1f032399c00000124",
      name: "Hamish",
      email: "hgodsell7c@diigo.com",
      password: "qAdkcLT",
      city: "Tabu",
      state: null,
      country: "ID",
      occupation: "Web Developer III",
      phoneNumber: "3014361855",
      transactions: [
        "63701d74f03239c72c0001a3",
        "63701d74f032390a34000344",
        "63701d74f03239db69000130",
        "63701d74f0323944410002f8",
        "63701d74f032390a34000349",
        "63701d74f03239444100031b",
      ],
      role: "admin",
    },
    {
      _id: "63701cc1f032399c00000125",
      name: "Cornelius",
      email: "cramsted7d@discovery.com",
      password: "TrUNV355z",
      city: "Mrongi Daja",
      state: null,
      country: "ID",
      occupation: "Software Consultant",
      phoneNumber: "6327630529",
      transactions: [
        "63701d74f0323986f300013b",
        "63701d74f03239cdc5000038",
        "63701d74f03239b7f700001e",
        "63701d74f03239d591000358",
        "63701d74f03239db69000144",
        "63701d74f03239db6900013e",
        "63701d74f03239b913000025",
        "63701d74f03239cdc5000034",
      ],
      role: "user",
    },
    {
      _id: "63701cc1f032399c00000126",
      name: "Nana",
      email: "nlydford7e@uiuc.edu",
      password: "a0deYJLsemel",
      city: "Krasnystaw",
      state: null,
      country: "PL",
      occupation: "Business Systems Development Analyst",
      phoneNumber: "3848778104",
      transactions: ["63701d74f03239cdc500003b", "63701d74f03239d40b000089"],
      role: "user",
    },
    {
      _id: "63701cc1f032399c00000127",
      name: "Leoline",
      email: "lbeckenham7f@elegantthemes.com",
      password: "EAWCcI3E",
      city: "Gotputuk",
      state: null,
      country: "ID",
      occupation: "Analyst Programmer",
      phoneNumber: "2095279022",
      transactions: [
        "63701d74f032394441000307",
        "63701d74f03239d591000335",
        "63701d74f032395b33000152",
        "63701d74f032390a34000332",
        "63701d74f032396b8e000045",
        "63701d74f03239f09e000195",
        "63701d74f032395b33000138",
        "63701d74f032395694000028",
        "63701d74f03239b7f700002f",
        "63701d74f03239d591000331",
      ],
      role: "admin",
    },
    {
      _id: "63701cc1f032399c00000128",
      name: "Angelita",
      email: "alumbley7g@privacy.gov.au",
      password: "WL1lXbGd",
      city: "San Antonio",
      state: null,
      country: "AR",
      occupation: "Desktop Support Technician",
      phoneNumber: "6601817739",
      transactions: ["63701d74f0323986f300014d"],
      role: "superadmin",
    },
    {
      _id: "63701cc1f032399c00000129",
      name: "Noemi",
      email: "npether7h@netlog.com",
      password: "JaOsVjBbV",
      city: "Sigay",
      state: null,
      country: "PH",
      occupation: "Software Test Engineer IV",
      phoneNumber: "7542221334",
      transactions: ["63701d74f032394c49000151", "63701d74f03239d40b000080"],
      role: "superadmin",
    },
    {
      _id: "63701cc1f0323986f300011b",
      name: "Benita",
      email: "blackham7i@netlog.com",
      password: "xQbtTsiC",
      city: "Shangzhang",
      state: null,
      country: "CN",
      occupation: "VP Sales",
      phoneNumber: "4102440627",
      transactions: [
        "63701d74f032395b33000145",
        "63701d74f0323986f3000148",
        "63701d74f0323944410002f4",
      ],
      role: "admin",
    },
    {
      _id: "63701cc1f0323986f300011c",
      name: "Faustina",
      email: "fdunridge7j@unicef.org",
      password: "Ma2OZtY",
      city: "Shënmëri",
      state: null,
      country: "AL",
      occupation: "Quality Engineer",
      phoneNumber: "2264803495",
      transactions: [
        "63701d74f03239bef0000132",
        "63701d74f0323986f3000133",
        "63701d74f032395694000038",
        "63701d74f03239d40b00008e",
        "63701d74f03239b7f700003f",
        "63701d74f03239db69000147",
        "63701d74f03239b91300002a",
        "63701d74f032399c0000015a",
        "63701d74f03239f09e0001b2",
        "63701d74f03239867500014b",
      ],
      role: "user",
    },
    {
      _id: "63701cc1f0323986f300011d",
      name: "Katya",
      email: "kbavidge7k@mtv.com",
      password: "Y6G5BWAusz1L",
      city: "Huazhai",
      state: null,
      country: "CN",
      occupation: "VP Marketing",
      phoneNumber: "3099635129",
      transactions: [
        "63701d74f03239c72c0001a4",
        "63701d74f03239cdc500003a",
        "63701d74f03239db6900015b",
        "63701d74f03239b7f7000041",
      ],
      role: "user",
    },
    {
      _id: "63701cc1f0323986f300011e",
      name: "Justino",
      email: "jrymmer7l@about.com",
      password: "z8qIusarhGd",
      city: "Nepalgunj",
      state: null,
      country: "NP",
      occupation: "Marketing Assistant",
      phoneNumber: "7006762962",
      transactions: [
        "63701d74f03239cdc5000041",
        "63701d74f032390a34000345",
        "63701d74f032395694000029",
        "63701d74f03239b7f7000029",
        "63701d74f03239569400003a",
      ],
      role: "user",
    },
    {
      _id: "63701cc1f0323986f300011f",
      name: "Nike",
      email: "nhawkey7m@livejournal.com",
      password: "4Whw8HVfTa",
      city: "Czerniewice",
      state: null,
      country: "PL",
      occupation: "Librarian",
      phoneNumber: "4358315887",
      transactions: [
        "63701d74f03239b7f700001c",
        "63701d74f03239f09e000198",
        "63701d74f032396b8e000044",
      ],
      role: "superadmin",
    },
    {
      _id: "63701cc1f0323986f3000120",
      name: "Lottie",
      email: "lhamments7n@addthis.com",
      password: "oDl4KvKd",
      city: "Puubheto",
      state: null,
      country: "ID",
      occupation: "Research Associate",
      phoneNumber: "5967332894",
      transactions: [
        "63701d74f03239cdc5000031",
        "63701d74f03239d81e000038",
        "63701d74f03239bef0000133",
        "63701d74f03239cdc500003f",
        "63701d74f03239b7f700001e",
        "63701d74f03239bef0000139",
        "63701d74f032399c0000015b",
        "63701d74f032396b8e000032",
      ],
      role: "superadmin",
    },
    {
      _id: "63701cc1f0323986f3000121",
      name: "Stefa",
      email: "sghiroldi7o@cargocollective.com",
      password: "mrk4M9VD1T",
      city: "Kurayyimah",
      state: null,
      country: "JO",
      occupation: "Staff Scientist",
      phoneNumber: "9187433652",
      transactions: [
        "63701d74f032394c4900015b",
        "63701d74f03239d81e00002f",
        "63701d74f0323986f300013a",
      ],
      role: "admin",
    },
    {
      _id: "63701cc1f0323986f3000122",
      name: "Alysa",
      email: "agoad7p@xrea.com",
      password: "0fSpamg",
      city: "Luodian",
      state: null,
      country: "CN",
      occupation: "Desktop Support Technician",
      phoneNumber: "1509929715",
      transactions: [
        "63701d74f03239db6900014c",
        "63701d74f03239db69000152",
        "63701d74f032399c0000014e",
        "63701d74f03239bef0000135",
        "63701d74f032390a34000343",
        "63701d74f03239f09e00019e",
        "63701d74f032394c4900013e",
        "63701d74f03239bef000013a",
        "63701d74f03239d40b000060",
      ],
      role: "user",
    },
    {
      _id: "63701cc1f0323986f3000123",
      name: "Drucill",
      email: "dkochel7q@gizmodo.com",
      password: "6V5SrnjSeg7",
      city: "Ratíškovice",
      state: null,
      country: "CZ",
      occupation: "Account Coordinator",
      phoneNumber: "9993343715",
      transactions: [
        "63701d74f03239db6900014d",
        "63701d74f03239f09e00019d",
        "63701d74f032399c00000156",
        "63701d74f032398675000151",
        "63701d74f032395694000044",
        "63701d74f032390a34000351",
        "63701d74f032394441000302",
        "63701d74f03239bef0000147",
      ],
      role: "admin",
    },
    {
      _id: "63701cc1f0323986f3000124",
      name: "Marleen",
      email: "mdunseath7r@hostgator.com",
      password: "suBr8XVI3",
      city: "Hopetown",
      state: null,
      country: "ZA",
      occupation: "Analog Circuit Design manager",
      phoneNumber: "7157474501",
      transactions: [
        "63701d74f03239c72c0001a5",
        "63701d74f032395694000024",
        "63701d74f03239d40b000089",
      ],
      role: "user",
    },
    {
      _id: "63701cc1f0323986f3000125",
      name: "Jessy",
      email: "jcapnerhurst7s@cyberchimps.com",
      password: "2HDq15ape",
      city: "Independencia",
      state: "OAX",
      country: "MX",
      occupation: "Speech Pathologist",
      phoneNumber: "9542194914",
      transactions: [
        "63701d74f03239528f00001f",
        "63701d74f03239d81e000035",
        "63701d74f03239b7f700002e",
        "63701d74f032396b8e000040",
        "63701d74f03239569400002a",
        "63701d74f0323986f3000144",
        "63701d74f032395b3300012f",
        "63701d74f032398675000134",
      ],
      role: "admin",
    },
    {
      _id: "63701cc1f0323986f3000126",
      name: "Addi",
      email: "ablazej7t@archive.org",
      password: "PNPXoHyZghJw",
      city: "Golovinskiy",
      state: null,
      country: "RU",
      occupation: "Data Coordiator",
      phoneNumber: "4132071143",
      transactions: [
        "63701d74f032398675000157",
        "63701d74f032396b8e000046",
        "63701d74f03239569400001d",
      ],
      role: "user",
    },
    {
      _id: "63701cc1f0323986f3000127",
      name: "Hamnet",
      email: "hgoatcher7u@stumbleupon.com",
      password: "aeql1NMP",
      city: "Coripata",
      state: null,
      country: "BO",
      occupation: "Nurse Practicioner",
      phoneNumber: "2161218895",
      transactions: [
        "63701d74f03239bef0000131",
        "63701d74f03239f09e0001b7",
        "63701d74f03239c72c0001a6",
        "63701d74f03239d40b000065",
        "63701d74f032394441000315",
        "63701d74f03239f09e0001a5",
        "63701d74f03239cdc5000035",
        "63701d74f03239d81e00001c",
        "63701d74f032394441000301",
      ],
      role: "user",
    },
    {
      _id: "63701cc1f0323986f3000128",
      name: "Leif",
      email: "lricard7v@miitbeian.gov.cn",
      password: "wRNZvXTv7",
      city: "Boulogne-Billancourt",
      state: "A8",
      country: "FR",
      occupation: "Nurse Practicioner",
      phoneNumber: "4544363972",
      transactions: ["63701d74f03239bef000015b", "63701d74f03239b91300002c"],
      role: "superadmin",
    },
    {
      _id: "63701cc1f0323986f3000129",
      name: "Lorin",
      email: "lmackonochie7w@1688.com",
      password: "NdaNsBtK",
      city: "Imām Şāḩib",
      state: null,
      country: "AF",
      occupation: "Sales Representative",
      phoneNumber: "1923232722",
      transactions: [
        "63701d74f0323986f3000158",
        "63701d74f03239444100030e",
        "63701d74f03239c72c00019b",
      ],
      role: "superadmin",
    },
    {
      _id: "63701cc1f03239d40b000038",
      name: "Claudius",
      email: "cmcelory7x@dagondesign.com",
      password: "ocj6RWqWbhi9",
      city: "Waajid",
      state: null,
      country: "SO",
      occupation: "Graphic Designer",
      phoneNumber: "7976549619",
      transactions: [
        "63701d74f032396b8e00003f",
        "63701d74f0323986f3000142",
        "63701d74f03239d40b000074",
        "63701d74f03239528f000042",
      ],
      role: "admin",
    },
    {
      _id: "63701cc1f03239d40b000039",
      name: "Eran",
      email: "emuglestone7y@ovh.net",
      password: "1Qe8fx",
      city: "Radamata",
      state: null,
      country: "ID",
      occupation: "Desktop Support Technician",
      phoneNumber: "6841672881",
      transactions: [
        "63701d74f03239db69000159",
        "63701d74f032394441000307",
        "63701d74f032395694000043",
      ],
      role: "user",
    },
    {
      _id: "63701cc1f03239d40b00003a",
      name: "Jeddy",
      email: "jdebenham7z@forbes.com",
      password: "ixMj7jOw4J9",
      city: "Nantes",
      state: "B5",
      country: "FR",
      occupation: "Human Resources Manager",
      phoneNumber: "2626797396",
      transactions: [
        "63701d74f032394441000304",
        "63701d74f03239d591000332",
        "63701d74f03239569400001c",
      ],
      role: "user",
    },
    {
      _id: "63701cc1f03239d40b00003b",
      name: "Heather",
      email: "hfost80@sciencedaily.com",
      password: "gWYmdo",
      city: "Pandian",
      state: null,
      country: "ID",
      occupation: "Developer IV",
      phoneNumber: "6824178344",
      transactions: ["63701d74f03239d81e000043", "63701d74f03239f09e0001bf"],
      role: "superadmin",
    },
    {
      _id: "63701cc1f03239d40b00003c",
      name: "Florinda",
      email: "ffache81@quantcast.com",
      password: "sCCTWmvo",
      city: "Hats’avan",
      state: null,
      country: "AM",
      occupation: "Web Designer I",
      phoneNumber: "5559497135",
      transactions: ["63701d74f03239c72c000196"],
      role: "user",
    },
    {
      _id: "63701cc1f03239d40b00003d",
      name: "Clemmie",
      email: "clowdyane82@hibu.com",
      password: "MfJXh5v",
      city: "Parung",
      state: null,
      country: "ID",
      occupation: "Clinical Specialist",
      phoneNumber: "1476153631",
      transactions: [
        "63701d74f03239d81e00002b",
        "63701d74f0323986f3000150",
        "63701d74f032390a34000348",
        "63701d74f03239bef0000150",
        "63701d74f03239528f00003a",
        "63701d74f032394c49000130",
      ],
      role: "superadmin",
    },
    {
      _id: "63701cc1f03239d40b00003e",
      name: "Micky",
      email: "mplail83@redcross.org",
      password: "mLPevua",
      city: "Dahu",
      state: null,
      country: "ID",
      occupation: "Teacher",
      phoneNumber: "9225826889",
      transactions: [
        "63701d74f03239d59100034e",
        "63701d74f032390a34000349",
        "63701d74f03239d591000349",
        "63701d74f03239b7f700003c",
        "63701d74f03239d40b00005c",
        "63701d74f032396b8e000036",
        "63701d74f03239f09e0001a4",
      ],
      role: "superadmin",
    },
    {
      _id: "63701cc1f03239d40b00003f",
      name: "Bonnie",
      email: "bbront84@ibm.com",
      password: "Ah4Zw3QtNCN5",
      city: "Campo de la Cruz",
      state: null,
      country: "CO",
      occupation: "Nurse",
      phoneNumber: "2731484562",
      transactions: ["63701d74f03239b7f700001e"],
      role: "user",
    },
    {
      _id: "63701cc1f03239d40b000040",
      name: "Obediah",
      email: "oduro85@japanpost.jp",
      password: "CtNHkQxlMhdd",
      city: "Nijmegen",
      state: "03",
      country: "NL",
      occupation: "Accounting Assistant II",
      phoneNumber: "7409445535",
      transactions: [
        "63701d74f032394c49000156",
        "63701d74f032399c00000150",
        "63701d74f03239c72c0001a1",
        "63701d74f03239528f00002f",
      ],
      role: "admin",
    },
    {
      _id: "63701cc1f03239d40b000041",
      name: "Harrison",
      email: "hpalister86@npr.org",
      password: "sR7umNTsaAii",
      city: "Tuoshi",
      state: null,
      country: "CN",
      occupation: "Design Engineer",
      phoneNumber: "6449317103",
      transactions: ["63701d74f03239b913000045"],
      role: "user",
    },
    {
      _id: "63701cc1f03239d40b000042",
      name: "Cecilla",
      email: "cjeffels87@free.fr",
      password: "cz1ytWA",
      city: "Qifang",
      state: null,
      country: "CN",
      occupation: "Automation Specialist III",
      phoneNumber: "1506165643",
      transactions: [
        "63701d74f032390a34000343",
        "63701d74f03239d40b00006c",
        "63701d74f032394c4900013d",
        "63701d74f03239b7f7000042",
      ],
      role: "admin",
    },
    {
      _id: "63701cc1f03239d40b000043",
      name: "Gav",
      email: "gcuttles88@purevolume.com",
      password: "hRqCrsFJVq",
      city: "Capitán Bado",
      state: null,
      country: "PY",
      occupation: "Geological Engineer",
      phoneNumber: "8768925153",
      transactions: ["63701d74f032395b33000131", "63701d74f03239b913000030"],
      role: "superadmin",
    },
    {
      _id: "63701cc1f03239d40b000044",
      name: "Georgianne",
      email: "gcoulbeck89@printfriendly.com",
      password: "PJyCrk",
      city: "Bagusan",
      state: null,
      country: "ID",
      occupation: "Engineer II",
      phoneNumber: "5043493141",
      transactions: [
        "63701d74f03239b913000040",
        "63701d74f03239db6900015a",
        "63701d74f03239569400001f",
        "63701d74f032399c00000144",
        "63701d74f03239f09e0001bd",
        "63701d74f03239c72c0001bc",
        "63701d74f03239d59100032d",
      ],
      role: "user",
    },
    {
      _id: "63701cc1f03239d40b000045",
      name: "Xerxes",
      email: "xdreinan8a@wix.com",
      password: "x93O2ercDrLG",
      city: "Liên Chiểu",
      state: null,
      country: "VN",
      occupation: "GIS Technical Architect",
      phoneNumber: "7076130812",
      transactions: [
        "63701d74f03239d81e000027",
        "63701d74f03239528f000035",
        "63701d74f03239d40b000081",
        "63701d74f03239cdc5000026",
        "63701d74f03239d40b000082",
        "63701d74f032396b8e00002f",
        "63701d74f03239d40b000061",
        "63701d74f03239f09e000195",
        "63701d74f03239c72c0001b7",
      ],
      role: "superadmin",
    },
    {
      _id: "63701cc1f03239d40b000046",
      name: "Karlie",
      email: "ksorby8b@altervista.org",
      password: "yiMyjbHk",
      city: "Dao",
      state: null,
      country: "PH",
      occupation: "Social Worker",
      phoneNumber: "1371356593",
      transactions: ["63701d74f032399c0000014f", "63701d74f03239b7f700003f"],
      role: "admin",
    },
  ];